"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[545],{

/***/ 60545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Smartcut$SmartcutsMacros = __webpack_require__(95418);
var Main = __webpack_require__(59359);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var LoginSmartcut$SmartcutsMacros = __webpack_require__(26553);
var OAuthProvider$SmartcutsMacros = __webpack_require__(86090);
var StartPlayback$SmartcutsMacros = __webpack_require__(97258);
var Modal__WebAuth$SmartcutsMacros = __webpack_require__(44833);
var PlaybackTrigger$SmartcutsMacros = __webpack_require__(82528);
var ScheduledTrigger$SmartcutsMacros = __webpack_require__(36512);
var PermissionAndOrigin$SmartcutsMacros = __webpack_require__(93834);
var Bg__StateMachine__Shared$SmartcutsMacros = __webpack_require__(82194);
var Segment__TrackedQuotaWarning$SmartcutsMacros = __webpack_require__(19376);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
function exists(param) {
    return window.analytics.analytics !== undefined;
}
function MakeTrackerForEventWithProperties(Track) {
    var _$track = function _$track(properties) {
        window.analytics.track(Track.$$event, Curry._1(Track.preparePropertiesForSegment, properties));
    };
    return {
        track: _$track
    };
}
var WithStringVisibility = {};
var TrackedInstallableSmartcutProps = {
    WithStringVisibility: WithStringVisibility
};
var TrackedInstalledSmartcutProps = {};
var TrackedVisitingFromDevice = {};
function track(properties) {
    window.analytics.track("Visit page from device", properties);
}
var TrackVisitingFromDevice = {
    track: track
};
function trackVisitingFromDevice(page) {
    return track({
        page: page,
        browserName: Main.browserName,
        browserVersion: Main.browserVersion,
        fullBrowserVersion: Main.fullBrowserVersion,
        isMobile: Main.isMobile,
        osName: Main.osName,
        osVersion: Main.osVersion
    });
}
var WithStringified = {};
function convertTypes(param) {
    return {
        configStep: ScheduledTrigger$SmartcutsMacros.Idiomatic.configStepToString(param.configStep),
        installedSmartcutId: param.installedSmartcutId,
        scheduledDays: ScheduledTrigger$SmartcutsMacros.Idiomatic.scheduledDaysToString(param.scheduledDays),
        nTimesInADay: ScheduledTrigger$SmartcutsMacros.Idiomatic.nTimesInADayToString(param.nTimesInADay),
        nTimesInADayCustomized: param.nTimesInADayCustomized,
        scheduledTimes: ScheduledTrigger$SmartcutsMacros.Idiomatic.scheduledTimesToString(param.scheduledTimes),
        isSettingUpScheduledTriggers: param.isSettingUpScheduledTriggers ? "true" : "false"
    };
}
var TrackedSchedulingSmartcutProps = {
    WithStringified: WithStringified,
    convertTypes: convertTypes
};
function preparePropertiesForSegment1(param) {
    return {
        smartcutId: param.smartcutId,
        numCommands: param.numCommands,
        numParams: param.numParams,
        hosts: param.hosts,
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        isOutdated: param.isOutdated,
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$1(properties) {
    window.analytics.track("View Installable Smartcut", preparePropertiesForSegment1(properties));
}
var TrackViewInstallableSmartcut = {
    track: track$1
};
function trackAttemptAcceptInvite(param) {
    window.analytics.track("Attempt to accept invite");
}
function trackAcceptedInvite(param) {
    window.analytics.track("Accepted invite");
}
function track$2(properties) {
    window.analytics.track("Error while accepting invite", properties);
}
var TrackFailedAttemptToAcceptInvite = {
    track: track$2
};
function trackAttemptSetPassword(param) {
    window.analytics.track("Attempt to set password");
}
function trackSetPassword(param) {
    window.analytics.track("Set password");
}
function track$3(properties) {
    window.analytics.track("Error while setting password", properties);
}
var TrackFailedAttemptToSetPassword = {
    track: track$3
};
function trackUserForgotPassword(param) {
    window.analytics.track("User attempt to reset password");
}
function trackChromeExtensionDownloadAttempt(param) {
    window.analytics.track("Attempted to Download Chrome Extension");
}
function track$4(properties) {
    window.analytics.track("Installed Chrome extension", properties);
}
var TrackChromeExtensionInstall = {
    track: track$4
};
function track$5(properties) {
    window.analytics.track("Uninstalled Chrome extension", properties);
}
var TrackChromeExtensionUninstall = {
    track: track$5
};
function track$6(properties) {
    window.analytics.track("Updated Chrome extension", properties);
}
var TrackChromeExtensionUpdate = {
    track: track$6
};
function trackChromeUpdate(param) {
    window.analytics.track("Updated Chrome");
}
function trackChromeSharedModuleUpdate(param) {
    window.analytics.track("Updated Chrome Shared Module");
}
function promptReason_encode(v) {
    if (v) {
        return [
            "PromptedForPlayback"
        ];
    } else {
        return [
            "PromptedForRecording"
        ];
    }
}
function promptReason_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "PromptedForPlayback":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PromptedForPlayback */ 1
                    };
                }
            case "PromptedForRecording":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PromptedForRecording */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyPromptReason(promptReason) {
    if (promptReason) {
        return "playback";
    } else {
        return "recording";
    }
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "promptReason",
            promptReason_encode(v.promptReason)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var promptReason = promptReason_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "promptReason"), null));
    if (promptReason.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                promptReason: promptReason._0
            }
        };
    }
    var e = promptReason._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".promptReason" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function stringify(param) {
    return "{promptReason: " + ((param.promptReason ? "playback" : "recording") + "}");
}
var TrackedPermissionsRejection = {
    promptReason_encode: promptReason_encode,
    promptReason_decode: promptReason_decode,
    stringifyPromptReason: stringifyPromptReason,
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
var TrackedPermissionsRejectionWithStringReason = {};
function preparePropertiesForSegment$110(param) {
    return {
        promptReason: param.promptReason ? "playback" : "recording"
    };
}
function track$7(properties) {
    window.analytics.track("Rejected Chrome Permissions", preparePropertiesForSegment$110(properties));
}
var TrackRejectPermissions = {
    track: track$7
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "context",
            Modal__WebAuth$SmartcutsMacros.Context.t_encode(v.context)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var context = Modal__WebAuth$SmartcutsMacros.Context.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "context"), null));
    if (context.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                context: context._0
            }
        };
    }
    var e = context._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".context" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
var WithStringContext = {};
var TrackedViewOauthExplanationModal = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    WithStringContext: WithStringContext
};
function preparePropertiesForSegment$26(param) {
    return {
        context: Modal__WebAuth$SmartcutsMacros.Context.stringify(param.context)
    };
}
function track$8(properties) {
    window.analytics.track("View OAuth Explanation Modal", preparePropertiesForSegment$26(properties));
}
var TrackViewOauthExplanationModal = {
    track: track$8
};
function trackCancelOAuthExplanationModal(param) {
    window.analytics.track("Canceled OAuth Explanation Modal");
}
function trackInitiateOAuthConsentFlow(param) {
    window.analytics.track("Initiate OAuth Consent Flow");
}
function trackOAuthConsentGranted(param) {
    window.analytics.track("OAuth Consent Granted");
}
function trackOAuthConsentRejected(param) {
    window.analytics.track("OAuth Consent Rejected");
}
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "host",
            Decco.stringToJson(v.host)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "trigger",
            Decco.stringToJson(v.trigger)
        ],
        [
            "mainSmartcutId",
            Decco.optionToJson(SmartcutIds$SmartcutsMacros.smartcutId_encode, v.mainSmartcutId)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var host = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "host"), null));
    if (host.TAG === /* Ok */ 0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
            if (trigger.TAG === /* Ok */ 0) {
                var mainSmartcutId = Decco.optionFromJson(SmartcutIds$SmartcutsMacros.smartcutId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mainSmartcutId"), null));
                if (mainSmartcutId.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            host: host._0,
                            url: url._0,
                            trigger: trigger._0,
                            mainSmartcutId: mainSmartcutId._0
                        }
                    };
                }
                var e = mainSmartcutId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".mainSmartcutId" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = trigger._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".trigger" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = host._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".host" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
var WithStringFields = {
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
var TrackedStartRecording = {
    WithStringFields: WithStringFields
};
function preparePropertiesForSegment$3(param) {
    var trigger = param.trigger;
    return {
        host: param.host,
        url: param.url,
        trigger: typeof trigger === "number" ? trigger !== 0 ? "Url Triggering as Smartcut" : "Browser Action" : "Record Login Smartcut",
        mainSmartcutId: typeof trigger === "number" ? undefined : Caml_option.some(trigger._0.mainSmartcutId)
    };
}
function track$9(properties) {
    window.analytics.track("Started Recording", preparePropertiesForSegment$3(properties));
}
var TrackStartedRecording = {
    track: track$9
};
function finalSmartcutRecordingProps_encode(v) {
    return Js_dict.fromArray([
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "hosts",
            Decco.arrayToJson(Decco.stringToJson, v.hosts)
        ]
    ]);
}
function finalSmartcutRecordingProps_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
    if (numCommands.TAG === /* Ok */ 0) {
        var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
        if (hosts.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    numCommands: numCommands._0,
                    hosts: hosts._0
                }
            };
        }
        var e = hosts._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".hosts" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = numCommands._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".numCommands" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function finalSmartcutProps_encode(v) {
    return Js_dict.fromArray([
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "numParams",
            Decco.intToJson(v.numParams)
        ],
        [
            "hosts",
            Decco.arrayToJson(Decco.stringToJson, v.hosts)
        ]
    ]);
}
function finalSmartcutProps_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
    if (numCommands.TAG === /* Ok */ 0) {
        var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
        if (numParams.TAG === /* Ok */ 0) {
            var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
            if (hosts.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        numCommands: numCommands._0,
                        numParams: numParams._0,
                        hosts: hosts._0
                    }
                };
            }
            var e = hosts._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".hosts" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = numParams._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".numParams" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = numCommands._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".numCommands" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function track$10(properties) {
    window.analytics.track("Stopped Recording", properties);
}
var TrackAttemptedStopRecording = {
    track: track$10
};
function track$11(properties) {
    window.analytics.track("Finished Authoring Smartcut", properties);
}
var TrackFinishedAuthoringSmartcut = {
    track: track$11
};
function preparePropertiesForSegment$4(param) {
    return {
        smartcutId: param.smartcutId,
        numCommands: param.numCommands,
        numParams: param.numParams,
        hosts: param.hosts,
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        isOutdated: param.isOutdated,
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$12(properties) {
    window.analytics.track("Interested In Installing Smartcut", preparePropertiesForSegment$4(properties));
}
var TrackInterestedInInstallingSmartcut = {
    track: track$12
};
function preparePropertiesForSegment$5(param) {
    return {
        smartcutId: param.smartcutId,
        numCommands: param.numCommands,
        numParams: param.numParams,
        hosts: param.hosts,
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        isOutdated: param.isOutdated,
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$13(properties) {
    window.analytics.track("Attempt to Install Smartcut", preparePropertiesForSegment$5(properties));
}
var TrackAttemptInstallSmartcut = {
    track: track$13
};
function trackUserAttemptToContactSupport(param) {
    window.analytics.track("User attempted to contact support");
}
function PageOnboardingSpecified(Step) {
    var WithStringified1 = {};
    var TrackedOnboardingPageStateProps = {
        WithStringified: WithStringified1
    };
    var preparePropertiesForSegment = function preparePropertiesForSegment(param) {
        return {
            step: Curry._1(Step.humanize, param.step)
        };
    };
    var _$track = function _$track(properties) {
        window.analytics.track("Onboarding: User reloads page", preparePropertiesForSegment(properties));
    };
    var TrackPageOnLoad = {
        track: _$track
    };
    var preparePropertiesForSegment$1 = function preparePropertiesForSegment$1(param) {
        return {
            step: Curry._1(Step.humanize, param.step)
        };
    };
    var _$track$1 = function _$track$1(properties) {
        window.analytics.track("Onboarding: Step transition", preparePropertiesForSegment$1(properties));
    };
    var TrackStepTransition = {
        track: _$track$1
    };
    var TrackedOnboardingCollectedPoshmarkUsername = {};
    var preparePropertiesForSegment$2 = function preparePropertiesForSegment$2(param) {
        return {
            username: param.username
        };
    };
    var _$track$2 = function _$track$2(properties) {
        window.analytics.track("Onboarding: Collected Poshmark Username", preparePropertiesForSegment$2(properties));
    };
    var TrackOnboardingCollectedPoshmarkUsername = {
        track: _$track$2
    };
    var trackUserCheckingPoshmarkLogin = function trackUserCheckingPoshmarkLogin(param) {
        window.analytics.track("Onboarding: user checks the Poshmark login");
    };
    var _$track$3 = function _$track$3(properties) {
        window.analytics.track("Onboarding: User setting up smartcut schedule", convertTypes(properties));
    };
    var TrackSettingUpInstalledSmartcutSchedule = {
        track: _$track$3
    };
    var _$track$4 = function _$track$4(properties) {
        window.analytics.track("Onboarding: User successfully set up smartcut schedule", convertTypes(properties));
    };
    var TrackSuccessfullySetUpInstalledSmartcutSchedule = {
        track: _$track$4
    };
    var _$track$5 = function _$track$5(properties) {
        window.analytics.track("Onboarding: user attempt to try out the smartcut", properties);
    };
    var TrackUserAttemptForSmartcutTryOut = {
        track: _$track$5
    };
    return {
        TrackedOnboardingPageStateProps: TrackedOnboardingPageStateProps,
        TrackPageOnLoad: TrackPageOnLoad,
        TrackStepTransition: TrackStepTransition,
        TrackedOnboardingCollectedPoshmarkUsername: TrackedOnboardingCollectedPoshmarkUsername,
        TrackOnboardingCollectedPoshmarkUsername: TrackOnboardingCollectedPoshmarkUsername,
        trackUserCheckingPoshmarkLogin: trackUserCheckingPoshmarkLogin,
        TrackSettingUpInstalledSmartcutSchedule: TrackSettingUpInstalledSmartcutSchedule,
        TrackSuccessfullySetUpInstalledSmartcutSchedule: TrackSuccessfullySetUpInstalledSmartcutSchedule,
        TrackUserAttemptForSmartcutTryOut: TrackUserAttemptForSmartcutTryOut
    };
}
function preparePropertiesForSegment$6(param) {
    return {
        smartcutId: param.smartcutId,
        numCommands: param.numCommands,
        numParams: param.numParams,
        hosts: param.hosts,
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        isOutdated: param.isOutdated,
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$14(properties) {
    window.analytics.track("Begin AutoInstall Smartcut", preparePropertiesForSegment$6(properties));
}
var TrackBeginAutoInstallSmartcut = {
    track: track$14
};
function preparePropertiesForSegment$7(param) {
    return {
        smartcutId: param.smartcutId,
        numCommands: param.numCommands,
        numParams: param.numParams,
        hosts: param.hosts,
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        isOutdated: param.isOutdated,
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$15(properties) {
    window.analytics.track("Install Smartcut Success", preparePropertiesForSegment$7(properties));
}
var TrackInstallSmartcutSuccess = {
    track: track$15
};
function preparePropertiesForSegment$8(param) {
    return {
        smartcutId: param.smartcutId,
        numCommands: param.numCommands,
        numParams: param.numParams,
        hosts: param.hosts,
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        isOutdated: param.isOutdated,
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$16(properties) {
    window.analytics.track("Install Smartcut Failed", preparePropertiesForSegment$8(properties));
}
var TrackInstallSmartcutFailed = {
    track: track$16
};
function finalSmartcutPropsWithId_encode(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "numParams",
            Decco.intToJson(v.numParams)
        ],
        [
            "hosts",
            Decco.arrayToJson(Decco.stringToJson, v.hosts)
        ]
    ]);
}
function finalSmartcutPropsWithId_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
        if (numCommands.TAG === /* Ok */ 0) {
            var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
            if (numParams.TAG === /* Ok */ 0) {
                var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
                if (hosts.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            id: id._0,
                            numCommands: numCommands._0,
                            numParams: numParams._0,
                            hosts: hosts._0
                        }
                    };
                }
                var e = hosts._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".hosts" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = numParams._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numParams" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = numCommands._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".numCommands" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "triggeredBy",
            Decco.stringToJson(v.triggeredBy)
        ],
        [
            "permissions",
            Decco.arrayToJson(Decco.stringToJson, v.permissions)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var triggeredBy = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeredBy"), null));
    if (triggeredBy.TAG === /* Ok */ 0) {
        var permissions = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "permissions"), null));
        if (permissions.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    triggeredBy: triggeredBy._0,
                    permissions: permissions._0
                }
            };
        }
        var e = permissions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".permissions" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = triggeredBy._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".triggeredBy" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var WithStringFields$1 = {
    t_encode: t_encode$3,
    t_decode: t_decode$3
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "triggeredBy",
            PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_encode(v.triggeredBy)
        ],
        [
            "permissions",
            Decco.arrayToJson(PermissionAndOrigin$SmartcutsMacros.t_encode, v.permissions)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var triggeredBy = PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeredBy"), null));
    if (triggeredBy.TAG === /* Ok */ 0) {
        var permissions = Decco.arrayFromJson(PermissionAndOrigin$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "permissions"), null));
        if (permissions.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    triggeredBy: triggeredBy._0,
                    permissions: permissions._0
                }
            };
        }
        var e = permissions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".permissions" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = triggeredBy._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".triggeredBy" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var TrackedPermissionEventProps = {
    WithStringFields: WithStringFields$1,
    t_encode: t_encode$4,
    t_decode: t_decode$4
};
function preparePropertiesForSegment$9(param) {
    return {
        triggeredBy: PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.justVariantStringMinusParams(param.triggeredBy),
        permissions: Belt_Array.map(param.permissions, PermissionAndOrigin$SmartcutsMacros.toString)
    };
}
function track$17(properties) {
    window.analytics.track("About to Explain Permissions", preparePropertiesForSegment$9(properties));
}
var TrackAboutToExplainPermission = {
    track: track$17
};
function preparePropertiesForSegment$10(param) {
    return {
        triggeredBy: PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.justVariantStringMinusParams(param.triggeredBy),
        permissions: Belt_Array.map(param.permissions, PermissionAndOrigin$SmartcutsMacros.toString)
    };
}
function track$18(properties) {
    window.analytics.track("Grant Permissions", preparePropertiesForSegment$10(properties));
}
var TrackPermissionGrant = {
    track: track$18
};
function preparePropertiesForSegment$11(param) {
    return {
        triggeredBy: PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.justVariantStringMinusParams(param.triggeredBy),
        permissions: Belt_Array.map(param.permissions, PermissionAndOrigin$SmartcutsMacros.toString)
    };
}
function track$19(properties) {
    window.analytics.track("Deny Permissions", preparePropertiesForSegment$11(properties));
}
var TrackPermissionDeny = {
    track: track$19
};
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "numPlaybacks",
            Decco.intToJson(v.numPlaybacks)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "numParams",
            Decco.intToJson(v.numParams)
        ],
        [
            "hosts",
            Decco.arrayToJson(Decco.stringToJson, v.hosts)
        ],
        [
            "visibility",
            Decco.stringToJson(v.visibility)
        ],
        [
            "trigger",
            Decco.stringToJson(v.trigger)
        ],
        [
            "hasLoginSmartcut",
            Decco.boolToJson(v.hasLoginSmartcut)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var numPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPlaybacks"), null));
        if (numPlaybacks.TAG === /* Ok */ 0) {
            var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
            if (numCommands.TAG === /* Ok */ 0) {
                var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
                if (numParams.TAG === /* Ok */ 0) {
                    var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
                    if (hosts.TAG === /* Ok */ 0) {
                        var visibility = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                        if (visibility.TAG === /* Ok */ 0) {
                            var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
                            if (trigger.TAG === /* Ok */ 0) {
                                var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                                if (hasLoginSmartcut.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            smartcutId: smartcutId._0,
                                            numPlaybacks: numPlaybacks._0,
                                            numCommands: numCommands._0,
                                            numParams: numParams._0,
                                            hosts: hosts._0,
                                            visibility: visibility._0,
                                            trigger: trigger._0,
                                            hasLoginSmartcut: hasLoginSmartcut._0
                                        }
                                    };
                                }
                                var e = hasLoginSmartcut._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".hasLoginSmartcut" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = trigger._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".trigger" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = visibility._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".visibility" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = hosts._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".hosts" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = numParams._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".numParams" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = numCommands._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numCommands" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = numPlaybacks._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".numPlaybacks" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
var WithStringTrigger = {
    t_encode: t_encode$5,
    t_decode: t_decode$5
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "numPlaybacks",
            Decco.intToJson(v.numPlaybacks)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "numParams",
            Decco.intToJson(v.numParams)
        ],
        [
            "hosts",
            Decco.arrayToJson(Decco.stringToJson, v.hosts)
        ],
        [
            "visibility",
            Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
        ],
        [
            "trigger",
            PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
        ],
        [
            "hasLoginSmartcut",
            Decco.boolToJson(v.hasLoginSmartcut)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var numPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPlaybacks"), null));
        if (numPlaybacks.TAG === /* Ok */ 0) {
            var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
            if (numCommands.TAG === /* Ok */ 0) {
                var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
                if (numParams.TAG === /* Ok */ 0) {
                    var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
                    if (hosts.TAG === /* Ok */ 0) {
                        var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                        if (visibility.TAG === /* Ok */ 0) {
                            var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
                            if (trigger.TAG === /* Ok */ 0) {
                                var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                                if (hasLoginSmartcut.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            smartcutId: smartcutId._0,
                                            numPlaybacks: numPlaybacks._0,
                                            numCommands: numCommands._0,
                                            numParams: numParams._0,
                                            hosts: hosts._0,
                                            visibility: visibility._0,
                                            trigger: trigger._0,
                                            hasLoginSmartcut: hasLoginSmartcut._0
                                        }
                                    };
                                }
                                var e = hasLoginSmartcut._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".hasLoginSmartcut" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = trigger._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".trigger" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = visibility._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".visibility" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = hosts._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".hosts" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = numParams._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".numParams" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = numCommands._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numCommands" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = numPlaybacks._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".numPlaybacks" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
function stringify$1(param) {
    return "{smartcutId: " + param.smartcutId + ", numPlaybacks: " + (String(param.numPlaybacks) + (", numCommands: " + (String(param.numCommands) + (", numParams: " + (String(param.numParams) + (", hosts: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(param.hosts)) + (", visibility: " + (Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility) + (", trigger: " + (PlaybackTrigger$SmartcutsMacros.stringify(param.trigger) + (", hasLoginSmartcut: " + (Pervasives.string_of_bool(param.hasLoginSmartcut) + "}")))))))))))));
}
function fromStartPlayback(startPlayback) {
    var match = StartPlayback$SmartcutsMacros.view(startPlayback);
    var numParams = match.numParams;
    var visibility = match.visibility;
    var origins = match.origins;
    var trigger = match.trigger;
    var commandLog = match.commandLog;
    var match$1 = match.loadedSmartcut.smartcut;
    var loginSmartcuts = match$1.loginSmartcuts;
    var smartcutId = match$1.id;
    return StartPlayback$SmartcutsMacros.numExecutions(startPlayback).then(function(numPlaybacks) {
        return Promise.resolve({
            smartcutId: smartcutId,
            numPlaybacks: numPlaybacks,
            numCommands: List.length(commandLog),
            numParams: numParams,
            hosts: origins,
            visibility: visibility,
            trigger: trigger,
            hasLoginSmartcut: !Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.isEmpty, loginSmartcuts)
        });
    });
}
var TrackedStartPlaybackSet = {
    WithStringTrigger: WithStringTrigger,
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    stringify: stringify$1,
    fromStartPlayback: fromStartPlayback
};
function t_encode$7(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "numPlaybacks",
            Decco.intToJson(v.numPlaybacks)
        ],
        [
            "numSucceeded",
            Decco.intToJson(v.numSucceeded)
        ],
        [
            "numFailed",
            Decco.intToJson(v.numFailed)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "numParams",
            Decco.intToJson(v.numParams)
        ],
        [
            "hosts",
            Decco.arrayToJson(Decco.stringToJson, v.hosts)
        ],
        [
            "visibility",
            Decco.stringToJson(v.visibility)
        ],
        [
            "trigger",
            Decco.stringToJson(v.trigger)
        ],
        [
            "hasLoginSmartcut",
            Decco.boolToJson(v.hasLoginSmartcut)
        ]
    ]);
}
function t_decode$7(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var numPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPlaybacks"), null));
        if (numPlaybacks.TAG === /* Ok */ 0) {
            var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
            if (numSucceeded.TAG === /* Ok */ 0) {
                var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
                if (numFailed.TAG === /* Ok */ 0) {
                    var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
                    if (numCommands.TAG === /* Ok */ 0) {
                        var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
                        if (numParams.TAG === /* Ok */ 0) {
                            var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
                            if (hosts.TAG === /* Ok */ 0) {
                                var visibility = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                                if (visibility.TAG === /* Ok */ 0) {
                                    var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
                                    if (trigger.TAG === /* Ok */ 0) {
                                        var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                                        if (hasLoginSmartcut.TAG === /* Ok */ 0) {
                                            return {
                                                TAG: /* Ok */ 0,
                                                _0: {
                                                    smartcutId: smartcutId._0,
                                                    numPlaybacks: numPlaybacks._0,
                                                    numSucceeded: numSucceeded._0,
                                                    numFailed: numFailed._0,
                                                    numCommands: numCommands._0,
                                                    numParams: numParams._0,
                                                    hosts: hosts._0,
                                                    visibility: visibility._0,
                                                    trigger: trigger._0,
                                                    hasLoginSmartcut: hasLoginSmartcut._0
                                                }
                                            };
                                        }
                                        var e = hasLoginSmartcut._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".hasLoginSmartcut" + e.path,
                                                message: e.message,
                                                value: e.value
                                            }
                                        };
                                    }
                                    var e$1 = trigger._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".trigger" + e$1.path,
                                            message: e$1.message,
                                            value: e$1.value
                                        }
                                    };
                                }
                                var e$2 = visibility._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".visibility" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                    }
                                };
                            }
                            var e$3 = hosts._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".hosts" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                }
                            };
                        }
                        var e$4 = numParams._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".numParams" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = numCommands._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".numCommands" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = numFailed._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".numFailed" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            }
            var e$7 = numSucceeded._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numSucceeded" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                }
            };
        }
        var e$8 = numPlaybacks._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".numPlaybacks" + e$8.path,
                message: e$8.message,
                value: e$8.value
            }
        };
    }
    var e$9 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$9.path,
            message: e$9.message,
            value: e$9.value
        }
    };
}
var WithStringTrigger$1 = {
    t_encode: t_encode$7,
    t_decode: t_decode$7
};
function t_encode$8(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "numPlaybacks",
            Decco.intToJson(v.numPlaybacks)
        ],
        [
            "numSucceeded",
            Decco.intToJson(v.numSucceeded)
        ],
        [
            "numFailed",
            Decco.intToJson(v.numFailed)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "numParams",
            Decco.intToJson(v.numParams)
        ],
        [
            "hosts",
            Decco.arrayToJson(Decco.stringToJson, v.hosts)
        ],
        [
            "visibility",
            Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
        ],
        [
            "trigger",
            PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
        ],
        [
            "hasLoginSmartcut",
            Decco.boolToJson(v.hasLoginSmartcut)
        ]
    ]);
}
function t_decode$8(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var numPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPlaybacks"), null));
        if (numPlaybacks.TAG === /* Ok */ 0) {
            var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
            if (numSucceeded.TAG === /* Ok */ 0) {
                var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
                if (numFailed.TAG === /* Ok */ 0) {
                    var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
                    if (numCommands.TAG === /* Ok */ 0) {
                        var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
                        if (numParams.TAG === /* Ok */ 0) {
                            var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
                            if (hosts.TAG === /* Ok */ 0) {
                                var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                                if (visibility.TAG === /* Ok */ 0) {
                                    var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
                                    if (trigger.TAG === /* Ok */ 0) {
                                        var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                                        if (hasLoginSmartcut.TAG === /* Ok */ 0) {
                                            return {
                                                TAG: /* Ok */ 0,
                                                _0: {
                                                    smartcutId: smartcutId._0,
                                                    numPlaybacks: numPlaybacks._0,
                                                    numSucceeded: numSucceeded._0,
                                                    numFailed: numFailed._0,
                                                    numCommands: numCommands._0,
                                                    numParams: numParams._0,
                                                    hosts: hosts._0,
                                                    visibility: visibility._0,
                                                    trigger: trigger._0,
                                                    hasLoginSmartcut: hasLoginSmartcut._0
                                                }
                                            };
                                        }
                                        var e = hasLoginSmartcut._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".hasLoginSmartcut" + e.path,
                                                message: e.message,
                                                value: e.value
                                            }
                                        };
                                    }
                                    var e$1 = trigger._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".trigger" + e$1.path,
                                            message: e$1.message,
                                            value: e$1.value
                                        }
                                    };
                                }
                                var e$2 = visibility._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".visibility" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                    }
                                };
                            }
                            var e$3 = hosts._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".hosts" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                }
                            };
                        }
                        var e$4 = numParams._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".numParams" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = numCommands._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".numCommands" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = numFailed._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".numFailed" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            }
            var e$7 = numSucceeded._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numSucceeded" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                }
            };
        }
        var e$8 = numPlaybacks._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".numPlaybacks" + e$8.path,
                message: e$8.message,
                value: e$8.value
            }
        };
    }
    var e$9 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$9.path,
            message: e$9.message,
            value: e$9.value
        }
    };
}
function stringify$2(param) {
    return "{smartcutId: " + (param.smartcutId + (", numPlaybacks: " + (String(param.numPlaybacks) + (", numSucceeded: " + (String(param.numSucceeded) + (", numFailed: " + (String(param.numFailed) + (", numCommands: " + (String(param.numCommands) + (", numParams: " + (String(param.numParams) + (", hosts: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(param.hosts)) + (", visibility: " + (Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility) + (", trigger: " + (PlaybackTrigger$SmartcutsMacros.stringify(param.trigger) + (", hasLoginSmartcut: " + (Pervasives.string_of_bool(param.hasLoginSmartcut) + "}")))))))))))))))))));
}
var TrackedFinishPlaybackSet = {
    WithStringTrigger: WithStringTrigger$1,
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    stringify: stringify$2
};
function t_encode$9(v) {
    switch(v){
        case /* NewWindowCommand */ 0:
            return [
                "NewWindowCommand"
            ];
        case /* NewWindowWithUrlCommand */ 1:
            return [
                "NewWindowWithUrlCommand"
            ];
        case /* NewTabCommand */ 2:
            return [
                "NewTabCommand"
            ];
        case /* NewTabWithUrlCommand */ 3:
            return [
                "NewTabWithUrlCommand"
            ];
        case /* CloseTabCommand */ 4:
            return [
                "CloseTabCommand"
            ];
        case /* FocusTabCommand */ 5:
            return [
                "FocusTabCommand"
            ];
        case /* URLCommand */ 6:
            return [
                "URLCommand"
            ];
        case /* OpenedLinkCommand */ 7:
            return [
                "OpenedLinkCommand"
            ];
        case /* SubmitFormCommand */ 8:
            return [
                "SubmitFormCommand"
            ];
        case /* SubmitFormRedirectCommand */ 9:
            return [
                "SubmitFormRedirectCommand"
            ];
        case /* ClientRedirectCommand */ 10:
            return [
                "ClientRedirectCommand"
            ];
        case /* ServerRedirectCommand */ 11:
            return [
                "ServerRedirectCommand"
            ];
        case /* ReloadCommand */ 12:
            return [
                "ReloadCommand"
            ];
        case /* ForwardCommand */ 13:
            return [
                "ForwardCommand"
            ];
        case /* BackCommand */ 14:
            return [
                "BackCommand"
            ];
        case /* ClickCommand */ 15:
            return [
                "ClickCommand"
            ];
        case /* ClickInputCommand */ 16:
            return [
                "ClickInputCommand"
            ];
        case /* ClickContentEditableCommand */ 17:
            return [
                "ClickContentEditableCommand"
            ];
        case /* TypeCommand */ 18:
            return [
                "TypeCommand"
            ];
        case /* CheckboxCommand */ 19:
            return [
                "CheckboxCommand"
            ];
        case /* SelectCommand */ 20:
            return [
                "SelectCommand"
            ];
        case /* RadioCommand */ 21:
            return [
                "RadioCommand"
            ];
        case /* KeyCommand */ 22:
            return [
                "KeyCommand"
            ];
        case /* KeyComboCommand */ 23:
            return [
                "KeyComboCommand"
            ];
        case /* SelectionCommand */ 24:
            return [
                "SelectionCommand"
            ];
        case /* MoveInputCursorCommand */ 25:
            return [
                "MoveInputCursorCommand"
            ];
        case /* MoveContentEditableCursorCommand */ 26:
            return [
                "MoveContentEditableCursorCommand"
            ];
        case /* CopyCommand */ 27:
            return [
                "CopyCommand"
            ];
        case /* CopyLinkAddressCommand */ 28:
            return [
                "CopyLinkAddressCommand"
            ];
        case /* CopyImageSrcCommand */ 29:
            return [
                "CopyImageSrcCommand"
            ];
        case /* CutCommand */ 30:
            return [
                "CutCommand"
            ];
        case /* PasteInInputCommand */ 31:
            return [
                "PasteInInputCommand"
            ];
        case /* PasteInContentEditableCommand */ 32:
            return [
                "PasteInContentEditableCommand"
            ];
        case /* DragCommand */ 33:
            return [
                "DragCommand"
            ];
        case /* DropCommand */ 34:
            return [
                "DropCommand"
            ];
        case /* ScrollCommand */ 35:
            return [
                "ScrollCommand"
            ];
        case /* DownloadCommand */ 36:
            return [
                "DownloadCommand"
            ];
        case /* GoogleSheetsCommand */ 37:
            return [
                "GoogleSheetsCommand"
            ];
        case /* ContextMenuCommand */ 38:
            return [
                "ContextMenuCommand"
            ];
        case /* LoopCommand */ 39:
            return [
                "LoopCommand"
            ];
        case /* SwitchCommand */ 40:
            return [
                "SwitchCommand"
            ];
        case /* ScreenshotToClipboardCommand */ 41:
            return [
                "ScreenshotToClipboardCommand"
            ];
        case /* PasteImageInContentEditableCommand */ 42:
            return [
                "PasteImageInContentEditableCommand"
            ];
        case /* PasswordCommand */ 43:
            return [
                "PasswordCommand"
            ];
        case /* ClickToOAuthCommand */ 44:
            return [
                "ClickToOAuthCommand"
            ];
        case /* UploadCommand */ 45:
            return [
                "UploadCommand"
            ];
        case /* WithElementGroupsCommand */ 46:
            return [
                "WithElementGroupsCommand"
            ];
    }
}
function t_decode$9(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BackCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* BackCommand */ 14
                    };
                }
            case "CheckboxCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CheckboxCommand */ 19
                    };
                }
            case "ClickCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ClickCommand */ 15
                    };
                }
            case "ClickContentEditableCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ClickContentEditableCommand */ 17
                    };
                }
            case "ClickInputCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ClickInputCommand */ 16
                    };
                }
            case "ClickToOAuthCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ClickToOAuthCommand */ 44
                    };
                }
            case "ClientRedirectCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ClientRedirectCommand */ 10
                    };
                }
            case "CloseTabCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CloseTabCommand */ 4
                    };
                }
            case "ContextMenuCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContextMenuCommand */ 38
                    };
                }
            case "CopyCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CopyCommand */ 27
                    };
                }
            case "CopyImageSrcCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CopyImageSrcCommand */ 29
                    };
                }
            case "CopyLinkAddressCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CopyLinkAddressCommand */ 28
                    };
                }
            case "CutCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CutCommand */ 30
                    };
                }
            case "DownloadCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DownloadCommand */ 36
                    };
                }
            case "DragCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DragCommand */ 33
                    };
                }
            case "DropCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DropCommand */ 34
                    };
                }
            case "FocusTabCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FocusTabCommand */ 5
                    };
                }
            case "ForwardCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ForwardCommand */ 13
                    };
                }
            case "GoogleSheetsCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* GoogleSheetsCommand */ 37
                    };
                }
            case "KeyComboCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* KeyComboCommand */ 23
                    };
                }
            case "KeyCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* KeyCommand */ 22
                    };
                }
            case "LoopCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* LoopCommand */ 39
                    };
                }
            case "MoveContentEditableCursorCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* MoveContentEditableCursorCommand */ 26
                    };
                }
            case "MoveInputCursorCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* MoveInputCursorCommand */ 25
                    };
                }
            case "NewTabCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NewTabCommand */ 2
                    };
                }
            case "NewTabWithUrlCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NewTabWithUrlCommand */ 3
                    };
                }
            case "NewWindowCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NewWindowCommand */ 0
                    };
                }
            case "NewWindowWithUrlCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NewWindowWithUrlCommand */ 1
                    };
                }
            case "OpenedLinkCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* OpenedLinkCommand */ 7
                    };
                }
            case "PasswordCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PasswordCommand */ 43
                    };
                }
            case "PasteImageInContentEditableCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PasteImageInContentEditableCommand */ 42
                    };
                }
            case "PasteInContentEditableCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PasteInContentEditableCommand */ 32
                    };
                }
            case "PasteInInputCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PasteInInputCommand */ 31
                    };
                }
            case "RadioCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RadioCommand */ 21
                    };
                }
            case "ReloadCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ReloadCommand */ 12
                    };
                }
            case "ScreenshotToClipboardCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ScreenshotToClipboardCommand */ 41
                    };
                }
            case "ScrollCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ScrollCommand */ 35
                    };
                }
            case "SelectCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SelectCommand */ 20
                    };
                }
            case "SelectionCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SelectionCommand */ 24
                    };
                }
            case "ServerRedirectCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ServerRedirectCommand */ 11
                    };
                }
            case "SubmitFormCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SubmitFormCommand */ 8
                    };
                }
            case "SubmitFormRedirectCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SubmitFormRedirectCommand */ 9
                    };
                }
            case "SwitchCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SwitchCommand */ 40
                    };
                }
            case "TypeCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TypeCommand */ 18
                    };
                }
            case "URLCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* URLCommand */ 6
                    };
                }
            case "UploadCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UploadCommand */ 45
                    };
                }
            case "WithElementGroupsCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* WithElementGroupsCommand */ 46
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$3(v) {
    switch(v){
        case /* NewWindowCommand */ 0:
            return "NewWindowCommand";
        case /* NewWindowWithUrlCommand */ 1:
            return "NewWindowWithUrlCommand";
        case /* NewTabCommand */ 2:
            return "NewTabCommand";
        case /* NewTabWithUrlCommand */ 3:
            return "NewTabWithUrlCommand";
        case /* CloseTabCommand */ 4:
            return "CloseTabCommand";
        case /* FocusTabCommand */ 5:
            return "FocusTabCommand";
        case /* URLCommand */ 6:
            return "URLCommand";
        case /* OpenedLinkCommand */ 7:
            return "OpenedLinkCommand";
        case /* SubmitFormCommand */ 8:
            return "SubmitFormCommand";
        case /* SubmitFormRedirectCommand */ 9:
            return "SubmitFormRedirectCommand";
        case /* ClientRedirectCommand */ 10:
            return "ClientRedirectCommand";
        case /* ServerRedirectCommand */ 11:
            return "ServerRedirectCommand";
        case /* ReloadCommand */ 12:
            return "ReloadCommand";
        case /* ForwardCommand */ 13:
            return "ForwardCommand";
        case /* BackCommand */ 14:
            return "BackCommand";
        case /* ClickCommand */ 15:
            return "ClickCommand";
        case /* ClickInputCommand */ 16:
            return "ClickInputCommand";
        case /* ClickContentEditableCommand */ 17:
            return "ClickContentEditableCommand";
        case /* TypeCommand */ 18:
            return "TypeCommand";
        case /* CheckboxCommand */ 19:
            return "CheckboxCommand";
        case /* SelectCommand */ 20:
            return "SelectCommand";
        case /* RadioCommand */ 21:
            return "RadioCommand";
        case /* KeyCommand */ 22:
            return "KeyCommand";
        case /* KeyComboCommand */ 23:
            return "KeyComboCommand";
        case /* SelectionCommand */ 24:
            return "SelectionCommand";
        case /* MoveInputCursorCommand */ 25:
            return "MoveInputCursorCommand";
        case /* MoveContentEditableCursorCommand */ 26:
            return "MoveContentEditableCursorCommand";
        case /* CopyCommand */ 27:
            return "CopyCommand";
        case /* CopyLinkAddressCommand */ 28:
            return "CopyLinkAddressCommand";
        case /* CopyImageSrcCommand */ 29:
            return "CopyImageSrcCommand";
        case /* CutCommand */ 30:
            return "CutCommand";
        case /* PasteInInputCommand */ 31:
            return "PasteInInputCommand";
        case /* PasteInContentEditableCommand */ 32:
            return "PasteInContentEditableCommand";
        case /* DragCommand */ 33:
            return "DragCommand";
        case /* DropCommand */ 34:
            return "DropCommand";
        case /* ScrollCommand */ 35:
            return "ScrollCommand";
        case /* DownloadCommand */ 36:
            return "DownloadCommand";
        case /* GoogleSheetsCommand */ 37:
            return "GoogleSheetsCommand";
        case /* ContextMenuCommand */ 38:
            return "ContextMenuCommand";
        case /* LoopCommand */ 39:
            return "LoopCommand";
        case /* SwitchCommand */ 40:
            return "SwitchCommand";
        case /* ScreenshotToClipboardCommand */ 41:
            return "ScreenshotToClipboardCommand";
        case /* PasteImageInContentEditableCommand */ 42:
            return "PasteImageInContentEditableCommand";
        case /* PasswordCommand */ 43:
            return "PasswordCommand";
        case /* ClickToOAuthCommand */ 44:
            return "ClickToOAuthCommand";
        case /* UploadCommand */ 45:
            return "UploadCommand";
        case /* WithElementGroupsCommand */ 46:
            return "WithElementGroupsCommand";
    }
}
function fromCommand(command) {
    if (typeof command === "number") {
        switch(command){
            case /* ReloadCommand */ 0:
                return /* ReloadCommand */ 12;
            case /* ForwardCommand */ 1:
                return /* ForwardCommand */ 13;
            case /* BackCommand */ 2:
                return /* BackCommand */ 14;
        }
    } else {
        switch(command.TAG | 0){
            case /* NewWindowCommand */ 0:
                return /* NewWindowCommand */ 0;
            case /* NewWindowWithUrlCommand */ 1:
                return /* NewWindowWithUrlCommand */ 1;
            case /* NewTabCommand */ 2:
                return /* NewTabCommand */ 2;
            case /* NewTabWithUrlCommand */ 3:
                return /* NewTabWithUrlCommand */ 3;
            case /* CloseTabCommand */ 4:
                return /* CloseTabCommand */ 4;
            case /* FocusTabCommand */ 5:
                return /* FocusTabCommand */ 5;
            case /* URLCommand */ 6:
                return /* URLCommand */ 6;
            case /* OpenedLinkCommand */ 7:
                return /* OpenedLinkCommand */ 7;
            case /* SubmitFormCommand */ 8:
                return /* SubmitFormCommand */ 8;
            case /* SubmitFormRedirectCommand */ 9:
                return /* SubmitFormRedirectCommand */ 9;
            case /* ClientRedirectCommand */ 10:
                return /* ClientRedirectCommand */ 10;
            case /* ServerRedirectCommand */ 11:
                return /* ServerRedirectCommand */ 11;
            case /* ClickCommand */ 12:
                return /* ClickCommand */ 15;
            case /* ClickInputCommand */ 13:
                return /* ClickInputCommand */ 16;
            case /* ClickContentEditableCommand */ 14:
                return /* ClickContentEditableCommand */ 17;
            case /* TypeCommand */ 15:
                return /* TypeCommand */ 18;
            case /* CheckboxCommand */ 16:
                return /* CheckboxCommand */ 19;
            case /* SelectCommand */ 17:
                return /* SelectCommand */ 20;
            case /* RadioCommand */ 18:
                return /* RadioCommand */ 21;
            case /* KeyCommand */ 19:
                return /* KeyCommand */ 22;
            case /* KeyComboCommand */ 20:
                return /* KeyComboCommand */ 23;
            case /* SelectionCommand */ 21:
                return /* SelectionCommand */ 24;
            case /* MoveInputCursorCommand */ 22:
                return /* MoveInputCursorCommand */ 25;
            case /* MoveContentEditableCursorCommand */ 23:
                return /* MoveContentEditableCursorCommand */ 26;
            case /* CopyCommand */ 24:
                return /* CopyCommand */ 27;
            case /* CopyLinkAddressCommand */ 25:
                return /* CopyLinkAddressCommand */ 28;
            case /* CutCommand */ 26:
                return /* CutCommand */ 30;
            case /* PasteInInputCommand */ 27:
                return /* PasteInInputCommand */ 31;
            case /* PasteInContentEditableCommand */ 28:
                return /* PasteInContentEditableCommand */ 32;
            case /* DragCommand */ 29:
                return /* DragCommand */ 33;
            case /* DropCommand */ 30:
                return /* DropCommand */ 34;
            case /* ScrollCommand */ 31:
                return /* ScrollCommand */ 35;
            case /* DownloadCommand */ 32:
                return /* DownloadCommand */ 36;
            case /* GoogleSheetsCommand */ 33:
                return /* GoogleSheetsCommand */ 37;
            case /* ContextMenuCommand */ 34:
                return /* ContextMenuCommand */ 38;
            case /* LoopCommand */ 35:
                return /* LoopCommand */ 39;
            case /* SwitchCommand */ 36:
                return /* SwitchCommand */ 40;
            case /* ScreenshotToClipboardCommand */ 37:
                return /* ScreenshotToClipboardCommand */ 41;
            case /* PasteImageInContentEditableCommand */ 38:
                return /* PasteImageInContentEditableCommand */ 42;
            case /* PasswordCommand */ 39:
                return /* PasswordCommand */ 43;
            case /* ClickToOAuthCommand */ 40:
                return /* ClickToOAuthCommand */ 44;
            case /* UploadCommand */ 41:
                return /* UploadCommand */ 45;
            case /* CopyImageSrcCommand */ 42:
                return /* CopyImageSrcCommand */ 29;
            case /* WithElementGroupsCommand */ 43:
                return /* WithElementGroupsCommand */ 46;
        }
    }
}
var TrackedCommand = {
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    stringify: stringify$3,
    fromCommand: fromCommand
};
function t_encode$10(v) {
    if (v) {
        return [
            "ContentScriptMainFrame"
        ];
    } else {
        return [
            "BgScript"
        ];
    }
}
function t_decode$10(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BgScript":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* BgScript */ 0
                    };
                }
            case "ContentScriptMainFrame":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContentScriptMainFrame */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$4(v) {
    if (v) {
        return "ContentScriptMainFrame";
    } else {
        return "BgScript";
    }
}
var FailureEnv = {
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    stringify: stringify$4
};
function t_encode$11(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "trigger",
            Decco.stringToJson(v.trigger)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "failedAfterNCommands",
            Decco.intToJson(v.failedAfterNCommands)
        ],
        [
            "failedIn",
            Decco.stringToJson(v.failedIn)
        ],
        [
            "failedOnHost",
            Decco.stringToJson(v.failedOnHost)
        ],
        [
            "failedOnUrl",
            Decco.stringToJson(v.failedOnUrl)
        ],
        [
            "failedWithCommand",
            Decco.stringToJson(v.failedWithCommand)
        ],
        [
            "failureReason",
            Decco.stringToJson(v.failureReason)
        ],
        [
            "visibility",
            Decco.stringToJson(v.visibility)
        ],
        [
            "hasLoginSmartcut",
            Decco.boolToJson(v.hasLoginSmartcut)
        ]
    ]);
}
function t_decode$11(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
        if (trigger.TAG === /* Ok */ 0) {
            var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
            if (numCommands.TAG === /* Ok */ 0) {
                var failedAfterNCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedAfterNCommands"), null));
                if (failedAfterNCommands.TAG === /* Ok */ 0) {
                    var failedIn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedIn"), null));
                    if (failedIn.TAG === /* Ok */ 0) {
                        var failedOnHost = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedOnHost"), null));
                        if (failedOnHost.TAG === /* Ok */ 0) {
                            var failedOnUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedOnUrl"), null));
                            if (failedOnUrl.TAG === /* Ok */ 0) {
                                var failedWithCommand = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedWithCommand"), null));
                                if (failedWithCommand.TAG === /* Ok */ 0) {
                                    var failureReason = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureReason"), null));
                                    if (failureReason.TAG === /* Ok */ 0) {
                                        var visibility = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                                        if (visibility.TAG === /* Ok */ 0) {
                                            var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                                            if (hasLoginSmartcut.TAG === /* Ok */ 0) {
                                                return {
                                                    TAG: /* Ok */ 0,
                                                    _0: {
                                                        smartcutId: smartcutId._0,
                                                        trigger: trigger._0,
                                                        numCommands: numCommands._0,
                                                        failedAfterNCommands: failedAfterNCommands._0,
                                                        failedIn: failedIn._0,
                                                        failedOnHost: failedOnHost._0,
                                                        failedOnUrl: failedOnUrl._0,
                                                        failedWithCommand: failedWithCommand._0,
                                                        failureReason: failureReason._0,
                                                        visibility: visibility._0,
                                                        hasLoginSmartcut: hasLoginSmartcut._0
                                                    }
                                                };
                                            }
                                            var e = hasLoginSmartcut._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".hasLoginSmartcut" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                }
                                            };
                                        }
                                        var e$1 = visibility._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".visibility" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                            }
                                        };
                                    }
                                    var e$2 = failureReason._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".failureReason" + e$2.path,
                                            message: e$2.message,
                                            value: e$2.value
                                        }
                                    };
                                }
                                var e$3 = failedWithCommand._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".failedWithCommand" + e$3.path,
                                        message: e$3.message,
                                        value: e$3.value
                                    }
                                };
                            }
                            var e$4 = failedOnUrl._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".failedOnUrl" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                }
                            };
                        }
                        var e$5 = failedOnHost._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".failedOnHost" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = failedIn._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".failedIn" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = failedAfterNCommands._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".failedAfterNCommands" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            }
            var e$8 = numCommands._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numCommands" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        }
        var e$9 = trigger._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".trigger" + e$9.path,
                message: e$9.message,
                value: e$9.value
            }
        };
    }
    var e$10 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$10.path,
            message: e$10.message,
            value: e$10.value
        }
    };
}
var WithStringFields$2 = {
    t_encode: t_encode$11,
    t_decode: t_decode$11
};
function t_encode$12(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "trigger",
            PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "failedAfterNCommands",
            Decco.intToJson(v.failedAfterNCommands)
        ],
        [
            "failedIn",
            t_encode$10(v.failedIn)
        ],
        [
            "failedOnHost",
            Decco.stringToJson(v.failedOnHost)
        ],
        [
            "failedOnUrl",
            Decco.stringToJson(v.failedOnUrl)
        ],
        [
            "failedWithCommand",
            t_encode$9(v.failedWithCommand)
        ],
        [
            "failureReason",
            Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, Bg__StateMachine__Shared$SmartcutsMacros.otherFailureReasonShared_encode, v.failureReason)
        ],
        [
            "visibility",
            Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
        ],
        [
            "hasLoginSmartcut",
            Decco.boolToJson(v.hasLoginSmartcut)
        ]
    ]);
}
function t_decode$12(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
        if (trigger.TAG === /* Ok */ 0) {
            var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
            if (numCommands.TAG === /* Ok */ 0) {
                var failedAfterNCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedAfterNCommands"), null));
                if (failedAfterNCommands.TAG === /* Ok */ 0) {
                    var failedIn = t_decode$10(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedIn"), null));
                    if (failedIn.TAG === /* Ok */ 0) {
                        var failedOnHost = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedOnHost"), null));
                        if (failedOnHost.TAG === /* Ok */ 0) {
                            var failedOnUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedOnUrl"), null));
                            if (failedOnUrl.TAG === /* Ok */ 0) {
                                var failedWithCommand = t_decode$9(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedWithCommand"), null));
                                if (failedWithCommand.TAG === /* Ok */ 0) {
                                    var failureReason = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, Bg__StateMachine__Shared$SmartcutsMacros.otherFailureReasonShared_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureReason"), null));
                                    if (failureReason.TAG === /* Ok */ 0) {
                                        var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                                        if (visibility.TAG === /* Ok */ 0) {
                                            var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                                            if (hasLoginSmartcut.TAG === /* Ok */ 0) {
                                                return {
                                                    TAG: /* Ok */ 0,
                                                    _0: {
                                                        smartcutId: smartcutId._0,
                                                        trigger: trigger._0,
                                                        numCommands: numCommands._0,
                                                        failedAfterNCommands: failedAfterNCommands._0,
                                                        failedIn: failedIn._0,
                                                        failedOnHost: failedOnHost._0,
                                                        failedOnUrl: failedOnUrl._0,
                                                        failedWithCommand: failedWithCommand._0,
                                                        failureReason: failureReason._0,
                                                        visibility: visibility._0,
                                                        hasLoginSmartcut: hasLoginSmartcut._0
                                                    }
                                                };
                                            }
                                            var e = hasLoginSmartcut._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".hasLoginSmartcut" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                }
                                            };
                                        }
                                        var e$1 = visibility._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".visibility" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                            }
                                        };
                                    }
                                    var e$2 = failureReason._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".failureReason" + e$2.path,
                                            message: e$2.message,
                                            value: e$2.value
                                        }
                                    };
                                }
                                var e$3 = failedWithCommand._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".failedWithCommand" + e$3.path,
                                        message: e$3.message,
                                        value: e$3.value
                                    }
                                };
                            }
                            var e$4 = failedOnUrl._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".failedOnUrl" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                }
                            };
                        }
                        var e$5 = failedOnHost._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".failedOnHost" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = failedIn._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".failedIn" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = failedAfterNCommands._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".failedAfterNCommands" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            }
            var e$8 = numCommands._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numCommands" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        }
        var e$9 = trigger._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".trigger" + e$9.path,
                message: e$9.message,
                value: e$9.value
            }
        };
    }
    var e$10 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$10.path,
            message: e$10.message,
            value: e$10.value
        }
    };
}
function stringify$5(param) {
    return "{smartcutId: " + (param.smartcutId + (", trigger: " + (PlaybackTrigger$SmartcutsMacros.stringify(param.trigger) + (", numCommands: " + (String(param.numCommands) + (", failedAfterNCommands: " + (String(param.failedAfterNCommands) + (", failedIn: " + ((param.failedIn ? "ContentScriptMainFrame" : "BgScript") + (", failedOnUrl: " + (param.failedOnUrl + (", failedOnHost: " + (param.failedOnHost + (", failedWithCommand: " + (stringify$3(param.failedWithCommand) + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, Bg__StateMachine__Shared$SmartcutsMacros.stringifyOtherFailureReason, param.failureReason) + (", visibility: " + (Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility) + (", hasLoginSmartcut: " + (Pervasives.string_of_bool(param.hasLoginSmartcut) + "}"))))))))))))))))))));
}
var TrackedPlaybackFailure = {
    FailureEnv: FailureEnv,
    WithStringFields: WithStringFields$2,
    t_encode: t_encode$12,
    t_decode: t_decode$12,
    stringify: stringify$5
};
function t_encode$13(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "trigger",
            Decco.stringToJson(v.trigger)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "afterNCommands",
            Decco.intToJson(v.afterNCommands)
        ],
        [
            "numSucceeded",
            Decco.intToJson(v.numSucceeded)
        ],
        [
            "numFailed",
            Decco.intToJson(v.numFailed)
        ],
        [
            "host",
            Decco.stringToJson(v.host)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "command",
            Decco.stringToJson(v.command)
        ],
        [
            "visibility",
            Decco.stringToJson(v.visibility)
        ],
        [
            "hasLoginSmartcut",
            Decco.boolToJson(v.hasLoginSmartcut)
        ]
    ]);
}
function t_decode$13(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
        if (trigger.TAG === /* Ok */ 0) {
            var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
            if (numCommands.TAG === /* Ok */ 0) {
                var afterNCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "afterNCommands"), null));
                if (afterNCommands.TAG === /* Ok */ 0) {
                    var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
                    if (numSucceeded.TAG === /* Ok */ 0) {
                        var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
                        if (numFailed.TAG === /* Ok */ 0) {
                            var host = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "host"), null));
                            if (host.TAG === /* Ok */ 0) {
                                var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                                if (url.TAG === /* Ok */ 0) {
                                    var command = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
                                    if (command.TAG === /* Ok */ 0) {
                                        var visibility = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                                        if (visibility.TAG === /* Ok */ 0) {
                                            var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                                            if (hasLoginSmartcut.TAG === /* Ok */ 0) {
                                                return {
                                                    TAG: /* Ok */ 0,
                                                    _0: {
                                                        smartcutId: smartcutId._0,
                                                        trigger: trigger._0,
                                                        numCommands: numCommands._0,
                                                        afterNCommands: afterNCommands._0,
                                                        numSucceeded: numSucceeded._0,
                                                        numFailed: numFailed._0,
                                                        host: host._0,
                                                        url: url._0,
                                                        command: command._0,
                                                        visibility: visibility._0,
                                                        hasLoginSmartcut: hasLoginSmartcut._0
                                                    }
                                                };
                                            }
                                            var e = hasLoginSmartcut._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".hasLoginSmartcut" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                }
                                            };
                                        }
                                        var e$1 = visibility._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".visibility" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                            }
                                        };
                                    }
                                    var e$2 = command._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".command" + e$2.path,
                                            message: e$2.message,
                                            value: e$2.value
                                        }
                                    };
                                }
                                var e$3 = url._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".url" + e$3.path,
                                        message: e$3.message,
                                        value: e$3.value
                                    }
                                };
                            }
                            var e$4 = host._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".host" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                }
                            };
                        }
                        var e$5 = numFailed._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".numFailed" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = numSucceeded._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".numSucceeded" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = afterNCommands._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".afterNCommands" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            }
            var e$8 = numCommands._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numCommands" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        }
        var e$9 = trigger._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".trigger" + e$9.path,
                message: e$9.message,
                value: e$9.value
            }
        };
    }
    var e$10 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$10.path,
            message: e$10.message,
            value: e$10.value
        }
    };
}
var WithStringFields$3 = {
    t_encode: t_encode$13,
    t_decode: t_decode$13
};
function t_encode$14(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "trigger",
            PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "afterNCommands",
            Decco.intToJson(v.afterNCommands)
        ],
        [
            "numSucceeded",
            Decco.intToJson(v.numSucceeded)
        ],
        [
            "numFailed",
            Decco.intToJson(v.numFailed)
        ],
        [
            "host",
            Decco.stringToJson(v.host)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "command",
            t_encode$9(v.command)
        ],
        [
            "visibility",
            Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
        ],
        [
            "hasLoginSmartcut",
            Decco.boolToJson(v.hasLoginSmartcut)
        ]
    ]);
}
function t_decode$14(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
        if (trigger.TAG === /* Ok */ 0) {
            var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
            if (numCommands.TAG === /* Ok */ 0) {
                var afterNCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "afterNCommands"), null));
                if (afterNCommands.TAG === /* Ok */ 0) {
                    var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
                    if (numSucceeded.TAG === /* Ok */ 0) {
                        var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
                        if (numFailed.TAG === /* Ok */ 0) {
                            var host = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "host"), null));
                            if (host.TAG === /* Ok */ 0) {
                                var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                                if (url.TAG === /* Ok */ 0) {
                                    var command = t_decode$9(Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
                                    if (command.TAG === /* Ok */ 0) {
                                        var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                                        if (visibility.TAG === /* Ok */ 0) {
                                            var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                                            if (hasLoginSmartcut.TAG === /* Ok */ 0) {
                                                return {
                                                    TAG: /* Ok */ 0,
                                                    _0: {
                                                        smartcutId: smartcutId._0,
                                                        trigger: trigger._0,
                                                        numCommands: numCommands._0,
                                                        afterNCommands: afterNCommands._0,
                                                        numSucceeded: numSucceeded._0,
                                                        numFailed: numFailed._0,
                                                        host: host._0,
                                                        url: url._0,
                                                        command: command._0,
                                                        visibility: visibility._0,
                                                        hasLoginSmartcut: hasLoginSmartcut._0
                                                    }
                                                };
                                            }
                                            var e = hasLoginSmartcut._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".hasLoginSmartcut" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                }
                                            };
                                        }
                                        var e$1 = visibility._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".visibility" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                            }
                                        };
                                    }
                                    var e$2 = command._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".command" + e$2.path,
                                            message: e$2.message,
                                            value: e$2.value
                                        }
                                    };
                                }
                                var e$3 = url._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".url" + e$3.path,
                                        message: e$3.message,
                                        value: e$3.value
                                    }
                                };
                            }
                            var e$4 = host._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".host" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                }
                            };
                        }
                        var e$5 = numFailed._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".numFailed" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = numSucceeded._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".numSucceeded" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = afterNCommands._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".afterNCommands" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            }
            var e$8 = numCommands._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".numCommands" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        }
        var e$9 = trigger._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".trigger" + e$9.path,
                message: e$9.message,
                value: e$9.value
            }
        };
    }
    var e$10 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$10.path,
            message: e$10.message,
            value: e$10.value
        }
    };
}
var TrackedPlaybackSetUserCancellation = {
    WithStringFields: WithStringFields$3,
    t_encode: t_encode$14,
    t_decode: t_decode$14
};
function preparePropertiesForSegment$12(param) {
    return {
        smartcutId: param.smartcutId,
        trigger: PlaybackTrigger$SmartcutsMacros.stringify(param.trigger),
        numCommands: param.numCommands,
        afterNCommands: param.afterNCommands,
        numSucceeded: param.numSucceeded,
        numFailed: param.numFailed,
        host: param.host,
        url: param.url,
        command: stringify$3(param.command),
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$20(properties) {
    window.analytics.track("User Canceled Playback Set", preparePropertiesForSegment$12(properties));
}
var TrackUserCanceledPlaybackSet = {
    track: track$20
};
function track$21(properties) {
    window.analytics.track("Deleted Smartcut", properties);
}
var TrackDeleteSmartcut = {
    track: track$21
};
function preparePropertiesForSegment$13(param) {
    var failureReason = param.failureReason;
    var failedOnUrl = param.failedOnUrl;
    var tmp;
    if (typeof failureReason === "number" || failureReason.TAG !== /* FailWithOtherReason */ 0) {
        tmp = failedOnUrl;
    } else {
        var match = failureReason._0;
        tmp = typeof match === "number" || match.TAG !== /* FailWithElementNotFound */ 5 ? failedOnUrl : match._0;
    }
    return {
        smartcutId: param.smartcutId,
        trigger: PlaybackTrigger$SmartcutsMacros.stringify(param.trigger),
        numCommands: param.numCommands,
        failedAfterNCommands: param.failedAfterNCommands,
        failedIn: param.failedIn ? "ContentScriptMainFrame" : "BgScript",
        failedOnHost: param.failedOnHost,
        failedOnUrl: tmp,
        failedWithCommand: stringify$3(param.failedWithCommand),
        failureReason: Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringifyWithoutDetails, function(otherReason) {
            if (typeof otherReason === "number") {
                switch(otherReason){
                    case /* FailWithReceivingEndDoesNotExist */ 0:
                        return "FailWithReceivingEndDoesNotExist";
                    case /* FailWithNoActiveTabToReceiveMessage */ 1:
                        return "FailWithNoActiveTabToReceiveMessage";
                    case /* FailWithUserCancellation */ 2:
                        return "FailWithUserCancellation";
                    case /* FailWithUserStopPlayback */ 3:
                        return "FailWithUserStopPlayback";
                    case /* FailWithPlaybackDownloadNeverInitiated */ 4:
                        return "FailWithPlaybackDownloadNeverInitiated";
                    case /* FailWithOAuthTokenNotGranted */ 5:
                        return "FailWithOAuthTokenNotGranted";
                    case /* FailWithUnhandledException */ 6:
                        return "FailWithUnhandledException";
                    case /* FailWithNoAvailableExecutions */ 7:
                        return "FailWithNoAvailableExecutions";
                }
            } else {
                switch(otherReason.TAG | 0){
                    case /* FailWithWebNavError */ 0:
                        return "FailWithWebNavError";
                    case /* FailWithContentScriptFailure */ 1:
                        return Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringifyWithoutDetails, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, otherReason._1);
                    case /* FailWithReceivedExtensionMessagingResponse */ 2:
                        return "FailWithReceivedExtensionMessagingResponse";
                    case /* FailWithReceivedExtensionMessagingResponseFailureId */ 3:
                        return "FailWithReceivedExtensionMessagingResponseFailureId";
                    case /* FailWithUserCloseLoginPage */ 4:
                        return "FailWithUserCloseLoginPage";
                    case /* FailWithElementNotFound */ 5:
                        return "FailWithElementNotFound";
                    case /* FailWithCannotCopyMissingSrcOfImg */ 6:
                        return "FailWithCannotCopyMissingSrcOfImg";
                    case /* FailWithDocumentNotVisible */ 7:
                        return "FailWithDocumentNotVisible";
                    case /* FailWithDocumentVisibilityUnknownOrUnloaded */ 8:
                        return "FailWithDocumentVisibilityUnknownOrUnloaded";
                    case /* FailWithCdpUnableToGetDocument */ 9:
                        return "FailWithCdpUnableToGetDocument";
                    case /* FailWithCdpUnableToGetContentQuads */ 10:
                        return "FailWithCdpUnableToGetContentQuads";
                    case /* FailWithCouldNotApplySemantic */ 11:
                        return "FailWithCouldNotApplySemantic";
                    case /* FailWithBlockingOverlay */ 12:
                        return "FailWithBlockingOverlay";
                    case /* FailWithErrorWhileWaitForOverlayToUnblock */ 13:
                        return "FailWithErrorWhileWaitForOverlayToUnblock";
                    case /* FailWithErrorWhileSearchForElement */ 14:
                        return "FailWithErrorWhileSearchForElement";
                    case /* FailWithErrorWhileSearchViaCdpQuerySelector */ 15:
                        return "FailWithErrorWhileSearchViaCdpQuerySelector";
                    case /* FailWithPlaybackCaptureScreenshotError */ 16:
                        if (otherReason._0) {
                            return "FailWithPlaybackCaptureScreenshotError(CouldNotCaptureScreenshot)";
                        } else {
                            return "FailWithPlaybackCaptureScreenshotError(CouldNotGetBoxModel)";
                        }
                    case /* FailWithNoSwitchPredicateSatisfied */ 17:
                        return "FailWithNoSwitchPredicateSatisfied";
                    case /* FailWithPermissionsRejected */ 18:
                        return "FailWithPermissionsRejected";
                    case /* FailWithCommandStackInitError */ 19:
                        return "FailWithCommandStackInitError";
                    case /* FailWithCommandStackRewindError */ 20:
                        return "FailWithCommandStackRewindError";
                }
            }
        }, failureReason),
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$22(properties) {
    window.analytics.track("Smartcut Failure", preparePropertiesForSegment$13(properties));
}
var TrackSingleSmartcutExitFailure = {
    track: track$22
};
function preparePropertiesForSegment$14(param) {
    return {
        smartcutId: param.smartcutId,
        numPlaybacks: param.numPlaybacks,
        numCommands: param.numCommands,
        numParams: param.numParams,
        hosts: param.hosts,
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        trigger: PlaybackTrigger$SmartcutsMacros.stringify(param.trigger),
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$23(properties) {
    window.analytics.track("Start Smartcut Playback Set", preparePropertiesForSegment$14(properties));
}
var TrackStartPlaybackSet = {
    track: track$23
};
function preparePropertiesForSegment$15(param) {
    return {
        smartcutId: param.smartcutId,
        numPlaybacks: param.numPlaybacks,
        numSucceeded: param.numSucceeded,
        numFailed: param.numFailed,
        numCommands: param.numCommands,
        numParams: param.numParams,
        hosts: param.hosts,
        visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
        trigger: PlaybackTrigger$SmartcutsMacros.stringify(param.trigger),
        hasLoginSmartcut: param.hasLoginSmartcut
    };
}
function track$24(properties) {
    window.analytics.track("Finish Playback Set", preparePropertiesForSegment$15(properties));
}
var TrackFinishPlaybackSet = {
    track: track$24
};
function preparePropertiesForSegment$16(param) {
    return {
        remainingExecutions: param.remainingExecutions,
        context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
    };
}
function track$25(properties) {
    window.analytics.track("Warned about plan quota", preparePropertiesForSegment$16(properties));
}
var TrackQuotaWarning = {
    track: track$25
};
function preparePropertiesForSegment$17(param) {
    return {
        remainingExecutions: param.remainingExecutions,
        context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
    };
}
function track$26(properties) {
    window.analytics.track("Closed quota warning modal", preparePropertiesForSegment$17(properties));
}
var TrackCloseQuotaWarningModal = {
    track: track$26
};
function preparePropertiesForSegment$18(param) {
    return {
        remainingExecutions: param.remainingExecutions,
        context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
    };
}
function track$27(properties) {
    window.analytics.track("Adjusted playbacks after viewing quota warning modal", preparePropertiesForSegment$18(properties));
}
var TrackAdjustAndPlaybackAfterQuotaWarningModal = {
    track: track$27
};
function preparePropertiesForSegment$19(param) {
    return {
        remainingExecutions: param.remainingExecutions,
        context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
    };
}
function track$28(properties) {
    window.analytics.track("Clicked on View Plans", preparePropertiesForSegment$19(properties));
}
var TrackClickOnViewPlans = {
    track: track$28
};
function preparePropertiesForSegment$20(param) {
    return {
        remainingExecutions: param.remainingExecutions,
        context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
    };
}
function track$29(properties) {
    window.analytics.track("Went to Chrome Store Listing to Write Review", preparePropertiesForSegment$20(properties));
}
var TrackGoToChromeStorePageToWriteReview = {
    track: track$29
};
var WithStringProperties = {};
function t_encode$15(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "installedSmartcutId",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
        ],
        [
            "origins",
            Decco.arrayToJson(Decco.stringToJson, v.origins)
        ],
        [
            "schedulePeriod",
            ScheduledTrigger$SmartcutsMacros.schedulePeriod_encode(v.schedulePeriod)
        ],
        [
            "doesUseCredentials",
            Decco.boolToJson(v.doesUseCredentials)
        ]
    ]);
}
function t_decode$15(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
        if (installedSmartcutId.TAG === /* Ok */ 0) {
            var origins = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "origins"), null));
            if (origins.TAG === /* Ok */ 0) {
                var schedulePeriod = ScheduledTrigger$SmartcutsMacros.schedulePeriod_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedulePeriod"), null));
                if (schedulePeriod.TAG === /* Ok */ 0) {
                    var doesUseCredentials = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "doesUseCredentials"), null));
                    if (doesUseCredentials.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                smartcutId: smartcutId._0,
                                installedSmartcutId: installedSmartcutId._0,
                                origins: origins._0,
                                schedulePeriod: schedulePeriod._0,
                                doesUseCredentials: doesUseCredentials._0
                            }
                        };
                    }
                    var e = doesUseCredentials._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".doesUseCredentials" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = schedulePeriod._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".schedulePeriod" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = origins._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".origins" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = installedSmartcutId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".installedSmartcutId" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function toWithStringProperties(param) {
    return {
        smartcutId: param.smartcutId,
        installedSmartcutId: param.installedSmartcutId,
        origins: param.origins,
        schedulePeriod: ScheduledTrigger$SmartcutsMacros.humanizeSchedulePeriod(param.schedulePeriod),
        doesUseCredentials: param.doesUseCredentials
    };
}
function stringify$6(param) {
    return "{ smartcutId: " + param.smartcutId + ", origins: [" + (param.origins.join(", ") + ("], schedulePeriod, doesUseCredentials: " + (Pervasives.string_of_bool(param.doesUseCredentials) + "}")));
}
var CreateScheduledTrigger = {
    WithStringProperties: WithStringProperties,
    t_encode: t_encode$15,
    t_decode: t_decode$15,
    toWithStringProperties: toWithStringProperties,
    stringify: stringify$6
};
function track$30(properties) {
    window.analytics.track("Created trigger", toWithStringProperties(properties));
}
var TrackCreateScheduledTrigger = {
    track: track$30
};
function track$31(properties) {
    window.analytics.track("Archived trigger", {
        triggerId: properties
    });
}
var TrackArchiveScheduledTrigger = {
    track: track$31
};
function trackUserAttemptToRenewFreePlan(param) {
    window.analytics.track("User attempt to renew free plan");
}
function trackUserSuccessfullyRenewedFreePlan(param) {
    window.analytics.track("User successfully renewed free plan");
}
function track$32(properties) {
    window.analytics.track("User failed to renew free plan", {
        failureInfo: properties
    });
}
var TrackUserFailedToRenewFreePlan = {
    track: track$32
};
function trackExtensionInit(param) {
    window.analytics.track("Extension initialized");
}
var WithStringProperties$1 = {};
function t_encode$16(v) {
    return Js_dict.fromArray([
        [
            "scheduledTriggerId",
            Decco.stringToJson(v.scheduledTriggerId)
        ],
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "installedSmartcutId",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
        ],
        [
            "schedulePeriod",
            ScheduledTrigger$SmartcutsMacros.schedulePeriod_encode(v.schedulePeriod)
        ]
    ]);
}
function t_decode$16(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var scheduledTriggerId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scheduledTriggerId"), null));
    if (scheduledTriggerId.TAG === /* Ok */ 0) {
        var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
        if (smartcutId.TAG === /* Ok */ 0) {
            var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
            if (installedSmartcutId.TAG === /* Ok */ 0) {
                var schedulePeriod = ScheduledTrigger$SmartcutsMacros.schedulePeriod_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedulePeriod"), null));
                if (schedulePeriod.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            scheduledTriggerId: scheduledTriggerId._0,
                            smartcutId: smartcutId._0,
                            installedSmartcutId: installedSmartcutId._0,
                            schedulePeriod: schedulePeriod._0
                        }
                    };
                }
                var e = schedulePeriod._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".schedulePeriod" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = installedSmartcutId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".installedSmartcutId" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = smartcutId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".smartcutId" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = scheduledTriggerId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".scheduledTriggerId" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
var ScheduledTriggerProps = {
    WithStringProperties: WithStringProperties$1,
    t_encode: t_encode$16,
    t_decode: t_decode$16
};
function preparePropertiesForSegment$21(param) {
    return {
        scheduledTriggerId: param.scheduledTriggerId,
        smartcutId: param.smartcutId,
        installedSmartcutId: param.installedSmartcutId,
        schedulePeriod: ScheduledTrigger$SmartcutsMacros.humanizeSchedulePeriod(param.schedulePeriod)
    };
}
function track$33(properties) {
    window.analytics.track("Cancelled scheduled playback", preparePropertiesForSegment$21(properties));
}
var TrackCancelScheduledPlayback = {
    track: track$33
};
var WithStringProperties$2 = {};
function t_encode$17(v) {
    return Js_dict.fromArray([
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "installedSmartcutId",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
        ],
        [
            "commandId",
            Decco.intToJson(v.commandId)
        ],
        [
            "urlWhenDetected",
            Decco.stringToJson(v.urlWhenDetected)
        ],
        [
            "loginUrl",
            Decco.stringToJson(v.loginUrl)
        ]
    ]);
}
function t_decode$17(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */ 0) {
        var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
        if (installedSmartcutId.TAG === /* Ok */ 0) {
            var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
            if (commandId.TAG === /* Ok */ 0) {
                var urlWhenDetected = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlWhenDetected"), null));
                if (urlWhenDetected.TAG === /* Ok */ 0) {
                    var loginUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginUrl"), null));
                    if (loginUrl.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                smartcutId: smartcutId._0,
                                installedSmartcutId: installedSmartcutId._0,
                                commandId: commandId._0,
                                urlWhenDetected: urlWhenDetected._0,
                                loginUrl: loginUrl._0
                            }
                        };
                    }
                    var e = loginUrl._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".loginUrl" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = urlWhenDetected._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".urlWhenDetected" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = commandId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".commandId" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = installedSmartcutId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".installedSmartcutId" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = smartcutId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutId" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
var DetectedLoggedOutProps = {
    WithStringProperties: WithStringProperties$2,
    t_encode: t_encode$17,
    t_decode: t_decode$17
};
function preparePropertiesForSegment$22(param) {
    return {
        smartcutId: param.smartcutId,
        installedSmartcutId: param.installedSmartcutId,
        commandId: param.commandId,
        urlWhenDetected: param.urlWhenDetected,
        loginUrl: param.loginUrl
    };
}
function track$34(properties) {
    window.analytics.track("Detected logged out of website", preparePropertiesForSegment$22(properties));
}
var TrackDetectedUserLoggedOutOfWebsite = {
    track: track$34
};
function track$35(properties) {
    window.analytics.track("User did login to website", {
        loginUrl: properties
    });
}
var TrackUserDidLoginToWebsite = {
    track: track$35
};
function category_encode(v) {
    switch(v){
        case /* DoesntWorkOnWebsites */ 0:
            return [
                "DoesntWorkOnWebsites"
            ];
        case /* DontKnowHowToUse */ 1:
            return [
                "DontKnowHowToUse"
            ];
        case /* DoesntHaveFeatureNeeded */ 2:
            return [
                "DoesntHaveFeatureNeeded"
            ];
        case /* RequiresPayment */ 3:
            return [
                "RequiresPayment"
            ];
        case /* SlowsDownMyComputer */ 4:
            return [
                "SlowsDownMyComputer"
            ];
        case /* InstallOnAnotherDevice */ 5:
            return [
                "InstallOnAnotherDevice"
            ];
        case /* OtherReason */ 6:
            return [
                "OtherReason"
            ];
    }
}
function category_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DoesntHaveFeatureNeeded":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DoesntHaveFeatureNeeded */ 2
                    };
                }
            case "DoesntWorkOnWebsites":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DoesntWorkOnWebsites */ 0
                    };
                }
            case "DontKnowHowToUse":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DontKnowHowToUse */ 1
                    };
                }
            case "InstallOnAnotherDevice":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* InstallOnAnotherDevice */ 5
                    };
                }
            case "OtherReason":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* OtherReason */ 6
                    };
                }
            case "RequiresPayment":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RequiresPayment */ 3
                    };
                }
            case "SlowsDownMyComputer":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SlowsDownMyComputer */ 4
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function displayCategory(category) {
    switch(category){
        case /* DoesntWorkOnWebsites */ 0:
            return "It doesn't work on websites";
        case /* DontKnowHowToUse */ 1:
            return "I don't know how to use it";
        case /* DoesntHaveFeatureNeeded */ 2:
            return "It doesn't have feature(s) I needed";
        case /* RequiresPayment */ 3:
            return "I don't like it requires payments/It's too expensive";
        case /* SlowsDownMyComputer */ 4:
            return "It slows down my computer";
        case /* InstallOnAnotherDevice */ 5:
            return "I have installed/will install Smartcuts on my other computers";
        case /* OtherReason */ 6:
            return "Other reasons";
    }
}
var ForOrigTrack = {};
function forOrigTrack(props) {
    var arg = props.category;
    var category = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expect some reason for uninstalling)");
    var extraInfo;
    switch(category){
        case /* DoesntWorkOnWebsites */ 0:
            extraInfo = Belt_Option.map(props.extraInfo.doesntWorkOnWebsites, function(v) {
                if (v.TAG === /* FromInstalledSmartcuts */ 0) {
                    return v._0.join(", ");
                } else {
                    return v._0;
                }
            });
            break;
        case /* DoesntHaveFeatureNeeded */ 2:
            extraInfo = props.extraInfo.doesntHaveFeatureNeeded;
            break;
        case /* DontKnowHowToUse */ 1:
        case /* RequiresPayment */ 3:
        case /* SlowsDownMyComputer */ 4:
        case /* InstallOnAnotherDevice */ 5:
            extraInfo = undefined;
            break;
        case /* OtherReason */ 6:
            extraInfo = props.extraInfo.otherReason;
            break;
    }
    return {
        category: displayCategory(category),
        extraInfo: extraInfo
    };
}
var ReasonForUninstalling = {
    category_encode: category_encode,
    category_decode: category_decode,
    displayCategory: displayCategory,
    ForOrigTrack: ForOrigTrack,
    forOrigTrack: forOrigTrack
};
function track$36(properties) {
    window.analytics.track("User selected reason for uninstalling", forOrigTrack(properties));
}
var TrackUserSelectReasonForUninstalling = {
    track: track$36
};
function preparePropertiesForSegment$23(propertiesForTrack) {
    return {
        reason: forOrigTrack(propertiesForTrack.reason),
        feedback: propertiesForTrack.feedback
    };
}
function track$37(properties) {
    window.analytics.track("User submitted post-uninstall survey", preparePropertiesForSegment$23(properties));
}
var TrackUserSubmitUninstallSurvey = {
    track: track$37
};
function credentialType_encode(v) {
    if (v) {
        return [
            "OAuthVia",
            OAuthProvider$SmartcutsMacros.t_encode(v._0)
        ];
    } else {
        return [
            "Password"
        ];
    }
}
function credentialType_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OAuthVia":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = OAuthProvider$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* OAuthVia */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Password":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Password */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function credentialTypeToString(credentialType) {
    if (credentialType) {
        return "OAuth via " + OAuthProvider$SmartcutsMacros.stringify(credentialType._0);
    } else {
        return "Password";
    }
}
function preparePropertiesForSegment$24(param) {
    return {
        hostname: param.hostname,
        credentialType: credentialTypeToString(param.credentialType)
    };
}
function track$38(properties) {
    window.analytics.track("User added credential", preparePropertiesForSegment$24(properties));
}
var TrackUserAddedCredential = {
    track: track$38
};
function preparePropertiesForSegment$25(param) {
    return {
        hostname: param.hostname,
        credentialType: credentialTypeToString(param.credentialType)
    };
}
function track$39(properties) {
    window.analytics.track("User removed credential", preparePropertiesForSegment$25(properties));
}
var TrackUserRemovedCredential = {
    track: track$39
};
var TrackedUserClickOnRecordLoginSmartcut = {};
function track$40(properties) {
    window.analytics.track("Click on record new login smartcut", properties);
}
var TrackUserClickOnRecordNewLoginSmartcut = {
    track: track$40
};
var TrackedUserRemoveLoginSmartcut = {};
function track$41(properties) {
    window.analytics.track("Click on remove login smartcut", properties);
}
var TrackUserClickOnRemoveLoginSmartcut = {
    track: track$41
};
function track$42(properties) {
    window.analytics.track("Did remove login smartcut", properties);
}
var TrackUserDidDetachLoginSmartcut = {
    track: track$42
};
exports.exists = exists;
exports.MakeTrackerForEventWithProperties = MakeTrackerForEventWithProperties;
exports.TrackedInstallableSmartcutProps = TrackedInstallableSmartcutProps;
exports.TrackedInstalledSmartcutProps = TrackedInstalledSmartcutProps;
exports.TrackedVisitingFromDevice = TrackedVisitingFromDevice;
exports.TrackVisitingFromDevice = TrackVisitingFromDevice;
exports.trackVisitingFromDevice = trackVisitingFromDevice;
exports.TrackedSchedulingSmartcutProps = TrackedSchedulingSmartcutProps;
exports.TrackViewInstallableSmartcut = TrackViewInstallableSmartcut;
exports.trackAttemptAcceptInvite = trackAttemptAcceptInvite;
exports.trackAcceptedInvite = trackAcceptedInvite;
exports.TrackFailedAttemptToAcceptInvite = TrackFailedAttemptToAcceptInvite;
exports.trackAttemptSetPassword = trackAttemptSetPassword;
exports.trackSetPassword = trackSetPassword;
exports.TrackFailedAttemptToSetPassword = TrackFailedAttemptToSetPassword;
exports.trackUserForgotPassword = trackUserForgotPassword;
exports.trackChromeExtensionDownloadAttempt = trackChromeExtensionDownloadAttempt;
exports.TrackChromeExtensionInstall = TrackChromeExtensionInstall;
exports.TrackChromeExtensionUninstall = TrackChromeExtensionUninstall;
exports.TrackChromeExtensionUpdate = TrackChromeExtensionUpdate;
exports.trackChromeUpdate = trackChromeUpdate;
exports.trackChromeSharedModuleUpdate = trackChromeSharedModuleUpdate;
exports.TrackedPermissionsRejection = TrackedPermissionsRejection;
exports.TrackedPermissionsRejectionWithStringReason = TrackedPermissionsRejectionWithStringReason;
exports.TrackRejectPermissions = TrackRejectPermissions;
exports.TrackedViewOauthExplanationModal = TrackedViewOauthExplanationModal;
exports.TrackViewOauthExplanationModal = TrackViewOauthExplanationModal;
exports.trackCancelOAuthExplanationModal = trackCancelOAuthExplanationModal;
exports.trackInitiateOAuthConsentFlow = trackInitiateOAuthConsentFlow;
exports.trackOAuthConsentGranted = trackOAuthConsentGranted;
exports.trackOAuthConsentRejected = trackOAuthConsentRejected;
exports.TrackedStartRecording = TrackedStartRecording;
exports.TrackStartedRecording = TrackStartedRecording;
exports.finalSmartcutRecordingProps_encode = finalSmartcutRecordingProps_encode;
exports.finalSmartcutRecordingProps_decode = finalSmartcutRecordingProps_decode;
exports.finalSmartcutProps_encode = finalSmartcutProps_encode;
exports.finalSmartcutProps_decode = finalSmartcutProps_decode;
exports.TrackAttemptedStopRecording = TrackAttemptedStopRecording;
exports.TrackFinishedAuthoringSmartcut = TrackFinishedAuthoringSmartcut;
exports.TrackInterestedInInstallingSmartcut = TrackInterestedInInstallingSmartcut;
exports.TrackAttemptInstallSmartcut = TrackAttemptInstallSmartcut;
exports.trackUserAttemptToContactSupport = trackUserAttemptToContactSupport;
exports.PageOnboardingSpecified = PageOnboardingSpecified;
exports.TrackBeginAutoInstallSmartcut = TrackBeginAutoInstallSmartcut;
exports.TrackInstallSmartcutSuccess = TrackInstallSmartcutSuccess;
exports.TrackInstallSmartcutFailed = TrackInstallSmartcutFailed;
exports.finalSmartcutPropsWithId_encode = finalSmartcutPropsWithId_encode;
exports.finalSmartcutPropsWithId_decode = finalSmartcutPropsWithId_decode;
exports.TrackedPermissionEventProps = TrackedPermissionEventProps;
exports.TrackAboutToExplainPermission = TrackAboutToExplainPermission;
exports.TrackPermissionGrant = TrackPermissionGrant;
exports.TrackPermissionDeny = TrackPermissionDeny;
exports.TrackedStartPlaybackSet = TrackedStartPlaybackSet;
exports.TrackedFinishPlaybackSet = TrackedFinishPlaybackSet;
exports.TrackedCommand = TrackedCommand;
exports.TrackedPlaybackFailure = TrackedPlaybackFailure;
exports.TrackedPlaybackSetUserCancellation = TrackedPlaybackSetUserCancellation;
exports.TrackUserCanceledPlaybackSet = TrackUserCanceledPlaybackSet;
exports.TrackDeleteSmartcut = TrackDeleteSmartcut;
exports.TrackSingleSmartcutExitFailure = TrackSingleSmartcutExitFailure;
exports.TrackStartPlaybackSet = TrackStartPlaybackSet;
exports.TrackFinishPlaybackSet = TrackFinishPlaybackSet;
exports.TrackQuotaWarning = TrackQuotaWarning;
exports.TrackCloseQuotaWarningModal = TrackCloseQuotaWarningModal;
exports.TrackAdjustAndPlaybackAfterQuotaWarningModal = TrackAdjustAndPlaybackAfterQuotaWarningModal;
exports.TrackClickOnViewPlans = TrackClickOnViewPlans;
exports.TrackGoToChromeStorePageToWriteReview = TrackGoToChromeStorePageToWriteReview;
exports.CreateScheduledTrigger = CreateScheduledTrigger;
exports.TrackCreateScheduledTrigger = TrackCreateScheduledTrigger;
exports.TrackArchiveScheduledTrigger = TrackArchiveScheduledTrigger;
exports.trackUserAttemptToRenewFreePlan = trackUserAttemptToRenewFreePlan;
exports.trackUserSuccessfullyRenewedFreePlan = trackUserSuccessfullyRenewedFreePlan;
exports.TrackUserFailedToRenewFreePlan = TrackUserFailedToRenewFreePlan;
exports.trackExtensionInit = trackExtensionInit;
exports.ScheduledTriggerProps = ScheduledTriggerProps;
exports.TrackCancelScheduledPlayback = TrackCancelScheduledPlayback;
exports.DetectedLoggedOutProps = DetectedLoggedOutProps;
exports.TrackDetectedUserLoggedOutOfWebsite = TrackDetectedUserLoggedOutOfWebsite;
exports.TrackUserDidLoginToWebsite = TrackUserDidLoginToWebsite;
exports.ReasonForUninstalling = ReasonForUninstalling;
exports.TrackUserSelectReasonForUninstalling = TrackUserSelectReasonForUninstalling;
exports.TrackUserSubmitUninstallSurvey = TrackUserSubmitUninstallSurvey;
exports.credentialType_encode = credentialType_encode;
exports.credentialType_decode = credentialType_decode;
exports.credentialTypeToString = credentialTypeToString;
exports.TrackUserAddedCredential = TrackUserAddedCredential;
exports.TrackUserRemovedCredential = TrackUserRemovedCredential;
exports.TrackedUserClickOnRecordLoginSmartcut = TrackedUserClickOnRecordLoginSmartcut;
exports.TrackUserClickOnRecordNewLoginSmartcut = TrackUserClickOnRecordNewLoginSmartcut;
exports.TrackedUserRemoveLoginSmartcut = TrackedUserRemoveLoginSmartcut;
exports.TrackUserClickOnRemoveLoginSmartcut = TrackUserClickOnRemoveLoginSmartcut;
exports.TrackUserDidDetachLoginSmartcut = TrackUserDidDetachLoginSmartcut; /* Smartcut-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 80190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Result = __webpack_require__(86369);
var Util$SmartcutsMacros = __webpack_require__(25092);
var JsExnUtils$SmartcutsMacros = __webpack_require__(79713);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var GoogleApiHelpers$SmartcutsMacros = __webpack_require__(81530);
var Browser__Identity$SmartcutsMacros = __webpack_require__(60051);
var GoogleApis__Sheets$SmartcutsMacros = __webpack_require__(45694);
var GoogleSheetHelpers$SmartcutsMacros = __webpack_require__(42828);
var GoogleSheetHelpers2$SmartcutsMacros = __webpack_require__(97533);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
function error_encode(v) {
    if (typeof v === "number") {
        if (v === /* DidNotGetOAuthToken */ 0) {
            return [
                "DidNotGetOAuthToken"
            ];
        } else {
            return [
                "GoogleSheetApiAuthenticationError"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* CouldNotFindGoogleSheetBySpreadsheetId */ 0:
            return [
                "CouldNotFindGoogleSheetBySpreadsheetId",
                Decco.stringToJson(v._0)
            ];
        case /* GapiIsUndefined */ 1:
            return [
                "GapiIsUndefined",
                JsExnUtils$SmartcutsMacros.t_encode(v._0)
            ];
        case /* ErrorFetchGoogleSheet */ 2:
            return [
                "ErrorFetchGoogleSheet",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
            ];
        case /* JsonDecodeArrayError */ 3:
            return [
                "JsonDecodeArrayError",
                v._0
            ];
    }
}
function error_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CouldNotFindGoogleSheetBySpreadsheetId":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DidNotGetOAuthToken":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidNotGetOAuthToken */ 0
                    };
                }
            case "ErrorFetchGoogleSheet":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ErrorFetchGoogleSheet */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "GapiIsUndefined":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GapiIsUndefined */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "GoogleSheetApiAuthenticationError":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* GoogleSheetApiAuthenticationError */ 1
                    };
                }
            case "JsonDecodeArrayError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = {
                    TAG: /* Ok */ 0,
                    _0: Belt_Array.getExn(jsonArr$1, 1)
                };
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* JsonDecodeArrayError */ 3,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyError(error) {
    if (typeof error === "number") {
        if (error === /* DidNotGetOAuthToken */ 0) {
            return "DidNotGetOAuthToken";
        } else {
            return "GoogleSheetApiAuthenticationError";
        }
    }
    switch(error.TAG | 0){
        case /* CouldNotFindGoogleSheetBySpreadsheetId */ 0:
            return "CouldNotFindGoogleSheetBySpreadsheetId(" + (error._0 + ")");
        case /* GapiIsUndefined */ 1:
            return "GapiIsUndefined";
        case /* ErrorFetchGoogleSheet */ 2:
            return "ErrorFetchGoogleSheet";
        case /* JsonDecodeArrayError */ 3:
            return "JsonDecodeArrayError(" + (JSON.stringify(error._0) + ")");
    }
}
function fetchRowsAndTransformToPlaybackData(smartcutParams, loginSmartcuts, userCredentials, spreadsheetId) {
    return Browser__Identity$SmartcutsMacros.getAuthToken(false, false, undefined, undefined, undefined).then(function(maybeToken) {
        if (maybeToken !== undefined) {
            return GoogleSheetHelpers$SmartcutsMacros.loadClientButReloadExtensionIfGapiIsNotDefined(undefined).then(function(client1) {
                return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(function(accessToken, client) {
                    return GoogleApis__Sheets$SmartcutsMacros.get(accessToken, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, spreadsheetId, undefined, undefined, client);
                }, maybeToken, client1);
            }).then(function(result) {
                var worksheets;
                if (result.TAG === /* Ok */ 0) {
                    var match = result._0;
                    if (typeof match === "number") {
                        return Util$SmartcutsMacros.logAndRaiseJsError("Could not reset invalid token");
                    }
                    if (match.TAG === /* MethodDidReturnUsingOriginalToken */ 0) {
                        var match$1 = match._0;
                        if (match$1 === undefined) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */ 0,
                                    _0: spreadsheetId
                                }
                            });
                        }
                        var worksheets$1 = match$1.sheets;
                        if (worksheets$1 === undefined) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */ 0,
                                    _0: spreadsheetId
                                }
                            });
                        }
                        worksheets = worksheets$1;
                    } else {
                        var match$2 = match.return_;
                        if (match$2 === undefined) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */ 0,
                                    _0: spreadsheetId
                                }
                            });
                        }
                        var worksheets$2 = match$2.sheets;
                        if (worksheets$2 === undefined) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */ 0,
                                    _0: spreadsheetId
                                }
                            });
                        }
                        worksheets = worksheets$2;
                    }
                } else {
                    var match$3 = result._0;
                    switch(match$3.TAG | 0){
                        case /* MethodDidThrowPromiseError */ 0:
                            var httpResponse = match$3.errorType;
                            if (typeof httpResponse === "number") {
                                return Util$SmartcutsMacros.logAndRaiseJsError("Gapi call failed");
                            }
                            switch(httpResponse.TAG | 0){
                                case /* GapiIsUndefined */ 2:
                                    return Util$SmartcutsMacros.logAndRaiseJsError("Gapi not loaded");
                                case /* HttpResponse */ 12:
                                    var httpResponse$1 = httpResponse._0;
                                    console.warn("Google api call failed:", httpResponse$1);
                                    return Util$SmartcutsMacros.logAndRaiseJsError("Google api call failed with http response " + String(httpResponse$1.result.error.code));
                                default:
                                    return Util$SmartcutsMacros.logAndRaiseJsError("Gapi call failed");
                            }
                        case /* JsExnWhileRemoveCachedOAuthToken */ 1:
                            return Util$SmartcutsMacros.logAndRaiseJsError("Error while removing cached token");
                        case /* PromiseErrorWhileGetNewOAuthToken */ 2:
                            return Util$SmartcutsMacros.logAndRaiseJsError("Error while getting new token");
                    }
                }
                var arg = Caml_array.get(worksheets, 0).data;
                var worksheetData = function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                }("Expected sheets[0] to contain data");
                var arg$1 = Caml_array.get(worksheetData, 0).rowData;
                var rows = function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                }("Expected data to contain rowData");
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: rows
                });
            }).catch(function(jsPromiseError) {
                var httpResponse = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
                if (typeof httpResponse === "number") {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* ErrorFetchGoogleSheet */ 2,
                            _0: jsPromiseError
                        }
                    });
                }
                switch(httpResponse.TAG | 0){
                    case /* GapiIsUndefined */ 2:
                        var jsExn = httpResponse._0;
                        return Util$SmartcutsMacros.wait(100).then(function(_timeoutId) {
                            return browser.runtime.reload();
                        }).then(function(param) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* GapiIsUndefined */ 1,
                                    _0: jsExn
                                }
                            });
                        });
                    case /* HttpResponse */ 12:
                        var httpResponse$1 = httpResponse._0;
                        console.warn("Google api call failed:", httpResponse$1);
                        var match = httpResponse$1.result.error.code;
                        if (match !== 401) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* ErrorFetchGoogleSheet */ 2,
                                    _0: jsPromiseError
                                }
                            });
                        } else {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: /* GoogleSheetApiAuthenticationError */ 1
                            });
                        }
                    default:
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* ErrorFetchGoogleSheet */ 2,
                                _0: jsPromiseError
                            }
                        });
                }
            });
        } else {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: /* DidNotGetOAuthToken */ 0
            });
        }
    }).then(function(result) {
        return Promise.resolve(Belt_Result.map(result, function(rows) {
            var func = Curry._2(GoogleSheetHelpers2$SmartcutsMacros.transformRowsToPlaybackValues, undefined, smartcutParams);
            var func$1 = Curry._1(func, loginSmartcuts);
            return Curry._2(func$1, userCredentials, rows);
        }));
    });
}
exports.error_encode = error_encode;
exports.error_decode = error_decode;
exports.stringifyError = stringifyError;
exports.fetchRowsAndTransformToPlaybackData = fetchRowsAndTransformToPlaybackData; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 82194:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var Config$SmartcutsMacros = __webpack_require__(55838);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ExtErrors$SmartcutsMacros = __webpack_require__(36570);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var Browser__Runtime$SmartcutsMacros = __webpack_require__(59508);
var Browser__Windows$SmartcutsMacros = __webpack_require__(49325);
var SelectorOverrides$SmartcutsMacros = __webpack_require__(51670);
var ExtensionMessaging$SmartcutsMacros = __webpack_require__(31052);
var SelectionSemantics$SmartcutsMacros = __webpack_require__(8741);
var GenericCommandStack$SmartcutsMacros = __webpack_require__(50924);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var PermissionAndOrigin$SmartcutsMacros = __webpack_require__(93834);
var Browser__WebNavigation$SmartcutsMacros = __webpack_require__(25558);
var ExtErrors__OverlayBlocking$SmartcutsMacros = __webpack_require__(18962);
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = __webpack_require__(20229);
var ExtensionMessaging__FromExtension$SmartcutsMacros = __webpack_require__(15462);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
var ContentScript__StateMachine__Types$SmartcutsMacros = __webpack_require__(65595);
var ExtensionMessagingAndStateMachineTypes$SmartcutsMacros = __webpack_require__(87210);
function basicEvent_encode(v) {
    if (typeof v === "number") {
        if (v === /* DidNotGetOAuthToken */ 0) {
            return [
                "DidNotGetOAuthToken"
            ];
        } else {
            return [
                "DidEncounterGoogleSheetAuthenticationError"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* MessageToExtension */ 0:
            return [
                "MessageToExtension",
                Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.message_encode, v._0),
                Browser__Runtime$SmartcutsMacros.Sender.t_encode(v._1),
                Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.respondToSender_encode, v._2),
                ExtensionMessaging$SmartcutsMacros.rejectToTab_encode(v._3)
            ];
        case /* BrowserActionClicked */ 1:
            return [
                "BrowserActionClicked",
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._0)
            ];
        case /* GotWindowInfo */ 2:
            return [
                "GotWindowInfo",
                Decco.intToJson(v._0),
                Curry._1(Browser__Windows$SmartcutsMacros.$$Window.t_encode, v._1),
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._2)
            ];
        case /* GotTabInfo */ 3:
            return [
                "GotTabInfo",
                Decco.intToJson(v._0),
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._1)
            ];
        case /* OnWebNavigationBeforeNavigate */ 4:
            return [
                "OnWebNavigationBeforeNavigate",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnBeforeNavigate.Details.t_encode, v._0)
            ];
        case /* OnWebNavigationCommitted */ 5:
            return [
                "OnWebNavigationCommitted",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.record_encode, v._0)
            ];
        case /* OnWebNavigationHistoryStateUpdated */ 6:
            return [
                "OnWebNavigationHistoryStateUpdated",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.record_encode, v._0)
            ];
        case /* OnWebNavigationCompleted */ 7:
            return [
                "OnWebNavigationCompleted",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCompleted.Details.t_encode, v._0)
            ];
        case /* OnMainFrameWebNavigationError */ 8:
            return [
                "OnMainFrameWebNavigationError",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_encode, v._0)
            ];
        case /* OnSubFrameWebNavigationError */ 9:
            return [
                "OnSubFrameWebNavigationError",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_encode, v._0)
            ];
        case /* OnReceivingEndDoesNotExistForTab */ 10:
            return [
                "OnReceivingEndDoesNotExistForTab",
                Decco.intToJson(v._0)
            ];
        case /* OnTabCreated */ 11:
            return [
                "OnTabCreated",
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._0)
            ];
        case /* OnTabUpdated */ 12:
            return [
                "OnTabUpdated",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnUpdated.ChangeInfo.Record.t_encode, v._1),
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._2)
            ];
        case /* OnTabRemoved */ 13:
            return [
                "OnTabRemoved",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnRemoved.RemoveInfo.t_encode, v._1)
            ];
        case /* OnTabMovedWithinWindow */ 14:
            return [
                "OnTabMovedWithinWindow",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnMoved.MoveInfo.t_encode, v._1)
            ];
        case /* OnTabDetached */ 15:
            return [
                "OnTabDetached",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnDetached.DetachInfo.t_encode, v._1)
            ];
        case /* OnTabAttached */ 16:
            return [
                "OnTabAttached",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnAttached.AttachInfo.t_encode, v._1)
            ];
        case /* OnActiveTab */ 17:
            return [
                "OnActiveTab",
                Curry._1(Browser__Tabs$SmartcutsMacros.OnActivated.ActiveInfo.t_encode, v._0)
            ];
        case /* OnReplacedTab */ 18:
            return [
                "OnReplacedTab",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* OnWindowCreated */ 19:
            return [
                "OnWindowCreated",
                Curry._1(Browser__Windows$SmartcutsMacros.$$Window.t_encode, v._0)
            ];
        case /* OnWindowRemoved */ 20:
            return [
                "OnWindowRemoved",
                Decco.intToJson(v._0)
            ];
        case /* OnWindowFocusChange */ 21:
            return [
                "OnWindowFocusChange",
                Decco.intToJson(v._0)
            ];
        case /* OnNotificationButtonClicked */ 22:
            return [
                "OnNotificationButtonClicked",
                Decco.stringToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* DidGetOAuthToken */ 23:
            return [
                "DidGetOAuthToken",
                Decco.stringToJson(v._0),
                Decco.boolToJson(v._1)
            ];
        case /* DidRemoveCachedOAuthToken */ 24:
            return [
                "DidRemoveCachedOAuthToken",
                Decco.stringToJson(v._0)
            ];
        case /* DidNotRemoveCachedOAuthToken */ 25:
            return [
                "DidNotRemoveCachedOAuthToken",
                Decco.stringToJson(v._0)
            ];
    }
}
function basicEvent_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BrowserActionClicked":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BrowserActionClicked */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DidEncounterGoogleSheetAuthenticationError":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidEncounterGoogleSheetAuthenticationError */ 1
                    };
                }
            case "DidGetOAuthToken":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DidGetOAuthToken */ 23,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "DidNotGetOAuthToken":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidNotGetOAuthToken */ 0
                    };
                }
            case "DidNotRemoveCachedOAuthToken":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidNotRemoveCachedOAuthToken */ 25,
                            _0: v0$1._0
                        }
                    };
                }
                var e$3 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "DidRemoveCachedOAuthToken":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidRemoveCachedOAuthToken */ 24,
                            _0: v0$2._0
                        }
                    };
                }
                var e$4 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "GotTabInfo":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* GotTabInfo */ 3,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$5 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "GotWindowInfo":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Curry._1(Browser__Windows$SmartcutsMacros.$$Window.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                var match$7 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        if (match$7.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* GotWindowInfo */ 2,
                                    _0: match$5._0,
                                    _1: match$6._0,
                                    _2: match$7._0
                                }
                            };
                        }
                        var e$7 = match$7._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$7.path,
                                message: e$7.message,
                                value: e$7.value
                            }
                        };
                    }
                    var e$8 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                        }
                    };
                }
                var e$9 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "MessageToExtension":
                if (tagged.length !== 5) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$8 = Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.message_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$9 = Browser__Runtime$SmartcutsMacros.Sender.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$10 = Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.respondToSender_decode, Belt_Array.getExn(jsonArr$1, 3));
                var match$11 = ExtensionMessaging$SmartcutsMacros.rejectToTab_decode(Belt_Array.getExn(jsonArr$1, 4));
                if (match$8.TAG === /* Ok */ 0) {
                    if (match$9.TAG === /* Ok */ 0) {
                        if (match$10.TAG === /* Ok */ 0) {
                            if (match$11.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        TAG: /* MessageToExtension */ 0,
                                        _0: match$8._0,
                                        _1: match$9._0,
                                        _2: match$10._0,
                                        _3: match$11._0
                                    }
                                };
                            }
                            var e$10 = match$11._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[3]" + e$10.path,
                                    message: e$10.message,
                                    value: e$10.value
                                }
                            };
                        }
                        var e$11 = match$10._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$11.path,
                                message: e$11.message,
                                value: e$11.value
                            }
                        };
                    }
                    var e$12 = match$9._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                        }
                    };
                }
                var e$13 = match$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "OnActiveTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._1(Browser__Tabs$SmartcutsMacros.OnActivated.ActiveInfo.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnActiveTab */ 17,
                            _0: v0$3._0
                        }
                    };
                }
                var e$14 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "OnMainFrameWebNavigationError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnMainFrameWebNavigationError */ 8,
                            _0: v0$4._0
                        }
                    };
                }
                var e$15 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "OnNotificationButtonClicked":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$12 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$13 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$12.TAG === /* Ok */ 0) {
                    if (match$13.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* OnNotificationButtonClicked */ 22,
                                _0: match$12._0,
                                _1: match$13._0
                            }
                        };
                    }
                    var e$16 = match$13._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$16.path,
                            message: e$16.message,
                            value: e$16.value
                        }
                    };
                }
                var e$17 = match$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "OnReceivingEndDoesNotExistForTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnReceivingEndDoesNotExistForTab */ 10,
                            _0: v0$5._0
                        }
                    };
                }
                var e$18 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "OnReplacedTab":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$14 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$15 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$14.TAG === /* Ok */ 0) {
                    if (match$15.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* OnReplacedTab */ 18,
                                _0: match$14._0,
                                _1: match$15._0
                            }
                        };
                    }
                    var e$19 = match$15._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$19.path,
                            message: e$19.message,
                            value: e$19.value
                        }
                    };
                }
                var e$20 = match$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            case "OnSubFrameWebNavigationError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnSubFrameWebNavigationError */ 9,
                            _0: v0$6._0
                        }
                    };
                }
                var e$21 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$21.path,
                        message: e$21.message,
                        value: e$21.value
                    }
                };
            case "OnTabAttached":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$16 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$17 = Curry._1(Browser__Tabs$SmartcutsMacros.OnAttached.AttachInfo.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$16.TAG === /* Ok */ 0) {
                    if (match$17.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* OnTabAttached */ 16,
                                _0: match$16._0,
                                _1: match$17._0
                            }
                        };
                    }
                    var e$22 = match$17._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$22.path,
                            message: e$22.message,
                            value: e$22.value
                        }
                    };
                }
                var e$23 = match$16._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                    }
                };
            case "OnTabCreated":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnTabCreated */ 11,
                            _0: v0$7._0
                        }
                    };
                }
                var e$24 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$24.path,
                        message: e$24.message,
                        value: e$24.value
                    }
                };
            case "OnTabDetached":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$18 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$19 = Curry._1(Browser__Tabs$SmartcutsMacros.OnDetached.DetachInfo.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$18.TAG === /* Ok */ 0) {
                    if (match$19.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* OnTabDetached */ 15,
                                _0: match$18._0,
                                _1: match$19._0
                            }
                        };
                    }
                    var e$25 = match$19._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$25.path,
                            message: e$25.message,
                            value: e$25.value
                        }
                    };
                }
                var e$26 = match$18._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$26.path,
                        message: e$26.message,
                        value: e$26.value
                    }
                };
            case "OnTabMovedWithinWindow":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$20 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$21 = Curry._1(Browser__Tabs$SmartcutsMacros.OnMoved.MoveInfo.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$20.TAG === /* Ok */ 0) {
                    if (match$21.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* OnTabMovedWithinWindow */ 14,
                                _0: match$20._0,
                                _1: match$21._0
                            }
                        };
                    }
                    var e$27 = match$21._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$27.path,
                            message: e$27.message,
                            value: e$27.value
                        }
                    };
                }
                var e$28 = match$20._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$28.path,
                        message: e$28.message,
                        value: e$28.value
                    }
                };
            case "OnTabRemoved":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$22 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$23 = Curry._1(Browser__Tabs$SmartcutsMacros.OnRemoved.RemoveInfo.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$22.TAG === /* Ok */ 0) {
                    if (match$23.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* OnTabRemoved */ 13,
                                _0: match$22._0,
                                _1: match$23._0
                            }
                        };
                    }
                    var e$29 = match$23._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$29.path,
                            message: e$29.message,
                            value: e$29.value
                        }
                    };
                }
                var e$30 = match$22._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$30.path,
                        message: e$30.message,
                        value: e$30.value
                    }
                };
            case "OnTabUpdated":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$24 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$25 = Curry._1(Browser__Tabs$SmartcutsMacros.OnUpdated.ChangeInfo.Record.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                var match$26 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$24.TAG === /* Ok */ 0) {
                    if (match$25.TAG === /* Ok */ 0) {
                        if (match$26.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* OnTabUpdated */ 12,
                                    _0: match$24._0,
                                    _1: match$25._0,
                                    _2: match$26._0
                                }
                            };
                        }
                        var e$31 = match$26._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$31.path,
                                message: e$31.message,
                                value: e$31.value
                            }
                        };
                    }
                    var e$32 = match$25._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$32.path,
                            message: e$32.message,
                            value: e$32.value
                        }
                    };
                }
                var e$33 = match$24._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$33.path,
                        message: e$33.message,
                        value: e$33.value
                    }
                };
            case "OnWebNavigationBeforeNavigate":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnBeforeNavigate.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnWebNavigationBeforeNavigate */ 4,
                            _0: v0$8._0
                        }
                    };
                }
                var e$34 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$34.path,
                        message: e$34.message,
                        value: e$34.value
                    }
                };
            case "OnWebNavigationCommitted":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.record_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnWebNavigationCommitted */ 5,
                            _0: v0$9._0
                        }
                    };
                }
                var e$35 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$35.path,
                        message: e$35.message,
                        value: e$35.value
                    }
                };
            case "OnWebNavigationCompleted":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCompleted.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnWebNavigationCompleted */ 7,
                            _0: v0$10._0
                        }
                    };
                }
                var e$36 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$36.path,
                        message: e$36.message,
                        value: e$36.value
                    }
                };
            case "OnWebNavigationHistoryStateUpdated":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$11 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.record_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$11.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnWebNavigationHistoryStateUpdated */ 6,
                            _0: v0$11._0
                        }
                    };
                }
                var e$37 = v0$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$37.path,
                        message: e$37.message,
                        value: e$37.value
                    }
                };
            case "OnWindowCreated":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$12 = Curry._1(Browser__Windows$SmartcutsMacros.$$Window.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$12.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnWindowCreated */ 19,
                            _0: v0$12._0
                        }
                    };
                }
                var e$38 = v0$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$38.path,
                        message: e$38.message,
                        value: e$38.value
                    }
                };
            case "OnWindowFocusChange":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$13 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$13.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnWindowFocusChange */ 21,
                            _0: v0$13._0
                        }
                    };
                }
                var e$39 = v0$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$39.path,
                        message: e$39.message,
                        value: e$39.value
                    }
                };
            case "OnWindowRemoved":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$14 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$14.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnWindowRemoved */ 20,
                            _0: v0$14._0
                        }
                    };
                }
                var e$40 = v0$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$40.path,
                        message: e$40.message,
                        value: e$40.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyBasicEvent($$event) {
    if (typeof $$event === "number") {
        if ($$event === /* DidNotGetOAuthToken */ 0) {
            return "DidNotGetOAuthToken";
        } else {
            return "DidEncounterGoogleSheetAuthenticationError";
        }
    }
    switch($$event.TAG | 0){
        case /* MessageToExtension */ 0:
            return "MessageToExtension(, message=" + (Curry._1(ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ExtensionMessagingLogging.FromTab.AllAll.stringifyMessage, $$event._0) + (", " + (Browser__Runtime$SmartcutsMacros.Sender.stringify($$event._1) + ", respondToTab, rejectToTab)")));
        case /* BrowserActionClicked */ 1:
            return "BrowserActionClicked(tab)";
        case /* GotWindowInfo */ 2:
            return "GotWindowInfo(windowId, window, activeTab)";
        case /* GotTabInfo */ 3:
            return "GotTabInfo(tabId=" + (String($$event._0) + ", tab)");
        case /* OnWebNavigationBeforeNavigate */ 4:
            return "OnWebNavigationBeforeNavigate(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnBeforeNavigate.Details.stringify, $$event._0) + ")");
        case /* OnWebNavigationCommitted */ 5:
            return "OnWebNavigationCommitted(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.stringify, $$event._0) + ")");
        case /* OnWebNavigationHistoryStateUpdated */ 6:
            return "OnWebNavigationHistoryStateUpdated(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.stringify, $$event._0) + ")");
        case /* OnWebNavigationCompleted */ 7:
            var details = $$event._0;
            return "OnWebNavigationCompleted(details={tabId=" + (String(details.tabId) + (", url=" + (details.url + ", ...})")));
        case /* OnMainFrameWebNavigationError */ 8:
            return "OnMainFrameWebNavigationError(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.stringify, $$event._0) + ")");
        case /* OnSubFrameWebNavigationError */ 9:
            return "OnSubFrameWebNavigationError(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.stringify, $$event._0) + ")");
        case /* OnReceivingEndDoesNotExistForTab */ 10:
            return "OnReceivingEndDoesNotExistForTab(" + (String($$event._0) + ")");
        case /* OnTabCreated */ 11:
            var tab = $$event._0;
            var arg = Belt_Option.map(tab.openerTabId, function(prim) {
                return String(prim);
            });
            var arg$1 = Belt_Option.map(tab.pendingUrl, StringUtils$SmartcutsMacros.quote);
            var arg$2 = Belt_Option.map(tab.url, StringUtils$SmartcutsMacros.quote);
            return "OnTabCreated({id: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", Belt_Option.map(tab.id, function(prim) {
                return String(prim);
            })) + (", openerTabId: " + (function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            }("undefined") + (", pendingUrl: " + (function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
            }("undefined") + (", url: " + (function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
            }("undefined") + (", windowId: " + (String(tab.windowId) + "})")))))))));
        case /* OnTabUpdated */ 12:
            return "OnTabUpdated(tabId=" + (String($$event._0) + (", changeInfo=" + (Curry._1(Browser__Tabs$SmartcutsMacros.OnUpdated.ChangeInfo.stringify, $$event._1) + ", tab)")));
        case /* OnTabRemoved */ 13:
            return "OnTabRemoved(tabId=" + (String($$event._0) + ", removeInfo)");
        case /* OnTabMovedWithinWindow */ 14:
            return "OnTabMovedWithinWindow(tabId=" + (String($$event._0) + ", moveInfo)");
        case /* OnTabDetached */ 15:
            return "OnTabDetached(tabId=" + (String($$event._0) + ", detachInfo)");
        case /* OnTabAttached */ 16:
            return "OnTabAttached(tabId=" + (String($$event._0) + ", attachInfo)");
        case /* OnActiveTab */ 17:
            var activeInfo = $$event._0;
            return "OnActiveTab({tabId=" + (String(activeInfo.tabId) + (", windowId=" + (String(activeInfo.windowId) + "})")));
        case /* OnReplacedTab */ 18:
            return "OnReplacedTab(addedTabId=" + (String($$event._0) + (", removedTabId=" + (String($$event._1) + ")")));
        case /* OnWindowCreated */ 19:
            return "OnWindowCreated(window)";
        case /* OnWindowRemoved */ 20:
            return "OnWindowRemoved(windowId=" + (String($$event._0) + ")");
        case /* OnWindowFocusChange */ 21:
            return "OnWindowFocusChange(windowId=" + (String($$event._0) + ")");
        case /* OnNotificationButtonClicked */ 22:
            return "OnNotificationButtonClicked(" + ($$event._0 + (", indexOfButtonClicked=" + (String($$event._1) + ")")));
        case /* DidGetOAuthToken */ 23:
            return "DidGetOAuthToken(_token, " + (Pervasives.string_of_bool($$event._1) + ")");
        case /* DidRemoveCachedOAuthToken */ 24:
            return "DidRemoveCachedOAuthToken(" + ($$event._0 + ")");
        case /* DidNotRemoveCachedOAuthToken */ 25:
            return "DidNotRemoveCachedOAuthToken(<token>)";
    }
}
function extractRespondToTabFromBasicEvent($$event) {
    if (typeof $$event === "number" || $$event.TAG !== /* MessageToExtension */ 0) {
        return;
    } else {
        return $$event._2;
    }
}
function extractTabIdsFromBasicEvent($$event) {
    var tmp;
    var exit = 0;
    if (typeof $$event === "number") {
        tmp = /* [] */ 0;
    } else {
        switch($$event.TAG | 0){
            case /* MessageToExtension */ 0:
                tmp = OptionUtils$SmartcutsMacros.withDefault(/* [] */ 0, OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.andThen(function(tab) {
                    return tab.id;
                }, $$event._1.tab), function(tabId) {
                    return {
                        hd: tabId,
                        tl: /* [] */ 0
                    };
                }));
                break;
            case /* OnMainFrameWebNavigationError */ 8:
            case /* OnSubFrameWebNavigationError */ 9:
                tmp = {
                    hd: $$event._0.tabId,
                    tl: /* [] */ 0
                };
                break;
            case /* BrowserActionClicked */ 1:
            case /* OnTabCreated */ 11:
                exit = 1;
                break;
            case /* GotTabInfo */ 3:
            case /* OnReceivingEndDoesNotExistForTab */ 10:
            case /* OnTabUpdated */ 12:
            case /* OnTabRemoved */ 13:
            case /* OnTabMovedWithinWindow */ 14:
            case /* OnTabDetached */ 15:
            case /* OnTabAttached */ 16:
                tmp = {
                    hd: $$event._0,
                    tl: /* [] */ 0
                };
                break;
            case /* OnWebNavigationBeforeNavigate */ 4:
            case /* OnWebNavigationCommitted */ 5:
            case /* OnWebNavigationHistoryStateUpdated */ 6:
            case /* OnWebNavigationCompleted */ 7:
            case /* OnActiveTab */ 17:
                exit = 2;
                break;
            case /* OnReplacedTab */ 18:
                tmp = {
                    hd: $$event._0,
                    tl: {
                        hd: $$event._1,
                        tl: /* [] */ 0
                    }
                };
                break;
            case /* OnWindowCreated */ 19:
                tmp = Browser__Windows$SmartcutsMacros.$$Window.extractTabIds($$event._0);
                break;
            case /* GotWindowInfo */ 2:
            case /* OnWindowRemoved */ 20:
            case /* OnWindowFocusChange */ 21:
                tmp = /* [] */ 0;
                break;
            default:
                tmp = /* [] */ 0;
        }
    }
    switch(exit){
        case 1:
            var tabId1 = $$event._0.id;
            tmp = tabId1 !== undefined ? {
                hd: tabId1,
                tl: /* [] */ 0
            } : /* [] */ 0;
            break;
        case 2:
            tmp = {
                hd: $$event._0.tabId,
                tl: /* [] */ 0
            };
            break;
    }
    return List.map(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.makePlaybackId, tmp);
}
function failWithReceivedExtensionMessagingResponse_encode(v) {
    return Js_dict.fromArray([
        [
            "failureId",
            InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v.failureId)
        ],
        [
            "failure",
            Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.otherFailureReason_encode, v.failure)
        ],
        [
            "errorContext",
            Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.errorContext_encode, v.errorContext)
        ],
        [
            "history",
            StateMachine$SmartcutsMacros.$$History.t_encode(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.listener_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, v.history)
        ]
    ]);
}
function failWithReceivedExtensionMessagingResponse_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var failureId = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureId"), null));
    if (failureId.TAG === /* Ok */ 0) {
        var failure = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.otherFailureReason_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failure"), null));
        if (failure.TAG === /* Ok */ 0) {
            var errorContext = Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.errorContext_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "errorContext"), null));
            if (errorContext.TAG === /* Ok */ 0) {
                var history = StateMachine$SmartcutsMacros.$$History.t_decode(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.listener_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "history"), null));
                if (history.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            failureId: failureId._0,
                            failure: failure._0,
                            errorContext: errorContext._0,
                            history: history._0
                        }
                    };
                }
                var e = history._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".history" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = errorContext._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".errorContext" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = failure._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".failure" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = failureId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".failureId" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function failWithReceivedExtensionMessagingResponseFailureId_encode(v) {
    return Js_dict.fromArray([
        [
            "failureId",
            InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v.failureId)
        ],
        [
            "tabId",
            Decco.intToJson(v.tabId)
        ],
        [
            "messageRespondingTo",
            ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_encode(v.messageRespondingTo)
        ]
    ]);
}
function failWithReceivedExtensionMessagingResponseFailureId_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var failureId = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureId"), null));
    if (failureId.TAG === /* Ok */ 0) {
        var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
        if (tabId.TAG === /* Ok */ 0) {
            var messageRespondingTo = ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "messageRespondingTo"), null));
            if (messageRespondingTo.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        failureId: failureId._0,
                        tabId: tabId._0,
                        messageRespondingTo: messageRespondingTo._0
                    }
                };
            }
            var e = messageRespondingTo._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".messageRespondingTo" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = tabId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".tabId" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = failureId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".failureId" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function domElementRepresentation_encode(v) {
    if (v.TAG === /* NodeId */ 0) {
        return [
            "NodeId",
            Decco.intToJson(v._0)
        ];
    } else {
        return [
            "XPath",
            Decco.stringToJson(v._0)
        ];
    }
}
function domElementRepresentation_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NodeId":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NodeId */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "XPath":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* XPath */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function elementSearchVia_encode(v) {
    switch(v.TAG | 0){
        case /* SearchViaSelector */ 0:
            return [
                "SearchViaSelector",
                Selector$SmartcutsMacros.selector_encode(v._0)
            ];
        case /* SearchViaElementLocator */ 1:
            return [
                "SearchViaElementLocator",
                SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_encode(v._0)
            ];
        case /* SearchViaCssSelector */ 2:
            return [
                "SearchViaCssSelector",
                Decco.stringToJson(v._0)
            ];
    }
}
function elementSearchVia_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "SearchViaCssSelector":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SearchViaCssSelector */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SearchViaElementLocator":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SearchViaElementLocator */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "SearchViaSelector":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SearchViaSelector */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function otherFailureReasonShared_encode(v) {
    if (typeof v === "number") {
        switch(v){
            case /* FailWithReceivingEndDoesNotExist */ 0:
                return [
                    "FailWithReceivingEndDoesNotExist"
                ];
            case /* FailWithNoActiveTabToReceiveMessage */ 1:
                return [
                    "FailWithNoActiveTabToReceiveMessage"
                ];
            case /* FailWithUserCancellation */ 2:
                return [
                    "FailWithUserCancellation"
                ];
            case /* FailWithUserStopPlayback */ 3:
                return [
                    "FailWithUserStopPlayback"
                ];
            case /* FailWithPlaybackDownloadNeverInitiated */ 4:
                return [
                    "FailWithPlaybackDownloadNeverInitiated"
                ];
            case /* FailWithOAuthTokenNotGranted */ 5:
                return [
                    "FailWithOAuthTokenNotGranted"
                ];
            case /* FailWithUnhandledException */ 6:
                return [
                    "FailWithUnhandledException"
                ];
            case /* FailWithNoAvailableExecutions */ 7:
                return [
                    "FailWithNoAvailableExecutions"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* FailWithWebNavError */ 0:
                return [
                    "FailWithWebNavError",
                    Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_encode, v._0)
                ];
            case /* FailWithContentScriptFailure */ 1:
                return [
                    "FailWithContentScriptFailure",
                    Decco.intToJson(v._0),
                    Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.otherFailureReason_encode, v._1),
                    Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.errorContext_encode, v._2),
                    StateMachine$SmartcutsMacros.$$History.t_encode(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.listener_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, v._3)
                ];
            case /* FailWithReceivedExtensionMessagingResponse */ 2:
                return [
                    "FailWithReceivedExtensionMessagingResponse",
                    failWithReceivedExtensionMessagingResponse_encode(v._0)
                ];
            case /* FailWithReceivedExtensionMessagingResponseFailureId */ 3:
                return [
                    "FailWithReceivedExtensionMessagingResponseFailureId",
                    failWithReceivedExtensionMessagingResponseFailureId_encode(v._0)
                ];
            case /* FailWithUserCloseLoginPage */ 4:
                return [
                    "FailWithUserCloseLoginPage",
                    Decco.stringToJson(v._0)
                ];
            case /* FailWithElementNotFound */ 5:
                return [
                    "FailWithElementNotFound",
                    Decco.stringToJson(v._0),
                    elementSearchVia_encode(v._1)
                ];
            case /* FailWithCannotCopyMissingSrcOfImg */ 6:
                return [
                    "FailWithCannotCopyMissingSrcOfImg",
                    Decco.stringToJson(v._0),
                    elementSearchVia_encode(v._1)
                ];
            case /* FailWithDocumentNotVisible */ 7:
                return [
                    "FailWithDocumentNotVisible",
                    Decco.stringToJson(v._0)
                ];
            case /* FailWithDocumentVisibilityUnknownOrUnloaded */ 8:
                return [
                    "FailWithDocumentVisibilityUnknownOrUnloaded",
                    Decco.stringToJson(v._0)
                ];
            case /* FailWithCdpUnableToGetDocument */ 9:
                return [
                    "FailWithCdpUnableToGetDocument",
                    Decco.stringToJson(v._0)
                ];
            case /* FailWithCdpUnableToGetContentQuads */ 10:
                return [
                    "FailWithCdpUnableToGetContentQuads",
                    Decco.stringToJson(v._0)
                ];
            case /* FailWithCouldNotApplySemantic */ 11:
                return [
                    "FailWithCouldNotApplySemantic",
                    SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_encode(v._0),
                    Decco.stringToJson(v._1)
                ];
            case /* FailWithBlockingOverlay */ 12:
                return [
                    "FailWithBlockingOverlay",
                    ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_encode(domElementRepresentation_encode, v._0),
                    Decco.stringToJson(v._1)
                ];
            case /* FailWithErrorWhileWaitForOverlayToUnblock */ 13:
                return [
                    "FailWithErrorWhileWaitForOverlayToUnblock",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                    Decco.stringToJson(v._1)
                ];
            case /* FailWithErrorWhileSearchForElement */ 14:
                return [
                    "FailWithErrorWhileSearchForElement",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                    Decco.stringToJson(v._1)
                ];
            case /* FailWithErrorWhileSearchViaCdpQuerySelector */ 15:
                return [
                    "FailWithErrorWhileSearchViaCdpQuerySelector",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                    Decco.stringToJson(v._1)
                ];
            case /* FailWithPlaybackCaptureScreenshotError */ 16:
                return [
                    "FailWithPlaybackCaptureScreenshotError",
                    ExtErrors$SmartcutsMacros.PlaybackCaptureScreenshotError.t_encode(v._0),
                    Decco.stringToJson(v._1)
                ];
            case /* FailWithNoSwitchPredicateSatisfied */ 17:
                return [
                    "FailWithNoSwitchPredicateSatisfied",
                    Decco.stringToJson(v._0)
                ];
            case /* FailWithPermissionsRejected */ 18:
                return [
                    "FailWithPermissionsRejected",
                    Decco.arrayToJson(PermissionAndOrigin$SmartcutsMacros.t_encode, v._0)
                ];
            case /* FailWithCommandStackInitError */ 19:
                return [
                    "FailWithCommandStackInitError",
                    GenericCommandStack$SmartcutsMacros.initError_encode(v._0)
                ];
            case /* FailWithCommandStackRewindError */ 20:
                return [
                    "FailWithCommandStackRewindError",
                    GenericCommandStack$SmartcutsMacros.rewindError_encode(v._0)
                ];
        }
    }
}
function otherFailureReasonShared_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FailWithBlockingOverlay":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_decode(domElementRepresentation_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithBlockingOverlay */ 12,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "FailWithCannotCopyMissingSrcOfImg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = elementSearchVia_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithCannotCopyMissingSrcOfImg */ 6,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "FailWithCdpUnableToGetContentQuads":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithCdpUnableToGetContentQuads */ 10,
                            _0: v0._0
                        }
                    };
                }
                var e$4 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "FailWithCdpUnableToGetDocument":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithCdpUnableToGetDocument */ 9,
                            _0: v0$1._0
                        }
                    };
                }
                var e$5 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "FailWithCommandStackInitError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = GenericCommandStack$SmartcutsMacros.initError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithCommandStackInitError */ 19,
                            _0: v0$2._0
                        }
                    };
                }
                var e$6 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "FailWithCommandStackRewindError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = GenericCommandStack$SmartcutsMacros.rewindError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithCommandStackRewindError */ 20,
                            _0: v0$3._0
                        }
                    };
                }
                var e$7 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "FailWithContentScriptFailure":
                if (tagged.length !== 5) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
                var match$7 = Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.errorContext_decode, Belt_Array.getExn(jsonArr$1, 3));
                var match$8 = StateMachine$SmartcutsMacros.$$History.t_decode(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.listener_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, Belt_Array.getExn(jsonArr$1, 4));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        if (match$7.TAG === /* Ok */ 0) {
                            if (match$8.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        TAG: /* FailWithContentScriptFailure */ 1,
                                        _0: match$5._0,
                                        _1: match$6._0,
                                        _2: match$7._0,
                                        _3: match$8._0
                                    }
                                };
                            }
                            var e$8 = match$8._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[3]" + e$8.path,
                                    message: e$8.message,
                                    value: e$8.value
                                }
                            };
                        }
                        var e$9 = match$7._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$9.path,
                                message: e$9.message,
                                value: e$9.value
                            }
                        };
                    }
                    var e$10 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$10.path,
                            message: e$10.message,
                            value: e$10.value
                        }
                    };
                }
                var e$11 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "FailWithCouldNotApplySemantic":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$9 = SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$10 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$9.TAG === /* Ok */ 0) {
                    if (match$10.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithCouldNotApplySemantic */ 11,
                                _0: match$9._0,
                                _1: match$10._0
                            }
                        };
                    }
                    var e$12 = match$10._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                        }
                    };
                }
                var e$13 = match$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "FailWithDocumentNotVisible":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithDocumentNotVisible */ 7,
                            _0: v0$4._0
                        }
                    };
                }
                var e$14 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "FailWithDocumentVisibilityUnknownOrUnloaded":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithDocumentVisibilityUnknownOrUnloaded */ 8,
                            _0: v0$5._0
                        }
                    };
                }
                var e$15 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "FailWithElementNotFound":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$11 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$12 = elementSearchVia_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$11.TAG === /* Ok */ 0) {
                    if (match$12.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithElementNotFound */ 5,
                                _0: match$11._0,
                                _1: match$12._0
                            }
                        };
                    }
                    var e$16 = match$12._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$16.path,
                            message: e$16.message,
                            value: e$16.value
                        }
                    };
                }
                var e$17 = match$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "FailWithErrorWhileSearchForElement":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$13 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$14 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$13.TAG === /* Ok */ 0) {
                    if (match$14.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithErrorWhileSearchForElement */ 14,
                                _0: match$13._0,
                                _1: match$14._0
                            }
                        };
                    }
                    var e$18 = match$14._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$18.path,
                            message: e$18.message,
                            value: e$18.value
                        }
                    };
                }
                var e$19 = match$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "FailWithErrorWhileSearchViaCdpQuerySelector":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$15 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$16 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$15.TAG === /* Ok */ 0) {
                    if (match$16.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithErrorWhileSearchViaCdpQuerySelector */ 15,
                                _0: match$15._0,
                                _1: match$16._0
                            }
                        };
                    }
                    var e$20 = match$16._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$20.path,
                            message: e$20.message,
                            value: e$20.value
                        }
                    };
                }
                var e$21 = match$15._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$21.path,
                        message: e$21.message,
                        value: e$21.value
                    }
                };
            case "FailWithErrorWhileWaitForOverlayToUnblock":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$17 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$18 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$17.TAG === /* Ok */ 0) {
                    if (match$18.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithErrorWhileWaitForOverlayToUnblock */ 13,
                                _0: match$17._0,
                                _1: match$18._0
                            }
                        };
                    }
                    var e$22 = match$18._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$22.path,
                            message: e$22.message,
                            value: e$22.value
                        }
                    };
                }
                var e$23 = match$17._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                    }
                };
            case "FailWithNoActiveTabToReceiveMessage":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithNoActiveTabToReceiveMessage */ 1
                    };
                }
            case "FailWithNoAvailableExecutions":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithNoAvailableExecutions */ 7
                    };
                }
            case "FailWithNoSwitchPredicateSatisfied":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithNoSwitchPredicateSatisfied */ 17,
                            _0: v0$6._0
                        }
                    };
                }
                var e$24 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$24.path,
                        message: e$24.message,
                        value: e$24.value
                    }
                };
            case "FailWithOAuthTokenNotGranted":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithOAuthTokenNotGranted */ 5
                    };
                }
            case "FailWithPermissionsRejected":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = Decco.arrayFromJson(PermissionAndOrigin$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithPermissionsRejected */ 18,
                            _0: v0$7._0
                        }
                    };
                }
                var e$25 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                    }
                };
            case "FailWithPlaybackCaptureScreenshotError":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$19 = ExtErrors$SmartcutsMacros.PlaybackCaptureScreenshotError.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$20 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$19.TAG === /* Ok */ 0) {
                    if (match$20.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FailWithPlaybackCaptureScreenshotError */ 16,
                                _0: match$19._0,
                                _1: match$20._0
                            }
                        };
                    }
                    var e$26 = match$20._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$26.path,
                            message: e$26.message,
                            value: e$26.value
                        }
                    };
                }
                var e$27 = match$19._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$27.path,
                        message: e$27.message,
                        value: e$27.value
                    }
                };
            case "FailWithPlaybackDownloadNeverInitiated":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithPlaybackDownloadNeverInitiated */ 4
                    };
                }
            case "FailWithReceivedExtensionMessagingResponse":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = failWithReceivedExtensionMessagingResponse_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithReceivedExtensionMessagingResponse */ 2,
                            _0: v0$8._0
                        }
                    };
                }
                var e$28 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$28.path,
                        message: e$28.message,
                        value: e$28.value
                    }
                };
            case "FailWithReceivedExtensionMessagingResponseFailureId":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = failWithReceivedExtensionMessagingResponseFailureId_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithReceivedExtensionMessagingResponseFailureId */ 3,
                            _0: v0$9._0
                        }
                    };
                }
                var e$29 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$29.path,
                        message: e$29.message,
                        value: e$29.value
                    }
                };
            case "FailWithReceivingEndDoesNotExist":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithReceivingEndDoesNotExist */ 0
                    };
                }
            case "FailWithUnhandledException":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithUnhandledException */ 6
                    };
                }
            case "FailWithUserCancellation":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithUserCancellation */ 2
                    };
                }
            case "FailWithUserCloseLoginPage":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithUserCloseLoginPage */ 4,
                            _0: v0$10._0
                        }
                    };
                }
                var e$30 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$30.path,
                        message: e$30.message,
                        value: e$30.value
                    }
                };
            case "FailWithUserStopPlayback":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithUserStopPlayback */ 3
                    };
                }
            case "FailWithWebNavError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$11 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$11.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithWebNavError */ 0,
                            _0: v0$11._0
                        }
                    };
                }
                var e$31 = v0$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$31.path,
                        message: e$31.message,
                        value: e$31.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function minify(reason) {
    if (typeof reason === "number") {
        return reason;
    }
    switch(reason.TAG | 0){
        case /* FailWithElementNotFound */ 5:
        case /* FailWithCannotCopyMissingSrcOfImg */ 6:
        case /* FailWithDocumentNotVisible */ 7:
        case /* FailWithDocumentVisibilityUnknownOrUnloaded */ 8:
        case /* FailWithCdpUnableToGetDocument */ 9:
        case /* FailWithCdpUnableToGetContentQuads */ 10:
        case /* FailWithCouldNotApplySemantic */ 11:
        case /* FailWithBlockingOverlay */ 12:
        case /* FailWithErrorWhileWaitForOverlayToUnblock */ 13:
        case /* FailWithErrorWhileSearchForElement */ 14:
        case /* FailWithErrorWhileSearchViaCdpQuerySelector */ 15:
            return reason;
        default:
            return reason;
    }
}
function stringifyOtherFailureReason(otherFailureReason) {
    if (typeof otherFailureReason === "number") {
        switch(otherFailureReason){
            case /* FailWithReceivingEndDoesNotExist */ 0:
                return "FailWithReceivingEndDoesNotExist";
            case /* FailWithNoActiveTabToReceiveMessage */ 1:
                return "FailWithNoActiveTabToReceiveMessage";
            case /* FailWithUserCancellation */ 2:
                return "FailWithUserCancellation";
            case /* FailWithUserStopPlayback */ 3:
                return "FailWithUserStopPlayback";
            case /* FailWithPlaybackDownloadNeverInitiated */ 4:
                return "FailWithPlaybackDownloadNeverInitiated";
            case /* FailWithOAuthTokenNotGranted */ 5:
                return "FailWithOAuthTokenNotGranted";
            case /* FailWithUnhandledException */ 6:
                return "FailWithUnhandledException";
            case /* FailWithNoAvailableExecutions */ 7:
                return "FailWithNoAvailableExecutions";
        }
    } else {
        switch(otherFailureReason.TAG | 0){
            case /* FailWithWebNavError */ 0:
                return "FailWithWebNavError(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.stringify, otherFailureReason._0) + ")");
            case /* FailWithContentScriptFailure */ 1:
                return "FailWithContentScriptFailure(tabId=" + (String(otherFailureReason._0) + (", failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ContentScript__StateMachine__Types__Helpers.Generic.stringifyOtherFailureReason, otherFailureReason._1) + (", errorContext=" + (Curry._1(ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ContentScript__StateMachine__Types__Helpers.ForSerialization.stringifyErrorContext, otherFailureReason._2) + (", history({len: " + (String(otherFailureReason._3.transitions.length) + "}))")))))));
            case /* FailWithReceivedExtensionMessagingResponse */ 2:
                var match = otherFailureReason._0;
                return "FailWithReceivedExtensionMessagingResponse(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify(match.failureId) + (", failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ContentScript__StateMachine__Types__Helpers.Generic.stringifyOtherFailureReason, match.failure) + (", errorContext=" + (Curry._1(ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ContentScript__StateMachine__Types__Helpers.ForSerialization.stringifyErrorContext, match.errorContext) + (", history({len: " + (String(match.history.transitions.length) + "}))")))))));
            case /* FailWithReceivedExtensionMessagingResponseFailureId */ 3:
                var match$1 = otherFailureReason._0;
                return "FailWithReceivedExtensionMessagingResponseFailureId(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify(match$1.failureId) + (", tabId=" + (String(match$1.tabId) + (", messageRespondingTo=" + (Curry._1(ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ExtensionMessagingLogging.FromExtension.All.stringifyMessage, match$1.messageRespondingTo) + ")")))));
            case /* FailWithUserCloseLoginPage */ 4:
                return "FailWithUserCloseLoginPage(" + (otherFailureReason._0 + ")");
            case /* FailWithElementNotFound */ 5:
                return "FailWithElementNotFound(" + (otherFailureReason._0 + ", elementSearchVia)");
            case /* FailWithCannotCopyMissingSrcOfImg */ 6:
                return "FailWithCannotCopyMissingSrcOfImg(" + (otherFailureReason._0 + ", elementSearchVia)");
            case /* FailWithDocumentNotVisible */ 7:
                return "FailWithDocumentNotVisible(" + (otherFailureReason._0 + ")");
            case /* FailWithDocumentVisibilityUnknownOrUnloaded */ 8:
                return "FailWithDocumentVisibilityUnknownOrUnloaded(" + (otherFailureReason._0 + ")");
            case /* FailWithCdpUnableToGetDocument */ 9:
                return "FailWithCdpUnableToGetDocument(" + (otherFailureReason._0 + ")");
            case /* FailWithCdpUnableToGetContentQuads */ 10:
                return "FailWithCdpUnableToGetContentQuads(" + (otherFailureReason._0 + ")");
            case /* FailWithCouldNotApplySemantic */ 11:
                return "FailWithCouldNotApplySemantic(semanticError" + (otherFailureReason._1 + ")");
            case /* FailWithBlockingOverlay */ 12:
                var match$2 = otherFailureReason._0;
                var element1 = match$2.element;
                var tmp;
                tmp = element1.TAG === /* NodeId */ 0 ? String(element1._0) : element1._0;
                var arg = Belt_Option.map(match$2.maybeOverlayElement, function(element) {
                    if (element.TAG === /* NodeId */ 0) {
                        return String(element._0);
                    } else {
                        return element._0;
                    }
                });
                return "FailWithErrorWhileWaitForOverlayToUnblock({element: " + (tmp + (", maybeOverlayElement: " + (function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("None") + (", ms: " + (match$2.ms.toString() + ("}, " + (otherFailureReason._1 + ")")))))));
            case /* FailWithErrorWhileWaitForOverlayToUnblock */ 13:
                return "FailWithErrorWhileWaitForOverlayToUnblock(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, otherFailureReason._0) + (", " + (otherFailureReason._1 + ")")));
            case /* FailWithErrorWhileSearchForElement */ 14:
                return "FailWithErrorWhileSearchForElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, otherFailureReason._0) + (otherFailureReason._1 + ")"));
            case /* FailWithErrorWhileSearchViaCdpQuerySelector */ 15:
                return "FailWithErrorWhileSearchViaCdpQuerySelector(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, otherFailureReason._0) + (otherFailureReason._1 + ")"));
            case /* FailWithPlaybackCaptureScreenshotError */ 16:
                return "FailWithPlaybackCaptureScreenshotError(" + (ExtErrors$SmartcutsMacros.PlaybackCaptureScreenshotError.stringify(otherFailureReason._0) + (", " + (otherFailureReason._1 + ")")));
            case /* FailWithNoSwitchPredicateSatisfied */ 17:
                return "FailWithNoSwitchPredicateSatisfied(" + (otherFailureReason._0 + ")");
            case /* FailWithPermissionsRejected */ 18:
                return "FailWithPermissionsRejected([" + (Belt_Array.map(otherFailureReason._0, PermissionAndOrigin$SmartcutsMacros.toString).join(",") + "])");
            case /* FailWithCommandStackInitError */ 19:
                return "FailWithCommandStackInitError(" + (GenericCommandStack$SmartcutsMacros.stringifyInitError(otherFailureReason._0) + ")");
            case /* FailWithCommandStackRewindError */ 20:
                return "FailWithCommandStackRewindError(" + (GenericCommandStack$SmartcutsMacros.stringifyRewindError(otherFailureReason._0) + ")");
        }
    }
}
var detachListenersCallback_encode = DeccoUtils$SmartcutsMacros.unitToUnit_encode;
var detachListenersCallback_decode = DeccoUtils$SmartcutsMacros.unitToUnit_decode;
function listenersStatus_encode(v) {
    if (typeof v !== "number") {
        return [
            "Listening",
            DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
        ];
    }
    switch(v){
        case /* NoListenersNeeded */ 0:
            return [
                "NoListenersNeeded"
            ];
        case /* BeforeAddListeners */ 1:
            return [
                "BeforeAddListeners"
            ];
        case /* AddingListeners */ 2:
            return [
                "AddingListeners"
            ];
        case /* RemovingListeners */ 3:
            return [
                "RemovingListeners"
            ];
        case /* RemovedAllListeners */ 4:
            return [
                "RemovedAllListeners"
            ];
    }
}
function listenersStatus_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AddingListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AddingListeners */ 2
                    };
                }
            case "BeforeAddListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* BeforeAddListeners */ 1
                    };
                }
            case "Listening":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Listening */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NoListenersNeeded":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoListenersNeeded */ 0
                    };
                }
            case "RemovedAllListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemovedAllListeners */ 4
                    };
                }
            case "RemovingListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemovingListeners */ 3
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyListenersStatus(v) {
    if (typeof v !== "number") {
        return "Listening(detachListeners)";
    }
    switch(v){
        case /* NoListenersNeeded */ 0:
            return "NoListenersNeeded";
        case /* BeforeAddListeners */ 1:
            return "BeforeAddListeners";
        case /* AddingListeners */ 2:
            return "AddingListeners";
        case /* RemovingListeners */ 3:
            return "RemovingListeners";
        case /* RemovedAllListeners */ 4:
            return "RemovedAllListeners";
    }
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "id",
            DeccoUtils$SmartcutsMacros.timeoutId_encode(v.id)
        ],
        [
            "timeout",
            Decco.intToJson(v.timeout)
        ],
        [
            "createdAt",
            Decco.floatToJson(v.createdAt)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var timeout = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeout"), null));
        if (timeout.TAG === /* Ok */ 0) {
            var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
            if (createdAt.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        id: id._0,
                        timeout: timeout._0,
                        createdAt: createdAt._0
                    }
                };
            }
            var e = createdAt._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".createdAt" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = timeout._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".timeout" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var StaleTimer = {
    t_encode: t_encode,
    t_decode: t_decode
};
function installedSmartcutPageUrlForUser(user, installedSmartcutId) {
    return Config$SmartcutsMacros.hostnameForUser(user) + ("/app/my_smartcuts/" + installedSmartcutId);
}
var ExtensionMessagingLogging;
exports.ExtensionMessagingLogging = ExtensionMessagingLogging;
exports.basicEvent_encode = basicEvent_encode;
exports.basicEvent_decode = basicEvent_decode;
exports.stringifyBasicEvent = stringifyBasicEvent;
exports.extractRespondToTabFromBasicEvent = extractRespondToTabFromBasicEvent;
exports.extractTabIdsFromBasicEvent = extractTabIdsFromBasicEvent;
exports.failWithReceivedExtensionMessagingResponse_encode = failWithReceivedExtensionMessagingResponse_encode;
exports.failWithReceivedExtensionMessagingResponse_decode = failWithReceivedExtensionMessagingResponse_decode;
exports.failWithReceivedExtensionMessagingResponseFailureId_encode = failWithReceivedExtensionMessagingResponseFailureId_encode;
exports.failWithReceivedExtensionMessagingResponseFailureId_decode = failWithReceivedExtensionMessagingResponseFailureId_decode;
exports.domElementRepresentation_encode = domElementRepresentation_encode;
exports.domElementRepresentation_decode = domElementRepresentation_decode;
exports.elementSearchVia_encode = elementSearchVia_encode;
exports.elementSearchVia_decode = elementSearchVia_decode;
exports.otherFailureReasonShared_encode = otherFailureReasonShared_encode;
exports.otherFailureReasonShared_decode = otherFailureReasonShared_decode;
exports.minify = minify;
exports.stringifyOtherFailureReason = stringifyOtherFailureReason;
exports.detachListenersCallback_encode = detachListenersCallback_encode;
exports.detachListenersCallback_decode = detachListenersCallback_decode;
exports.listenersStatus_encode = listenersStatus_encode;
exports.listenersStatus_decode = listenersStatus_decode;
exports.stringifyListenersStatus = stringifyListenersStatus;
exports.StaleTimer = StaleTimer;
exports.installedSmartcutPageUrlForUser = installedSmartcutPageUrlForUser; /* Config-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 65595:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Belt_Result = __webpack_require__(86369);
var Caml_module = __webpack_require__(27236);
var Caml_option = __webpack_require__(57175);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var JsExnUtils$SmartcutsMacros = __webpack_require__(79713);
var RenderOnHost$SmartcutsMacros = __webpack_require__(95421);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
var ExtensionMessaging$SmartcutsMacros = __webpack_require__(31052);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var RenderOnHost__Geometry$SmartcutsMacros = __webpack_require__(1763);
var ExtensionMessagingBuilders$SmartcutsMacros = __webpack_require__(23158);
var ExtensionMessaging__FromTab$SmartcutsMacros = __webpack_require__(44409);
var DOM__Event__ForSerialization$SmartcutsMacros = __webpack_require__(54179);
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = __webpack_require__(20229);
var ExtensionMessaging__FromExtension$SmartcutsMacros = __webpack_require__(15462);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
var ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros = __webpack_require__(14250);
var ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros = __webpack_require__(98519);
var ExtensionMessaging__FromTab__WithStateMachineDeps$SmartcutsMacros = __webpack_require__(46057);
var ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros = __webpack_require__(1591);
var ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros = __webpack_require__(77448);
var Generic = Caml_module.init_mod([
    "ContentScript__StateMachine__Types.re",
    319,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "listener_encode"
        ],
        [
            /* Function */ 0,
            "listener_decode"
        ],
        [
            /* Function */ 0,
            "contentScriptIdle_encode"
        ],
        [
            /* Function */ 0,
            "contentScriptIdle_decode"
        ],
        [
            /* Function */ 0,
            "state_encode"
        ],
        [
            /* Function */ 0,
            "state_decode"
        ],
        [
            /* Function */ 0,
            "event_encode"
        ],
        [
            /* Function */ 0,
            "event_decode"
        ],
        [
            /* Function */ 0,
            "errorContext_encode"
        ],
        [
            /* Function */ 0,
            "errorContext_decode"
        ],
        [
            /* Function */ 0,
            "failure_encode"
        ],
        [
            /* Function */ 0,
            "failure_decode"
        ],
        [
            /* Function */ 0,
            "otherFailureReason_encode"
        ],
        [
            /* Function */ 0,
            "otherFailureReason_decode"
        ],
        [
            /* Function */ 0,
            "sideEffect_encode"
        ],
        [
            /* Function */ 0,
            "sideEffect_decode"
        ]
    ]
});
var ForSerialization = Caml_module.init_mod([
    "ContentScript__StateMachine__Types.re",
    703,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "listener_encode"
        ],
        [
            /* Function */ 0,
            "listener_decode"
        ],
        [
            /* Function */ 0,
            "state_encode"
        ],
        [
            /* Function */ 0,
            "state_decode"
        ],
        [
            /* Function */ 0,
            "event_encode"
        ],
        [
            /* Function */ 0,
            "event_decode"
        ],
        [
            /* Function */ 0,
            "sideEffect_encode"
        ],
        [
            /* Function */ 0,
            "sideEffect_decode"
        ],
        [
            /* Function */ 0,
            "errorContext_encode"
        ],
        [
            /* Function */ 0,
            "errorContext_decode"
        ],
        [
            /* Function */ 0,
            "failure_encode"
        ],
        [
            /* Function */ 0,
            "failure_decode"
        ],
        [
            /* Function */ 0,
            "otherFailureReason_encode"
        ],
        [
            /* Function */ 0,
            "otherFailureReason_decode"
        ],
        [
            /* Function */ 0,
            "failureInfo_encode"
        ],
        [
            /* Function */ 0,
            "failureInfo_decode"
        ]
    ]
});
var ExtensionMessagingFromTabWithStateMachineDeps = Caml_module.init_mod([
    "ContentScript__StateMachine__Types.re",
    836,
    2
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ]
                ]
            },
            "MR_NotifyBgOfContentScriptFailure"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ],
                    [
                        /* Function */ 0,
                        "responseError_encode"
                    ],
                    [
                        /* Function */ 0,
                        "responseError_decode"
                    ],
                    [
                        /* Function */ 0,
                        "result__encode"
                    ],
                    [
                        /* Function */ 0,
                        "result__decode"
                    ],
                    [
                        /* Function */ 0,
                        "respondToSender_encode"
                    ],
                    [
                        /* Function */ 0,
                        "respondToSender_decode"
                    ],
                    [
                        /* Function */ 0,
                        "makeRespondToBg"
                    ],
                    [
                        /* Function */ 0,
                        "encodeAndSendMessage"
                    ],
                    [
                        /* Function */ 0,
                        "encodeAndSendMessageToExtensionId"
                    ]
                ]
            },
            "NotifyBgOfContentScriptFailure"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ]
                ]
            },
            "MR_NotifyBgOfContentScriptResponseFailure"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ],
                    [
                        /* Function */ 0,
                        "responseError_encode"
                    ],
                    [
                        /* Function */ 0,
                        "responseError_decode"
                    ],
                    [
                        /* Function */ 0,
                        "result__encode"
                    ],
                    [
                        /* Function */ 0,
                        "result__decode"
                    ],
                    [
                        /* Function */ 0,
                        "respondToSender_encode"
                    ],
                    [
                        /* Function */ 0,
                        "respondToSender_decode"
                    ],
                    [
                        /* Function */ 0,
                        "makeRespondToBg"
                    ],
                    [
                        /* Function */ 0,
                        "encodeAndSendMessage"
                    ],
                    [
                        /* Function */ 0,
                        "encodeAndSendMessageToExtensionId"
                    ]
                ]
            },
            "NotifyBgOfContentScriptResponseFailure"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ]
                ]
            },
            "MR_All"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ]
                ]
            },
            "All"
        ]
    ]
});
var ExtensionMessagingFromTabAll = Caml_module.init_mod([
    "ContentScript__StateMachine__Types.re",
    899,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "message_encode"
        ],
        [
            /* Function */ 0,
            "message_decode"
        ],
        [
            /* Function */ 0,
            "response_encode"
        ],
        [
            /* Function */ 0,
            "response_decode"
        ],
        [
            /* Function */ 0,
            "responseError_encode"
        ],
        [
            /* Function */ 0,
            "responseError_decode"
        ],
        [
            /* Function */ 0,
            "result__encode"
        ],
        [
            /* Function */ 0,
            "result__decode"
        ],
        [
            /* Function */ 0,
            "respondToSender_encode"
        ],
        [
            /* Function */ 0,
            "respondToSender_decode"
        ],
        [
            /* Function */ 0,
            "onMessageToExtension"
        ],
        [
            /* Function */ 0,
            "onMessageExternal"
        ],
        [
            /* Function */ 0,
            "makeNestedRespondToTabFromRootRespondToTab"
        ],
        [
            /* Function */ 0,
            "makeRootRespondToTabFromNestedRespondToTab"
        ]
    ]
});
function listener_encode(encoder_domEvent, encoder_domMutationRecord, v) {
    if (typeof v === "number") {
        if (v === /* NoListener */ 0) {
            return [
                "NoListener"
            ];
        } else {
            return [
                "ContextMenuDomEventListener"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* MessageFromExtensionListener */ 0:
            return [
                "MessageFromExtensionListener",
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_encode(v._0),
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._1),
                ExtensionMessaging$SmartcutsMacros.rejectToBg_encode(v._2)
            ];
        case /* RecordingModeListener */ 1:
            return [
                "RecordingModeListener",
                ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.Generic.listener_encode(encoder_domEvent, encoder_domMutationRecord, v._0)
            ];
        case /* UrlTriggeringModeListener */ 2:
            return [
                "UrlTriggeringModeListener",
                ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.listener_encode(v._0)
            ];
        case /* DataExtractionModeListener */ 3:
            return [
                "DataExtractionModeListener",
                ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.listener_encode(encoder_domMutationRecord, v._0)
            ];
    }
}
function listener_decode(decoder_domEvent, decoder_domMutationRecord, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContextMenuDomEventListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContextMenuDomEventListener */ 1
                    };
                }
            case "DataExtractionModeListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.listener_decode(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DataExtractionModeListener */ 3,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "MessageFromExtensionListener":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = ExtensionMessaging$SmartcutsMacros.rejectToBg_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* MessageFromExtensionListener */ 0,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e$1 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "NoListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoListener */ 0
                    };
                }
            case "RecordingModeListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.Generic.listener_decode(decoder_domEvent, decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RecordingModeListener */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$4 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "UrlTriggeringModeListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.listener_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UrlTriggeringModeListener */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$5 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function contentScriptIdle_encode(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "lastContextMenuTarget",
            Decco.optionToJson(encoder_htmlElement, v.lastContextMenuTarget)
        ],
        [
            "disconnectLinkTriggerListener",
            Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.disconnectLinkTriggerListener)
        ]
    ]);
}
function contentScriptIdle_decode(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var lastContextMenuTarget = Decco.optionFromJson(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastContextMenuTarget"), null));
    if (lastContextMenuTarget.TAG === /* Ok */ 0) {
        var disconnectLinkTriggerListener = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "disconnectLinkTriggerListener"), null));
        if (disconnectLinkTriggerListener.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    lastContextMenuTarget: lastContextMenuTarget._0,
                    disconnectLinkTriggerListener: disconnectLinkTriggerListener._0
                }
            };
        }
        var e = disconnectLinkTriggerListener._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".disconnectLinkTriggerListener" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = lastContextMenuTarget._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".lastContextMenuTarget" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function state_encode(encoder_recordingState, encoder_htmlElement, encoder_domEvent, v) {
    if (typeof v === "number") {
        if (v === /* Init */ 0) {
            return [
                "Init"
            ];
        } else {
            return [
                "ExtensionContextInvalidated"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* WaitingForBgToAckContentScriptReady */ 0:
            return [
                "WaitingForBgToAckContentScriptReady",
                contentScriptIdle_encode(encoder_htmlElement, v._0)
            ];
        case /* ContentScriptIdle */ 1:
            return [
                "ContentScriptIdle",
                contentScriptIdle_encode(encoder_htmlElement, v._0)
            ];
        case /* RecordingMode */ 2:
            return [
                "RecordingMode",
                Curry._1(encoder_recordingState, v._0)
            ];
        case /* PlaybackMode */ 3:
            return [
                "PlaybackMode",
                ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.state_encode(encoder_htmlElement, encoder_domEvent, v._0)
            ];
        case /* UrlTriggeringMode */ 4:
            return [
                "UrlTriggeringMode",
                ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.state_encode(encoder_htmlElement, encoder_domEvent, v._0)
            ];
        case /* DataExtractionMode */ 5:
            return [
                "DataExtractionMode",
                ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.state_encode(encoder_htmlElement, v._0)
            ];
    }
}
function state_decode(decoder_recordingState, decoder_htmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentScriptIdle":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = contentScriptIdle_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentScriptIdle */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DataExtractionMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.state_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DataExtractionMode */ 5,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ExtensionContextInvalidated":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExtensionContextInvalidated */ 1
                    };
                }
            case "Init":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Init */ 0
                    };
                }
            case "PlaybackMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.state_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PlaybackMode */ 3,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "RecordingMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._1(decoder_recordingState, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RecordingMode */ 2,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "UrlTriggeringMode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.state_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UrlTriggeringMode */ 4,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "WaitingForBgToAckContentScriptReady":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = contentScriptIdle_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WaitingForBgToAckContentScriptReady */ 0,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function event_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v) {
    if (typeof v === "number") {
        return [
            "Initialize"
        ];
    }
    switch(v.TAG | 0){
        case /* BasicEventRootLevel */ 0:
            return [
                "BasicEventRootLevel",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
            ];
        case /* BgDidAckContentScriptReady */ 1:
            return [
                "BgDidAckContentScriptReady",
                Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.ContentScriptReady.result__encode, v._0)
            ];
        case /* DidRespondToBgWithContentScriptFailureId */ 2:
            return [
                "DidRespondToBgWithContentScriptFailureId",
                InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v._0),
                Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, otherFailureReason_encode, v._1),
                errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._2)
            ];
        case /* DidSetupLinkTriggerListener */ 3:
            return [
                "DidSetupLinkTriggerListener",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
            ];
        case /* RecordingModeEvent */ 4:
            return [
                "RecordingModeEvent",
                Curry._1(encoder_recordingEvent, v._0)
            ];
        case /* PlaybackModeEvent */ 5:
            return [
                "PlaybackModeEvent",
                ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.event_encode(encoder_htmlElement, encoder_domEvent, v._0)
            ];
        case /* UrlTriggeringModeEvent */ 6:
            return [
                "UrlTriggeringModeEvent",
                ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.event_encode(encoder_htmlElement, encoder_domEvent, v._0)
            ];
        case /* DataExtractionModeEvent */ 7:
            return [
                "DataExtractionModeEvent",
                ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* Fail */ 8:
            return [
                "Fail",
                failure_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._0)
            ];
        case /* ContextMenuEventDidFireOnElement */ 9:
            return [
                "ContextMenuEventDidFireOnElement",
                Curry._1(encoder_htmlElement, v._0)
            ];
    }
}
function event_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BasicEventRootLevel":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BasicEventRootLevel */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "BgDidAckContentScriptReady":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.ContentScriptReady.result__decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BgDidAckContentScriptReady */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ContextMenuEventDidFireOnElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContextMenuEventDidFireOnElement */ 9,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "DataExtractionModeEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DataExtractionModeEvent */ 7,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "DidRespondToBgWithContentScriptFailureId":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* DidRespondToBgWithContentScriptFailureId */ 2,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e$4 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "DidSetupLinkTriggerListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidSetupLinkTriggerListener */ 3,
                            _0: v0$4._0
                        }
                    };
                }
                var e$7 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "Fail":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = failure_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Fail */ 8,
                            _0: v0$5._0
                        }
                    };
                }
                var e$8 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "Initialize":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Initialize */ 0
                    };
                }
            case "PlaybackModeEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.event_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PlaybackModeEvent */ 5,
                            _0: v0$6._0
                        }
                    };
                }
                var e$9 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "RecordingModeEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = Curry._1(decoder_recordingEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RecordingModeEvent */ 4,
                            _0: v0$7._0
                        }
                    };
                }
                var e$10 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "UrlTriggeringModeEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.event_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UrlTriggeringModeEvent */ 6,
                            _0: v0$8._0
                        }
                    };
                }
                var e$11 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, function(param) {
        return state_encode(encoder_recordingState, encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, param);
    }, function(param) {
        return sideEffect_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, param);
    }, function(param) {
        return listener_encode(encoder_domEvent, encoder_domMutationRecord, param);
    }, v);
}
function errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, function(param) {
        return state_decode(decoder_recordingState, decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, param);
    }, function(param) {
        return sideEffect_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, param);
    }, function(param) {
        return listener_decode(decoder_domEvent, decoder_domMutationRecord, param);
    }, v);
}
function failure_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, function(param) {
        return state_encode(encoder_recordingState, encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, param);
    }, function(param) {
        return sideEffect_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, param);
    }, function(param) {
        return listener_encode(encoder_domEvent, encoder_domMutationRecord, param);
    }, otherFailureReason_encode, v);
}
function failure_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, function(param) {
        return state_decode(decoder_recordingState, decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, param);
    }, function(param) {
        return sideEffect_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, param);
    }, function(param) {
        return listener_decode(decoder_domEvent, decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
function sideEffect_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v) {
    if (typeof v === "number") {
        switch(v){
            case /* ResetStateMachineHistory */ 0:
                return [
                    "ResetStateMachineHistory"
                ];
            case /* NotifyBgThatContentScriptReady */ 1:
                return [
                    "NotifyBgThatContentScriptReady"
                ];
            case /* SetupLinkTriggerListener */ 2:
                return [
                    "SetupLinkTriggerListener"
                ];
            case /* RemoveRenderedContent */ 3:
                return [
                    "RemoveRenderedContent"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* Dispatch */ 0:
                return [
                    "Dispatch",
                    event_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._0)
                ];
            case /* NotifyBgOfContentScriptFailure */ 1:
                return [
                    "NotifyBgOfContentScriptFailure",
                    Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, otherFailureReason_encode, v._0),
                    errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._1)
                ];
            case /* NotifyBgOfContentScriptResponseFailure */ 2:
                return [
                    "NotifyBgOfContentScriptResponseFailure",
                    InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v._0),
                    Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, otherFailureReason_encode, v._1),
                    errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._2)
                ];
            case /* TeardownLinkTriggerListener */ 3:
                return [
                    "TeardownLinkTriggerListener",
                    DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
            case /* RecordingModeSideEffect */ 4:
                return [
                    "RecordingModeSideEffect",
                    Curry._1(encoder_recordingSideEffect, v._0)
                ];
            case /* PlaybackModeSideEffect */ 5:
                return [
                    "PlaybackModeSideEffect",
                    ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
            case /* UrlTriggeringModeSideEffect */ 6:
                return [
                    "UrlTriggeringModeSideEffect",
                    ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
            case /* DataExtractionModeSideEffect */ 7:
                return [
                    "DataExtractionModeSideEffect",
                    ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
                ];
            case /* WindowAlert */ 8:
                return [
                    "WindowAlert",
                    Decco.stringToJson(v._0)
                ];
            case /* ConsoleJsPromiseError */ 9:
                return [
                    "ConsoleJsPromiseError",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                    errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._1)
                ];
            case /* ConsoleJsExn */ 10:
                return [
                    "ConsoleJsExn",
                    JsExnUtils$SmartcutsMacros.t_encode(v._0),
                    errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._1)
                ];
            case /* RespondToBg */ 11:
                return [
                    "RespondToBg",
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(v._1)
                ];
            case /* RespondToBgWithFailure */ 12:
                return [
                    "RespondToBgWithFailure",
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                    Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, otherFailureReason_encode, v._1),
                    errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._2)
                ];
            case /* RenderOnHostPage */ 13:
                return [
                    "RenderOnHostPage",
                    RenderOnHost$SmartcutsMacros.t_encode(v._0)
                ];
            case /* RenderHtmlMarkup */ 14:
                return [
                    "RenderHtmlMarkup",
                    Decco.stringToJson(v._0)
                ];
            case /* UpdateRenderedContentGeometry */ 15:
                return [
                    "UpdateRenderedContentGeometry",
                    RenderOnHost__Geometry$SmartcutsMacros.t_encode(v._0)
                ];
            case /* CheckIfElementExistsOnPageAndRespond */ 16:
                return [
                    "CheckIfElementExistsOnPageAndRespond",
                    Selector$SmartcutsMacros.elementSelector_encode(v._0),
                    Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v._1),
                    Curry._1(ExtensionMessaging__FromExtension$SmartcutsMacros.DoesElementExistOnPage.respondToSender_encode, v._2)
                ];
        }
    }
}
function sideEffect_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CheckIfElementExistsOnPageAndRespond":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Selector$SmartcutsMacros.elementSelector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = Curry._1(ExtensionMessaging__FromExtension$SmartcutsMacros.DoesElementExistOnPage.respondToSender_decode, Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* CheckIfElementExistsOnPageAndRespond */ 16,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "ConsoleJsExn":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$4 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$5 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
                if (match$4.TAG === /* Ok */ 0) {
                    if (match$5.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ConsoleJsExn */ 10,
                                _0: match$4._0,
                                _1: match$5._0
                            }
                        };
                    }
                    var e$3 = match$5._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "ConsoleJsPromiseError":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$6 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$7 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
                if (match$6.TAG === /* Ok */ 0) {
                    if (match$7.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ConsoleJsPromiseError */ 9,
                                _0: match$6._0,
                                _1: match$7._0
                            }
                        };
                    }
                    var e$5 = match$7._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "DataExtractionModeSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DataExtractionModeSideEffect */ 7,
                            _0: v0._0
                        }
                    };
                }
                var e$7 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "Dispatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = event_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Dispatch */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$8 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "NotifyBgOfContentScriptFailure":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$8 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$9 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
                if (match$8.TAG === /* Ok */ 0) {
                    if (match$9.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* NotifyBgOfContentScriptFailure */ 1,
                                _0: match$8._0,
                                _1: match$9._0
                            }
                        };
                    }
                    var e$9 = match$9._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = match$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "NotifyBgOfContentScriptResponseFailure":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$10 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$11 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
                var match$12 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
                if (match$10.TAG === /* Ok */ 0) {
                    if (match$11.TAG === /* Ok */ 0) {
                        if (match$12.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* NotifyBgOfContentScriptResponseFailure */ 2,
                                    _0: match$10._0,
                                    _1: match$11._0,
                                    _2: match$12._0
                                }
                            };
                        }
                        var e$11 = match$12._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$11.path,
                                message: e$11.message,
                                value: e$11.value
                            }
                        };
                    }
                    var e$12 = match$11._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                        }
                    };
                }
                var e$13 = match$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "NotifyBgThatContentScriptReady":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NotifyBgThatContentScriptReady */ 1
                    };
                }
            case "PlaybackModeSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PlaybackModeSideEffect */ 5,
                            _0: v0$2._0
                        }
                    };
                }
                var e$14 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "RecordingModeSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._1(decoder_recordingSideEffect, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RecordingModeSideEffect */ 4,
                            _0: v0$3._0
                        }
                    };
                }
                var e$15 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "RemoveRenderedContent":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemoveRenderedContent */ 3
                    };
                }
            case "RenderHtmlMarkup":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RenderHtmlMarkup */ 14,
                            _0: v0$4._0
                        }
                    };
                }
                var e$16 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$16.path,
                        message: e$16.message,
                        value: e$16.value
                    }
                };
            case "RenderOnHostPage":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = RenderOnHost$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RenderOnHostPage */ 13,
                            _0: v0$5._0
                        }
                    };
                }
                var e$17 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "ResetStateMachineHistory":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ResetStateMachineHistory */ 0
                    };
                }
            case "RespondToBg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$13 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$14 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$13.TAG === /* Ok */ 0) {
                    if (match$14.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RespondToBg */ 11,
                                _0: match$13._0,
                                _1: match$14._0
                            }
                        };
                    }
                    var e$18 = match$14._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$18.path,
                            message: e$18.message,
                            value: e$18.value
                        }
                    };
                }
                var e$19 = match$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "RespondToBgWithFailure":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$15 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$16 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
                var match$17 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
                if (match$15.TAG === /* Ok */ 0) {
                    if (match$16.TAG === /* Ok */ 0) {
                        if (match$17.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* RespondToBgWithFailure */ 12,
                                    _0: match$15._0,
                                    _1: match$16._0,
                                    _2: match$17._0
                                }
                            };
                        }
                        var e$20 = match$17._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$20.path,
                                message: e$20.message,
                                value: e$20.value
                            }
                        };
                    }
                    var e$21 = match$16._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$21.path,
                            message: e$21.message,
                            value: e$21.value
                        }
                    };
                }
                var e$22 = match$15._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$22.path,
                        message: e$22.message,
                        value: e$22.value
                    }
                };
            case "SetupLinkTriggerListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SetupLinkTriggerListener */ 2
                    };
                }
            case "TeardownLinkTriggerListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TeardownLinkTriggerListener */ 3,
                            _0: v0$6._0
                        }
                    };
                }
                var e$23 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                    }
                };
            case "UpdateRenderedContentGeometry":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = RenderOnHost__Geometry$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpdateRenderedContentGeometry */ 15,
                            _0: v0$7._0
                        }
                    };
                }
                var e$24 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$24.path,
                        message: e$24.message,
                        value: e$24.value
                    }
                };
            case "UrlTriggeringModeSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UrlTriggeringModeSideEffect */ 6,
                            _0: v0$8._0
                        }
                    };
                }
                var e$25 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                    }
                };
            case "WindowAlert":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WindowAlert */ 8,
                            _0: v0$9._0
                        }
                    };
                }
                var e$26 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$26.path,
                        message: e$26.message,
                        value: e$26.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "listener_encode"
        ],
        [
            /* Function */ 0,
            "listener_decode"
        ],
        [
            /* Function */ 0,
            "contentScriptIdle_encode"
        ],
        [
            /* Function */ 0,
            "contentScriptIdle_decode"
        ],
        [
            /* Function */ 0,
            "state_encode"
        ],
        [
            /* Function */ 0,
            "state_decode"
        ],
        [
            /* Function */ 0,
            "event_encode"
        ],
        [
            /* Function */ 0,
            "event_decode"
        ],
        [
            /* Function */ 0,
            "errorContext_encode"
        ],
        [
            /* Function */ 0,
            "errorContext_decode"
        ],
        [
            /* Function */ 0,
            "failure_encode"
        ],
        [
            /* Function */ 0,
            "failure_decode"
        ],
        [
            /* Function */ 0,
            "otherFailureReason_encode"
        ],
        [
            /* Function */ 0,
            "otherFailureReason_decode"
        ],
        [
            /* Function */ 0,
            "sideEffect_encode"
        ],
        [
            /* Function */ 0,
            "sideEffect_decode"
        ]
    ]
}, Generic, {
    listener_encode: listener_encode,
    listener_decode: listener_decode,
    contentScriptIdle_encode: contentScriptIdle_encode,
    contentScriptIdle_decode: contentScriptIdle_decode,
    state_encode: state_encode,
    state_decode: state_decode,
    event_encode: event_encode,
    event_decode: event_decode,
    errorContext_encode: errorContext_encode,
    errorContext_decode: errorContext_decode,
    failure_encode: failure_encode,
    failure_decode: failure_decode,
    otherFailureReason_encode: otherFailureReason_encode,
    otherFailureReason_decode: otherFailureReason_decode,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode
});
function listener_encode$1(v) {
    return Curry._3(Generic.listener_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function listener_decode$1(v) {
    return Curry._3(Generic.listener_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
function state_encode$1(v) {
    return Curry._4(Generic.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function state_decode$1(v) {
    return Curry._4(Generic.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
function event_encode$1(v) {
    return Curry._7(Generic.event_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}
function event_decode$1(v) {
    return Curry._7(Generic.event_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}
function sideEffect_encode$1(v) {
    return Curry._7(Generic.sideEffect_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}
function sideEffect_decode$1(v) {
    return Curry._7(Generic.sideEffect_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}
function errorContext_encode$1(v) {
    return Curry._7(Generic.errorContext_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}
function errorContext_decode$1(v) {
    return Curry._7(Generic.errorContext_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}
function failure_encode$1(v) {
    return Curry._7(Generic.failure_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}
function failure_decode$1(v) {
    return Curry._7(Generic.failure_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}
function otherFailureReason_encode$1(v) {
    return Curry._1(Generic.otherFailureReason_encode, v);
}
function otherFailureReason_decode$1(v) {
    return Curry._1(Generic.otherFailureReason_decode, v);
}
function failureInfo_encode(v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.Root.FailureInfo.t_encode, state_encode$1, event_encode$1, sideEffect_encode$1, listener_encode$1, otherFailureReason_encode$1, v);
}
function failureInfo_decode(v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.Root.FailureInfo.t_decode, state_decode$1, event_decode$1, sideEffect_decode$1, listener_decode$1, otherFailureReason_decode$1, v);
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "listener_encode"
        ],
        [
            /* Function */ 0,
            "listener_decode"
        ],
        [
            /* Function */ 0,
            "state_encode"
        ],
        [
            /* Function */ 0,
            "state_decode"
        ],
        [
            /* Function */ 0,
            "event_encode"
        ],
        [
            /* Function */ 0,
            "event_decode"
        ],
        [
            /* Function */ 0,
            "sideEffect_encode"
        ],
        [
            /* Function */ 0,
            "sideEffect_decode"
        ],
        [
            /* Function */ 0,
            "errorContext_encode"
        ],
        [
            /* Function */ 0,
            "errorContext_decode"
        ],
        [
            /* Function */ 0,
            "failure_encode"
        ],
        [
            /* Function */ 0,
            "failure_decode"
        ],
        [
            /* Function */ 0,
            "otherFailureReason_encode"
        ],
        [
            /* Function */ 0,
            "otherFailureReason_decode"
        ],
        [
            /* Function */ 0,
            "failureInfo_encode"
        ],
        [
            /* Function */ 0,
            "failureInfo_decode"
        ]
    ]
}, ForSerialization, {
    listener_encode: listener_encode$1,
    listener_decode: listener_decode$1,
    state_encode: state_encode$1,
    state_decode: state_decode$1,
    event_encode: event_encode$1,
    event_decode: event_decode$1,
    sideEffect_encode: sideEffect_encode$1,
    sideEffect_decode: sideEffect_decode$1,
    errorContext_encode: errorContext_encode$1,
    errorContext_decode: errorContext_decode$1,
    failure_encode: failure_encode$1,
    failure_decode: failure_decode$1,
    otherFailureReason_encode: otherFailureReason_encode$1,
    otherFailureReason_decode: otherFailureReason_decode$1,
    failureInfo_encode: failureInfo_encode,
    failureInfo_decode: failureInfo_decode
});
var $$let = ExtensionMessaging__FromTab__WithStateMachineDeps$SmartcutsMacros.Make({
    state_encode: ForSerialization.state_encode,
    state_decode: ForSerialization.state_decode,
    event_encode: ForSerialization.event_encode,
    event_decode: ForSerialization.event_decode,
    sideEffect_encode: ForSerialization.sideEffect_encode,
    sideEffect_decode: ForSerialization.sideEffect_decode,
    listener_encode: ForSerialization.listener_encode,
    listener_decode: ForSerialization.listener_decode,
    errorContext_encode: ForSerialization.errorContext_encode,
    errorContext_decode: ForSerialization.errorContext_decode,
    otherFailureReason_encode: ForSerialization.otherFailureReason_encode,
    otherFailureReason_decode: ForSerialization.otherFailureReason_decode
});
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ]
                ]
            },
            "MR_NotifyBgOfContentScriptFailure"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ],
                    [
                        /* Function */ 0,
                        "responseError_encode"
                    ],
                    [
                        /* Function */ 0,
                        "responseError_decode"
                    ],
                    [
                        /* Function */ 0,
                        "result__encode"
                    ],
                    [
                        /* Function */ 0,
                        "result__decode"
                    ],
                    [
                        /* Function */ 0,
                        "respondToSender_encode"
                    ],
                    [
                        /* Function */ 0,
                        "respondToSender_decode"
                    ],
                    [
                        /* Function */ 0,
                        "makeRespondToBg"
                    ],
                    [
                        /* Function */ 0,
                        "encodeAndSendMessage"
                    ],
                    [
                        /* Function */ 0,
                        "encodeAndSendMessageToExtensionId"
                    ]
                ]
            },
            "NotifyBgOfContentScriptFailure"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ]
                ]
            },
            "MR_NotifyBgOfContentScriptResponseFailure"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ],
                    [
                        /* Function */ 0,
                        "responseError_encode"
                    ],
                    [
                        /* Function */ 0,
                        "responseError_decode"
                    ],
                    [
                        /* Function */ 0,
                        "result__encode"
                    ],
                    [
                        /* Function */ 0,
                        "result__decode"
                    ],
                    [
                        /* Function */ 0,
                        "respondToSender_encode"
                    ],
                    [
                        /* Function */ 0,
                        "respondToSender_decode"
                    ],
                    [
                        /* Function */ 0,
                        "makeRespondToBg"
                    ],
                    [
                        /* Function */ 0,
                        "encodeAndSendMessage"
                    ],
                    [
                        /* Function */ 0,
                        "encodeAndSendMessageToExtensionId"
                    ]
                ]
            },
            "NotifyBgOfContentScriptResponseFailure"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ]
                ]
            },
            "MR_All"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "message_encode"
                    ],
                    [
                        /* Function */ 0,
                        "message_decode"
                    ],
                    [
                        /* Function */ 0,
                        "response_encode"
                    ],
                    [
                        /* Function */ 0,
                        "response_decode"
                    ]
                ]
            },
            "All"
        ]
    ]
}, ExtensionMessagingFromTabWithStateMachineDeps, {
    MR_NotifyBgOfContentScriptFailure: $$let.MR_NotifyBgOfContentScriptFailure,
    NotifyBgOfContentScriptFailure: $$let.NotifyBgOfContentScriptFailure,
    MR_NotifyBgOfContentScriptResponseFailure: $$let.MR_NotifyBgOfContentScriptResponseFailure,
    NotifyBgOfContentScriptResponseFailure: $$let.NotifyBgOfContentScriptResponseFailure,
    MR_All: $$let.MR_All,
    All: $$let.All
});
function message_encode(v) {
    if (v.TAG === /* Message_FromTabWithStateMachineDeps */ 0) {
        return [
            "Message_FromTabWithStateMachineDeps",
            Curry._1(ExtensionMessagingFromTabWithStateMachineDeps.All.message_encode, v._0)
        ];
    } else {
        return [
            "Message_FromTab",
            ExtensionMessaging__FromTab$SmartcutsMacros.All.message_encode(v._0)
        ];
    }
}
function message_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Message_FromTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ExtensionMessaging__FromTab$SmartcutsMacros.All.message_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_FromTab */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Message_FromTabWithStateMachineDeps":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(ExtensionMessagingFromTabWithStateMachineDeps.All.message_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Message_FromTabWithStateMachineDeps */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode(v) {
    if (v.TAG === /* Response_FromTabWithStateMachineDeps */ 0) {
        return [
            "Response_FromTabWithStateMachineDeps",
            Curry._1(ExtensionMessagingFromTabWithStateMachineDeps.All.response_encode, v._0)
        ];
    } else {
        return [
            "Response_FromTab",
            ExtensionMessaging__FromTab$SmartcutsMacros.All.response_encode(v._0)
        ];
    }
}
function response_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Response_FromTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ExtensionMessaging__FromTab$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_FromTab */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Response_FromTabWithStateMachineDeps":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(ExtensionMessagingFromTabWithStateMachineDeps.All.response_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Response_FromTabWithStateMachineDeps */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var responseError_encode = Decco.stringToJson;
var responseError_decode = Decco.stringFromJson;
var res_encode = response_encode;
var res_decode = response_decode;
var resError_encode = Decco.stringToJson;
var resError_decode = Decco.stringFromJson;
var include = ExtensionMessagingBuilders$SmartcutsMacros.MakeResponderTypesWithDeccoSupport({
    res_encode: res_encode,
    res_decode: res_decode,
    resError_encode: resError_encode,
    resError_decode: resError_decode
});
var result__encode = include.result__encode;
function onMessageToExtension(listener) {
    browser.runtime.onMessage.addListener(function(json, sender) {
        var msg = message_decode(json);
        if (msg.TAG === /* Ok */ 0) {
            return Curry._2(listener, msg._0, sender).then(function(result) {
                return Promise.resolve(Curry._1(result__encode, result));
            });
        }
        Curry._3(Log$SmartcutsMacros.decco.error3, "decodeError", msg._0, json);
        return Promise.resolve(Curry._1(result__encode, {
            TAG: /* Error */ 1,
            _0: "Error decoding message from tab"
        }));
    });
}
function onMessageExternal(listener) {
    browser.runtime.onMessageExternal.addListener(function(json, sender) {
        var msg = message_decode(json);
        if (msg.TAG === /* Ok */ 0) {
            return Curry._2(listener, msg._0, sender).then(function(result) {
                return Promise.resolve(Curry._1(result__encode, result));
            });
        }
        Curry._3(Log$SmartcutsMacros.decco.error3, "decodeError", msg._0, json);
        return Promise.resolve(Curry._1(result__encode, {
            TAG: /* Error */ 1,
            _0: "Error decoding message from tab"
        }));
    });
}
function makeNestedRespondToTabFromRootRespondToTab(wrapResponseAsAllResponse, respondToTab) {
    return function(result) {
        return respondToTab(Belt_Result.map(result, function(response) {
            return {
                TAG: /* Response_FromTab */ 1,
                _0: Curry._1(wrapResponseAsAllResponse, response)
            };
        }));
    };
}
function makeRootRespondToTabFromNestedRespondToTab(extractNestedResponseFromAllResponse, expectedAllResponse, nestedRespondToTab) {
    return function(result) {
        if (result.TAG !== /* Ok */ 0) {
            return Curry._1(nestedRespondToTab, {
                TAG: /* Error */ 1,
                _0: result._0
            });
        }
        var allResponse = result._0;
        if (allResponse.TAG === /* Response_FromTabWithStateMachineDeps */ 0) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected only Response_FromTab(" + (expectedAllResponse + ")"));
        }
        var nestedResponse = Curry._1(extractNestedResponseFromAllResponse, allResponse._0);
        if (nestedResponse !== undefined) {
            return Curry._1(nestedRespondToTab, {
                TAG: /* Ok */ 0,
                _0: Caml_option.valFromOption(nestedResponse)
            });
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected only Response_FromTab(" + (expectedAllResponse + ")"));
        }
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "message_encode"
        ],
        [
            /* Function */ 0,
            "message_decode"
        ],
        [
            /* Function */ 0,
            "response_encode"
        ],
        [
            /* Function */ 0,
            "response_decode"
        ],
        [
            /* Function */ 0,
            "responseError_encode"
        ],
        [
            /* Function */ 0,
            "responseError_decode"
        ],
        [
            /* Function */ 0,
            "result__encode"
        ],
        [
            /* Function */ 0,
            "result__decode"
        ],
        [
            /* Function */ 0,
            "respondToSender_encode"
        ],
        [
            /* Function */ 0,
            "respondToSender_decode"
        ],
        [
            /* Function */ 0,
            "onMessageToExtension"
        ],
        [
            /* Function */ 0,
            "onMessageExternal"
        ],
        [
            /* Function */ 0,
            "makeNestedRespondToTabFromRootRespondToTab"
        ],
        [
            /* Function */ 0,
            "makeRootRespondToTabFromNestedRespondToTab"
        ]
    ]
}, ExtensionMessagingFromTabAll, {
    message_encode: message_encode,
    message_decode: message_decode,
    response_encode: response_encode,
    response_decode: response_decode,
    responseError_encode: responseError_encode,
    responseError_decode: responseError_decode,
    result__encode: result__encode,
    result__decode: include.result__decode,
    respondToSender_encode: include.respondToSender_encode,
    respondToSender_decode: include.respondToSender_decode,
    onMessageToExtension: onMessageToExtension,
    onMessageExternal: onMessageExternal,
    makeNestedRespondToTabFromRootRespondToTab: makeNestedRespondToTabFromRootRespondToTab,
    makeRootRespondToTabFromNestedRespondToTab: makeRootRespondToTabFromNestedRespondToTab
});
var Regular = {};
exports.Generic = Generic;
exports.ForSerialization = ForSerialization;
exports.ExtensionMessagingFromTabWithStateMachineDeps = ExtensionMessagingFromTabWithStateMachineDeps;
exports.ExtensionMessagingFromTabAll = ExtensionMessagingFromTabAll;
exports.Regular = Regular; /* Generic Not a pure module */ 


/***/ }),

/***/ 77448:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var STEM__Client$SmartcutsMacros = __webpack_require__(97563);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var STEM__Interfaces$SmartcutsMacros = __webpack_require__(32985);
var DataExtraction__DataRecord$SmartcutsMacros = __webpack_require__(57870);
var DataExtraction__DataRegion$SmartcutsMacros = __webpack_require__(88644);
var DataExtraction__ExportToTable$SmartcutsMacros = __webpack_require__(87148);
var ExtensionMessaging__FromExtension$SmartcutsMacros = __webpack_require__(15462);
var ContentScript__StateMachine__Shared$SmartcutsMacros = __webpack_require__(31166);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
function t_encode(encoder_htmlElement, v) {
    return [
        "STEM",
        STEM__Client$SmartcutsMacros.Generic.t_encode(encoder_htmlElement, v._0)
    ];
}
function t_decode(decoder_htmlElement, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "STEM") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = STEM__Client$SmartcutsMacros.Generic.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* STEM */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function mapHtmlElement(mapHtmlElement$11, client) {
    var func = STEM__Client$SmartcutsMacros.Generic.mapHtmlElement;
    return /* STEM */ {
        _0: Curry._2(func, mapHtmlElement$11, client._0)
    };
}
var Client = {
    t_encode: t_encode,
    t_decode: t_decode,
    mapHtmlElement: mapHtmlElement
};
function t_encode$1(v) {
    return [
        "STEM",
        STEM__Interfaces$SmartcutsMacros.signal_encode(v._0)
    ];
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "STEM") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = STEM__Interfaces$SmartcutsMacros.signal_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* STEM */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var Signal = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function entry_decode(decoder_htmlElement, decoder_textNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var dataRecord = DataExtraction__DataRecord$SmartcutsMacros.WithDomElementOrTextNode.t_decode(decoder_htmlElement, decoder_textNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRecord"), null));
    if (dataRecord.TAG === /* Ok */ 0) {
        var dataRegion = DataExtraction__DataRegion$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRegion"), null));
        if (dataRegion.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    dataRecord: dataRecord._0,
                    dataRegion: dataRegion._0
                }
            };
        }
        var e = dataRegion._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dataRegion" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = dataRecord._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".dataRecord" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function entry_encode(encoder_htmlElement, encoder_textNode, v) {
    return Js_dict.fromArray([
        [
            "dataRecord",
            DataExtraction__DataRecord$SmartcutsMacros.WithDomElementOrTextNode.t_encode(encoder_htmlElement, encoder_textNode, v.dataRecord)
        ],
        [
            "dataRegion",
            DataExtraction__DataRegion$SmartcutsMacros.t_encode(v.dataRegion)
        ]
    ]);
}
function t_encode$2(encoder_htmlElement, encoder_textNode, v) {
    return Decco.arrayToJson(function(param) {
        return entry_encode(encoder_htmlElement, encoder_textNode, param);
    }, v);
}
function t_decode$2(decoder_htmlElement, decoder_textNode, v) {
    return Decco.arrayFromJson(function(param) {
        return entry_decode(decoder_htmlElement, decoder_textNode, param);
    }, v);
}
function mapHtmlElement$1(mapHtmlElement$2, entries) {
    return Belt_Array.map(entries, function(param) {
        var func = DataExtraction__DataRecord$SmartcutsMacros.WithDomElementOrTextNode.mapHtmlElement;
        return {
            dataRecord: Curry._2(func, mapHtmlElement$2, param.dataRecord),
            dataRegion: param.dataRegion
        };
    });
}
var DataRecords = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    entry_encode: entry_encode,
    entry_decode: entry_decode,
    mapHtmlElement: mapHtmlElement$1
};
function state_encode(encoder_htmlElement, v) {
    if (typeof v === "number") {
        switch(v){
            case /* Init */ 0:
                return [
                    "Init"
                ];
            case /* Initializing */ 1:
                return [
                    "Initializing"
                ];
            case /* Exiting */ 2:
                return [
                    "Exiting"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* ExtractingSignal */ 0:
                return [
                    "ExtractingSignal",
                    t_encode(encoder_htmlElement, v._0)
                ];
            case /* ProcessingSignal */ 1:
                return [
                    "ProcessingSignal",
                    t_encode(encoder_htmlElement, v._0)
                ];
            case /* SelectingDataToExport */ 2:
                return [
                    "SelectingDataToExport",
                    t_encode(encoder_htmlElement, v._0),
                    Decco.arrayToJson(function(param) {
                        return Decco.arrayToJson(DataExtraction__DataRegion$SmartcutsMacros.t_encode, param);
                    }, v._1)
                ];
        }
    }
}
function state_decode(decoder_htmlElement, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Exiting":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Exiting */ 2
                    };
                }
            case "ExtractingSignal":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExtractingSignal */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Init":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Init */ 0
                    };
                }
            case "Initializing":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Initializing */ 1
                    };
                }
            case "ProcessingSignal":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ProcessingSignal */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "SelectingDataToExport":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.arrayFromJson(function(param) {
                    return Decco.arrayFromJson(DataExtraction__DataRegion$SmartcutsMacros.t_decode, param);
                }, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectingDataToExport */ 2,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function selectingDataToExport_encode(encoder_htmlElement, encoder_textNode, v) {
    return Js_dict.fromArray([
        [
            "client",
            t_encode(encoder_htmlElement, v.client)
        ],
        [
            "dataRecords",
            t_encode$2(encoder_htmlElement, encoder_textNode, v.dataRecords)
        ],
        [
            "columns",
            Decco.arrayToJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.dataSchema_encode, param);
            }, v.columns)
        ],
        [
            "rows",
            Decco.arrayToJson(function(param1) {
                return Decco.arrayToJson(function(param) {
                    return Decco.optionToJson(Decco.stringToJson, param);
                }, param1);
            }, v.rows)
        ]
    ]);
}
function selectingDataToExport_decode(decoder_htmlElement, decoder_textNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var client = t_decode(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "client"), null));
    if (client.TAG === /* Ok */ 0) {
        var dataRecords = t_decode$2(decoder_htmlElement, decoder_textNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRecords"), null));
        if (dataRecords.TAG === /* Ok */ 0) {
            var columns = Decco.arrayFromJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.dataSchema_decode, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
            if (columns.TAG === /* Ok */ 0) {
                var rows = Decco.arrayFromJson(function(param2) {
                    return Decco.arrayFromJson(function(param) {
                        return Decco.optionFromJson(Decco.stringFromJson, param);
                    }, param2);
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
                if (rows.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            client: client._0,
                            dataRecords: dataRecords._0,
                            columns: columns._0,
                            rows: rows._0
                        }
                    };
                }
                var e = rows._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".rows" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = columns._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".columns" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = dataRecords._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dataRecords" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = client._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".client" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
    switch(v.TAG | 0){
        case /* Initialize */ 0:
            return [
                "Initialize",
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0)
            ];
        case /* BasicEventWhileDataExtraction */ 1:
            return [
                "BasicEventWhileDataExtraction",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
            ];
        case /* Fail */ 2:
            return [
                "Fail",
                failure_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* DidInitializeClient */ 3:
            return [
                "DidInitializeClient",
                t_encode(encoder_htmlElement, v._0)
            ];
        case /* DidExtractSignal */ 4:
            return [
                "DidExtractSignal",
                t_encode$1(v._0)
            ];
        case /* DidExtractDataRecords */ 5:
            return [
                "DidExtractDataRecords",
                Decco.arrayToJson(function(param) {
                    return Decco.arrayToJson(DataExtraction__DataRegion$SmartcutsMacros.t_encode, param);
                }, v._0)
            ];
        case /* Exit */ 6:
            return [
                "Exit",
                exitReason_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
    }
}
function failure_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return [
            "NoListener"
        ];
    }, otherFailureReason_encode, v);
}
function exitReason_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return [
            "NoListener"
        ];
    }, otherFailureReason_encode, v);
}
function sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AskBgToProcessDataExtractionSignal":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = t_decode$1(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* AskBgToProcessDataExtractionSignal */ 2,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Dispatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Dispatch */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "ExtractSignal":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExtractSignal */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$3 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "InitializeClient":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* InitializeClient */ 0
                    };
                }
            case "RemoveDataExportWidget":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemoveDataExportWidget */ 2
                    };
                }
            case "RenderDataExportWidget":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.arrayFromJson(function(param) {
                    return Decco.arrayFromJson(DataExtraction__DataRegion$SmartcutsMacros.t_decode, param);
                }, Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RenderDataExportWidget */ 3,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$4 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "RenderInitialLoadingOverlay":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RenderInitialLoadingOverlay */ 1
                    };
                }
            case "RespondToBg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RespondToBg */ 4,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$6 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
function event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BasicEventWhileDataExtraction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BasicEventWhileDataExtraction */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DidExtractDataRecords":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.arrayFromJson(function(param) {
                    return Decco.arrayFromJson(DataExtraction__DataRegion$SmartcutsMacros.t_decode, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidExtractDataRecords */ 5,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "DidExtractSignal":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidExtractSignal */ 4,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "DidInitializeClient":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidInitializeClient */ 3,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = exitReason_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exit */ 6,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "Fail":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = failure_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Fail */ 2,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "Initialize":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Initialize */ 0,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function listener_decode(decoder_domMutationRecord, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "NoListener") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* NoListener */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function failure_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
function exitReason_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
function sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
    if (typeof v === "number") {
        switch(v){
            case /* InitializeClient */ 0:
                return [
                    "InitializeClient"
                ];
            case /* RenderInitialLoadingOverlay */ 1:
                return [
                    "RenderInitialLoadingOverlay"
                ];
            case /* RemoveDataExportWidget */ 2:
                return [
                    "RemoveDataExportWidget"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* Dispatch */ 0:
                return [
                    "Dispatch",
                    event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
                ];
            case /* ExtractSignal */ 1:
                return [
                    "ExtractSignal",
                    t_encode(encoder_htmlElement, v._0)
                ];
            case /* AskBgToProcessDataExtractionSignal */ 2:
                return [
                    "AskBgToProcessDataExtractionSignal",
                    t_encode(encoder_htmlElement, v._0),
                    t_encode$1(v._1)
                ];
            case /* RenderDataExportWidget */ 3:
                return [
                    "RenderDataExportWidget",
                    t_encode(encoder_htmlElement, v._0),
                    Decco.arrayToJson(function(param) {
                        return Decco.arrayToJson(DataExtraction__DataRegion$SmartcutsMacros.t_encode, param);
                    }, v._1)
                ];
            case /* RespondToBg */ 4:
                return [
                    "RespondToBg",
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(v._1)
                ];
        }
    }
}
function listener_encode(encoder_domMutationRecord, v) {
    return [
        "NoListener"
    ];
}
function errorContext_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return [
            "NoListener"
        ];
    }, v);
}
function errorContext_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, v);
}
function stringifyState(param, state) {
    if (typeof state === "number") {
        switch(state){
            case /* Init */ 0:
                return "Init";
            case /* Initializing */ 1:
                return "Initializing";
            case /* Exiting */ 2:
                return "Exiting";
        }
    } else {
        switch(state.TAG | 0){
            case /* ExtractingSignal */ 0:
                return "ExtractingSignal(STEM(client))";
            case /* ProcessingSignal */ 1:
                return "ProcessingSignal(STEM(client))";
            case /* SelectingDataToExport */ 2:
                return "SelectingDataToExport(client: STEM(client), dataRecordsGroupedByFirstNode)";
        }
    }
}
function stringifyEvent(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, $$event) {
    switch($$event.TAG | 0){
        case /* Initialize */ 0:
            return "Initialize(respondToBg)";
        case /* BasicEventWhileDataExtraction */ 1:
            return "BasicEventWhileDataExtraction(" + (Curry._1(stringifyBasicEvent, $$event._0) + ")");
        case /* Fail */ 2:
            var failure = $$event._0;
            var func = StateMachine$SmartcutsMacros.Failure.WithListener.stringify;
            var param = function param(param$1) {
                return stringifyState(stringifyHtmlElement, param$1);
            };
            var func$1 = Curry._1(func, param);
            return "Fail(" + (Curry._3(function(param3) {
                var func$2 = Curry._1(func$1, param3);
                return function(param4) {
                    var func$3 = Curry._1(func$2, param4);
                    return function(param5) {
                        var func$4 = Curry._1(func$3, param5);
                        return function(param) {
                            return Curry._2(func$4, param, failure);
                        };
                    };
                };
            }(function(param) {
                return stringifyEvent(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, param);
            }), function(param) {
                return stringifySideEffect(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, param);
            }, stringifyListener, stringifyOtherFailureReason) + ")");
        case /* DidInitializeClient */ 3:
            return "DidInitializeClient(STEM(client))";
        case /* DidExtractSignal */ 4:
            return "DidExtractSignal(STEM(signal))";
        case /* DidExtractDataRecords */ 5:
            return "DidExtractDataRecords([n=" + (String($$event._0.length) + "])");
        case /* Exit */ 6:
            var exitReason = $$event._0;
            var func$21 = StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify;
            var param$11 = function param$11(param$2) {
                return stringifyState(stringifyHtmlElement, param$2);
            };
            var func$31 = Curry._1(func$21, param$11);
            return "Exit(" + (Curry._3(function(param6) {
                var func$4 = Curry._1(func$31, param6);
                return function(param7) {
                    var func$5 = Curry._1(func$4, param7);
                    return function(param8) {
                        var func$6 = Curry._1(func$5, param8);
                        return function(param) {
                            return Curry._2(func$6, param, exitReason);
                        };
                    };
                };
            }(function(param) {
                return stringifyEvent(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, param);
            }), function(param) {
                return stringifySideEffect(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, param);
            }, stringifyListener, stringifyOtherFailureReason) + ")");
    }
}
function stringifySideEffect(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* InitializeClient */ 0:
                return "InitializeClient";
            case /* RenderInitialLoadingOverlay */ 1:
                return "RenderInitialLoadingOverlay";
            case /* RemoveDataExportWidget */ 2:
                return "RemoveDataExportWidget";
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                var $$event = sideEffect._0;
                var func = function func(param, param$1, param$2) {
                    return stringifyEvent(stringifyHtmlElement, param, param$1, param$2);
                };
                var func$1 = Curry._1(func, stringifyBasicEvent);
                return "Dispatch(" + (Curry._1(function(param) {
                    return Curry._2(func$1, param, $$event);
                }, stringifyDomEvent) + ")");
            case /* ExtractSignal */ 1:
                return "ExtractSignal(STEM(client))";
            case /* AskBgToProcessDataExtractionSignal */ 2:
                return "AskBgToProcessDataExtractionSignal(STEM(client), STEM(signal))";
            case /* RenderDataExportWidget */ 3:
                return "RenderDataExportWidget(STEM(client), dataRecordsGroupedByFirstNode)";
            case /* RespondToBg */ 4:
                return "RespondToBg(respondToBg, response)";
        }
    }
}
function stringifyListener(listener) {
    return "NoListener";
}
var stringifyOtherFailureReason = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason;
function mapState(mapHtmlElement$2, state) {
    if (typeof state === "number") {
        switch(state){
            case /* Init */ 0:
                return /* Init */ 0;
            case /* Initializing */ 1:
                return /* Initializing */ 1;
            case /* Exiting */ 2:
                return /* Exiting */ 2;
        }
    } else {
        switch(state.TAG | 0){
            case /* ExtractingSignal */ 0:
                return {
                    TAG: /* ExtractingSignal */ 0,
                    _0: mapHtmlElement(mapHtmlElement$2, state._0)
                };
            case /* ProcessingSignal */ 1:
                return {
                    TAG: /* ProcessingSignal */ 1,
                    _0: mapHtmlElement(mapHtmlElement$2, state._0)
                };
            case /* SelectingDataToExport */ 2:
                return {
                    TAG: /* SelectingDataToExport */ 2,
                    _0: mapHtmlElement(mapHtmlElement$2, state._0),
                    _1: state._1
                };
        }
    }
}
function mapEvent(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, $$event) {
    switch($$event.TAG | 0){
        case /* Initialize */ 0:
            return {
                TAG: /* Initialize */ 0,
                _0: $$event._0
            };
        case /* BasicEventWhileDataExtraction */ 1:
            return {
                TAG: /* BasicEventWhileDataExtraction */ 1,
                _0: $$event._0
            };
        case /* Fail */ 2:
            var failure = $$event._0;
            var func = StateMachine$SmartcutsMacros.Failure.WithListener.map;
            var param = function param(param$1) {
                return mapState(mapHtmlElement$2, param$1);
            };
            var func$1 = Curry._1(func, param);
            return {
                TAG: /* Fail */ 2,
                _0: Curry._2(function(param9) {
                    var func$2 = Curry._1(func$1, param9);
                    return function(param10) {
                        var func$3 = Curry._1(func$2, param10);
                        return function(param) {
                            return Curry._2(func$3, param, failure);
                        };
                    };
                }(function(param) {
                    return mapEvent(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, param);
                }), function(param) {
                    return mapSideEffect(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, param);
                }, function(param) {
                    return /* NoListener */ 0;
                })
            };
        case /* DidInitializeClient */ 3:
            return {
                TAG: /* DidInitializeClient */ 3,
                _0: mapHtmlElement(mapHtmlElement$2, $$event._0)
            };
        case /* DidExtractSignal */ 4:
            return {
                TAG: /* DidExtractSignal */ 4,
                _0: $$event._0
            };
        case /* DidExtractDataRecords */ 5:
            return {
                TAG: /* DidExtractDataRecords */ 5,
                _0: $$event._0
            };
        case /* Exit */ 6:
            var exitReason = $$event._0;
            var func$22 = StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map;
            var param$12 = function param$12(param$2) {
                return mapState(mapHtmlElement$2, param$2);
            };
            var func$32 = Curry._1(func$22, param$12);
            return {
                TAG: /* Exit */ 6,
                _0: Curry._2(function(param11) {
                    var func$4 = Curry._1(func$32, param11);
                    return function(param12) {
                        var func$5 = Curry._1(func$4, param12);
                        return function(param) {
                            return Curry._2(func$5, param, exitReason);
                        };
                    };
                }(function(param) {
                    return mapEvent(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, param);
                }), function(param) {
                    return mapSideEffect(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, param);
                }, function(param) {
                    return /* NoListener */ 0;
                })
            };
    }
}
function mapSideEffect(mapHtmlElement$2, mapDomMutationRecord, mapDomEvent, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* InitializeClient */ 0:
                return /* InitializeClient */ 0;
            case /* RenderInitialLoadingOverlay */ 1:
                return /* RenderInitialLoadingOverlay */ 1;
            case /* RemoveDataExportWidget */ 2:
                return /* RemoveDataExportWidget */ 2;
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                var $$event = sideEffect._0;
                var func = function func(param, param$1, param$2) {
                    return mapEvent(mapHtmlElement$2, param, param$1, param$2);
                };
                var func$1 = Curry._1(func, mapDomMutationRecord);
                return {
                    TAG: /* Dispatch */ 0,
                    _0: Curry._1(function(param) {
                        return Curry._2(func$1, param, $$event);
                    }, mapDomEvent)
                };
            case /* ExtractSignal */ 1:
                return {
                    TAG: /* ExtractSignal */ 1,
                    _0: mapHtmlElement(mapHtmlElement$2, sideEffect._0)
                };
            case /* AskBgToProcessDataExtractionSignal */ 2:
                return {
                    TAG: /* AskBgToProcessDataExtractionSignal */ 2,
                    _0: mapHtmlElement(mapHtmlElement$2, sideEffect._0),
                    _1: sideEffect._1
                };
            case /* RenderDataExportWidget */ 3:
                return {
                    TAG: /* RenderDataExportWidget */ 3,
                    _0: mapHtmlElement(mapHtmlElement$2, sideEffect._0),
                    _1: sideEffect._1
                };
            case /* RespondToBg */ 4:
                return {
                    TAG: /* RespondToBg */ 4,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
        }
    }
}
function mapListener(param, listener) {
    return /* NoListener */ 0;
}
function isAnyFailEvent($$event) {
    if ($$event.TAG === /* Fail */ 2) {
        return true;
    } else {
        return false;
    }
}
function extractRespondToBgFromEvent($$event) {
    switch($$event.TAG | 0){
        case /* Initialize */ 0:
            return $$event._0;
        case /* BasicEventWhileDataExtraction */ 1:
            return ContentScript__StateMachine__Shared$SmartcutsMacros.extractRespondToBgFromEvent($$event._0);
        default:
            return;
    }
}
function extractRespondToBgFromListener(listener) {}
function extractRespondToBgFromSideEffect(sideEffect) {
    if (typeof sideEffect === "number" || sideEffect.TAG !== /* Dispatch */ 0) {
        return;
    } else {
        return extractRespondToBgFromEvent(sideEffect._0);
    }
}
var Generic = {
    state_encode: state_encode,
    state_decode: state_decode,
    selectingDataToExport_encode: selectingDataToExport_encode,
    selectingDataToExport_decode: selectingDataToExport_decode,
    event_encode: event_encode,
    event_decode: event_decode,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode,
    exitReason_encode: exitReason_encode,
    exitReason_decode: exitReason_decode,
    failure_encode: failure_encode,
    failure_decode: failure_decode,
    listener_encode: listener_encode,
    listener_decode: listener_decode,
    errorContext_encode: errorContext_encode,
    errorContext_decode: errorContext_decode,
    otherFailureReason_encode: otherFailureReason_encode,
    otherFailureReason_decode: otherFailureReason_decode,
    stringifyState: stringifyState,
    stringifyEvent: stringifyEvent,
    stringifySideEffect: stringifySideEffect,
    stringifyListener: stringifyListener,
    stringifyOtherFailureReason: stringifyOtherFailureReason,
    mapState: mapState,
    mapEvent: mapEvent,
    mapSideEffect: mapSideEffect,
    mapListener: mapListener,
    isAnyFailEvent: isAnyFailEvent,
    extractRespondToBgFromEvent: extractRespondToBgFromEvent,
    extractRespondToBgFromListener: extractRespondToBgFromListener,
    extractRespondToBgFromSideEffect: extractRespondToBgFromSideEffect
};
function state_encode$1(v) {
    return state_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}
function state_decode$1(v) {
    return state_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}
var ForSerialization = {
    state_encode: state_encode$1,
    state_decode: state_decode$1
};
exports.Client = Client;
exports.Signal = Signal;
exports.DataRecords = DataRecords;
exports.Generic = Generic;
exports.ForSerialization = ForSerialization; /* STEM__Client-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 14250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var ExtErrors$SmartcutsMacros = __webpack_require__(36570);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var PlaybackOptions$SmartcutsMacros = __webpack_require__(84094);
var SelectionSemantics$SmartcutsMacros = __webpack_require__(8741);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var CommandPreconditions$SmartcutsMacros = __webpack_require__(89645);
var CommandPlaybackRuntime$SmartcutsMacros = __webpack_require__(500);
var ExtErrors__OverlayBlocking$SmartcutsMacros = __webpack_require__(18962);
var SelectorOverrideWithoutScope$SmartcutsMacros = __webpack_require__(65443);
var StateMachine__DebounceManager$SmartcutsMacros = __webpack_require__(79764);
var ExtensionMessaging__FromExtension$SmartcutsMacros = __webpack_require__(15462);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
var ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros = __webpack_require__(1591);
function t_encode(v) {
    if (typeof v === "number") {
        switch(v){
            case /* NotSupported */ 0:
                return [
                    "NotSupported"
                ];
            case /* TabOrWindowNotVisible */ 1:
                return [
                    "TabOrWindowNotVisible"
                ];
            case /* TabOrWindowVisibilityUnknownOrUnloaded */ 2:
                return [
                    "TabOrWindowVisibilityUnknownOrUnloaded"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* SearchElementTimedOut */ 0:
                return [
                    "SearchElementTimedOut",
                    ExtErrors$SmartcutsMacros.searchElementTimedOut_encode(v._0)
                ];
            case /* QuerySelectorOverridesTimedOut */ 1:
                return [
                    "QuerySelectorOverridesTimedOut",
                    Decco.arrayToJson(SelectorOverrideWithoutScope$SmartcutsMacros.t_encode, v._0)
                ];
            case /* CouldNotApplySemantic */ 2:
                return [
                    "CouldNotApplySemantic",
                    SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_encode(v._0)
                ];
            case /* OverlayStillBlockingElementAfterMs */ 3:
                return [
                    "OverlayStillBlockingElementAfterMs",
                    ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_encode(Decco.stringToJson, v._0)
                ];
            case /* ErrorWhileSearchForElement */ 4:
                return [
                    "ErrorWhileSearchForElement",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
            case /* ErrorWhileWaitForPossibleOverlayToDisappear */ 5:
                return [
                    "ErrorWhileWaitForPossibleOverlayToDisappear",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
            case /* RanIntoUnhandledPromiseError */ 6:
                return [
                    "RanIntoUnhandledPromiseError",
                    Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
        }
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CouldNotApplySemantic":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CouldNotApplySemantic */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ErrorWhileSearchForElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ErrorWhileSearchForElement */ 4,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ErrorWhileWaitForPossibleOverlayToDisappear":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ErrorWhileWaitForPossibleOverlayToDisappear */ 5,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "NotSupported":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NotSupported */ 0
                    };
                }
            case "OverlayStillBlockingElementAfterMs":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_decode(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OverlayStillBlockingElementAfterMs */ 3,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "QuerySelectorOverridesTimedOut":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.arrayFromJson(SelectorOverrideWithoutScope$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* QuerySelectorOverridesTimedOut */ 1,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "RanIntoUnhandledPromiseError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RanIntoUnhandledPromiseError */ 6,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "SearchElementTimedOut":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = ExtErrors$SmartcutsMacros.searchElementTimedOut_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SearchElementTimedOut */ 0,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "TabOrWindowNotVisible":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TabOrWindowNotVisible */ 1
                    };
                }
            case "TabOrWindowVisibilityUnknownOrUnloaded":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TabOrWindowVisibilityUnknownOrUnloaded */ 2
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromDomSearchError(error) {
    if (typeof error !== "number") {
        switch(error.TAG | 0){
            case /* SearchElementTimedOut */ 7:
                var match = error._0;
                return {
                    TAG: /* SearchElementTimedOut */ 0,
                    _0: {
                        selector: match.selector,
                        ms: match.ms
                    }
                };
            case /* QuerySelectorOverridesTimedOut */ 8:
                return {
                    TAG: /* QuerySelectorOverridesTimedOut */ 1,
                    _0: error._0
                };
            case /* ErrorWhileSearchForElement */ 9:
                return {
                    TAG: /* ErrorWhileSearchForElement */ 4,
                    _0: error._0
                };
        }
    }
}
function fromOverlayError(error) {
    if (typeof error !== "number") {
        if (error.TAG !== /* OverlayStillBlockingElementAfterMs */ 5) {
            return {
                TAG: /* ErrorWhileWaitForPossibleOverlayToDisappear */ 5,
                _0: error._0
            };
        }
        var match = error._0;
        return {
            TAG: /* OverlayStillBlockingElementAfterMs */ 3,
            _0: {
                element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
                maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
                ms: match.ms
            }
        };
    }
}
function fromDocumentVisibilityError(error) {
    if (typeof error === "number") {
        if (error === /* TabOrWindowNotVisible */ 2) {
            return /* TabOrWindowNotVisible */ 1;
        } else {
            return /* TabOrWindowVisibilityUnknownOrUnloaded */ 2;
        }
    }
}
function fromUnhandledError(error) {
    return {
        TAG: /* RanIntoUnhandledPromiseError */ 6,
        _0: error._0
    };
}
function fromDomSearchOrUnhandledError(error) {
    if (typeof error === "number" || error.TAG !== /* UnhandledContentScriptPromiseError */ 14) {
        return fromDomSearchError(error);
    } else {
        return fromUnhandledError(error);
    }
}
function fromDomSearchOrOverlayError(error) {
    if (typeof error === "number") {
        return fromDomSearchError(error);
    }
    switch(error.TAG | 0){
        case /* OverlayStillBlockingElementAfterMs */ 5:
        case /* ErrorWhileWaitForPossibleOverlayToDisappear */ 6:
            return fromOverlayError(error);
        default:
            return fromDomSearchError(error);
    }
}
function fromDomSearchOrOverlayOrDocumentVisibilityError(error) {
    if (typeof error === "number") {
        switch(error){
            case /* TabOrWindowNotVisible */ 2:
            case /* TabOrWindowVisibilityUnknownOrUnloaded */ 3:
                return fromDocumentVisibilityError(error);
            default:
                return fromDomSearchError(error);
        }
    } else {
        switch(error.TAG | 0){
            case /* OverlayStillBlockingElementAfterMs */ 5:
            case /* ErrorWhileWaitForPossibleOverlayToDisappear */ 6:
                return fromOverlayError(error);
            default:
                return fromDomSearchError(error);
        }
    }
}
function fromDomSearchOrDocumentVisibilityOrUnhandledError(error) {
    if (typeof error !== "number") {
        if (error.TAG === /* UnhandledContentScriptPromiseError */ 14) {
            return fromUnhandledError(error);
        } else {
            return fromDomSearchError(error);
        }
    }
    switch(error){
        case /* TabOrWindowNotVisible */ 2:
        case /* TabOrWindowVisibilityUnknownOrUnloaded */ 3:
            return fromDocumentVisibilityError(error);
        default:
            return fromDomSearchError(error);
    }
}
function fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError(error) {
    if (typeof error === "number") {
        switch(error){
            case /* TabOrWindowNotVisible */ 2:
            case /* TabOrWindowVisibilityUnknownOrUnloaded */ 3:
                return fromDocumentVisibilityError(error);
            default:
                return fromDomSearchError(error);
        }
    } else {
        switch(error.TAG | 0){
            case /* OverlayStillBlockingElementAfterMs */ 5:
            case /* ErrorWhileWaitForPossibleOverlayToDisappear */ 6:
                return fromOverlayError(error);
            case /* UnhandledContentScriptPromiseError */ 14:
                return fromUnhandledError(error);
            default:
                return fromDomSearchError(error);
        }
    }
}
function fromSelectionOrCursorSemantics_findInDomAndApplySemanticError(error) {
    if (typeof error === "number") {
        switch(error){
            case /* TabOrWindowNotVisible */ 2:
            case /* TabOrWindowVisibilityUnknownOrUnloaded */ 3:
                return fromDocumentVisibilityError(error);
            default:
                return fromDomSearchOrOverlayError(error);
        }
    } else {
        switch(error.TAG | 0){
            case /* InputSelectionSemanticError */ 1:
            case /* InputCursorSemanticError */ 2:
            case /* ContentEditableCursorSemanticError */ 3:
            case /* ContentEditableSelectionSemanticError */ 4:
                return {
                    TAG: /* CouldNotApplySemantic */ 2,
                    _0: SelectionSemantics$SmartcutsMacros.fromSelectionOrCursorSemanticsError(error)
                };
            default:
                return fromDomSearchOrOverlayError(error);
        }
    }
}
function fromStrictSelectionSemantics_findInDomAndApplySemanticError(error) {
    if (typeof error === "number") {
        return fromDomSearchOrOverlayOrDocumentVisibilityError(error);
    }
    switch(error.TAG | 0){
        case /* NonInputSelectionSemanticError */ 0:
        case /* InputSelectionSemanticError */ 1:
            return {
                TAG: /* CouldNotApplySemantic */ 2,
                _0: SelectionSemantics$SmartcutsMacros.fromStrictSelectionSemanticsError(error)
            };
        default:
            return fromDomSearchOrOverlayOrDocumentVisibilityError(error);
    }
}
function fromInputCursorSemantics_moveCursorAtSelectorError(error) {
    if (typeof error === "number" || error.TAG !== /* InputCursorSemanticError */ 2) {
        return fromDomSearchOrOverlayOrDocumentVisibilityError(error);
    } else {
        return {
            TAG: /* CouldNotApplySemantic */ 2,
            _0: error
        };
    }
}
function fromClickInputCommand_execCommandError(error) {
    if (typeof error === "number" || error.TAG !== /* InputCursorSemanticError */ 2) {
        return fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError(error);
    } else {
        return {
            TAG: /* CouldNotApplySemantic */ 2,
            _0: error
        };
    }
}
function fromClickContentEditable_execCommandError(error) {
    if (typeof error === "number" || error.TAG !== /* ContentEditableCursorSemanticError */ 3) {
        return fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError(error);
    } else {
        return {
            TAG: /* CouldNotApplySemantic */ 2,
            _0: error
        };
    }
}
function fromTypeCommand_execCommandError(error) {
    if (typeof error === "number" || error.TAG !== /* InputSelectionSemanticError */ 1) {
        return fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError(error);
    } else {
        return {
            TAG: /* CouldNotApplySemantic */ 2,
            _0: {
                TAG: /* InputSelectionSemanticError */ 1,
                _0: error._0
            }
        };
    }
}
var ReasonNotPlaybackCommand = {
    t_encode: t_encode,
    t_decode: t_decode,
    fromDomSearchError: fromDomSearchError,
    fromOverlayError: fromOverlayError,
    fromDocumentVisibilityError: fromDocumentVisibilityError,
    fromUnhandledError: fromUnhandledError,
    fromDomSearchOrUnhandledError: fromDomSearchOrUnhandledError,
    fromDomSearchOrOverlayError: fromDomSearchOrOverlayError,
    fromDomSearchOrOverlayOrDocumentVisibilityError: fromDomSearchOrOverlayOrDocumentVisibilityError,
    fromDomSearchOrDocumentVisibilityOrUnhandledError: fromDomSearchOrDocumentVisibilityOrUnhandledError,
    fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError: fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError,
    fromSelectionOrCursorSemantics_findInDomAndApplySemanticError: fromSelectionOrCursorSemantics_findInDomAndApplySemanticError,
    fromStrictSelectionSemantics_findInDomAndApplySemanticError: fromStrictSelectionSemantics_findInDomAndApplySemanticError,
    fromInputCursorSemantics_moveCursorAtSelectorError: fromInputCursorSemantics_moveCursorAtSelectorError,
    fromClickInputCommand_execCommandError: fromClickInputCommand_execCommandError,
    fromClickContentEditable_execCommandError: fromClickContentEditable_execCommandError,
    fromTypeCommand_execCommandError: fromTypeCommand_execCommandError
};
function t_encode$1(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "triggeringElement",
            ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.triggeringElement_encode(encoder_htmlElement, v.triggeringElement)
        ],
        [
            "respondToBg",
            ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v.respondToBg)
        ],
        [
            "isPlaybackMode",
            Decco.boolToJson(v.isPlaybackMode)
        ]
    ]);
}
function t_decode$1(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var triggeringElement = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.triggeringElement_decode(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeringElement"), null));
    if (triggeringElement.TAG === /* Ok */ 0) {
        var respondToBg = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "respondToBg"), null));
        if (respondToBg.TAG === /* Ok */ 0) {
            var isPlaybackMode = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isPlaybackMode"), null));
            if (isPlaybackMode.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        triggeringElement: triggeringElement._0,
                        respondToBg: respondToBg._0,
                        isPlaybackMode: isPlaybackMode._0
                    }
                };
            }
            var e = isPlaybackMode._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".isPlaybackMode" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = respondToBg._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".respondToBg" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = triggeringElement._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".triggeringElement" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var UrlTriggerAfterExit = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "maybeUrlTriggerAfterExit",
            Decco.optionToJson(function(param) {
                return t_encode$1(encoder_htmlElement, param);
            }, v.maybeUrlTriggerAfterExit)
        ]
    ]);
}
function t_decode$2(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var maybeUrlTriggerAfterExit = Decco.optionFromJson(function(param) {
        return t_decode$1(decoder_htmlElement, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict._0, "maybeUrlTriggerAfterExit"), null));
    if (maybeUrlTriggerAfterExit.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                maybeUrlTriggerAfterExit: maybeUrlTriggerAfterExit._0
            }
        };
    }
    var e = maybeUrlTriggerAfterExit._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".maybeUrlTriggerAfterExit" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
var Exited = {
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
function mode_encode(encoder_htmlElement, encoder_domEvent, v) {
    if (typeof v === "number") {
        if (v === /* Init */ 0) {
            return [
                "Init"
            ];
        } else {
            return [
                "WaitingForNextCommand"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* PlayingBackCommand */ 0:
            return [
                "PlayingBackCommand",
                Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0)
            ];
        case /* Exiting */ 1:
            return [
                "Exiting",
                exiting_encode(encoder_htmlElement, encoder_domEvent, v._0)
            ];
        case /* Exited */ 2:
            return [
                "Exited",
                t_encode$2(encoder_htmlElement, v._0)
            ];
    }
}
function paginateState_encode(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "subtreesWithCollectedDataRecords",
            Decco.arrayToJson(encoder_htmlElement, v.subtreesWithCollectedDataRecords)
        ]
    ]);
}
function playbackWarningModalState_encode(encoder_domEvent, v) {
    if (v) {
        return [
            "ShowingPlaybackWarningModal",
            StateMachine__DebounceManager$SmartcutsMacros.t_encode(encoder_domEvent, Decco.unitToJson, v._0)
        ];
    } else {
        return [
            "HidingSmartcutsPlaybackWarningModal"
        ];
    }
}
function sideEffect_decode(decoder_htmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AttachListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AttachListeners */ 0
                    };
                }
            case "ClearDebounceTimeout":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ClearDebounceTimeout */ 4,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "DetachListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DetachListeners */ 5
                    };
                }
            case "Dispatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = event_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Dispatch */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "PlaybackCommandAndRespondToBg":
                if (tagged.length !== 5) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = PlaybackOptions$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$5 = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 3));
                var match$6 = Curry._1(ExtensionMessaging__FromExtension$SmartcutsMacros.Playback.respondToSender_decode, Belt_Array.getExn(jsonArr$1, 4));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        if (match$5.TAG === /* Ok */ 0) {
                            if (match$6.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        TAG: /* PlaybackCommandAndRespondToBg */ 1,
                                        _0: match$3._0,
                                        _1: match$4._0,
                                        _2: match$5._0,
                                        _3: match$6._0
                                    }
                                };
                            }
                            var e$3 = match$6._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[3]" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                }
                            };
                        }
                        var e$4 = match$5._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "RemoveDataExtractionOverlay":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemoveDataExtractionOverlay */ 4
                    };
                }
            case "RemovePlaybackModal":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemovePlaybackModal */ 2
                    };
                }
            case "RenderDataExtractionOverlay":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RenderDataExtractionOverlay */ 3
                    };
                }
            case "RenderPlaybackModal":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RenderPlaybackModal */ 1
                    };
                }
            case "ResetDebounceTimeout":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.timeoutId_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ResetDebounceTimeout */ 3,
                                _0: match$7._0,
                                _1: match$8._0
                            }
                        };
                    }
                    var e$7 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "RespondToBg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$9 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$10 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$9.TAG === /* Ok */ 0) {
                    if (match$10.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RespondToBg */ 2,
                                _0: match$9._0,
                                _1: match$10._0
                            }
                        };
                    }
                    var e$9 = match$10._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = match$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function state_decode(decoder_htmlElement, decoder_domEvent, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var playbackWarningModalState = playbackWarningModalState_decode(decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackWarningModalState"), null));
    if (playbackWarningModalState.TAG === /* Ok */ 0) {
        var mode = mode_decode(decoder_htmlElement, decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mode"), null));
        if (mode.TAG === /* Ok */ 0) {
            var paginateState = paginateState_decode(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateState"), null));
            if (paginateState.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        playbackWarningModalState: playbackWarningModalState._0,
                        mode: mode._0,
                        paginateState: paginateState._0
                    }
                };
            }
            var e = paginateState._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".paginateState" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = mode._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".mode" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = playbackWarningModalState._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".playbackWarningModalState" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
function event_decode(decoder_htmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BasicEventWhilePlayback":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BasicEventWhilePlayback */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DebounceTimerExpired":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DebounceTimerExpired */ 5,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "DidAttachListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidAttachListeners */ 1
                    };
                }
            case "DidClearDebounceTimeout":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidClearDebounceTimeout */ 7,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "DidDetachListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidDetachListeners */ 3
                    };
                }
            case "DidFinishCollectingDataRecords":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidFinishCollectingDataRecords */ 5
                    };
                }
            case "DidFlushDebouncedEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = StateMachine__DebounceManager$SmartcutsMacros.entry_decode(decoder_domEvent, Decco.unitFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidFlushDebouncedEvent */ 6,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "DidPlaybackCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidPlaybackCommand */ 0,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "DidSetNewDebounceTimeout":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DidSetNewDebounceTimeout */ 4,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$5 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "DidStartCollectingDataRecords":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidStartCollectingDataRecords */ 4
                    };
                }
            case "DidntPlaybackCommand":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DidntPlaybackCommand */ 1,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$7 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "DomEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DomEvent */ 3,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$9 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = exitReason_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exit */ 10,
                            _0: v0$5._0
                        }
                    };
                }
                var e$11 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "Fail":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = failure_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Fail */ 9,
                            _0: v0$6._0
                        }
                    };
                }
                var e$12 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "IgnoreSubtreesWithCollectedDataRecords":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = Decco.arrayFromJson(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* IgnoreSubtreesWithCollectedDataRecords */ 8,
                            _0: v0$7._0
                        }
                    };
                }
                var e$13 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "Initialize":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Initialize */ 0
                    };
                }
            case "ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */ 2
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function state_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Js_dict.fromArray([
        [
            "playbackWarningModalState",
            playbackWarningModalState_encode(encoder_domEvent, v.playbackWarningModalState)
        ],
        [
            "mode",
            mode_encode(encoder_htmlElement, encoder_domEvent, v.mode)
        ],
        [
            "paginateState",
            paginateState_encode(encoder_htmlElement, v.paginateState)
        ]
    ]);
}
function sideEffect_encode(encoder_htmlElement, encoder_domEvent, v) {
    if (typeof v === "number") {
        switch(v){
            case /* AttachListeners */ 0:
                return [
                    "AttachListeners"
                ];
            case /* RenderPlaybackModal */ 1:
                return [
                    "RenderPlaybackModal"
                ];
            case /* RemovePlaybackModal */ 2:
                return [
                    "RemovePlaybackModal"
                ];
            case /* RenderDataExtractionOverlay */ 3:
                return [
                    "RenderDataExtractionOverlay"
                ];
            case /* RemoveDataExtractionOverlay */ 4:
                return [
                    "RemoveDataExtractionOverlay"
                ];
            case /* DetachListeners */ 5:
                return [
                    "DetachListeners"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* Dispatch */ 0:
                return [
                    "Dispatch",
                    event_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
            case /* PlaybackCommandAndRespondToBg */ 1:
                return [
                    "PlaybackCommandAndRespondToBg",
                    Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0),
                    PlaybackOptions$SmartcutsMacros.t_encode(v._1),
                    Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v._2),
                    Curry._1(ExtensionMessaging__FromExtension$SmartcutsMacros.Playback.respondToSender_encode, v._3)
                ];
            case /* RespondToBg */ 2:
                return [
                    "RespondToBg",
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(v._1)
                ];
            case /* ResetDebounceTimeout */ 3:
                return [
                    "ResetDebounceTimeout",
                    Decco.stringToJson(v._0),
                    Decco.optionToJson(DeccoUtils$SmartcutsMacros.timeoutId_encode, v._1)
                ];
            case /* ClearDebounceTimeout */ 4:
                return [
                    "ClearDebounceTimeout",
                    Decco.stringToJson(v._0),
                    DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
        }
    }
}
var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
function event_encode(encoder_htmlElement, encoder_domEvent, v) {
    if (typeof v === "number") {
        switch(v){
            case /* Initialize */ 0:
                return [
                    "Initialize"
                ];
            case /* DidAttachListeners */ 1:
                return [
                    "DidAttachListeners"
                ];
            case /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */ 2:
                return [
                    "ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand"
                ];
            case /* DidDetachListeners */ 3:
                return [
                    "DidDetachListeners"
                ];
            case /* DidStartCollectingDataRecords */ 4:
                return [
                    "DidStartCollectingDataRecords"
                ];
            case /* DidFinishCollectingDataRecords */ 5:
                return [
                    "DidFinishCollectingDataRecords"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* DidPlaybackCommand */ 0:
                return [
                    "DidPlaybackCommand",
                    Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0)
                ];
            case /* DidntPlaybackCommand */ 1:
                return [
                    "DidntPlaybackCommand",
                    Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0),
                    t_encode(v._1)
                ];
            case /* BasicEventWhilePlayback */ 2:
                return [
                    "BasicEventWhilePlayback",
                    ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
                ];
            case /* DomEvent */ 3:
                return [
                    "DomEvent",
                    Curry._1(encoder_domEvent, v._0),
                    Decco.floatToJson(v._1)
                ];
            case /* DidSetNewDebounceTimeout */ 4:
                return [
                    "DidSetNewDebounceTimeout",
                    Decco.stringToJson(v._0),
                    DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
            case /* DebounceTimerExpired */ 5:
                return [
                    "DebounceTimerExpired",
                    Decco.stringToJson(v._0)
                ];
            case /* DidFlushDebouncedEvent */ 6:
                return [
                    "DidFlushDebouncedEvent",
                    StateMachine__DebounceManager$SmartcutsMacros.entry_encode(encoder_domEvent, Decco.unitToJson, v._0)
                ];
            case /* DidClearDebounceTimeout */ 7:
                return [
                    "DidClearDebounceTimeout",
                    Decco.stringToJson(v._0)
                ];
            case /* IgnoreSubtreesWithCollectedDataRecords */ 8:
                return [
                    "IgnoreSubtreesWithCollectedDataRecords",
                    Decco.arrayToJson(encoder_htmlElement, v._0)
                ];
            case /* Fail */ 9:
                return [
                    "Fail",
                    failure_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
            case /* Exit */ 10:
                return [
                    "Exit",
                    exitReason_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
        }
    }
}
function exitReason_decode(decoder_htmlElement, decoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithoutListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
    }, otherFailureReason_decode, v);
}
function failure_decode(decoder_htmlElement, decoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithoutListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
    }, otherFailureReason_decode, v);
}
function exitReason_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithoutListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
    }, otherFailureReason_encode, v);
}
function failure_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithoutListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
    }, otherFailureReason_encode, v);
}
function exiting_decode(decoder_htmlElement, decoder_domEvent, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var maybeUrlTriggerAfterExit = Decco.optionFromJson(function(param) {
        return t_decode$1(decoder_htmlElement, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeUrlTriggerAfterExit"), null));
    if (maybeUrlTriggerAfterExit.TAG === /* Ok */ 0) {
        var didDetachListeners = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "didDetachListeners"), null));
        if (didDetachListeners.TAG === /* Ok */ 0) {
            var nRemainingDebouncedTimeers = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nRemainingDebouncedTimeers"), null));
            if (nRemainingDebouncedTimeers.TAG === /* Ok */ 0) {
                var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                    return exitReason_decode(decoder_htmlElement, decoder_domEvent, param);
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "allExitReasons"), null));
                if (allExitReasons.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            maybeUrlTriggerAfterExit: maybeUrlTriggerAfterExit._0,
                            didDetachListeners: didDetachListeners._0,
                            nRemainingDebouncedTimeers: nRemainingDebouncedTimeers._0,
                            allExitReasons: allExitReasons._0
                        }
                    };
                }
                var e = allExitReasons._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".allExitReasons" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = nRemainingDebouncedTimeers._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".nRemainingDebouncedTimeers" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = didDetachListeners._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".didDetachListeners" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = maybeUrlTriggerAfterExit._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".maybeUrlTriggerAfterExit" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function mode_decode(decoder_htmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Exited":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$2(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exited */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Exiting":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = exiting_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exiting */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Init":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Init */ 0
                    };
                }
            case "PlayingBackCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PlayingBackCommand */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "WaitingForNextCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* WaitingForNextCommand */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function playbackWarningModalState_decode(decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "HidingSmartcutsPlaybackWarningModal":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* HidingSmartcutsPlaybackWarningModal */ 0
                    };
                }
            case "ShowingPlaybackWarningModal":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = StateMachine__DebounceManager$SmartcutsMacros.t_decode(decoder_domEvent, Decco.unitFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ShowingPlaybackWarningModal */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function paginateState_decode(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var subtreesWithCollectedDataRecords = Decco.arrayFromJson(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict._0, "subtreesWithCollectedDataRecords"), null));
    if (subtreesWithCollectedDataRecords.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                subtreesWithCollectedDataRecords: subtreesWithCollectedDataRecords._0
            }
        };
    }
    var e = subtreesWithCollectedDataRecords._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".subtreesWithCollectedDataRecords" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function exiting_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Js_dict.fromArray([
        [
            "maybeUrlTriggerAfterExit",
            Decco.optionToJson(function(param) {
                return t_encode$1(encoder_htmlElement, param);
            }, v.maybeUrlTriggerAfterExit)
        ],
        [
            "didDetachListeners",
            Decco.boolToJson(v.didDetachListeners)
        ],
        [
            "nRemainingDebouncedTimeers",
            Decco.intToJson(v.nRemainingDebouncedTimeers)
        ],
        [
            "allExitReasons",
            Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                return exitReason_encode(encoder_htmlElement, encoder_domEvent, param);
            }, v.allExitReasons)
        ]
    ]);
}
function errorContext_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Curry._4(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithoutListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
    }, v);
}
function errorContext_decode(decoder_htmlElement, decoder_domEvent, v) {
    return Curry._4(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithoutListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
    }, v);
}
function listener_encode(v) {
    return [
        "NoListener"
    ];
}
function listener_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "NoListener") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* NoListener */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function maybeGetPlaybackModalDebounceManager(playbackWarningModalState) {
    if (playbackWarningModalState) {
        return Caml_option.some(playbackWarningModalState._0);
    }
}
var Generic = {
    UrlTriggerAfterExit: UrlTriggerAfterExit,
    Exited: Exited,
    mode_encode: mode_encode,
    mode_decode: mode_decode,
    state_encode: state_encode,
    state_decode: state_decode,
    paginateState_encode: paginateState_encode,
    paginateState_decode: paginateState_decode,
    playbackWarningModalState_encode: playbackWarningModalState_encode,
    playbackWarningModalState_decode: playbackWarningModalState_decode,
    exiting_encode: exiting_encode,
    exiting_decode: exiting_decode,
    event_encode: event_encode,
    event_decode: event_decode,
    failure_encode: failure_encode,
    failure_decode: failure_decode,
    exitReason_encode: exitReason_encode,
    exitReason_decode: exitReason_decode,
    errorContext_encode: errorContext_encode,
    errorContext_decode: errorContext_decode,
    otherFailureReason_encode: otherFailureReason_encode,
    otherFailureReason_decode: otherFailureReason_decode,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode,
    listener_encode: listener_encode,
    listener_decode: listener_decode,
    maybeGetPlaybackModalDebounceManager: maybeGetPlaybackModalDebounceManager
};
var Regular = {};
var ForSerialization = {};
exports.ReasonNotPlaybackCommand = ReasonNotPlaybackCommand;
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization; /* ExtErrors-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 3183:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var DOM__Node$SmartcutsMacros = __webpack_require__(73466);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var DOM__Event__ForSerialization$SmartcutsMacros = __webpack_require__(54179);
var Virtualized__ContentEditable$SmartcutsMacros = __webpack_require__(93366);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = __webpack_require__(26362);
var disconnect_encode = DeccoUtils$SmartcutsMacros.unitToUnit_encode;
var disconnect_decode = DeccoUtils$SmartcutsMacros.unitToUnit_decode;
function listener_encode(encoder_domMutationRecord, v) {
    if (v.TAG === /* DocumentBodyMutationObserverListener */ 0) {
        return [
            "DocumentBodyMutationObserverListener",
            Decco.arrayToJson(encoder_domMutationRecord, v._0)
        ];
    } else {
        return [
            "ContentEditableMutationObserverListener",
            Decco.arrayToJson(encoder_domMutationRecord, v._0)
        ];
    }
}
function listener_decode(decoder_domMutationRecord, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentEditableMutationObserverListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.arrayFromJson(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentEditableMutationObserverListener */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DocumentBodyMutationObserverListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.arrayFromJson(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DocumentBodyMutationObserverListener */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    if (typeof v === "number") {
        if (v === /* Init */ 0) {
            return [
                "Init"
            ];
        } else {
            return [
                "NotEditing"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* WaitMutationObserverAttachTo */ 0:
            return [
                "WaitMutationObserverAttachTo",
                Curry._1(encoder_domHtmlElement, v._0)
            ];
        case /* EditingContentEditable */ 1:
            return [
                "EditingContentEditable",
                Virtualized__ContentEditable$SmartcutsMacros.Generic.t_encode(encoder_domHtmlElement, encoder_domNode, v._0),
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._1)
            ];
        case /* Exiting */ 2:
            return [
                "Exiting",
                exiting_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* Exited */ 3:
            return [
                "Exited",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                    return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                }, v._0)
            ];
    }
}
var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
function sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    switch(v.TAG | 0){
        case /* Dispatch */ 0:
            return [
                "Dispatch",
                event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* SetupMutationObserver */ 1:
            return [
                "SetupMutationObserver",
                Curry._1(encoder_domHtmlElement, v._0)
            ];
        case /* TearDownMutationObserver */ 2:
            return [
                "TearDownMutationObserver",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
            ];
    }
}
function event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    if (typeof v === "number") {
        if (v === /* Initialize */ 0) {
            return [
                "Initialize"
            ];
        } else {
            return [
                "MutationObserved"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* SharedEvent */ 0:
            return [
                "SharedEvent",
                ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_encode(encoder_domHtmlElement, encoder_domEvent, v._0)
            ];
        case /* BasicEventWhileContentEditing */ 1:
            return [
                "BasicEventWhileContentEditing",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
            ];
        case /* FocusOnContentEditable */ 2:
            return [
                "FocusOnContentEditable",
                Curry._1(encoder_domNode, v._0)
            ];
        case /* MutationObserverAttachedTo */ 3:
            return [
                "MutationObserverAttachedTo",
                Curry._1(encoder_domHtmlElement, v._0),
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._1)
            ];
        case /* Fail */ 4:
            return [
                "Fail",
                failure_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* Exit */ 5:
            return [
                "Exit",
                exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
    }
}
function exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, function(param) {
        return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
function event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BasicEventWhileContentEditing":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BasicEventWhileContentEditing */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exit */ 5,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Fail":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = failure_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Fail */ 4,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "FocusOnContentEditable":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._1(decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FocusOnContentEditable */ 2,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Initialize":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Initialize */ 0
                    };
                }
            case "MutationObserved":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* MutationObserved */ 1
                    };
                }
            case "MutationObserverAttachedTo":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* MutationObserverAttachedTo */ 3,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$4 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "SharedEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_decode(decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SharedEvent */ 0,
                            _0: v0$4._0
                        }
                    };
                }
                var e$6 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, function(param) {
        return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return listener_encode(encoder_domMutationRecord, param);
    }, otherFailureReason_encode, v);
}
function failure_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, function(param) {
        return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return listener_encode(encoder_domMutationRecord, param);
    }, otherFailureReason_encode, v);
}
var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
function state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "EditingContentEditable":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Virtualized__ContentEditable$SmartcutsMacros.Generic.t_decode(decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* EditingContentEditable */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Exited":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                    return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exited */ 3,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Exiting":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = exiting_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exiting */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$3 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Init":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Init */ 0
                    };
                }
            case "NotEditing":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NotEditing */ 1
                    };
                }
            case "WaitMutationObserverAttachTo":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WaitMutationObserverAttachTo */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$4 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Dispatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Dispatch */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SetupMutationObserver":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SetupMutationObserver */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "TearDownMutationObserver":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TearDownMutationObserver */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function failure_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, function(param) {
        return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
function exiting_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    return Js_dict.fromArray([
        [
            "allExitReasons",
            Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
            }, v.allExitReasons)
        ]
    ]);
}
function exiting_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
        return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict._0, "allExitReasons"), null));
    if (allExitReasons.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                allExitReasons: allExitReasons._0
            }
        };
    }
    var e = allExitReasons._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".allExitReasons" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function errorContext_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, function(param) {
        return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return listener_encode(encoder_domMutationRecord, param);
    }, v);
}
function errorContext_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, function(param) {
        return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, v);
}
var Generic = {
    disconnect_encode: disconnect_encode,
    disconnect_decode: disconnect_decode,
    listener_encode: listener_encode,
    listener_decode: listener_decode,
    state_encode: state_encode,
    state_decode: state_decode,
    exiting_encode: exiting_encode,
    exiting_decode: exiting_decode,
    event_encode: event_encode,
    event_decode: event_decode,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode,
    failure_encode: failure_encode,
    failure_decode: failure_decode,
    otherFailureReason_encode: otherFailureReason_encode,
    otherFailureReason_decode: otherFailureReason_decode,
    errorContext_encode: errorContext_encode,
    errorContext_decode: errorContext_decode,
    exitReason_encode: exitReason_encode,
    exitReason_decode: exitReason_decode
};
var Regular = {};
function listener_encode$1(v) {
    return listener_encode(DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function listener_decode$1(v) {
    return listener_decode(DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
function state_encode$1(v) {
    return state_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function state_decode$1(v) {
    return state_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
function event_encode$1(v) {
    return event_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function event_decode$1(v) {
    return event_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
function sideEffect_encode$1(v) {
    return sideEffect_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function sideEffect_decode$1(v) {
    return sideEffect_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
function failure_encode$1(v) {
    return failure_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function failure_decode$1(v) {
    return failure_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
function errorContext_encode$1(v) {
    return errorContext_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function errorContext_decode$1(v) {
    return errorContext_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
function exitReason_encode$1(v) {
    return exitReason_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function exitReason_decode$1(v) {
    return exitReason_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
var ForSerialization = {
    listener_encode: listener_encode$1,
    listener_decode: listener_decode$1,
    state_encode: state_encode$1,
    state_decode: state_decode$1,
    event_encode: event_encode$1,
    event_decode: event_decode$1,
    sideEffect_encode: sideEffect_encode$1,
    sideEffect_decode: sideEffect_decode$1,
    failure_encode: failure_encode$1,
    failure_decode: failure_decode$1,
    errorContext_encode: errorContext_encode$1,
    errorContext_decode: errorContext_decode$1,
    exitReason_encode: exitReason_encode$1,
    exitReason_decode: exitReason_decode$1
};
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization; /* DOM-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 4738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var Command$SmartcutsMacros = __webpack_require__(4290);
var DOM__Node$SmartcutsMacros = __webpack_require__(73466);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var DOM__FocusTrail$SmartcutsMacros = __webpack_require__(62912);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var ExtensionMessaging$SmartcutsMacros = __webpack_require__(31052);
var PendingCommandInfo$SmartcutsMacros = __webpack_require__(40099);
var Selection__Snapshot$SmartcutsMacros = __webpack_require__(27836);
var Virtualized__InputMaps$SmartcutsMacros = __webpack_require__(23676);
var HighlightElement__Shared$SmartcutsMacros = __webpack_require__(98226);
var DOM__Event__ForSerialization$SmartcutsMacros = __webpack_require__(54179);
var StateMachine__DebounceManager$SmartcutsMacros = __webpack_require__(79764);
var ExtensionMessaging__FromExtension$SmartcutsMacros = __webpack_require__(15462);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
var Selection__ContentEditableSelectionOrCursor$SmartcutsMacros = __webpack_require__(92190);
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = __webpack_require__(26362);
function retrieveCommandInfo_encode(v) {
    return [
        "RetrieveClipboardItemAsPasteInContentEditable",
        Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v._0)
    ];
}
function retrieveCommandInfo_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "RetrieveClipboardItemAsPasteInContentEditable") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* RetrieveClipboardItemAsPasteInContentEditable */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function listener_encode(encoder_domEvent, v) {
    return [
        "DOMEventListener",
        Curry._1(encoder_domEvent, v._0)
    ];
}
function listener_decode(decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "DOMEventListener") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* DOMEventListener */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function debounceFirstCallData_encode(encoder_domHtmlElement, v) {
    return Js_dict.fromArray([
        [
            "pendingCommandKey",
            PendingCommandInfo$SmartcutsMacros.key_encode(v.pendingCommandKey)
        ],
        [
            "focusTrail",
            Decco.listToJson(function(param) {
                return DOM__FocusTrail$SmartcutsMacros.Item.t_encode(encoder_domHtmlElement, param);
            }, v.focusTrail)
        ],
        [
            "firstTimestamp",
            Decco.floatToJson(v.firstTimestamp)
        ]
    ]);
}
function debounceFirstCallData_decode(decoder_domHtmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var pendingCommandKey = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pendingCommandKey"), null));
    if (pendingCommandKey.TAG === /* Ok */ 0) {
        var focusTrail = Decco.listFromJson(function(param) {
            return DOM__FocusTrail$SmartcutsMacros.Item.t_decode(decoder_domHtmlElement, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusTrail"), null));
        if (focusTrail.TAG === /* Ok */ 0) {
            var firstTimestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstTimestamp"), null));
            if (firstTimestamp.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        pendingCommandKey: pendingCommandKey._0,
                        focusTrail: focusTrail._0,
                        firstTimestamp: firstTimestamp._0
                    }
                };
            }
            var e = firstTimestamp._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".firstTimestamp" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = focusTrail._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".focusTrail" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = pendingCommandKey._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".pendingCommandKey" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function debounceManager_encode(encoder_domEvent, encoder_domHtmlElement, v) {
    return StateMachine__DebounceManager$SmartcutsMacros.t_encode(encoder_domEvent, function(param) {
        return debounceFirstCallData_encode(encoder_domHtmlElement, param);
    }, v);
}
function debounceManager_decode(decoder_domEvent, decoder_domHtmlElement, v) {
    return StateMachine__DebounceManager$SmartcutsMacros.t_decode(decoder_domEvent, function(param) {
        return debounceFirstCallData_decode(decoder_domHtmlElement, param);
    }, v);
}
function streamingState_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v) {
    return Js_dict.fromArray([
        [
            "inputByDomElementRepresentation",
            Curry._1(encoder_inputByDomElementRepresentation, v.inputByDomElementRepresentation)
        ],
        [
            "currentSelection",
            Selection__Snapshot$SmartcutsMacros.Generic.t_encode(encoder_domNode, v.currentSelection)
        ],
        [
            "focusTrail",
            Decco.listToJson(function(param) {
                return DOM__FocusTrail$SmartcutsMacros.Item.t_encode(encoder_domHtmlElement, param);
            }, v.focusTrail)
        ],
        [
            "maybeClickContext",
            Decco.optionToJson(encoder_domEvent, v.maybeClickContext)
        ],
        [
            "debounceManager",
            debounceManager_encode(encoder_domEvent, encoder_domHtmlElement, v.debounceManager)
        ]
    ]);
}
function streamingState_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var inputByDomElementRepresentation = Curry._1(decoder_inputByDomElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputByDomElementRepresentation"), null));
    if (inputByDomElementRepresentation.TAG === /* Ok */ 0) {
        var currentSelection = Selection__Snapshot$SmartcutsMacros.Generic.t_decode(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentSelection"), null));
        if (currentSelection.TAG === /* Ok */ 0) {
            var focusTrail = Decco.listFromJson(function(param) {
                return DOM__FocusTrail$SmartcutsMacros.Item.t_decode(decoder_domHtmlElement, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusTrail"), null));
            if (focusTrail.TAG === /* Ok */ 0) {
                var maybeClickContext = Decco.optionFromJson(decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeClickContext"), null));
                if (maybeClickContext.TAG === /* Ok */ 0) {
                    var debounceManager = debounceManager_decode(decoder_domEvent, decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "debounceManager"), null));
                    if (debounceManager.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                inputByDomElementRepresentation: inputByDomElementRepresentation._0,
                                currentSelection: currentSelection._0,
                                focusTrail: focusTrail._0,
                                maybeClickContext: maybeClickContext._0,
                                debounceManager: debounceManager._0
                            }
                        };
                    }
                    var e = debounceManager._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".debounceManager" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = maybeClickContext._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".maybeClickContext" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = focusTrail._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".focusTrail" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = currentSelection._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".currentSelection" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = inputByDomElementRepresentation._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".inputByDomElementRepresentation" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
    if (typeof v === "number") {
        if (v === /* Init */ 0) {
            return [
                "Init"
            ];
        } else {
            return [
                "SettingUpEventStreamingToBg"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* StreamingEventsToBg */ 0:
            return [
                "StreamingEventsToBg",
                streamingState_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v._0)
            ];
        case /* HighlightingElementWhileStreamingEventsToBg */ 1:
            return [
                "HighlightingElementWhileStreamingEventsToBg",
                streamingState_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v._0),
                HighlightElement__Shared$SmartcutsMacros.Callback.t_encode(v._1)
            ];
        case /* Exiting */ 2:
            return [
                "Exiting",
                exiting_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
            ];
        case /* Exited */ 3:
            return [
                "Exited",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                    return exitReason_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
                }, v._0)
            ];
    }
}
function sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
    if (typeof v === "number") {
        switch(v){
            case /* SetupEventStreaming */ 0:
                return [
                    "SetupEventStreaming"
                ];
            case /* TeardownEventStreaming */ 1:
                return [
                    "TeardownEventStreaming"
                ];
            case /* RenderModalToExplainHighlightElement */ 2:
                return [
                    "RenderModalToExplainHighlightElement"
                ];
            case /* RenderHighlightElementControl */ 3:
                return [
                    "RenderHighlightElementControl"
                ];
            case /* RemoveRenderedContent */ 4:
                return [
                    "RemoveRenderedContent"
                ];
            case /* TellBgToStopHighlightingElement */ 5:
                return [
                    "TellBgToStopHighlightingElement"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* Dispatch */ 0:
                return [
                    "Dispatch",
                    event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
                ];
            case /* StreamCommandToBgToRecordIt */ 1:
                return [
                    "StreamCommandToBgToRecordIt",
                    Command$SmartcutsMacros.CommandWithContextLocal.t_encode(v._0),
                    Decco.optionToJson(function(param) {
                        return [
                            PendingCommandInfo$SmartcutsMacros.key_encode(param[0]),
                            Decco.intToJson(param[1])
                        ];
                    }, v._1)
                ];
            case /* NotifyBgAboutPossibleCommand */ 2:
                return [
                    "NotifyBgAboutPossibleCommand",
                    PendingCommandInfo$SmartcutsMacros.key_encode(v._0),
                    Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v._1)
                ];
            case /* ResetDebounceTimeout */ 3:
                return [
                    "ResetDebounceTimeout",
                    StateMachine__DebounceManager$SmartcutsMacros.uuid_encode(v._0),
                    Decco.optionToJson(DeccoUtils$SmartcutsMacros.timeoutId_encode, v._1)
                ];
            case /* RespondToBg */ 4:
                return [
                    "RespondToBg",
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.result_encode(v._1)
                ];
            case /* StreamCommandToBgForHighlightedElement */ 5:
                return [
                    "StreamCommandToBgForHighlightedElement",
                    Curry._1(encoder_domHtmlElement, v._0),
                    HighlightElement__Shared$SmartcutsMacros.Callback.t_encode(v._1)
                ];
            case /* RetrievePossibleCommandInfoAndMaybeStreamToBg */ 6:
                return [
                    "RetrievePossibleCommandInfoAndMaybeStreamToBg",
                    PendingCommandInfo$SmartcutsMacros.key_encode(v._0),
                    retrieveCommandInfo_encode(v._1),
                    extraInfoRetrieveCommandInfo_encode(v._2)
                ];
        }
    }
}
function event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
    if (typeof v === "number") {
        switch(v){
            case /* DidSetupEventStreaming */ 0:
                return [
                    "DidSetupEventStreaming"
                ];
            case /* DidTeardownEventStreaming */ 1:
                return [
                    "DidTeardownEventStreaming"
                ];
            case /* ShouldNotShowUserExplainHighlightModal */ 2:
                return [
                    "ShouldNotShowUserExplainHighlightModal"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* Initialize */ 0:
                return [
                    "Initialize",
                    Decco.optionToJson(function(param) {
                        return [
                            ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(param[0]),
                            ExtensionMessaging$SmartcutsMacros.rejectToTab_encode(param[1])
                        ];
                    }, v._0)
                ];
            case /* DidSetNewDebounceTimeout */ 1:
                return [
                    "DidSetNewDebounceTimeout",
                    StateMachine__DebounceManager$SmartcutsMacros.uuid_encode(v._0),
                    DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
            case /* DebounceTimerExpired */ 2:
                return [
                    "DebounceTimerExpired",
                    StateMachine__DebounceManager$SmartcutsMacros.uuid_encode(v._0)
                ];
            case /* DidFlushDebouncedEvent */ 3:
                return [
                    "DidFlushDebouncedEvent",
                    StateMachine__DebounceManager$SmartcutsMacros.entry_encode(encoder_domEvent, function(param) {
                        return debounceFirstCallData_encode(encoder_domHtmlElement, param);
                    }, v._0)
                ];
            case /* UserDidSelectElement */ 4:
                return [
                    "UserDidSelectElement",
                    Curry._1(encoder_domHtmlElement, v._0)
                ];
            case /* SharedEvent */ 5:
                return [
                    "SharedEvent",
                    ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_encode(encoder_domHtmlElement, encoder_domEvent, v._0)
                ];
            case /* BasicEventWhileEventStreaming */ 6:
                return [
                    "BasicEventWhileEventStreaming",
                    ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
                ];
            case /* Fail */ 7:
                return [
                    "Fail",
                    failure_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
                ];
            case /* Exit */ 8:
                return [
                    "Exit",
                    exitReason_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
                ];
        }
    }
}
function exitReason_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, function(param) {
        return state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return listener_encode(encoder_domEvent, param);
    }, otherFailureReason_encode, v);
}
function exiting_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
    return Js_dict.fromArray([
        [
            "didTeardownEventStreaming",
            Decco.boolToJson(v.didTeardownEventStreaming)
        ],
        [
            "debounceStatusForExit",
            debounceStatusForExit_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v.debounceStatusForExit)
        ],
        [
            "allExitReasons",
            Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                return exitReason_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
            }, v.allExitReasons)
        ]
    ]);
}
function exiting_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var didTeardownEventStreaming = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "didTeardownEventStreaming"), null));
    if (didTeardownEventStreaming.TAG === /* Ok */ 0) {
        var debounceStatusForExit = debounceStatusForExit_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "debounceStatusForExit"), null));
        if (debounceStatusForExit.TAG === /* Ok */ 0) {
            var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                return exitReason_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "allExitReasons"), null));
            if (allExitReasons.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        didTeardownEventStreaming: didTeardownEventStreaming._0,
                        debounceStatusForExit: debounceStatusForExit._0,
                        allExitReasons: allExitReasons._0
                    }
                };
            }
            var e = allExitReasons._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".allExitReasons" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = debounceStatusForExit._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".debounceStatusForExit" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = didTeardownEventStreaming._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".didTeardownEventStreaming" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function exitReason_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, function(param) {
        return state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return listener_decode(decoder_domEvent, param);
    }, otherFailureReason_decode, v);
}
function event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match1 = Belt_Array.getExn(tagged, 0);
    if (typeof match1 !== "number" && match1.TAG === /* JSONString */ 0) {
        switch(match1._0){
            case "BasicEventWhileEventStreaming":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v01 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v01.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BasicEventWhileEventStreaming */ 6,
                            _0: v01._0
                        }
                    };
                }
                var e1 = v01._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e1.path,
                        message: e1.message,
                        value: e1.value
                    }
                };
            case "DebounceTimerExpired":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = StateMachine__DebounceManager$SmartcutsMacros.uuid_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DebounceTimerExpired */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$11 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "DidFlushDebouncedEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = StateMachine__DebounceManager$SmartcutsMacros.entry_decode(decoder_domEvent, function(param) {
                    return debounceFirstCallData_decode(decoder_domHtmlElement, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidFlushDebouncedEvent */ 3,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "DidSetNewDebounceTimeout":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$11 = StateMachine__DebounceManager$SmartcutsMacros.uuid_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$21 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$11.TAG === /* Ok */ 0) {
                    if (match$21.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DidSetNewDebounceTimeout */ 1,
                                _0: match$11._0,
                                _1: match$21._0
                            }
                        };
                    }
                    var e$3 = match$21._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "DidSetupEventStreaming":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidSetupEventStreaming */ 0
                    };
                }
            case "DidTeardownEventStreaming":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidTeardownEventStreaming */ 1
                    };
                }
            case "Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = exitReason_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exit */ 8,
                            _0: v0$3._0
                        }
                    };
                }
                var e$5 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "Fail":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = failure_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Fail */ 7,
                            _0: v0$4._0
                        }
                    };
                }
                var e$6 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "Initialize":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.optionFromJson(function(json) {
                    var match = Js_json.classify(json);
                    if (typeof match === "number") {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    if (match.TAG !== /* JSONArray */ 3) {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    var match$1 = match._0;
                    if (match$1.length !== 2) {
                        return Decco.error(undefined, "Incorrect cardinality", json);
                    }
                    var v0 = match$1[0];
                    var v1 = match$1[1];
                    var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(v0);
                    var match$3 = ExtensionMessaging$SmartcutsMacros.rejectToTab_decode(v1);
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: [
                                    match$2._0,
                                    match$3._0
                                ]
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[1]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Initialize */ 0,
                            _0: v0$5._0
                        }
                    };
                }
                var e$7 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "SharedEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_decode(decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SharedEvent */ 5,
                            _0: v0$6._0
                        }
                    };
                }
                var e$8 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "ShouldNotShowUserExplainHighlightModal":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ShouldNotShowUserExplainHighlightModal */ 2
                    };
                }
            case "UserDidSelectElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UserDidSelectElement */ 4,
                            _0: v0$7._0
                        }
                    };
                }
                var e$9 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match2 = Belt_Array.getExn(tagged, 0);
    if (typeof match2 !== "number" && match2.TAG === /* JSONString */ 0) {
        switch(match2._0){
            case "Dispatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v03 = event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v03.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Dispatch */ 0,
                            _0: v03._0
                        }
                    };
                }
                var e3 = v03._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e3.path,
                        message: e3.message,
                        value: e3.value
                    }
                };
            case "NotifyBgAboutPossibleCommand":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$14 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$23 = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$14.TAG === /* Ok */ 0) {
                    if (match$23.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* NotifyBgAboutPossibleCommand */ 2,
                                _0: match$14._0,
                                _1: match$23._0
                            }
                        };
                    }
                    var e$1 = match$23._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "RemoveRenderedContent":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemoveRenderedContent */ 4
                    };
                }
            case "RenderHighlightElementControl":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RenderHighlightElementControl */ 3
                    };
                }
            case "RenderModalToExplainHighlightElement":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RenderModalToExplainHighlightElement */ 2
                    };
                }
            case "ResetDebounceTimeout":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$31 = StateMachine__DebounceManager$SmartcutsMacros.uuid_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.timeoutId_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$31.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ResetDebounceTimeout */ 3,
                                _0: match$31._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$3 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$31._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "RespondToBg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.result_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RespondToBg */ 4,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$5 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "RetrievePossibleCommandInfoAndMaybeStreamToBg":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = retrieveCommandInfo_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$9 = extraInfoRetrieveCommandInfo_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        if (match$9.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* RetrievePossibleCommandInfoAndMaybeStreamToBg */ 6,
                                    _0: match$7._0,
                                    _1: match$8._0,
                                    _2: match$9._0
                                }
                            };
                        }
                        var e$7 = match$9._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$7.path,
                                message: e$7.message,
                                value: e$7.value
                            }
                        };
                    }
                    var e$8 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                        }
                    };
                }
                var e$9 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "SetupEventStreaming":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SetupEventStreaming */ 0
                    };
                }
            case "StreamCommandToBgForHighlightedElement":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$10 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
                var match$11 = HighlightElement__Shared$SmartcutsMacros.Callback.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$10.TAG === /* Ok */ 0) {
                    if (match$11.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* StreamCommandToBgForHighlightedElement */ 5,
                                _0: match$10._0,
                                _1: match$11._0
                            }
                        };
                    }
                    var e$10 = match$11._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$10.path,
                            message: e$10.message,
                            value: e$10.value
                        }
                    };
                }
                var e$11 = match$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "StreamCommandToBgToRecordIt":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$12 = Command$SmartcutsMacros.CommandWithContextLocal.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$13 = Decco.optionFromJson(function(json) {
                    var match = Js_json.classify(json);
                    if (typeof match === "number") {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    if (match.TAG !== /* JSONArray */ 3) {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    var match$1 = match._0;
                    if (match$1.length !== 2) {
                        return Decco.error(undefined, "Incorrect cardinality", json);
                    }
                    var v0 = match$1[0];
                    var v1 = match$1[1];
                    var match$2 = PendingCommandInfo$SmartcutsMacros.key_decode(v0);
                    var match$3 = Decco.intFromJson(v1);
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: [
                                    match$2._0,
                                    match$3._0
                                ]
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[1]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }, Belt_Array.getExn(jsonArr$1, 2));
                if (match$12.TAG === /* Ok */ 0) {
                    if (match$13.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* StreamCommandToBgToRecordIt */ 1,
                                _0: match$12._0,
                                _1: match$13._0
                            }
                        };
                    }
                    var e$12 = match$13._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                        }
                    };
                }
                var e$13 = match$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "TeardownEventStreaming":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TeardownEventStreaming */ 1
                    };
                }
            case "TellBgToStopHighlightingElement":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TellBgToStopHighlightingElement */ 5
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Exited":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                    return exitReason_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exited */ 3,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Exiting":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = exiting_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exiting */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "HighlightingElementWhileStreamingEventsToBg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = streamingState_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = HighlightElement__Shared$SmartcutsMacros.Callback.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* HighlightingElementWhileStreamingEventsToBg */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Init":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Init */ 0
                    };
                }
            case "SettingUpEventStreamingToBg":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SettingUpEventStreamingToBg */ 1
                    };
                }
            case "StreamingEventsToBg":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = streamingState_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* StreamingEventsToBg */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$4 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
function debounceStatusForExit_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AwaitingAllDebouncedEventsToFlush":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = streamingState_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AwaitingAllDebouncedEventsToFlush */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "FlushedAllDebouncedEvents":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FlushedAllDebouncedEvents */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function failure_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, function(param) {
        return state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return listener_decode(decoder_domEvent, param);
    }, otherFailureReason_decode, v);
}
var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
function extraInfoRetrieveCommandInfo_encode(v) {
    return Js_dict.fromArray([
        [
            "targetBoundingRect",
            Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v.targetBoundingRect)
        ],
        [
            "timestamp",
            Decco.floatToJson(v.timestamp)
        ],
        [
            "insertAfterOffset",
            Decco.intToJson(v.insertAfterOffset)
        ]
    ]);
}
function extraInfoRetrieveCommandInfo_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var targetBoundingRect = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRect"), null));
    if (targetBoundingRect.TAG === /* Ok */ 0) {
        var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
        if (timestamp.TAG === /* Ok */ 0) {
            var insertAfterOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "insertAfterOffset"), null));
            if (insertAfterOffset.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        targetBoundingRect: targetBoundingRect._0,
                        timestamp: timestamp._0,
                        insertAfterOffset: insertAfterOffset._0
                    }
                };
            }
            var e = insertAfterOffset._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".insertAfterOffset" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = timestamp._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".timestamp" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = targetBoundingRect._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".targetBoundingRect" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function failure_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, function(param) {
        return state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return listener_encode(encoder_domEvent, param);
    }, otherFailureReason_encode, v);
}
function debounceStatusForExit_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v) {
    if (v) {
        return [
            "AwaitingAllDebouncedEventsToFlush",
            streamingState_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v._0)
        ];
    } else {
        return [
            "FlushedAllDebouncedEvents"
        ];
    }
}
function errorContext_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, function(param) {
        return state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
    }, function(param) {
        return listener_encode(encoder_domEvent, param);
    }, v);
}
function errorContext_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, function(param) {
        return state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
    }, function(param) {
        return listener_decode(decoder_domEvent, param);
    }, v);
}
var Generic = {
    listener_encode: listener_encode,
    listener_decode: listener_decode,
    debounceFirstCallData_encode: debounceFirstCallData_encode,
    debounceFirstCallData_decode: debounceFirstCallData_decode,
    debounceManager_encode: debounceManager_encode,
    debounceManager_decode: debounceManager_decode,
    streamingState_encode: streamingState_encode,
    streamingState_decode: streamingState_decode,
    state_encode: state_encode,
    state_decode: state_decode,
    exiting_encode: exiting_encode,
    exiting_decode: exiting_decode,
    debounceStatusForExit_encode: debounceStatusForExit_encode,
    debounceStatusForExit_decode: debounceStatusForExit_decode,
    event_encode: event_encode,
    event_decode: event_decode,
    failure_encode: failure_encode,
    failure_decode: failure_decode,
    errorContext_encode: errorContext_encode,
    errorContext_decode: errorContext_decode,
    exitReason_encode: exitReason_encode,
    exitReason_decode: exitReason_decode,
    otherFailureReason_encode: otherFailureReason_encode,
    otherFailureReason_decode: otherFailureReason_decode,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode,
    extraInfoRetrieveCommandInfo_encode: extraInfoRetrieveCommandInfo_encode,
    extraInfoRetrieveCommandInfo_decode: extraInfoRetrieveCommandInfo_decode
};
var Regular = {};
function listener_encode$1(v) {
    return listener_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function listener_decode$1(v) {
    return listener_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
function state_encode$1(v) {
    return state_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}
function state_decode$1(v) {
    return state_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}
function event_encode$1(v) {
    return event_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}
function event_decode$1(v) {
    return event_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}
function sideEffect_encode$1(v) {
    return sideEffect_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}
function sideEffect_decode$1(v) {
    return sideEffect_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}
function failure_encode$1(v) {
    return failure_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}
function failure_decode$1(v) {
    return failure_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}
function errorContext_encode$1(v) {
    return errorContext_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}
function errorContext_decode$1(v) {
    return errorContext_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}
function exitReason_encode$1(v) {
    return exitReason_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}
function exitReason_decode$1(v) {
    return exitReason_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}
var otherFailureReason_encode$1 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
var otherFailureReason_decode$1 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
var ForSerialization = {
    listener_encode: listener_encode$1,
    listener_decode: listener_decode$1,
    state_encode: state_encode$1,
    state_decode: state_decode$1,
    event_encode: event_encode$1,
    event_decode: event_decode$1,
    sideEffect_encode: sideEffect_encode$1,
    sideEffect_decode: sideEffect_decode$1,
    failure_encode: failure_encode$1,
    failure_decode: failure_decode$1,
    errorContext_encode: errorContext_encode$1,
    errorContext_decode: errorContext_decode$1,
    exitReason_encode: exitReason_encode$1,
    exitReason_decode: exitReason_decode$1,
    otherFailureReason_encode: otherFailureReason_encode$1,
    otherFailureReason_decode: otherFailureReason_decode$1
};
exports.retrieveCommandInfo_encode = retrieveCommandInfo_encode;
exports.retrieveCommandInfo_decode = retrieveCommandInfo_decode;
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization; /* Rect-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 21370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var GoogleSheetTypes$SmartcutsMacros = __webpack_require__(25330);
var PendingCommandInfo$SmartcutsMacros = __webpack_require__(40099);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = __webpack_require__(26362);
function state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    if (typeof v === "number") {
        return [
            "Init"
        ];
    }
    switch(v.TAG | 0){
        case /* EditingGoogleSheets */ 0:
            return [
                "EditingGoogleSheets",
                editingGoogleSheets_encode(encoder_domEvent, v._0)
            ];
        case /* AwaitingPendingRequestsToFinishAndExit */ 1:
            return [
                "AwaitingPendingRequestsToFinishAndExit",
                editingGoogleSheets_encode(encoder_domEvent, v._0),
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                    return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                }, v._1)
            ];
        case /* Exiting */ 2:
            return [
                "Exiting",
                exiting_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* Exited */ 3:
            return [
                "Exited",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                    return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                }, v._0)
            ];
    }
}
function exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, function(param) {
        return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
function exiting_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
        return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict._0, "allExitReasons"), null));
    if (allExitReasons.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                allExitReasons: allExitReasons._0
            }
        };
    }
    var e = allExitReasons._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".allExitReasons" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function editingGoogleSheets_decode(decoder_domEvent, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheets = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheets"), null));
        if (sheets.TAG === /* Ok */ 0) {
            var editingInCell = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "editingInCell"), null));
            if (editingInCell.TAG === /* Ok */ 0) {
                var numPendingRequests = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPendingRequests"), null));
                if (numPendingRequests.TAG === /* Ok */ 0) {
                    var disconnectMutationObserver = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "disconnectMutationObserver"), null));
                    if (disconnectMutationObserver.TAG === /* Ok */ 0) {
                        var stopListeningToCanvas = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stopListeningToCanvas"), null));
                        if (stopListeningToCanvas.TAG === /* Ok */ 0) {
                            var expectPaste = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectPaste"), null));
                            if (expectPaste.TAG === /* Ok */ 0) {
                                var googleAuthCallback = Decco.optionFromJson(function(param) {
                                    return googleAuthCallback_decode(decoder_domEvent, param);
                                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "googleAuthCallback"), null));
                                if (googleAuthCallback.TAG === /* Ok */ 0) {
                                    var removeListenersPreventingUserInteraction = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "removeListenersPreventingUserInteraction"), null));
                                    if (removeListenersPreventingUserInteraction.TAG === /* Ok */ 0) {
                                        var sheetUpdateTriggerCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetUpdateTriggerCount"), null));
                                        if (sheetUpdateTriggerCount.TAG === /* Ok */ 0) {
                                            var mostRecentTriggerThatReceivedSheetUpdate = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mostRecentTriggerThatReceivedSheetUpdate"), null));
                                            if (mostRecentTriggerThatReceivedSheetUpdate.TAG === /* Ok */ 0) {
                                                var rectForCommandKey = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rectForCommandKey"), null));
                                                if (rectForCommandKey.TAG === /* Ok */ 0) {
                                                    var expectCellValue = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectCellValue"), null));
                                                    if (expectCellValue.TAG === /* Ok */ 0) {
                                                        var pendingCommandKey = Decco.optionFromJson(PendingCommandInfo$SmartcutsMacros.key_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pendingCommandKey"), null));
                                                        if (pendingCommandKey.TAG === /* Ok */ 0) {
                                                            return {
                                                                TAG: /* Ok */ 0,
                                                                _0: {
                                                                    spreadsheetId: spreadsheetId._0,
                                                                    sheets: sheets._0,
                                                                    editingInCell: editingInCell._0,
                                                                    numPendingRequests: numPendingRequests._0,
                                                                    disconnectMutationObserver: disconnectMutationObserver._0,
                                                                    stopListeningToCanvas: stopListeningToCanvas._0,
                                                                    expectPaste: expectPaste._0,
                                                                    googleAuthCallback: googleAuthCallback._0,
                                                                    removeListenersPreventingUserInteraction: removeListenersPreventingUserInteraction._0,
                                                                    sheetUpdateTriggerCount: sheetUpdateTriggerCount._0,
                                                                    mostRecentTriggerThatReceivedSheetUpdate: mostRecentTriggerThatReceivedSheetUpdate._0,
                                                                    rectForCommandKey: rectForCommandKey._0,
                                                                    expectCellValue: expectCellValue._0,
                                                                    pendingCommandKey: pendingCommandKey._0
                                                                }
                                                            };
                                                        }
                                                        var e = pendingCommandKey._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".pendingCommandKey" + e.path,
                                                                message: e.message,
                                                                value: e.value
                                                            }
                                                        };
                                                    }
                                                    var e$1 = expectCellValue._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".expectCellValue" + e$1.path,
                                                            message: e$1.message,
                                                            value: e$1.value
                                                        }
                                                    };
                                                }
                                                var e$2 = rectForCommandKey._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".rectForCommandKey" + e$2.path,
                                                        message: e$2.message,
                                                        value: e$2.value
                                                    }
                                                };
                                            }
                                            var e$3 = mostRecentTriggerThatReceivedSheetUpdate._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".mostRecentTriggerThatReceivedSheetUpdate" + e$3.path,
                                                    message: e$3.message,
                                                    value: e$3.value
                                                }
                                            };
                                        }
                                        var e$4 = sheetUpdateTriggerCount._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".sheetUpdateTriggerCount" + e$4.path,
                                                message: e$4.message,
                                                value: e$4.value
                                            }
                                        };
                                    }
                                    var e$5 = removeListenersPreventingUserInteraction._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".removeListenersPreventingUserInteraction" + e$5.path,
                                            message: e$5.message,
                                            value: e$5.value
                                        }
                                    };
                                }
                                var e$6 = googleAuthCallback._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".googleAuthCallback" + e$6.path,
                                        message: e$6.message,
                                        value: e$6.value
                                    }
                                };
                            }
                            var e$7 = expectPaste._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".expectPaste" + e$7.path,
                                    message: e$7.message,
                                    value: e$7.value
                                }
                            };
                        }
                        var e$8 = stopListeningToCanvas._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".stopListeningToCanvas" + e$8.path,
                                message: e$8.message,
                                value: e$8.value
                            }
                        };
                    }
                    var e$9 = disconnectMutationObserver._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".disconnectMutationObserver" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = numPendingRequests._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".numPendingRequests" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            }
            var e$11 = editingInCell._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".editingInCell" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                }
            };
        }
        var e$12 = sheets._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheets" + e$12.path,
                message: e$12.message,
                value: e$12.value
            }
        };
    }
    var e$13 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$13.path,
            message: e$13.message,
            value: e$13.value
        }
    };
}
function reasonToCheckUpdate_decode(decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ChangeEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ChangeEvent */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "EditingCellChanged":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* EditingCellChanged */ 0
                    };
                }
            case "PasteEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasteEvent */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "PastedText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PastedText */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    if (typeof v === "number") {
        if (v === /* Initialize */ 0) {
            return [
                "Initialize"
            ];
        } else {
            return [
                "DiscoveredGapiNotLoaded"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* SharedEvent */ 0:
            return [
                "SharedEvent",
                ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_encode(encoder_domHtmlElement, encoder_domEvent, v._0)
            ];
        case /* BasicEventOnGoogleSheets */ 1:
            return [
                "BasicEventOnGoogleSheets",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
            ];
        case /* DidPreventUserInteraction */ 2:
            return [
                "DidPreventUserInteraction",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
            ];
        case /* DidAttachMutationObserver */ 3:
            return [
                "DidAttachMutationObserver",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
            ];
        case /* MutationsObserved */ 4:
            return [
                "MutationsObserved",
                Decco.arrayToJson(encoder_domMutationRecord, v._0)
            ];
        case /* DidStartListeningToCanvas */ 5:
            return [
                "DidStartListeningToCanvas",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
            ];
        case /* CanvasDidFillText */ 6:
            return [
                "CanvasDidFillText",
                Decco.stringToJson(v._0),
                Decco.intToJson(v._1),
                Decco.intToJson(v._2),
                Curry._1(encoder_domHtmlElement, v._3)
            ];
        case /* DiscoveredGoogleAuthMissing */ 7:
            return [
                "DiscoveredGoogleAuthMissing",
                googleAuthCallback_encode(encoder_domEvent, v._0)
            ];
        case /* DidGetNewAuthToken */ 8:
            return [
                "DidGetNewAuthToken",
                Decco.stringToJson(v._0)
            ];
        case /* DidFetchGoogleSheet */ 9:
            return [
                "DidFetchGoogleSheet",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_encode, v._0)
            ];
        case /* GoogleSheetUpdate */ 10:
            return [
                "GoogleSheetUpdate",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_encode, v._0),
                reasonToCheckUpdate_encode(encoder_domEvent, v._1),
                PendingCommandInfo$SmartcutsMacros.key_encode(v._2),
                Decco.intToJson(v._3),
                Decco.intToJson(v._4)
            ];
        case /* Fail */ 11:
            return [
                "Fail",
                failure_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* Exit */ 12:
            return [
                "Exit",
                exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
    }
}
function listener_encode(encoder_domMutationRecord, v) {
    if (v) {
        return [
            "GoogleSheetsMutationObserverListener",
            Decco.arrayToJson(encoder_domMutationRecord, v._0)
        ];
    } else {
        return [
            "CanvasListener"
        ];
    }
}
function sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    if (typeof v === "number") {
        switch(v){
            case /* PreventUserInteraction */ 0:
                return [
                    "PreventUserInteraction"
                ];
            case /* StartGoogleAuthFlow */ 1:
                return [
                    "StartGoogleAuthFlow"
                ];
            case /* StartListeningToCanvas */ 2:
                return [
                    "StartListeningToCanvas"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* Dispatch */ 0:
                return [
                    "Dispatch",
                    event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
                ];
            case /* AllowUserInteraction */ 1:
                return [
                    "AllowUserInteraction",
                    DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
            case /* FetchGoogleSheetData */ 2:
                return [
                    "FetchGoogleSheetData",
                    Decco.stringToJson(v._0),
                    Decco.optionToJson(Decco.stringToJson, v._1)
                ];
            case /* SetupMutationObserver */ 3:
                return [
                    "SetupMutationObserver",
                    Curry._1(encoder_domHtmlElement, v._0)
                ];
            case /* NotifyBgAboutPossibleCommand */ 4:
                return [
                    "NotifyBgAboutPossibleCommand",
                    PendingCommandInfo$SmartcutsMacros.key_encode(v._0),
                    Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v._1)
                ];
            case /* CheckForGoogleSheetUpdates */ 5:
                return [
                    "CheckForGoogleSheetUpdates",
                    Decco.stringToJson(v._0),
                    reasonToCheckUpdate_encode(encoder_domEvent, v._1),
                    Decco.optionToJson(Decco.stringToJson, v._2),
                    PendingCommandInfo$SmartcutsMacros.key_encode(v._3),
                    Decco.intToJson(v._4),
                    Decco.intToJson(v._5)
                ];
            case /* StreamGoogleSheetsCommandsToBg */ 6:
                var v2 = v._2;
                return [
                    "StreamGoogleSheetsCommandsToBg",
                    Decco.listToJson(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.t_encode, v._0),
                    CommandContext$SmartcutsMacros.commandContextLocal_encode(v._1),
                    [
                        PendingCommandInfo$SmartcutsMacros.key_encode(v2[0]),
                        Decco.intToJson(v2[1])
                    ]
                ];
            case /* TellBgThatKeyDoesNotGenerateCommand */ 7:
                return [
                    "TellBgThatKeyDoesNotGenerateCommand",
                    PendingCommandInfo$SmartcutsMacros.key_encode(v._0)
                ];
            case /* DisconnectMutationObserver */ 8:
                return [
                    "DisconnectMutationObserver",
                    DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
            case /* StopListeningToCanvas */ 9:
                return [
                    "StopListeningToCanvas",
                    DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
        }
    }
}
function googleAuthCallback_encode(encoder_domEvent, v) {
    if (v.TAG === /* Cb_FetchGoogleSheetData */ 0) {
        return [
            "Cb_FetchGoogleSheetData",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "Cb_CheckForGoogleSheetUpdates",
            Decco.stringToJson(v._0),
            reasonToCheckUpdate_encode(encoder_domEvent, v._1),
            PendingCommandInfo$SmartcutsMacros.key_encode(v._2),
            Decco.intToJson(v._3)
        ];
    }
}
function reasonToCheckUpdate_encode(encoder_domEvent, v) {
    if (typeof v === "number") {
        return [
            "EditingCellChanged"
        ];
    }
    switch(v.TAG | 0){
        case /* PastedText */ 0:
            return [
                "PastedText",
                Decco.stringToJson(v._0)
            ];
        case /* PasteEvent */ 1:
            return [
                "PasteEvent",
                Curry._1(encoder_domEvent, v._0)
            ];
        case /* ChangeEvent */ 2:
            return [
                "ChangeEvent",
                Decco.stringToJson(v._0)
            ];
    }
}
function exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, function(param) {
        return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return listener_encode(encoder_domMutationRecord, param);
    }, otherFailureReason_encode, v);
}
function state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AwaitingPendingRequestsToFinishAndExit":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = editingGoogleSheets_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                    return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
                }, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* AwaitingPendingRequestsToFinishAndExit */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "EditingGoogleSheets":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = editingGoogleSheets_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* EditingGoogleSheets */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Exited":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                    return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exited */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$3 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Exiting":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = exiting_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exiting */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$4 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "Init":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Init */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
function listener_decode(decoder_domMutationRecord, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CanvasListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CanvasListener */ 0
                    };
                }
            case "GoogleSheetsMutationObserverListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.arrayFromJson(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* GoogleSheetsMutationObserverListener */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BasicEventOnGoogleSheets":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BasicEventOnGoogleSheets */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CanvasDidFillText":
                if (tagged.length !== 5) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 3));
                var match$4 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 4));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            if (match$4.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        TAG: /* CanvasDidFillText */ 6,
                                        _0: match$1._0,
                                        _1: match$2._0,
                                        _2: match$3._0,
                                        _3: match$4._0
                                    }
                                };
                            }
                            var e$1 = match$4._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[3]" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "DidAttachMutationObserver":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidAttachMutationObserver */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$5 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "DidFetchGoogleSheet":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidFetchGoogleSheet */ 9,
                            _0: v0$2._0
                        }
                    };
                }
                var e$6 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "DidGetNewAuthToken":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidGetNewAuthToken */ 8,
                            _0: v0$3._0
                        }
                    };
                }
                var e$7 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "DidPreventUserInteraction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidPreventUserInteraction */ 2,
                            _0: v0$4._0
                        }
                    };
                }
                var e$8 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "DidStartListeningToCanvas":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidStartListeningToCanvas */ 5,
                            _0: v0$5._0
                        }
                    };
                }
                var e$9 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "DiscoveredGapiNotLoaded":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DiscoveredGapiNotLoaded */ 1
                    };
                }
            case "DiscoveredGoogleAuthMissing":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = googleAuthCallback_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DiscoveredGoogleAuthMissing */ 7,
                            _0: v0$6._0
                        }
                    };
                }
                var e$10 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exit */ 12,
                            _0: v0$7._0
                        }
                    };
                }
                var e$11 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "Fail":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = failure_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Fail */ 11,
                            _0: v0$8._0
                        }
                    };
                }
                var e$12 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "GoogleSheetUpdate":
                if (tagged.length !== 6) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = reasonToCheckUpdate_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 2));
                var match$7 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 3));
                var match$8 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 4));
                var match$9 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 5));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        if (match$7.TAG === /* Ok */ 0) {
                            if (match$8.TAG === /* Ok */ 0) {
                                if (match$9.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            TAG: /* GoogleSheetUpdate */ 10,
                                            _0: match$5._0,
                                            _1: match$6._0,
                                            _2: match$7._0,
                                            _3: match$8._0,
                                            _4: match$9._0
                                        }
                                    };
                                }
                                var e$13 = match$9._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[4]" + e$13.path,
                                        message: e$13.message,
                                        value: e$13.value
                                    }
                                };
                            }
                            var e$14 = match$8._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[3]" + e$14.path,
                                    message: e$14.message,
                                    value: e$14.value
                                }
                            };
                        }
                        var e$15 = match$7._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$15.path,
                                message: e$15.message,
                                value: e$15.value
                            }
                        };
                    }
                    var e$16 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$16.path,
                            message: e$16.message,
                            value: e$16.value
                        }
                    };
                }
                var e$17 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "Initialize":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Initialize */ 0
                    };
                }
            case "MutationsObserved":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = Decco.arrayFromJson(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MutationsObserved */ 4,
                            _0: v0$9._0
                        }
                    };
                }
                var e$18 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "SharedEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_decode(decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SharedEvent */ 0,
                            _0: v0$10._0
                        }
                    };
                }
                var e$19 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AllowUserInteraction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AllowUserInteraction */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CheckForGoogleSheetUpdates":
                if (tagged.length !== 7) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = reasonToCheckUpdate_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = Decco.optionFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 3));
                var match$4 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 4));
                var match$5 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 5));
                var match$6 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 6));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            if (match$4.TAG === /* Ok */ 0) {
                                if (match$5.TAG === /* Ok */ 0) {
                                    if (match$6.TAG === /* Ok */ 0) {
                                        return {
                                            TAG: /* Ok */ 0,
                                            _0: {
                                                TAG: /* CheckForGoogleSheetUpdates */ 5,
                                                _0: match$1._0,
                                                _1: match$2._0,
                                                _2: match$3._0,
                                                _3: match$4._0,
                                                _4: match$5._0,
                                                _5: match$6._0
                                            }
                                        };
                                    }
                                    var e$1 = match$6._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: "[5]" + e$1.path,
                                            message: e$1.message,
                                            value: e$1.value
                                        }
                                    };
                                }
                                var e$2 = match$5._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[4]" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                    }
                                };
                            }
                            var e$3 = match$4._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[3]" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                }
                            };
                        }
                        var e$4 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "DisconnectMutationObserver":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DisconnectMutationObserver */ 8,
                            _0: v0$1._0
                        }
                    };
                }
                var e$7 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "Dispatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Dispatch */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$8 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "FetchGoogleSheetData":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = Decco.optionFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 2));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FetchGoogleSheetData */ 2,
                                _0: match$7._0,
                                _1: match$8._0
                            }
                        };
                    }
                    var e$9 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "NotifyBgAboutPossibleCommand":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$9 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$10 = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$9.TAG === /* Ok */ 0) {
                    if (match$10.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* NotifyBgAboutPossibleCommand */ 4,
                                _0: match$9._0,
                                _1: match$10._0
                            }
                        };
                    }
                    var e$11 = match$10._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                        }
                    };
                }
                var e$12 = match$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "PreventUserInteraction":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PreventUserInteraction */ 0
                    };
                }
            case "SetupMutationObserver":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SetupMutationObserver */ 3,
                            _0: v0$3._0
                        }
                    };
                }
                var e$13 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "StartGoogleAuthFlow":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* StartGoogleAuthFlow */ 1
                    };
                }
            case "StartListeningToCanvas":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* StartListeningToCanvas */ 2
                    };
                }
            case "StopListeningToCanvas":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* StopListeningToCanvas */ 9,
                            _0: v0$4._0
                        }
                    };
                }
                var e$14 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "StreamGoogleSheetsCommandsToBg":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$11 = Decco.listFromJson(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                var match$12 = CommandContext$SmartcutsMacros.commandContextLocal_decode(Belt_Array.getExn(jsonArr$1, 2));
                var json = Belt_Array.getExn(jsonArr$1, 3);
                var match$13 = Js_json.classify(json);
                var match$14;
                if (typeof match$13 === "number" || match$13.TAG !== /* JSONArray */ 3) {
                    match$14 = Decco.error(undefined, "Not a tuple", json);
                } else {
                    var match$15 = match$13._0;
                    if (match$15.length !== 2) {
                        match$14 = Decco.error(undefined, "Incorrect cardinality", json);
                    } else {
                        var v0$5 = match$15[0];
                        var v1 = match$15[1];
                        var match$16 = PendingCommandInfo$SmartcutsMacros.key_decode(v0$5);
                        var match$17 = Decco.intFromJson(v1);
                        if (match$16.TAG === /* Ok */ 0) {
                            if (match$17.TAG === /* Ok */ 0) {
                                match$14 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$16._0,
                                        match$17._0
                                    ]
                                };
                            } else {
                                var e$15 = match$17._0;
                                match$14 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$15.path,
                                        message: e$15.message,
                                        value: e$15.value
                                    }
                                };
                            }
                        } else {
                            var e$16 = match$16._0;
                            match$14 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$16.path,
                                    message: e$16.message,
                                    value: e$16.value
                                }
                            };
                        }
                    }
                }
                if (match$11.TAG === /* Ok */ 0) {
                    if (match$12.TAG === /* Ok */ 0) {
                        if (match$14.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* StreamGoogleSheetsCommandsToBg */ 6,
                                    _0: match$11._0,
                                    _1: match$12._0,
                                    _2: match$14._0
                                }
                            };
                        }
                        var e$17 = match$14._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$17.path,
                                message: e$17.message,
                                value: e$17.value
                            }
                        };
                    }
                    var e$18 = match$12._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$18.path,
                            message: e$18.message,
                            value: e$18.value
                        }
                    };
                }
                var e$19 = match$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "TellBgThatKeyDoesNotGenerateCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TellBgThatKeyDoesNotGenerateCommand */ 7,
                            _0: v0$6._0
                        }
                    };
                }
                var e$20 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function googleAuthCallback_decode(decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Cb_CheckForGoogleSheetUpdates":
                if (tagged.length !== 5) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = reasonToCheckUpdate_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 3));
                var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 4));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            if (match$4.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        TAG: /* Cb_CheckForGoogleSheetUpdates */ 1,
                                        _0: match$1._0,
                                        _1: match$2._0,
                                        _2: match$3._0,
                                        _3: match$4._0
                                    }
                                };
                            }
                            var e = match$4._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[3]" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Cb_FetchGoogleSheetData":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Cb_FetchGoogleSheetData */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$4 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function failure_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, function(param) {
        return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return listener_encode(encoder_domMutationRecord, param);
    }, otherFailureReason_encode, v);
}
function failure_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, function(param) {
        return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
function exiting_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    return Js_dict.fromArray([
        [
            "allExitReasons",
            Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
            }, v.allExitReasons)
        ]
    ]);
}
function editingGoogleSheets_encode(encoder_domEvent, v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheets",
            Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Worksheet.t_encode, v.sheets)
        ],
        [
            "editingInCell",
            Decco.optionToJson(Decco.stringToJson, v.editingInCell)
        ],
        [
            "numPendingRequests",
            Decco.intToJson(v.numPendingRequests)
        ],
        [
            "disconnectMutationObserver",
            Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.disconnectMutationObserver)
        ],
        [
            "stopListeningToCanvas",
            Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.stopListeningToCanvas)
        ],
        [
            "expectPaste",
            Decco.optionToJson(Decco.stringToJson, v.expectPaste)
        ],
        [
            "googleAuthCallback",
            Decco.optionToJson(function(param) {
                return googleAuthCallback_encode(encoder_domEvent, param);
            }, v.googleAuthCallback)
        ],
        [
            "removeListenersPreventingUserInteraction",
            Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.removeListenersPreventingUserInteraction)
        ],
        [
            "sheetUpdateTriggerCount",
            Decco.intToJson(v.sheetUpdateTriggerCount)
        ],
        [
            "mostRecentTriggerThatReceivedSheetUpdate",
            Decco.optionToJson(Decco.intToJson, v.mostRecentTriggerThatReceivedSheetUpdate)
        ],
        [
            "rectForCommandKey",
            CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(Rect$SmartcutsMacros.t_encode, v.rectForCommandKey)
        ],
        [
            "expectCellValue",
            Decco.optionToJson(Decco.stringToJson, v.expectCellValue)
        ],
        [
            "pendingCommandKey",
            Decco.optionToJson(PendingCommandInfo$SmartcutsMacros.key_encode, v.pendingCommandKey)
        ]
    ]);
}
var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
function errorContext_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, function(param) {
        return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
    }, function(param) {
        return listener_encode(encoder_domMutationRecord, param);
    }, v);
}
function errorContext_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, function(param) {
        return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
    }, function(param) {
        return listener_decode(decoder_domMutationRecord, param);
    }, v);
}
var Generic = {
    state_encode: state_encode,
    state_decode: state_decode,
    googleAuthCallback_encode: googleAuthCallback_encode,
    googleAuthCallback_decode: googleAuthCallback_decode,
    editingGoogleSheets_encode: editingGoogleSheets_encode,
    editingGoogleSheets_decode: editingGoogleSheets_decode,
    exiting_encode: exiting_encode,
    exiting_decode: exiting_decode,
    event_encode: event_encode,
    event_decode: event_decode,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode,
    reasonToCheckUpdate_encode: reasonToCheckUpdate_encode,
    reasonToCheckUpdate_decode: reasonToCheckUpdate_decode,
    listener_encode: listener_encode,
    listener_decode: listener_decode,
    failure_encode: failure_encode,
    failure_decode: failure_decode,
    otherFailureReason_encode: otherFailureReason_encode,
    otherFailureReason_decode: otherFailureReason_decode,
    errorContext_encode: errorContext_encode,
    errorContext_decode: errorContext_decode,
    exitReason_encode: exitReason_encode,
    exitReason_decode: exitReason_decode
};
var Regular = {};
var ForSerialization = {};
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization; /* Rect-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 26362:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
function contentDiff_encode(encoder_domHtmlElement, v) {
    return Js_dict.fromArray([
        [
            "contentEditableHost",
            Curry._1(encoder_domHtmlElement, v.contentEditableHost)
        ],
        [
            "lastValue",
            Decco.stringToJson(v.lastValue)
        ],
        [
            "newValue",
            Decco.stringToJson(v.newValue)
        ],
        [
            "timestamp",
            Decco.floatToJson(v.timestamp)
        ]
    ]);
}
function contentDiff_decode(decoder_domHtmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var contentEditableHost = Curry._1(decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditableHost"), null));
    if (contentEditableHost.TAG === /* Ok */ 0) {
        var lastValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastValue"), null));
        if (lastValue.TAG === /* Ok */ 0) {
            var newValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "newValue"), null));
            if (newValue.TAG === /* Ok */ 0) {
                var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
                if (timestamp.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            contentEditableHost: contentEditableHost._0,
                            lastValue: lastValue._0,
                            newValue: newValue._0,
                            timestamp: timestamp._0
                        }
                    };
                }
                var e = timestamp._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".timestamp" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = newValue._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".newValue" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = lastValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".lastValue" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = contentEditableHost._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".contentEditableHost" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function event_encode(encoder_domHtmlElement, encoder_domEvent, v) {
    if (typeof v === "number") {
        return [
            "ParentDidAskChildToExit"
        ];
    } else if (v.TAG === /* ContentDiff */ 0) {
        return [
            "ContentDiff",
            contentDiff_encode(encoder_domHtmlElement, v._0)
        ];
    } else {
        return [
            "EventTransported",
            Curry._1(encoder_domEvent, v._0),
            Decco.floatToJson(v._1)
        ];
    }
}
function event_decode(decoder_domHtmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentDiff":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = contentDiff_decode(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentDiff */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "EventTransported":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* EventTransported */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "ParentDidAskChildToExit":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ParentDidAskChildToExit */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyContentDiff(stringifyDomHtmlElement, param) {
    return "{contentEditableHost: " + (Curry._1(stringifyDomHtmlElement, param.contentEditableHost) + (", lastValue: " + (param.lastValue + (", newValue: " + (param.newValue + (", timstamp: " + (param.timestamp.toString() + "}")))))));
}
function mapContentDiff(mapDomHtmlElement, param) {
    return {
        contentEditableHost: Curry._1(mapDomHtmlElement, param.contentEditableHost),
        lastValue: param.lastValue,
        newValue: param.newValue,
        timestamp: param.timestamp
    };
}
function stringifyEvent(stringifyDomHtmlElement, stringifyDomEvent, $$event) {
    if (typeof $$event === "number") {
        return "ParentDidAskChildToExit";
    } else if ($$event.TAG === /* ContentDiff */ 0) {
        return "ContentDiff(" + (stringifyContentDiff(stringifyDomHtmlElement, $$event._0) + ")");
    } else {
        return "EventTransported(event=" + (Curry._1(stringifyDomEvent, $$event._0) + (", timestamp=" + ($$event._1.toString() + ")")));
    }
}
function mapEvent(mapDomHtmlElement, mapDomEvent, $$event) {
    if (typeof $$event === "number") {
        return /* ParentDidAskChildToExit */ 0;
    } else if ($$event.TAG === /* ContentDiff */ 0) {
        return {
            TAG: /* ContentDiff */ 0,
            _0: mapContentDiff(mapDomHtmlElement, $$event._0)
        };
    } else {
        return {
            TAG: /* EventTransported */ 1,
            _0: Curry._1(mapDomEvent, $$event._0),
            _1: $$event._1
        };
    }
}
function extractRespondToBgFromEvent(v) {}
var domElementIdentifierGenerator = DomElementIdentifierGenerator$SmartcutsMacros.make(undefined);
exports.contentDiff_encode = contentDiff_encode;
exports.contentDiff_decode = contentDiff_decode;
exports.event_encode = event_encode;
exports.event_decode = event_decode;
exports.stringifyContentDiff = stringifyContentDiff;
exports.mapContentDiff = mapContentDiff;
exports.stringifyEvent = stringifyEvent;
exports.mapEvent = mapEvent;
exports.extractRespondToBgFromEvent = extractRespondToBgFromEvent;
exports.domElementIdentifierGenerator = domElementIdentifierGenerator; /* domElementIdentifierGenerator Not a pure module */ 


/***/ }),

/***/ 98519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var DOM__Node$SmartcutsMacros = __webpack_require__(73466);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var SideEffectGroup$SmartcutsMacros = __webpack_require__(42798);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var ExtensionMessaging$SmartcutsMacros = __webpack_require__(31052);
var Virtualized__InputMaps$SmartcutsMacros = __webpack_require__(23676);
var DOM__Event__ForSerialization$SmartcutsMacros = __webpack_require__(54179);
var ExtensionMessaging__FromExtension$SmartcutsMacros = __webpack_require__(15462);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = __webpack_require__(26362);
var ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros = __webpack_require__(21370);
var ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros = __webpack_require__(3183);
var ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros = __webpack_require__(4738);
function listener_encode(encoder_domEvent, encoder_domMutationRecord, v) {
    if (typeof v === "number") {
        return [
            "NoListener"
        ];
    }
    switch(v.TAG | 0){
        case /* EventStreamingListener */ 0:
            return [
                "EventStreamingListener",
                ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros.Generic.listener_encode(encoder_domEvent, v._0)
            ];
        case /* ContentEditingListener */ 1:
            return [
                "ContentEditingListener",
                ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros.Generic.listener_encode(encoder_domMutationRecord, v._0)
            ];
        case /* GoogleSheetsListener */ 2:
            return [
                "GoogleSheetsListener",
                ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros.Generic.listener_encode(encoder_domMutationRecord, v._0)
            ];
    }
}
function listener_decode(decoder_domEvent, decoder_domMutationRecord, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentEditingListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros.Generic.listener_decode(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentEditingListener */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "EventStreamingListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros.Generic.listener_decode(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* EventStreamingListener */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "GoogleSheetsListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros.Generic.listener_decode(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GoogleSheetsListener */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "NoListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoListener */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
function parallelStates_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v) {
    return Js_dict.fromArray([
        [
            "eventStreaming",
            ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros.Generic.state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v.eventStreaming)
        ],
        [
            "contentEditing",
            ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros.Generic.state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v.contentEditing)
        ],
        [
            "googleSheets",
            ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros.Generic.state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v.googleSheets)
        ]
    ]);
}
function parallelStates_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var eventStreaming = ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros.Generic.state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventStreaming"), null));
    if (eventStreaming.TAG === /* Ok */ 0) {
        var contentEditing = ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros.Generic.state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditing"), null));
        if (contentEditing.TAG === /* Ok */ 0) {
            var googleSheets = ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros.Generic.state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "googleSheets"), null));
            if (googleSheets.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        eventStreaming: eventStreaming._0,
                        contentEditing: contentEditing._0,
                        googleSheets: googleSheets._0
                    }
                };
            }
            var e = googleSheets._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".googleSheets" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = contentEditing._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".contentEditing" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = eventStreaming._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".eventStreaming" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function state_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v) {
    switch(v.TAG | 0){
        case /* Init */ 0:
            return [
                "Init",
                parallelStates_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v._0)
            ];
        case /* Parallel */ 1:
            return [
                "Parallel",
                parallelStates_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v._0)
            ];
        case /* Exiting */ 2:
            return [
                "Exiting",
                exiting_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v._0)
            ];
    }
}
function exitReason_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, function(param) {
        return state_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return event_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return sideEffect_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return listener_decode(decoder_domEvent, decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
function failure_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, function(param) {
        return state_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return event_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return sideEffect_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return listener_decode(decoder_domEvent, decoder_domMutationRecord, param);
    }, otherFailureReason_decode, v);
}
function event_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v) {
    switch(v.TAG | 0){
        case /* Initialize */ 0:
            return [
                "Initialize",
                Decco.optionToJson(function(param) {
                    return [
                        ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(param[0]),
                        ExtensionMessaging$SmartcutsMacros.rejectToTab_encode(param[1])
                    ];
                }, v._0)
            ];
        case /* SharedEvent */ 1:
            return [
                "SharedEvent",
                ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_encode(encoder_domHtmlElement, encoder_domEvent, v._0)
            ];
        case /* BasicEventWhileRecording */ 2:
            return [
                "BasicEventWhileRecording",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
            ];
        case /* EventStreamingEvent */ 3:
            return [
                "EventStreamingEvent",
                ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros.Generic.event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
            ];
        case /* ContentEditingEvent */ 4:
            return [
                "ContentEditingEvent",
                ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros.Generic.event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* GoogleSheetsEvent */ 5:
            return [
                "GoogleSheetsEvent",
                ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros.Generic.event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
            ];
        case /* Fail */ 6:
            return [
                "Fail",
                failure_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v._0)
            ];
        case /* Exit */ 7:
            return [
                "Exit",
                exitReason_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v._0)
            ];
    }
}
function sideEffect_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v) {
    switch(v.TAG | 0){
        case /* Dispatch */ 0:
            return [
                "Dispatch",
                event_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v._0)
            ];
        case /* EventStreamingSideEffect */ 1:
            return [
                "EventStreamingSideEffect",
                SideEffectGroup$SmartcutsMacros.List.sideEffectGroup_encode(function(param) {
                    return ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
                }, v._0)
            ];
        case /* ContentEditingSideEffect */ 2:
            return [
                "ContentEditingSideEffect",
                SideEffectGroup$SmartcutsMacros.List.sideEffectGroup_encode(function(param) {
                    return ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                }, v._0)
            ];
        case /* GoogleSheetsSideEffect */ 3:
            return [
                "GoogleSheetsSideEffect",
                SideEffectGroup$SmartcutsMacros.List.sideEffectGroup_encode(function(param) {
                    return ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                }, v._0)
            ];
        case /* RespondToBg */ 4:
            return [
                "RespondToBg",
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.result_encode(v._1)
            ];
    }
}
function exitReason_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, function(param) {
        return state_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return event_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return sideEffect_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return listener_encode(encoder_domEvent, encoder_domMutationRecord, param);
    }, otherFailureReason_encode, v);
}
function state_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Exiting":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = exiting_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exiting */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Init":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = parallelStates_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Init */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Parallel":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = parallelStates_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Parallel */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function event_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match1 = Belt_Array.getExn(tagged, 0);
    if (typeof match1 !== "number" && match1.TAG === /* JSONString */ 0) {
        switch(match1._0){
            case "BasicEventWhileRecording":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v01 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v01.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BasicEventWhileRecording */ 2,
                            _0: v01._0
                        }
                    };
                }
                var e1 = v01._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e1.path,
                        message: e1.message,
                        value: e1.value
                    }
                };
            case "ContentEditingEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros.Generic.event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentEditingEvent */ 4,
                            _0: v0$1._0
                        }
                    };
                }
                var e$11 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "EventStreamingEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros.Generic.event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* EventStreamingEvent */ 3,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = exitReason_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exit */ 7,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Fail":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = failure_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Fail */ 6,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "GoogleSheetsEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros.Generic.event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GoogleSheetsEvent */ 5,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "Initialize":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = Decco.optionFromJson(function(json) {
                    var match = Js_json.classify(json);
                    if (typeof match === "number") {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    if (match.TAG !== /* JSONArray */ 3) {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    var match$1 = match._0;
                    if (match$1.length !== 2) {
                        return Decco.error(undefined, "Incorrect cardinality", json);
                    }
                    var v0 = match$1[0];
                    var v1 = match$1[1];
                    var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(v0);
                    var match$3 = ExtensionMessaging$SmartcutsMacros.rejectToTab_decode(v1);
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: [
                                    match$2._0,
                                    match$3._0
                                ]
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[1]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Initialize */ 0,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "SharedEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_decode(decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SharedEvent */ 1,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function sideEffect_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentEditingSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SideEffectGroup$SmartcutsMacros.List.sideEffectGroup_decode(function(param) {
                    return ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentEditingSideEffect */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Dispatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = event_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Dispatch */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "EventStreamingSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = SideEffectGroup$SmartcutsMacros.List.sideEffectGroup_decode(function(param) {
                    return ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* EventStreamingSideEffect */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "GoogleSheetsSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = SideEffectGroup$SmartcutsMacros.List.sideEffectGroup_decode(function(param) {
                    return ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GoogleSheetsSideEffect */ 3,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "RespondToBg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.result_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RespondToBg */ 4,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$4 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function exiting_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var parallelStates = parallelStates_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, Belt_Option.getWithDefault(Js_dict.get(dict$1, "parallelStates"), null));
    if (parallelStates.TAG === /* Ok */ 0) {
        var maybeRespondToBgWithResult = Decco.optionFromJson(function(json) {
            var match = Js_json.classify(json);
            if (typeof match === "number") {
                return Decco.error(undefined, "Not a tuple", json);
            }
            if (match.TAG !== /* JSONArray */ 3) {
                return Decco.error(undefined, "Not a tuple", json);
            }
            var match$1 = match._0;
            if (match$1.length !== 2) {
                return Decco.error(undefined, "Incorrect cardinality", json);
            }
            var v0 = match$1[0];
            var v1 = match$1[1];
            var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(v0);
            var match$3 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.result_decode(v1);
            if (match$2.TAG === /* Ok */ 0) {
                if (match$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: [
                            match$2._0,
                            match$3._0
                        ]
                    };
                }
                var e = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[1]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = match$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeRespondToBgWithResult"), null));
        if (maybeRespondToBgWithResult.TAG === /* Ok */ 0) {
            var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                return exitReason_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "allExitReasons"), null));
            if (allExitReasons.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        parallelStates: parallelStates._0,
                        maybeRespondToBgWithResult: maybeRespondToBgWithResult._0,
                        allExitReasons: allExitReasons._0
                    }
                };
            }
            var e3 = allExitReasons._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".allExitReasons" + e3.path,
                    message: e3.message,
                    value: e3.value
                }
            };
        }
        var e$13 = maybeRespondToBgWithResult._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".maybeRespondToBgWithResult" + e$13.path,
                message: e$13.message,
                value: e$13.value
            }
        };
    }
    var e$2 = parallelStates._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".parallelStates" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function exiting_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v) {
    return Js_dict.fromArray([
        [
            "parallelStates",
            parallelStates_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v.parallelStates)
        ],
        [
            "maybeRespondToBgWithResult",
            Decco.optionToJson(function(param) {
                return [
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(param[0]),
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.result_encode(param[1])
                ];
            }, v.maybeRespondToBgWithResult)
        ],
        [
            "allExitReasons",
            Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                return exitReason_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
            }, v.allExitReasons)
        ]
    ]);
}
function failure_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, function(param) {
        return state_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return event_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return sideEffect_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return listener_encode(encoder_domEvent, encoder_domMutationRecord, param);
    }, otherFailureReason_encode, v);
}
function errorContext_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, function(param) {
        return state_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return event_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return sideEffect_encode(encoder_domEvent, encoder_domHtmlElement, encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domMutationRecord, param);
    }, function(param) {
        return listener_encode(encoder_domEvent, encoder_domMutationRecord, param);
    }, v);
}
function errorContext_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, function(param) {
        return state_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return event_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return sideEffect_decode(decoder_domEvent, decoder_domHtmlElement, decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domMutationRecord, param);
    }, function(param) {
        return listener_decode(decoder_domEvent, decoder_domMutationRecord, param);
    }, v);
}
var Generic = {
    listener_encode: listener_encode,
    listener_decode: listener_decode,
    otherFailureReason_encode: otherFailureReason_encode,
    otherFailureReason_decode: otherFailureReason_decode,
    parallelStates_encode: parallelStates_encode,
    parallelStates_decode: parallelStates_decode,
    state_encode: state_encode,
    state_decode: state_decode,
    exiting_encode: exiting_encode,
    exiting_decode: exiting_decode,
    event_encode: event_encode,
    event_decode: event_decode,
    failure_encode: failure_encode,
    failure_decode: failure_decode,
    errorContext_encode: errorContext_encode,
    errorContext_decode: errorContext_decode,
    exitReason_encode: exitReason_encode,
    exitReason_decode: exitReason_decode,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode
};
var Regular = {};
function listener_encode$1(v) {
    return listener_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function listener_decode$1(v) {
    return listener_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
function state_encode$1(v) {
    return state_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function state_decode$1(v) {
    return state_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
function event_encode$1(v) {
    return event_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function event_decode$1(v) {
    return event_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
function sideEffect_encode$1(v) {
    return sideEffect_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function sideEffect_decode$1(v) {
    return sideEffect_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
function failure_encode$1(v) {
    return failure_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function failure_decode$1(v) {
    return failure_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
function errorContext_encode$1(v) {
    return errorContext_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function errorContext_decode$1(v) {
    return errorContext_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
function exitReason_encode$1(v) {
    return exitReason_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}
function exitReason_decode$1(v) {
    return exitReason_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}
var ForSerialization = {
    listener_encode: listener_encode$1,
    listener_decode: listener_decode$1,
    state_encode: state_encode$1,
    state_decode: state_decode$1,
    event_encode: event_encode$1,
    event_decode: event_decode$1,
    sideEffect_encode: sideEffect_encode$1,
    sideEffect_decode: sideEffect_decode$1,
    failure_encode: failure_encode$1,
    failure_decode: failure_decode$1,
    errorContext_encode: errorContext_encode$1,
    errorContext_decode: errorContext_decode$1,
    exitReason_encode: exitReason_encode$1,
    exitReason_decode: exitReason_decode$1
};
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization; /* DOM-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 1591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var Belt_MapString = __webpack_require__(35082);
var Util$SmartcutsMacros = __webpack_require__(25092);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var UrlConstraint$SmartcutsMacros = __webpack_require__(32600);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var MultiUrlTriggering__Shared$SmartcutsMacros = __webpack_require__(8641);
var DOM__Event__ForSerialization$SmartcutsMacros = __webpack_require__(54179);
var MultiUrlTriggering__LinkGroup$SmartcutsMacros = __webpack_require__(28538);
var StateMachine__DebounceManager$SmartcutsMacros = __webpack_require__(79764);
var ExtensionMessaging__FromExtension$SmartcutsMacros = __webpack_require__(15462);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
function timeoutId_encode(timeoutId) {
    return timeoutId;
}
function timeoutId_decode(json) {
    return {
        TAG: /* Ok */ 0,
        _0: json
    };
}
function mode_encode(encoder_htmlElement, encoder_domEvent, v) {
    switch(v.TAG | 0){
        case /* Init */ 0:
            return [
                "Init",
                initializing_encode(encoder_htmlElement, v._0)
            ];
        case /* SelectingUrls */ 1:
            return [
                "SelectingUrls",
                selectingUrls_encode(encoder_htmlElement, v._0)
            ];
        case /* AwaitingNewLinks */ 2:
            return [
                "AwaitingNewLinks",
                awaitingNewLinks_encode(encoder_htmlElement, v._0)
            ];
        case /* RecordingPageAction */ 3:
            return [
                "RecordingPageAction",
                MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_encode(v._0),
                selectingUrls_encode(encoder_htmlElement, v._1)
            ];
        case /* PlayingBackPageAction */ 4:
            return [
                "PlayingBackPageAction",
                Decco.intToJson(v._0),
                MultiUrlTriggering__Shared$SmartcutsMacros.remainingPages_encode(v._1),
                selectingUrls_encode(encoder_htmlElement, v._2)
            ];
        case /* Exiting */ 5:
            return [
                "Exiting",
                exiting_encode(encoder_htmlElement, encoder_domEvent, v._0)
            ];
        case /* Exited */ 6:
            return [
                "Exited",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                    return exitReason_encode(encoder_htmlElement, encoder_domEvent, param);
                }, v._0)
            ];
    }
}
function triggeringElement_encode(encoder_htmlElement, v) {
    if (typeof v === "number") {
        return [
            "NoTriggeringElement"
        ];
    } else if (v.TAG === /* TriggeringElementAsUrlAndText */ 0) {
        return [
            "TriggeringElementAsUrlAndText",
            Decco.stringToJson(v._0),
            Decco.optionToJson(Decco.stringToJson, v._1)
        ];
    } else {
        return [
            "TriggeringElementAsHtmlElement",
            Curry._1(encoder_htmlElement, v._0)
        ];
    }
}
function exitReason_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
    }, listener_encode, otherFailureReason_encode, v);
}
function failure_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
    }, listener_encode, otherFailureReason_encode, v);
}
function failure_decode(decoder_htmlElement, decoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
    }, listener_decode, otherFailureReason_decode, v);
}
function triggeringElement_decode(decoder_htmlElement, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NoTriggeringElement":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoTriggeringElement */ 0
                    };
                }
            case "TriggeringElementAsHtmlElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TriggeringElementAsHtmlElement */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "TriggeringElementAsUrlAndText":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.optionFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TriggeringElementAsUrlAndText */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function exitReason_decode(decoder_htmlElement, decoder_domEvent, v) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
    }, listener_decode, otherFailureReason_decode, v);
}
function event_encode(encoder_htmlElement, encoder_domEvent, v) {
    if (typeof v === "number") {
        switch(v){
            case /* WindowResized */ 0:
                return [
                    "WindowResized"
                ];
            case /* DidBgStopRecordPageAction */ 1:
                return [
                    "DidBgStopRecordPageAction"
                ];
            case /* PaginationFnCompleted */ 2:
                return [
                    "PaginationFnCompleted"
                ];
            case /* PaginationFnFailed */ 3:
                return [
                    "PaginationFnFailed"
                ];
            case /* DidDetachListeners */ 4:
                return [
                    "DidDetachListeners"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* Initialize */ 0:
                return [
                    "Initialize",
                    triggeringElement_encode(encoder_htmlElement, v._0),
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._1)
                ];
            case /* DidAttachListeners */ 1:
                return [
                    "DidAttachListeners",
                    DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
            case /* QuerySelectorAllDidFindElements */ 2:
                return [
                    "QuerySelectorAllDidFindElements",
                    Decco.arrayToJson(encoder_htmlElement, v._0)
                ];
            case /* DidFinishGroupLinks */ 3:
                return [
                    "DidFinishGroupLinks",
                    Decco.arrayToJson(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                    }, v._0),
                    MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._1)
                ];
            case /* LinkAtIndexUpdated */ 4:
                return [
                    "LinkAtIndexUpdated",
                    MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, v._0),
                    Decco.intToJson(v._1)
                ];
            case /* LinksUpdated */ 5:
                return [
                    "LinksUpdated",
                    Decco.arrayToJson(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                    }, v._0)
                ];
            case /* DidSetTimer */ 6:
                return [
                    "DidSetTimer",
                    v._0
                ];
            case /* TimerFinished */ 7:
                return [
                    "TimerFinished",
                    Util$SmartcutsMacros.GlobalTimeoutId.t_encode(v._0),
                    Decco.floatToJson(v._1)
                ];
            case /* PageActionRecordedAsClickElement */ 8:
                return [
                    "PageActionRecordedAsClickElement",
                    Curry._1(encoder_htmlElement, v._0)
                ];
            case /* BasicEventWhileUrlTriggering */ 9:
                return [
                    "BasicEventWhileUrlTriggering",
                    ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
                ];
            case /* DomEvent */ 10:
                return [
                    "DomEvent",
                    Curry._1(encoder_domEvent, v._0),
                    Decco.floatToJson(v._1)
                ];
            case /* DidSetNewDebounceTimeout */ 11:
                return [
                    "DidSetNewDebounceTimeout",
                    Decco.stringToJson(v._0),
                    DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
            case /* DebounceTimerExpired */ 12:
                return [
                    "DebounceTimerExpired",
                    Decco.stringToJson(v._0)
                ];
            case /* DidFlushDebouncedEvent */ 13:
                return [
                    "DidFlushDebouncedEvent",
                    StateMachine__DebounceManager$SmartcutsMacros.entry_encode(encoder_domEvent, Decco.unitToJson, v._0)
                ];
            case /* DidClearDebounceTimeout */ 14:
                return [
                    "DidClearDebounceTimeout",
                    Decco.stringToJson(v._0)
                ];
            case /* Fail */ 15:
                return [
                    "Fail",
                    failure_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
            case /* Exit */ 16:
                return [
                    "Exit",
                    exitReason_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
        }
    }
}
var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;
function state_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Js_dict.fromArray([
        [
            "mode",
            mode_encode(encoder_htmlElement, encoder_domEvent, v.mode)
        ],
        [
            "maybeDebounceManager",
            Decco.optionToJson(function(param) {
                return StateMachine__DebounceManager$SmartcutsMacros.t_encode(encoder_domEvent, Decco.unitToJson, param);
            }, v.maybeDebounceManager)
        ]
    ]);
}
function sideEffect_encode(encoder_htmlElement, encoder_domEvent, v) {
    if (typeof v === "number") {
        switch(v){
            case /* AttachListeners */ 0:
                return [
                    "AttachListeners"
                ];
            case /* SetupListenerForClickEvent */ 1:
                return [
                    "SetupListenerForClickEvent"
                ];
            case /* HideMarkers */ 2:
                return [
                    "HideMarkers"
                ];
            case /* TellBgDidFinishPlaybackPageAction */ 3:
                return [
                    "TellBgDidFinishPlaybackPageAction"
                ];
            case /* TellBgMaybeReadyToPlaybackPagination */ 4:
                return [
                    "TellBgMaybeReadyToPlaybackPagination"
                ];
            case /* RemoveMarkers */ 5:
                return [
                    "RemoveMarkers"
                ];
            case /* RenderPlaybackModal */ 6:
                return [
                    "RenderPlaybackModal"
                ];
            case /* RemovePlaybackModal */ 7:
                return [
                    "RemovePlaybackModal"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* RespondToBg */ 0:
                return [
                    "RespondToBg",
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(v._1)
                ];
            case /* Dispatch */ 1:
                return [
                    "Dispatch",
                    event_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
            case /* QuerySelectorAllForLinks */ 2:
                return [
                    "QuerySelectorAllForLinks",
                    Decco.stringToJson(v._0)
                ];
            case /* Timer */ 3:
                return [
                    "Timer",
                    Decco.floatToJson(v._0),
                    Decco.intToJson(v._1)
                ];
            case /* AskBgToStopRecordPageAction */ 4:
                return [
                    "AskBgToStopRecordPageAction",
                    MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, v._0)
                ];
            case /* RunPaginateFn */ 5:
                return [
                    "RunPaginateFn",
                    MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, v._0)
                ];
            case /* ScrollToPageClick */ 6:
                return [
                    "ScrollToPageClick",
                    MultiUrlTriggering__Shared$SmartcutsMacros.ClickTarget.t_encode(encoder_htmlElement, v._0)
                ];
            case /* RenderMarkers */ 7:
                return [
                    "RenderMarkers",
                    Decco.arrayToJson(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                    }, v._0)
                ];
            case /* GroupLinks */ 8:
                return [
                    "GroupLinks",
                    Decco.arrayToJson(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                    }, v._0),
                    MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._1),
                    Decco.optionToJson(encoder_htmlElement, v._2)
                ];
            case /* KillTimer */ 9:
                return [
                    "KillTimer",
                    v._0
                ];
            case /* TellBgToUpdateLinks */ 10:
                return [
                    "TellBgToUpdateLinks",
                    Decco.arrayToJson(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                    }, v._0)
                ];
            case /* TellBgToUpdateLinkAtIndex */ 11:
                return [
                    "TellBgToUpdateLinkAtIndex",
                    MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, v._0),
                    Decco.intToJson(v._1)
                ];
            case /* TellBgToUpdateLinkGroups */ 12:
                return [
                    "TellBgToUpdateLinkGroups",
                    MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._0)
                ];
            case /* TellBgToUpdatePaginateFn */ 13:
                return [
                    "TellBgToUpdatePaginateFn",
                    MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, v._0)
                ];
            case /* PrepareForScreenshotWithLinksAndRespond */ 14:
                return [
                    "PrepareForScreenshotWithLinksAndRespond",
                    Decco.arrayToJson(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                    }, v._0),
                    ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._1)
                ];
            case /* ResetDebounceTimeout */ 15:
                return [
                    "ResetDebounceTimeout",
                    Decco.stringToJson(v._0),
                    Decco.optionToJson(DeccoUtils$SmartcutsMacros.timeoutId_encode, v._1)
                ];
            case /* ClearDebounceTimeout */ 16:
                return [
                    "ClearDebounceTimeout",
                    Decco.stringToJson(v._0),
                    DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
            case /* DetachListeners */ 17:
                return [
                    "DetachListeners",
                    DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
        }
    }
}
function listener_encode(v) {
    switch(v){
        case /* NoListener */ 0:
            return [
                "NoListener"
            ];
        case /* WindowResizedListener */ 1:
            return [
                "WindowResizedListener"
            ];
        case /* MutationObserverListener */ 2:
            return [
                "MutationObserverListener"
            ];
        case /* DOMEventListener */ 3:
            return [
                "DOMEventListener"
            ];
    }
}
function initializing_decode(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var maybeDetachListeners = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeDetachListeners"), null));
    if (maybeDetachListeners.TAG === /* Ok */ 0) {
        var triggeringElement = Decco.optionFromJson(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeringElement"), null));
        if (triggeringElement.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    maybeDetachListeners: maybeDetachListeners._0,
                    triggeringElement: triggeringElement._0
                }
            };
        }
        var e = triggeringElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".triggeringElement" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = maybeDetachListeners._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".maybeDetachListeners" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function exiting_decode(decoder_htmlElement, decoder_domEvent, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var didDetachListeners = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "didDetachListeners"), null));
    if (didDetachListeners.TAG === /* Ok */ 0) {
        var nRemainingDebouncedTimeers = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nRemainingDebouncedTimeers"), null));
        if (nRemainingDebouncedTimeers.TAG === /* Ok */ 0) {
            var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                return exitReason_decode(decoder_htmlElement, decoder_domEvent, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "allExitReasons"), null));
            if (allExitReasons.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        didDetachListeners: didDetachListeners._0,
                        nRemainingDebouncedTimeers: nRemainingDebouncedTimeers._0,
                        allExitReasons: allExitReasons._0
                    }
                };
            }
            var e = allExitReasons._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".allExitReasons" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = nRemainingDebouncedTimeers._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".nRemainingDebouncedTimeers" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = didDetachListeners._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".didDetachListeners" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function selectingUrls_decode(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var urlPatterns = Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlPatterns"), null));
    if (urlPatterns.TAG === /* Ok */ 0) {
        var page = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "page"), null));
        if (page.TAG === /* Ok */ 0) {
            var links = Decco.arrayFromJson(function(param) {
                return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "links"), null));
            if (links.TAG === /* Ok */ 0) {
                var linkGroups = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "linkGroups"), null));
                if (linkGroups.TAG === /* Ok */ 0) {
                    var detachListeners = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detachListeners"), null));
                    if (detachListeners.TAG === /* Ok */ 0) {
                        var maybePaginateFn = Decco.optionFromJson(function(param) {
                            return MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, param);
                        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybePaginateFn"), null));
                        if (maybePaginateFn.TAG === /* Ok */ 0) {
                            var triggeringLink = Decco.optionFromJson(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeringLink"), null));
                            if (triggeringLink.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        urlPatterns: urlPatterns._0,
                                        page: page._0,
                                        links: links._0,
                                        linkGroups: linkGroups._0,
                                        detachListeners: detachListeners._0,
                                        maybePaginateFn: maybePaginateFn._0,
                                        triggeringLink: triggeringLink._0
                                    }
                                };
                            }
                            var e = triggeringLink._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".triggeringLink" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = maybePaginateFn._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".maybePaginateFn" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = detachListeners._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".detachListeners" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = linkGroups._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".linkGroups" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = links._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".links" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = page._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".page" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = urlPatterns._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".urlPatterns" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
function awaitingNewLinks_decode(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var page = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "page"), null));
    if (page.TAG === /* Ok */ 0) {
        var lastUpdatedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastUpdatedAt"), null));
        if (lastUpdatedAt.TAG === /* Ok */ 0) {
            var timeoutId = Decco.optionFromJson(timeoutId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeoutId"), null));
            if (timeoutId.TAG === /* Ok */ 0) {
                var stateCallback = stateCallback_decode(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stateCallback"), null));
                if (stateCallback.TAG === /* Ok */ 0) {
                    var didPaginationFnFindNewLinks = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "didPaginationFnFindNewLinks"), null));
                    if (didPaginationFnFindNewLinks.TAG === /* Ok */ 0) {
                        var maybeLimitToSingleGroup = Decco.optionFromJson(function(json) {
                            var match = Js_json.classify(json);
                            if (typeof match === "number") {
                                return Decco.error(undefined, "Not a tuple", json);
                            }
                            if (match.TAG !== /* JSONArray */ 3) {
                                return Decco.error(undefined, "Not a tuple", json);
                            }
                            var match$1 = match._0;
                            if (match$1.length !== 2) {
                                return Decco.error(undefined, "Incorrect cardinality", json);
                            }
                            var v0 = match$1[0];
                            var v1 = match$1[1];
                            var match$2 = Decco.stringFromJson(v0);
                            var match$3 = MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode(v1);
                            if (match$2.TAG === /* Ok */ 0) {
                                if (match$3.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: [
                                            match$2._0,
                                            match$3._0
                                        ]
                                    };
                                }
                                var e = match$3._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = match$2._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLimitToSingleGroup"), null));
                        if (maybeLimitToSingleGroup.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    page: page._0,
                                    lastUpdatedAt: lastUpdatedAt._0,
                                    timeoutId: timeoutId._0,
                                    stateCallback: stateCallback._0,
                                    didPaginationFnFindNewLinks: didPaginationFnFindNewLinks._0,
                                    maybeLimitToSingleGroup: maybeLimitToSingleGroup._0
                                }
                            };
                        }
                        var e1 = maybeLimitToSingleGroup._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".maybeLimitToSingleGroup" + e1.path,
                                message: e1.message,
                                value: e1.value
                            }
                        };
                    }
                    var e$11 = didPaginationFnFindNewLinks._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".didPaginationFnFindNewLinks" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                        }
                    };
                }
                var e$2 = stateCallback._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".stateCallback" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = timeoutId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".timeoutId" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = lastUpdatedAt._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".lastUpdatedAt" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = page._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".page" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function stateCallback_encode(encoder_htmlElement, v) {
    if (v.TAG === /* Cb_SelectingUrls */ 0) {
        return [
            "Cb_SelectingUrls",
            selectingUrls_encode(encoder_htmlElement, v._0)
        ];
    } else {
        return [
            "Cb_PlayingBackPageAction",
            MultiUrlTriggering__Shared$SmartcutsMacros.remainingPages_encode(v._0),
            MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, v._1),
            selectingUrls_encode(encoder_htmlElement, v._2)
        ];
    }
}
function state_decode(decoder_htmlElement, decoder_domEvent, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var mode = mode_decode(decoder_htmlElement, decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mode"), null));
    if (mode.TAG === /* Ok */ 0) {
        var maybeDebounceManager = Decco.optionFromJson(function(param) {
            return StateMachine__DebounceManager$SmartcutsMacros.t_decode(decoder_domEvent, Decco.unitFromJson, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeDebounceManager"), null));
        if (maybeDebounceManager.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    mode: mode._0,
                    maybeDebounceManager: maybeDebounceManager._0
                }
            };
        }
        var e = maybeDebounceManager._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".maybeDebounceManager" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = mode._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".mode" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function sideEffect_decode(decoder_htmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AskBgToStopRecordPageAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AskBgToStopRecordPageAction */ 4,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "AttachListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AttachListeners */ 0
                    };
                }
            case "ClearDebounceTimeout":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ClearDebounceTimeout */ 16,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "DetachListeners":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DetachListeners */ 17,
                            _0: v0$1._0
                        }
                    };
                }
                var e$3 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Dispatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = event_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Dispatch */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$4 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "GroupLinks":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.arrayFromJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$5 = Decco.optionFromJson(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        if (match$5.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* GroupLinks */ 8,
                                    _0: match$3._0,
                                    _1: match$4._0,
                                    _2: match$5._0
                                }
                            };
                        }
                        var e$5 = match$5._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "HideMarkers":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* HideMarkers */ 2
                    };
                }
            case "KillTimer":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = {
                    TAG: /* Ok */ 0,
                    _0: Belt_Array.getExn(jsonArr$1, 1)
                };
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* KillTimer */ 9,
                            _0: v0$3._0
                        }
                    };
                }
                var e$8 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "PrepareForScreenshotWithLinksAndRespond":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$6 = Decco.arrayFromJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                var match$7 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$6.TAG === /* Ok */ 0) {
                    if (match$7.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* PrepareForScreenshotWithLinksAndRespond */ 14,
                                _0: match$6._0,
                                _1: match$7._0
                            }
                        };
                    }
                    var e$9 = match$7._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = match$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "QuerySelectorAllForLinks":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* QuerySelectorAllForLinks */ 2,
                            _0: v0$4._0
                        }
                    };
                }
                var e$11 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "RemoveMarkers":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemoveMarkers */ 5
                    };
                }
            case "RemovePlaybackModal":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RemovePlaybackModal */ 7
                    };
                }
            case "RenderMarkers":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.arrayFromJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RenderMarkers */ 7,
                            _0: v0$5._0
                        }
                    };
                }
                var e$12 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "RenderPlaybackModal":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RenderPlaybackModal */ 6
                    };
                }
            case "ResetDebounceTimeout":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$9 = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.timeoutId_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$8.TAG === /* Ok */ 0) {
                    if (match$9.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ResetDebounceTimeout */ 15,
                                _0: match$8._0,
                                _1: match$9._0
                            }
                        };
                    }
                    var e$13 = match$9._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$13.path,
                            message: e$13.message,
                            value: e$13.value
                        }
                    };
                }
                var e$14 = match$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "RespondToBg":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$10 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$11 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$10.TAG === /* Ok */ 0) {
                    if (match$11.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RespondToBg */ 0,
                                _0: match$10._0,
                                _1: match$11._0
                            }
                        };
                    }
                    var e$15 = match$11._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$15.path,
                            message: e$15.message,
                            value: e$15.value
                        }
                    };
                }
                var e$16 = match$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$16.path,
                        message: e$16.message,
                        value: e$16.value
                    }
                };
            case "RunPaginateFn":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RunPaginateFn */ 5,
                            _0: v0$6._0
                        }
                    };
                }
                var e$17 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "ScrollToPageClick":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = MultiUrlTriggering__Shared$SmartcutsMacros.ClickTarget.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ScrollToPageClick */ 6,
                            _0: v0$7._0
                        }
                    };
                }
                var e$18 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "SetupListenerForClickEvent":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SetupListenerForClickEvent */ 1
                    };
                }
            case "TellBgDidFinishPlaybackPageAction":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TellBgDidFinishPlaybackPageAction */ 3
                    };
                }
            case "TellBgMaybeReadyToPlaybackPagination":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TellBgMaybeReadyToPlaybackPagination */ 4
                    };
                }
            case "TellBgToUpdateLinkAtIndex":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$12 = MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                var match$13 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$12.TAG === /* Ok */ 0) {
                    if (match$13.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TellBgToUpdateLinkAtIndex */ 11,
                                _0: match$12._0,
                                _1: match$13._0
                            }
                        };
                    }
                    var e$19 = match$13._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$19.path,
                            message: e$19.message,
                            value: e$19.value
                        }
                    };
                }
                var e$20 = match$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            case "TellBgToUpdateLinkGroups":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TellBgToUpdateLinkGroups */ 12,
                            _0: v0$8._0
                        }
                    };
                }
                var e$21 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$21.path,
                        message: e$21.message,
                        value: e$21.value
                    }
                };
            case "TellBgToUpdateLinks":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = Decco.arrayFromJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TellBgToUpdateLinks */ 10,
                            _0: v0$9._0
                        }
                    };
                }
                var e$22 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$22.path,
                        message: e$22.message,
                        value: e$22.value
                    }
                };
            case "TellBgToUpdatePaginateFn":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TellBgToUpdatePaginateFn */ 13,
                            _0: v0$10._0
                        }
                    };
                }
                var e$23 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                    }
                };
            case "Timer":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$14 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$15 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$14.TAG === /* Ok */ 0) {
                    if (match$15.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Timer */ 3,
                                _0: match$14._0,
                                _1: match$15._0
                            }
                        };
                    }
                    var e$24 = match$15._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$24.path,
                            message: e$24.message,
                            value: e$24.value
                        }
                    };
                }
                var e$25 = match$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function event_decode(decoder_htmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BasicEventWhileUrlTriggering":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BasicEventWhileUrlTriggering */ 9,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DebounceTimerExpired":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DebounceTimerExpired */ 12,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "DidAttachListeners":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidAttachListeners */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "DidBgStopRecordPageAction":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidBgStopRecordPageAction */ 1
                    };
                }
            case "DidClearDebounceTimeout":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidClearDebounceTimeout */ 14,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "DidDetachListeners":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DidDetachListeners */ 4
                    };
                }
            case "DidFinishGroupLinks":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.arrayFromJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DidFinishGroupLinks */ 3,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$4 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "DidFlushDebouncedEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = StateMachine__DebounceManager$SmartcutsMacros.entry_decode(decoder_domEvent, Decco.unitFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidFlushDebouncedEvent */ 13,
                            _0: v0$4._0
                        }
                    };
                }
                var e$6 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "DidSetNewDebounceTimeout":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DidSetNewDebounceTimeout */ 11,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$7 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "DidSetTimer":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = {
                    TAG: /* Ok */ 0,
                    _0: Belt_Array.getExn(jsonArr$1, 1)
                };
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidSetTimer */ 6,
                            _0: v0$5._0
                        }
                    };
                }
                var e$9 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "DomEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DomEvent */ 10,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$10 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$10.path,
                            message: e$10.message,
                            value: e$10.value
                        }
                    };
                }
                var e$11 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "Exit":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = exitReason_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exit */ 16,
                            _0: v0$6._0
                        }
                    };
                }
                var e$12 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "Fail":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = failure_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Fail */ 15,
                            _0: v0$7._0
                        }
                    };
                }
                var e$13 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "Initialize":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = triggeringElement_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Initialize */ 0,
                                _0: match$7._0,
                                _1: match$8._0
                            }
                        };
                    }
                    var e$14 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$14.path,
                            message: e$14.message,
                            value: e$14.value
                        }
                    };
                }
                var e$15 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "LinkAtIndexUpdated":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$9 = MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                var match$10 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$9.TAG === /* Ok */ 0) {
                    if (match$10.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* LinkAtIndexUpdated */ 4,
                                _0: match$9._0,
                                _1: match$10._0
                            }
                        };
                    }
                    var e$16 = match$10._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$16.path,
                            message: e$16.message,
                            value: e$16.value
                        }
                    };
                }
                var e$17 = match$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "LinksUpdated":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = Decco.arrayFromJson(function(param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LinksUpdated */ 5,
                            _0: v0$8._0
                        }
                    };
                }
                var e$18 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "PageActionRecordedAsClickElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PageActionRecordedAsClickElement */ 8,
                            _0: v0$9._0
                        }
                    };
                }
                var e$19 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "PaginationFnCompleted":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PaginationFnCompleted */ 2
                    };
                }
            case "PaginationFnFailed":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PaginationFnFailed */ 3
                    };
                }
            case "QuerySelectorAllDidFindElements":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = Decco.arrayFromJson(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* QuerySelectorAllDidFindElements */ 2,
                            _0: v0$10._0
                        }
                    };
                }
                var e$20 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            case "TimerFinished":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$11 = Util$SmartcutsMacros.GlobalTimeoutId.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$12 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$11.TAG === /* Ok */ 0) {
                    if (match$12.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TimerFinished */ 7,
                                _0: match$11._0,
                                _1: match$12._0
                            }
                        };
                    }
                    var e$21 = match$12._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$21.path,
                            message: e$21.message,
                            value: e$21.value
                        }
                    };
                }
                var e$22 = match$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$22.path,
                        message: e$22.message,
                        value: e$22.value
                    }
                };
            case "WindowResized":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* WindowResized */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function listener_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DOMEventListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DOMEventListener */ 3
                    };
                }
            case "MutationObserverListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* MutationObserverListener */ 2
                    };
                }
            case "NoListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoListener */ 0
                    };
                }
            case "WindowResizedListener":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* WindowResizedListener */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;
function initializing_encode(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "maybeDetachListeners",
            Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.maybeDetachListeners)
        ],
        [
            "triggeringElement",
            Decco.optionToJson(encoder_htmlElement, v.triggeringElement)
        ]
    ]);
}
function selectingUrls_encode(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "urlPatterns",
            Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v.urlPatterns)
        ],
        [
            "page",
            Decco.intToJson(v.page)
        ],
        [
            "links",
            Decco.arrayToJson(function(param) {
                return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
            }, v.links)
        ],
        [
            "linkGroups",
            CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode, v.linkGroups)
        ],
        [
            "detachListeners",
            DeccoUtils$SmartcutsMacros.unitToUnit_encode(v.detachListeners)
        ],
        [
            "maybePaginateFn",
            Decco.optionToJson(function(param) {
                return MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, param);
            }, v.maybePaginateFn)
        ],
        [
            "triggeringLink",
            Decco.optionToJson(encoder_htmlElement, v.triggeringLink)
        ]
    ]);
}
function awaitingNewLinks_encode(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "page",
            Decco.intToJson(v.page)
        ],
        [
            "lastUpdatedAt",
            Decco.optionToJson(Decco.floatToJson, v.lastUpdatedAt)
        ],
        [
            "timeoutId",
            Decco.optionToJson(timeoutId_encode, v.timeoutId)
        ],
        [
            "stateCallback",
            stateCallback_encode(encoder_htmlElement, v.stateCallback)
        ],
        [
            "didPaginationFnFindNewLinks",
            Decco.boolToJson(v.didPaginationFnFindNewLinks)
        ],
        [
            "maybeLimitToSingleGroup",
            Decco.optionToJson(function(param) {
                return [
                    Decco.stringToJson(param[0]),
                    MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode(param[1])
                ];
            }, v.maybeLimitToSingleGroup)
        ]
    ]);
}
function exiting_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Js_dict.fromArray([
        [
            "didDetachListeners",
            Decco.boolToJson(v.didDetachListeners)
        ],
        [
            "nRemainingDebouncedTimeers",
            Decco.intToJson(v.nRemainingDebouncedTimeers)
        ],
        [
            "allExitReasons",
            Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, function(param) {
                return exitReason_encode(encoder_htmlElement, encoder_domEvent, param);
            }, v.allExitReasons)
        ]
    ]);
}
function mode_decode(decoder_htmlElement, decoder_domEvent, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AwaitingNewLinks":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = awaitingNewLinks_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AwaitingNewLinks */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Exited":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, function(param) {
                    return exitReason_decode(decoder_htmlElement, decoder_domEvent, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exited */ 6,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Exiting":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = exiting_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Exiting */ 5,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Init":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = initializing_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Init */ 0,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "PlayingBackPageAction":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.remainingPages_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* PlayingBackPageAction */ 4,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e$4 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "RecordingPageAction":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$4 = MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$5 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
                if (match$4.TAG === /* Ok */ 0) {
                    if (match$5.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RecordingPageAction */ 3,
                                _0: match$4._0,
                                _1: match$5._0
                            }
                        };
                    }
                    var e$7 = match$5._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = match$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "SelectingUrls":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectingUrls */ 1,
                            _0: v0$4._0
                        }
                    };
                }
                var e$9 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stateCallback_decode(decoder_htmlElement, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Cb_PlayingBackPageAction":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = MultiUrlTriggering__Shared$SmartcutsMacros.remainingPages_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* Cb_PlayingBackPageAction */ 1,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Cb_SelectingUrls":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Cb_SelectingUrls */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$3 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function errorContext_encode(encoder_htmlElement, encoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, function(param) {
        return state_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return event_encode(encoder_htmlElement, encoder_domEvent, param);
    }, function(param) {
        return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
    }, listener_encode, v);
}
function errorContext_decode(decoder_htmlElement, decoder_domEvent, v) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, function(param) {
        return state_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return event_decode(decoder_htmlElement, decoder_domEvent, param);
    }, function(param) {
        return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
    }, listener_decode, v);
}
function stringifyListener(v) {
    switch(v){
        case /* NoListener */ 0:
            return "NoListener";
        case /* WindowResizedListener */ 1:
            return "WindowResizedListener";
        case /* MutationObserverListener */ 2:
            return "MutationObserverListener";
        case /* DOMEventListener */ 3:
            return "DOMEventListener";
    }
}
function stringifyStateCallback(v) {
    if (v.TAG === /* Cb_SelectingUrls */ 0) {
        return "Cb_SelectingUrls(selectingUrls)";
    } else {
        return "Cb_PlayingBackPageAction(" + (MultiUrlTriggering__Shared$SmartcutsMacros.stringifyRemainingPages(v._0) + ", paginateFn, selectingUrls)");
    }
}
function stringifyTriggeringElement(stringifyHtmlElement, triggeringElement) {
    if (typeof triggeringElement === "number") {
        return "NoTriggeringElement";
    } else if (triggeringElement.TAG === /* TriggeringElementAsUrlAndText */ 0) {
        return "TriggeringElementAsUrlAndText(" + (triggeringElement._0 + (". " + (OptionUtils$SmartcutsMacros.withDefault("None", triggeringElement._1) + ")")));
    } else {
        return "TriggeringElementAsHtmlElement(" + (Curry._1(stringifyHtmlElement, triggeringElement._0) + ")");
    }
}
function stringifyInitializing(stringifyHtmlElement, param1) {
    var arg = OptionUtils$SmartcutsMacros.map(param1.triggeringElement, stringifyHtmlElement);
    return "{triggeringElement: " + (function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }("None") + "}");
}
function stringifyMode(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, state) {
    switch(state.TAG | 0){
        case /* Init */ 0:
            return "Init(" + (stringifyInitializing(stringifyHtmlElement, state._0) + ")");
        case /* SelectingUrls */ 1:
            var match = state._0;
            return "SelectingUrls({ page: " + (String(match.page) + (", urlPatten, links: array(length=" + (String(match.links.length) + ("), linkGroups({len: " + (String(MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.size(match.linkGroups)) + "})})")))));
        case /* AwaitingNewLinks */ 2:
            var match$1 = state._0;
            var lastUpdatedAt = match$1.lastUpdatedAt;
            var tmp;
            if (lastUpdatedAt !== undefined) {
                var ms = Date.now() - lastUpdatedAt;
                tmp = "last updated " + ((ms / 1000.0).toString() + "s ago");
            } else {
                tmp = "not updated yet";
            }
            var arg = OptionUtils$SmartcutsMacros.map(match$1.timeoutId, function(id) {
                return String(id);
            });
            return "AwaitingNewLinks({page: " + (String(match$1.page) + (", lastUpdated: " + (tmp + (", timeoutId: " + (function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            }("None") + (", stateCallback: " + (stringifyStateCallback(match$1.stateCallback) + "})")))))));
        case /* RecordingPageAction */ 3:
            var match$2 = state._1;
            return "RecordingPageAction(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Step.stringifyPageAction(state._0) + (", { page: " + (String(match$2.page) + (", urlPatten, links: array(length=" + (String(match$2.links.length) + ") })")))));
        case /* PlayingBackPageAction */ 4:
            return "PlayingBackPageAction(page=" + (String(state._0) + (", remaining=" + (MultiUrlTriggering__Shared$SmartcutsMacros.stringifyRemainingPages(state._1) + (", {  urlPatten, links: array(length=" + (String(state._2.links.length) + ") })")))));
        case /* Exiting */ 5:
            var match$3 = state._0;
            return "Exiting({ allExitReasons: " + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
                return stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
            }, match$3.allExitReasons) + (", nRemainingDebouncedTimeers: " + (String(match$3.nRemainingDebouncedTimeers) + (", didDetachListeners: " + (Pervasives.string_of_bool(match$3.didDetachListeners) + " })")))));
        case /* Exited */ 6:
            return "Exited(" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
                return stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
            }, state._0) + ")");
    }
}
function stringifyState(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param2) {
    var mode = param2.mode;
    var func = function func(param, param$1, param$2) {
        return stringifyMode(stringifyHtmlElement, param, param$1, param$2);
    };
    var func$1 = Curry._1(func, stringifyDomEvent);
    return "{ mode: " + (Curry._1(function(param) {
        return Curry._2(func$1, param, mode);
    }, stringifyBasicEvent) + ("maybeDebounceManager: " + (OptionUtils$SmartcutsMacros.stringify(function(param) {
        return "debounceManager";
    }, param2.maybeDebounceManager) + "}")));
}
function stringifyEvent(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, $$event) {
    if (typeof $$event === "number") {
        switch($$event){
            case /* WindowResized */ 0:
                return "WindowResized";
            case /* DidBgStopRecordPageAction */ 1:
                return "DidBgStopRecordPageAction";
            case /* PaginationFnCompleted */ 2:
                return "PaginationFnCompleted";
            case /* PaginationFnFailed */ 3:
                return "PaginationFnFailed";
            case /* DidDetachListeners */ 4:
                return "DidDetachListeners";
        }
    } else {
        switch($$event.TAG | 0){
            case /* Initialize */ 0:
                return "Initialize(triggeringElement, respondToBg)";
            case /* DidAttachListeners */ 1:
                return "DidAttachListeners(callback)";
            case /* QuerySelectorAllDidFindElements */ 2:
                return "QuerySelectorAllDidFindElements(htmlElements({len: " + (String($$event._0.length) + "}))");
            case /* DidFinishGroupLinks */ 3:
                return "DidFinishGroupLinks(array(length=" + (String($$event._0.length) + ("), linkGroups(size=" + (String(Belt_MapString.size($$event._1)) + "))")));
            case /* LinkAtIndexUpdated */ 4:
                return "LinkAtIndexUpdated(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Link.stringify(stringifyHtmlElement, $$event._0) + (", " + (String($$event._1) + ")")));
            case /* LinksUpdated */ 5:
                return "LinksUpdated(array(length=" + (String($$event._0.length) + "))");
            case /* DidSetTimer */ 6:
                return "DidSetTimer(" + (String($$event._0) + ")");
            case /* TimerFinished */ 7:
                var ms = Date.now() - $$event._1;
                return "TimerFinished(" + (String($$event._0) + (", started " + ((ms / 1000.0).toString() + "s ago)")));
            case /* PageActionRecordedAsClickElement */ 8:
                return "PageActionRecordedAsClickElement(element)";
            case /* BasicEventWhileUrlTriggering */ 9:
                return "BasicEventWhileUrlTriggering(" + (Curry._1(stringifyBasicEvent, $$event._0) + ")");
            case /* DomEvent */ 10:
                return "DomEvent(" + (Curry._1(stringifyDomEvent, $$event._0) + (", " + ($$event._1.toString() + ")")));
            case /* DidSetNewDebounceTimeout */ 11:
                return "DidSetNewDebounceTimeout(" + ($$event._0 + ", timeoutId)");
            case /* DebounceTimerExpired */ 12:
                return "DebounceTimerExpired(" + ($$event._0 + ")");
            case /* DidFlushDebouncedEvent */ 13:
                return "DidFlushDebouncedEvent(entry)";
            case /* DidClearDebounceTimeout */ 14:
                return "DidClearDebounceTimeout(" + ($$event._0 + ")");
            case /* Fail */ 15:
                return "Fail(" + (stringifyFailure(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, $$event._0) + ")");
            case /* Exit */ 16:
                return "Exit(" + (stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, $$event._0) + ")");
        }
    }
}
function stringifyFailure(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, failure) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, function(param) {
        return stringifyState(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
    }, function(param) {
        return stringifyEvent(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
    }, function(param) {
        return stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
    }, stringifyListener, stringifyOtherFailureReason, failure);
}
function stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, exitReason) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, function(param) {
        return stringifyState(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
    }, function(param) {
        return stringifyEvent(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
    }, function(param) {
        return stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
    }, stringifyListener, stringifyOtherFailureReason, exitReason);
}
function stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* AttachListeners */ 0:
                return "AttachListeners";
            case /* SetupListenerForClickEvent */ 1:
                return "SetupListenerForClickEvent";
            case /* HideMarkers */ 2:
                return "HideMarkers";
            case /* TellBgDidFinishPlaybackPageAction */ 3:
                return "TellBgDidFinishPlaybackPageAction";
            case /* TellBgMaybeReadyToPlaybackPagination */ 4:
                return "TellBgMaybeReadyToPlaybackPagination";
            case /* RemoveMarkers */ 5:
                return "RemoveMarkers";
            case /* RenderPlaybackModal */ 6:
                return "RenderPlaybackModal";
            case /* RemovePlaybackModal */ 7:
                return "RemovePlaybackModal";
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* RespondToBg */ 0:
                return "RespondToBg(respondToBg, " + (JSON.stringify(ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(sideEffect._1)) + ")");
            case /* Dispatch */ 1:
                return "Dispatch(" + (stringifyEvent(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, sideEffect._0) + ")");
            case /* QuerySelectorAllForLinks */ 2:
                return "QuerySelectorAllForLinks(" + (sideEffect._0 + ")");
            case /* Timer */ 3:
                var ms = Date.now() - sideEffect._0;
                return "Timer(started " + ((ms / 1000.0).toString() + ("s ago, waitForMillis=" + (String(sideEffect._1) + ")")));
            case /* AskBgToStopRecordPageAction */ 4:
                return "AskBgToStopRecordPageAction(paginateFn)";
            case /* RunPaginateFn */ 5:
                return "RunPaginateFn(" + (MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.stringify(sideEffect._0) + ")");
            case /* ScrollToPageClick */ 6:
                return "ScrollToPageClick(selector)";
            case /* RenderMarkers */ 7:
                return "RenderMarkers(array(length=" + (String(sideEffect._0.length) + "))");
            case /* GroupLinks */ 8:
                var arg = OptionUtils$SmartcutsMacros.map(sideEffect._2, stringifyHtmlElement);
                return "GroupLinks(array(length=" + (String(sideEffect._0.length) + ("), linkGroups(size=" + (String(Belt_MapString.size(sideEffect._1)) + ("), " + (function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("None") + ")")))));
            case /* KillTimer */ 9:
                return "KillTimer(" + (String(sideEffect._0) + ")");
            case /* TellBgToUpdateLinks */ 10:
                return "TellBgToUpdateLinks(array(length=" + (String(sideEffect._0.length) + "))");
            case /* TellBgToUpdateLinkAtIndex */ 11:
                return "TellBgToUpdateLinkAtIndex(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Link.stringify(stringifyHtmlElement, sideEffect._0) + (", " + (String(sideEffect._1) + ")")));
            case /* TellBgToUpdateLinkGroups */ 12:
                return "TellBgToUpdateLinkGroups(linkGroups(size=" + (String(Belt_MapString.size(sideEffect._0)) + "))");
            case /* TellBgToUpdatePaginateFn */ 13:
                return "TellBgToUpdatePaginateFn(" + (MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.stringify(sideEffect._0) + ")");
            case /* PrepareForScreenshotWithLinksAndRespond */ 14:
                return "PrepareForScreenshotWithLinksAndRespond(links=array(length=" + (String(sideEffect._0.length) + "), respondToBg)");
            case /* ResetDebounceTimeout */ 15:
                return "ResetDebounceTimeout(" + (sideEffect._0 + (", maybePreviouseTimeoutId=" + OptionUtils$SmartcutsMacros.stringify(function(param) {
                    return "timeoutId";
                }, sideEffect._1)));
            case /* ClearDebounceTimeout */ 16:
                return "ClearDebounceTimeout(" + (sideEffect._0 + ", timeoutId)");
            case /* DetachListeners */ 17:
                return "DetachListeners(fn)";
        }
    }
}
var stringifyOtherFailureReason = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason;
function mapTriggeringElement(mapHtmlElement, triggeringElement) {
    if (typeof triggeringElement === "number") {
        return /* NoTriggeringElement */ 0;
    } else if (triggeringElement.TAG === /* TriggeringElementAsUrlAndText */ 0) {
        return {
            TAG: /* TriggeringElementAsUrlAndText */ 0,
            _0: triggeringElement._0,
            _1: triggeringElement._1
        };
    } else {
        return {
            TAG: /* TriggeringElementAsHtmlElement */ 1,
            _0: Curry._1(mapHtmlElement, triggeringElement._0)
        };
    }
}
function mapInitializing(mapHtmlElement, initializing) {
    return {
        maybeDetachListeners: initializing.maybeDetachListeners,
        triggeringElement: OptionUtils$SmartcutsMacros.map(initializing.triggeringElement, mapHtmlElement)
    };
}
function mapState(mapHtmlElement, mapDomEvent, param3) {
    var mode = param3.mode;
    var tmp;
    switch(mode.TAG | 0){
        case /* Init */ 0:
            tmp = {
                TAG: /* Init */ 0,
                _0: mapInitializing(mapHtmlElement, mode._0)
            };
            break;
        case /* SelectingUrls */ 1:
            tmp = {
                TAG: /* SelectingUrls */ 1,
                _0: mapSelectingUrls(mapHtmlElement, mode._0)
            };
            break;
        case /* AwaitingNewLinks */ 2:
            var match = mode._0;
            tmp = {
                TAG: /* AwaitingNewLinks */ 2,
                _0: {
                    page: match.page,
                    lastUpdatedAt: match.lastUpdatedAt,
                    timeoutId: match.timeoutId,
                    stateCallback: mapStateCallback(mapHtmlElement, match.stateCallback),
                    didPaginationFnFindNewLinks: match.didPaginationFnFindNewLinks,
                    maybeLimitToSingleGroup: match.maybeLimitToSingleGroup
                }
            };
            break;
        case /* RecordingPageAction */ 3:
            tmp = {
                TAG: /* RecordingPageAction */ 3,
                _0: mode._0,
                _1: mapSelectingUrls(mapHtmlElement, mode._1)
            };
            break;
        case /* PlayingBackPageAction */ 4:
            tmp = {
                TAG: /* PlayingBackPageAction */ 4,
                _0: mode._0,
                _1: mode._1,
                _2: mapSelectingUrls(mapHtmlElement, mode._2)
            };
            break;
        case /* Exiting */ 5:
            var match$1 = mode._0;
            tmp = {
                TAG: /* Exiting */ 5,
                _0: {
                    didDetachListeners: match$1.didDetachListeners,
                    nRemainingDebouncedTimeers: match$1.nRemainingDebouncedTimeers,
                    allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                        return mapExitReason(mapHtmlElement, mapDomEvent, param);
                    }, match$1.allExitReasons)
                }
            };
            break;
        case /* Exited */ 6:
            tmp = {
                TAG: /* Exited */ 6,
                _0: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                    return mapExitReason(mapHtmlElement, mapDomEvent, param);
                }, mode._0)
            };
            break;
    }
    return {
        mode: tmp,
        maybeDebounceManager: Belt_Option.map(param3.maybeDebounceManager, function(param) {
            return StateMachine__DebounceManager$SmartcutsMacros.map(mapDomEvent, function(param) {}, param);
        })
    };
}
function mapSelectingUrls(mapHtmlElement, param4) {
    return {
        urlPatterns: param4.urlPatterns,
        page: param4.page,
        links: $$Array.map(function(param) {
            return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
        }, param4.links),
        linkGroups: param4.linkGroups,
        detachListeners: param4.detachListeners,
        maybePaginateFn: OptionUtils$SmartcutsMacros.map(param4.maybePaginateFn, function(param) {
            return MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, param);
        }),
        triggeringLink: OptionUtils$SmartcutsMacros.map(param4.triggeringLink, mapHtmlElement)
    };
}
function mapStateCallback(mapHtmlElement, callback) {
    if (callback.TAG === /* Cb_SelectingUrls */ 0) {
        return {
            TAG: /* Cb_SelectingUrls */ 0,
            _0: mapSelectingUrls(mapHtmlElement, callback._0)
        };
    } else {
        return {
            TAG: /* Cb_PlayingBackPageAction */ 1,
            _0: callback._0,
            _1: MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, callback._1),
            _2: mapSelectingUrls(mapHtmlElement, callback._2)
        };
    }
}
function mapEvent(mapHtmlElement, mapDomEvent, $$event) {
    if (typeof $$event === "number") {
        switch($$event){
            case /* WindowResized */ 0:
                return /* WindowResized */ 0;
            case /* DidBgStopRecordPageAction */ 1:
                return /* DidBgStopRecordPageAction */ 1;
            case /* PaginationFnCompleted */ 2:
                return /* PaginationFnCompleted */ 2;
            case /* PaginationFnFailed */ 3:
                return /* PaginationFnFailed */ 3;
            case /* DidDetachListeners */ 4:
                return /* DidDetachListeners */ 4;
        }
    } else {
        switch($$event.TAG | 0){
            case /* Initialize */ 0:
                return {
                    TAG: /* Initialize */ 0,
                    _0: mapTriggeringElement(mapHtmlElement, $$event._0),
                    _1: $$event._1
                };
            case /* DidAttachListeners */ 1:
                return {
                    TAG: /* DidAttachListeners */ 1,
                    _0: $$event._0
                };
            case /* QuerySelectorAllDidFindElements */ 2:
                return {
                    TAG: /* QuerySelectorAllDidFindElements */ 2,
                    _0: Belt_Array.map($$event._0, mapHtmlElement)
                };
            case /* DidFinishGroupLinks */ 3:
                return {
                    TAG: /* DidFinishGroupLinks */ 3,
                    _0: $$Array.map(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                    }, $$event._0),
                    _1: $$event._1
                };
            case /* LinkAtIndexUpdated */ 4:
                return {
                    TAG: /* LinkAtIndexUpdated */ 4,
                    _0: MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, $$event._0),
                    _1: $$event._1
                };
            case /* LinksUpdated */ 5:
                return {
                    TAG: /* LinksUpdated */ 5,
                    _0: $$Array.map(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                    }, $$event._0)
                };
            case /* DidSetTimer */ 6:
                return {
                    TAG: /* DidSetTimer */ 6,
                    _0: $$event._0
                };
            case /* TimerFinished */ 7:
                return {
                    TAG: /* TimerFinished */ 7,
                    _0: $$event._0,
                    _1: $$event._1
                };
            case /* PageActionRecordedAsClickElement */ 8:
                return {
                    TAG: /* PageActionRecordedAsClickElement */ 8,
                    _0: Curry._1(mapHtmlElement, $$event._0)
                };
            case /* BasicEventWhileUrlTriggering */ 9:
                return {
                    TAG: /* BasicEventWhileUrlTriggering */ 9,
                    _0: $$event._0
                };
            case /* DomEvent */ 10:
                return {
                    TAG: /* DomEvent */ 10,
                    _0: Curry._1(mapDomEvent, $$event._0),
                    _1: $$event._1
                };
            case /* DidSetNewDebounceTimeout */ 11:
                return {
                    TAG: /* DidSetNewDebounceTimeout */ 11,
                    _0: $$event._0,
                    _1: $$event._1
                };
            case /* DebounceTimerExpired */ 12:
                return {
                    TAG: /* DebounceTimerExpired */ 12,
                    _0: $$event._0
                };
            case /* DidFlushDebouncedEvent */ 13:
                return {
                    TAG: /* DidFlushDebouncedEvent */ 13,
                    _0: StateMachine__DebounceManager$SmartcutsMacros.mapEntry(mapDomEvent, function(param) {}, $$event._0)
                };
            case /* DidClearDebounceTimeout */ 14:
                return {
                    TAG: /* DidClearDebounceTimeout */ 14,
                    _0: $$event._0
                };
            case /* Fail */ 15:
                return {
                    TAG: /* Fail */ 15,
                    _0: mapFailure(mapHtmlElement, mapDomEvent, $$event._0)
                };
            case /* Exit */ 16:
                return {
                    TAG: /* Exit */ 16,
                    _0: mapExitReason(mapHtmlElement, mapDomEvent, $$event._0)
                };
        }
    }
}
function mapFailure(mapHtmlElement, mapDomEvent, failure) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, function(param) {
        return mapState(mapHtmlElement, mapDomEvent, param);
    }, function(param) {
        return mapEvent(mapHtmlElement, mapDomEvent, param);
    }, function(param) {
        return mapSideEffect(mapHtmlElement, mapDomEvent, param);
    }, function(listener) {
        return listener;
    }, failure);
}
function mapExitReason(mapHtmlElement, mapDomEvent, exitReason) {
    return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, function(param) {
        return mapState(mapHtmlElement, mapDomEvent, param);
    }, function(param) {
        return mapEvent(mapHtmlElement, mapDomEvent, param);
    }, function(param) {
        return mapSideEffect(mapHtmlElement, mapDomEvent, param);
    }, function(listener) {
        return listener;
    }, exitReason);
}
function mapSideEffect(mapHtmlElement, mapDomEvent, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* AttachListeners */ 0:
                return /* AttachListeners */ 0;
            case /* SetupListenerForClickEvent */ 1:
                return /* SetupListenerForClickEvent */ 1;
            case /* HideMarkers */ 2:
                return /* HideMarkers */ 2;
            case /* TellBgDidFinishPlaybackPageAction */ 3:
                return /* TellBgDidFinishPlaybackPageAction */ 3;
            case /* TellBgMaybeReadyToPlaybackPagination */ 4:
                return /* TellBgMaybeReadyToPlaybackPagination */ 4;
            case /* RemoveMarkers */ 5:
                return /* RemoveMarkers */ 5;
            case /* RenderPlaybackModal */ 6:
                return /* RenderPlaybackModal */ 6;
            case /* RemovePlaybackModal */ 7:
                return /* RemovePlaybackModal */ 7;
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* RespondToBg */ 0:
                return {
                    TAG: /* RespondToBg */ 0,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* Dispatch */ 1:
                return {
                    TAG: /* Dispatch */ 1,
                    _0: mapEvent(mapHtmlElement, mapDomEvent, sideEffect._0)
                };
            case /* QuerySelectorAllForLinks */ 2:
                return {
                    TAG: /* QuerySelectorAllForLinks */ 2,
                    _0: sideEffect._0
                };
            case /* Timer */ 3:
                return {
                    TAG: /* Timer */ 3,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* AskBgToStopRecordPageAction */ 4:
                return {
                    TAG: /* AskBgToStopRecordPageAction */ 4,
                    _0: MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, sideEffect._0)
                };
            case /* RunPaginateFn */ 5:
                return {
                    TAG: /* RunPaginateFn */ 5,
                    _0: MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, sideEffect._0)
                };
            case /* ScrollToPageClick */ 6:
                return {
                    TAG: /* ScrollToPageClick */ 6,
                    _0: MultiUrlTriggering__Shared$SmartcutsMacros.ClickTarget.map(mapHtmlElement, sideEffect._0)
                };
            case /* RenderMarkers */ 7:
                return {
                    TAG: /* RenderMarkers */ 7,
                    _0: $$Array.map(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                    }, sideEffect._0)
                };
            case /* GroupLinks */ 8:
                return {
                    TAG: /* GroupLinks */ 8,
                    _0: $$Array.map(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                    }, sideEffect._0),
                    _1: sideEffect._1,
                    _2: OptionUtils$SmartcutsMacros.map(sideEffect._2, mapHtmlElement)
                };
            case /* KillTimer */ 9:
                return {
                    TAG: /* KillTimer */ 9,
                    _0: sideEffect._0
                };
            case /* TellBgToUpdateLinks */ 10:
                return {
                    TAG: /* TellBgToUpdateLinks */ 10,
                    _0: $$Array.map(function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                    }, sideEffect._0)
                };
            case /* TellBgToUpdateLinkAtIndex */ 11:
                return {
                    TAG: /* TellBgToUpdateLinkAtIndex */ 11,
                    _0: MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, sideEffect._0),
                    _1: sideEffect._1
                };
            case /* TellBgToUpdateLinkGroups */ 12:
                return {
                    TAG: /* TellBgToUpdateLinkGroups */ 12,
                    _0: sideEffect._0
                };
            case /* TellBgToUpdatePaginateFn */ 13:
                return {
                    TAG: /* TellBgToUpdatePaginateFn */ 13,
                    _0: MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, sideEffect._0)
                };
            case /* PrepareForScreenshotWithLinksAndRespond */ 14:
                return {
                    TAG: /* PrepareForScreenshotWithLinksAndRespond */ 14,
                    _0: Belt_Array.map(sideEffect._0, function(param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                    }),
                    _1: sideEffect._1
                };
            case /* ResetDebounceTimeout */ 15:
                return {
                    TAG: /* ResetDebounceTimeout */ 15,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* ClearDebounceTimeout */ 16:
                return {
                    TAG: /* ClearDebounceTimeout */ 16,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* DetachListeners */ 17:
                return {
                    TAG: /* DetachListeners */ 17,
                    _0: sideEffect._0
                };
        }
    }
}
var Generic = {
    mode_encode: mode_encode,
    mode_decode: mode_decode,
    exiting_encode: exiting_encode,
    exiting_decode: exiting_decode,
    state_encode: state_encode,
    state_decode: state_decode,
    awaitingNewLinks_encode: awaitingNewLinks_encode,
    awaitingNewLinks_decode: awaitingNewLinks_decode,
    stateCallback_encode: stateCallback_encode,
    stateCallback_decode: stateCallback_decode,
    initializing_encode: initializing_encode,
    initializing_decode: initializing_decode,
    triggeringElement_encode: triggeringElement_encode,
    triggeringElement_decode: triggeringElement_decode,
    selectingUrls_encode: selectingUrls_encode,
    selectingUrls_decode: selectingUrls_decode,
    event_encode: event_encode,
    event_decode: event_decode,
    failure_encode: failure_encode,
    failure_decode: failure_decode,
    exitReason_encode: exitReason_encode,
    exitReason_decode: exitReason_decode,
    errorContext_encode: errorContext_encode,
    errorContext_decode: errorContext_decode,
    otherFailureReason_encode: otherFailureReason_encode,
    otherFailureReason_decode: otherFailureReason_decode,
    listener_encode: listener_encode,
    listener_decode: listener_decode,
    sideEffect_encode: sideEffect_encode,
    sideEffect_decode: sideEffect_decode,
    stringifyListener: stringifyListener,
    stringifyStateCallback: stringifyStateCallback,
    stringifyTriggeringElement: stringifyTriggeringElement,
    stringifyInitializing: stringifyInitializing,
    stringifyMode: stringifyMode,
    stringifyState: stringifyState,
    stringifyEvent: stringifyEvent,
    stringifyFailure: stringifyFailure,
    stringifyOtherFailureReason: stringifyOtherFailureReason,
    stringifyExitReason: stringifyExitReason,
    stringifySideEffect: stringifySideEffect,
    mapTriggeringElement: mapTriggeringElement,
    mapInitializing: mapInitializing,
    mapState: mapState,
    mapSelectingUrls: mapSelectingUrls,
    mapStateCallback: mapStateCallback,
    mapEvent: mapEvent,
    mapFailure: mapFailure,
    mapExitReason: mapExitReason,
    mapSideEffect: mapSideEffect
};
var Regular = {};
var listener_encode$1 = listener_encode;
var listener_decode$1 = listener_decode;
function state_encode$1(v) {
    return state_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}
function state_decode$1(v) {
    return state_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}
var ForSerialization = {
    listener_encode: listener_encode$1,
    listener_decode: listener_decode$1,
    state_encode: state_encode$1,
    state_decode: state_decode$1
};
var Shared;
exports.Shared = Shared;
exports.timeoutId_encode = timeoutId_encode;
exports.timeoutId_decode = timeoutId_decode;
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 54179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__DragEvent = __webpack_require__(39575);
var Webapi__Dom__FocusEvent = __webpack_require__(63056);
var Webapi__Dom__InputEvent = __webpack_require__(82371);
var Webapi__Dom__MouseEvent = __webpack_require__(49116);
var Webapi__Dom__WheelEvent = __webpack_require__(53329);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var Webapi__Dom__KeyboardEvent = __webpack_require__(41702);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var Webapi__Dom__ClipboardEvent = __webpack_require__(69852);
var DOM__EventType$SmartcutsMacros = __webpack_require__(41639);
var DOM__DataTransfer$SmartcutsMacros = __webpack_require__(44129);
function t_encode(v) {
    if (typeof v === "number") {
        if (v !== 0) {
            return [
                "Document"
            ];
        } else {
            return [
                "Window"
            ];
        }
    } else {
        return [
            "Element",
            Selector$SmartcutsMacros.selector_encode(v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Document":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Document */ 1
                    };
                }
            case "Element":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Element */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Window":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Window */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromDomEventTarget(target) {
    if (window === target) {
        return /* Window */ 0;
    } else if (document === target) {
        return /* Document */ 1;
    } else {
        return /* Element */ {
            _0: Selector$SmartcutsMacros.forDomEventTarget(target)
        };
    }
}
function stringify(v) {
    if (typeof v === "number") {
        if (v !== 0) {
            return "Document";
        } else {
            return "Window";
        }
    } else {
        return "Element(" + (Selector$SmartcutsMacros.stringify(undefined, false, v._0) + ")");
    }
}
var EventTargetForSerialization = {
    t_encode: t_encode,
    t_decode: t_decode,
    fromDomEventTarget: fromDomEventTarget,
    stringify: stringify
};
function eventPhase_encode(v) {
    switch(v){
        case /* None */ 0:
            return [
                "None"
            ];
        case /* CapturingPhase */ 1:
            return [
                "CapturingPhase"
            ];
        case /* AtTarget */ 2:
            return [
                "AtTarget"
            ];
        case /* BubblingPhase */ 3:
            return [
                "BubblingPhase"
            ];
        case /* Unknown */ 4:
            return [
                "Unknown"
            ];
    }
}
function eventPhase_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AtTarget":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AtTarget */ 2
                    };
                }
            case "BubblingPhase":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* BubblingPhase */ 3
                    };
                }
            case "CapturingPhase":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CapturingPhase */ 1
                    };
                }
            case "None":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* None */ 0
                    };
                }
            case "Unknown":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Unknown */ 4
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function webapiEventPhaseToEventPhase(webapiEventPhase) {
    return webapiEventPhase;
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "bubbles",
            Decco.boolToJson(v.bubbles)
        ],
        [
            "cancelable",
            Decco.boolToJson(v.cancelable)
        ],
        [
            "composed",
            Decco.boolToJson(v.composed)
        ],
        [
            "currentTarget",
            Decco.optionToJson(t_encode, v.currentTarget)
        ],
        [
            "defaultPrevented",
            Decco.boolToJson(v.defaultPrevented)
        ],
        [
            "eventPhase",
            eventPhase_encode(v.eventPhase)
        ],
        [
            "target",
            t_encode(v.target)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ],
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "isTrusted",
            Decco.boolToJson(v.isTrusted)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
    if (bubbles.TAG === /* Ok */ 0) {
        var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
        if (cancelable.TAG === /* Ok */ 0) {
            var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
            if (composed.TAG === /* Ok */ 0) {
                var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                if (currentTarget.TAG === /* Ok */ 0) {
                    var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                    if (defaultPrevented.TAG === /* Ok */ 0) {
                        var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                        if (eventPhase.TAG === /* Ok */ 0) {
                            var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                            if (target.TAG === /* Ok */ 0) {
                                var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                if (timeStamp.TAG === /* Ok */ 0) {
                                    var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                    if (type_.TAG === /* Ok */ 0) {
                                        var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                        if (isTrusted.TAG === /* Ok */ 0) {
                                            return {
                                                TAG: /* Ok */ 0,
                                                _0: {
                                                    bubbles: bubbles._0,
                                                    cancelable: cancelable._0,
                                                    composed: composed._0,
                                                    currentTarget: currentTarget._0,
                                                    defaultPrevented: defaultPrevented._0,
                                                    eventPhase: eventPhase._0,
                                                    target: target._0,
                                                    timeStamp: timeStamp._0,
                                                    type_: type_._0,
                                                    isTrusted: isTrusted._0
                                                }
                                            };
                                        }
                                        var e = isTrusted._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".isTrusted" + e.path,
                                                message: e.message,
                                                value: e.value
                                            }
                                        };
                                    }
                                    var e$1 = type_._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".type_" + e$1.path,
                                            message: e$1.message,
                                            value: e$1.value
                                        }
                                    };
                                }
                                var e$2 = timeStamp._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".timeStamp" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                    }
                                };
                            }
                            var e$3 = target._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".target" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                }
                            };
                        }
                        var e$4 = eventPhase._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".eventPhase" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = defaultPrevented._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".defaultPrevented" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = currentTarget._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".currentTarget" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            }
            var e$7 = composed._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".composed" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                }
            };
        }
        var e$8 = cancelable._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".cancelable" + e$8.path,
                message: e$8.message,
                value: e$8.value
            }
        };
    }
    var e$9 = bubbles._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".bubbles" + e$9.path,
            message: e$9.message,
            value: e$9.value
        }
    };
}
function fromDomEvent($$event) {
    return {
        bubbles: $$event.bubbles,
        cancelable: $$event.cancelable,
        composed: $$event.composed,
        currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
        defaultPrevented: $$event.defaultPrevented,
        eventPhase: Webapi__Dom__Event.eventPhase($$event),
        target: fromDomEventTarget($$event.target),
        timeStamp: $$event.timeStamp,
        type_: $$event.type,
        isTrusted: $$event.isTrusted
    };
}
function stringify$1($$event) {
    return JSON.stringify(t_encode$1($$event));
}
var EventForSerialization = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromDomEvent: fromDomEvent,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "target",
            t_encode(v.target)
        ],
        [
            "clipboardWhenOpened",
            Decco.stringToJson(v.clipboardWhenOpened)
        ],
        [
            "clipboardWhenClosed",
            Decco.stringToJson(v.clipboardWhenClosed)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
    if (target.TAG === /* Ok */ 0) {
        var clipboardWhenOpened = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardWhenOpened"), null));
        if (clipboardWhenOpened.TAG === /* Ok */ 0) {
            var clipboardWhenClosed = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardWhenClosed"), null));
            if (clipboardWhenClosed.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        target: target._0,
                        clipboardWhenOpened: clipboardWhenOpened._0,
                        clipboardWhenClosed: clipboardWhenClosed._0
                    }
                };
            }
            var e = clipboardWhenClosed._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".clipboardWhenClosed" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = clipboardWhenOpened._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".clipboardWhenOpened" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = target._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".target" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$2(param) {
    return "{target, clipboardWhenOpened: " + (StringUtils$SmartcutsMacros.quote(param.clipboardWhenOpened) + (", clipboardWhenClosed: " + (StringUtils$SmartcutsMacros.quote(param.clipboardWhenClosed) + "}")));
}
var ContextMenuClosedForSerialization = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2
};
function t_encode$3(v) {
    return [
        "ContextMenuClosed",
        t_encode$2(v._0)
    ];
}
function t_decode$3(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ContextMenuClosed") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ContextMenuClosed */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromSyntheticEvent($$event) {
    var match = $$event._0;
    return /* ContextMenuClosed */ {
        _0: {
            target: fromDomEventTarget(match.target),
            clipboardWhenOpened: match.clipboardWhenOpened,
            clipboardWhenClosed: match.clipboardWhenClosed
        }
    };
}
function stringify$3($$event) {
    return "ContextMenuClosed(" + (stringify$2($$event._0) + ")");
}
var SyntheticEventForSerialization = {
    ContextMenuClosedForSerialization: ContextMenuClosedForSerialization,
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromSyntheticEvent: fromSyntheticEvent,
    stringify: stringify$3
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "altKey",
            Decco.boolToJson(v.altKey)
        ],
        [
            "button",
            Decco.intToJson(v.button)
        ],
        [
            "buttons",
            Decco.intToJson(v.buttons)
        ],
        [
            "clientX",
            Decco.floatToJson(v.clientX)
        ],
        [
            "clientY",
            Decco.floatToJson(v.clientY)
        ],
        [
            "ctrlKey",
            Decco.boolToJson(v.ctrlKey)
        ],
        [
            "metaKey",
            Decco.boolToJson(v.metaKey)
        ],
        [
            "movementX",
            Decco.intToJson(v.movementX)
        ],
        [
            "movementY",
            Decco.intToJson(v.movementY)
        ],
        [
            "offsetX",
            Decco.intToJson(v.offsetX)
        ],
        [
            "offsetY",
            Decco.intToJson(v.offsetY)
        ],
        [
            "pageX",
            Decco.intToJson(v.pageX)
        ],
        [
            "pageY",
            Decco.intToJson(v.pageY)
        ],
        [
            "region",
            Decco.optionToJson(Decco.stringToJson, v.region)
        ],
        [
            "relatedTarget",
            Decco.optionToJson(t_encode, v.relatedTarget)
        ],
        [
            "screenX",
            Decco.intToJson(v.screenX)
        ],
        [
            "screenY",
            Decco.intToJson(v.screenY)
        ],
        [
            "shiftKey",
            Decco.boolToJson(v.shiftKey)
        ],
        [
            "x",
            Decco.intToJson(v.x)
        ],
        [
            "y",
            Decco.intToJson(v.y)
        ],
        [
            "detail",
            Decco.intToJson(v.detail)
        ],
        [
            "bubbles",
            Decco.boolToJson(v.bubbles)
        ],
        [
            "cancelable",
            Decco.boolToJson(v.cancelable)
        ],
        [
            "composed",
            Decco.boolToJson(v.composed)
        ],
        [
            "currentTarget",
            Decco.optionToJson(t_encode, v.currentTarget)
        ],
        [
            "defaultPrevented",
            Decco.boolToJson(v.defaultPrevented)
        ],
        [
            "eventPhase",
            eventPhase_encode(v.eventPhase)
        ],
        [
            "target",
            t_encode(v.target)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ],
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "isTrusted",
            Decco.boolToJson(v.isTrusted)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
    if (altKey.TAG === /* Ok */ 0) {
        var button = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button"), null));
        if (button.TAG === /* Ok */ 0) {
            var buttons = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "buttons"), null));
            if (buttons.TAG === /* Ok */ 0) {
                var clientX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientX"), null));
                if (clientX.TAG === /* Ok */ 0) {
                    var clientY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientY"), null));
                    if (clientY.TAG === /* Ok */ 0) {
                        var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
                        if (ctrlKey.TAG === /* Ok */ 0) {
                            var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
                            if (metaKey.TAG === /* Ok */ 0) {
                                var movementX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementX"), null));
                                if (movementX.TAG === /* Ok */ 0) {
                                    var movementY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementY"), null));
                                    if (movementY.TAG === /* Ok */ 0) {
                                        var offsetX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetX"), null));
                                        if (offsetX.TAG === /* Ok */ 0) {
                                            var offsetY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetY"), null));
                                            if (offsetY.TAG === /* Ok */ 0) {
                                                var pageX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageX"), null));
                                                if (pageX.TAG === /* Ok */ 0) {
                                                    var pageY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageY"), null));
                                                    if (pageY.TAG === /* Ok */ 0) {
                                                        var region = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "region"), null));
                                                        if (region.TAG === /* Ok */ 0) {
                                                            var relatedTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
                                                            if (relatedTarget.TAG === /* Ok */ 0) {
                                                                var screenX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenX"), null));
                                                                if (screenX.TAG === /* Ok */ 0) {
                                                                    var screenY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenY"), null));
                                                                    if (screenY.TAG === /* Ok */ 0) {
                                                                        var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                                                                        if (shiftKey.TAG === /* Ok */ 0) {
                                                                            var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
                                                                            if (x.TAG === /* Ok */ 0) {
                                                                                var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
                                                                                if (y.TAG === /* Ok */ 0) {
                                                                                    var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
                                                                                    if (detail.TAG === /* Ok */ 0) {
                                                                                        var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                                                                                        if (bubbles.TAG === /* Ok */ 0) {
                                                                                            var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                                                                                            if (cancelable.TAG === /* Ok */ 0) {
                                                                                                var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                                                                                                if (composed.TAG === /* Ok */ 0) {
                                                                                                    var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                                                                                                    if (currentTarget.TAG === /* Ok */ 0) {
                                                                                                        var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                                                                                                        if (defaultPrevented.TAG === /* Ok */ 0) {
                                                                                                            var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                                                                                            if (eventPhase.TAG === /* Ok */ 0) {
                                                                                                                var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                                                                                                if (target.TAG === /* Ok */ 0) {
                                                                                                                    var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                                                                                                    if (timeStamp.TAG === /* Ok */ 0) {
                                                                                                                        var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                                                                                                        if (type_.TAG === /* Ok */ 0) {
                                                                                                                            var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                                                                                            if (isTrusted.TAG === /* Ok */ 0) {
                                                                                                                                return {
                                                                                                                                    TAG: /* Ok */ 0,
                                                                                                                                    _0: {
                                                                                                                                        altKey: altKey._0,
                                                                                                                                        button: button._0,
                                                                                                                                        buttons: buttons._0,
                                                                                                                                        clientX: clientX._0,
                                                                                                                                        clientY: clientY._0,
                                                                                                                                        ctrlKey: ctrlKey._0,
                                                                                                                                        metaKey: metaKey._0,
                                                                                                                                        movementX: movementX._0,
                                                                                                                                        movementY: movementY._0,
                                                                                                                                        offsetX: offsetX._0,
                                                                                                                                        offsetY: offsetY._0,
                                                                                                                                        pageX: pageX._0,
                                                                                                                                        pageY: pageY._0,
                                                                                                                                        region: region._0,
                                                                                                                                        relatedTarget: relatedTarget._0,
                                                                                                                                        screenX: screenX._0,
                                                                                                                                        screenY: screenY._0,
                                                                                                                                        shiftKey: shiftKey._0,
                                                                                                                                        x: x._0,
                                                                                                                                        y: y._0,
                                                                                                                                        detail: detail._0,
                                                                                                                                        bubbles: bubbles._0,
                                                                                                                                        cancelable: cancelable._0,
                                                                                                                                        composed: composed._0,
                                                                                                                                        currentTarget: currentTarget._0,
                                                                                                                                        defaultPrevented: defaultPrevented._0,
                                                                                                                                        eventPhase: eventPhase._0,
                                                                                                                                        target: target._0,
                                                                                                                                        timeStamp: timeStamp._0,
                                                                                                                                        type_: type_._0,
                                                                                                                                        isTrusted: isTrusted._0
                                                                                                                                    }
                                                                                                                                };
                                                                                                                            }
                                                                                                                            var e = isTrusted._0;
                                                                                                                            return {
                                                                                                                                TAG: /* Error */ 1,
                                                                                                                                _0: {
                                                                                                                                    path: ".isTrusted" + e.path,
                                                                                                                                    message: e.message,
                                                                                                                                    value: e.value
                                                                                                                                }
                                                                                                                            };
                                                                                                                        }
                                                                                                                        var e$1 = type_._0;
                                                                                                                        return {
                                                                                                                            TAG: /* Error */ 1,
                                                                                                                            _0: {
                                                                                                                                path: ".type_" + e$1.path,
                                                                                                                                message: e$1.message,
                                                                                                                                value: e$1.value
                                                                                                                            }
                                                                                                                        };
                                                                                                                    }
                                                                                                                    var e$2 = timeStamp._0;
                                                                                                                    return {
                                                                                                                        TAG: /* Error */ 1,
                                                                                                                        _0: {
                                                                                                                            path: ".timeStamp" + e$2.path,
                                                                                                                            message: e$2.message,
                                                                                                                            value: e$2.value
                                                                                                                        }
                                                                                                                    };
                                                                                                                }
                                                                                                                var e$3 = target._0;
                                                                                                                return {
                                                                                                                    TAG: /* Error */ 1,
                                                                                                                    _0: {
                                                                                                                        path: ".target" + e$3.path,
                                                                                                                        message: e$3.message,
                                                                                                                        value: e$3.value
                                                                                                                    }
                                                                                                                };
                                                                                                            }
                                                                                                            var e$4 = eventPhase._0;
                                                                                                            return {
                                                                                                                TAG: /* Error */ 1,
                                                                                                                _0: {
                                                                                                                    path: ".eventPhase" + e$4.path,
                                                                                                                    message: e$4.message,
                                                                                                                    value: e$4.value
                                                                                                                }
                                                                                                            };
                                                                                                        }
                                                                                                        var e$5 = defaultPrevented._0;
                                                                                                        return {
                                                                                                            TAG: /* Error */ 1,
                                                                                                            _0: {
                                                                                                                path: ".defaultPrevented" + e$5.path,
                                                                                                                message: e$5.message,
                                                                                                                value: e$5.value
                                                                                                            }
                                                                                                        };
                                                                                                    }
                                                                                                    var e$6 = currentTarget._0;
                                                                                                    return {
                                                                                                        TAG: /* Error */ 1,
                                                                                                        _0: {
                                                                                                            path: ".currentTarget" + e$6.path,
                                                                                                            message: e$6.message,
                                                                                                            value: e$6.value
                                                                                                        }
                                                                                                    };
                                                                                                }
                                                                                                var e$7 = composed._0;
                                                                                                return {
                                                                                                    TAG: /* Error */ 1,
                                                                                                    _0: {
                                                                                                        path: ".composed" + e$7.path,
                                                                                                        message: e$7.message,
                                                                                                        value: e$7.value
                                                                                                    }
                                                                                                };
                                                                                            }
                                                                                            var e$8 = cancelable._0;
                                                                                            return {
                                                                                                TAG: /* Error */ 1,
                                                                                                _0: {
                                                                                                    path: ".cancelable" + e$8.path,
                                                                                                    message: e$8.message,
                                                                                                    value: e$8.value
                                                                                                }
                                                                                            };
                                                                                        }
                                                                                        var e$9 = bubbles._0;
                                                                                        return {
                                                                                            TAG: /* Error */ 1,
                                                                                            _0: {
                                                                                                path: ".bubbles" + e$9.path,
                                                                                                message: e$9.message,
                                                                                                value: e$9.value
                                                                                            }
                                                                                        };
                                                                                    }
                                                                                    var e$10 = detail._0;
                                                                                    return {
                                                                                        TAG: /* Error */ 1,
                                                                                        _0: {
                                                                                            path: ".detail" + e$10.path,
                                                                                            message: e$10.message,
                                                                                            value: e$10.value
                                                                                        }
                                                                                    };
                                                                                }
                                                                                var e$11 = y._0;
                                                                                return {
                                                                                    TAG: /* Error */ 1,
                                                                                    _0: {
                                                                                        path: ".y" + e$11.path,
                                                                                        message: e$11.message,
                                                                                        value: e$11.value
                                                                                    }
                                                                                };
                                                                            }
                                                                            var e$12 = x._0;
                                                                            return {
                                                                                TAG: /* Error */ 1,
                                                                                _0: {
                                                                                    path: ".x" + e$12.path,
                                                                                    message: e$12.message,
                                                                                    value: e$12.value
                                                                                }
                                                                            };
                                                                        }
                                                                        var e$13 = shiftKey._0;
                                                                        return {
                                                                            TAG: /* Error */ 1,
                                                                            _0: {
                                                                                path: ".shiftKey" + e$13.path,
                                                                                message: e$13.message,
                                                                                value: e$13.value
                                                                            }
                                                                        };
                                                                    }
                                                                    var e$14 = screenY._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".screenY" + e$14.path,
                                                                            message: e$14.message,
                                                                            value: e$14.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$15 = screenX._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".screenX" + e$15.path,
                                                                        message: e$15.message,
                                                                        value: e$15.value
                                                                    }
                                                                };
                                                            }
                                                            var e$16 = relatedTarget._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".relatedTarget" + e$16.path,
                                                                    message: e$16.message,
                                                                    value: e$16.value
                                                                }
                                                            };
                                                        }
                                                        var e$17 = region._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".region" + e$17.path,
                                                                message: e$17.message,
                                                                value: e$17.value
                                                            }
                                                        };
                                                    }
                                                    var e$18 = pageY._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".pageY" + e$18.path,
                                                            message: e$18.message,
                                                            value: e$18.value
                                                        }
                                                    };
                                                }
                                                var e$19 = pageX._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".pageX" + e$19.path,
                                                        message: e$19.message,
                                                        value: e$19.value
                                                    }
                                                };
                                            }
                                            var e$20 = offsetY._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".offsetY" + e$20.path,
                                                    message: e$20.message,
                                                    value: e$20.value
                                                }
                                            };
                                        }
                                        var e$21 = offsetX._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".offsetX" + e$21.path,
                                                message: e$21.message,
                                                value: e$21.value
                                            }
                                        };
                                    }
                                    var e$22 = movementY._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".movementY" + e$22.path,
                                            message: e$22.message,
                                            value: e$22.value
                                        }
                                    };
                                }
                                var e$23 = movementX._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".movementX" + e$23.path,
                                        message: e$23.message,
                                        value: e$23.value
                                    }
                                };
                            }
                            var e$24 = metaKey._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".metaKey" + e$24.path,
                                    message: e$24.message,
                                    value: e$24.value
                                }
                            };
                        }
                        var e$25 = ctrlKey._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".ctrlKey" + e$25.path,
                                message: e$25.message,
                                value: e$25.value
                            }
                        };
                    }
                    var e$26 = clientY._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".clientY" + e$26.path,
                            message: e$26.message,
                            value: e$26.value
                        }
                    };
                }
                var e$27 = clientX._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".clientX" + e$27.path,
                        message: e$27.message,
                        value: e$27.value
                    }
                };
            }
            var e$28 = buttons._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".buttons" + e$28.path,
                    message: e$28.message,
                    value: e$28.value
                }
            };
        }
        var e$29 = button._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".button" + e$29.path,
                message: e$29.message,
                value: e$29.value
            }
        };
    }
    var e$30 = altKey._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".altKey" + e$30.path,
            message: e$30.message,
            value: e$30.value
        }
    };
}
function fromDomMouseEvent($$event) {
    return {
        altKey: $$event.altKey,
        button: $$event.button,
        buttons: $$event.buttons,
        clientX: $$event.clientX,
        clientY: $$event.clientY,
        ctrlKey: $$event.ctrlKey,
        metaKey: $$event.metaKey,
        movementX: $$event.movementX,
        movementY: $$event.movementY,
        offsetX: $$event.offsetX,
        offsetY: $$event.offsetY,
        pageX: $$event.pageX,
        pageY: $$event.pageY,
        region: Caml_option.nullable_to_opt($$event.region),
        relatedTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.relatedTarget), fromDomEventTarget),
        screenX: $$event.screenX,
        screenY: $$event.screenY,
        shiftKey: $$event.shiftKey,
        x: $$event.x,
        y: $$event.y,
        detail: $$event.detail,
        bubbles: $$event.bubbles,
        cancelable: $$event.cancelable,
        composed: $$event.composed,
        currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
        defaultPrevented: $$event.defaultPrevented,
        eventPhase: Curry._1(Webapi__Dom__MouseEvent.eventPhase, $$event),
        target: fromDomEventTarget($$event.target),
        timeStamp: $$event.timeStamp,
        type_: $$event.type,
        isTrusted: $$event.isTrusted
    };
}
function stringify$4($$event) {
    return JSON.stringify(t_encode$4($$event));
}
var MouseEventForSerialization = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    fromDomMouseEvent: fromDomMouseEvent,
    stringify: stringify$4
};
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "data",
            Decco.optionToJson(Decco.stringToJson, v.data)
        ],
        [
            "isComposing",
            Decco.boolToJson(v.isComposing)
        ],
        [
            "detail",
            Decco.intToJson(v.detail)
        ],
        [
            "bubbles",
            Decco.boolToJson(v.bubbles)
        ],
        [
            "cancelable",
            Decco.boolToJson(v.cancelable)
        ],
        [
            "composed",
            Decco.boolToJson(v.composed)
        ],
        [
            "currentTarget",
            Decco.optionToJson(t_encode, v.currentTarget)
        ],
        [
            "defaultPrevented",
            Decco.boolToJson(v.defaultPrevented)
        ],
        [
            "eventPhase",
            eventPhase_encode(v.eventPhase)
        ],
        [
            "target",
            t_encode(v.target)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ],
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "isTrusted",
            Decco.boolToJson(v.isTrusted)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var data = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "data"), null));
    if (data.TAG === /* Ok */ 0) {
        var isComposing = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isComposing"), null));
        if (isComposing.TAG === /* Ok */ 0) {
            var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
            if (detail.TAG === /* Ok */ 0) {
                var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                if (bubbles.TAG === /* Ok */ 0) {
                    var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                    if (cancelable.TAG === /* Ok */ 0) {
                        var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                        if (composed.TAG === /* Ok */ 0) {
                            var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                            if (currentTarget.TAG === /* Ok */ 0) {
                                var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                                if (defaultPrevented.TAG === /* Ok */ 0) {
                                    var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                    if (eventPhase.TAG === /* Ok */ 0) {
                                        var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                        if (target.TAG === /* Ok */ 0) {
                                            var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                            if (timeStamp.TAG === /* Ok */ 0) {
                                                var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                                if (type_.TAG === /* Ok */ 0) {
                                                    var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                    if (isTrusted.TAG === /* Ok */ 0) {
                                                        return {
                                                            TAG: /* Ok */ 0,
                                                            _0: {
                                                                data: data._0,
                                                                isComposing: isComposing._0,
                                                                detail: detail._0,
                                                                bubbles: bubbles._0,
                                                                cancelable: cancelable._0,
                                                                composed: composed._0,
                                                                currentTarget: currentTarget._0,
                                                                defaultPrevented: defaultPrevented._0,
                                                                eventPhase: eventPhase._0,
                                                                target: target._0,
                                                                timeStamp: timeStamp._0,
                                                                type_: type_._0,
                                                                isTrusted: isTrusted._0
                                                            }
                                                        };
                                                    }
                                                    var e = isTrusted._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".isTrusted" + e.path,
                                                            message: e.message,
                                                            value: e.value
                                                        }
                                                    };
                                                }
                                                var e$1 = type_._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".type_" + e$1.path,
                                                        message: e$1.message,
                                                        value: e$1.value
                                                    }
                                                };
                                            }
                                            var e$2 = timeStamp._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".timeStamp" + e$2.path,
                                                    message: e$2.message,
                                                    value: e$2.value
                                                }
                                            };
                                        }
                                        var e$3 = target._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".target" + e$3.path,
                                                message: e$3.message,
                                                value: e$3.value
                                            }
                                        };
                                    }
                                    var e$4 = eventPhase._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".eventPhase" + e$4.path,
                                            message: e$4.message,
                                            value: e$4.value
                                        }
                                    };
                                }
                                var e$5 = defaultPrevented._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".defaultPrevented" + e$5.path,
                                        message: e$5.message,
                                        value: e$5.value
                                    }
                                };
                            }
                            var e$6 = currentTarget._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".currentTarget" + e$6.path,
                                    message: e$6.message,
                                    value: e$6.value
                                }
                            };
                        }
                        var e$7 = composed._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".composed" + e$7.path,
                                message: e$7.message,
                                value: e$7.value
                            }
                        };
                    }
                    var e$8 = cancelable._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".cancelable" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                        }
                    };
                }
                var e$9 = bubbles._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".bubbles" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            }
            var e$10 = detail._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".detail" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                }
            };
        }
        var e$11 = isComposing._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".isComposing" + e$11.path,
                message: e$11.message,
                value: e$11.value
            }
        };
    }
    var e$12 = data._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".data" + e$12.path,
            message: e$12.message,
            value: e$12.value
        }
    };
}
function fromDomInputEvent($$event) {
    return {
        data: Belt_Option.flatMap(Caml_option.nullable_to_opt($$event.data), function(str) {
            if (str == null) {
                return;
            } else {
                return Caml_option.some(str);
            }
        }),
        isComposing: $$event.isComposing,
        detail: $$event.detail,
        bubbles: $$event.bubbles,
        cancelable: $$event.cancelable,
        composed: $$event.composed,
        currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
        defaultPrevented: $$event.defaultPrevented,
        eventPhase: Curry._1(Webapi__Dom__InputEvent.eventPhase, $$event),
        target: fromDomEventTarget($$event.target),
        timeStamp: $$event.timeStamp,
        type_: $$event.type,
        isTrusted: $$event.isTrusted
    };
}
function stringify$5($$event) {
    return JSON.stringify(t_encode$5($$event));
}
var InputEventForSerialization = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromDomInputEvent: fromDomInputEvent,
    stringify: stringify$5
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "altKey",
            Decco.boolToJson(v.altKey)
        ],
        [
            "code",
            Decco.stringToJson(v.code)
        ],
        [
            "ctrlKey",
            Decco.boolToJson(v.ctrlKey)
        ],
        [
            "isComposing",
            Decco.boolToJson(v.isComposing)
        ],
        [
            "key",
            Decco.stringToJson(v.key)
        ],
        [
            "location",
            Decco.intToJson(v.location)
        ],
        [
            "metaKey",
            Decco.boolToJson(v.metaKey)
        ],
        [
            "repeat",
            Decco.boolToJson(v.repeat)
        ],
        [
            "shiftKey",
            Decco.boolToJson(v.shiftKey)
        ],
        [
            "detail",
            Decco.intToJson(v.detail)
        ],
        [
            "bubbles",
            Decco.boolToJson(v.bubbles)
        ],
        [
            "cancelable",
            Decco.boolToJson(v.cancelable)
        ],
        [
            "composed",
            Decco.boolToJson(v.composed)
        ],
        [
            "currentTarget",
            Decco.optionToJson(t_encode, v.currentTarget)
        ],
        [
            "defaultPrevented",
            Decco.boolToJson(v.defaultPrevented)
        ],
        [
            "eventPhase",
            eventPhase_encode(v.eventPhase)
        ],
        [
            "target",
            t_encode(v.target)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ],
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "isTrusted",
            Decco.boolToJson(v.isTrusted)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
    if (altKey.TAG === /* Ok */ 0) {
        var code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
        if (code.TAG === /* Ok */ 0) {
            var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
            if (ctrlKey.TAG === /* Ok */ 0) {
                var isComposing = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isComposing"), null));
                if (isComposing.TAG === /* Ok */ 0) {
                    var key = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "key"), null));
                    if (key.TAG === /* Ok */ 0) {
                        var $$location = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
                        if ($$location.TAG === /* Ok */ 0) {
                            var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
                            if (metaKey.TAG === /* Ok */ 0) {
                                var repeat = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "repeat"), null));
                                if (repeat.TAG === /* Ok */ 0) {
                                    var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                                    if (shiftKey.TAG === /* Ok */ 0) {
                                        var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
                                        if (detail.TAG === /* Ok */ 0) {
                                            var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                                            if (bubbles.TAG === /* Ok */ 0) {
                                                var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                                                if (cancelable.TAG === /* Ok */ 0) {
                                                    var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                                                    if (composed.TAG === /* Ok */ 0) {
                                                        var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                                                        if (currentTarget.TAG === /* Ok */ 0) {
                                                            var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                                                            if (defaultPrevented.TAG === /* Ok */ 0) {
                                                                var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                                                if (eventPhase.TAG === /* Ok */ 0) {
                                                                    var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                                                    if (target.TAG === /* Ok */ 0) {
                                                                        var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                                                        if (timeStamp.TAG === /* Ok */ 0) {
                                                                            var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                                                            if (type_.TAG === /* Ok */ 0) {
                                                                                var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                                                if (isTrusted.TAG === /* Ok */ 0) {
                                                                                    return {
                                                                                        TAG: /* Ok */ 0,
                                                                                        _0: {
                                                                                            altKey: altKey._0,
                                                                                            code: code._0,
                                                                                            ctrlKey: ctrlKey._0,
                                                                                            isComposing: isComposing._0,
                                                                                            key: key._0,
                                                                                            location: $$location._0,
                                                                                            metaKey: metaKey._0,
                                                                                            repeat: repeat._0,
                                                                                            shiftKey: shiftKey._0,
                                                                                            detail: detail._0,
                                                                                            bubbles: bubbles._0,
                                                                                            cancelable: cancelable._0,
                                                                                            composed: composed._0,
                                                                                            currentTarget: currentTarget._0,
                                                                                            defaultPrevented: defaultPrevented._0,
                                                                                            eventPhase: eventPhase._0,
                                                                                            target: target._0,
                                                                                            timeStamp: timeStamp._0,
                                                                                            type_: type_._0,
                                                                                            isTrusted: isTrusted._0
                                                                                        }
                                                                                    };
                                                                                }
                                                                                var e = isTrusted._0;
                                                                                return {
                                                                                    TAG: /* Error */ 1,
                                                                                    _0: {
                                                                                        path: ".isTrusted" + e.path,
                                                                                        message: e.message,
                                                                                        value: e.value
                                                                                    }
                                                                                };
                                                                            }
                                                                            var e$1 = type_._0;
                                                                            return {
                                                                                TAG: /* Error */ 1,
                                                                                _0: {
                                                                                    path: ".type_" + e$1.path,
                                                                                    message: e$1.message,
                                                                                    value: e$1.value
                                                                                }
                                                                            };
                                                                        }
                                                                        var e$2 = timeStamp._0;
                                                                        return {
                                                                            TAG: /* Error */ 1,
                                                                            _0: {
                                                                                path: ".timeStamp" + e$2.path,
                                                                                message: e$2.message,
                                                                                value: e$2.value
                                                                            }
                                                                        };
                                                                    }
                                                                    var e$3 = target._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".target" + e$3.path,
                                                                            message: e$3.message,
                                                                            value: e$3.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$4 = eventPhase._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".eventPhase" + e$4.path,
                                                                        message: e$4.message,
                                                                        value: e$4.value
                                                                    }
                                                                };
                                                            }
                                                            var e$5 = defaultPrevented._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".defaultPrevented" + e$5.path,
                                                                    message: e$5.message,
                                                                    value: e$5.value
                                                                }
                                                            };
                                                        }
                                                        var e$6 = currentTarget._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".currentTarget" + e$6.path,
                                                                message: e$6.message,
                                                                value: e$6.value
                                                            }
                                                        };
                                                    }
                                                    var e$7 = composed._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".composed" + e$7.path,
                                                            message: e$7.message,
                                                            value: e$7.value
                                                        }
                                                    };
                                                }
                                                var e$8 = cancelable._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".cancelable" + e$8.path,
                                                        message: e$8.message,
                                                        value: e$8.value
                                                    }
                                                };
                                            }
                                            var e$9 = bubbles._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".bubbles" + e$9.path,
                                                    message: e$9.message,
                                                    value: e$9.value
                                                }
                                            };
                                        }
                                        var e$10 = detail._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".detail" + e$10.path,
                                                message: e$10.message,
                                                value: e$10.value
                                            }
                                        };
                                    }
                                    var e$11 = shiftKey._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".shiftKey" + e$11.path,
                                            message: e$11.message,
                                            value: e$11.value
                                        }
                                    };
                                }
                                var e$12 = repeat._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".repeat" + e$12.path,
                                        message: e$12.message,
                                        value: e$12.value
                                    }
                                };
                            }
                            var e$13 = metaKey._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".metaKey" + e$13.path,
                                    message: e$13.message,
                                    value: e$13.value
                                }
                            };
                        }
                        var e$14 = $$location._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".location" + e$14.path,
                                message: e$14.message,
                                value: e$14.value
                            }
                        };
                    }
                    var e$15 = key._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".key" + e$15.path,
                            message: e$15.message,
                            value: e$15.value
                        }
                    };
                }
                var e$16 = isComposing._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".isComposing" + e$16.path,
                        message: e$16.message,
                        value: e$16.value
                    }
                };
            }
            var e$17 = ctrlKey._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".ctrlKey" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                }
            };
        }
        var e$18 = code._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".code" + e$18.path,
                message: e$18.message,
                value: e$18.value
            }
        };
    }
    var e$19 = altKey._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".altKey" + e$19.path,
            message: e$19.message,
            value: e$19.value
        }
    };
}
function fromDomKeyboardEvent($$event) {
    return {
        altKey: $$event.altKey,
        code: $$event.code,
        ctrlKey: $$event.ctrlKey,
        isComposing: $$event.isComposing,
        key: $$event.key,
        location: $$event.location,
        metaKey: $$event.metaKey,
        repeat: $$event.repeat,
        shiftKey: $$event.shiftKey,
        detail: $$event.detail,
        bubbles: $$event.bubbles,
        cancelable: $$event.cancelable,
        composed: $$event.composed,
        currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
        defaultPrevented: $$event.defaultPrevented,
        eventPhase: Curry._1(Webapi__Dom__KeyboardEvent.eventPhase, $$event),
        target: fromDomEventTarget($$event.target),
        timeStamp: $$event.timeStamp,
        type_: $$event.type,
        isTrusted: $$event.isTrusted
    };
}
function stringify$6($$event) {
    return JSON.stringify(t_encode$6($$event));
}
var KeyboardEventForSerialization = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    fromDomKeyboardEvent: fromDomKeyboardEvent,
    stringify: stringify$6
};
function t_encode$7(v) {
    return Js_dict.fromArray([
        [
            "clipboardData",
            Decco.stringToJson(v.clipboardData)
        ],
        [
            "bubbles",
            Decco.boolToJson(v.bubbles)
        ],
        [
            "cancelable",
            Decco.boolToJson(v.cancelable)
        ],
        [
            "composed",
            Decco.boolToJson(v.composed)
        ],
        [
            "currentTarget",
            Decco.optionToJson(t_encode, v.currentTarget)
        ],
        [
            "defaultPrevented",
            Decco.boolToJson(v.defaultPrevented)
        ],
        [
            "eventPhase",
            eventPhase_encode(v.eventPhase)
        ],
        [
            "target",
            t_encode(v.target)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ],
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "isTrusted",
            Decco.boolToJson(v.isTrusted)
        ]
    ]);
}
function t_decode$7(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var clipboardData = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardData"), null));
    if (clipboardData.TAG === /* Ok */ 0) {
        var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
        if (bubbles.TAG === /* Ok */ 0) {
            var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
            if (cancelable.TAG === /* Ok */ 0) {
                var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                if (composed.TAG === /* Ok */ 0) {
                    var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                    if (currentTarget.TAG === /* Ok */ 0) {
                        var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                        if (defaultPrevented.TAG === /* Ok */ 0) {
                            var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                            if (eventPhase.TAG === /* Ok */ 0) {
                                var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                if (target.TAG === /* Ok */ 0) {
                                    var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                    if (timeStamp.TAG === /* Ok */ 0) {
                                        var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                        if (type_.TAG === /* Ok */ 0) {
                                            var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                            if (isTrusted.TAG === /* Ok */ 0) {
                                                return {
                                                    TAG: /* Ok */ 0,
                                                    _0: {
                                                        clipboardData: clipboardData._0,
                                                        bubbles: bubbles._0,
                                                        cancelable: cancelable._0,
                                                        composed: composed._0,
                                                        currentTarget: currentTarget._0,
                                                        defaultPrevented: defaultPrevented._0,
                                                        eventPhase: eventPhase._0,
                                                        target: target._0,
                                                        timeStamp: timeStamp._0,
                                                        type_: type_._0,
                                                        isTrusted: isTrusted._0
                                                    }
                                                };
                                            }
                                            var e = isTrusted._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".isTrusted" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                }
                                            };
                                        }
                                        var e$1 = type_._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".type_" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                            }
                                        };
                                    }
                                    var e$2 = timeStamp._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".timeStamp" + e$2.path,
                                            message: e$2.message,
                                            value: e$2.value
                                        }
                                    };
                                }
                                var e$3 = target._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".target" + e$3.path,
                                        message: e$3.message,
                                        value: e$3.value
                                    }
                                };
                            }
                            var e$4 = eventPhase._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".eventPhase" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                }
                            };
                        }
                        var e$5 = defaultPrevented._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".defaultPrevented" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = currentTarget._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".currentTarget" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = composed._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".composed" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            }
            var e$8 = cancelable._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".cancelable" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        }
        var e$9 = bubbles._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".bubbles" + e$9.path,
                message: e$9.message,
                value: e$9.value
            }
        };
    }
    var e$10 = clipboardData._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".clipboardData" + e$10.path,
            message: e$10.message,
            value: e$10.value
        }
    };
}
function fromDomClipboardEvent($$event) {
    return {
        clipboardData: DOM__DataTransfer$SmartcutsMacros.getData("text", $$event.clipboardData),
        bubbles: $$event.bubbles,
        cancelable: $$event.cancelable,
        composed: $$event.composed,
        currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
        defaultPrevented: $$event.defaultPrevented,
        eventPhase: Curry._1(Webapi__Dom__ClipboardEvent.eventPhase, $$event),
        target: fromDomEventTarget($$event.target),
        timeStamp: $$event.timeStamp,
        type_: $$event.type,
        isTrusted: $$event.isTrusted
    };
}
function stringify$7($$event) {
    return JSON.stringify(t_encode$7($$event));
}
var ClipboardEventForSerialization = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    fromDomClipboardEvent: fromDomClipboardEvent,
    stringify: stringify$7
};
function t_encode$8(v) {
    return Js_dict.fromArray([
        [
            "dataTransfer",
            Decco.stringToJson(v.dataTransfer)
        ],
        [
            "altKey",
            Decco.boolToJson(v.altKey)
        ],
        [
            "button",
            Decco.intToJson(v.button)
        ],
        [
            "buttons",
            Decco.intToJson(v.buttons)
        ],
        [
            "clientX",
            Decco.floatToJson(v.clientX)
        ],
        [
            "clientY",
            Decco.floatToJson(v.clientY)
        ],
        [
            "ctrlKey",
            Decco.boolToJson(v.ctrlKey)
        ],
        [
            "metaKey",
            Decco.boolToJson(v.metaKey)
        ],
        [
            "movementX",
            Decco.intToJson(v.movementX)
        ],
        [
            "movementY",
            Decco.intToJson(v.movementY)
        ],
        [
            "offsetX",
            Decco.intToJson(v.offsetX)
        ],
        [
            "offsetY",
            Decco.intToJson(v.offsetY)
        ],
        [
            "pageX",
            Decco.intToJson(v.pageX)
        ],
        [
            "pageY",
            Decco.intToJson(v.pageY)
        ],
        [
            "region",
            Decco.optionToJson(Decco.stringToJson, v.region)
        ],
        [
            "relatedTarget",
            Decco.optionToJson(t_encode, v.relatedTarget)
        ],
        [
            "screenX",
            Decco.intToJson(v.screenX)
        ],
        [
            "screenY",
            Decco.intToJson(v.screenY)
        ],
        [
            "shiftKey",
            Decco.boolToJson(v.shiftKey)
        ],
        [
            "x",
            Decco.intToJson(v.x)
        ],
        [
            "y",
            Decco.intToJson(v.y)
        ],
        [
            "detail",
            Decco.intToJson(v.detail)
        ],
        [
            "bubbles",
            Decco.boolToJson(v.bubbles)
        ],
        [
            "cancelable",
            Decco.boolToJson(v.cancelable)
        ],
        [
            "composed",
            Decco.boolToJson(v.composed)
        ],
        [
            "currentTarget",
            Decco.optionToJson(t_encode, v.currentTarget)
        ],
        [
            "defaultPrevented",
            Decco.boolToJson(v.defaultPrevented)
        ],
        [
            "eventPhase",
            eventPhase_encode(v.eventPhase)
        ],
        [
            "target",
            t_encode(v.target)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ],
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "isTrusted",
            Decco.boolToJson(v.isTrusted)
        ]
    ]);
}
function t_decode$8(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var dataTransfer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataTransfer"), null));
    if (dataTransfer.TAG === /* Ok */ 0) {
        var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
        if (altKey.TAG === /* Ok */ 0) {
            var button = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button"), null));
            if (button.TAG === /* Ok */ 0) {
                var buttons = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "buttons"), null));
                if (buttons.TAG === /* Ok */ 0) {
                    var clientX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientX"), null));
                    if (clientX.TAG === /* Ok */ 0) {
                        var clientY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientY"), null));
                        if (clientY.TAG === /* Ok */ 0) {
                            var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
                            if (ctrlKey.TAG === /* Ok */ 0) {
                                var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
                                if (metaKey.TAG === /* Ok */ 0) {
                                    var movementX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementX"), null));
                                    if (movementX.TAG === /* Ok */ 0) {
                                        var movementY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementY"), null));
                                        if (movementY.TAG === /* Ok */ 0) {
                                            var offsetX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetX"), null));
                                            if (offsetX.TAG === /* Ok */ 0) {
                                                var offsetY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetY"), null));
                                                if (offsetY.TAG === /* Ok */ 0) {
                                                    var pageX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageX"), null));
                                                    if (pageX.TAG === /* Ok */ 0) {
                                                        var pageY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageY"), null));
                                                        if (pageY.TAG === /* Ok */ 0) {
                                                            var region = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "region"), null));
                                                            if (region.TAG === /* Ok */ 0) {
                                                                var relatedTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
                                                                if (relatedTarget.TAG === /* Ok */ 0) {
                                                                    var screenX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenX"), null));
                                                                    if (screenX.TAG === /* Ok */ 0) {
                                                                        var screenY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenY"), null));
                                                                        if (screenY.TAG === /* Ok */ 0) {
                                                                            var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                                                                            if (shiftKey.TAG === /* Ok */ 0) {
                                                                                var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
                                                                                if (x.TAG === /* Ok */ 0) {
                                                                                    var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
                                                                                    if (y.TAG === /* Ok */ 0) {
                                                                                        var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
                                                                                        if (detail.TAG === /* Ok */ 0) {
                                                                                            var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                                                                                            if (bubbles.TAG === /* Ok */ 0) {
                                                                                                var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                                                                                                if (cancelable.TAG === /* Ok */ 0) {
                                                                                                    var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                                                                                                    if (composed.TAG === /* Ok */ 0) {
                                                                                                        var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                                                                                                        if (currentTarget.TAG === /* Ok */ 0) {
                                                                                                            var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                                                                                                            if (defaultPrevented.TAG === /* Ok */ 0) {
                                                                                                                var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                                                                                                if (eventPhase.TAG === /* Ok */ 0) {
                                                                                                                    var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                                                                                                    if (target.TAG === /* Ok */ 0) {
                                                                                                                        var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                                                                                                        if (timeStamp.TAG === /* Ok */ 0) {
                                                                                                                            var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                                                                                                            if (type_.TAG === /* Ok */ 0) {
                                                                                                                                var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                                                                                                if (isTrusted.TAG === /* Ok */ 0) {
                                                                                                                                    return {
                                                                                                                                        TAG: /* Ok */ 0,
                                                                                                                                        _0: {
                                                                                                                                            dataTransfer: dataTransfer._0,
                                                                                                                                            altKey: altKey._0,
                                                                                                                                            button: button._0,
                                                                                                                                            buttons: buttons._0,
                                                                                                                                            clientX: clientX._0,
                                                                                                                                            clientY: clientY._0,
                                                                                                                                            ctrlKey: ctrlKey._0,
                                                                                                                                            metaKey: metaKey._0,
                                                                                                                                            movementX: movementX._0,
                                                                                                                                            movementY: movementY._0,
                                                                                                                                            offsetX: offsetX._0,
                                                                                                                                            offsetY: offsetY._0,
                                                                                                                                            pageX: pageX._0,
                                                                                                                                            pageY: pageY._0,
                                                                                                                                            region: region._0,
                                                                                                                                            relatedTarget: relatedTarget._0,
                                                                                                                                            screenX: screenX._0,
                                                                                                                                            screenY: screenY._0,
                                                                                                                                            shiftKey: shiftKey._0,
                                                                                                                                            x: x._0,
                                                                                                                                            y: y._0,
                                                                                                                                            detail: detail._0,
                                                                                                                                            bubbles: bubbles._0,
                                                                                                                                            cancelable: cancelable._0,
                                                                                                                                            composed: composed._0,
                                                                                                                                            currentTarget: currentTarget._0,
                                                                                                                                            defaultPrevented: defaultPrevented._0,
                                                                                                                                            eventPhase: eventPhase._0,
                                                                                                                                            target: target._0,
                                                                                                                                            timeStamp: timeStamp._0,
                                                                                                                                            type_: type_._0,
                                                                                                                                            isTrusted: isTrusted._0
                                                                                                                                        }
                                                                                                                                    };
                                                                                                                                }
                                                                                                                                var e = isTrusted._0;
                                                                                                                                return {
                                                                                                                                    TAG: /* Error */ 1,
                                                                                                                                    _0: {
                                                                                                                                        path: ".isTrusted" + e.path,
                                                                                                                                        message: e.message,
                                                                                                                                        value: e.value
                                                                                                                                    }
                                                                                                                                };
                                                                                                                            }
                                                                                                                            var e$1 = type_._0;
                                                                                                                            return {
                                                                                                                                TAG: /* Error */ 1,
                                                                                                                                _0: {
                                                                                                                                    path: ".type_" + e$1.path,
                                                                                                                                    message: e$1.message,
                                                                                                                                    value: e$1.value
                                                                                                                                }
                                                                                                                            };
                                                                                                                        }
                                                                                                                        var e$2 = timeStamp._0;
                                                                                                                        return {
                                                                                                                            TAG: /* Error */ 1,
                                                                                                                            _0: {
                                                                                                                                path: ".timeStamp" + e$2.path,
                                                                                                                                message: e$2.message,
                                                                                                                                value: e$2.value
                                                                                                                            }
                                                                                                                        };
                                                                                                                    }
                                                                                                                    var e$3 = target._0;
                                                                                                                    return {
                                                                                                                        TAG: /* Error */ 1,
                                                                                                                        _0: {
                                                                                                                            path: ".target" + e$3.path,
                                                                                                                            message: e$3.message,
                                                                                                                            value: e$3.value
                                                                                                                        }
                                                                                                                    };
                                                                                                                }
                                                                                                                var e$4 = eventPhase._0;
                                                                                                                return {
                                                                                                                    TAG: /* Error */ 1,
                                                                                                                    _0: {
                                                                                                                        path: ".eventPhase" + e$4.path,
                                                                                                                        message: e$4.message,
                                                                                                                        value: e$4.value
                                                                                                                    }
                                                                                                                };
                                                                                                            }
                                                                                                            var e$5 = defaultPrevented._0;
                                                                                                            return {
                                                                                                                TAG: /* Error */ 1,
                                                                                                                _0: {
                                                                                                                    path: ".defaultPrevented" + e$5.path,
                                                                                                                    message: e$5.message,
                                                                                                                    value: e$5.value
                                                                                                                }
                                                                                                            };
                                                                                                        }
                                                                                                        var e$6 = currentTarget._0;
                                                                                                        return {
                                                                                                            TAG: /* Error */ 1,
                                                                                                            _0: {
                                                                                                                path: ".currentTarget" + e$6.path,
                                                                                                                message: e$6.message,
                                                                                                                value: e$6.value
                                                                                                            }
                                                                                                        };
                                                                                                    }
                                                                                                    var e$7 = composed._0;
                                                                                                    return {
                                                                                                        TAG: /* Error */ 1,
                                                                                                        _0: {
                                                                                                            path: ".composed" + e$7.path,
                                                                                                            message: e$7.message,
                                                                                                            value: e$7.value
                                                                                                        }
                                                                                                    };
                                                                                                }
                                                                                                var e$8 = cancelable._0;
                                                                                                return {
                                                                                                    TAG: /* Error */ 1,
                                                                                                    _0: {
                                                                                                        path: ".cancelable" + e$8.path,
                                                                                                        message: e$8.message,
                                                                                                        value: e$8.value
                                                                                                    }
                                                                                                };
                                                                                            }
                                                                                            var e$9 = bubbles._0;
                                                                                            return {
                                                                                                TAG: /* Error */ 1,
                                                                                                _0: {
                                                                                                    path: ".bubbles" + e$9.path,
                                                                                                    message: e$9.message,
                                                                                                    value: e$9.value
                                                                                                }
                                                                                            };
                                                                                        }
                                                                                        var e$10 = detail._0;
                                                                                        return {
                                                                                            TAG: /* Error */ 1,
                                                                                            _0: {
                                                                                                path: ".detail" + e$10.path,
                                                                                                message: e$10.message,
                                                                                                value: e$10.value
                                                                                            }
                                                                                        };
                                                                                    }
                                                                                    var e$11 = y._0;
                                                                                    return {
                                                                                        TAG: /* Error */ 1,
                                                                                        _0: {
                                                                                            path: ".y" + e$11.path,
                                                                                            message: e$11.message,
                                                                                            value: e$11.value
                                                                                        }
                                                                                    };
                                                                                }
                                                                                var e$12 = x._0;
                                                                                return {
                                                                                    TAG: /* Error */ 1,
                                                                                    _0: {
                                                                                        path: ".x" + e$12.path,
                                                                                        message: e$12.message,
                                                                                        value: e$12.value
                                                                                    }
                                                                                };
                                                                            }
                                                                            var e$13 = shiftKey._0;
                                                                            return {
                                                                                TAG: /* Error */ 1,
                                                                                _0: {
                                                                                    path: ".shiftKey" + e$13.path,
                                                                                    message: e$13.message,
                                                                                    value: e$13.value
                                                                                }
                                                                            };
                                                                        }
                                                                        var e$14 = screenY._0;
                                                                        return {
                                                                            TAG: /* Error */ 1,
                                                                            _0: {
                                                                                path: ".screenY" + e$14.path,
                                                                                message: e$14.message,
                                                                                value: e$14.value
                                                                            }
                                                                        };
                                                                    }
                                                                    var e$15 = screenX._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".screenX" + e$15.path,
                                                                            message: e$15.message,
                                                                            value: e$15.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$16 = relatedTarget._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".relatedTarget" + e$16.path,
                                                                        message: e$16.message,
                                                                        value: e$16.value
                                                                    }
                                                                };
                                                            }
                                                            var e$17 = region._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".region" + e$17.path,
                                                                    message: e$17.message,
                                                                    value: e$17.value
                                                                }
                                                            };
                                                        }
                                                        var e$18 = pageY._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".pageY" + e$18.path,
                                                                message: e$18.message,
                                                                value: e$18.value
                                                            }
                                                        };
                                                    }
                                                    var e$19 = pageX._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".pageX" + e$19.path,
                                                            message: e$19.message,
                                                            value: e$19.value
                                                        }
                                                    };
                                                }
                                                var e$20 = offsetY._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".offsetY" + e$20.path,
                                                        message: e$20.message,
                                                        value: e$20.value
                                                    }
                                                };
                                            }
                                            var e$21 = offsetX._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".offsetX" + e$21.path,
                                                    message: e$21.message,
                                                    value: e$21.value
                                                }
                                            };
                                        }
                                        var e$22 = movementY._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".movementY" + e$22.path,
                                                message: e$22.message,
                                                value: e$22.value
                                            }
                                        };
                                    }
                                    var e$23 = movementX._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".movementX" + e$23.path,
                                            message: e$23.message,
                                            value: e$23.value
                                        }
                                    };
                                }
                                var e$24 = metaKey._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".metaKey" + e$24.path,
                                        message: e$24.message,
                                        value: e$24.value
                                    }
                                };
                            }
                            var e$25 = ctrlKey._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".ctrlKey" + e$25.path,
                                    message: e$25.message,
                                    value: e$25.value
                                }
                            };
                        }
                        var e$26 = clientY._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".clientY" + e$26.path,
                                message: e$26.message,
                                value: e$26.value
                            }
                        };
                    }
                    var e$27 = clientX._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".clientX" + e$27.path,
                            message: e$27.message,
                            value: e$27.value
                        }
                    };
                }
                var e$28 = buttons._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".buttons" + e$28.path,
                        message: e$28.message,
                        value: e$28.value
                    }
                };
            }
            var e$29 = button._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".button" + e$29.path,
                    message: e$29.message,
                    value: e$29.value
                }
            };
        }
        var e$30 = altKey._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".altKey" + e$30.path,
                message: e$30.message,
                value: e$30.value
            }
        };
    }
    var e$31 = dataTransfer._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".dataTransfer" + e$31.path,
            message: e$31.message,
            value: e$31.value
        }
    };
}
function fromDomDragEvent($$event) {
    return {
        dataTransfer: DOM__DataTransfer$SmartcutsMacros.getData("text", $$event.dataTransfer),
        altKey: $$event.altKey,
        button: $$event.button,
        buttons: $$event.buttons,
        clientX: $$event.clientX,
        clientY: $$event.clientY,
        ctrlKey: $$event.ctrlKey,
        metaKey: $$event.metaKey,
        movementX: $$event.movementX,
        movementY: $$event.movementY,
        offsetX: $$event.offsetX,
        offsetY: $$event.offsetY,
        pageX: $$event.pageX,
        pageY: $$event.pageY,
        region: Caml_option.nullable_to_opt($$event.region),
        relatedTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.relatedTarget), fromDomEventTarget),
        screenX: $$event.screenX,
        screenY: $$event.screenY,
        shiftKey: $$event.shiftKey,
        x: $$event.x,
        y: $$event.y,
        detail: $$event.detail,
        bubbles: $$event.bubbles,
        cancelable: $$event.cancelable,
        composed: $$event.composed,
        currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
        defaultPrevented: $$event.defaultPrevented,
        eventPhase: Curry._1(Webapi__Dom__DragEvent.eventPhase, $$event),
        target: fromDomEventTarget($$event.target),
        timeStamp: $$event.timeStamp,
        type_: $$event.type,
        isTrusted: $$event.isTrusted
    };
}
function stringify$8($$event) {
    return JSON.stringify(t_encode$8($$event));
}
var DragEventForSerialization = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    fromDomDragEvent: fromDomDragEvent,
    stringify: stringify$8
};
function t_encode$9(v) {
    return Js_dict.fromArray([
        [
            "relatedTarget",
            Decco.optionToJson(t_encode, v.relatedTarget)
        ],
        [
            "detail",
            Decco.intToJson(v.detail)
        ],
        [
            "bubbles",
            Decco.boolToJson(v.bubbles)
        ],
        [
            "cancelable",
            Decco.boolToJson(v.cancelable)
        ],
        [
            "composed",
            Decco.boolToJson(v.composed)
        ],
        [
            "currentTarget",
            Decco.optionToJson(t_encode, v.currentTarget)
        ],
        [
            "defaultPrevented",
            Decco.boolToJson(v.defaultPrevented)
        ],
        [
            "eventPhase",
            eventPhase_encode(v.eventPhase)
        ],
        [
            "target",
            t_encode(v.target)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ],
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "isTrusted",
            Decco.boolToJson(v.isTrusted)
        ]
    ]);
}
function t_decode$9(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var relatedTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
    if (relatedTarget.TAG === /* Ok */ 0) {
        var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
        if (detail.TAG === /* Ok */ 0) {
            var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
            if (bubbles.TAG === /* Ok */ 0) {
                var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                if (cancelable.TAG === /* Ok */ 0) {
                    var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                    if (composed.TAG === /* Ok */ 0) {
                        var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                        if (currentTarget.TAG === /* Ok */ 0) {
                            var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                            if (defaultPrevented.TAG === /* Ok */ 0) {
                                var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                if (eventPhase.TAG === /* Ok */ 0) {
                                    var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                    if (target.TAG === /* Ok */ 0) {
                                        var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                        if (timeStamp.TAG === /* Ok */ 0) {
                                            var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                            if (type_.TAG === /* Ok */ 0) {
                                                var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                if (isTrusted.TAG === /* Ok */ 0) {
                                                    return {
                                                        TAG: /* Ok */ 0,
                                                        _0: {
                                                            relatedTarget: relatedTarget._0,
                                                            detail: detail._0,
                                                            bubbles: bubbles._0,
                                                            cancelable: cancelable._0,
                                                            composed: composed._0,
                                                            currentTarget: currentTarget._0,
                                                            defaultPrevented: defaultPrevented._0,
                                                            eventPhase: eventPhase._0,
                                                            target: target._0,
                                                            timeStamp: timeStamp._0,
                                                            type_: type_._0,
                                                            isTrusted: isTrusted._0
                                                        }
                                                    };
                                                }
                                                var e = isTrusted._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".isTrusted" + e.path,
                                                        message: e.message,
                                                        value: e.value
                                                    }
                                                };
                                            }
                                            var e$1 = type_._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".type_" + e$1.path,
                                                    message: e$1.message,
                                                    value: e$1.value
                                                }
                                            };
                                        }
                                        var e$2 = timeStamp._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".timeStamp" + e$2.path,
                                                message: e$2.message,
                                                value: e$2.value
                                            }
                                        };
                                    }
                                    var e$3 = target._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".target" + e$3.path,
                                            message: e$3.message,
                                            value: e$3.value
                                        }
                                    };
                                }
                                var e$4 = eventPhase._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".eventPhase" + e$4.path,
                                        message: e$4.message,
                                        value: e$4.value
                                    }
                                };
                            }
                            var e$5 = defaultPrevented._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".defaultPrevented" + e$5.path,
                                    message: e$5.message,
                                    value: e$5.value
                                }
                            };
                        }
                        var e$6 = currentTarget._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".currentTarget" + e$6.path,
                                message: e$6.message,
                                value: e$6.value
                            }
                        };
                    }
                    var e$7 = composed._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".composed" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = cancelable._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".cancelable" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            }
            var e$9 = bubbles._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".bubbles" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                }
            };
        }
        var e$10 = detail._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".detail" + e$10.path,
                message: e$10.message,
                value: e$10.value
            }
        };
    }
    var e$11 = relatedTarget._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".relatedTarget" + e$11.path,
            message: e$11.message,
            value: e$11.value
        }
    };
}
function fromDomFocusEvent($$event) {
    return {
        relatedTarget: OptionUtils$SmartcutsMacros.$neg$question$great(Caml_option.nullable_to_opt($$event.relatedTarget), fromDomEventTarget),
        detail: $$event.detail,
        bubbles: $$event.bubbles,
        cancelable: $$event.cancelable,
        composed: $$event.composed,
        currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
        defaultPrevented: $$event.defaultPrevented,
        eventPhase: Curry._1(Webapi__Dom__FocusEvent.eventPhase, $$event),
        target: fromDomEventTarget($$event.target),
        timeStamp: $$event.timeStamp,
        type_: $$event.type,
        isTrusted: $$event.isTrusted
    };
}
function stringify$9($$event) {
    return JSON.stringify(t_encode$9($$event));
}
var FocusEventForSerialization = {
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    fromDomFocusEvent: fromDomFocusEvent,
    stringify: stringify$9
};
function deltaMode_encode(v) {
    switch(v){
        case /* Pixel */ 0:
            return [
                "Pixel"
            ];
        case /* Line */ 1:
            return [
                "Line"
            ];
        case /* Page */ 2:
            return [
                "Page"
            ];
    }
}
function deltaMode_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Line":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Line */ 1
                    };
                }
            case "Page":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Page */ 2
                    };
                }
            case "Pixel":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Pixel */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function webapiDeltaModeToDeltaMode(webapiDeltaMode) {
    return webapiDeltaMode;
}
function t_encode$10(v) {
    return Js_dict.fromArray([
        [
            "deltaX",
            Decco.floatToJson(v.deltaX)
        ],
        [
            "deltaY",
            Decco.floatToJson(v.deltaY)
        ],
        [
            "deltaZ",
            Decco.floatToJson(v.deltaZ)
        ],
        [
            "deltaMode",
            deltaMode_encode(v.deltaMode)
        ],
        [
            "altKey",
            Decco.boolToJson(v.altKey)
        ],
        [
            "button",
            Decco.intToJson(v.button)
        ],
        [
            "buttons",
            Decco.intToJson(v.buttons)
        ],
        [
            "clientX",
            Decco.floatToJson(v.clientX)
        ],
        [
            "clientY",
            Decco.floatToJson(v.clientY)
        ],
        [
            "ctrlKey",
            Decco.boolToJson(v.ctrlKey)
        ],
        [
            "metaKey",
            Decco.boolToJson(v.metaKey)
        ],
        [
            "movementX",
            Decco.intToJson(v.movementX)
        ],
        [
            "movementY",
            Decco.intToJson(v.movementY)
        ],
        [
            "offsetX",
            Decco.intToJson(v.offsetX)
        ],
        [
            "offsetY",
            Decco.intToJson(v.offsetY)
        ],
        [
            "pageX",
            Decco.intToJson(v.pageX)
        ],
        [
            "pageY",
            Decco.intToJson(v.pageY)
        ],
        [
            "region",
            Decco.optionToJson(Decco.stringToJson, v.region)
        ],
        [
            "relatedTarget",
            Decco.optionToJson(t_encode, v.relatedTarget)
        ],
        [
            "screenX",
            Decco.intToJson(v.screenX)
        ],
        [
            "screenY",
            Decco.intToJson(v.screenY)
        ],
        [
            "shiftKey",
            Decco.boolToJson(v.shiftKey)
        ],
        [
            "x",
            Decco.intToJson(v.x)
        ],
        [
            "y",
            Decco.intToJson(v.y)
        ],
        [
            "detail",
            Decco.intToJson(v.detail)
        ],
        [
            "bubbles",
            Decco.boolToJson(v.bubbles)
        ],
        [
            "cancelable",
            Decco.boolToJson(v.cancelable)
        ],
        [
            "composed",
            Decco.boolToJson(v.composed)
        ],
        [
            "currentTarget",
            Decco.optionToJson(t_encode, v.currentTarget)
        ],
        [
            "defaultPrevented",
            Decco.boolToJson(v.defaultPrevented)
        ],
        [
            "eventPhase",
            eventPhase_encode(v.eventPhase)
        ],
        [
            "target",
            t_encode(v.target)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ],
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "isTrusted",
            Decco.boolToJson(v.isTrusted)
        ]
    ]);
}
function t_decode$10(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var deltaX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaX"), null));
    if (deltaX.TAG === /* Ok */ 0) {
        var deltaY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaY"), null));
        if (deltaY.TAG === /* Ok */ 0) {
            var deltaZ = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaZ"), null));
            if (deltaZ.TAG === /* Ok */ 0) {
                var deltaMode = deltaMode_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaMode"), null));
                if (deltaMode.TAG === /* Ok */ 0) {
                    var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
                    if (altKey.TAG === /* Ok */ 0) {
                        var button = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button"), null));
                        if (button.TAG === /* Ok */ 0) {
                            var buttons = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "buttons"), null));
                            if (buttons.TAG === /* Ok */ 0) {
                                var clientX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientX"), null));
                                if (clientX.TAG === /* Ok */ 0) {
                                    var clientY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientY"), null));
                                    if (clientY.TAG === /* Ok */ 0) {
                                        var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
                                        if (ctrlKey.TAG === /* Ok */ 0) {
                                            var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
                                            if (metaKey.TAG === /* Ok */ 0) {
                                                var movementX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementX"), null));
                                                if (movementX.TAG === /* Ok */ 0) {
                                                    var movementY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "movementY"), null));
                                                    if (movementY.TAG === /* Ok */ 0) {
                                                        var offsetX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetX"), null));
                                                        if (offsetX.TAG === /* Ok */ 0) {
                                                            var offsetY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offsetY"), null));
                                                            if (offsetY.TAG === /* Ok */ 0) {
                                                                var pageX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageX"), null));
                                                                if (pageX.TAG === /* Ok */ 0) {
                                                                    var pageY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageY"), null));
                                                                    if (pageY.TAG === /* Ok */ 0) {
                                                                        var region = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "region"), null));
                                                                        if (region.TAG === /* Ok */ 0) {
                                                                            var relatedTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
                                                                            if (relatedTarget.TAG === /* Ok */ 0) {
                                                                                var screenX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenX"), null));
                                                                                if (screenX.TAG === /* Ok */ 0) {
                                                                                    var screenY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenY"), null));
                                                                                    if (screenY.TAG === /* Ok */ 0) {
                                                                                        var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                                                                                        if (shiftKey.TAG === /* Ok */ 0) {
                                                                                            var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
                                                                                            if (x.TAG === /* Ok */ 0) {
                                                                                                var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
                                                                                                if (y.TAG === /* Ok */ 0) {
                                                                                                    var detail = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
                                                                                                    if (detail.TAG === /* Ok */ 0) {
                                                                                                        var bubbles = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bubbles"), null));
                                                                                                        if (bubbles.TAG === /* Ok */ 0) {
                                                                                                            var cancelable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelable"), null));
                                                                                                            if (cancelable.TAG === /* Ok */ 0) {
                                                                                                                var composed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "composed"), null));
                                                                                                                if (composed.TAG === /* Ok */ 0) {
                                                                                                                    var currentTarget = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentTarget"), null));
                                                                                                                    if (currentTarget.TAG === /* Ok */ 0) {
                                                                                                                        var defaultPrevented = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultPrevented"), null));
                                                                                                                        if (defaultPrevented.TAG === /* Ok */ 0) {
                                                                                                                            var eventPhase = eventPhase_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventPhase"), null));
                                                                                                                            if (eventPhase.TAG === /* Ok */ 0) {
                                                                                                                                var target = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
                                                                                                                                if (target.TAG === /* Ok */ 0) {
                                                                                                                                    var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                                                                                                                    if (timeStamp.TAG === /* Ok */ 0) {
                                                                                                                                        var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
                                                                                                                                        if (type_.TAG === /* Ok */ 0) {
                                                                                                                                            var isTrusted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isTrusted"), null));
                                                                                                                                            if (isTrusted.TAG === /* Ok */ 0) {
                                                                                                                                                return {
                                                                                                                                                    TAG: /* Ok */ 0,
                                                                                                                                                    _0: {
                                                                                                                                                        deltaX: deltaX._0,
                                                                                                                                                        deltaY: deltaY._0,
                                                                                                                                                        deltaZ: deltaZ._0,
                                                                                                                                                        deltaMode: deltaMode._0,
                                                                                                                                                        altKey: altKey._0,
                                                                                                                                                        button: button._0,
                                                                                                                                                        buttons: buttons._0,
                                                                                                                                                        clientX: clientX._0,
                                                                                                                                                        clientY: clientY._0,
                                                                                                                                                        ctrlKey: ctrlKey._0,
                                                                                                                                                        metaKey: metaKey._0,
                                                                                                                                                        movementX: movementX._0,
                                                                                                                                                        movementY: movementY._0,
                                                                                                                                                        offsetX: offsetX._0,
                                                                                                                                                        offsetY: offsetY._0,
                                                                                                                                                        pageX: pageX._0,
                                                                                                                                                        pageY: pageY._0,
                                                                                                                                                        region: region._0,
                                                                                                                                                        relatedTarget: relatedTarget._0,
                                                                                                                                                        screenX: screenX._0,
                                                                                                                                                        screenY: screenY._0,
                                                                                                                                                        shiftKey: shiftKey._0,
                                                                                                                                                        x: x._0,
                                                                                                                                                        y: y._0,
                                                                                                                                                        detail: detail._0,
                                                                                                                                                        bubbles: bubbles._0,
                                                                                                                                                        cancelable: cancelable._0,
                                                                                                                                                        composed: composed._0,
                                                                                                                                                        currentTarget: currentTarget._0,
                                                                                                                                                        defaultPrevented: defaultPrevented._0,
                                                                                                                                                        eventPhase: eventPhase._0,
                                                                                                                                                        target: target._0,
                                                                                                                                                        timeStamp: timeStamp._0,
                                                                                                                                                        type_: type_._0,
                                                                                                                                                        isTrusted: isTrusted._0
                                                                                                                                                    }
                                                                                                                                                };
                                                                                                                                            }
                                                                                                                                            var e = isTrusted._0;
                                                                                                                                            return {
                                                                                                                                                TAG: /* Error */ 1,
                                                                                                                                                _0: {
                                                                                                                                                    path: ".isTrusted" + e.path,
                                                                                                                                                    message: e.message,
                                                                                                                                                    value: e.value
                                                                                                                                                }
                                                                                                                                            };
                                                                                                                                        }
                                                                                                                                        var e$1 = type_._0;
                                                                                                                                        return {
                                                                                                                                            TAG: /* Error */ 1,
                                                                                                                                            _0: {
                                                                                                                                                path: ".type_" + e$1.path,
                                                                                                                                                message: e$1.message,
                                                                                                                                                value: e$1.value
                                                                                                                                            }
                                                                                                                                        };
                                                                                                                                    }
                                                                                                                                    var e$2 = timeStamp._0;
                                                                                                                                    return {
                                                                                                                                        TAG: /* Error */ 1,
                                                                                                                                        _0: {
                                                                                                                                            path: ".timeStamp" + e$2.path,
                                                                                                                                            message: e$2.message,
                                                                                                                                            value: e$2.value
                                                                                                                                        }
                                                                                                                                    };
                                                                                                                                }
                                                                                                                                var e$3 = target._0;
                                                                                                                                return {
                                                                                                                                    TAG: /* Error */ 1,
                                                                                                                                    _0: {
                                                                                                                                        path: ".target" + e$3.path,
                                                                                                                                        message: e$3.message,
                                                                                                                                        value: e$3.value
                                                                                                                                    }
                                                                                                                                };
                                                                                                                            }
                                                                                                                            var e$4 = eventPhase._0;
                                                                                                                            return {
                                                                                                                                TAG: /* Error */ 1,
                                                                                                                                _0: {
                                                                                                                                    path: ".eventPhase" + e$4.path,
                                                                                                                                    message: e$4.message,
                                                                                                                                    value: e$4.value
                                                                                                                                }
                                                                                                                            };
                                                                                                                        }
                                                                                                                        var e$5 = defaultPrevented._0;
                                                                                                                        return {
                                                                                                                            TAG: /* Error */ 1,
                                                                                                                            _0: {
                                                                                                                                path: ".defaultPrevented" + e$5.path,
                                                                                                                                message: e$5.message,
                                                                                                                                value: e$5.value
                                                                                                                            }
                                                                                                                        };
                                                                                                                    }
                                                                                                                    var e$6 = currentTarget._0;
                                                                                                                    return {
                                                                                                                        TAG: /* Error */ 1,
                                                                                                                        _0: {
                                                                                                                            path: ".currentTarget" + e$6.path,
                                                                                                                            message: e$6.message,
                                                                                                                            value: e$6.value
                                                                                                                        }
                                                                                                                    };
                                                                                                                }
                                                                                                                var e$7 = composed._0;
                                                                                                                return {
                                                                                                                    TAG: /* Error */ 1,
                                                                                                                    _0: {
                                                                                                                        path: ".composed" + e$7.path,
                                                                                                                        message: e$7.message,
                                                                                                                        value: e$7.value
                                                                                                                    }
                                                                                                                };
                                                                                                            }
                                                                                                            var e$8 = cancelable._0;
                                                                                                            return {
                                                                                                                TAG: /* Error */ 1,
                                                                                                                _0: {
                                                                                                                    path: ".cancelable" + e$8.path,
                                                                                                                    message: e$8.message,
                                                                                                                    value: e$8.value
                                                                                                                }
                                                                                                            };
                                                                                                        }
                                                                                                        var e$9 = bubbles._0;
                                                                                                        return {
                                                                                                            TAG: /* Error */ 1,
                                                                                                            _0: {
                                                                                                                path: ".bubbles" + e$9.path,
                                                                                                                message: e$9.message,
                                                                                                                value: e$9.value
                                                                                                            }
                                                                                                        };
                                                                                                    }
                                                                                                    var e$10 = detail._0;
                                                                                                    return {
                                                                                                        TAG: /* Error */ 1,
                                                                                                        _0: {
                                                                                                            path: ".detail" + e$10.path,
                                                                                                            message: e$10.message,
                                                                                                            value: e$10.value
                                                                                                        }
                                                                                                    };
                                                                                                }
                                                                                                var e$11 = y._0;
                                                                                                return {
                                                                                                    TAG: /* Error */ 1,
                                                                                                    _0: {
                                                                                                        path: ".y" + e$11.path,
                                                                                                        message: e$11.message,
                                                                                                        value: e$11.value
                                                                                                    }
                                                                                                };
                                                                                            }
                                                                                            var e$12 = x._0;
                                                                                            return {
                                                                                                TAG: /* Error */ 1,
                                                                                                _0: {
                                                                                                    path: ".x" + e$12.path,
                                                                                                    message: e$12.message,
                                                                                                    value: e$12.value
                                                                                                }
                                                                                            };
                                                                                        }
                                                                                        var e$13 = shiftKey._0;
                                                                                        return {
                                                                                            TAG: /* Error */ 1,
                                                                                            _0: {
                                                                                                path: ".shiftKey" + e$13.path,
                                                                                                message: e$13.message,
                                                                                                value: e$13.value
                                                                                            }
                                                                                        };
                                                                                    }
                                                                                    var e$14 = screenY._0;
                                                                                    return {
                                                                                        TAG: /* Error */ 1,
                                                                                        _0: {
                                                                                            path: ".screenY" + e$14.path,
                                                                                            message: e$14.message,
                                                                                            value: e$14.value
                                                                                        }
                                                                                    };
                                                                                }
                                                                                var e$15 = screenX._0;
                                                                                return {
                                                                                    TAG: /* Error */ 1,
                                                                                    _0: {
                                                                                        path: ".screenX" + e$15.path,
                                                                                        message: e$15.message,
                                                                                        value: e$15.value
                                                                                    }
                                                                                };
                                                                            }
                                                                            var e$16 = relatedTarget._0;
                                                                            return {
                                                                                TAG: /* Error */ 1,
                                                                                _0: {
                                                                                    path: ".relatedTarget" + e$16.path,
                                                                                    message: e$16.message,
                                                                                    value: e$16.value
                                                                                }
                                                                            };
                                                                        }
                                                                        var e$17 = region._0;
                                                                        return {
                                                                            TAG: /* Error */ 1,
                                                                            _0: {
                                                                                path: ".region" + e$17.path,
                                                                                message: e$17.message,
                                                                                value: e$17.value
                                                                            }
                                                                        };
                                                                    }
                                                                    var e$18 = pageY._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".pageY" + e$18.path,
                                                                            message: e$18.message,
                                                                            value: e$18.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$19 = pageX._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".pageX" + e$19.path,
                                                                        message: e$19.message,
                                                                        value: e$19.value
                                                                    }
                                                                };
                                                            }
                                                            var e$20 = offsetY._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".offsetY" + e$20.path,
                                                                    message: e$20.message,
                                                                    value: e$20.value
                                                                }
                                                            };
                                                        }
                                                        var e$21 = offsetX._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".offsetX" + e$21.path,
                                                                message: e$21.message,
                                                                value: e$21.value
                                                            }
                                                        };
                                                    }
                                                    var e$22 = movementY._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".movementY" + e$22.path,
                                                            message: e$22.message,
                                                            value: e$22.value
                                                        }
                                                    };
                                                }
                                                var e$23 = movementX._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".movementX" + e$23.path,
                                                        message: e$23.message,
                                                        value: e$23.value
                                                    }
                                                };
                                            }
                                            var e$24 = metaKey._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".metaKey" + e$24.path,
                                                    message: e$24.message,
                                                    value: e$24.value
                                                }
                                            };
                                        }
                                        var e$25 = ctrlKey._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".ctrlKey" + e$25.path,
                                                message: e$25.message,
                                                value: e$25.value
                                            }
                                        };
                                    }
                                    var e$26 = clientY._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".clientY" + e$26.path,
                                            message: e$26.message,
                                            value: e$26.value
                                        }
                                    };
                                }
                                var e$27 = clientX._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".clientX" + e$27.path,
                                        message: e$27.message,
                                        value: e$27.value
                                    }
                                };
                            }
                            var e$28 = buttons._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".buttons" + e$28.path,
                                    message: e$28.message,
                                    value: e$28.value
                                }
                            };
                        }
                        var e$29 = button._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".button" + e$29.path,
                                message: e$29.message,
                                value: e$29.value
                            }
                        };
                    }
                    var e$30 = altKey._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".altKey" + e$30.path,
                            message: e$30.message,
                            value: e$30.value
                        }
                    };
                }
                var e$31 = deltaMode._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".deltaMode" + e$31.path,
                        message: e$31.message,
                        value: e$31.value
                    }
                };
            }
            var e$32 = deltaZ._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".deltaZ" + e$32.path,
                    message: e$32.message,
                    value: e$32.value
                }
            };
        }
        var e$33 = deltaY._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".deltaY" + e$33.path,
                message: e$33.message,
                value: e$33.value
            }
        };
    }
    var e$34 = deltaX._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".deltaX" + e$34.path,
            message: e$34.message,
            value: e$34.value
        }
    };
}
function fromDomWheelEvent($$event) {
    return {
        deltaX: $$event.deltaX,
        deltaY: $$event.deltaY,
        deltaZ: $$event.deltaZ,
        deltaMode: Webapi__Dom__WheelEvent.deltaMode($$event),
        altKey: $$event.altKey,
        button: $$event.button,
        buttons: $$event.buttons,
        clientX: $$event.clientX,
        clientY: $$event.clientY,
        ctrlKey: $$event.ctrlKey,
        metaKey: $$event.metaKey,
        movementX: $$event.movementX,
        movementY: $$event.movementY,
        offsetX: $$event.offsetX,
        offsetY: $$event.offsetY,
        pageX: $$event.pageX,
        pageY: $$event.pageY,
        region: Caml_option.nullable_to_opt($$event.region),
        relatedTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.relatedTarget), fromDomEventTarget),
        screenX: $$event.screenX,
        screenY: $$event.screenY,
        shiftKey: $$event.shiftKey,
        x: $$event.x,
        y: $$event.y,
        detail: $$event.detail,
        bubbles: $$event.bubbles,
        cancelable: $$event.cancelable,
        composed: $$event.composed,
        currentTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt($$event.currentTarget), fromDomEventTarget),
        defaultPrevented: $$event.defaultPrevented,
        eventPhase: Curry._1(Webapi__Dom__WheelEvent.eventPhase, $$event),
        target: fromDomEventTarget($$event.target),
        timeStamp: $$event.timeStamp,
        type_: $$event.type,
        isTrusted: $$event.isTrusted
    };
}
function stringify$10($$event) {
    return JSON.stringify(t_encode$10($$event));
}
var WheelEventForSerialization = {
    deltaMode_encode: deltaMode_encode,
    deltaMode_decode: deltaMode_decode,
    webapiDeltaModeToDeltaMode: webapiDeltaModeToDeltaMode,
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    fromDomWheelEvent: fromDomWheelEvent,
    stringify: stringify$10
};
function t__encode(v) {
    switch(v.TAG | 0){
        case /* MouseEvent */ 0:
            return [
                "MouseEvent",
                Decco.stringToJson(v._0),
                t_encode$4(v._1)
            ];
        case /* InputEvent */ 1:
            return [
                "InputEvent",
                Decco.stringToJson(v._0),
                t_encode$5(v._1)
            ];
        case /* KeyboardEvent */ 2:
            return [
                "KeyboardEvent",
                Decco.stringToJson(v._0),
                t_encode$6(v._1)
            ];
        case /* ClipboardEvent */ 3:
            return [
                "ClipboardEvent",
                Decco.stringToJson(v._0),
                t_encode$7(v._1)
            ];
        case /* DragEvent */ 4:
            return [
                "DragEvent",
                Decco.stringToJson(v._0),
                t_encode$8(v._1)
            ];
        case /* WheelEvent */ 5:
            return [
                "WheelEvent",
                Decco.stringToJson(v._0),
                t_encode$10(v._1)
            ];
        case /* FocusEvent */ 6:
            return [
                "FocusEvent",
                Decco.stringToJson(v._0),
                t_encode$9(v._1)
            ];
        case /* BlurEvent */ 7:
            return [
                "BlurEvent",
                Decco.stringToJson(v._0),
                t_encode$9(v._1)
            ];
        case /* ChangeEvent */ 8:
            return [
                "ChangeEvent",
                t_encode$1(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* Event */ 9:
            return [
                "Event",
                Decco.stringToJson(v._0),
                t_encode$1(v._1)
            ];
        case /* SyntheticEvent */ 10:
            return [
                "SyntheticEvent",
                t_encode$3(v._0)
            ];
    }
}
function t__decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BlurEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = t_decode$9(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BlurEvent */ 7,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ChangeEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ChangeEvent */ 8,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "ClipboardEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = t_decode$7(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ClipboardEvent */ 3,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$4 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "DragEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = t_decode$8(Belt_Array.getExn(jsonArr$1, 2));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DragEvent */ 4,
                                _0: match$7._0,
                                _1: match$8._0
                            }
                        };
                    }
                    var e$6 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "Event":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$10 = t_decode$1(Belt_Array.getExn(jsonArr$1, 2));
                if (match$9.TAG === /* Ok */ 0) {
                    if (match$10.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Event */ 9,
                                _0: match$9._0,
                                _1: match$10._0
                            }
                        };
                    }
                    var e$8 = match$10._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                        }
                    };
                }
                var e$9 = match$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "FocusEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$11 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$12 = t_decode$9(Belt_Array.getExn(jsonArr$1, 2));
                if (match$11.TAG === /* Ok */ 0) {
                    if (match$12.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* FocusEvent */ 6,
                                _0: match$11._0,
                                _1: match$12._0
                            }
                        };
                    }
                    var e$10 = match$12._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$10.path,
                            message: e$10.message,
                            value: e$10.value
                        }
                    };
                }
                var e$11 = match$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "InputEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$13 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$14 = t_decode$5(Belt_Array.getExn(jsonArr$1, 2));
                if (match$13.TAG === /* Ok */ 0) {
                    if (match$14.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* InputEvent */ 1,
                                _0: match$13._0,
                                _1: match$14._0
                            }
                        };
                    }
                    var e$12 = match$14._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                        }
                    };
                }
                var e$13 = match$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "KeyboardEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$15 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$16 = t_decode$6(Belt_Array.getExn(jsonArr$1, 2));
                if (match$15.TAG === /* Ok */ 0) {
                    if (match$16.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* KeyboardEvent */ 2,
                                _0: match$15._0,
                                _1: match$16._0
                            }
                        };
                    }
                    var e$14 = match$16._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$14.path,
                            message: e$14.message,
                            value: e$14.value
                        }
                    };
                }
                var e$15 = match$15._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "MouseEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$17 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$18 = t_decode$4(Belt_Array.getExn(jsonArr$1, 2));
                if (match$17.TAG === /* Ok */ 0) {
                    if (match$18.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* MouseEvent */ 0,
                                _0: match$17._0,
                                _1: match$18._0
                            }
                        };
                    }
                    var e$16 = match$18._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$16.path,
                            message: e$16.message,
                            value: e$16.value
                        }
                    };
                }
                var e$17 = match$17._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "SyntheticEvent":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SyntheticEvent */ 10,
                            _0: v0._0
                        }
                    };
                }
                var e$18 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "WheelEvent":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$19 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$20 = t_decode$10(Belt_Array.getExn(jsonArr$1, 2));
                if (match$19.TAG === /* Ok */ 0) {
                    if (match$20.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* WheelEvent */ 5,
                                _0: match$19._0,
                                _1: match$20._0
                            }
                        };
                    }
                    var e$19 = match$20._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$19.path,
                            message: e$19.message,
                            value: e$19.value
                        }
                    };
                }
                var e$20 = match$19._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function make($$event) {
    switch($$event.TAG | 0){
        case /* MouseEvent */ 0:
            return {
                TAG: /* MouseEvent */ 0,
                _0: DOM__EventType$SmartcutsMacros.mouseToJs($$event._0),
                _1: fromDomMouseEvent($$event._1)
            };
        case /* InputEvent */ 1:
            return {
                TAG: /* InputEvent */ 1,
                _0: DOM__EventType$SmartcutsMacros.inputToJs($$event._0),
                _1: fromDomInputEvent($$event._1)
            };
        case /* KeyboardEvent */ 2:
            return {
                TAG: /* KeyboardEvent */ 2,
                _0: DOM__EventType$SmartcutsMacros.keyboardToJs($$event._0),
                _1: fromDomKeyboardEvent($$event._1)
            };
        case /* ClipboardEvent */ 3:
            return {
                TAG: /* ClipboardEvent */ 3,
                _0: DOM__EventType$SmartcutsMacros.clipboardToJs($$event._0),
                _1: fromDomClipboardEvent($$event._1)
            };
        case /* DragEvent */ 4:
            return {
                TAG: /* DragEvent */ 4,
                _0: DOM__EventType$SmartcutsMacros.dragToJs($$event._0),
                _1: fromDomDragEvent($$event._1)
            };
        case /* WheelEvent */ 5:
            return {
                TAG: /* WheelEvent */ 5,
                _0: DOM__EventType$SmartcutsMacros.wheelToJs($$event._0),
                _1: fromDomWheelEvent($$event._1)
            };
        case /* FocusEvent */ 6:
            return {
                TAG: /* FocusEvent */ 6,
                _0: DOM__EventType$SmartcutsMacros.focusToJs($$event._0),
                _1: fromDomFocusEvent($$event._1)
            };
        case /* BlurEvent */ 7:
            return {
                TAG: /* BlurEvent */ 7,
                _0: DOM__EventType$SmartcutsMacros.blurToJs($$event._0),
                _1: fromDomFocusEvent($$event._1)
            };
        case /* ChangeEvent */ 8:
            return {
                TAG: /* ChangeEvent */ 8,
                _0: fromDomEvent($$event._0),
                _1: $$event._1
            };
        case /* Event */ 9:
            return {
                TAG: /* Event */ 9,
                _0: DOM__EventType$SmartcutsMacros.tToJs($$event._0),
                _1: fromDomEvent($$event._1)
            };
        case /* SyntheticEvent */ 10:
            return {
                TAG: /* SyntheticEvent */ 10,
                _0: fromSyntheticEvent($$event._0)
            };
    }
}
function stringify$11($$event) {
    switch($$event.TAG | 0){
        case /* MouseEvent */ 0:
            return "MouseEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$4($$event._1)) + ")")));
        case /* InputEvent */ 1:
            return "InputEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$5($$event._1)) + ")")));
        case /* KeyboardEvent */ 2:
            return "KeyboardEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$6($$event._1)) + ")")));
        case /* ClipboardEvent */ 3:
            return "ClipboardEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$7($$event._1)) + ")")));
        case /* DragEvent */ 4:
            return "DragEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$8($$event._1)) + ")")));
        case /* WheelEvent */ 5:
            return "WheelEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$10($$event._1)) + ")")));
        case /* FocusEvent */ 6:
            return "FocusEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$9($$event._1)) + ")")));
        case /* BlurEvent */ 7:
            return "BlurEvent(" + ($$event._0 + (", " + (JSON.stringify(t_encode$9($$event._1)) + ")")));
        case /* ChangeEvent */ 8:
            return "ChangeEvent(" + (JSON.stringify(t_encode$1($$event._0)) + (", " + (StringUtils$SmartcutsMacros.quote($$event._1) + ")")));
        case /* Event */ 9:
            return "Event(" + ($$event._0 + (", " + (JSON.stringify(t_encode$1($$event._1)) + ")")));
        case /* SyntheticEvent */ 10:
            return "SyntheticEvent(" + stringify$3($$event._0);
    }
}
exports.EventTargetForSerialization = EventTargetForSerialization;
exports.eventPhase_encode = eventPhase_encode;
exports.eventPhase_decode = eventPhase_decode;
exports.webapiEventPhaseToEventPhase = webapiEventPhaseToEventPhase;
exports.EventForSerialization = EventForSerialization;
exports.SyntheticEventForSerialization = SyntheticEventForSerialization;
exports.MouseEventForSerialization = MouseEventForSerialization;
exports.InputEventForSerialization = InputEventForSerialization;
exports.KeyboardEventForSerialization = KeyboardEventForSerialization;
exports.ClipboardEventForSerialization = ClipboardEventForSerialization;
exports.DragEventForSerialization = DragEventForSerialization;
exports.FocusEventForSerialization = FocusEventForSerialization;
exports.WheelEventForSerialization = WheelEventForSerialization;
exports.t__encode = t__encode;
exports.t__decode = t__decode;
exports.make = make;
exports.stringify = stringify$11; /* Webapi__Dom__DragEvent Not a pure module */ 


/***/ }),

/***/ 64988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$String = __webpack_require__(65760);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DOM__Attributes$SmartcutsMacros = __webpack_require__(92169);
function ofElement(element) {
    var tagName = element.tagName.toLowerCase();
    var attributes = DOM__Attributes$SmartcutsMacros.ofDomElement(element);
    var attributesWithLowercaseType_type_ = OptionUtils$SmartcutsMacros.map(attributes.type_, $$String.lowercase_ascii);
    var attributesWithLowercaseType_value = attributes.value;
    var attributesWithLowercaseType_name = attributes.name;
    var attributesWithLowercaseType_title = attributes.title;
    var attributesWithLowercaseType_placeholder = attributes.placeholder;
    var attributesWithLowercaseType_selected = attributes.selected;
    var attributesWithLowercaseType_contenteditable = attributes.contenteditable;
    switch(tagName){
        case "input":
            var match = attributesWithLowercaseType_type_;
            if (match === undefined) {
                return Caml_option.some(element);
            }
            switch(match){
                case "email":
                case "password":
                case "search":
                case "tel":
                case "text":
                case "url":
                    return Caml_option.some(element);
                default:
                    return;
            }
        case "textarea":
            return Caml_option.some(element);
        default:
            return;
    }
}
function valueGet(inputElement) {
    var value = inputElement.value;
    var match = $$String.lowercase_ascii(inputElement.type);
    var match$1 = $$String.lowercase_ascii(value);
    switch(match){
        case "checkbox":
        case "radio":
            break;
        default:
            return value;
    }
    if (match$1 === "on") {
        return;
    } else {
        return value;
    }
}
function doesSupportSelection(htmlInputElement) {
    var tagName = htmlInputElement.tagName;
    if (tagName === "TEXTAREA") {
        return true;
    }
    if (tagName !== "INPUT") {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: element should be <textarea> or <input>, got <" + (tagName + ">"));
    }
    var type_ = htmlInputElement.type;
    switch(type_){
        case "password":
        case "search":
        case "tel":
        case "text":
        case "url":
            return true;
        default:
            return false;
    }
}
exports.ofElement = ofElement;
exports.valueGet = valueGet;
exports.doesSupportSelection = doesSupportSelection; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 87210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var $$String = __webpack_require__(65760);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var Caml_module = __webpack_require__(27236);
var Belt_MapString = __webpack_require__(35082);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Image$SmartcutsMacros = __webpack_require__(68387);
var Command$SmartcutsMacros = __webpack_require__(4290);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__Node$SmartcutsMacros = __webpack_require__(73466);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var AuthStatus$SmartcutsMacros = __webpack_require__(10775);
var DOM__Event$SmartcutsMacros = __webpack_require__(46307);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var RenderOnHost$SmartcutsMacros = __webpack_require__(95421);
var SelectorTree$SmartcutsMacros = __webpack_require__(47118);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var Modal__WebAuth$SmartcutsMacros = __webpack_require__(44833);
var DOM__FocusTrail$SmartcutsMacros = __webpack_require__(62912);
var PlaybackOptions$SmartcutsMacros = __webpack_require__(84094);
var SideEffectGroup$SmartcutsMacros = __webpack_require__(42798);
var ClipboardHelpers$SmartcutsMacros = __webpack_require__(25154);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
var SelectorOverrides$SmartcutsMacros = __webpack_require__(51670);
var PendingCommandInfo$SmartcutsMacros = __webpack_require__(40099);
var Virtualized__Input$SmartcutsMacros = __webpack_require__(5283);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var Selection__Snapshot$SmartcutsMacros = __webpack_require__(27836);
var CommandPlaybackRuntime$SmartcutsMacros = __webpack_require__(500);
var RenderOnHost__Geometry$SmartcutsMacros = __webpack_require__(1763);
var Virtualized__InputMaps$SmartcutsMacros = __webpack_require__(23676);
var HighlightElement__Shared$SmartcutsMacros = __webpack_require__(98226);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
var MultiUrlTriggering__Types$SmartcutsMacros = __webpack_require__(12433);
var MultiUrlTriggering__Shared$SmartcutsMacros = __webpack_require__(8641);
var RenderOnHost__Notification$SmartcutsMacros = __webpack_require__(44976);
var ExtensionMessaging__FromTab$SmartcutsMacros = __webpack_require__(44409);
var DOM__Event__ForSerialization$SmartcutsMacros = __webpack_require__(54179);
var SelectorOverrideWithoutScope$SmartcutsMacros = __webpack_require__(65443);
var Virtualized__ContentEditable$SmartcutsMacros = __webpack_require__(93366);
var BgFx__UserCredentials__Shared$SmartcutsMacros = __webpack_require__(58407);
var StateMachine__DebounceManager$SmartcutsMacros = __webpack_require__(79764);
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = __webpack_require__(20229);
var DataExtraction__DataRecord__Types$SmartcutsMacros = __webpack_require__(36589);
var ContentScript__StateMachine__Types$SmartcutsMacros = __webpack_require__(65595);
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = __webpack_require__(24738);
var ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros = __webpack_require__(98519);
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = __webpack_require__(26362);
var ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros = __webpack_require__(1591);
var ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros = __webpack_require__(77448);
var ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros = __webpack_require__(21370);
var ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros = __webpack_require__(3183);
var ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros = __webpack_require__(4738);
var ContentScript__StateMachine__PlaybackMode__Types__Helpers = Caml_module.init_mod([
    "ExtensionMessagingAndStateMachineTypes.re",
    94,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "stringifyReaonNotPlaybackCommand"
        ],
        [
            /* Function */ 0,
            "stringifyState"
        ],
        [
            /* Function */ 0,
            "stringifyFailure"
        ],
        [
            /* Function */ 0,
            "stringifyExitReason"
        ],
        [
            /* Function */ 0,
            "stringifyEvent"
        ],
        [
            /* Function */ 0,
            "stringifySideEffect"
        ],
        [
            /* Function */ 0,
            "mapState"
        ],
        [
            /* Function */ 0,
            "mapEvent"
        ],
        [
            /* Function */ 0,
            "mapSideEffect"
        ]
    ]
});
var ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers = Caml_module.init_mod([
    "ExtensionMessagingAndStateMachineTypes.re",
    791,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyFailure"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapExitReason"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareListenerForSerialization"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
});
var ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers = Caml_module.init_mod([
    "ExtensionMessagingAndStateMachineTypes.re",
    1685,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyFailure"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareFailureForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareExitReasonForSerialization"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
});
var ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers = Caml_module.init_mod([
    "ExtensionMessagingAndStateMachineTypes.re",
    2883,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyFailure"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapExitReason"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
});
var ContentScript__StateMachine__RecordingMode__Types__Helpers = Caml_module.init_mod([
    "ExtensionMessagingAndStateMachineTypes.re",
    4169,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyParallelState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareExitReasonForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
});
var ContentScript__StateMachine__Shared__Types__Helpers = Caml_module.init_mod([
    "ExtensionMessagingAndStateMachineTypes.re",
    5222,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "stringifyEvent"
        ]
    ]
});
var ContentScript__StateMachine__Types__Helpers = Caml_module.init_mod([
    "ExtensionMessagingAndStateMachineTypes.re",
    5507,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyOtherFailureReason"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyErrorContext"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapErrorContext"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyErrorContext"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareListenerForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareErrorContextForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyErrorContext"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyFailureInfo"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
});
var ExtensionMessagingLogging = Caml_module.init_mod([
    "ExtensionMessagingAndStateMachineTypes.re",
    7444,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StartStreamingEventsToBackground"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StopStreamingEventsToBackground"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "Playback"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "PlaybackExited"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "RenderInContentScript"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskContentScriptToAdjustModalGeometry"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskContentScriptToEnterUrlTriggeringMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_RefreshLinks"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_UpdateLinks"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_TellTabToUpdateLinkGroups"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_Exit"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskContentScriptToRecordPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_StopRecordPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_PlaybackPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_DidFinishPlaybackPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_ShowLinkWithId"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_SendContextLocalAndLinkGroups"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_PrepareForScreenshot"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "PingTab"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DoesElementExistOnPage"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToRenderModalToExplainHighlightElement"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToSetupHighlightElementControl"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToTeardownHighlightElementControl"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToEnterDataExtractionMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToExitDataExtractionMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "All"
                    ]
                ]
            },
            "FromExtension"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ContentScriptReady"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToRefreshAuthStatus"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToFetchPlanSubscriptionProgress"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "NotifyBgOfContentScriptFailure"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "NotifyBgOfContentScriptResponseFailure"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StartDebugSelector"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StartRecording"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StopRecording"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DidStartRecording"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "NotifyBgAboutPossibleCommand"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ClearKeyThatDoesNotGenerateCommand"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "RecordCommand"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "FinishAuthoring"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "OpenPageForSmartcutId"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ShowFormForSmartcutId"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToAdjustModalGeometry"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "InitializePlayback"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetAuthoringCommandLog"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetMySmartcuts"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "InstallSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DeleteSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetExecutionHistoryForSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetScheduledTriggersForSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "FindExecutionById"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UpdateExecutionStatus"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UpsertExecutionSet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DeleteExecutionSet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetExecutionSetProgress"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetExecutionSetById"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UpsertScheduledTriggerAndCreateAlarm"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ArchiveScheduledTrigger"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "SaveExternalAccount"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "FindExternalAccountById"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetOAuthToken"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToClipboard"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "CreateGoogleSheet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "FetchGoogleSheet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "BatchUpdateGoogleSheet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "InitGoogleAuthFlow"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UserDidCloseGoogleOAuthModal"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "MultiUrlTriggering"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DebugSelector"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "PlaybackModeControl"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToUpdateLinkGroups"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToRecordPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToStopRecordPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToPlaybackPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_DidFinishPlaybackPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToShowLinkWithId"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_MaybeReadyToPlaybackPagination"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToUpdatePaginateFn"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToFocusTab"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToFocusWindow"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "SmartcutSavingProgress"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "RequestPermissions"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "NotifyConfirmExecutionQuotaResult"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "TrackWithSegment"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UserReadyLogInToWebsite"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "OpenNewWindow"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StoreAuthStatusItem"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToHighlightElement"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DidCloseExplainModalAndAskBgToHighlightElement"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToStopHighlightElement"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetUserCredentials"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UnlockVaultWithMasterSecret"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ModifyUserCredentials"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgIfMasterSecretDoesExist"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgForMissingPasswords"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToCreateVaultWithMasterSecret"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToResetMasterSecret"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToDetachLoginSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToEnterDataExtractionMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToProcessDataExtractionSignal"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToExitFromDataExtractionMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToRenderNotification"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToSaveDataExtractionAsSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "All"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AllAll"
                    ]
                ]
            },
            "FromTab"
        ]
    ]
});
function stringifyReaonNotPlaybackCommand(reason) {
    if (typeof reason === "number") {
        switch(reason){
            case /* NotSupported */ 0:
                return "Not supported";
            case /* TabOrWindowNotVisible */ 1:
                return "TabOrWindowNotVisible";
            case /* TabOrWindowVisibilityUnknownOrUnloaded */ 2:
                return "TabOrWindowVisibilityUnknownOrUnloaded";
        }
    } else {
        switch(reason.TAG | 0){
            case /* SearchElementTimedOut */ 0:
                var match = reason._0;
                return "SearchElementTimedOut({selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, match.selector) + (", ms: " + (match.ms.toString() + "})")));
            case /* QuerySelectorOverridesTimedOut */ 1:
                return "QuerySelectorOverridesTimedOut(" + (Belt_Array.map(reason._0, SelectorOverrideWithoutScope$SmartcutsMacros.toString).join(", ") + ")");
            case /* CouldNotApplySemantic */ 2:
                return "CouldNotApplySemantic(semanticError)";
            case /* OverlayStillBlockingElementAfterMs */ 3:
                var match$1 = reason._0;
                return "OverlayStillBlockingElementAfterMs({element: " + (match$1.element + (", maybeOverlayElement: " + (OptionUtils$SmartcutsMacros.withDefault("None", match$1.maybeOverlayElement) + (", ms: " + (match$1.ms.toString() + "})")))));
            case /* ErrorWhileSearchForElement */ 4:
                return "ErrorWhileSearchForElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, reason._0) + ")");
            case /* ErrorWhileWaitForPossibleOverlayToDisappear */ 5:
                return "ErrorWhileWaitForPossibleOverlayToDisappear(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, reason._0) + ")");
            case /* RanIntoUnhandledPromiseError */ 6:
                return "RanIntoUnhandledPromiseError(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, reason._0) + ")");
        }
    }
}
function stringifyUrlTriggerAfterExit(stringifyHtmlElement, param) {
    return "{ triggeringElement: " + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifyTriggeringElement(stringifyHtmlElement, param.triggeringElement) + " }");
}
function stringifyExited(stringifyHtmlElement, param1) {
    return "{ maybeUrlTriggerAfterExit: " + (OptionUtils$SmartcutsMacros.stringify(function(param) {
        return stringifyUrlTriggerAfterExit(stringifyHtmlElement, param);
    }, param1.maybeUrlTriggerAfterExit) + " }");
}
function stringifyExiting(stringifyHtmlElement, stringifyDomEvent, param2) {
    return "{ allExitReasons: " + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
        return stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, param);
    }, param2.allExitReasons) + (", maybeUrlTriggerAfterExit: " + (OptionUtils$SmartcutsMacros.stringify(function(param) {
        return stringifyUrlTriggerAfterExit(stringifyHtmlElement, param);
    }, param2.maybeUrlTriggerAfterExit) + (", didDetachListeners: " + (Pervasives.string_of_bool(param2.didDetachListeners) + (", nRemainingDebouncedTimeers: " + (String(param2.nRemainingDebouncedTimeers) + " }")))))));
}
function stringifyState(stringifyHtmlElement, stringifyDomEvent, param) {
    var mode = param.mode;
    var playbackWarningModalState = param.playbackWarningModalState;
    var tmp;
    if (typeof mode === "number") {
        tmp = mode === /* Init */ 0 ? "Init" : "WaitingForNextCommand";
    } else {
        switch(mode.TAG | 0){
            case /* PlayingBackCommand */ 0:
                tmp = "PlayingBackCommand(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, mode._0) + ")");
                break;
            case /* Exiting */ 1:
                tmp = "Exiting(" + (stringifyExiting(stringifyHtmlElement, stringifyDomEvent, mode._0) + ")");
                break;
            case /* Exited */ 2:
                tmp = "Exited(" + (stringifyExited(stringifyHtmlElement, mode._0) + ")");
                break;
        }
    }
    return "{ mode: " + (tmp + (", playbackWarningModalState: " + ((playbackWarningModalState ? "ShowingPlaybackWarningModal({len: " + (String(Belt_MapString.size(playbackWarningModalState._0)) + "})") : "HidingSmartcutsPlaybackWarningModal") + "}")));
}
function stringifyFailure(stringifyHtmlElement, stringifyDomEvent, failure) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithoutListener.stringify, function(param) {
        return stringifyState(stringifyHtmlElement, stringifyDomEvent, param);
    }, function(param) {
        return stringifyEvent(stringifyHtmlElement, stringifyDomEvent, param);
    }, function(param) {
        return stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, failure);
}
function stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, exitReason) {
    return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithoutListener.stringify, function(param) {
        return stringifyState(stringifyHtmlElement, stringifyDomEvent, param);
    }, function(param) {
        return stringifyEvent(stringifyHtmlElement, stringifyDomEvent, param);
    }, function(param) {
        return stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}
function stringifyEvent(stringifyHtmlElement, stringifyDomEvent, $$event) {
    if (typeof $$event === "number") {
        switch($$event){
            case /* Initialize */ 0:
                return "Initialize";
            case /* DidAttachListeners */ 1:
                return "DidAttachListeners";
            case /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */ 2:
                return "ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand";
            case /* DidDetachListeners */ 3:
                return "DidDetachListeners";
            case /* DidStartCollectingDataRecords */ 4:
                return "DidStartCollectingDataRecords";
            case /* DidFinishCollectingDataRecords */ 5:
                return "DidFinishCollectingDataRecords";
        }
    } else {
        switch($$event.TAG | 0){
            case /* DidPlaybackCommand */ 0:
                return "DidPlaybackCommand(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, $$event._0) + ")");
            case /* DidntPlaybackCommand */ 1:
                return "DidntPlaybackCommand(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, $$event._0) + (", reason=" + (stringifyReaonNotPlaybackCommand($$event._1) + ")")));
            case /* BasicEventWhilePlayback */ 2:
                return "BasicEventWhilePlayback(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
            case /* DomEvent */ 3:
                return "DomEvent(" + (Curry._1(stringifyDomEvent, $$event._0) + (", " + ($$event._1.toString() + ")")));
            case /* DidSetNewDebounceTimeout */ 4:
                return "DidSetNewDebounceTimeout(" + ($$event._0 + ", timeoutId)");
            case /* DebounceTimerExpired */ 5:
                return "DebounceTimerExpired(" + ($$event._0 + ")");
            case /* DidFlushDebouncedEvent */ 6:
                return "DidFlushDebouncedEvent(entry)";
            case /* DidClearDebounceTimeout */ 7:
                return "DidClearDebounceTimeout(" + ($$event._0 + ")");
            case /* IgnoreSubtreesWithCollectedDataRecords */ 8:
                return "IgnoreSubtreesWithCollectedDataRecords([n=" + (String($$event._0.length) + ")");
            case /* Fail */ 9:
                return "Fail(" + (stringifyFailure(stringifyHtmlElement, stringifyDomEvent, $$event._0) + ")");
            case /* Exit */ 10:
                return "Exit(" + (stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, $$event._0) + ")");
        }
    }
}
function stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* AttachListeners */ 0:
                return "AttachListeners";
            case /* RenderPlaybackModal */ 1:
                return "RenderPlaybackModal";
            case /* RemovePlaybackModal */ 2:
                return "RemovePlaybackModal";
            case /* RenderDataExtractionOverlay */ 3:
                return "RenderDataExtractionOverlay";
            case /* RemoveDataExtractionOverlay */ 4:
                return "RemoveDataExtractionOverlay";
            case /* DetachListeners */ 5:
                return "DetachListeners";
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                return "Dispatch(" + (stringifyEvent(stringifyHtmlElement, stringifyDomEvent, sideEffect._0) + ")");
            case /* PlaybackCommandAndRespondToBg */ 1:
                return "PlaybackCommandAndRespondToBg(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, sideEffect._0) + ", playbackOptions, preconditions, respondToBg)");
            case /* RespondToBg */ 2:
                return "RespondToBg(respondToBg, " + (Curry._1(ExtensionMessagingLogging.FromExtension.All.stringifyResponse, sideEffect._1) + ")");
            case /* ResetDebounceTimeout */ 3:
                return "ResetDebounceTimeout(" + (sideEffect._0 + (", maybePreviouseTimeoutId=" + OptionUtils$SmartcutsMacros.stringify(function(param) {
                    return "timeoutId";
                }, sideEffect._1)));
            case /* ClearDebounceTimeout */ 4:
                return "ClearDebounceTimeout(" + (sideEffect._0 + ", timeoutId)");
        }
    }
}
function mapPlaybackModalState(mapDomEvent1, playbackWarningModalState) {
    if (playbackWarningModalState) {
        return /* ShowingPlaybackWarningModal */ {
            _0: StateMachine__DebounceManager$SmartcutsMacros.map(mapDomEvent1, function(param) {}, playbackWarningModalState._0)
        };
    } else {
        return /* HidingSmartcutsPlaybackWarningModal */ 0;
    }
}
function mapState(mapHtmlElement, mapDomEvent2, param3) {
    var mode = param3.mode;
    var tmp;
    if (typeof mode === "number") {
        tmp = mode === /* Init */ 0 ? /* Init */ 0 : /* WaitingForNextCommand */ 1;
    } else {
        switch(mode.TAG | 0){
            case /* PlayingBackCommand */ 0:
                tmp = {
                    TAG: /* PlayingBackCommand */ 0,
                    _0: mode._0
                };
                break;
            case /* Exiting */ 1:
                var match = mode._0;
                tmp = {
                    TAG: /* Exiting */ 1,
                    _0: {
                        maybeUrlTriggerAfterExit: Belt_Option.map(match.maybeUrlTriggerAfterExit, function(param) {
                            return {
                                triggeringElement: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapTriggeringElement(mapHtmlElement, param.triggeringElement),
                                respondToBg: param.respondToBg,
                                isPlaybackMode: param.isPlaybackMode
                            };
                        }),
                        didDetachListeners: match.didDetachListeners,
                        nRemainingDebouncedTimeers: match.nRemainingDebouncedTimeers,
                        allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, mapExitReason(mapHtmlElement, mapDomEvent2), match.allExitReasons)
                    }
                };
                break;
            case /* Exited */ 2:
                tmp = {
                    TAG: /* Exited */ 2,
                    _0: {
                        maybeUrlTriggerAfterExit: Belt_Option.map(mode._0.maybeUrlTriggerAfterExit, function(param) {
                            return {
                                triggeringElement: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapTriggeringElement(mapHtmlElement, param.triggeringElement),
                                respondToBg: param.respondToBg,
                                isPlaybackMode: param.isPlaybackMode
                            };
                        })
                    }
                };
                break;
        }
    }
    return {
        playbackWarningModalState: mapPlaybackModalState(mapDomEvent2, param3.playbackWarningModalState),
        mode: tmp,
        paginateState: {
            subtreesWithCollectedDataRecords: Belt_Array.map(param3.paginateState.subtreesWithCollectedDataRecords, mapHtmlElement)
        }
    };
}
function mapEvent(mapHtmlElement, mapDomEvent3, $$event) {
    if (typeof $$event === "number") {
        switch($$event){
            case /* Initialize */ 0:
                return /* Initialize */ 0;
            case /* DidAttachListeners */ 1:
                return /* DidAttachListeners */ 1;
            case /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */ 2:
                return /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */ 2;
            case /* DidDetachListeners */ 3:
                return /* DidDetachListeners */ 3;
            case /* DidStartCollectingDataRecords */ 4:
                return /* DidStartCollectingDataRecords */ 4;
            case /* DidFinishCollectingDataRecords */ 5:
                return /* DidFinishCollectingDataRecords */ 5;
        }
    } else {
        switch($$event.TAG | 0){
            case /* DidPlaybackCommand */ 0:
                return {
                    TAG: /* DidPlaybackCommand */ 0,
                    _0: $$event._0
                };
            case /* DidntPlaybackCommand */ 1:
                return {
                    TAG: /* DidntPlaybackCommand */ 1,
                    _0: $$event._0,
                    _1: $$event._1
                };
            case /* BasicEventWhilePlayback */ 2:
                return {
                    TAG: /* BasicEventWhilePlayback */ 2,
                    _0: $$event._0
                };
            case /* DomEvent */ 3:
                return {
                    TAG: /* DomEvent */ 3,
                    _0: Curry._1(mapDomEvent3, $$event._0),
                    _1: $$event._1
                };
            case /* DidSetNewDebounceTimeout */ 4:
                return {
                    TAG: /* DidSetNewDebounceTimeout */ 4,
                    _0: $$event._0,
                    _1: $$event._1
                };
            case /* DebounceTimerExpired */ 5:
                return {
                    TAG: /* DebounceTimerExpired */ 5,
                    _0: $$event._0
                };
            case /* DidFlushDebouncedEvent */ 6:
                return {
                    TAG: /* DidFlushDebouncedEvent */ 6,
                    _0: StateMachine__DebounceManager$SmartcutsMacros.mapEntry(mapDomEvent3, function(param) {}, $$event._0)
                };
            case /* DidClearDebounceTimeout */ 7:
                return {
                    TAG: /* DidClearDebounceTimeout */ 7,
                    _0: $$event._0
                };
            case /* IgnoreSubtreesWithCollectedDataRecords */ 8:
                return {
                    TAG: /* IgnoreSubtreesWithCollectedDataRecords */ 8,
                    _0: Belt_Array.map($$event._0, mapHtmlElement)
                };
            case /* Fail */ 9:
                return {
                    TAG: /* Fail */ 9,
                    _0: Curry._1(mapFailure(mapHtmlElement, mapDomEvent3), $$event._0)
                };
            case /* Exit */ 10:
                return {
                    TAG: /* Exit */ 10,
                    _0: Curry._1(mapExitReason(mapHtmlElement, mapDomEvent3), $$event._0)
                };
        }
    }
}
function mapFailure(mapHtmlElement, mapDomEvent4) {
    return Curry._3(StateMachine$SmartcutsMacros.Failure.WithoutListener.map, function(param) {
        return mapState(mapHtmlElement, mapDomEvent4, param);
    }, function(param) {
        return mapEvent(mapHtmlElement, mapDomEvent4, param);
    }, function(param) {
        return mapSideEffect(mapHtmlElement, mapDomEvent4, param);
    });
}
function mapExitReason(mapHtmlElement, mapDomEvent5) {
    return Curry._3(StateMachine$SmartcutsMacros.Exit.ExitReason.WithoutListener.map, function(param) {
        return mapState(mapHtmlElement, mapDomEvent5, param);
    }, function(param) {
        return mapEvent(mapHtmlElement, mapDomEvent5, param);
    }, function(param) {
        return mapSideEffect(mapHtmlElement, mapDomEvent5, param);
    });
}
function mapSideEffect(mapHtmlElement, mapDomEvent6, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* AttachListeners */ 0:
                return /* AttachListeners */ 0;
            case /* RenderPlaybackModal */ 1:
                return /* RenderPlaybackModal */ 1;
            case /* RemovePlaybackModal */ 2:
                return /* RemovePlaybackModal */ 2;
            case /* RenderDataExtractionOverlay */ 3:
                return /* RenderDataExtractionOverlay */ 3;
            case /* RemoveDataExtractionOverlay */ 4:
                return /* RemoveDataExtractionOverlay */ 4;
            case /* DetachListeners */ 5:
                return /* DetachListeners */ 5;
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                return {
                    TAG: /* Dispatch */ 0,
                    _0: mapEvent(mapHtmlElement, mapDomEvent6, sideEffect._0)
                };
            case /* PlaybackCommandAndRespondToBg */ 1:
                return {
                    TAG: /* PlaybackCommandAndRespondToBg */ 1,
                    _0: sideEffect._0,
                    _1: sideEffect._1,
                    _2: sideEffect._2,
                    _3: sideEffect._3
                };
            case /* RespondToBg */ 2:
                return {
                    TAG: /* RespondToBg */ 2,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* ResetDebounceTimeout */ 3:
                return {
                    TAG: /* ResetDebounceTimeout */ 3,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* ClearDebounceTimeout */ 4:
                return {
                    TAG: /* ClearDebounceTimeout */ 4,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
        }
    }
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "stringifyReaonNotPlaybackCommand"
        ],
        [
            /* Function */ 0,
            "stringifyState"
        ],
        [
            /* Function */ 0,
            "stringifyFailure"
        ],
        [
            /* Function */ 0,
            "stringifyExitReason"
        ],
        [
            /* Function */ 0,
            "stringifyEvent"
        ],
        [
            /* Function */ 0,
            "stringifySideEffect"
        ],
        [
            /* Function */ 0,
            "mapState"
        ],
        [
            /* Function */ 0,
            "mapEvent"
        ],
        [
            /* Function */ 0,
            "mapSideEffect"
        ]
    ]
}, ContentScript__StateMachine__PlaybackMode__Types__Helpers, {
    stringifyReaonNotPlaybackCommand: stringifyReaonNotPlaybackCommand,
    stringifyState: stringifyState,
    stringifyFailure: stringifyFailure,
    stringifyExitReason: stringifyExitReason,
    stringifyEvent: stringifyEvent,
    stringifySideEffect: stringifySideEffect,
    mapState: mapState,
    mapEvent: mapEvent,
    mapSideEffect: mapSideEffect
});
function stringifyListener(stringifyDomMutationRecord1, listener) {
    if (listener.TAG === /* DocumentBodyMutationObserverListener */ 0) {
        return "DocumentBodyMutationObserverListener([" + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list($$Array.map(stringifyDomMutationRecord1, listener._0))) + "])");
    } else {
        return "ContentEditableMutationObserverListener([" + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list($$Array.map(stringifyDomMutationRecord1, listener._0))) + "])");
    }
}
function stringifyState$1(stringifyDomHtmlElement1, stringifyDomNode1, stringifyDomMutationRecord2, stringifyDomEvent, state) {
    if (typeof state === "number") {
        if (state === /* Init */ 0) {
            return "Init";
        } else {
            return "NotEditing";
        }
    }
    switch(state.TAG | 0){
        case /* WaitMutationObserverAttachTo */ 0:
            return "WaitMutationObserverAttachTo(contentEditableHost=" + (Curry._1(stringifyDomHtmlElement1, state._0) + ")");
        case /* EditingContentEditable */ 1:
            return "EditingContentEditable(virtualizedContentEditable=" + (Virtualized__ContentEditable$SmartcutsMacros.Generic.stringify(stringifyDomHtmlElement1, stringifyDomNode1, state._0) + ", _disconnect)");
        case /* Exiting */ 2:
            return "Exiting(respondToBg)";
        case /* Exited */ 3:
            return "Exited(" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
                return stringifyExitReason$1(stringifyDomHtmlElement1, stringifyDomNode1, stringifyDomMutationRecord2, stringifyDomEvent, param);
            }, state._0) + ")");
    }
}
function stringifyEvent$1(stringifyDomHtmlElement2, stringifyDomNode2, stringifyDomMutationRecord3, stringifyDomEvent, $$event) {
    if (typeof $$event === "number") {
        if ($$event === /* Initialize */ 0) {
            return "Initialize";
        } else {
            return "MutationObserved";
        }
    }
    switch($$event.TAG | 0){
        case /* SharedEvent */ 0:
            return "SharedEvent(" + (ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.stringifyEvent(stringifyDomHtmlElement2, stringifyDomEvent, $$event._0) + ")");
        case /* BasicEventWhileContentEditing */ 1:
            return "BasicEventWhileContentEditing(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
        case /* FocusOnContentEditable */ 2:
            return "FocusOnContentEditable(" + (Curry._1(stringifyDomNode2, $$event._0) + ")");
        case /* MutationObserverAttachedTo */ 3:
            return "MutationObserverAttachedTo(contentEditableHost=" + (Curry._1(stringifyDomHtmlElement2, $$event._0) + ", disconnect)");
        case /* Fail */ 4:
            return "Fail(" + (stringifyFailure$1(stringifyDomHtmlElement2, stringifyDomNode2, stringifyDomMutationRecord3, stringifyDomEvent, $$event._0) + ")");
        case /* Exit */ 5:
            return "Exit(" + (stringifyExitReason$1(stringifyDomHtmlElement2, stringifyDomNode2, stringifyDomMutationRecord3, stringifyDomEvent, $$event._0) + ")");
    }
}
function stringifySideEffect$1(stringifyDomHtmlElement3, stringifyDomNode3, stringifyDomMutationRecord4, stringifyDomEvent, sideEffect) {
    switch(sideEffect.TAG | 0){
        case /* Dispatch */ 0:
            return "Dispatch(" + (stringifyEvent$1(stringifyDomHtmlElement3, stringifyDomNode3, stringifyDomMutationRecord4, stringifyDomEvent, sideEffect._0) + ")");
        case /* SetupMutationObserver */ 1:
            return "SetupMutationObserver(contentEditableHost=" + (Curry._1(stringifyDomHtmlElement3, sideEffect._0) + ")");
        case /* TearDownMutationObserver */ 2:
            return "TearDownMutationObserver(disconnect)";
    }
}
function stringifyFailure$1(stringifyDomHtmlElement4, stringifyDomNode4, stringifyDomMutationRecord5, stringifyDomEvent, failure) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, function(param) {
        return stringifyState$1(stringifyDomHtmlElement4, stringifyDomNode4, stringifyDomMutationRecord5, stringifyDomEvent, param);
    }, function(param) {
        return stringifyEvent$1(stringifyDomHtmlElement4, stringifyDomNode4, stringifyDomMutationRecord5, stringifyDomEvent, param);
    }, function(param) {
        return stringifySideEffect$1(stringifyDomHtmlElement4, stringifyDomNode4, stringifyDomMutationRecord5, stringifyDomEvent, param);
    }, function(param) {
        return stringifyListener(stringifyDomMutationRecord5, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, failure);
}
function stringifyExitReason$1(stringifyDomHtmlElement5, stringifyDomNode5, stringifyDomMutationRecord6, stringifyDomEvent, exitReason) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, function(param) {
        return stringifyState$1(stringifyDomHtmlElement5, stringifyDomNode5, stringifyDomMutationRecord6, stringifyDomEvent, param);
    }, function(param) {
        return stringifyEvent$1(stringifyDomHtmlElement5, stringifyDomNode5, stringifyDomMutationRecord6, stringifyDomEvent, param);
    }, function(param) {
        return stringifySideEffect$1(stringifyDomHtmlElement5, stringifyDomNode5, stringifyDomMutationRecord6, stringifyDomEvent, param);
    }, function(param) {
        return stringifyListener(stringifyDomMutationRecord6, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}
function mapListener(mapDomMutationRecord1, listener) {
    if (listener.TAG === /* DocumentBodyMutationObserverListener */ 0) {
        return {
            TAG: /* DocumentBodyMutationObserverListener */ 0,
            _0: $$Array.map(mapDomMutationRecord1, listener._0)
        };
    } else {
        return {
            TAG: /* ContentEditableMutationObserverListener */ 1,
            _0: $$Array.map(mapDomMutationRecord1, listener._0)
        };
    }
}
function mapState$1(mapDomHtmlElement1, mapDomNode1, mapDomMutationRecord2, mapDomEvent7, state) {
    if (typeof state === "number") {
        if (state === /* Init */ 0) {
            return /* Init */ 0;
        } else {
            return /* NotEditing */ 1;
        }
    }
    switch(state.TAG | 0){
        case /* WaitMutationObserverAttachTo */ 0:
            return {
                TAG: /* WaitMutationObserverAttachTo */ 0,
                _0: Curry._1(mapDomHtmlElement1, state._0)
            };
        case /* EditingContentEditable */ 1:
            return {
                TAG: /* EditingContentEditable */ 1,
                _0: Virtualized__ContentEditable$SmartcutsMacros.Generic.map(mapDomHtmlElement1, mapDomNode1, state._0),
                _1: state._1
            };
        case /* Exiting */ 2:
            return {
                TAG: /* Exiting */ 2,
                _0: {
                    allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                        return mapExitReason$1(mapDomHtmlElement1, mapDomNode1, mapDomMutationRecord2, mapDomEvent7, param);
                    }, state._0.allExitReasons)
                }
            };
        case /* Exited */ 3:
            return {
                TAG: /* Exited */ 3,
                _0: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                    return mapExitReason$1(mapDomHtmlElement1, mapDomNode1, mapDomMutationRecord2, mapDomEvent7, param);
                }, state._0)
            };
    }
}
function mapEvent$1(mapDomHtmlElement2, mapDomNode2, mapDomMutationRecord3, mapDomEvent8, $$event) {
    if (typeof $$event === "number") {
        if ($$event === /* Initialize */ 0) {
            return /* Initialize */ 0;
        } else {
            return /* MutationObserved */ 1;
        }
    }
    switch($$event.TAG | 0){
        case /* SharedEvent */ 0:
            return {
                TAG: /* SharedEvent */ 0,
                _0: ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.mapEvent(mapDomHtmlElement2, mapDomEvent8, $$event._0)
            };
        case /* BasicEventWhileContentEditing */ 1:
            return {
                TAG: /* BasicEventWhileContentEditing */ 1,
                _0: $$event._0
            };
        case /* FocusOnContentEditable */ 2:
            return {
                TAG: /* FocusOnContentEditable */ 2,
                _0: Curry._1(mapDomNode2, $$event._0)
            };
        case /* MutationObserverAttachedTo */ 3:
            return {
                TAG: /* MutationObserverAttachedTo */ 3,
                _0: Curry._1(mapDomHtmlElement2, $$event._0),
                _1: $$event._1
            };
        case /* Fail */ 4:
            return {
                TAG: /* Fail */ 4,
                _0: mapFailure$1(mapDomHtmlElement2, mapDomNode2, mapDomMutationRecord3, mapDomEvent8, $$event._0)
            };
        case /* Exit */ 5:
            return {
                TAG: /* Exit */ 5,
                _0: mapExitReason$1(mapDomHtmlElement2, mapDomNode2, mapDomMutationRecord3, mapDomEvent8, $$event._0)
            };
    }
}
function mapSideEffect$1(mapDomHtmlElement3, mapDomNode3, mapDomMutationRecord4, mapDomEvent9, sideEffect) {
    switch(sideEffect.TAG | 0){
        case /* Dispatch */ 0:
            return {
                TAG: /* Dispatch */ 0,
                _0: mapEvent$1(mapDomHtmlElement3, mapDomNode3, mapDomMutationRecord4, mapDomEvent9, sideEffect._0)
            };
        case /* SetupMutationObserver */ 1:
            return {
                TAG: /* SetupMutationObserver */ 1,
                _0: Curry._1(mapDomHtmlElement3, sideEffect._0)
            };
        case /* TearDownMutationObserver */ 2:
            return {
                TAG: /* TearDownMutationObserver */ 2,
                _0: sideEffect._0
            };
    }
}
function mapFailure$1(mapDomHtmlElement4, mapDomNode4, mapDomMutationRecord5, mapDomEvent10, failure) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, function(param) {
        return mapState$1(mapDomHtmlElement4, mapDomNode4, mapDomMutationRecord5, mapDomEvent10, param);
    }, function(param) {
        return mapEvent$1(mapDomHtmlElement4, mapDomNode4, mapDomMutationRecord5, mapDomEvent10, param);
    }, function(param) {
        return mapSideEffect$1(mapDomHtmlElement4, mapDomNode4, mapDomMutationRecord5, mapDomEvent10, param);
    }, function(param) {
        return mapListener(mapDomMutationRecord5, param);
    }, failure);
}
function mapExitReason$1(mapDomHtmlElement5, mapDomNode5, mapDomMutationRecord6, mapDomEvent11, exitReason) {
    return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, function(param) {
        return mapState$1(mapDomHtmlElement5, mapDomNode5, mapDomMutationRecord6, mapDomEvent11, param);
    }, function(param) {
        return mapEvent$1(mapDomHtmlElement5, mapDomNode5, mapDomMutationRecord6, mapDomEvent11, param);
    }, function(param) {
        return mapSideEffect$1(mapDomHtmlElement5, mapDomNode5, mapDomMutationRecord6, mapDomEvent11, param);
    }, function(param) {
        return mapListener(mapDomMutationRecord6, param);
    }, exitReason);
}
var stringifyDomMutationRecord = DOM$SmartcutsMacros.$$MutationRecord.stringify;
function stringifyState$2(param) {
    return stringifyState$1(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord, DOM__Event$SmartcutsMacros.stringify, param);
}
function stringifyEvent$2(param) {
    return stringifyEvent$1(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord, DOM__Event$SmartcutsMacros.stringify, param);
}
function stringifySideEffect$2(param) {
    return stringifySideEffect$1(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord, DOM__Event$SmartcutsMacros.stringify, param);
}
function stringifyListener$1(param) {
    return stringifyListener(stringifyDomMutationRecord, param);
}
var stringifyDomHtmlElement = DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify;
var stringifyDomNode = DOM__Node$SmartcutsMacros.ForSerialization.stringify;
var stringifyDomMutationRecord$1 = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify;
function stringifyState$3(param) {
    return stringifyState$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord$1, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}
function stringifyEvent$3(param) {
    return stringifyEvent$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord$1, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}
function stringifySideEffect$3(param) {
    return stringifySideEffect$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord$1, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}
function stringifyListener$2(param) {
    return stringifyListener(stringifyDomMutationRecord$1, param);
}
var mapDomHtmlElement = DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement;
var mapDomNode = DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode;
var mapDomMutationRecord = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord;
var mapDomEvent = DOM__Event__ForSerialization$SmartcutsMacros.make;
function prepareStateForSerialization(state) {
    return mapState$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, state);
}
function prepareEventForSerialization($$event) {
    return mapEvent$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event);
}
function prepareSideEffectForSerialization(sideEffect) {
    return mapSideEffect$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, sideEffect);
}
function prepareListenerForSerialization(listener) {
    return mapListener(mapDomMutationRecord, listener);
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyFailure"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapExitReason"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareListenerForSerialization"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
}, ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers, {
    Generic: {
        stringifyListener: stringifyListener,
        stringifyState: stringifyState$1,
        stringifyEvent: stringifyEvent$1,
        stringifySideEffect: stringifySideEffect$1,
        stringifyFailure: stringifyFailure$1,
        stringifyExitReason: stringifyExitReason$1,
        mapListener: mapListener,
        mapState: mapState$1,
        mapEvent: mapEvent$1,
        mapSideEffect: mapSideEffect$1,
        mapFailure: mapFailure$1,
        mapExitReason: mapExitReason$1
    },
    Regular: {
        stringifyState: stringifyState$2,
        stringifyEvent: stringifyEvent$2,
        stringifySideEffect: stringifySideEffect$2,
        stringifyListener: stringifyListener$1
    },
    ForSerialization: {
        stringifyState: stringifyState$3,
        stringifyEvent: stringifyEvent$3,
        stringifySideEffect: stringifySideEffect$3,
        stringifyListener: stringifyListener$2,
        prepareStateForSerialization: prepareStateForSerialization,
        prepareEventForSerialization: prepareEventForSerialization,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization,
        prepareListenerForSerialization: prepareListenerForSerialization
    }
});
function mapListener$1(mapDomEvent12, listener) {
    return /* DOMEventListener */ {
        _0: Curry._1(mapDomEvent12, listener._0)
    };
}
function mapState$2(mapDomEvent13, mapInputByDomElementRepresentation, mapDomHtmlElement6, mapDomNode6, state) {
    if (typeof state === "number") {
        if (state === /* Init */ 0) {
            return /* Init */ 0;
        } else {
            return /* SettingUpEventStreamingToBg */ 1;
        }
    }
    switch(state.TAG | 0){
        case /* StreamingEventsToBg */ 0:
            return {
                TAG: /* StreamingEventsToBg */ 0,
                _0: mapStreamingState(mapDomEvent13, mapInputByDomElementRepresentation, mapDomHtmlElement6, mapDomNode6, state._0)
            };
        case /* HighlightingElementWhileStreamingEventsToBg */ 1:
            return {
                TAG: /* HighlightingElementWhileStreamingEventsToBg */ 1,
                _0: mapStreamingState(mapDomEvent13, mapInputByDomElementRepresentation, mapDomHtmlElement6, mapDomNode6, state._0),
                _1: state._1
            };
        case /* Exiting */ 2:
            var match = state._0;
            return {
                TAG: /* Exiting */ 2,
                _0: {
                    didTeardownEventStreaming: match.didTeardownEventStreaming,
                    debounceStatusForExit: mapDebounceStatusForExit(mapDomEvent13, mapInputByDomElementRepresentation, mapDomHtmlElement6, mapDomNode6, match.debounceStatusForExit),
                    allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                        return mapExitReason$2(mapDomEvent13, mapInputByDomElementRepresentation, mapDomHtmlElement6, mapDomNode6, param);
                    }, match.allExitReasons)
                }
            };
        case /* Exited */ 3:
            return {
                TAG: /* Exited */ 3,
                _0: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                    return mapExitReason$2(mapDomEvent13, mapInputByDomElementRepresentation, mapDomHtmlElement6, mapDomNode6, param);
                }, state._0)
            };
    }
}
function mapStreamingState(mapDomEvent14, mapInputByDomElementRepresentation, mapDomHtmlElement7, mapDomNode7, param4) {
    var func = function func(param, param$1) {
        return StateMachine__DebounceManager$SmartcutsMacros.map(mapDomEvent14, param, param$1);
    };
    return {
        inputByDomElementRepresentation: Curry._1(mapInputByDomElementRepresentation, param4.inputByDomElementRepresentation),
        currentSelection: Selection__Snapshot$SmartcutsMacros.Generic.map(mapDomNode7, param4.currentSelection),
        focusTrail: List.map(function(param) {
            return DOM__FocusTrail$SmartcutsMacros.Item.map(mapDomHtmlElement7, param);
        }, param4.focusTrail),
        maybeClickContext: Belt_Option.map(param4.maybeClickContext, mapDomEvent14),
        debounceManager: Curry._2(func, function(firstCallData) {
            return {
                pendingCommandKey: firstCallData.pendingCommandKey,
                focusTrail: List.map(function(param) {
                    return DOM__FocusTrail$SmartcutsMacros.Item.map(mapDomHtmlElement7, param);
                }, firstCallData.focusTrail),
                firstTimestamp: firstCallData.firstTimestamp
            };
        }, param4.debounceManager)
    };
}
function mapDebounceStatusForExit(mapDomEvent15, mapInputByDomElementRepresentation, mapDomHtmlElement8, mapDomNode8, exitingSubState) {
    if (exitingSubState) {
        return /* AwaitingAllDebouncedEventsToFlush */ {
            _0: mapStreamingState(mapDomEvent15, mapInputByDomElementRepresentation, mapDomHtmlElement8, mapDomNode8, exitingSubState._0)
        };
    } else {
        return /* FlushedAllDebouncedEvents */ 0;
    }
}
function mapEvent$2(mapDomEvent16, mapInputByDomElementRepresentation, mapDomHtmlElement9, mapDomNode9, $$event) {
    if (typeof $$event === "number") {
        switch($$event){
            case /* DidSetupEventStreaming */ 0:
                return /* DidSetupEventStreaming */ 0;
            case /* DidTeardownEventStreaming */ 1:
                return /* DidTeardownEventStreaming */ 1;
            case /* ShouldNotShowUserExplainHighlightModal */ 2:
                return /* ShouldNotShowUserExplainHighlightModal */ 2;
        }
    } else {
        switch($$event.TAG | 0){
            case /* Initialize */ 0:
                return {
                    TAG: /* Initialize */ 0,
                    _0: $$event._0
                };
            case /* DidSetNewDebounceTimeout */ 1:
                return {
                    TAG: /* DidSetNewDebounceTimeout */ 1,
                    _0: $$event._0,
                    _1: $$event._1
                };
            case /* DebounceTimerExpired */ 2:
                return {
                    TAG: /* DebounceTimerExpired */ 2,
                    _0: $$event._0
                };
            case /* DidFlushDebouncedEvent */ 3:
                return {
                    TAG: /* DidFlushDebouncedEvent */ 3,
                    _0: StateMachine__DebounceManager$SmartcutsMacros.mapEntry(mapDomEvent16, function(firstCallData) {
                        return {
                            pendingCommandKey: firstCallData.pendingCommandKey,
                            focusTrail: List.map(function(param) {
                                return DOM__FocusTrail$SmartcutsMacros.Item.map(mapDomHtmlElement9, param);
                            }, firstCallData.focusTrail),
                            firstTimestamp: firstCallData.firstTimestamp
                        };
                    }, $$event._0)
                };
            case /* UserDidSelectElement */ 4:
                return {
                    TAG: /* UserDidSelectElement */ 4,
                    _0: Curry._1(mapDomHtmlElement9, $$event._0)
                };
            case /* SharedEvent */ 5:
                return {
                    TAG: /* SharedEvent */ 5,
                    _0: ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.mapEvent(mapDomHtmlElement9, mapDomEvent16, $$event._0)
                };
            case /* BasicEventWhileEventStreaming */ 6:
                return {
                    TAG: /* BasicEventWhileEventStreaming */ 6,
                    _0: $$event._0
                };
            case /* Fail */ 7:
                return {
                    TAG: /* Fail */ 7,
                    _0: mapFailure$2(mapDomEvent16, mapInputByDomElementRepresentation, mapDomHtmlElement9, mapDomNode9, $$event._0)
                };
            case /* Exit */ 8:
                return {
                    TAG: /* Exit */ 8,
                    _0: mapExitReason$2(mapDomEvent16, mapInputByDomElementRepresentation, mapDomHtmlElement9, mapDomNode9, $$event._0)
                };
        }
    }
}
function mapFailure$2(mapDomEvent17, mapInputByDomElementRepresentation, mapDomHtmlElement10, mapDomNode10, failure) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, function(param) {
        return mapState$2(mapDomEvent17, mapInputByDomElementRepresentation, mapDomHtmlElement10, mapDomNode10, param);
    }, function(param) {
        return mapEvent$2(mapDomEvent17, mapInputByDomElementRepresentation, mapDomHtmlElement10, mapDomNode10, param);
    }, function(param) {
        return mapSideEffect$2(mapDomEvent17, mapInputByDomElementRepresentation, mapDomHtmlElement10, mapDomNode10, param);
    }, function(param) {
        return mapListener$1(mapDomEvent17, param);
    }, failure);
}
function mapExitReason$2(mapDomEvent18, mapInputByDomElementRepresentation, mapDomHtmlElement11, mapDomNode11, exitReason) {
    return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, function(param) {
        return mapState$2(mapDomEvent18, mapInputByDomElementRepresentation, mapDomHtmlElement11, mapDomNode11, param);
    }, function(param) {
        return mapEvent$2(mapDomEvent18, mapInputByDomElementRepresentation, mapDomHtmlElement11, mapDomNode11, param);
    }, function(param) {
        return mapSideEffect$2(mapDomEvent18, mapInputByDomElementRepresentation, mapDomHtmlElement11, mapDomNode11, param);
    }, function(param) {
        return mapListener$1(mapDomEvent18, param);
    }, exitReason);
}
function mapSideEffect$2(mapDomEvent19, mapInputByDomElementRepresentation, mapDomHtmlElement12, mapDomNode12, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* SetupEventStreaming */ 0:
                return /* SetupEventStreaming */ 0;
            case /* TeardownEventStreaming */ 1:
                return /* TeardownEventStreaming */ 1;
            case /* RenderModalToExplainHighlightElement */ 2:
                return /* RenderModalToExplainHighlightElement */ 2;
            case /* RenderHighlightElementControl */ 3:
                return /* RenderHighlightElementControl */ 3;
            case /* RemoveRenderedContent */ 4:
                return /* RemoveRenderedContent */ 4;
            case /* TellBgToStopHighlightingElement */ 5:
                return /* TellBgToStopHighlightingElement */ 5;
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                return {
                    TAG: /* Dispatch */ 0,
                    _0: mapEvent$2(mapDomEvent19, mapInputByDomElementRepresentation, mapDomHtmlElement12, mapDomNode12, sideEffect._0)
                };
            case /* StreamCommandToBgToRecordIt */ 1:
                return {
                    TAG: /* StreamCommandToBgToRecordIt */ 1,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* NotifyBgAboutPossibleCommand */ 2:
                return {
                    TAG: /* NotifyBgAboutPossibleCommand */ 2,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* ResetDebounceTimeout */ 3:
                return {
                    TAG: /* ResetDebounceTimeout */ 3,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* RespondToBg */ 4:
                return {
                    TAG: /* RespondToBg */ 4,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* StreamCommandToBgForHighlightedElement */ 5:
                return {
                    TAG: /* StreamCommandToBgForHighlightedElement */ 5,
                    _0: Curry._1(mapDomHtmlElement12, sideEffect._0),
                    _1: sideEffect._1
                };
            case /* RetrievePossibleCommandInfoAndMaybeStreamToBg */ 6:
                return {
                    TAG: /* RetrievePossibleCommandInfoAndMaybeStreamToBg */ 6,
                    _0: sideEffect._0,
                    _1: sideEffect._1,
                    _2: sideEffect._2
                };
        }
    }
}
function stringifyListener$3(stringifyDomEvent, listener) {
    return "DOM.listen(timestamp, domEvent=" + (Curry._1(stringifyDomEvent, listener._0) + ") for listener setup as a result of SetupEventStreaming");
}
function stringifyState$4(stringifyDomEvent, stringifyInputByDomElementRepresentation1, stringifyDomHtmlElement6, stringifyDomNode6, state) {
    var stringifyStreamingState = function stringifyStreamingState(param) {
        return "{inputByDomElementRepresentation: " + (Curry._1(stringifyInputByDomElementRepresentation1, param.inputByDomElementRepresentation) + (", currentSelection: " + (Selection__Snapshot$SmartcutsMacros.Generic.stringify(stringifyDomNode6, param.currentSelection) + (", maybeClickContext: " + (OptionUtils$SmartcutsMacros.stringify(stringifyDomEvent, param.maybeClickContext) + (", debounceManager({len: " + (String(StateMachine__DebounceManager$SmartcutsMacros.size(param.debounceManager)) + "})}")))))));
    };
    if (typeof state === "number") {
        if (state === /* Init */ 0) {
            return "Init";
        } else {
            return "SettingUpEventStreamingToBg";
        }
    }
    switch(state.TAG | 0){
        case /* StreamingEventsToBg */ 0:
            return "StreamingEventsToBg(" + (stringifyStreamingState(state._0) + ")");
        case /* HighlightingElementWhileStreamingEventsToBg */ 1:
            return "HighlightingElementWhileStreamingEventsToBg(" + (stringifyStreamingState(state._0) + (", callback=" + (HighlightElement__Shared$SmartcutsMacros.Callback.stringify(state._1) + ")")));
        case /* Exiting */ 2:
            var match = state._0;
            var debounceStatusForExit = match.debounceStatusForExit;
            var tmp;
            if (debounceStatusForExit) {
                var match$1 = debounceStatusForExit._0;
                tmp = "AwaitingAllDebouncedEventsToFlush({inputByDomElementRepresentation: " + (Curry._1(stringifyInputByDomElementRepresentation1, match$1.inputByDomElementRepresentation) + (", currentSelection: " + (Selection__Snapshot$SmartcutsMacros.Generic.stringify(stringifyDomNode6, match$1.currentSelection) + (", maybeClickContext: " + ((match$1.maybeClickContext !== undefined ? "Some(domEvent)" : "None") + (", debounceManager({len: " + (String(StateMachine__DebounceManager$SmartcutsMacros.size(match$1.debounceManager)) + "})})")))))));
            } else {
                tmp = "FlushedAllDebouncedEvents";
            }
            return "Exiting({didTeardownEventStreaming: " + (Pervasives.string_of_bool(match.didTeardownEventStreaming) + (", debounceStatusForExit: " + (tmp + ", allExitReasons})")));
        case /* Exited */ 3:
            return "Exited(" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
                return stringifyExitReason$2(stringifyDomEvent, stringifyInputByDomElementRepresentation1, stringifyDomHtmlElement6, stringifyDomNode6, param);
            }, state._0) + ")");
    }
}
function stringifyExitReason$2(stringifyDomEvent, stringifyInputByDomElementRepresentation2, stringifyDomHtmlElement7, stringifyDomNode7, exitReason) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, function(param) {
        return stringifyState$4(stringifyDomEvent, stringifyInputByDomElementRepresentation2, stringifyDomHtmlElement7, stringifyDomNode7, param);
    }, function(param) {
        return stringifyEvent$4(stringifyDomEvent, stringifyInputByDomElementRepresentation2, stringifyDomHtmlElement7, stringifyDomNode7, param);
    }, function(param) {
        return stringifySideEffect$4(stringifyDomEvent, stringifyInputByDomElementRepresentation2, stringifyDomHtmlElement7, stringifyDomNode7, param);
    }, function(param) {
        return stringifyListener$3(stringifyDomEvent, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}
function stringifyFailure$2(stringifyDomEvent, stringifyInputByDomElementRepresentation3, stringifyDomHtmlElement8, stringifyDomNode8, failure) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, function(param) {
        return stringifyState$4(stringifyDomEvent, stringifyInputByDomElementRepresentation3, stringifyDomHtmlElement8, stringifyDomNode8, param);
    }, function(param) {
        return stringifyEvent$4(stringifyDomEvent, stringifyInputByDomElementRepresentation3, stringifyDomHtmlElement8, stringifyDomNode8, param);
    }, function(param) {
        return stringifySideEffect$4(stringifyDomEvent, stringifyInputByDomElementRepresentation3, stringifyDomHtmlElement8, stringifyDomNode8, param);
    }, function(param) {
        return stringifyListener$3(stringifyDomEvent, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, failure);
}
function stringifyEvent$4(stringifyDomEvent, stringifyInputByDomElementRepresentation4, stringifyDomHtmlElement9, stringifyDomNode9, $$event) {
    if (typeof $$event === "number") {
        switch($$event){
            case /* DidSetupEventStreaming */ 0:
                return "DidSetupEventStreaming";
            case /* DidTeardownEventStreaming */ 1:
                return "DidTeardownEventStreaming";
            case /* ShouldNotShowUserExplainHighlightModal */ 2:
                return "ShouldNotShowUserExplainHighlightModal";
        }
    } else {
        switch($$event.TAG | 0){
            case /* Initialize */ 0:
                if ($$event._0 !== undefined) {
                    return "Initialize(respondToBg, rejectToBg)";
                } else {
                    return "Initialize(None)";
                }
            case /* DidSetNewDebounceTimeout */ 1:
                return "DidSetNewDebounceTimeout(" + ($$event._0 + (", " + (String($$event._1) + ")")));
            case /* DebounceTimerExpired */ 2:
                return "DebounceTimerExpired(" + ($$event._0 + ")");
            case /* DidFlushDebouncedEvent */ 3:
                return "DidFlushDebouncedEvent(" + (Curry._1(stringifyDomEvent, $$event._0.event) + ")");
            case /* UserDidSelectElement */ 4:
                return "UserDidSelectElement(htmlElement)";
            case /* SharedEvent */ 5:
                return "SharedEvent(" + (ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.stringifyEvent(stringifyDomHtmlElement9, stringifyDomEvent, $$event._0) + ")");
            case /* BasicEventWhileEventStreaming */ 6:
                return "BasicEventWhileEventStreaming(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
            case /* Fail */ 7:
                return "Fail(" + (stringifyFailure$2(stringifyDomEvent, stringifyInputByDomElementRepresentation4, stringifyDomHtmlElement9, stringifyDomNode9, $$event._0) + ")");
            case /* Exit */ 8:
                return "Exit(" + (stringifyExitReason$2(stringifyDomEvent, stringifyInputByDomElementRepresentation4, stringifyDomHtmlElement9, stringifyDomNode9, $$event._0) + ")");
        }
    }
}
function stringifySideEffect$4(stringifyDomEvent, stringifyInputByDomElementRepresentation5, stringifyDomHtmlElement10, stringifyDomNode10, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* SetupEventStreaming */ 0:
                return "SetupEventStreaming";
            case /* TeardownEventStreaming */ 1:
                return "TeardownEventStreaming";
            case /* RenderModalToExplainHighlightElement */ 2:
                return "RenderModalToExplainHighlightElement";
            case /* RenderHighlightElementControl */ 3:
                return "RenderHighlightElementControl";
            case /* RemoveRenderedContent */ 4:
                return "RemoveRenderedContent";
            case /* TellBgToStopHighlightingElement */ 5:
                return "TellBgToStopHighlightingElement";
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                return "Dispatch(" + (stringifyEvent$4(stringifyDomEvent, stringifyInputByDomElementRepresentation5, stringifyDomHtmlElement10, stringifyDomNode10, sideEffect._0) + ")");
            case /* StreamCommandToBgToRecordIt */ 1:
                var arg = OptionUtils$SmartcutsMacros.map(sideEffect._1, function(param) {
                    return "(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(param[0]) + (", " + String(param[1])));
                });
                return "StreamCommandToBgToRecordIt(commandWithContextLocal where command=" + (Command$SmartcutsMacros.stringifyRecordingCommand(sideEffect._0.command) + (", maybeInsertAfter=" + (function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("None") + ")")));
            case /* NotifyBgAboutPossibleCommand */ 2:
                var maybeBoundingRect = sideEffect._1;
                return "NotifyBgAboutPossibleCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._0) + (", boundingRect=" + ((maybeBoundingRect !== undefined ? JSON.stringify(Rect$SmartcutsMacros.t_encode(maybeBoundingRect)) : "None") + ")")));
            case /* ResetDebounceTimeout */ 3:
                var arg$1 = OptionUtils$SmartcutsMacros.map(sideEffect._1, function(id) {
                    return String(id);
                });
                return "ResetDebounceTimeout(" + (sideEffect._0 + (", " + (function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                }("None") + ")")));
            case /* RespondToBg */ 4:
                return "RespondToBg(respondToBg, " + (Util$SmartcutsMacros.Result.stringify(ExtensionMessagingLogging.FromExtension.All.stringifyResponse, InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.stringify, sideEffect._1) + ")");
            case /* StreamCommandToBgForHighlightedElement */ 5:
                return "StreamCommandToBgForHighlightedElement(element, callback=" + (HighlightElement__Shared$SmartcutsMacros.Callback.stringify(sideEffect._1) + ")");
            case /* RetrievePossibleCommandInfoAndMaybeStreamToBg */ 6:
                var match = sideEffect._2;
                return "RetrievePossibleCommandInfoAndMaybeStreamToBg(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._0) + (", RetrieveClipboardItemAsPasteInContentEditable(selection), {targetBoundingRect: " + (OptionUtils$SmartcutsMacros.stringify(Rect$SmartcutsMacros.stringify, match.targetBoundingRect) + (", timestamp: " + (match.timestamp.toString() + (", insertAfterOffset: " + (String(match.insertAfterOffset) + "})")))))));
        }
    }
}
function stringifyInputByDomElementRepresentation(inputByDomElement) {
    return StringUtils$SmartcutsMacros.join(", ", List.map(function(param) {
        return "[element]=" + (Virtualized__Input$SmartcutsMacros.stringify(param[1]) + "");
    }, Curry._1(Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputByDomElement.toList, inputByDomElement)));
}
function stringifyState$5(param) {
    return stringifyState$4(DOM__Event$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation, DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, param);
}
function stringifyEvent$5(param) {
    return stringifyEvent$4(DOM__Event$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation, DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, param);
}
function stringifySideEffect$5(param) {
    return stringifySideEffect$4(DOM__Event$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation, DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, param);
}
function prepareStateForSerialization$1(state) {
    return mapState$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, state);
}
function prepareEventForSerialization$1($$event) {
    return mapEvent$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, $$event);
}
function prepareSideEffectForSerialization$1(sideEffect) {
    return mapSideEffect$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, sideEffect);
}
function prepareFailureForSerialization(failure) {
    return mapFailure$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, failure);
}
function prepareExitReasonForSerialization(exitReason) {
    return mapExitReason$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, exitReason);
}
function stringifyInputByDomElementRepresentation$1(inputBySelector) {
    return StringUtils$SmartcutsMacros.join(", ", List.map(function(param) {
        return "[" + (Selector$SmartcutsMacros.stringify(undefined, false, param[0]) + ("]=" + (Virtualized__Input$SmartcutsMacros.stringify(param[1]) + "")));
    }, Curry._1(Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.toList, inputBySelector)));
}
var stringifyDomHtmlElement$1 = DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify;
var stringifyDomNode$1 = DOM__Node$SmartcutsMacros.ForSerialization.stringify;
function stringifyState$6(param) {
    return stringifyState$4(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$1, stringifyDomHtmlElement$1, stringifyDomNode$1, param);
}
function stringifyEvent$6(param) {
    return stringifyEvent$4(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$1, stringifyDomHtmlElement$1, stringifyDomNode$1, param);
}
function stringifySideEffect$6(param) {
    return stringifySideEffect$4(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$1, stringifyDomHtmlElement$1, stringifyDomNode$1, param);
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyFailure"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareFailureForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareExitReasonForSerialization"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
}, ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers, {
    Generic: {
        mapListener: mapListener$1,
        mapState: mapState$2,
        mapEvent: mapEvent$2,
        mapFailure: mapFailure$2,
        mapExitReason: mapExitReason$2,
        mapSideEffect: mapSideEffect$2,
        stringifyListener: stringifyListener$3,
        stringifyState: stringifyState$4,
        stringifyExitReason: stringifyExitReason$2,
        stringifyFailure: stringifyFailure$2,
        stringifyEvent: stringifyEvent$4,
        stringifySideEffect: stringifySideEffect$4
    },
    Regular: {
        stringifyState: stringifyState$5,
        stringifyEvent: stringifyEvent$5,
        stringifySideEffect: stringifySideEffect$5
    },
    ForSerialization: {
        stringifyState: stringifyState$6,
        stringifyEvent: stringifyEvent$6,
        stringifySideEffect: stringifySideEffect$6,
        prepareStateForSerialization: prepareStateForSerialization$1,
        prepareEventForSerialization: prepareEventForSerialization$1,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization$1,
        prepareFailureForSerialization: prepareFailureForSerialization,
        prepareExitReasonForSerialization: prepareExitReasonForSerialization
    }
});
function stringifyState$7(stringifyDomHtmlElement11, stringifyDomNode11, stringifyDomMutationRecord7, stringifyDomEvent, state) {
    if (typeof state === "number") {
        return "Init";
    }
    switch(state.TAG | 0){
        case /* EditingGoogleSheets */ 0:
            var match = state._0;
            var editingInCell = match.editingInCell;
            var cellLoc = editingInCell !== undefined ? editingInCell : "None";
            var arg = OptionUtils$SmartcutsMacros.map(match.pendingCommandKey, PendingCommandInfo$SmartcutsMacros.keyAsString);
            return "EditingGoogleSheets({ spreadsheetId: " + (match.spreadsheetId + (", sheets({len: " + (String(match.sheets.length) + ("}), editingInCell: " + (cellLoc + (", expectPaste=" + (OptionUtils$SmartcutsMacros.withDefault("None", match.expectPaste) + (", expectCellValue=" + (OptionUtils$SmartcutsMacros.withDefault("None", match.expectCellValue) + (", pendingCommandKey=" + (function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            }("None") + (", numPendingRequests: " + (String(match.numPendingRequests) + (", sheetUpdateTriggerCount=" + (String(match.sheetUpdateTriggerCount) + (", mostRecentTriggerThatReceivedSheetUpdate=" + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(match.mostRecentTriggerThatReceivedSheetUpdate, function(prim) {
                return String(prim);
            })) + (", removeListenersPreventingUserInteraction=" + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(match.removeListenersPreventingUserInteraction, function(param) {
                return "fn";
            })) + (", googleAuthCallback=" + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(match.googleAuthCallback, function(param) {
                return "fn";
            })) + (", disconnectMutationObserver=" + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(match.disconnectMutationObserver, function(param) {
                return "fn";
            })) + ")")))))))))))))))))))))));
        case /* AwaitingPendingRequestsToFinishAndExit */ 1:
            var match$1 = state._0;
            var editingInCell$1 = match$1.editingInCell;
            var cellLoc$1 = editingInCell$1 !== undefined ? editingInCell$1 : "None";
            return "AwaitingPendingRequestsToFinishAndExit({ spreadsheetId: " + (match$1.spreadsheetId + (", editingInCell: " + (cellLoc$1 + (", numPendingRequests: " + (String(match$1.numPendingRequests) + (", allExitReasons=" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
                return stringifyExitReason$3(stringifyDomHtmlElement11, stringifyDomNode11, stringifyDomMutationRecord7, stringifyDomEvent, param);
            }, state._1) + ")")))))));
        case /* Exiting */ 2:
            return "Exiting({allExitReasons: " + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
                return stringifyExitReason$3(stringifyDomHtmlElement11, stringifyDomNode11, stringifyDomMutationRecord7, stringifyDomEvent, param);
            }, state._0.allExitReasons) + "})");
        case /* Exited */ 3:
            return "Exited(" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
                return stringifyExitReason$3(stringifyDomHtmlElement11, stringifyDomNode11, stringifyDomMutationRecord7, stringifyDomEvent, param);
            }, state._0) + ")");
    }
}
function stringifyEvent$7(stringifyDomHtmlElement12, stringifyDomNode12, stringifyDomMutationRecord8, stringifyDomEvent, $$event) {
    if (typeof $$event === "number") {
        if ($$event === /* Initialize */ 0) {
            return "Initialize";
        } else {
            return "DiscoveredGapiNotLoaded";
        }
    }
    switch($$event.TAG | 0){
        case /* SharedEvent */ 0:
            return "SharedEvent(" + (ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.stringifyEvent(stringifyDomHtmlElement12, stringifyDomEvent, $$event._0) + ")");
        case /* BasicEventOnGoogleSheets */ 1:
            return "BasicEventOnGoogleSheets(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
        case /* DidPreventUserInteraction */ 2:
            return "DidPreventUserInteraction(removeListeners)";
        case /* DidAttachMutationObserver */ 3:
            return "DidAttachMutationObserver(disconnectMutatioObserver)";
        case /* MutationsObserved */ 4:
            return "MutationsObserved([" + ($$Array.map(stringifyDomMutationRecord8, $$event._0).join(", ") + "])");
        case /* DidStartListeningToCanvas */ 5:
            return "DidStartListeningToCanvas(stopListening)";
        case /* CanvasDidFillText */ 6:
            return "CanvasDidFillText(text, x, y, canvas)";
        case /* DiscoveredGoogleAuthMissing */ 7:
            return "DiscoveredGoogleAuthMissing(" + (stringifyGoogleAuthCallback(stringifyDomEvent, $$event._0) + ")");
        case /* DidGetNewAuthToken */ 8:
            return "DidGetNewAuthToken(authToken)";
        case /* DidFetchGoogleSheet */ 9:
            return "DidFetchGoogleSheet(sheets)";
        case /* GoogleSheetUpdate */ 10:
            return "GoogleSheetUpdate(sheets, " + (stringifyReasonToCheckUpdate(stringifyDomEvent, $$event._1) + (", pendingCommandKey=" + (PendingCommandInfo$SmartcutsMacros.keyAsString($$event._2) + (", attemptCount=" + (String($$event._3) + (", triggerIndex=" + (String($$event._4) + ")")))))));
        case /* Fail */ 11:
            return "Fail(" + (stringifyFailure$3(stringifyDomHtmlElement12, stringifyDomNode12, stringifyDomMutationRecord8, stringifyDomEvent, $$event._0) + ")");
        case /* Exit */ 12:
            return "Exit(" + (stringifyExitReason$3(stringifyDomHtmlElement12, stringifyDomNode12, stringifyDomMutationRecord8, stringifyDomEvent, $$event._0) + ")");
    }
}
function stringifySideEffect$7(stringifyDomHtmlElement13, stringifyDomNode13, stringifyDomMutationRecord9, stringifyDomEvent, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* PreventUserInteraction */ 0:
                return "PreventUserInteraction";
            case /* StartGoogleAuthFlow */ 1:
                return "StartGoogleAuthFlow";
            case /* StartListeningToCanvas */ 2:
                return "StartListeningToCanvas";
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                return "Dispatch(" + (stringifyEvent$7(stringifyDomHtmlElement13, stringifyDomNode13, stringifyDomMutationRecord9, stringifyDomEvent, sideEffect._0) + ")");
            case /* AllowUserInteraction */ 1:
                return "AllowUserInteraction(removeListeners)";
            case /* FetchGoogleSheetData */ 2:
                return "FetchGoogleSheetData(spreadsheetId=" + (sideEffect._0 + (", authToken=" + ((sideEffect._1 !== undefined ? "<...>" : "undefined") + ")")));
            case /* SetupMutationObserver */ 3:
                return "SetupMutationObserver(" + (Curry._1(stringifyDomHtmlElement13, sideEffect._0) + ")");
            case /* NotifyBgAboutPossibleCommand */ 4:
                var maybeBoundingRect = sideEffect._1;
                return "NotifyBgAboutPossibleCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._0) + (", boundingRect=" + ((maybeBoundingRect !== undefined ? JSON.stringify(Rect$SmartcutsMacros.t_encode(maybeBoundingRect)) : "None") + ")")));
            case /* CheckForGoogleSheetUpdates */ 5:
                return "CheckForGoogleSheetUpdates(" + (sideEffect._0 + (", reason=" + (stringifyReasonToCheckUpdate(stringifyDomEvent, sideEffect._1) + (", authToken=" + ((sideEffect._2 !== undefined ? "<...>" : "undefined") + (", pendingCommandKey=" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._3) + (", attemptCount=" + (String(sideEffect._4) + (", triggerIndex=" + (String(sideEffect._5) + ")")))))))))));
            case /* StreamGoogleSheetsCommandsToBg */ 6:
                var match = sideEffect._2;
                var arg = OptionUtils$SmartcutsMacros.map(sideEffect._1.targetBoundingRect, Rect$SmartcutsMacros.stringify);
                return "StreamGoogleSheetsCommandsToBg(commands=[" + ($$String.concat(", ", List.map(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.stringify, sideEffect._0)) + ("], {" + (function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("None") + ("}, (" + (PendingCommandInfo$SmartcutsMacros.keyAsString(match[0]) + (", " + (String(match[1]) + "))")))))));
            case /* TellBgThatKeyDoesNotGenerateCommand */ 7:
                return "TellBgThatKeyDoesNotGenerateCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._0) + ")");
            case /* DisconnectMutationObserver */ 8:
                return "DisconnectMutationObserver(disconnect)";
            case /* StopListeningToCanvas */ 9:
                return "StopListeningToCanvas(stopListening)";
        }
    }
}
function stringifyGoogleAuthCallback(stringifyDomEvent, cb) {
    if (cb.TAG === /* Cb_FetchGoogleSheetData */ 0) {
        return "Cb_FetchGoogleSheetData(" + (cb._0 + ")");
    } else {
        return "Cb_CheckForGoogleSheetUpdates(" + (cb._0 + (", " + (stringifyReasonToCheckUpdate(stringifyDomEvent, cb._1) + (", pendingCommandKey=" + (PendingCommandInfo$SmartcutsMacros.keyAsString(cb._2) + (", attemptCount=" + (String(cb._3) + ")")))))));
    }
}
function stringifyReasonToCheckUpdate(stringifyDomEvent, reason) {
    if (typeof reason === "number") {
        return "EditingCellChanged";
    }
    switch(reason.TAG | 0){
        case /* PastedText */ 0:
            return "PastedText(" + (reason._0 + ")");
        case /* PasteEvent */ 1:
            return "PasteEvent(" + (Curry._1(stringifyDomEvent, reason._0) + ")");
        case /* ChangeEvent */ 2:
            return "ChangeEvent(" + (StringUtils$SmartcutsMacros.quote(reason._0) + ")");
    }
}
function stringifyListener$4(stringifyDomMutationRecord10, listener) {
    if (listener) {
        return "GoogleSheetsMutationObserverListener([" + ($$Array.map(stringifyDomMutationRecord10, listener._0).join(", ") + "])");
    } else {
        return "CanvasListener";
    }
}
function stringifyFailure$3(stringifyDomHtmlElement14, stringifyDomNode14, stringifyDomMutationRecord11, stringifyDomEvent, failure) {
    return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, function(param) {
        return stringifyState$7(stringifyDomHtmlElement14, stringifyDomNode14, stringifyDomMutationRecord11, stringifyDomEvent, param);
    }, function(param) {
        return stringifyEvent$7(stringifyDomHtmlElement14, stringifyDomNode14, stringifyDomMutationRecord11, stringifyDomEvent, param);
    }, function(param) {
        return stringifySideEffect$7(stringifyDomHtmlElement14, stringifyDomNode14, stringifyDomMutationRecord11, stringifyDomEvent, param);
    }, function(param) {
        return stringifyListener$4(stringifyDomMutationRecord11, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, failure);
}
function stringifyExitReason$3(stringifyDomHtmlElement15, stringifyDomNode15, stringifyDomMutationRecord12, stringifyDomEvent, exitReason) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, function(param) {
        return stringifyState$7(stringifyDomHtmlElement15, stringifyDomNode15, stringifyDomMutationRecord12, stringifyDomEvent, param);
    }, function(param) {
        return stringifyEvent$7(stringifyDomHtmlElement15, stringifyDomNode15, stringifyDomMutationRecord12, stringifyDomEvent, param);
    }, function(param) {
        return stringifySideEffect$7(stringifyDomHtmlElement15, stringifyDomNode15, stringifyDomMutationRecord12, stringifyDomEvent, param);
    }, function(param) {
        return stringifyListener$4(stringifyDomMutationRecord12, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}
function mapState$3(mapDomHtmlElement13, mapDomNode13, mapDomMutationRecord7, mapDomEvent20, state) {
    if (typeof state === "number") {
        return /* Init */ 0;
    }
    switch(state.TAG | 0){
        case /* EditingGoogleSheets */ 0:
            return {
                TAG: /* EditingGoogleSheets */ 0,
                _0: mapEditingState(mapDomEvent20, state._0)
            };
        case /* AwaitingPendingRequestsToFinishAndExit */ 1:
            return {
                TAG: /* AwaitingPendingRequestsToFinishAndExit */ 1,
                _0: mapEditingState(mapDomEvent20, state._0),
                _1: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                    return mapExitReason$3(mapDomHtmlElement13, mapDomNode13, mapDomMutationRecord7, mapDomEvent20, param);
                }, state._1)
            };
        case /* Exiting */ 2:
            return {
                TAG: /* Exiting */ 2,
                _0: {
                    allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                        return mapExitReason$3(mapDomHtmlElement13, mapDomNode13, mapDomMutationRecord7, mapDomEvent20, param);
                    }, state._0.allExitReasons)
                }
            };
        case /* Exited */ 3:
            return {
                TAG: /* Exited */ 3,
                _0: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                    return mapExitReason$3(mapDomHtmlElement13, mapDomNode13, mapDomMutationRecord7, mapDomEvent20, param);
                }, state._0)
            };
    }
}
function mapEvent$3(mapDomHtmlElement14, mapDomNode14, mapDomMutationRecord8, mapDomEvent21, $$event) {
    if (typeof $$event === "number") {
        if ($$event === /* Initialize */ 0) {
            return /* Initialize */ 0;
        } else {
            return /* DiscoveredGapiNotLoaded */ 1;
        }
    }
    switch($$event.TAG | 0){
        case /* SharedEvent */ 0:
            return {
                TAG: /* SharedEvent */ 0,
                _0: ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.mapEvent(mapDomHtmlElement14, mapDomEvent21, $$event._0)
            };
        case /* BasicEventOnGoogleSheets */ 1:
            return {
                TAG: /* BasicEventOnGoogleSheets */ 1,
                _0: $$event._0
            };
        case /* DidPreventUserInteraction */ 2:
            return {
                TAG: /* DidPreventUserInteraction */ 2,
                _0: $$event._0
            };
        case /* DidAttachMutationObserver */ 3:
            return {
                TAG: /* DidAttachMutationObserver */ 3,
                _0: $$event._0
            };
        case /* MutationsObserved */ 4:
            return {
                TAG: /* MutationsObserved */ 4,
                _0: $$Array.map(mapDomMutationRecord8, $$event._0)
            };
        case /* DidStartListeningToCanvas */ 5:
            return {
                TAG: /* DidStartListeningToCanvas */ 5,
                _0: $$event._0
            };
        case /* CanvasDidFillText */ 6:
            return {
                TAG: /* CanvasDidFillText */ 6,
                _0: $$event._0,
                _1: $$event._1,
                _2: $$event._2,
                _3: Curry._1(mapDomHtmlElement14, $$event._3)
            };
        case /* DiscoveredGoogleAuthMissing */ 7:
            return {
                TAG: /* DiscoveredGoogleAuthMissing */ 7,
                _0: mapGoogleAuthCallback(mapDomEvent21, $$event._0)
            };
        case /* DidGetNewAuthToken */ 8:
            return {
                TAG: /* DidGetNewAuthToken */ 8,
                _0: $$event._0
            };
        case /* DidFetchGoogleSheet */ 9:
            return {
                TAG: /* DidFetchGoogleSheet */ 9,
                _0: $$event._0
            };
        case /* GoogleSheetUpdate */ 10:
            return {
                TAG: /* GoogleSheetUpdate */ 10,
                _0: $$event._0,
                _1: mapReasonToCheckUpdate(mapDomEvent21, $$event._1),
                _2: $$event._2,
                _3: $$event._3,
                _4: $$event._4
            };
        case /* Fail */ 11:
            return {
                TAG: /* Fail */ 11,
                _0: mapFailure$3(mapDomHtmlElement14, mapDomNode14, mapDomMutationRecord8, mapDomEvent21, $$event._0)
            };
        case /* Exit */ 12:
            return {
                TAG: /* Exit */ 12,
                _0: mapExitReason$3(mapDomHtmlElement14, mapDomNode14, mapDomMutationRecord8, mapDomEvent21, $$event._0)
            };
    }
}
function mapSideEffect$3(mapDomHtmlElement15, mapDomNode15, mapDomMutationRecord9, mapDomEvent22, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* PreventUserInteraction */ 0:
                return /* PreventUserInteraction */ 0;
            case /* StartGoogleAuthFlow */ 1:
                return /* StartGoogleAuthFlow */ 1;
            case /* StartListeningToCanvas */ 2:
                return /* StartListeningToCanvas */ 2;
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                return {
                    TAG: /* Dispatch */ 0,
                    _0: mapEvent$3(mapDomHtmlElement15, mapDomNode15, mapDomMutationRecord9, mapDomEvent22, sideEffect._0)
                };
            case /* AllowUserInteraction */ 1:
                return {
                    TAG: /* AllowUserInteraction */ 1,
                    _0: sideEffect._0
                };
            case /* FetchGoogleSheetData */ 2:
                return {
                    TAG: /* FetchGoogleSheetData */ 2,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* SetupMutationObserver */ 3:
                return {
                    TAG: /* SetupMutationObserver */ 3,
                    _0: Curry._1(mapDomHtmlElement15, sideEffect._0)
                };
            case /* NotifyBgAboutPossibleCommand */ 4:
                return {
                    TAG: /* NotifyBgAboutPossibleCommand */ 4,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* CheckForGoogleSheetUpdates */ 5:
                return {
                    TAG: /* CheckForGoogleSheetUpdates */ 5,
                    _0: sideEffect._0,
                    _1: mapReasonToCheckUpdate(mapDomEvent22, sideEffect._1),
                    _2: sideEffect._2,
                    _3: sideEffect._3,
                    _4: sideEffect._4,
                    _5: sideEffect._5
                };
            case /* StreamGoogleSheetsCommandsToBg */ 6:
                return {
                    TAG: /* StreamGoogleSheetsCommandsToBg */ 6,
                    _0: sideEffect._0,
                    _1: sideEffect._1,
                    _2: sideEffect._2
                };
            case /* TellBgThatKeyDoesNotGenerateCommand */ 7:
                return {
                    TAG: /* TellBgThatKeyDoesNotGenerateCommand */ 7,
                    _0: sideEffect._0
                };
            case /* DisconnectMutationObserver */ 8:
                return {
                    TAG: /* DisconnectMutationObserver */ 8,
                    _0: sideEffect._0
                };
            case /* StopListeningToCanvas */ 9:
                return {
                    TAG: /* StopListeningToCanvas */ 9,
                    _0: sideEffect._0
                };
        }
    }
}
function mapEditingState(mapDomEvent23, editingState) {
    return {
        spreadsheetId: editingState.spreadsheetId,
        sheets: editingState.sheets,
        editingInCell: editingState.editingInCell,
        numPendingRequests: editingState.numPendingRequests,
        disconnectMutationObserver: editingState.disconnectMutationObserver,
        stopListeningToCanvas: editingState.stopListeningToCanvas,
        expectPaste: editingState.expectPaste,
        googleAuthCallback: OptionUtils$SmartcutsMacros.map(editingState.googleAuthCallback, function(param) {
            return mapGoogleAuthCallback(mapDomEvent23, param);
        }),
        removeListenersPreventingUserInteraction: editingState.removeListenersPreventingUserInteraction,
        sheetUpdateTriggerCount: editingState.sheetUpdateTriggerCount,
        mostRecentTriggerThatReceivedSheetUpdate: editingState.mostRecentTriggerThatReceivedSheetUpdate,
        rectForCommandKey: editingState.rectForCommandKey,
        expectCellValue: editingState.expectCellValue,
        pendingCommandKey: editingState.pendingCommandKey
    };
}
function mapGoogleAuthCallback(mapDomEvent24, cb) {
    if (cb.TAG === /* Cb_FetchGoogleSheetData */ 0) {
        return {
            TAG: /* Cb_FetchGoogleSheetData */ 0,
            _0: cb._0
        };
    } else {
        return {
            TAG: /* Cb_CheckForGoogleSheetUpdates */ 1,
            _0: cb._0,
            _1: mapReasonToCheckUpdate(mapDomEvent24, cb._1),
            _2: cb._2,
            _3: cb._3
        };
    }
}
function mapReasonToCheckUpdate(mapDomEvent25, reason) {
    if (typeof reason === "number") {
        return /* EditingCellChanged */ 0;
    }
    switch(reason.TAG | 0){
        case /* PastedText */ 0:
            return {
                TAG: /* PastedText */ 0,
                _0: reason._0
            };
        case /* PasteEvent */ 1:
            return {
                TAG: /* PasteEvent */ 1,
                _0: Curry._1(mapDomEvent25, reason._0)
            };
        case /* ChangeEvent */ 2:
            return {
                TAG: /* ChangeEvent */ 2,
                _0: reason._0
            };
    }
}
function mapListener$2(mapDomMutationRecord10, listener) {
    if (listener) {
        return /* GoogleSheetsMutationObserverListener */ {
            _0: $$Array.map(mapDomMutationRecord10, listener._0)
        };
    } else {
        return /* CanvasListener */ 0;
    }
}
function mapFailure$3(mapDomHtmlElement16, mapDomNode16, mapDomMutationRecord11, mapDomEvent26, failure) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, function(param) {
        return mapState$3(mapDomHtmlElement16, mapDomNode16, mapDomMutationRecord11, mapDomEvent26, param);
    }, function(param) {
        return mapEvent$3(mapDomHtmlElement16, mapDomNode16, mapDomMutationRecord11, mapDomEvent26, param);
    }, function(param) {
        return mapSideEffect$3(mapDomHtmlElement16, mapDomNode16, mapDomMutationRecord11, mapDomEvent26, param);
    }, function(param) {
        return mapListener$2(mapDomMutationRecord11, param);
    }, failure);
}
function mapExitReason$3(mapDomHtmlElement17, mapDomNode17, mapDomMutationRecord12, mapDomEvent27, exitReason) {
    return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, function(param) {
        return mapState$3(mapDomHtmlElement17, mapDomNode17, mapDomMutationRecord12, mapDomEvent27, param);
    }, function(param) {
        return mapEvent$3(mapDomHtmlElement17, mapDomNode17, mapDomMutationRecord12, mapDomEvent27, param);
    }, function(param) {
        return mapSideEffect$3(mapDomHtmlElement17, mapDomNode17, mapDomMutationRecord12, mapDomEvent27, param);
    }, function(param) {
        return mapListener$2(mapDomMutationRecord12, param);
    }, exitReason);
}
var stringifyDomMutationRecord$2 = DOM$SmartcutsMacros.$$MutationRecord.stringify;
function stringifyState$8(param) {
    return stringifyState$7(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$2, DOM__Event$SmartcutsMacros.stringify, param);
}
function stringifyEvent$8(param) {
    return stringifyEvent$7(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$2, DOM__Event$SmartcutsMacros.stringify, param);
}
function stringifySideEffect$8(param) {
    return stringifySideEffect$7(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$2, DOM__Event$SmartcutsMacros.stringify, param);
}
var stringifyDomHtmlElement$2 = DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify;
var stringifyDomNode$2 = DOM__Node$SmartcutsMacros.ForSerialization.stringify;
var stringifyDomMutationRecord$3 = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify;
function stringifyState$9(param) {
    return stringifyState$7(stringifyDomHtmlElement$2, stringifyDomNode$2, stringifyDomMutationRecord$3, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}
function stringifyEvent$9(param) {
    return stringifyEvent$7(stringifyDomHtmlElement$2, stringifyDomNode$2, stringifyDomMutationRecord$3, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}
function stringifySideEffect$9(param) {
    return stringifySideEffect$7(stringifyDomHtmlElement$2, stringifyDomNode$2, stringifyDomMutationRecord$3, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}
var mapDomHtmlElement$1 = DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement;
var mapDomNode$1 = DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode;
var mapDomMutationRecord$1 = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord;
var mapDomEvent$1 = DOM__Event__ForSerialization$SmartcutsMacros.make;
function prepareStateForSerialization$2(state) {
    return mapState$3(mapDomHtmlElement$1, mapDomNode$1, mapDomMutationRecord$1, mapDomEvent$1, state);
}
function prepareEventForSerialization$2($$event) {
    return mapEvent$3(mapDomHtmlElement$1, mapDomNode$1, mapDomMutationRecord$1, mapDomEvent$1, $$event);
}
function prepareSideEffectForSerialization$2(sideEffect) {
    return mapSideEffect$3(mapDomHtmlElement$1, mapDomNode$1, mapDomMutationRecord$1, mapDomEvent$1, sideEffect);
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyFailure"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapExitReason"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
}, ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers, {
    Generic: {
        stringifyState: stringifyState$7,
        stringifyEvent: stringifyEvent$7,
        stringifyListener: stringifyListener$4,
        stringifySideEffect: stringifySideEffect$7,
        stringifyFailure: stringifyFailure$3,
        stringifyExitReason: stringifyExitReason$3,
        mapState: mapState$3,
        mapEvent: mapEvent$3,
        mapSideEffect: mapSideEffect$3,
        mapListener: mapListener$2,
        mapFailure: mapFailure$3,
        mapExitReason: mapExitReason$3
    },
    Regular: {
        stringifyState: stringifyState$8,
        stringifyEvent: stringifyEvent$8,
        stringifySideEffect: stringifySideEffect$8
    },
    ForSerialization: {
        stringifyState: stringifyState$9,
        stringifyEvent: stringifyEvent$9,
        stringifySideEffect: stringifySideEffect$9,
        prepareStateForSerialization: prepareStateForSerialization$2,
        prepareEventForSerialization: prepareEventForSerialization$2,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization$2
    }
});
function stringifyParallelState(stringifyDomEvent, stringifyDomHtmlElement16, stringifyInputByDomElementRepresentation6, stringifyDomNode16, stringifyDomMutationRecord13, param) {
    return "{eventStreaming: " + (Curry._5(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.stringifyState, stringifyDomEvent, stringifyInputByDomElementRepresentation6, stringifyDomHtmlElement16, stringifyDomNode16, param.eventStreaming) + (", contentEditing: " + (Curry._5(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.stringifyState, stringifyDomHtmlElement16, stringifyDomNode16, stringifyDomMutationRecord13, stringifyDomEvent, param.contentEditing) + (", googleSheets: " + (Curry._5(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.stringifyState, stringifyDomHtmlElement16, stringifyDomNode16, stringifyDomMutationRecord13, stringifyDomEvent, param.googleSheets) + "}")))));
}
function stringifyListener$5(stringifyDomEvent, stringifyDomMutationRecord14, listener) {
    if (typeof listener === "number") {
        return "NoListener";
    }
    switch(listener.TAG | 0){
        case /* EventStreamingListener */ 0:
            return "EventStreamingListener(" + (Curry._2(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.stringifyListener, stringifyDomEvent, listener._0) + ")");
        case /* ContentEditingListener */ 1:
            return "ContentEditingListener(" + (Curry._2(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.stringifyListener, stringifyDomMutationRecord14, listener._0) + ")");
        case /* GoogleSheetsListener */ 2:
            return "GoogleSheetsListener(" + (Curry._2(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.stringifyListener, stringifyDomMutationRecord14, listener._0) + ")");
    }
}
function stringifyState$10(stringifyDomEvent, stringifyDomHtmlElement17, stringifyInputByDomElementRepresentation7, stringifyDomNode17, stringifyDomMutationRecord15, state) {
    switch(state.TAG | 0){
        case /* Init */ 0:
            return "Init(" + (stringifyParallelState(stringifyDomEvent, stringifyDomHtmlElement17, stringifyInputByDomElementRepresentation7, stringifyDomNode17, stringifyDomMutationRecord15, state._0) + ")");
        case /* Parallel */ 1:
            return "Parallel(" + (stringifyParallelState(stringifyDomEvent, stringifyDomHtmlElement17, stringifyInputByDomElementRepresentation7, stringifyDomNode17, stringifyDomMutationRecord15, state._0) + ")");
        case /* Exiting */ 2:
            var match = state._0;
            return "Exiting({parallelStates: " + (stringifyParallelState(stringifyDomEvent, stringifyDomHtmlElement17, stringifyInputByDomElementRepresentation7, stringifyDomNode17, stringifyDomMutationRecord15, match.parallelStates) + (", maybeChildrenExitingHelperState, , allExitReasons:" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, function(param) {
                return stringifyExitReason$4(stringifyDomEvent, stringifyDomHtmlElement17, stringifyInputByDomElementRepresentation7, stringifyDomNode17, stringifyDomMutationRecord15, param);
            }, match.allExitReasons) + "})")));
    }
}
function stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement18, stringifyInputByDomElementRepresentation8, stringifyDomNode18, stringifyDomMutationRecord16, $$event) {
    switch($$event.TAG | 0){
        case /* Initialize */ 0:
            if ($$event._0 !== undefined) {
                return "Initialize(respondToBg, rejectToBg)";
            } else {
                return "Initialize(None)";
            }
        case /* SharedEvent */ 1:
            return "Shared(" + (ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.stringifyEvent(stringifyDomHtmlElement18, stringifyDomEvent, $$event._0) + ")");
        case /* BasicEventWhileRecording */ 2:
            return "BasicEventWhileRecording(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
        case /* EventStreamingEvent */ 3:
            return "EventStreamingEvent(" + (Curry._5(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.stringifyEvent, stringifyDomEvent, stringifyInputByDomElementRepresentation8, stringifyDomHtmlElement18, stringifyDomNode18, $$event._0) + ")");
        case /* ContentEditingEvent */ 4:
            return "ContentEditingEvent(" + (Curry._5(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.stringifyEvent, stringifyDomHtmlElement18, stringifyDomNode18, stringifyDomMutationRecord16, stringifyDomEvent, $$event._0) + ")");
        case /* GoogleSheetsEvent */ 5:
            return "GoogleSheetsEvent(" + (Curry._5(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.stringifyEvent, stringifyDomHtmlElement18, stringifyDomNode18, stringifyDomMutationRecord16, stringifyDomEvent, $$event._0) + ")");
        case /* Fail */ 6:
            return "Fail(" + (Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, function(param) {
                return stringifyState$10(stringifyDomEvent, stringifyDomHtmlElement18, stringifyInputByDomElementRepresentation8, stringifyDomNode18, stringifyDomMutationRecord16, param);
            }, function(param) {
                return stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement18, stringifyInputByDomElementRepresentation8, stringifyDomNode18, stringifyDomMutationRecord16, param);
            }, function(param) {
                return stringifySideEffect$10(stringifyDomEvent, stringifyDomHtmlElement18, stringifyInputByDomElementRepresentation8, stringifyDomNode18, stringifyDomMutationRecord16, param);
            }, function(param) {
                return stringifyListener$5(stringifyDomEvent, stringifyDomMutationRecord16, param);
            }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, $$event._0) + ")");
        case /* Exit */ 7:
            return "Exit(" + (Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, function(param) {
                return stringifyState$10(stringifyDomEvent, stringifyDomHtmlElement18, stringifyInputByDomElementRepresentation8, stringifyDomNode18, stringifyDomMutationRecord16, param);
            }, function(param) {
                return stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement18, stringifyInputByDomElementRepresentation8, stringifyDomNode18, stringifyDomMutationRecord16, param);
            }, function(param) {
                return stringifySideEffect$10(stringifyDomEvent, stringifyDomHtmlElement18, stringifyInputByDomElementRepresentation8, stringifyDomNode18, stringifyDomMutationRecord16, param);
            }, function(param) {
                return stringifyListener$5(stringifyDomEvent, stringifyDomMutationRecord16, param);
            }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, $$event._0) + ")");
    }
}
function stringifySideEffect$10(stringifyDomEvent, stringifyDomHtmlElement19, stringifyInputByDomElementRepresentation9, stringifyDomNode19, stringifyDomMutationRecord17, sideEffect) {
    switch(sideEffect.TAG | 0){
        case /* Dispatch */ 0:
            return "Dispatch(" + (stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement19, stringifyInputByDomElementRepresentation9, stringifyDomNode19, stringifyDomMutationRecord17, sideEffect._0) + ")");
        case /* EventStreamingSideEffect */ 1:
            return "EventStreamingSideEffect(" + (SideEffectGroup$SmartcutsMacros.List.stringify(Curry._4(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.stringifySideEffect, stringifyDomEvent, stringifyInputByDomElementRepresentation9, stringifyDomHtmlElement19, stringifyDomNode19), sideEffect._0) + ")");
        case /* ContentEditingSideEffect */ 2:
            return "ContentEditingSideEffect" + (SideEffectGroup$SmartcutsMacros.List.stringify(Curry._4(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.stringifySideEffect, stringifyDomHtmlElement19, stringifyDomNode19, stringifyDomMutationRecord17, stringifyDomEvent), sideEffect._0) + ")");
        case /* GoogleSheetsSideEffect */ 3:
            return "GoogleSheetsSideEffect" + (SideEffectGroup$SmartcutsMacros.List.stringify(Curry._4(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.stringifySideEffect, stringifyDomHtmlElement19, stringifyDomNode19, stringifyDomMutationRecord17, stringifyDomEvent), sideEffect._0) + ")");
        case /* RespondToBg */ 4:
            return "RespondToBg(respondToBg, " + (Util$SmartcutsMacros.Result.stringify(ExtensionMessagingLogging.FromExtension.All.stringifyResponse, InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.stringify, sideEffect._1) + ")");
    }
}
function stringifyExitReason$4(stringifyDomEvent, stringifyDomHtmlElement20, stringifyInputByDomElementRepresentation10, stringifyDomNode20, stringifyDomMutationRecord18, exitReason) {
    return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, function(param) {
        return stringifyState$10(stringifyDomEvent, stringifyDomHtmlElement20, stringifyInputByDomElementRepresentation10, stringifyDomNode20, stringifyDomMutationRecord18, param);
    }, function(param) {
        return stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement20, stringifyInputByDomElementRepresentation10, stringifyDomNode20, stringifyDomMutationRecord18, param);
    }, function(param) {
        return stringifySideEffect$10(stringifyDomEvent, stringifyDomHtmlElement20, stringifyInputByDomElementRepresentation10, stringifyDomNode20, stringifyDomMutationRecord18, param);
    }, function(param) {
        return stringifyListener$5(stringifyDomEvent, stringifyDomMutationRecord18, param);
    }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}
function mapParallelState(mapDomEvent28, mapDomHtmlElement18, mapInputByDomElementRepresentation, mapDomNode18, mapDomMutationRecord13, param) {
    return {
        eventStreaming: Curry._5(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.mapState, mapDomEvent28, mapInputByDomElementRepresentation, mapDomHtmlElement18, mapDomNode18, param.eventStreaming),
        contentEditing: Curry._5(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.mapState, mapDomHtmlElement18, mapDomNode18, mapDomMutationRecord13, mapDomEvent28, param.contentEditing),
        googleSheets: Curry._5(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.mapState, mapDomHtmlElement18, mapDomNode18, mapDomMutationRecord13, mapDomEvent28, param.googleSheets)
    };
}
function mapListener$3(mapDomEvent29, mapDomMutationRecord14, listener) {
    if (typeof listener === "number") {
        return /* NoListener */ 0;
    }
    switch(listener.TAG | 0){
        case /* EventStreamingListener */ 0:
            return {
                TAG: /* EventStreamingListener */ 0,
                _0: Curry._2(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.mapListener, mapDomEvent29, listener._0)
            };
        case /* ContentEditingListener */ 1:
            return {
                TAG: /* ContentEditingListener */ 1,
                _0: Curry._2(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.mapListener, mapDomMutationRecord14, listener._0)
            };
        case /* GoogleSheetsListener */ 2:
            return {
                TAG: /* GoogleSheetsListener */ 2,
                _0: Curry._2(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.mapListener, mapDomMutationRecord14, listener._0)
            };
    }
}
function mapState$4(mapDomEvent30, mapDomHtmlElement19, mapInputByDomElementRepresentation, mapDomNode19, mapDomMutationRecord15, state) {
    switch(state.TAG | 0){
        case /* Init */ 0:
            return {
                TAG: /* Init */ 0,
                _0: mapParallelState(mapDomEvent30, mapDomHtmlElement19, mapInputByDomElementRepresentation, mapDomNode19, mapDomMutationRecord15, state._0)
            };
        case /* Parallel */ 1:
            return {
                TAG: /* Parallel */ 1,
                _0: mapParallelState(mapDomEvent30, mapDomHtmlElement19, mapInputByDomElementRepresentation, mapDomNode19, mapDomMutationRecord15, state._0)
            };
        case /* Exiting */ 2:
            var match = state._0;
            return {
                TAG: /* Exiting */ 2,
                _0: {
                    parallelStates: mapParallelState(mapDomEvent30, mapDomHtmlElement19, mapInputByDomElementRepresentation, mapDomNode19, mapDomMutationRecord15, match.parallelStates),
                    maybeRespondToBgWithResult: match.maybeRespondToBgWithResult,
                    allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, function(param) {
                        return mapExitReason$4(mapDomEvent30, mapDomHtmlElement19, mapInputByDomElementRepresentation, mapDomNode19, mapDomMutationRecord15, param);
                    }, match.allExitReasons)
                }
            };
    }
}
function mapEvent$4(mapDomEvent31, mapDomHtmlElement20, mapInputByDomElementRepresentation, mapDomNode20, mapDomMutationRecord16, $$event) {
    switch($$event.TAG | 0){
        case /* Initialize */ 0:
            return {
                TAG: /* Initialize */ 0,
                _0: $$event._0
            };
        case /* SharedEvent */ 1:
            return {
                TAG: /* SharedEvent */ 1,
                _0: ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.mapEvent(mapDomHtmlElement20, mapDomEvent31, $$event._0)
            };
        case /* BasicEventWhileRecording */ 2:
            return {
                TAG: /* BasicEventWhileRecording */ 2,
                _0: $$event._0
            };
        case /* EventStreamingEvent */ 3:
            return {
                TAG: /* EventStreamingEvent */ 3,
                _0: Curry._5(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.mapEvent, mapDomEvent31, mapInputByDomElementRepresentation, mapDomHtmlElement20, mapDomNode20, $$event._0)
            };
        case /* ContentEditingEvent */ 4:
            return {
                TAG: /* ContentEditingEvent */ 4,
                _0: Curry._5(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.mapEvent, mapDomHtmlElement20, mapDomNode20, mapDomMutationRecord16, mapDomEvent31, $$event._0)
            };
        case /* GoogleSheetsEvent */ 5:
            return {
                TAG: /* GoogleSheetsEvent */ 5,
                _0: Curry._5(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.mapEvent, mapDomHtmlElement20, mapDomNode20, mapDomMutationRecord16, mapDomEvent31, $$event._0)
            };
        case /* Fail */ 6:
            return {
                TAG: /* Fail */ 6,
                _0: mapFailure$4(mapDomEvent31, mapDomHtmlElement20, mapInputByDomElementRepresentation, mapDomNode20, mapDomMutationRecord16, $$event._0)
            };
        case /* Exit */ 7:
            return {
                TAG: /* Exit */ 7,
                _0: mapExitReason$4(mapDomEvent31, mapDomHtmlElement20, mapInputByDomElementRepresentation, mapDomNode20, mapDomMutationRecord16, $$event._0)
            };
    }
}
function mapFailure$4(mapDomEvent32, mapDomHtmlElement21, mapInputByDomElementRepresentation, mapDomNode21, mapDomMutationRecord17, failure) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, function(param) {
        return mapState$4(mapDomEvent32, mapDomHtmlElement21, mapInputByDomElementRepresentation, mapDomNode21, mapDomMutationRecord17, param);
    }, function(param) {
        return mapEvent$4(mapDomEvent32, mapDomHtmlElement21, mapInputByDomElementRepresentation, mapDomNode21, mapDomMutationRecord17, param);
    }, function(param) {
        return mapSideEffect$4(mapDomEvent32, mapDomHtmlElement21, mapInputByDomElementRepresentation, mapDomNode21, mapDomMutationRecord17, param);
    }, function(param) {
        return mapListener$3(mapDomEvent32, mapDomMutationRecord17, param);
    }, failure);
}
function mapExitReason$4(mapDomEvent33, mapDomHtmlElement22, mapInputByDomElementRepresentation, mapDomNode22, mapDomMutationRecord18, exitReason) {
    return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, function(param) {
        return mapState$4(mapDomEvent33, mapDomHtmlElement22, mapInputByDomElementRepresentation, mapDomNode22, mapDomMutationRecord18, param);
    }, function(param) {
        return mapEvent$4(mapDomEvent33, mapDomHtmlElement22, mapInputByDomElementRepresentation, mapDomNode22, mapDomMutationRecord18, param);
    }, function(param) {
        return mapSideEffect$4(mapDomEvent33, mapDomHtmlElement22, mapInputByDomElementRepresentation, mapDomNode22, mapDomMutationRecord18, param);
    }, function(param) {
        return mapListener$3(mapDomEvent33, mapDomMutationRecord18, param);
    }, exitReason);
}
function mapSideEffect$4(mapDomEvent34, mapDomHtmlElement23, mapInputByDomElementRepresentation, mapDomNode23, mapDomMutationRecord19, sideEffect) {
    switch(sideEffect.TAG | 0){
        case /* Dispatch */ 0:
            return {
                TAG: /* Dispatch */ 0,
                _0: mapEvent$4(mapDomEvent34, mapDomHtmlElement23, mapInputByDomElementRepresentation, mapDomNode23, mapDomMutationRecord19, sideEffect._0)
            };
        case /* EventStreamingSideEffect */ 1:
            return {
                TAG: /* EventStreamingSideEffect */ 1,
                _0: SideEffectGroup$SmartcutsMacros.List.map(Curry._4(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.mapSideEffect, mapDomEvent34, mapInputByDomElementRepresentation, mapDomHtmlElement23, mapDomNode23), sideEffect._0)
            };
        case /* ContentEditingSideEffect */ 2:
            return {
                TAG: /* ContentEditingSideEffect */ 2,
                _0: SideEffectGroup$SmartcutsMacros.List.map(Curry._4(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.mapSideEffect, mapDomHtmlElement23, mapDomNode23, mapDomMutationRecord19, mapDomEvent34), sideEffect._0)
            };
        case /* GoogleSheetsSideEffect */ 3:
            return {
                TAG: /* GoogleSheetsSideEffect */ 3,
                _0: SideEffectGroup$SmartcutsMacros.List.map(Curry._4(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.mapSideEffect, mapDomHtmlElement23, mapDomNode23, mapDomMutationRecord19, mapDomEvent34), sideEffect._0)
            };
        case /* RespondToBg */ 4:
            return {
                TAG: /* RespondToBg */ 4,
                _0: sideEffect._0,
                _1: sideEffect._1
            };
    }
}
function stringifyInputByDomElementRepresentation$2(inputByDomElement) {
    return StringUtils$SmartcutsMacros.join(", ", List.map(function(param) {
        return "[element]=" + (Virtualized__Input$SmartcutsMacros.stringify(param[1]) + "");
    }, Curry._1(Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputByDomElement.toList, inputByDomElement)));
}
var stringifyDomMutationRecord$4 = DOM$SmartcutsMacros.$$MutationRecord.stringify;
function stringifyState$11(param) {
    return stringifyState$10(DOM__Event$SmartcutsMacros.stringify, DOM__HtmlElement$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$2, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$4, param);
}
function stringifyEvent$11(param) {
    return stringifyEvent$10(DOM__Event$SmartcutsMacros.stringify, DOM__HtmlElement$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$2, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$4, param);
}
function stringifySideEffect$11(param) {
    return stringifySideEffect$10(DOM__Event$SmartcutsMacros.stringify, DOM__HtmlElement$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$2, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$4, param);
}
function stringifyExitReason$5(param) {
    return stringifyExitReason$4(DOM__Event$SmartcutsMacros.stringify, DOM__HtmlElement$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$2, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$4, param);
}
function prepareStateForSerialization$3(state) {
    return mapState$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, state);
}
function prepareEventForSerialization$3($$event) {
    return mapEvent$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, $$event);
}
function prepareSideEffectForSerialization$3(sideEffect) {
    return mapSideEffect$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, sideEffect);
}
function prepareExitReasonForSerialization$1(exitReason) {
    return mapExitReason$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, exitReason);
}
var stringifyDomHtmlElement$3 = DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify;
function stringifyInputByDomElementRepresentation$3(inputBySelector) {
    return StringUtils$SmartcutsMacros.join(", ", List.map(function(param) {
        return "[" + (Selector$SmartcutsMacros.stringify(undefined, false, param[0]) + ("]=" + (Virtualized__Input$SmartcutsMacros.stringify(param[1]) + "")));
    }, Curry._1(Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.toList, inputBySelector)));
}
var stringifyDomNode$3 = DOM__Node$SmartcutsMacros.ForSerialization.stringify;
var stringifyDomMutationRecord$5 = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify;
function stringifyState$12(param) {
    return stringifyState$10(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyDomHtmlElement$3, stringifyInputByDomElementRepresentation$3, stringifyDomNode$3, stringifyDomMutationRecord$5, param);
}
function stringifyEvent$12(param) {
    return stringifyEvent$10(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyDomHtmlElement$3, stringifyInputByDomElementRepresentation$3, stringifyDomNode$3, stringifyDomMutationRecord$5, param);
}
function stringifySideEffect$12(param) {
    return stringifySideEffect$10(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyDomHtmlElement$3, stringifyInputByDomElementRepresentation$3, stringifyDomNode$3, stringifyDomMutationRecord$5, param);
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyParallelState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapExitReason"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyExitReason"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareExitReasonForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
}, ContentScript__StateMachine__RecordingMode__Types__Helpers, {
    Generic: {
        stringifyParallelState: stringifyParallelState,
        stringifyState: stringifyState$10,
        stringifyListener: stringifyListener$5,
        stringifyEvent: stringifyEvent$10,
        stringifySideEffect: stringifySideEffect$10,
        stringifyExitReason: stringifyExitReason$4,
        mapState: mapState$4,
        mapListener: mapListener$3,
        mapEvent: mapEvent$4,
        mapFailure: mapFailure$4,
        mapExitReason: mapExitReason$4,
        mapSideEffect: mapSideEffect$4
    },
    Regular: {
        stringifyState: stringifyState$11,
        stringifyEvent: stringifyEvent$11,
        stringifySideEffect: stringifySideEffect$11,
        stringifyExitReason: stringifyExitReason$5
    },
    ForSerialization: {
        prepareStateForSerialization: prepareStateForSerialization$3,
        prepareEventForSerialization: prepareEventForSerialization$3,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization$3,
        prepareExitReasonForSerialization: prepareExitReasonForSerialization$1,
        stringifyState: stringifyState$12,
        stringifyEvent: stringifyEvent$12,
        stringifySideEffect: stringifySideEffect$12
    }
});
function stringifyEvent$13($$event) {
    if ($$event.TAG === /* MessageFromExtension */ 0) {
        return "MessageFromExtension(" + (Curry._1(ExtensionMessagingLogging.FromExtension.All.stringifyMessage, $$event._0) + ", respondToBg, rejectToBg)");
    } else {
        return "DidGetNewAuthToken(" + ($$event._0 + ")");
    }
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "stringifyEvent"
        ]
    ]
}, ContentScript__StateMachine__Shared__Types__Helpers, {
    stringifyEvent: stringifyEvent$13
});
function stringifyState$13(stringifyHtmlElement, stringifyDomEvent, stringifyRecordingState, state) {
    if (typeof state === "number") {
        if (state === /* Init */ 0) {
            return "Init";
        } else {
            return "ExtensionContextInvalidated";
        }
    }
    switch(state.TAG | 0){
        case /* WaitingForBgToAckContentScriptReady */ 0:
            return "WaitingForBgToAckContentScriptReady(contentScriptIdle)";
        case /* ContentScriptIdle */ 1:
            var arg = OptionUtils$SmartcutsMacros.map(state._0.disconnectLinkTriggerListener, function(param) {
                return "Some";
            });
            return "ContentScriptIdle({disconnectLinkTriggerListener: " + (function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            }("None") + "})");
        case /* RecordingMode */ 2:
            return "RecordingMode(" + (Curry._1(stringifyRecordingState, state._0) + ")");
        case /* PlaybackMode */ 3:
            return "PlaybackMode(" + (Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.stringifyState, stringifyHtmlElement, stringifyDomEvent, state._0) + ")");
        case /* UrlTriggeringMode */ 4:
            return "UrlTriggeringMode(" + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifyState(stringifyHtmlElement, stringifyDomEvent, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, state._0) + ")");
        case /* DataExtractionMode */ 5:
            return "DataExtractionMode(" + (ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.stringifyState(stringifyHtmlElement, state._0) + ")");
    }
}
function stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord19, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, errorContext) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.stringify, function(param) {
        return stringifyState$13(stringifyHtmlElement, stringifyDomEvent, stringifyRecordingState, param);
    }, function(param) {
        return stringifyEvent$14(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord19, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, param);
    }, function(param) {
        return stringifySideEffect$13(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord19, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, param);
    }, function(param) {
        return stringifyListener$6(stringifyDomEvent, stringifyDomMutationRecord19, param);
    }, errorContext);
}
function stringifyEvent$14(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord20, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, $$event) {
    if (typeof $$event === "number") {
        return "Initialize";
    }
    switch($$event.TAG | 0){
        case /* BasicEventRootLevel */ 0:
            return "BasicEventRootLevel(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
        case /* BgDidAckContentScriptReady */ 1:
            return "BgDidAckContentScriptReady(" + (Util$SmartcutsMacros.Result.stringify(ExtensionMessagingLogging.FromTab.ContentScriptReady.stringifyResponse, function(str) {
                return str;
            }, $$event._0) + ")");
        case /* DidRespondToBgWithContentScriptFailureId */ 2:
            return "DidRespondToBgWithContentScriptFailureId(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify($$event._0) + (", failWith=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, $$event._1) + (", errorContext=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord20, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, $$event._2) + ")")))));
        case /* DidSetupLinkTriggerListener */ 3:
            return "DidSetupLinkTriggerListener(teardownListener)";
        case /* RecordingModeEvent */ 4:
            return "RecordingModeEvent(" + (Curry._1(stringifyRecordingEvent, $$event._0) + ")");
        case /* PlaybackModeEvent */ 5:
            return "PlaybackModeEvent(" + (Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.stringifyEvent, stringifyHtmlElement, stringifyDomEvent, $$event._0) + ")");
        case /* UrlTriggeringModeEvent */ 6:
            return "UrlTriggeringModeEvent(" + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifyEvent(stringifyHtmlElement, stringifyDomEvent, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
        case /* DataExtractionModeEvent */ 7:
            return "DataExtractionModeEvent(" + (ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.stringifyEvent(stringifyHtmlElement, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, stringifyDomEvent, $$event._0) + ")");
        case /* Fail */ 8:
            return "Fail(" + (Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, function(param) {
                return stringifyState$13(stringifyHtmlElement, stringifyDomEvent, stringifyRecordingState, param);
            }, function(param) {
                return stringifyEvent$14(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord20, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, param);
            }, function(param) {
                return stringifySideEffect$13(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord20, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, param);
            }, function(param) {
                return stringifyListener$6(stringifyDomEvent, stringifyDomMutationRecord20, param);
            }, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, $$event._0) + ")");
        case /* ContextMenuEventDidFireOnElement */ 9:
            return "ContextMenuEventDidFireOnElement(htmlElement)";
    }
}
function stringifySideEffect$13(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord21, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* ResetStateMachineHistory */ 0:
                return "ResetStateMachineHistory";
            case /* NotifyBgThatContentScriptReady */ 1:
                return "NotifyBgThatContentScriptReady";
            case /* SetupLinkTriggerListener */ 2:
                return "SetupLinkTriggerListener";
            case /* RemoveRenderedContent */ 3:
                return "RemoveRenderedContent";
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                return "Dispatch(" + (stringifyEvent$14(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord21, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._0) + ")");
            case /* NotifyBgOfContentScriptFailure */ 1:
                return "NotifyBgOfContentScriptFailure(failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, sideEffect._0) + (", context=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord21, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._1) + ")")));
            case /* NotifyBgOfContentScriptResponseFailure */ 2:
                return "NotifyBgOfContentScriptResponseFailure(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify(sideEffect._0) + ("failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, sideEffect._1) + (", context=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord21, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._2) + ")")))));
            case /* TeardownLinkTriggerListener */ 3:
                return "TeardownLinkTriggerListener(fn)";
            case /* RecordingModeSideEffect */ 4:
                return "RecordingModeSideEffect(" + (Curry._1(stringifyRecordingSideEffect, sideEffect._0) + ")");
            case /* PlaybackModeSideEffect */ 5:
                return "PlaybackModeSideEffect(" + (Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.stringifySideEffect, stringifyHtmlElement, stringifyDomEvent, sideEffect._0) + ")");
            case /* UrlTriggeringModeSideEffect */ 6:
                return "UrlTriggeringModeSideEffect(" + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, sideEffect._0) + ")");
            case /* DataExtractionModeSideEffect */ 7:
                return "DataExtractionModeSideEffect(" + (ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.stringifySideEffect(stringifyHtmlElement, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, stringifyDomEvent, sideEffect._0) + ")");
            case /* WindowAlert */ 8:
                return "WindowAlert(" + (StringUtils$SmartcutsMacros.quote(sideEffect._0) + ")");
            case /* ConsoleJsPromiseError */ 9:
                return "ConsoleJsPromiseError(error, errorContext=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord21, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._1) + ")");
            case /* ConsoleJsExn */ 10:
                return "ConsoleJsExn(error, errorContext=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord21, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._1) + ")");
            case /* RespondToBg */ 11:
                return "RespondToBg(respondToBg, " + (Curry._1(ExtensionMessagingLogging.FromExtension.All.stringifyResponse, sideEffect._1) + ")");
            case /* RespondToBgWithFailure */ 12:
                return "RespondToBgWithFailure(respondToBg, failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, sideEffect._1) + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord21, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._2) + ")"));
            case /* RenderOnHostPage */ 13:
                return "RenderOnHostPage(" + (RenderOnHost$SmartcutsMacros.stringify(sideEffect._0) + ")");
            case /* RenderHtmlMarkup */ 14:
                return "RenderHtmlMarkup(" + (sideEffect._0 + ")");
            case /* UpdateRenderedContentGeometry */ 15:
                return "UpdateRenderedContentGeometry(" + (RenderOnHost__Geometry$SmartcutsMacros.stringify(sideEffect._0) + ")");
            case /* CheckIfElementExistsOnPageAndRespond */ 16:
                return "CheckIfElementExistsOnPageAndRespond(" + (Selector$SmartcutsMacros.stringifyElementSelector(sideEffect._0) + (", maybeInnerTextSemantic: " + (OptionUtils$SmartcutsMacros.stringify(InnerTextSemantic$SmartcutsMacros.stringify, sideEffect._1) + ", respondToBg)")));
        }
    }
}
function stringifyListener$6(stringifyDomEvent, stringifyDomMutationRecord22, listener) {
    if (typeof listener === "number") {
        if (listener === /* NoListener */ 0) {
            return "NoListener";
        } else {
            return "ContextMenuDomEventListener";
        }
    }
    switch(listener.TAG | 0){
        case /* MessageFromExtensionListener */ 0:
            return "ContentScript.onMessageFromExtension(" + (Curry._1(ExtensionMessagingLogging.FromExtension.All.stringifyMessage, listener._0) + ")");
        case /* RecordingModeListener */ 1:
            return "RecordingModeListener(" + (Curry._3(ContentScript__StateMachine__RecordingMode__Types__Helpers.Generic.stringifyListener, stringifyDomEvent, stringifyDomMutationRecord22, listener._0) + ")");
        case /* UrlTriggeringModeListener */ 2:
            return "UrlTriggeringModeListener(" + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifyListener(listener._0) + ")");
        case /* DataExtractionModeListener */ 3:
            return "DataExtractionModeListener(" + (ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.stringifyListener(listener._0) + ")");
    }
}
function mapListener$4(mapDomEvent35, mapDomMutationRecord20, listener) {
    if (typeof listener === "number") {
        if (listener === /* NoListener */ 0) {
            return /* NoListener */ 0;
        } else {
            return /* ContextMenuDomEventListener */ 1;
        }
    }
    switch(listener.TAG | 0){
        case /* MessageFromExtensionListener */ 0:
            return {
                TAG: /* MessageFromExtensionListener */ 0,
                _0: listener._0,
                _1: listener._1,
                _2: listener._2
            };
        case /* RecordingModeListener */ 1:
            return {
                TAG: /* RecordingModeListener */ 1,
                _0: Curry._3(ContentScript__StateMachine__RecordingMode__Types__Helpers.Generic.mapListener, mapDomEvent35, mapDomMutationRecord20, listener._0)
            };
        case /* UrlTriggeringModeListener */ 2:
            return {
                TAG: /* UrlTriggeringModeListener */ 2,
                _0: listener._0
            };
        case /* DataExtractionModeListener */ 3:
            return {
                TAG: /* DataExtractionModeListener */ 3,
                _0: ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.mapListener(mapDomMutationRecord20, listener._0)
            };
    }
}
function mapContentScriptIdle(mapHtmlElement, param) {
    return {
        lastContextMenuTarget: OptionUtils$SmartcutsMacros.map(param.lastContextMenuTarget, mapHtmlElement),
        disconnectLinkTriggerListener: param.disconnectLinkTriggerListener
    };
}
function mapState$5(mapRecordingState, mapHtmlElement, mapDomEvent36, state) {
    if (typeof state === "number") {
        if (state === /* Init */ 0) {
            return /* Init */ 0;
        } else {
            return /* ExtensionContextInvalidated */ 1;
        }
    }
    switch(state.TAG | 0){
        case /* WaitingForBgToAckContentScriptReady */ 0:
            return {
                TAG: /* WaitingForBgToAckContentScriptReady */ 0,
                _0: mapContentScriptIdle(mapHtmlElement, state._0)
            };
        case /* ContentScriptIdle */ 1:
            return {
                TAG: /* ContentScriptIdle */ 1,
                _0: mapContentScriptIdle(mapHtmlElement, state._0)
            };
        case /* RecordingMode */ 2:
            return {
                TAG: /* RecordingMode */ 2,
                _0: Curry._1(mapRecordingState, state._0)
            };
        case /* PlaybackMode */ 3:
            return {
                TAG: /* PlaybackMode */ 3,
                _0: Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.mapState, mapHtmlElement, mapDomEvent36, state._0)
            };
        case /* UrlTriggeringMode */ 4:
            return {
                TAG: /* UrlTriggeringMode */ 4,
                _0: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapState(mapHtmlElement, mapDomEvent36, state._0)
            };
        case /* DataExtractionMode */ 5:
            return {
                TAG: /* DataExtractionMode */ 5,
                _0: ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.mapState(mapHtmlElement, state._0)
            };
    }
}
function mapEvent$5(mapDomEvent37, mapDomMutationRecord21, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, $$event) {
    if (typeof $$event === "number") {
        return /* Initialize */ 0;
    }
    switch($$event.TAG | 0){
        case /* BasicEventRootLevel */ 0:
            return {
                TAG: /* BasicEventRootLevel */ 0,
                _0: $$event._0
            };
        case /* BgDidAckContentScriptReady */ 1:
            return {
                TAG: /* BgDidAckContentScriptReady */ 1,
                _0: $$event._0
            };
        case /* DidRespondToBgWithContentScriptFailureId */ 2:
            return {
                TAG: /* DidRespondToBgWithContentScriptFailureId */ 2,
                _0: $$event._0,
                _1: $$event._1,
                _2: mapErrorContext(mapDomEvent37, mapDomMutationRecord21, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, $$event._2)
            };
        case /* DidSetupLinkTriggerListener */ 3:
            return {
                TAG: /* DidSetupLinkTriggerListener */ 3,
                _0: $$event._0
            };
        case /* RecordingModeEvent */ 4:
            return {
                TAG: /* RecordingModeEvent */ 4,
                _0: Curry._1(mapRecordingEvent, $$event._0)
            };
        case /* PlaybackModeEvent */ 5:
            return {
                TAG: /* PlaybackModeEvent */ 5,
                _0: Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.mapEvent, mapHtmlElement, mapDomEvent37, $$event._0)
            };
        case /* UrlTriggeringModeEvent */ 6:
            return {
                TAG: /* UrlTriggeringModeEvent */ 6,
                _0: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapEvent(mapHtmlElement, mapDomEvent37, $$event._0)
            };
        case /* DataExtractionModeEvent */ 7:
            return {
                TAG: /* DataExtractionModeEvent */ 7,
                _0: ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.mapEvent(mapHtmlElement, mapDomMutationRecord21, mapDomEvent37, $$event._0)
            };
        case /* Fail */ 8:
            return {
                TAG: /* Fail */ 8,
                _0: mapFailure$5(mapDomEvent37, mapDomMutationRecord21, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, $$event._0)
            };
        case /* ContextMenuEventDidFireOnElement */ 9:
            return {
                TAG: /* ContextMenuEventDidFireOnElement */ 9,
                _0: Curry._1(mapHtmlElement, $$event._0)
            };
    }
}
function mapFailure$5(mapDomEvent38, mapDomMutationRecord22, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, failure) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, function(param) {
        return mapState$5(mapRecordingState, mapHtmlElement, mapDomEvent38, param);
    }, function(param) {
        return mapEvent$5(mapDomEvent38, mapDomMutationRecord22, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, param);
    }, function(param) {
        return mapSideEffect$5(mapDomEvent38, mapDomMutationRecord22, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, param);
    }, function(param) {
        return mapListener$4(mapDomEvent38, mapDomMutationRecord22, param);
    }, failure);
}
function mapErrorContext(mapDomEvent39, mapDomMutationRecord23, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, errorContext) {
    return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.map, function(param) {
        return mapState$5(mapRecordingState, mapHtmlElement, mapDomEvent39, param);
    }, function(param) {
        return mapEvent$5(mapDomEvent39, mapDomMutationRecord23, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, param);
    }, function(param) {
        return mapSideEffect$5(mapDomEvent39, mapDomMutationRecord23, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, param);
    }, function(param) {
        return mapListener$4(mapDomEvent39, mapDomMutationRecord23, param);
    }, errorContext);
}
function mapSideEffect$5(mapDomEvent40, mapDomMutationRecord24, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect) {
    if (typeof sideEffect === "number") {
        switch(sideEffect){
            case /* ResetStateMachineHistory */ 0:
                return /* ResetStateMachineHistory */ 0;
            case /* NotifyBgThatContentScriptReady */ 1:
                return /* NotifyBgThatContentScriptReady */ 1;
            case /* SetupLinkTriggerListener */ 2:
                return /* SetupLinkTriggerListener */ 2;
            case /* RemoveRenderedContent */ 3:
                return /* RemoveRenderedContent */ 3;
        }
    } else {
        switch(sideEffect.TAG | 0){
            case /* Dispatch */ 0:
                return {
                    TAG: /* Dispatch */ 0,
                    _0: mapEvent$5(mapDomEvent40, mapDomMutationRecord24, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._0)
                };
            case /* NotifyBgOfContentScriptFailure */ 1:
                return {
                    TAG: /* NotifyBgOfContentScriptFailure */ 1,
                    _0: sideEffect._0,
                    _1: mapErrorContext(mapDomEvent40, mapDomMutationRecord24, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._1)
                };
            case /* NotifyBgOfContentScriptResponseFailure */ 2:
                return {
                    TAG: /* NotifyBgOfContentScriptResponseFailure */ 2,
                    _0: sideEffect._0,
                    _1: sideEffect._1,
                    _2: mapErrorContext(mapDomEvent40, mapDomMutationRecord24, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._2)
                };
            case /* TeardownLinkTriggerListener */ 3:
                return {
                    TAG: /* TeardownLinkTriggerListener */ 3,
                    _0: sideEffect._0
                };
            case /* RecordingModeSideEffect */ 4:
                return {
                    TAG: /* RecordingModeSideEffect */ 4,
                    _0: Curry._1(mapRecordingSideEffect, sideEffect._0)
                };
            case /* PlaybackModeSideEffect */ 5:
                return {
                    TAG: /* PlaybackModeSideEffect */ 5,
                    _0: Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.mapSideEffect, mapHtmlElement, mapDomEvent40, sideEffect._0)
                };
            case /* UrlTriggeringModeSideEffect */ 6:
                return {
                    TAG: /* UrlTriggeringModeSideEffect */ 6,
                    _0: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapSideEffect(mapHtmlElement, mapDomEvent40, sideEffect._0)
                };
            case /* DataExtractionModeSideEffect */ 7:
                return {
                    TAG: /* DataExtractionModeSideEffect */ 7,
                    _0: ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.mapSideEffect(mapHtmlElement, mapDomMutationRecord24, mapDomEvent40, sideEffect._0)
                };
            case /* WindowAlert */ 8:
                return {
                    TAG: /* WindowAlert */ 8,
                    _0: sideEffect._0
                };
            case /* ConsoleJsPromiseError */ 9:
                return {
                    TAG: /* ConsoleJsPromiseError */ 9,
                    _0: sideEffect._0,
                    _1: mapErrorContext(mapDomEvent40, mapDomMutationRecord24, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._1)
                };
            case /* ConsoleJsExn */ 10:
                return {
                    TAG: /* ConsoleJsExn */ 10,
                    _0: sideEffect._0,
                    _1: mapErrorContext(mapDomEvent40, mapDomMutationRecord24, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._1)
                };
            case /* RespondToBg */ 11:
                return {
                    TAG: /* RespondToBg */ 11,
                    _0: sideEffect._0,
                    _1: sideEffect._1
                };
            case /* RespondToBgWithFailure */ 12:
                return {
                    TAG: /* RespondToBgWithFailure */ 12,
                    _0: sideEffect._0,
                    _1: sideEffect._1,
                    _2: mapErrorContext(mapDomEvent40, mapDomMutationRecord24, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._2)
                };
            case /* RenderOnHostPage */ 13:
                return {
                    TAG: /* RenderOnHostPage */ 13,
                    _0: sideEffect._0
                };
            case /* RenderHtmlMarkup */ 14:
                return {
                    TAG: /* RenderHtmlMarkup */ 14,
                    _0: sideEffect._0
                };
            case /* UpdateRenderedContentGeometry */ 15:
                return {
                    TAG: /* UpdateRenderedContentGeometry */ 15,
                    _0: sideEffect._0
                };
            case /* CheckIfElementExistsOnPageAndRespond */ 16:
                return {
                    TAG: /* CheckIfElementExistsOnPageAndRespond */ 16,
                    _0: sideEffect._0,
                    _1: sideEffect._1,
                    _2: sideEffect._2
                };
        }
    }
}
var stringifyDomMutationRecord$6 = DOM$SmartcutsMacros.$$MutationRecord.stringify;
function stringifyState$14(param) {
    return stringifyState$13(function(param) {
        return "htmlElement";
    }, DOM__Event$SmartcutsMacros.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyState, param);
}
function stringifyEvent$15(param) {
    return stringifyEvent$14(function(param) {
        return "htmlElement";
    }, DOM__Event$SmartcutsMacros.stringify, stringifyDomMutationRecord$6, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifySideEffect, param);
}
function stringifySideEffect$14(param) {
    return stringifySideEffect$13(function(param) {
        return "htmlElement";
    }, DOM__Event$SmartcutsMacros.stringify, stringifyDomMutationRecord$6, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifySideEffect, param);
}
function stringifyErrorContext$1(param) {
    return stringifyErrorContext(function(param) {
        return "htmlElement";
    }, DOM__Event$SmartcutsMacros.stringify, stringifyDomMutationRecord$6, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifySideEffect, param);
}
function stringifyListener$7(param) {
    return stringifyListener$6(DOM__Event$SmartcutsMacros.stringify, stringifyDomMutationRecord$6, param);
}
function prepareStateForSerialization$4(state) {
    return mapState$5(ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareStateForSerialization, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Event__ForSerialization$SmartcutsMacros.make, state);
}
function prepareEventForSerialization$4($$event) {
    return mapEvent$5(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareStateForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareEventForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareSideEffectForSerialization, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, $$event);
}
function prepareSideEffectForSerialization$4(sideEffect) {
    return mapSideEffect$5(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareStateForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareEventForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareSideEffectForSerialization, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, sideEffect);
}
function prepareListenerForSerialization$1(listener) {
    return mapListener$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, listener);
}
function prepareErrorContextForSerialization(errorContext) {
    return mapErrorContext(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareStateForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareEventForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareSideEffectForSerialization, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, errorContext);
}
function stringifyState$15(param) {
    return stringifyState$13(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, DOM__Event__ForSerialization$SmartcutsMacros.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyState, param);
}
function stringifyEvent$16(param) {
    return stringifyEvent$14(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, DOM__Event__ForSerialization$SmartcutsMacros.stringify, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifySideEffect, param);
}
function stringifySideEffect$15(param) {
    return stringifySideEffect$13(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, DOM__Event__ForSerialization$SmartcutsMacros.stringify, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifySideEffect, param);
}
function stringifyListener$8(param) {
    return stringifyListener$6(DOM__Event__ForSerialization$SmartcutsMacros.stringify, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify, param);
}
function stringifyErrorContext$2(param) {
    return stringifyErrorContext(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, DOM__Event__ForSerialization$SmartcutsMacros.stringify, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifySideEffect, param);
}
var stringifyFailureInfo = Curry._5(StateMachine$SmartcutsMacros.Failure.Root.FailureInfo.stringify, stringifyState$15, stringifyEvent$16, stringifySideEffect$15, stringifyListener$8, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason);
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyOtherFailureReason"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyErrorContext"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapListener"
                    ],
                    [
                        /* Function */ 0,
                        "mapState"
                    ],
                    [
                        /* Function */ 0,
                        "mapEvent"
                    ],
                    [
                        /* Function */ 0,
                        "mapFailure"
                    ],
                    [
                        /* Function */ 0,
                        "mapErrorContext"
                    ],
                    [
                        /* Function */ 0,
                        "mapSideEffect"
                    ]
                ]
            },
            "Generic"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyErrorContext"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ]
                ]
            },
            "Regular"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "prepareStateForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareEventForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareSideEffectForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareListenerForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "prepareErrorContextForSerialization"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyState"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyEvent"
                    ],
                    [
                        /* Function */ 0,
                        "stringifySideEffect"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyErrorContext"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyListener"
                    ],
                    [
                        /* Function */ 0,
                        "stringifyFailureInfo"
                    ]
                ]
            },
            "ForSerialization"
        ]
    ]
}, ContentScript__StateMachine__Types__Helpers, {
    Generic: {
        stringifyOtherFailureReason: ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason,
        stringifyState: stringifyState$13,
        stringifyErrorContext: stringifyErrorContext,
        stringifyEvent: stringifyEvent$14,
        stringifySideEffect: stringifySideEffect$13,
        stringifyListener: stringifyListener$6,
        mapListener: mapListener$4,
        mapState: mapState$5,
        mapEvent: mapEvent$5,
        mapFailure: mapFailure$5,
        mapErrorContext: mapErrorContext,
        mapSideEffect: mapSideEffect$5
    },
    Regular: {
        stringifyState: stringifyState$14,
        stringifyEvent: stringifyEvent$15,
        stringifySideEffect: stringifySideEffect$14,
        stringifyErrorContext: stringifyErrorContext$1,
        stringifyListener: stringifyListener$7
    },
    ForSerialization: {
        prepareStateForSerialization: prepareStateForSerialization$4,
        prepareEventForSerialization: prepareEventForSerialization$4,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization$4,
        prepareListenerForSerialization: prepareListenerForSerialization$1,
        prepareErrorContextForSerialization: prepareErrorContextForSerialization,
        stringifyState: stringifyState$15,
        stringifyEvent: stringifyEvent$16,
        stringifySideEffect: stringifySideEffect$15,
        stringifyErrorContext: stringifyErrorContext$2,
        stringifyListener: stringifyListener$8,
        stringifyFailureInfo: stringifyFailureInfo
    }
});
function stringifyMessage(message) {
    return "StartStreamingEventsToBackground";
}
function stringifyResponse(response) {
    return "TabDidSetupEventStreaming";
}
var StartStreamingEventsToBackground = {
    stringifyMessage: stringifyMessage,
    stringifyResponse: stringifyResponse
};
function stringifyMessage$1(message) {
    return "StopStreamingEventsToBackground";
}
function stringifyResponse$1(response) {
    return "TabDidStopStreamingEventsToBackground";
}
var StopStreamingEventsToBackground = {
    stringifyMessage: stringifyMessage$1,
    stringifyResponse: stringifyResponse$1
};
function stringifyMessage$2(message) {
    return "Playback(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, message._0) + "playbackOptions, preconditions)");
}
function stringifyResponse$2(response) {
    if (typeof response === "number") {
        return "TabDidPlaybackCommand";
    }
    switch(response.TAG | 0){
        case /* TabDidClickLink */ 0:
            return "TabDidClickLink(" + (response._0 + ")");
        case /* TabDidCopyText */ 1:
            return "TabDidCopyText(" + (response._0 + ")");
        case /* TabDidTakeScreenshot */ 2:
            return "TabDidTakeScreenshot(objectUrl=" + (StringUtils$SmartcutsMacros.quote(response._0) + (", metadata=" + (Image$SmartcutsMacros.Metadata.stringify(response._1) + ")")));
        case /* TabDidCollectDataGroups */ 3:
            var stringifyDataNode = function stringifyDataNode(param) {
                return "{ dataNodeId: " + (DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.stringify(param.dataNodeId) + (", domEntities: " + (Belt_Array.map(param.domEntities, function(domElementOrTextNode) {
                    if (domElementOrTextNode.TAG === /* HtmlElement */ 0) {
                        return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.stringify(domElementOrTextNode._0);
                    } else {
                        return domElementOrTextNode._0;
                    }
                }).join(", ") + " }")));
            };
            return "TabDidCollectDataGroups({ dataRecordsWithDataNodeId: [" + (Belt_Array.map(response._0.dataRecordsWithDataNodeId, function(param5) {
                return "{ friendlyName: " + (OptionUtils$SmartcutsMacros.stringify(function(str) {
                    return str;
                }, param5.friendlyName) + (", properties: [" + (Belt_Array.map(param5.properties, function(param) {
                    return "{ dataNode: " + (stringifyDataNode(param.dataNode) + " }");
                }).join(", ") + "] }")));
            }).join(", ") + "] })");
        case /* TabCouldNotFindElement */ 4:
            return "TabCouldNotFindElement(" + (response._0 + (", " + (SelectorOverrides$SmartcutsMacros.stringifyElementLocatorInTermsOfStrategy(response._1, true, function(selector) {
                var arg = ListUtils$SmartcutsMacros.last(selector);
                return "(chain=" + (Belt_Array.map($$Array.of_list(selector), function(param) {
                    return OptionUtils$SmartcutsMacros.getExn("Expect all selectorNodes to have tagName", param.tagName);
                }).join(" > ") + (", lastNode=" + (function(param) {
                    return OptionUtils$SmartcutsMacros.stringify(param, arg);
                }(SelectorTree$SmartcutsMacros.$$Node.stringify) + ")")));
            }) + ")")));
        case /* TabOrWindowNotVisible */ 5:
            return "TabOrWindowNotVisible(" + (response._0 + ")");
        case /* TabOrWindowVisibilityUnknownOrUnloaded */ 6:
            return "TabOrWindowVisibilityUnknownOrUnloaded(" + (response._0 + ")");
        case /* TabCouldNotApplySemantic */ 7:
            return "TabCouldNotApplySemantic(error, " + (response._1 + ")");
        case /* TabCannotCopyMissingSrcOfImg */ 8:
            return "TabCannotCopyMissingSrcOfImg(" + (response._0 + (", " + (SelectorOverrides$SmartcutsMacros.stringifyElementLocatorInTermsOfStrategy(response._1, true, function(selector) {
                var arg = ListUtils$SmartcutsMacros.last(selector);
                return "(chain=" + (Belt_Array.map($$Array.of_list(selector), function(param) {
                    return OptionUtils$SmartcutsMacros.getExn("Expect all selectorNodes to have tagName", param.tagName);
                }).join(" > ") + (", lastNode=" + (function(param) {
                    return OptionUtils$SmartcutsMacros.stringify(param, arg);
                }(SelectorTree$SmartcutsMacros.$$Node.stringify) + ")")));
            }) + ")")));
        case /* TabCouldNotPlaybackBecauseOverlayBlockingTargetElement */ 9:
            var match = response._0;
            return "TabCouldNotPlaybackBecauseOverlayBlockingTargetElement({element: " + (match.element + (", maybeOverlayElement: " + (OptionUtils$SmartcutsMacros.withDefault("None", match.maybeOverlayElement) + (", ms: " + (match.ms.toString() + ("}, " + (response._1 + ")")))))));
        case /* ErrorWhileWaitForOverlayToStopBlockingElement */ 10:
            return "ErrorWhileWaitForOverlayToStopBlockingElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, response._0) + (", " + (response._1 + ")")));
        case /* ErrorWhileSearchForElement */ 11:
            return "ErrorWhileSearchForElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, response._0) + (", " + (response._1 + ")")));
        case /* TabDidEvaluateSwitchCommand */ 12:
            var tabDidEvaluateSwitchCommand = response._0;
            var tmp;
            tmp = typeof tabDidEvaluateSwitchCommand === "number" ? "FailWithNoPredicateSatisfied" : tabDidEvaluateSwitchCommand.TAG === /* ResolvedToCommands */ 0 ? "ResolvedToCommands(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.SwitchCommandPlaybackRuntime.stringifyResolvedToCommands, tabDidEvaluateSwitchCommand._0) + ")") : "ResolvedToDoNothing(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.SwitchCommandPlaybackRuntime.stringifyCaseThatEvaluatedToTrue, tabDidEvaluateSwitchCommand._0) + ")");
            return "TabDidEvaluateSwitchCommand(" + (tmp + ")");
        case /* UnimplementedInTab */ 13:
            return "UnimplementedInTab(" + (StringUtils$SmartcutsMacros.quote(response._0) + ")");
    }
}
var Playback = {
    stringifyMessage: stringifyMessage$2,
    stringifyResponse: stringifyResponse$2
};
function stringifyMessage$3(message) {
    return "PlaybackExited";
}
function stringifyResponse$3(response) {
    return "AckPlaybackExited";
}
var PlaybackExited = {
    stringifyMessage: stringifyMessage$3,
    stringifyResponse: stringifyResponse$3
};
function stringifyMessage$4(message) {
    if (message) {
        return "RenderInContentScript(" + (RenderOnHost$SmartcutsMacros.stringify(message._0) + ")");
    } else {
        return "RemoveRenderedContent";
    }
}
function stringifyResponse$4(response) {
    return "AckRenderInContentScript";
}
var RenderInContentScript = {
    stringifyMessage: stringifyMessage$4,
    stringifyResponse: stringifyResponse$4
};
function stringifyMessage$5(message) {
    return "AskContentScriptToAdjustModalGeometry(" + (RenderOnHost__Geometry$SmartcutsMacros.stringify(message._0) + ")");
}
function stringifyResponse$5(response) {
    if (response) {
        return "ContentScriptDidNotAdjustModalGeometry";
    } else {
        return "ContentScriptDidAdjustModalGeometry";
    }
}
var AskContentScriptToAdjustModalGeometry = {
    stringifyMessage: stringifyMessage$5,
    stringifyResponse: stringifyResponse$5
};
function stringifyMessage$6(message) {
    var match = message._0;
    return "AskContentScriptToEnterUrlTriggeringMode({ maybeTriggeringLinkUrlAndText" + (OptionUtils$SmartcutsMacros.stringify(function(param) {
        return "Some(linkUrl, maybeSelectionText)";
    }, match.maybeTriggeringLinkUrlAndText) + (", isPlaybackMode: " + (Pervasives.string_of_bool(match.isPlaybackMode) + " })")));
}
function stringifyResponse$6(response) {
    if (response) {
        return "RequiresUserToTryAgain";
    } else {
        return "ContentScriptDidEnterUrlTriggeringMode";
    }
}
var AskContentScriptToEnterUrlTriggeringMode = {
    stringifyMessage: stringifyMessage$6,
    stringifyResponse: stringifyResponse$6
};
function stringifyMessage$7(message) {
    var arg = OptionUtils$SmartcutsMacros.map(message._4, MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.stringify);
    return "RefreshLinks(links(length=" + (String(message._0.length) + ("), linkGroups(length=" + (String(Belt_MapString.size(message._1)) + ("), urlPattern, step=" + (MultiUrlTriggering__Shared$SmartcutsMacros.Step.stringify(message._3) + (", paginateFn=" + (function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }("None") + ")")))))));
}
function stringifyResponse$7(response) {
    if (response) {
        return "LinksUpdated(array(length=" + (String(response._0.length) + "))");
    } else {
        return "NoUpdate";
    }
}
var UrlTriggering_RefreshLinks = {
    stringifyMessage: stringifyMessage$7,
    stringifyResponse: stringifyResponse$7
};
function stringifyMessage$8(message) {
    return "UpdateLinks(array(length=" + (String(message._0.length) + "))");
}
function stringifyResponse$8(response) {
    return "AckLinksUpdated";
}
var UrlTriggering_UpdateLinks = {
    stringifyMessage: stringifyMessage$8,
    stringifyResponse: stringifyResponse$8
};
function stringifyMessage$9(message) {
    return "TellTabToUpdateLinkGroups(size=" + (String(Belt_MapString.size(message._0)) + ")");
}
function stringifyResponse$9(response) {
    return "AckUpdateLinkGroups";
}
var UrlTriggering_TellTabToUpdateLinkGroups = {
    stringifyMessage: stringifyMessage$9,
    stringifyResponse: stringifyResponse$9
};
function stringifyMessage$10(message) {
    return "Exit";
}
function stringifyResponse$10(response) {
    return "AckExit";
}
var UrlTriggering_Exit = {
    stringifyMessage: stringifyMessage$10,
    stringifyResponse: stringifyResponse$10
};
function stringifyMessage$11(message) {
    return "AskContentScriptToRecordPageAction(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Step.stringifyPageAction(message._0) + ")");
}
function stringifyResponse$11(response) {
    return "ContentScriptDidRecordPageAction";
}
var UrlTriggering_AskContentScriptToRecordPageAction = {
    stringifyMessage: stringifyMessage$11,
    stringifyResponse: stringifyResponse$11
};
function stringifyMessage$12(message) {
    return "StopRecordPageAction";
}
function stringifyResponse$12(response) {
    return "AckStopRecordPageAction";
}
var UrlTriggering_StopRecordPageAction = {
    stringifyMessage: stringifyMessage$12,
    stringifyResponse: stringifyResponse$12
};
function stringifyMessage$13(message) {
    return "PlaybackPageActionUntil(" + (MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil(message._0) + ")");
}
function stringifyResponse$13(response) {
    return "AckPlaybackPageAction";
}
var UrlTriggering_PlaybackPageAction = {
    stringifyMessage: stringifyMessage$13,
    stringifyResponse: stringifyResponse$13
};
function stringifyMessage$14(message) {
    return "DidFinishPlaybackPageAction";
}
function stringifyResponse$14(response) {
    return "AckDidFinishPlaybackPageAction";
}
var UrlTriggering_DidFinishPlaybackPageAction = {
    stringifyMessage: stringifyMessage$14,
    stringifyResponse: stringifyResponse$14
};
function stringifyMessage$15(message) {
    return "ShowLinkWithId(" + (message._0 + ")");
}
function stringifyResponse$15(response) {
    return "AckShowLinkWithId";
}
var UrlTriggering_ShowLinkWithId = {
    stringifyMessage: stringifyMessage$15,
    stringifyResponse: stringifyResponse$15
};
function stringifyMessage$16(message) {
    return "PrepareForScreenshot";
}
function stringifyResponse$16(response) {
    return "AckPrepareForScreenshot";
}
var UrlTriggering_PrepareForScreenshot = {
    stringifyMessage: stringifyMessage$16,
    stringifyResponse: stringifyResponse$16
};
function stringifyMessage$17(message) {
    return "SendContextLocalAndLinkGroups";
}
function stringifyResponse$17(response) {
    return "GotContextLocalAndLinkGroups(contextLocal, selectedLinkGroups=array(length=" + (String(response._1.length) + "))");
}
var UrlTriggering_SendContextLocalAndLinkGroups = {
    stringifyMessage: stringifyMessage$17,
    stringifyResponse: stringifyResponse$17
};
function stringifyMessage$18(message) {
    return "Ping";
}
function stringifyResponse$18(response) {
    return "Ack";
}
var PingTab = {
    stringifyMessage: stringifyMessage$18,
    stringifyResponse: stringifyResponse$18
};
function stringifyMessage$19(message) {
    var arg = Belt_Option.map(message._1, InnerTextSemantic$SmartcutsMacros.stringify);
    return "DoesElementExistOnPage(selector=" + (Selector$SmartcutsMacros.stringifyElementSelector(message._0) + (", innerTextSemantic" + (function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }("None") + ")")));
}
function stringifyResponse$19(response) {
    if (response) {
        return "DidNotFindElement";
    } else {
        return "DidFindElement";
    }
}
var DoesElementExistOnPage = {
    stringifyMessage: stringifyMessage$19,
    stringifyResponse: stringifyResponse$19
};
function stringifyMessage$20(message) {
    return "AskTabToRenderModalToExplainHighlightElement";
}
function stringifyResponse$20(response) {
    return "AckRenderModalToExplainHighlightElement";
}
var AskTabToRenderModalToExplainHighlightElement = {
    stringifyMessage: stringifyMessage$20,
    stringifyResponse: stringifyResponse$20
};
function stringifyMessage$21(message) {
    return "AskTabToSetupHighlightElementControl(callback=" + (HighlightElement__Shared$SmartcutsMacros.Callback.stringify(message._0) + ")");
}
function stringifyResponse$21(response) {
    return "DidSetupHighlightElementControl";
}
var AskTabToSetupHighlightElementControl = {
    stringifyMessage: stringifyMessage$21,
    stringifyResponse: stringifyResponse$21
};
function stringifyMessage$22(message) {
    return "AskTabToTeardownHighlightElementControl";
}
function stringifyResponse$22(response) {
    return "DidTeardownHighlightElementControl";
}
var AskTabToTeardownHighlightElementControl = {
    stringifyMessage: stringifyMessage$22,
    stringifyResponse: stringifyResponse$22
};
function stringifyMessage$23(message) {
    return "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand";
}
function stringifyResponse$23(response) {
    return "DidHideSmartcutsPlaybackModalUntilCompletedCommand";
}
var AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = {
    stringifyMessage: stringifyMessage$23,
    stringifyResponse: stringifyResponse$23
};
function stringifyMessage$24(message) {
    return "AskTabToEnterDataExtractionMode";
}
function stringifyResponse$24(response) {
    return "TabDidEnterDataExtractionMode({newWindowCommandWithContextLocal})";
}
var AskTabToEnterDataExtractionMode = {
    stringifyMessage: stringifyMessage$24,
    stringifyResponse: stringifyResponse$24
};
function stringifyMessage$25(message) {
    return "AskTabToExitDataExtractionMode";
}
function stringifyResponse$25(response) {
    return "TabDidExitDataExtractionMode";
}
var AskTabToExitDataExtractionMode = {
    stringifyMessage: stringifyMessage$25,
    stringifyResponse: stringifyResponse$25
};
function stringifyMessage$26(message) {
    switch(message.TAG | 0){
        case /* Message_StartStreamingEventsToBackground */ 0:
            return Curry._1(ExtensionMessagingLogging.FromExtension.StartStreamingEventsToBackground.stringifyMessage, message._0);
        case /* Message_StopStreamingEventsToBackground */ 1:
            return Curry._1(ExtensionMessagingLogging.FromExtension.StopStreamingEventsToBackground.stringifyMessage, message._0);
        case /* Message_Playback */ 2:
            return Curry._1(ExtensionMessagingLogging.FromExtension.Playback.stringifyMessage, message._0);
        case /* Message_PlaybackExited */ 3:
            return Curry._1(ExtensionMessagingLogging.FromExtension.PlaybackExited.stringifyMessage, message._0);
        case /* Message_RenderInContentScript */ 4:
            return Curry._1(ExtensionMessagingLogging.FromExtension.RenderInContentScript.stringifyMessage, message._0);
        case /* Message_AskContentScriptToAdjustModalGeometry */ 5:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskContentScriptToAdjustModalGeometry.stringifyMessage, message._0);
        case /* Message_AskContentScriptToEnterUrlTriggeringMode */ 6:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskContentScriptToEnterUrlTriggeringMode.stringifyMessage, message._0);
        case /* Message_UrlTriggering_RefreshLinks */ 7:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_RefreshLinks.stringifyMessage, message._0);
        case /* Message_UrlTriggering_UpdateLinks */ 8:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_UpdateLinks.stringifyMessage, message._0);
        case /* Message_UrlTriggering_TellTabToUpdateLinkGroups */ 9:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_TellTabToUpdateLinkGroups.stringifyMessage, message._0);
        case /* Message_UrlTriggering_Exit */ 10:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_Exit.stringifyMessage, message._0);
        case /* Message_UrlTriggering_AskContentScriptToRecordPageAction */ 11:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_AskContentScriptToRecordPageAction.stringifyMessage, message._0);
        case /* Message_UrlTriggering_StopRecordPageAction */ 12:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_StopRecordPageAction.stringifyMessage, message._0);
        case /* Message_UrlTriggering_PlaybackPageAction */ 13:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_PlaybackPageAction.stringifyMessage, message._0);
        case /* Message_UrlTriggering_DidFinishPlaybackPageAction */ 14:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_DidFinishPlaybackPageAction.stringifyMessage, message._0);
        case /* Message_UrlTriggering_ShowLinkWithId */ 15:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_ShowLinkWithId.stringifyMessage, message._0);
        case /* Message_UrlTriggering_SendContextLocalAndLinkGroups */ 16:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_SendContextLocalAndLinkGroups.stringifyMessage, message._0);
        case /* Message_UrlTriggering_PrepareForScreenshot */ 17:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_PrepareForScreenshot.stringifyMessage, message._0);
        case /* Message_PingTab */ 18:
            return Curry._1(ExtensionMessagingLogging.FromExtension.PingTab.stringifyMessage, message._0);
        case /* Message_DoesElementExistOnPage */ 19:
            return Curry._1(ExtensionMessagingLogging.FromExtension.DoesElementExistOnPage.stringifyMessage, message._0);
        case /* Message_AskTabToRenderModalToExplainHighlightElement */ 20:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToRenderModalToExplainHighlightElement.stringifyMessage, message._0);
        case /* Message_AskTabToSetupHighlightElementControl */ 21:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToSetupHighlightElementControl.stringifyMessage, message._0);
        case /* Message_AskTabToTeardownHighlightElementControl */ 22:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToTeardownHighlightElementControl.stringifyMessage, message._0);
        case /* Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand.stringifyMessage, message._0);
        case /* Message_AskTabToEnterDataExtractionMode */ 24:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToEnterDataExtractionMode.stringifyMessage, message._0);
        case /* Message_AskTabToExitDataExtractionMode */ 25:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToExitDataExtractionMode.stringifyMessage, message._0);
    }
}
function stringifyResponse$26(response) {
    switch(response.TAG | 0){
        case /* Response_StartStreamingEventsToBackground */ 0:
            return Curry._1(ExtensionMessagingLogging.FromExtension.StartStreamingEventsToBackground.stringifyResponse, response._0);
        case /* Response_StopStreamingEventsToBackground */ 1:
            return Curry._1(ExtensionMessagingLogging.FromExtension.StopStreamingEventsToBackground.stringifyResponse, response._0);
        case /* Response_Playback */ 2:
            return Curry._1(ExtensionMessagingLogging.FromExtension.Playback.stringifyResponse, response._0);
        case /* Response_PlaybackExited */ 3:
            return Curry._1(ExtensionMessagingLogging.FromExtension.PlaybackExited.stringifyResponse, response._0);
        case /* Response_RenderInContentScript */ 4:
            return Curry._1(ExtensionMessagingLogging.FromExtension.RenderInContentScript.stringifyResponse, response._0);
        case /* Response_AskContentScriptToAdjustModalGeometry */ 5:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskContentScriptToAdjustModalGeometry.stringifyResponse, response._0);
        case /* Response_AskContentScriptToEnterUrlTriggeringMode */ 6:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskContentScriptToEnterUrlTriggeringMode.stringifyResponse, response._0);
        case /* Response_UrlTriggering_RefreshLinks */ 7:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_RefreshLinks.stringifyResponse, response._0);
        case /* Response_UrlTriggering_UpdateLinks */ 8:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_UpdateLinks.stringifyResponse, response._0);
        case /* Response_UrlTriggering_TellTabToUpdateLinkGroups */ 9:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_TellTabToUpdateLinkGroups.stringifyResponse, response._0);
        case /* Response_UrlTriggering_Exit */ 10:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_Exit.stringifyResponse, response._0);
        case /* Response_UrlTriggering_AskContentScriptToRecordPageAction */ 11:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_AskContentScriptToRecordPageAction.stringifyResponse, response._0);
        case /* Response_UrlTriggering_StopRecordPageAction */ 12:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_StopRecordPageAction.stringifyResponse, response._0);
        case /* Response_UrlTriggering_PlaybackPageAction */ 13:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_PlaybackPageAction.stringifyResponse, response._0);
        case /* Response_UrlTriggering_DidFinishPlaybackPageAction */ 14:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_DidFinishPlaybackPageAction.stringifyResponse, response._0);
        case /* Response_UrlTriggering_ShowLinkWithId */ 15:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_ShowLinkWithId.stringifyResponse, response._0);
        case /* Response_UrlTriggering_SendContextLocalAndLinkGroups */ 16:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_SendContextLocalAndLinkGroups.stringifyResponse, response._0);
        case /* Response_UrlTriggering_PrepareForScreenshot */ 17:
            return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_PrepareForScreenshot.stringifyResponse, response._0);
        case /* Response_PingTab */ 18:
            return Curry._1(ExtensionMessagingLogging.FromExtension.PingTab.stringifyResponse, response._0);
        case /* Response_DoesElementExistOnPage */ 19:
            return Curry._1(ExtensionMessagingLogging.FromExtension.DoesElementExistOnPage.stringifyResponse, response._0);
        case /* Response_AskTabToRenderModalToExplainHighlightElement */ 20:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToRenderModalToExplainHighlightElement.stringifyResponse, response._0);
        case /* Response_AskTabToSetupHighlightElementControl */ 21:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToSetupHighlightElementControl.stringifyResponse, response._0);
        case /* Response_AskTabToTeardownHighlightElementControl */ 22:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToTeardownHighlightElementControl.stringifyResponse, response._0);
        case /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */ 23:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand.stringifyResponse, response._0);
        case /* Response_AskTabToEnterDataExtractionMode */ 24:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToEnterDataExtractionMode.stringifyResponse, response._0);
        case /* Response_AskTabToExitDataExtractionMode */ 25:
            return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToExitDataExtractionMode.stringifyResponse, response._0);
    }
}
var All = {
    stringifyMessage: stringifyMessage$26,
    stringifyResponse: stringifyResponse$26
};
function stringifyMessage$27(message) {
    return "ContentScriptReady";
}
function stringifyResponse$27(response) {
    switch(response){
        case /* AttachToRecording */ 0:
            return "AttachToRecording";
        case /* AttachToPlayback */ 1:
            return "AttachToPlayback";
        case /* AckContentScriptReady */ 2:
            return "AckContentScriptReady";
    }
}
var ContentScriptReady = {
    stringifyMessage: stringifyMessage$27,
    stringifyResponse: stringifyResponse$27
};
function stringifyMessage$28(message) {
    return "AskBgToRefreshAuthStatus";
}
function stringifyResponse$28(response) {
    return "DidRefreshAuthStatus(" + (AuthStatus$SmartcutsMacros.stringify(response._0) + ")");
}
var AskBgToRefreshAuthStatus = {
    stringifyMessage: stringifyMessage$28,
    stringifyResponse: stringifyResponse$28
};
function stringifyMessage$29(message) {
    return "AskBgToFetchPlanSubscriptionProgress";
}
function stringifyResponse$29(response) {
    if (typeof response !== "number") {
        return "DidFetchRemainingExecutionSteps(" + (String(response._0) + (", " + (String(response._1) + (", " + (StringUtils$SmartcutsMacros.quote(response._2) + (", " + (new Date(response._3).toISOString() + ")")))))));
    }
    switch(response){
        case /* NotLoggedIn */ 0:
            return "NotLoggedIn";
        case /* HasNoActiveSubscription */ 1:
            return "HasNoActiveSubscription";
        case /* DbIssue */ 2:
            return "DbIssue";
    }
}
var AskBgToFetchPlanSubscriptionProgress = {
    stringifyMessage: stringifyMessage$29,
    stringifyResponse: stringifyResponse$29
};
function stringifyMessage$30(message) {
    return "NotifyBgOfContentScriptFailure(failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Types__Helpers.Generic.stringifyOtherFailureReason, message._0) + (", errorContext=" + (Curry._1(ContentScript__StateMachine__Types__Helpers.ForSerialization.stringifyErrorContext, message._1) + ", history)")));
}
function stringifyResponse$30(response) {
    return "BgDidAckTabError";
}
var NotifyBgOfContentScriptFailure = {
    stringifyMessage: stringifyMessage$30,
    stringifyResponse: stringifyResponse$30
};
function stringifyMessage$31(message) {
    return "NotifyBgOfContentScriptResponseFailure(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify(message._0) + (", failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Types__Helpers.Generic.stringifyOtherFailureReason, message._1) + (", errorContext=" + (Curry._1(ContentScript__StateMachine__Types__Helpers.ForSerialization.stringifyErrorContext, message._2) + ", history)")))));
}
function stringifyResponse$31(response) {
    return "BgDidAckNotifyBgOfContentScriptResponseFailure";
}
var NotifyBgOfContentScriptResponseFailure = {
    stringifyMessage: stringifyMessage$31,
    stringifyResponse: stringifyResponse$31
};
function stringifyMessage$32(message) {
    return "StartDebugSelector";
}
function stringifyResponse$32(response) {
    if (response) {
        return "BgCouldNotFindActiveTab";
    } else {
        return "BgDidStartDebugSelector";
    }
}
var StartDebugSelector = {
    stringifyMessage: stringifyMessage$32,
    stringifyResponse: stringifyResponse$32
};
function stringifyMessage$33(message) {
    if (!message) {
        return "StartRecording";
    }
    var match = message._0;
    return "StartRecordingLoginSmartcut({ mainSmartcutId:" + (match.mainSmartcutId + (", startingUrl: " + (match.startingUrl + " })")));
}
function stringifyResponse$33(response) {
    switch(response){
        case /* BgDidStartRecording */ 0:
            return "BgDidStartRecording";
        case /* BgCouldNotFindActiveTab */ 1:
            return "BgCouldNotFindActiveTab";
        case /* NotLoggedIn */ 2:
            return "NotLoggedIn";
    }
}
var StartRecording = {
    stringifyMessage: stringifyMessage$33,
    stringifyResponse: stringifyResponse$33
};
function stringifyMessage$34(message) {
    return "StopRecording";
}
function stringifyResponse$34(response) {
    return "AckStopRecording";
}
var StopRecording = {
    stringifyMessage: stringifyMessage$34,
    stringifyResponse: stringifyResponse$34
};
function stringifyMessage$35(message) {
    return "DidStartRecording";
}
function stringifyResponse$35(response) {
    if (response) {
        return "BgExitedRecording";
    } else {
        return "BgRecording";
    }
}
var DidStartRecording = {
    stringifyMessage: stringifyMessage$35,
    stringifyResponse: stringifyResponse$35
};
function stringifyMessage$36(message) {
    var maybeBoundingRect = message._1;
    return "NotifyBgAboutPossibleCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(message._0) + (", boundingRect=" + ((maybeBoundingRect !== undefined ? JSON.stringify(Rect$SmartcutsMacros.t_encode(maybeBoundingRect)) : "None") + ")")));
}
function stringifyResponse$36(response) {
    return "AckPossibleCommand";
}
var NotifyBgAboutPossibleCommand = {
    stringifyMessage: stringifyMessage$36,
    stringifyResponse: stringifyResponse$36
};
function stringifyMessage$37(message) {
    return "ClearKeyThatDoesNotGenerateCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(message._0) + ")");
}
function stringifyResponse$37(response) {
    return "AckClearKeyThatDoesNotGenerateCommand";
}
var ClearKeyThatDoesNotGenerateCommand = {
    stringifyMessage: stringifyMessage$37,
    stringifyResponse: stringifyResponse$37
};
function stringifyMessage$38(message) {
    if (message.TAG === /* RecordCommand */ 0) {
        return "RecordCommand(" + (Command$SmartcutsMacros.CommandWithContextLocal.stringify(message._0) + (", " + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(message._1, function(param) {
            return "(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(param[0]) + (", " + (String(param[1]) + ")")));
        })) + ")")));
    } else {
        return "RecordCommands([" + ($$String.concat(", ", List.map(Command$SmartcutsMacros.CommandWithContextLocal.stringify, message._0)) + ("], " + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(message._1, function(param) {
            return "(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(param[0]) + (", " + (String(param[1]) + ")")));
        })) + ")")));
    }
}
function stringifyResponse$38(response) {
    if (response) {
        return "BgDidIgnoreCommand";
    } else {
        return "BgDidRecordCommand";
    }
}
var RecordCommand = {
    stringifyMessage: stringifyMessage$38,
    stringifyResponse: stringifyResponse$38
};
function stringifyMessage$39(message) {
    return "FinishAuthoring(smartcutData)";
}
function stringifyResponse$39(response) {
    if (response) {
        return "AckFinishAuthoring(" + (response._0 + ")");
    } else {
        return "NotLoggedIn";
    }
}
var FinishAuthoring = {
    stringifyMessage: stringifyMessage$39,
    stringifyResponse: stringifyResponse$39
};
function stringifyMessage$40(message) {
    return "OpenPageForSmartcutId(" + message._0 + ")";
}
function stringifyResponse$40(response) {
    if (typeof response === "number") {
        if (response !== 0) {
            return "NotLoggedIn";
        } else {
            return "BgDidOpenSmartcutPage";
        }
    } else {
        return "DidNotFindSmartcutToOpenPage(" + response._0 + ")";
    }
}
var OpenPageForSmartcutId = {
    stringifyMessage: stringifyMessage$40,
    stringifyResponse: stringifyResponse$40
};
function stringifyMessage$41(message) {
    return "ShowFormForSmartcutId(" + message._0 + ")";
}
function stringifyResponse$41(response) {
    if (response) {
        return "DidNotFindSmartcutToOpenForm(" + response._0 + ")";
    } else {
        return "BgDidShowFormForSmartcutId";
    }
}
var ShowFormForSmartcutId = {
    stringifyMessage: stringifyMessage$41,
    stringifyResponse: stringifyResponse$41
};
function stringifyMessage$42(message) {
    return "AskBgToAdjustModalGeometry(geometry)";
}
function stringifyResponse$42(response) {
    if (response) {
        return "BgDidNotAdjustModalGeometry";
    } else {
        return "BgDidAdjustModalGeometry";
    }
}
var AskBgToAdjustModalGeometry = {
    stringifyMessage: stringifyMessage$42,
    stringifyResponse: stringifyResponse$42
};
function stringifyMessage$43(message) {
    var match = message._0;
    return "InitializePlayback(installedSmartcutId=" + (match.installedSmartcutId + (", context, userSpecifiedPlaybackOptions=" + (PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.stringify(match.userSpecifiedPlaybackOptions) + ")")));
}
function stringifyResponse$43(response) {
    return "BgDidInitializePlayback";
}
var InitializePlayback = {
    stringifyMessage: stringifyMessage$43,
    stringifyResponse: stringifyResponse$43
};
function stringifyMessage$44(message) {
    return "GetAuthoringCommandLog(" + (message._0 + ")");
}
function stringifyResponse$44(response) {
    if (typeof response === "number") {
        if (response !== 0) {
            return "NotLoggedIn";
        } else {
            return "DidNotFindAuthoringCommandLog";
        }
    } else {
        return "DidFindAuthoringCommandLog(commandLog)";
    }
}
var GetAuthoringCommandLog = {
    stringifyMessage: stringifyMessage$44,
    stringifyResponse: stringifyResponse$44
};
function stringifyMessage$45(message) {
    return "GetSmartcut(" + (message._0 + (", " + (Pervasives.string_of_bool(message._1) + ")")));
}
function stringifyResponse$45(response) {
    if (typeof response === "number") {
        return "NotLoggedIn";
    } else if (response.TAG === /* DidFindSmartcut */ 0) {
        return "DidFindSmartcut(smartcutData)";
    } else {
        return "DidNotFindSmartcut(installedSmartcutId" + (response._0 + ")");
    }
}
var GetSmartcut = {
    stringifyMessage: stringifyMessage$45,
    stringifyResponse: stringifyResponse$45
};
function stringifyMessage$46(message) {
    return "GetMySmartcuts";
}
function stringifyResponse$46(response) {
    if (typeof response === "number") {
        if (response !== 0) {
            return "NotLoggedIn";
        } else {
            return "DidNotFindMySmartcuts";
        }
    } else {
        return "DidFindMySmartcuts(smartcuts)";
    }
}
var GetMySmartcuts = {
    stringifyMessage: stringifyMessage$46,
    stringifyResponse: stringifyResponse$46
};
function stringifyMessage$47(message) {
    return "InstallSmartcut(" + (message._0 + ")");
}
function stringifyResponse$47(response) {
    if (response.TAG === /* DidInstallSmartcut */ 0) {
        return "DidInstallSmartcut(" + (response._0 + ")");
    } else {
        return "DidNotInstallSmartcut(error)";
    }
}
var InstallSmartcut = {
    stringifyMessage: stringifyMessage$47,
    stringifyResponse: stringifyResponse$47
};
function stringifyMessage$48(message) {
    return "DeleteSmartcut(" + (message._0 + ")");
}
function stringifyResponse$48(response) {
    if (typeof response === "number") {
        if (response !== 0) {
            return "NotLoggedIn";
        } else {
            return "DidDeleteSmartcut";
        }
    } else {
        return "DidNotDeleteSmartcut(error)";
    }
}
var DeleteSmartcut = {
    stringifyMessage: stringifyMessage$48,
    stringifyResponse: stringifyResponse$48
};
function stringifyMessage$49(message) {
    return "GetExecutionHistoryForSmartcut(" + (JSON.stringify(ExtensionMessaging__FromTab$SmartcutsMacros.MR_GetExecutionHistoryForSmartcut.getExecutionHistoryForSmartcut_encode(message._0)) + ")");
}
function stringifyResponse$49(response) {
    if (typeof response === "number") {
        return "NotLoggedIn";
    } else if (response.TAG === /* DidFindExecutionHistory */ 0) {
        return "DidFindExecutionHistory({executionHistory, exeuctionSets, unresolvedFailures, pendingExecutionSets})";
    } else {
        return "DidNotFindSmartcut(" + (response._0 + ")");
    }
}
var GetExecutionHistoryForSmartcut = {
    stringifyMessage: stringifyMessage$49,
    stringifyResponse: stringifyResponse$49
};
function stringifyMessage$50(message) {
    return "GetScheduledTriggersForSmartcut(" + message._0 + ")";
}
function stringifyResponse$50(response) {
    if (typeof response === "number") {
        return "NotLoggedIn";
    } else if (response.TAG === /* DidFindScheduledTriggers */ 0) {
        return "DidFindScheduledTriggers({executions, exeuctionSets, scheduledTriggers})";
    } else {
        return "DidNotFindSmartcut(" + (response._0 + ")");
    }
}
var GetScheduledTriggersForSmartcut = {
    stringifyMessage: stringifyMessage$50,
    stringifyResponse: stringifyResponse$50
};
function stringifyMessage$51(message) {
    return "FindExecutionById(" + (message._0 + ")");
}
function stringifyResponse$51(response) {
    if (typeof response === "number") {
        if (response !== 0) {
            return "NotLoggedIn";
        } else {
            return "DidNotFindExecution";
        }
    } else {
        return "DidFindExecution(execution)";
    }
}
var FindExecutionById = {
    stringifyMessage: stringifyMessage$51,
    stringifyResponse: stringifyResponse$51
};
function stringifyMessage$52(message) {
    return "UpdateExecutionStatus(" + (message._0 + ", status)");
}
function stringifyResponse$52(response) {
    if (response) {
        return "NotLoggedIn";
    } else {
        return "DidUpdateExecutionStatus";
    }
}
var UpdateExecutionStatus = {
    stringifyMessage: stringifyMessage$52,
    stringifyResponse: stringifyResponse$52
};
function stringifyMessage$53(message) {
    return "UpsertExecutionSet(executionSet)";
}
function stringifyResponse$53(response) {
    return "DidUpsertExecutionSet(isPlayingBackAnotherExecutionSet: " + (Pervasives.string_of_bool(response._0) + ")");
}
var UpsertExecutionSet = {
    stringifyMessage: stringifyMessage$53,
    stringifyResponse: stringifyResponse$53
};
function stringifyMessage$54(message) {
    return "DeleteExecutionSet(" + (message._0 + ")");
}
function stringifyResponse$54(response) {
    if (response) {
        return "NotLoggedIn";
    } else {
        return "DidDeleteExecutionSet";
    }
}
var DeleteExecutionSet = {
    stringifyMessage: stringifyMessage$54,
    stringifyResponse: stringifyResponse$54
};
function stringifyMessage$55(message) {
    return "GetExecutionSetProgress";
}
function stringifyResponse$55(response) {
    if (response) {
        return "DidGetExecutionSetProgress(" + (ExtensionMessaging__FromTab$SmartcutsMacros.MR_GetExecutionSetProgress.stringifyProgress(response._0) + ")");
    } else {
        return "NotLoggedIn";
    }
}
var GetExecutionSetProgress = {
    stringifyMessage: stringifyMessage$55,
    stringifyResponse: stringifyResponse$55
};
function stringifyMessage$56(message) {
    return "GetExecutionSetById(" + message._0 + ")";
}
function stringifyResponse$56(response) {
    return ExtensionMessaging__FromTab$SmartcutsMacros.MR_GetExecutionSetById.stringifyResponse(response);
}
var GetExecutionSetById = {
    stringifyMessage: stringifyMessage$56,
    stringifyResponse: stringifyResponse$56
};
function stringifyMessage$57(message) {
    return "UpsertScheduledTriggerAndCreateAlarm(scheduledTrigger)";
}
function stringifyResponse$57(response) {
    switch(response){
        case /* DidUpsertScheduledTriggerAndCreateAlarm */ 0:
            return "DidUpsertScheduledTriggerAndCreateAlarm";
        case /* DidNotFindSmartcut */ 1:
            return "DidNotFindSmartcut";
        case /* NotLoggedIn */ 2:
            return "NotLoggedIn";
    }
}
var UpsertScheduledTriggerAndCreateAlarm = {
    stringifyMessage: stringifyMessage$57,
    stringifyResponse: stringifyResponse$57
};
function stringifyMessage$58(message) {
    return "ArchiveScheduledTrigger(" + (message._0 + ")");
}
function stringifyResponse$58(response) {
    switch(response){
        case /* DidArchiveScheduledTrigger */ 0:
            return "DidArchiveScheduledTrigger";
        case /* DidNotClearAlarmNorArchiveInDb */ 1:
            return "DidNotClearAlarmNorArchiveInDb";
        case /* DidNotClearAlarmButDidArchiveInDb */ 2:
            return "DidNotClearAlarmButDidArchiveInDb";
        case /* ClearedAlarmButDidNotArchiveInDb */ 3:
            return "ClearedAlarmButDidNotArchiveInDb";
        case /* NotLoggedIn */ 4:
            return "NotLoggedIn";
    }
}
var ArchiveScheduledTrigger = {
    stringifyMessage: stringifyMessage$58,
    stringifyResponse: stringifyResponse$58
};
function stringifyMessage$59(message) {
    return "SaveExternalAccount(_account)";
}
function stringifyResponse$59(response) {
    return "DidSaveExternalAccount";
}
var SaveExternalAccount = {
    stringifyMessage: stringifyMessage$59,
    stringifyResponse: stringifyResponse$59
};
function stringifyMessage$60(message) {
    return "FindExternalAccountById(" + (message._0 + ")");
}
function stringifyResponse$60(response) {
    if (response) {
        return "DidFindExternalAccount(account)";
    } else {
        return "DidNotFindExternalAccount";
    }
}
var FindExternalAccountById = {
    stringifyMessage: stringifyMessage$60,
    stringifyResponse: stringifyResponse$60
};
function stringifyMessage$61(message) {
    return "GetOAuthToken(" + (Pervasives.string_of_bool(message._0) + ")");
}
function stringifyResponse$61(response) {
    if (response) {
        return "DidGetOAuthToken(token)";
    } else {
        return "DidNotGetOAuthToken";
    }
}
var GetOAuthToken = {
    stringifyMessage: stringifyMessage$61,
    stringifyResponse: stringifyResponse$61
};
function stringifyMessage$62(message) {
    return "AskBgToWriteToClipboard(" + (ClipboardHelpers$SmartcutsMacros.stringifyTextOrImageResolved(message._0) + ")");
}
function stringifyResponse$62(response) {
    return "BgDidWriteToClipboard";
}
var AskBgToClipboard = {
    stringifyMessage: stringifyMessage$62,
    stringifyResponse: stringifyResponse$62
};
function stringifyMessage$63(message) {
    return "InitGoogleAuthFlow(" + (Modal__WebAuth$SmartcutsMacros.Context.stringify(message._0) + ")");
}
function stringifyResponse$63(response) {
    if (response) {
        return "GoogleAuthFlowDidGetOAuthToken(" + (response._0 + ")");
    } else {
        return "GoogleAuthFlowWasCanceledByUser";
    }
}
var InitGoogleAuthFlow = {
    stringifyMessage: stringifyMessage$63,
    stringifyResponse: stringifyResponse$63
};
function stringifyMessage$64(message) {
    return "UserDidCloseGoogleOAuthModal";
}
function stringifyResponse$64(response) {
    return "AckUserDidCloseGoogleOAuthModal";
}
var UserDidCloseGoogleOAuthModal = {
    stringifyMessage: stringifyMessage$64,
    stringifyResponse: stringifyResponse$64
};
function stringifyMessage$65(message) {
    if (typeof message === "number") {
        return "Cancel";
    }
    switch(message.TAG | 0){
        case /* InitWithSmartcutId */ 0:
            var match = message._0;
            return "InitWithSmartcutId({installedSmartcutId: " + (match.installedSmartcutId + (", tabId: " + (String(match.tabId) + "})")));
        case /* UpdateLinks */ 1:
            return "UpdateLinks(array(length=" + (String(message._0.length) + "))");
        case /* UpdateLinkAtIndex */ 2:
            return "UpdateLinkAtIndex(" + (String(message._0) + (", " + (MultiUrlTriggering__Shared$SmartcutsMacros.Link.stringify(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, message._1) + ")")));
        case /* SubmitForPlayback */ 3:
            return "SubmitForPlayback(" + (JSON.stringify(ExtensionMessaging__FromTab$SmartcutsMacros.MR_MultiUrlTriggering.submitForPlayback_encode(message._0)) + ")");
    }
}
function stringifyResponse$65(response) {
    return "Ok";
}
function stringifyMessage$66(message) {
    if (typeof message === "number") {
        if (message === /* FetchCandidateChains */ 0) {
            return "FetchCandidateChains";
        } else {
            return "StopDebug";
        }
    } else if (message.TAG === /* GoToStep */ 0) {
        return "GoToStep(" + (String(message._0) + ")");
    } else {
        return "HighlightCandidateChain(" + (String(message._0) + ")");
    }
}
function stringifyResponse$66(response) {
    if (response) {
        return "DidFetchCandidateChains(candidateChains)";
    } else {
        return "Ok";
    }
}
var DebugSelector = {
    stringifyMessage: stringifyMessage$66,
    stringifyResponse: stringifyResponse$66
};
function stringifyMessage$67(message) {
    return "StopPlayback";
}
function stringifyResponse$67(response) {
    return "Ok";
}
var PlaybackModeControl = {
    stringifyMessage: stringifyMessage$67,
    stringifyResponse: stringifyResponse$67
};
function stringifyMessage$68(message) {
    return "AskBgToUpdateLinkGroups(size=" + (String(Belt_MapString.size(message._0)) + ")");
}
function stringifyResponse$68(response) {
    return "AckUpdateLinkGroups";
}
var UrlTriggering_AskBgToUpdateLinkGroups = {
    stringifyMessage: stringifyMessage$68,
    stringifyResponse: stringifyResponse$68
};
function stringifyMessage$69(message) {
    return "AskBgToRecordPageAction(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Step.stringifyPageAction(message._0) + ")");
}
function stringifyResponse$69(response) {
    return "AckAskBgToRecordPageAction";
}
var UrlTriggering_AskBgToRecordPageAction = {
    stringifyMessage: stringifyMessage$69,
    stringifyResponse: stringifyResponse$69
};
function stringifyMessage$70(message) {
    return "AskBgToStopRecordPageAction(" + (MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.stringify(message._0) + ")");
}
function stringifyResponse$70(response) {
    return "AckAskBgToStopRecordPageAction";
}
var UrlTriggering_AskBgToStopRecordPageAction = {
    stringifyMessage: stringifyMessage$70,
    stringifyResponse: stringifyResponse$70
};
function stringifyMessage$71(message) {
    return "AskBgToUpdatePaginateFn(" + (MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.stringify(message._0) + ")");
}
function stringifyResponse$71(response) {
    return "AckAskBgToUpdatePaginateFn";
}
var UrlTriggering_AskBgToUpdatePaginateFn = {
    stringifyMessage: stringifyMessage$71,
    stringifyResponse: stringifyResponse$71
};
function stringifyMessage$72(message) {
    return "AskBgToPlaybackPageActionUntil(" + (MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil(message._0) + ")");
}
function stringifyResponse$72(response) {
    return "AckAskBgToPlaybackPageAction";
}
var UrlTriggering_AskBgToPlaybackPageAction = {
    stringifyMessage: stringifyMessage$72,
    stringifyResponse: stringifyResponse$72
};
function stringifyMessage$73(message) {
    if (message) {
        return "AskBgToPlaybackPageActionFinished";
    } else {
        return "NotifyBgAboutToStartSinglePageAction";
    }
}
function stringifyResponse$73(response) {
    if (response) {
        return "AckAskBgToPlaybackPageActionFinished";
    } else {
        return "AckNotifyBgAboutToStartSinglePageAction";
    }
}
var UrlTriggering_DidFinishPlaybackPageAction$1 = {
    stringifyMessage: stringifyMessage$73,
    stringifyResponse: stringifyResponse$73
};
function stringifyMessage$74(message) {
    return "AskBgToShowLinkWithId(" + (message._0 + ")");
}
function stringifyResponse$74(response) {
    return "AckAskBgToShowLinkWithId";
}
var UrlTriggering_AskBgToShowLinkWithId = {
    stringifyMessage: stringifyMessage$74,
    stringifyResponse: stringifyResponse$74
};
function stringifyMessage$75(message) {
    return "AskBgToSaveUrlTriggeringAsSmartcut";
}
function stringifyResponse$75(response) {
    return "AckAskBgToSaveUrlTriggeringAsSmartcut";
}
var UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut = {
    stringifyMessage: stringifyMessage$75,
    stringifyResponse: stringifyResponse$75
};
function stringifyMessage$76(message) {
    return "MaybeReadyToPlaybackPagination";
}
function stringifyResponse$76(response) {
    return "AckMaybeReadyToPlaybackPagination";
}
var UrlTriggering_MaybeReadyToPlaybackPagination = {
    stringifyMessage: stringifyMessage$76,
    stringifyResponse: stringifyResponse$76
};
function stringifyMessage$77(message) {
    return "AskBgToFocusTab(" + (String(message._0) + ")");
}
function stringifyResponse$77(response) {
    return "AckAskBgToFocusTab";
}
var AskBgToFocusTab = {
    stringifyMessage: stringifyMessage$77,
    stringifyResponse: stringifyResponse$77
};
function stringifyMessage$78(message) {
    return "AskBgToFocusWindow(" + (String(message._0) + ")");
}
function stringifyResponse$78(response) {
    return "AckAskBgToFocusWindow";
}
var AskBgToFocusWindow = {
    stringifyMessage: stringifyMessage$78,
    stringifyResponse: stringifyResponse$78
};
function stringifyMessage$79(message) {
    return "GetProgressBySmartcutId(" + message._0 + ")";
}
function stringifyResponse$79(response) {
    if (response) {
        return "Progress(" + (String(response._0) + ")");
    } else {
        return "ProgressNotFound";
    }
}
var SmartcutSavingProgress = {
    stringifyMessage: stringifyMessage$79,
    stringifyResponse: stringifyResponse$79
};
function stringifyMessage$80(message) {
    return "RequestPermissions(permissions, permissionTrigger)";
}
function stringifyResponse$80(response) {
    return "DidRequestPermissions";
}
var RequestPermissions = {
    stringifyMessage: stringifyMessage$80,
    stringifyResponse: stringifyResponse$80
};
function stringifyMessage$81(message) {
    if (message) {
        return "ConfirmedToRunFirstNExecutions(" + (String(message._0) + ")");
    } else {
        return "Canceled";
    }
}
function stringifyResponse$81(response) {
    return "AckConfirmExecutionQuotaResult";
}
var NotifyConfirmExecutionQuotaResult = {
    stringifyMessage: stringifyMessage$81,
    stringifyResponse: stringifyResponse$81
};
function stringifyMessage$82(message) {
    return "TrackWithSegment(event)";
}
function stringifyResponse$82(response) {
    return "BgDidTrackWithSegment";
}
var TrackWithSegment = {
    stringifyMessage: stringifyMessage$82,
    stringifyResponse: stringifyResponse$82
};
function stringifyMessage$83(message) {
    return "UserReadyLogInToWebsite";
}
function stringifyResponse$83(response) {
    return "AckUserReadyLogInToWebsite";
}
var UserReadyLogInToWebsite = {
    stringifyMessage: stringifyMessage$83,
    stringifyResponse: stringifyResponse$83
};
function stringifyMessage$84(message) {
    return "OpenNewWindow(" + (Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.MR_OpenNewWindow.Params.stringify, message._0) + ")");
}
function stringifyResponse$84(response) {
    return "AckOpenNewWindow";
}
var OpenNewWindow = {
    stringifyMessage: stringifyMessage$84,
    stringifyResponse: stringifyResponse$84
};
function stringifyMessage$85(message) {
    return "StoreAuthStatusItem(key=" + (message._0 + (", value=" + (message._1 + ")")));
}
function stringifyResponse$85(response) {
    return "AckStoreAuthStatusItem";
}
var StoreAuthStatusItem = {
    stringifyMessage: stringifyMessage$85,
    stringifyResponse: stringifyResponse$85
};
function stringifyMessage$86(message) {
    return "AskBgToHighlightElement(callback=" + (HighlightElement__Shared$SmartcutsMacros.Callback.stringify(message._0) + ")");
}
function stringifyResponse$86(response) {
    return "AckHighlightElement";
}
var AskBgToHighlightElement = {
    stringifyMessage: stringifyMessage$86,
    stringifyResponse: stringifyResponse$86
};
function stringifyMessage$87(message) {
    return "DidCloseExplainModalAndAskBgToHighlightElement(" + (Pervasives.string_of_bool(message._0) + ")");
}
function stringifyResponse$87(response) {
    return "AckDidCloseExplainModalAndAskBgToHighlightElement";
}
var DidCloseExplainModalAndAskBgToHighlightElement = {
    stringifyMessage: stringifyMessage$87,
    stringifyResponse: stringifyResponse$87
};
function stringifyMessage$88(message) {
    if (message) {
        return "PopupAskBgToStopHighlightElementOnTab(tabId=" + (String(message._0) + ")");
    } else {
        return "TabAskBgToStopHighlightElement";
    }
}
function stringifyResponse$88(response) {
    return "DidTeardownHighlightElementControl";
}
var AskBgToStopHighlightElement = {
    stringifyMessage: stringifyMessage$88,
    stringifyResponse: stringifyResponse$88
};
function stringifyMessage$89(message) {
    return "GetUserCredentials";
}
function stringifyResponse$89(response) {
    if (typeof response === "number") {
        if (response !== 0) {
            return "VaultNotInitialized";
        } else {
            return "NotLoggedIn";
        }
    }
    var match = response._0;
    var vaultStatus = match.vaultStatus;
    return "DidGetUserCredentials({ credentials[size=" + (String(match.credentials.length) + ("], vaultStatus: " + ((typeof vaultStatus === "number" ? vaultStatus !== 0 ? "VaultLocked" : "VaultUnlocked" : "HasAskedTabToUnlockVault(" + (String(vaultStatus._0) + ")")) + " })")));
}
var GetUserCredentials = {
    stringifyMessage: stringifyMessage$89,
    stringifyResponse: stringifyResponse$89
};
function stringifyMessage$90(message) {
    return "UnlockVaultWithMasterSecret(masterSecret)";
}
function stringifyResponse$90(response) {
    if (!response) {
        return "DidUnlockVaultWithMasterSecret";
    }
    var error = response._0;
    var tmp;
    if (typeof error === "number") {
        switch(error){
            case /* UserCredentialsNotInitialized */ 0:
                tmp = "UserCredentialsNotInitialized";
                break;
            case /* IncorrectMasterSecret */ 1:
                tmp = "IncorrectMasterSecret";
                break;
            case /* VaultNotInitialized */ 2:
                tmp = "VaultNotInitialized";
                break;
            case /* DeccoDecodeError */ 3:
                tmp = "DeccoDecodeError";
                break;
            case /* NotLoggedIn */ 4:
                tmp = "NotLoggedIn";
                break;
        }
    } else {
        tmp = "KeyNotFound(" + (error._0 + ")");
    }
    return "DidNotUnlockVault(error=" + (tmp + ")");
}
var UnlockVaultWithMasterSecret = {
    stringifyMessage: stringifyMessage$90,
    stringifyResponse: stringifyResponse$90
};
function stringifyMessage$91(message) {
    return "ModifyUserCredentials({masterSecret: ********, action: " + (BgFx__UserCredentials__Shared$SmartcutsMacros.ModifyAction.stringify(function(param) {
        return "";
    }, message._0.action) + "})");
}
function stringifyResponse$91(response) {
    if (response.TAG === /* DidModifyUserCredentials */ 0) {
        return "DidModifyUserCredentials(" + (response._0 + ")");
    }
    var reason = response._0;
    var tmp;
    if (typeof reason === "number") {
        switch(reason){
            case /* IncorrectMasterSecret */ 0:
                tmp = "IncorrectMasterSecret";
                break;
            case /* VaultNotInitialized */ 1:
                tmp = "VaultNotInitialized";
                break;
            case /* VaultAlreadyExists */ 2:
                tmp = "VaultAlreadyExists";
                break;
            case /* DeccoDecodeError */ 3:
                tmp = "DeccoDecodeError";
                break;
            case /* NotLoggedIn */ 4:
                tmp = "NotLoggedIn";
                break;
        }
    } else {
        switch(reason.TAG | 0){
            case /* FaunaGraphqlError */ 0:
                tmp = "FaunaGraphqlError(error)";
                break;
            case /* JsonDecodeError */ 1:
                tmp = "JsonDecodeError(" + (reason._0 + ")");
                break;
            case /* KeyNotFound */ 2:
                tmp = "KeyNotFound(" + (reason._0 + ")");
                break;
        }
    }
    return "DidNotModifyUserCredentials(reason=" + (tmp + ")");
}
var ModifyUserCredentials = {
    stringifyMessage: stringifyMessage$91,
    stringifyResponse: stringifyResponse$91
};
function stringifyMessage$92(message) {
    return "TabAskBgIfMasterSecretDoesExist";
}
function stringifyResponse$92(response) {
    if (response) {
        return "MasterSecretDoesNotExist";
    } else {
        return "MasterSecretDoesExist";
    }
}
var AskBgIfMasterSecretDoesExist = {
    stringifyMessage: stringifyMessage$92,
    stringifyResponse: stringifyResponse$92
};
function stringifyMessage$93(message) {
    return "TabAskBgForMissingPasswords";
}
function stringifyResponse$93(response) {
    if (response) {
        return "MissingPasswords([...passwordIDs])";
    } else {
        return "NoMissingPasswords";
    }
}
var AskBgForMissingPasswords = {
    stringifyMessage: stringifyMessage$93,
    stringifyResponse: stringifyResponse$93
};
function stringifyMessage$94(message) {
    return "AskBgToResetMasterSecret(masterSecret)";
}
function stringifyResponse$94(response) {
    if (response) {
        return "DidResetMasterSecret(" + (response._0 + ")");
    } else {
        return "DidResetMasterSecret";
    }
}
var AskBgToResetMasterSecret = {
    stringifyMessage: stringifyMessage$94,
    stringifyResponse: stringifyResponse$94
};
function stringifyMessage$95(message) {
    return "AskBgToDetachLoginSmartcut(masterSecret)";
}
function stringifyResponse$95(response) {
    if (!response) {
        return "DidDetachLoginSmartcut";
    }
    var reason = response._0;
    return "DidDetachLoginSmartcut(" + ((typeof reason === "number" ? reason !== 0 ? "CouldNotFindSmartcut" : "NotLoggedIn" : "FaunaGraphqlError(error)") + ")");
}
var AskBgToDetachLoginSmartcut = {
    stringifyMessage: stringifyMessage$95,
    stringifyResponse: stringifyResponse$95
};
function stringifyMessage$96(message) {
    return "AskBgToEnterDataExtractionMode";
}
function stringifyResponse$96(response) {
    if (response) {
        return "BgCouldNotFindActiveTab";
    } else {
        return "DidEnterDataExtractionMode";
    }
}
var AskBgToEnterDataExtractionMode = {
    stringifyMessage: stringifyMessage$96,
    stringifyResponse: stringifyResponse$96
};
function stringifyMessage$97(message) {
    return "AskBgToProcessDataExtractionSignal(STEM(signal))";
}
function stringifyResponse$97(response) {
    return "DidProcessDataExtractionSignal(STEM(output))";
}
var AskBgToProcessDataExtractionSignal = {
    stringifyMessage: stringifyMessage$97,
    stringifyResponse: stringifyResponse$97
};
function stringifyMessage$98(message) {
    return "AskBgToCreateVaultWithMasterSecret(masterSecret)";
}
function stringifyResponse$98(response) {
    if (!response) {
        return "DidCreateVaultWithMasterSecret";
    }
    var reason = response._0;
    var tmp;
    if (typeof reason === "object") {
        var variant = reason.NAME;
        tmp = variant === "DeccoDecodeError" ? "DeccoDecodeError(error)" : variant === "JsonDecodeError" ? "JsonDecodeError(" + (reason.VAL + ")") : "FaunaGraphqlError(error)";
    } else {
        tmp = reason === "VaultNotInitialized" ? "VaultNotInitialized" : reason === "IncorrectMasterSecret" ? "IncorrectMasterSecret" : "VaultAlreadyExists";
    }
    return "DidNotCreateVaultWithMasterSecret(reason=" + (tmp + ")");
}
var AskBgToCreateVaultWithMasterSecret = {
    stringifyMessage: stringifyMessage$98,
    stringifyResponse: stringifyResponse$98
};
function stringifyMessage$99(message) {
    return "CreateSpreadsheet(" + (message._0.title + ", sheets)");
}
function stringifyResponse$99(response) {
    if (typeof response !== "number") {
        return "DidCreateSpreadsheet(spreadsheet)";
    }
    switch(response){
        case /* DidNotCreateSpreadsheet */ 0:
            return "DidNotCreateSpreadsheet";
        case /* DidNotCreateSpreadsheetBecauseUnauthenticated */ 1:
            return "DidNotCreateSpreadsheetBecauseUnauthenticated";
        case /* DidNotCreateSpreadsheetBecauseGapiNotLoaded */ 2:
            return "DidNotCreateSpreadsheetBecauseGapiNotLoaded";
    }
}
var CreateGoogleSheet = {
    stringifyMessage: stringifyMessage$99,
    stringifyResponse: stringifyResponse$99
};
function stringifyMessage$100(message) {
    return "FetchGoogleSheet(" + (message._0.spreadsheetId + ")");
}
function stringifyResponse$100(response) {
    if (typeof response !== "number") {
        return "DidFetchGoogleSheet(spreadsheet)";
    }
    switch(response){
        case /* DidNotFetchGoogleSheet */ 0:
            return "DidNotFetchGoogleSheet";
        case /* DidNotFetchGoogleSheetBecauseUnauthenticated */ 1:
            return "DidNotFetchGoogleSheetBecauseUnauthenticated";
        case /* DidNotFetchGoogleSheetBecauseGapiNotLoaded */ 2:
            return "DidNotFetchGoogleSheetBecauseGapiNotLoaded";
    }
}
var FetchGoogleSheet = {
    stringifyMessage: stringifyMessage$100,
    stringifyResponse: stringifyResponse$100
};
function stringifyMessage$101(message) {
    return "BatchUpdateSpreadsheet({" + (message._0.spreadsheetId + ", requestBody})");
}
function stringifyResponse$101(response) {
    switch(response){
        case /* DidBatchUpdateSpreadsheet */ 0:
            return "DidBatchUpdateSpreadsheet";
        case /* DidNotBatchUpdateSpreadsheet */ 1:
            return "DidNotBatchUpdateSpreadsheet";
        case /* DidNotBatchUpdateSpreadsheetBecauseUnauthenticated */ 2:
            return "DidNotBatchUpdateSpreadsheetBecauseUnauthenticated";
        case /* DidNotBatchUpdateSpreadsheetBecauseGapiNotLoaded */ 3:
            return "DidNotBatchUpdateSpreadsheetBecauseGapiNotLoaded";
    }
}
var BatchUpdateGoogleSheet = {
    stringifyMessage: stringifyMessage$101,
    stringifyResponse: stringifyResponse$101
};
function stringifyMessage$102(message) {
    return "AskBgToExitFromDataExtractionMode";
}
function stringifyResponse$102(response) {
    return "DidExitFromDataExtractionMode";
}
var AskBgToExitFromDataExtractionMode = {
    stringifyMessage: stringifyMessage$102,
    stringifyResponse: stringifyResponse$102
};
function stringifyMessage$103(message) {
    return "AskBgToRenderNotification(" + (RenderOnHost__Notification$SmartcutsMacros.stringify(message._0) + ")");
}
function stringifyResponse$103(response) {
    return "DidRenderNotification";
}
var AskBgToRenderNotification = {
    stringifyMessage: stringifyMessage$103,
    stringifyResponse: stringifyResponse$103
};
function stringifyMessage$104(message) {
    return "SaveDataExtractionAsSmartcut(" + (Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, message._0) + ", contextLocal)");
}
function stringifyResponse$104(response) {
    return "AckSaveDataExtractionAsSmartcut";
}
var AskBgToSaveDataExtractionAsSmartcut = {
    stringifyMessage: stringifyMessage$104,
    stringifyResponse: stringifyResponse$104
};
function stringifyMessage$105(message) {
    switch(message.TAG | 0){
        case /* Message_ContentScriptReady */ 0:
            return Curry._1(ExtensionMessagingLogging.FromTab.ContentScriptReady.stringifyMessage, message._0);
        case /* Message_AskBgToRefreshAuthStatus */ 1:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToRefreshAuthStatus.stringifyMessage, message._0);
        case /* Message_AskBgToFetchPlanSubscriptionProgress */ 2:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFetchPlanSubscriptionProgress.stringifyMessage, message._0);
        case /* Message_StartDebugSelector */ 3:
            return Curry._1(ExtensionMessagingLogging.FromTab.StartDebugSelector.stringifyMessage, message._0);
        case /* Message_StartRecording */ 4:
            return Curry._1(ExtensionMessagingLogging.FromTab.StartRecording.stringifyMessage, message._0);
        case /* Message_StopRecording */ 5:
            return Curry._1(ExtensionMessagingLogging.FromTab.StopRecording.stringifyMessage, message._0);
        case /* Message_DidStartRecording */ 6:
            return Curry._1(ExtensionMessagingLogging.FromTab.DidStartRecording.stringifyMessage, message._0);
        case /* Message_NotifyBgAboutPossibleCommand */ 7:
            return Curry._1(ExtensionMessagingLogging.FromTab.NotifyBgAboutPossibleCommand.stringifyMessage, message._0);
        case /* Message_ClearKeyThatDoesNotGenerateCommand */ 8:
            return Curry._1(ExtensionMessagingLogging.FromTab.ClearKeyThatDoesNotGenerateCommand.stringifyMessage, message._0);
        case /* Message_RecordCommand */ 9:
            return Curry._1(ExtensionMessagingLogging.FromTab.RecordCommand.stringifyMessage, message._0);
        case /* Message_FinishAuthoring */ 10:
            return Curry._1(ExtensionMessagingLogging.FromTab.FinishAuthoring.stringifyMessage, message._0);
        case /* Message_OpenPageForSmartcutId */ 11:
            return Curry._1(ExtensionMessagingLogging.FromTab.OpenPageForSmartcutId.stringifyMessage, message._0);
        case /* Message_ShowFormForSmartcutId */ 12:
            return Curry._1(ExtensionMessagingLogging.FromTab.ShowFormForSmartcutId.stringifyMessage, message._0);
        case /* Message_AskBgToAdjustModalGeometry */ 13:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToAdjustModalGeometry.stringifyMessage, message._0);
        case /* Message_InitializePlayback */ 14:
            return Curry._1(ExtensionMessagingLogging.FromTab.InitializePlayback.stringifyMessage, message._0);
        case /* Message_GetAuthoringCommandLog */ 15:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetAuthoringCommandLog.stringifyMessage, message._0);
        case /* Message_GetSmartcut */ 16:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetSmartcut.stringifyMessage, message._0);
        case /* Message_GetMySmartcuts */ 17:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetMySmartcuts.stringifyMessage, message._0);
        case /* Message_InstallSmartcut */ 18:
            return Curry._1(ExtensionMessagingLogging.FromTab.InstallSmartcut.stringifyMessage, message._0);
        case /* Message_DeleteSmartcut */ 19:
            return Curry._1(ExtensionMessagingLogging.FromTab.DeleteSmartcut.stringifyMessage, message._0);
        case /* Message_GetExecutionHistoryForSmartcut */ 20:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionHistoryForSmartcut.stringifyMessage, message._0);
        case /* Message_GetScheduledTriggersForSmartcut */ 21:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetScheduledTriggersForSmartcut.stringifyMessage, message._0);
        case /* Message_FindExecutionById */ 22:
            return Curry._1(ExtensionMessagingLogging.FromTab.FindExecutionById.stringifyMessage, message._0);
        case /* Message_UpdateExecutionStatus */ 23:
            return Curry._1(ExtensionMessagingLogging.FromTab.UpdateExecutionStatus.stringifyMessage, message._0);
        case /* Message_UpsertExecutionSet */ 24:
            return Curry._1(ExtensionMessagingLogging.FromTab.UpsertExecutionSet.stringifyMessage, message._0);
        case /* Message_DeleteExecutionSet */ 25:
            return Curry._1(ExtensionMessagingLogging.FromTab.DeleteExecutionSet.stringifyMessage, message._0);
        case /* Message_GetExecutionSetProgress */ 26:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionSetProgress.stringifyMessage, message._0);
        case /* Message_GetExecutionSetById */ 27:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionSetById.stringifyMessage, message._0);
        case /* Message_UpsertScheduledTriggerAndCreateAlarm */ 28:
            return Curry._1(ExtensionMessagingLogging.FromTab.UpsertScheduledTriggerAndCreateAlarm.stringifyMessage, message._0);
        case /* Message_ArchiveScheduledTrigger */ 29:
            return Curry._1(ExtensionMessagingLogging.FromTab.ArchiveScheduledTrigger.stringifyMessage, message._0);
        case /* Message_SaveExternalAccount */ 30:
            return Curry._1(ExtensionMessagingLogging.FromTab.SaveExternalAccount.stringifyMessage, message._0);
        case /* Message_FindExternalAccountById */ 31:
            return Curry._1(ExtensionMessagingLogging.FromTab.FindExternalAccountById.stringifyMessage, message._0);
        case /* Message_GetOAuthToken */ 32:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetOAuthToken.stringifyMessage, message._0);
        case /* Message_AskBgToClipboard */ 33:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToClipboard.stringifyMessage, message._0);
        case /* Message_CreateGoogleSheet */ 34:
            return Curry._1(ExtensionMessagingLogging.FromTab.CreateGoogleSheet.stringifyMessage, message._0);
        case /* Message_FetchGoogleSheet */ 35:
            return Curry._1(ExtensionMessagingLogging.FromTab.FetchGoogleSheet.stringifyMessage, message._0);
        case /* Message_BatchUpdateGoogleSheet */ 36:
            return Curry._1(ExtensionMessagingLogging.FromTab.BatchUpdateGoogleSheet.stringifyMessage, message._0);
        case /* Message_InitGoogleAuthFlow */ 37:
            return Curry._1(ExtensionMessagingLogging.FromTab.InitGoogleAuthFlow.stringifyMessage, message._0);
        case /* Message_UserDidCloseGoogleOAuthModal */ 38:
            return Curry._1(ExtensionMessagingLogging.FromTab.UserDidCloseGoogleOAuthModal.stringifyMessage, message._0);
        case /* Message_MultiUrlTriggering */ 39:
            return Curry._1(ExtensionMessagingLogging.FromTab.MultiUrlTriggering.stringifyMessage, message._0);
        case /* Message_DebugSelector */ 40:
            return Curry._1(ExtensionMessagingLogging.FromTab.DebugSelector.stringifyMessage, message._0);
        case /* Message_PlaybackModeControl */ 41:
            return Curry._1(ExtensionMessagingLogging.FromTab.PlaybackModeControl.stringifyMessage, message._0);
        case /* Message_UrlTriggering_AskBgToUpdateLinkGroups */ 42:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToUpdateLinkGroups.stringifyMessage, message._0);
        case /* Message_UrlTriggering_AskBgToRecordPageAction */ 43:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToRecordPageAction.stringifyMessage, message._0);
        case /* Message_UrlTriggering_AskBgToStopRecordPageAction */ 44:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToStopRecordPageAction.stringifyMessage, message._0);
        case /* Message_UrlTriggering_AskBgToUpdatePaginateFn */ 45:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToUpdatePaginateFn.stringifyMessage, message._0);
        case /* Message_UrlTriggering_AskBgToPlaybackPageAction */ 46:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToPlaybackPageAction.stringifyMessage, message._0);
        case /* Message_UrlTriggering_DidFinishPlaybackPageAction */ 47:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_DidFinishPlaybackPageAction.stringifyMessage, message._0);
        case /* Message_UrlTriggering_AskBgToShowLinkWithId */ 48:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToShowLinkWithId.stringifyMessage, message._0);
        case /* Message_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */ 49:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut.stringifyMessage, message._0);
        case /* Message_UrlTriggering_MaybeReadyToPlaybackPagination */ 50:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_MaybeReadyToPlaybackPagination.stringifyMessage, message._0);
        case /* Message_AskBgToFocusTab */ 51:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFocusTab.stringifyMessage, message._0);
        case /* Message_AskBgToFocusWindow */ 52:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFocusWindow.stringifyMessage, message._0);
        case /* Message_SmartcutSavingProgress */ 53:
            return Curry._1(ExtensionMessagingLogging.FromTab.SmartcutSavingProgress.stringifyMessage, message._0);
        case /* Message_RequestPermissions */ 54:
            return Curry._1(ExtensionMessagingLogging.FromTab.RequestPermissions.stringifyMessage, message._0);
        case /* Message_NotifyConfirmExecutionQuotaResult */ 55:
            return Curry._1(ExtensionMessagingLogging.FromTab.NotifyConfirmExecutionQuotaResult.stringifyMessage, message._0);
        case /* Message_TrackWithSegment */ 56:
            return Curry._1(ExtensionMessagingLogging.FromTab.TrackWithSegment.stringifyMessage, message._0);
        case /* Message_UserReadyLogInToWebsite */ 57:
            return Curry._1(ExtensionMessagingLogging.FromTab.UserReadyLogInToWebsite.stringifyMessage, message._0);
        case /* Message_OpenNewWindow */ 58:
            return Curry._1(ExtensionMessagingLogging.FromTab.OpenNewWindow.stringifyMessage, message._0);
        case /* Message_StoreAuthStatusItem */ 59:
            return Curry._1(ExtensionMessagingLogging.FromTab.StoreAuthStatusItem.stringifyMessage, message._0);
        case /* Message_AskBgToHighlightElement */ 60:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToHighlightElement.stringifyMessage, message._0);
        case /* Message_DidCloseExplainModalAndAskBgToHighlightElement */ 61:
            return Curry._1(ExtensionMessagingLogging.FromTab.DidCloseExplainModalAndAskBgToHighlightElement.stringifyMessage, message._0);
        case /* Message_AskBgToStopHighlightElement */ 62:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToStopHighlightElement.stringifyMessage, message._0);
        case /* Message_GetUserCredentials */ 63:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetUserCredentials.stringifyMessage, message._0);
        case /* Message_UnlockVaultWithMasterSecret */ 64:
            return Curry._1(ExtensionMessagingLogging.FromTab.UnlockVaultWithMasterSecret.stringifyMessage, message._0);
        case /* Message_ModifyUserCredentials */ 65:
            return Curry._1(ExtensionMessagingLogging.FromTab.ModifyUserCredentials.stringifyMessage, message._0);
        case /* Message_AskBgIfMasterSecretDoesExist */ 66:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgIfMasterSecretDoesExist.stringifyMessage, message._0);
        case /* Message_AskBgForMissingPasswords */ 67:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgForMissingPasswords.stringifyMessage, message._0);
        case /* Message_AskBgToCreateVaultWithMasterSecret */ 68:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToCreateVaultWithMasterSecret.stringifyMessage, message._0);
        case /* Message_AskBgToResetMasterSecret */ 69:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToResetMasterSecret.stringifyMessage, message._0);
        case /* Message_AskBgToDetachLoginSmartcut */ 70:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToDetachLoginSmartcut.stringifyMessage, message._0);
        case /* Message_AskBgToEnterDataExtractionMode */ 71:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToEnterDataExtractionMode.stringifyMessage, message._0);
        case /* Message_AskBgToProcessDataExtractionSignal */ 72:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToProcessDataExtractionSignal.stringifyMessage, message._0);
        case /* Message_AskBgToExitFromDataExtractionMode */ 73:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToExitFromDataExtractionMode.stringifyMessage, message._0);
        case /* Message_AskBgToSaveDataExtractionAsSmartcut */ 74:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToSaveDataExtractionAsSmartcut.stringifyMessage, message._0);
        case /* Message_AskBgToRenderNotification */ 75:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToRenderNotification.stringifyMessage, message._0);
    }
}
function stringifyResponse$105(response) {
    switch(response.TAG | 0){
        case /* Response_ContentScriptReady */ 0:
            return Curry._1(ExtensionMessagingLogging.FromTab.ContentScriptReady.stringifyResponse, response._0);
        case /* Response_AskBgToRefreshAuthStatus */ 1:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToRefreshAuthStatus.stringifyResponse, response._0);
        case /* Response_AskBgToFetchPlanSubscriptionProgress */ 2:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFetchPlanSubscriptionProgress.stringifyResponse, response._0);
        case /* Response_StartDebugSelector */ 3:
            return Curry._1(ExtensionMessagingLogging.FromTab.StartDebugSelector.stringifyResponse, response._0);
        case /* Response_StartRecording */ 4:
            return Curry._1(ExtensionMessagingLogging.FromTab.StartRecording.stringifyResponse, response._0);
        case /* Response_StopRecording */ 5:
            return Curry._1(ExtensionMessagingLogging.FromTab.StopRecording.stringifyResponse, response._0);
        case /* Response_DidStartRecording */ 6:
            return Curry._1(ExtensionMessagingLogging.FromTab.DidStartRecording.stringifyResponse, response._0);
        case /* Response_NotifyBgAboutPossibleCommand */ 7:
            return Curry._1(ExtensionMessagingLogging.FromTab.NotifyBgAboutPossibleCommand.stringifyResponse, response._0);
        case /* Response_ClearKeyThatDoesNotGenerateCommand */ 8:
            return Curry._1(ExtensionMessagingLogging.FromTab.ClearKeyThatDoesNotGenerateCommand.stringifyResponse, response._0);
        case /* Response_RecordCommand */ 9:
            return Curry._1(ExtensionMessagingLogging.FromTab.RecordCommand.stringifyResponse, response._0);
        case /* Response_FinishAuthoring */ 10:
            return Curry._1(ExtensionMessagingLogging.FromTab.FinishAuthoring.stringifyResponse, response._0);
        case /* Response_OpenPageForSmartcutId */ 11:
            return Curry._1(ExtensionMessagingLogging.FromTab.OpenPageForSmartcutId.stringifyResponse, response._0);
        case /* Response_ShowFormForSmartcutId */ 12:
            return Curry._1(ExtensionMessagingLogging.FromTab.ShowFormForSmartcutId.stringifyResponse, response._0);
        case /* Response_AskBgToAdjustModalGeometry */ 13:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToAdjustModalGeometry.stringifyResponse, response._0);
        case /* Response_InitializePlayback */ 14:
            return Curry._1(ExtensionMessagingLogging.FromTab.InitializePlayback.stringifyResponse, response._0);
        case /* Response_GetAuthoringCommandLog */ 15:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetAuthoringCommandLog.stringifyResponse, response._0);
        case /* Response_GetSmartcut */ 16:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetSmartcut.stringifyResponse, response._0);
        case /* Response_GetMySmartcuts */ 17:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetMySmartcuts.stringifyResponse, response._0);
        case /* Response_InstallSmartcut */ 18:
            return Curry._1(ExtensionMessagingLogging.FromTab.InstallSmartcut.stringifyResponse, response._0);
        case /* Response_DeleteSmartcut */ 19:
            return Curry._1(ExtensionMessagingLogging.FromTab.DeleteSmartcut.stringifyResponse, response._0);
        case /* Response_GetExecutionHistoryForSmartcut */ 20:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionHistoryForSmartcut.stringifyResponse, response._0);
        case /* Response_GetScheduledTriggersForSmartcut */ 21:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetScheduledTriggersForSmartcut.stringifyResponse, response._0);
        case /* Response_FindExecutionById */ 22:
            return Curry._1(ExtensionMessagingLogging.FromTab.FindExecutionById.stringifyResponse, response._0);
        case /* Response_UpdateExecutionStatus */ 23:
            return Curry._1(ExtensionMessagingLogging.FromTab.UpdateExecutionStatus.stringifyResponse, response._0);
        case /* Response_UpsertExecutionSet */ 24:
            return Curry._1(ExtensionMessagingLogging.FromTab.UpsertExecutionSet.stringifyResponse, response._0);
        case /* Response_DeleteExecutionSet */ 25:
            return Curry._1(ExtensionMessagingLogging.FromTab.DeleteExecutionSet.stringifyResponse, response._0);
        case /* Response_GetExecutionSetProgress */ 26:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionSetProgress.stringifyResponse, response._0);
        case /* Response_GetExecutionSetById */ 27:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionSetById.stringifyResponse, response._0);
        case /* Response_UpsertScheduledTriggerAndCreateAlarm */ 28:
            return Curry._1(ExtensionMessagingLogging.FromTab.UpsertScheduledTriggerAndCreateAlarm.stringifyResponse, response._0);
        case /* Response_ArchiveScheduledTrigger */ 29:
            return Curry._1(ExtensionMessagingLogging.FromTab.ArchiveScheduledTrigger.stringifyResponse, response._0);
        case /* Response_SaveExternalAccount */ 30:
            return Curry._1(ExtensionMessagingLogging.FromTab.SaveExternalAccount.stringifyResponse, response._0);
        case /* Response_FindExternalAccountById */ 31:
            return Curry._1(ExtensionMessagingLogging.FromTab.FindExternalAccountById.stringifyResponse, response._0);
        case /* Response_GetOAuthToken */ 32:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetOAuthToken.stringifyResponse, response._0);
        case /* Response_AskBgToClipboard */ 33:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToClipboard.stringifyResponse, response._0);
        case /* Response_CreateGoogleSheet */ 34:
            return Curry._1(ExtensionMessagingLogging.FromTab.CreateGoogleSheet.stringifyResponse, response._0);
        case /* Response_FetchGoogleSheet */ 35:
            return Curry._1(ExtensionMessagingLogging.FromTab.FetchGoogleSheet.stringifyResponse, response._0);
        case /* Response_BatchUpdateGoogleSheet */ 36:
            return Curry._1(ExtensionMessagingLogging.FromTab.BatchUpdateGoogleSheet.stringifyResponse, response._0);
        case /* Response_InitGoogleAuthFlow */ 37:
            return Curry._1(ExtensionMessagingLogging.FromTab.InitGoogleAuthFlow.stringifyResponse, response._0);
        case /* Response_UserDidCloseGoogleOAuthModal */ 38:
            return Curry._1(ExtensionMessagingLogging.FromTab.UserDidCloseGoogleOAuthModal.stringifyResponse, response._0);
        case /* Response_MultiUrlTriggering */ 39:
            return Curry._1(ExtensionMessagingLogging.FromTab.MultiUrlTriggering.stringifyResponse, response._0);
        case /* Response_DebugSelector */ 40:
            return Curry._1(ExtensionMessagingLogging.FromTab.DebugSelector.stringifyResponse, response._0);
        case /* Response_PlaybackModeControl */ 41:
            return Curry._1(ExtensionMessagingLogging.FromTab.PlaybackModeControl.stringifyResponse, response._0);
        case /* Response_UrlTriggering_AskBgToUpdateLinkGroups */ 42:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToUpdateLinkGroups.stringifyResponse, response._0);
        case /* Response_UrlTriggering_AskBgToRecordPageAction */ 43:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToRecordPageAction.stringifyResponse, response._0);
        case /* Response_UrlTriggering_AskBgToStopRecordPageAction */ 44:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToStopRecordPageAction.stringifyResponse, response._0);
        case /* Response_UrlTriggering_AskBgToUpdatePaginateFn */ 45:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToUpdatePaginateFn.stringifyResponse, response._0);
        case /* Response_UrlTriggering_AskBgToPlaybackPageAction */ 46:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToPlaybackPageAction.stringifyResponse, response._0);
        case /* Response_UrlTriggering_DidFinishPlaybackPageAction */ 47:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_DidFinishPlaybackPageAction.stringifyResponse, response._0);
        case /* Response_UrlTriggering_AskBgToShowLinkWithId */ 48:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToShowLinkWithId.stringifyResponse, response._0);
        case /* Response_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */ 49:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut.stringifyResponse, response._0);
        case /* Response_UrlTriggering_MaybeReadyToPlaybackPagination */ 50:
            return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_MaybeReadyToPlaybackPagination.stringifyResponse, response._0);
        case /* Response_SmartcutSavingProgress */ 51:
            return Curry._1(ExtensionMessagingLogging.FromTab.SmartcutSavingProgress.stringifyResponse, response._0);
        case /* Response_AskBgToFocusTab */ 52:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFocusTab.stringifyResponse, response._0);
        case /* Response_AskBgToFocusWindow */ 53:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFocusWindow.stringifyResponse, response._0);
        case /* Response_RequestPermissions */ 54:
            return Curry._1(ExtensionMessagingLogging.FromTab.RequestPermissions.stringifyResponse, response._0);
        case /* Response_NotifyConfirmExecutionQuotaResult */ 55:
            return Curry._1(ExtensionMessagingLogging.FromTab.NotifyConfirmExecutionQuotaResult.stringifyResponse, response._0);
        case /* Response_TrackWithSegment */ 56:
            return Curry._1(ExtensionMessagingLogging.FromTab.TrackWithSegment.stringifyResponse, response._0);
        case /* Response_UserReadyLogInToWebsite */ 57:
            return Curry._1(ExtensionMessagingLogging.FromTab.UserReadyLogInToWebsite.stringifyResponse, response._0);
        case /* Response_OpenNewWindow */ 58:
            return Curry._1(ExtensionMessagingLogging.FromTab.OpenNewWindow.stringifyResponse, response._0);
        case /* Response_StoreAuthStatusItem */ 59:
            return Curry._1(ExtensionMessagingLogging.FromTab.StoreAuthStatusItem.stringifyResponse, response._0);
        case /* Response_AskBgToHighlightElement */ 60:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToHighlightElement.stringifyResponse, response._0);
        case /* Response_DidCloseExplainModalAndAskBgToHighlightElement */ 61:
            return Curry._1(ExtensionMessagingLogging.FromTab.DidCloseExplainModalAndAskBgToHighlightElement.stringifyResponse, response._0);
        case /* Response_AskBgToStopHighlightElement */ 62:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToStopHighlightElement.stringifyResponse, response._0);
        case /* Response_GetUserCredentials */ 63:
            return Curry._1(ExtensionMessagingLogging.FromTab.GetUserCredentials.stringifyResponse, response._0);
        case /* Response_UnlockVaultWithMasterSecret */ 64:
            return Curry._1(ExtensionMessagingLogging.FromTab.UnlockVaultWithMasterSecret.stringifyResponse, response._0);
        case /* Response_ModifyUserCredentials */ 65:
            return Curry._1(ExtensionMessagingLogging.FromTab.ModifyUserCredentials.stringifyResponse, response._0);
        case /* Response_AskBgIfMasterSecretDoesExist */ 66:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgIfMasterSecretDoesExist.stringifyResponse, response._0);
        case /* Response_AskBgForMissingPasswords */ 67:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgForMissingPasswords.stringifyResponse, response._0);
        case /* Response_AskBgToCreateVaultWithMasterSecret */ 68:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToCreateVaultWithMasterSecret.stringifyResponse, response._0);
        case /* Response_AskBgToResetMasterSecret */ 69:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToResetMasterSecret.stringifyResponse, response._0);
        case /* Response_AskBgToDetachLoginSmartcut */ 70:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToDetachLoginSmartcut.stringifyResponse, response._0);
        case /* Response_AskBgToEnterDataExtractionMode */ 71:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToEnterDataExtractionMode.stringifyResponse, response._0);
        case /* Response_AskBgToProcessDataExtractionSignal */ 72:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToProcessDataExtractionSignal.stringifyResponse, response._0);
        case /* Response_AskBgToExitFromDataExtractionMode */ 73:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToExitFromDataExtractionMode.stringifyResponse, response._0);
        case /* Response_AskBgToSaveDataExtractionAsSmartcut */ 74:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToSaveDataExtractionAsSmartcut.stringifyResponse, response._0);
        case /* Response_AskBgToRenderNotification */ 75:
            return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToRenderNotification.stringifyResponse, response._0);
    }
}
var All$1 = {
    stringifyMessage: stringifyMessage$105,
    stringifyResponse: stringifyResponse$105
};
function stringifyMessage$106(message) {
    if (message.TAG !== /* Message_FromTabWithStateMachineDeps */ 0) {
        return stringifyMessage$105(message._0);
    }
    var msg = message._0;
    if (msg.TAG === /* Message_NotifyBgOfContentScriptFailure */ 0) {
        return stringifyMessage$30(msg._0);
    } else {
        return stringifyMessage$31(msg._0);
    }
}
function stringifyResponse$106(response) {
    if (response.TAG === /* Response_FromTabWithStateMachineDeps */ 0) {
        if (response._0.TAG === /* Response_NotifyBgOfContentScriptFailure */ 0) {
            return "BgDidAckTabError";
        } else {
            return "BgDidAckNotifyBgOfContentScriptResponseFailure";
        }
    } else {
        return stringifyResponse$105(response._0);
    }
}
var AllAll = {
    stringifyMessage: stringifyMessage$106,
    stringifyResponse: stringifyResponse$106
};
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StartStreamingEventsToBackground"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StopStreamingEventsToBackground"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "Playback"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "PlaybackExited"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "RenderInContentScript"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskContentScriptToAdjustModalGeometry"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskContentScriptToEnterUrlTriggeringMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_RefreshLinks"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_UpdateLinks"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_TellTabToUpdateLinkGroups"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_Exit"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskContentScriptToRecordPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_StopRecordPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_PlaybackPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_DidFinishPlaybackPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_ShowLinkWithId"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_SendContextLocalAndLinkGroups"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_PrepareForScreenshot"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "PingTab"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DoesElementExistOnPage"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToRenderModalToExplainHighlightElement"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToSetupHighlightElementControl"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToTeardownHighlightElementControl"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToEnterDataExtractionMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskTabToExitDataExtractionMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "All"
                    ]
                ]
            },
            "FromExtension"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ContentScriptReady"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToRefreshAuthStatus"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToFetchPlanSubscriptionProgress"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "NotifyBgOfContentScriptFailure"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "NotifyBgOfContentScriptResponseFailure"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StartDebugSelector"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StartRecording"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StopRecording"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DidStartRecording"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "NotifyBgAboutPossibleCommand"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ClearKeyThatDoesNotGenerateCommand"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "RecordCommand"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "FinishAuthoring"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "OpenPageForSmartcutId"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ShowFormForSmartcutId"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToAdjustModalGeometry"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "InitializePlayback"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetAuthoringCommandLog"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetMySmartcuts"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "InstallSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DeleteSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetExecutionHistoryForSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetScheduledTriggersForSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "FindExecutionById"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UpdateExecutionStatus"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UpsertExecutionSet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DeleteExecutionSet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetExecutionSetProgress"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetExecutionSetById"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UpsertScheduledTriggerAndCreateAlarm"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ArchiveScheduledTrigger"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "SaveExternalAccount"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "FindExternalAccountById"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetOAuthToken"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToClipboard"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "CreateGoogleSheet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "FetchGoogleSheet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "BatchUpdateGoogleSheet"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "InitGoogleAuthFlow"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UserDidCloseGoogleOAuthModal"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "MultiUrlTriggering"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DebugSelector"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "PlaybackModeControl"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToUpdateLinkGroups"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToRecordPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToStopRecordPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToPlaybackPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_DidFinishPlaybackPageAction"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToShowLinkWithId"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_MaybeReadyToPlaybackPagination"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UrlTriggering_AskBgToUpdatePaginateFn"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToFocusTab"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToFocusWindow"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "SmartcutSavingProgress"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "RequestPermissions"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "NotifyConfirmExecutionQuotaResult"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "TrackWithSegment"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UserReadyLogInToWebsite"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "OpenNewWindow"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "StoreAuthStatusItem"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToHighlightElement"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "DidCloseExplainModalAndAskBgToHighlightElement"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToStopHighlightElement"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "GetUserCredentials"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "UnlockVaultWithMasterSecret"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "ModifyUserCredentials"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgIfMasterSecretDoesExist"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgForMissingPasswords"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToCreateVaultWithMasterSecret"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToResetMasterSecret"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToDetachLoginSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToEnterDataExtractionMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToProcessDataExtractionSignal"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToExitFromDataExtractionMode"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToRenderNotification"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AskBgToSaveDataExtractionAsSmartcut"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "All"
                    ],
                    [
                        {
                            TAG: /* Module */ 0,
                            _0: [
                                [
                                    /* Function */ 0,
                                    "stringifyMessage"
                                ],
                                [
                                    /* Function */ 0,
                                    "stringifyResponse"
                                ]
                            ]
                        },
                        "AllAll"
                    ]
                ]
            },
            "FromTab"
        ]
    ]
}, ExtensionMessagingLogging, {
    FromExtension: {
        StartStreamingEventsToBackground: StartStreamingEventsToBackground,
        StopStreamingEventsToBackground: StopStreamingEventsToBackground,
        Playback: Playback,
        PlaybackExited: PlaybackExited,
        RenderInContentScript: RenderInContentScript,
        AskContentScriptToAdjustModalGeometry: AskContentScriptToAdjustModalGeometry,
        AskContentScriptToEnterUrlTriggeringMode: AskContentScriptToEnterUrlTriggeringMode,
        UrlTriggering_RefreshLinks: UrlTriggering_RefreshLinks,
        UrlTriggering_UpdateLinks: UrlTriggering_UpdateLinks,
        UrlTriggering_TellTabToUpdateLinkGroups: UrlTriggering_TellTabToUpdateLinkGroups,
        UrlTriggering_Exit: UrlTriggering_Exit,
        UrlTriggering_AskContentScriptToRecordPageAction: UrlTriggering_AskContentScriptToRecordPageAction,
        UrlTriggering_StopRecordPageAction: UrlTriggering_StopRecordPageAction,
        UrlTriggering_PlaybackPageAction: UrlTriggering_PlaybackPageAction,
        UrlTriggering_DidFinishPlaybackPageAction: UrlTriggering_DidFinishPlaybackPageAction,
        UrlTriggering_ShowLinkWithId: UrlTriggering_ShowLinkWithId,
        UrlTriggering_SendContextLocalAndLinkGroups: UrlTriggering_SendContextLocalAndLinkGroups,
        UrlTriggering_PrepareForScreenshot: UrlTriggering_PrepareForScreenshot,
        PingTab: PingTab,
        DoesElementExistOnPage: DoesElementExistOnPage,
        AskTabToRenderModalToExplainHighlightElement: AskTabToRenderModalToExplainHighlightElement,
        AskTabToSetupHighlightElementControl: AskTabToSetupHighlightElementControl,
        AskTabToTeardownHighlightElementControl: AskTabToTeardownHighlightElementControl,
        AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand: AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand,
        AskTabToEnterDataExtractionMode: AskTabToEnterDataExtractionMode,
        AskTabToExitDataExtractionMode: AskTabToExitDataExtractionMode,
        All: All
    },
    FromTab: {
        ContentScriptReady: ContentScriptReady,
        AskBgToRefreshAuthStatus: AskBgToRefreshAuthStatus,
        AskBgToFetchPlanSubscriptionProgress: AskBgToFetchPlanSubscriptionProgress,
        NotifyBgOfContentScriptFailure: NotifyBgOfContentScriptFailure,
        NotifyBgOfContentScriptResponseFailure: NotifyBgOfContentScriptResponseFailure,
        StartDebugSelector: StartDebugSelector,
        StartRecording: StartRecording,
        StopRecording: StopRecording,
        DidStartRecording: DidStartRecording,
        NotifyBgAboutPossibleCommand: NotifyBgAboutPossibleCommand,
        ClearKeyThatDoesNotGenerateCommand: ClearKeyThatDoesNotGenerateCommand,
        RecordCommand: RecordCommand,
        FinishAuthoring: FinishAuthoring,
        OpenPageForSmartcutId: OpenPageForSmartcutId,
        ShowFormForSmartcutId: ShowFormForSmartcutId,
        AskBgToAdjustModalGeometry: AskBgToAdjustModalGeometry,
        InitializePlayback: InitializePlayback,
        GetAuthoringCommandLog: GetAuthoringCommandLog,
        GetSmartcut: GetSmartcut,
        GetMySmartcuts: GetMySmartcuts,
        InstallSmartcut: InstallSmartcut,
        DeleteSmartcut: DeleteSmartcut,
        GetExecutionHistoryForSmartcut: GetExecutionHistoryForSmartcut,
        GetScheduledTriggersForSmartcut: GetScheduledTriggersForSmartcut,
        FindExecutionById: FindExecutionById,
        UpdateExecutionStatus: UpdateExecutionStatus,
        UpsertExecutionSet: UpsertExecutionSet,
        DeleteExecutionSet: DeleteExecutionSet,
        GetExecutionSetProgress: GetExecutionSetProgress,
        GetExecutionSetById: GetExecutionSetById,
        UpsertScheduledTriggerAndCreateAlarm: UpsertScheduledTriggerAndCreateAlarm,
        ArchiveScheduledTrigger: ArchiveScheduledTrigger,
        SaveExternalAccount: SaveExternalAccount,
        FindExternalAccountById: FindExternalAccountById,
        GetOAuthToken: GetOAuthToken,
        AskBgToClipboard: AskBgToClipboard,
        CreateGoogleSheet: CreateGoogleSheet,
        FetchGoogleSheet: FetchGoogleSheet,
        BatchUpdateGoogleSheet: BatchUpdateGoogleSheet,
        InitGoogleAuthFlow: InitGoogleAuthFlow,
        UserDidCloseGoogleOAuthModal: UserDidCloseGoogleOAuthModal,
        MultiUrlTriggering: {
            stringifyMessage: stringifyMessage$65,
            stringifyResponse: stringifyResponse$65
        },
        DebugSelector: DebugSelector,
        PlaybackModeControl: PlaybackModeControl,
        UrlTriggering_AskBgToUpdateLinkGroups: UrlTriggering_AskBgToUpdateLinkGroups,
        UrlTriggering_AskBgToRecordPageAction: UrlTriggering_AskBgToRecordPageAction,
        UrlTriggering_AskBgToStopRecordPageAction: UrlTriggering_AskBgToStopRecordPageAction,
        UrlTriggering_AskBgToPlaybackPageAction: UrlTriggering_AskBgToPlaybackPageAction,
        UrlTriggering_DidFinishPlaybackPageAction: UrlTriggering_DidFinishPlaybackPageAction$1,
        UrlTriggering_AskBgToShowLinkWithId: UrlTriggering_AskBgToShowLinkWithId,
        UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut: UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut,
        UrlTriggering_MaybeReadyToPlaybackPagination: UrlTriggering_MaybeReadyToPlaybackPagination,
        UrlTriggering_AskBgToUpdatePaginateFn: UrlTriggering_AskBgToUpdatePaginateFn,
        AskBgToFocusTab: AskBgToFocusTab,
        AskBgToFocusWindow: AskBgToFocusWindow,
        SmartcutSavingProgress: SmartcutSavingProgress,
        RequestPermissions: RequestPermissions,
        NotifyConfirmExecutionQuotaResult: NotifyConfirmExecutionQuotaResult,
        TrackWithSegment: TrackWithSegment,
        UserReadyLogInToWebsite: UserReadyLogInToWebsite,
        OpenNewWindow: OpenNewWindow,
        StoreAuthStatusItem: StoreAuthStatusItem,
        AskBgToHighlightElement: AskBgToHighlightElement,
        DidCloseExplainModalAndAskBgToHighlightElement: DidCloseExplainModalAndAskBgToHighlightElement,
        AskBgToStopHighlightElement: AskBgToStopHighlightElement,
        GetUserCredentials: GetUserCredentials,
        UnlockVaultWithMasterSecret: UnlockVaultWithMasterSecret,
        ModifyUserCredentials: ModifyUserCredentials,
        AskBgIfMasterSecretDoesExist: AskBgIfMasterSecretDoesExist,
        AskBgForMissingPasswords: AskBgForMissingPasswords,
        AskBgToCreateVaultWithMasterSecret: AskBgToCreateVaultWithMasterSecret,
        AskBgToResetMasterSecret: AskBgToResetMasterSecret,
        AskBgToDetachLoginSmartcut: AskBgToDetachLoginSmartcut,
        AskBgToEnterDataExtractionMode: AskBgToEnterDataExtractionMode,
        AskBgToProcessDataExtractionSignal: AskBgToProcessDataExtractionSignal,
        AskBgToExitFromDataExtractionMode: AskBgToExitFromDataExtractionMode,
        AskBgToRenderNotification: AskBgToRenderNotification,
        AskBgToSaveDataExtractionAsSmartcut: AskBgToSaveDataExtractionAsSmartcut,
        All: All$1,
        AllAll: AllAll
    }
});
exports.ContentScript__StateMachine__PlaybackMode__Types__Helpers = ContentScript__StateMachine__PlaybackMode__Types__Helpers;
exports.ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers = ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers;
exports.ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers = ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers;
exports.ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers = ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers;
exports.ContentScript__StateMachine__RecordingMode__Types__Helpers = ContentScript__StateMachine__RecordingMode__Types__Helpers;
exports.ContentScript__StateMachine__Shared__Types__Helpers = ContentScript__StateMachine__Shared__Types__Helpers;
exports.ContentScript__StateMachine__Types__Helpers = ContentScript__StateMachine__Types__Helpers;
exports.ExtensionMessagingLogging = ExtensionMessagingLogging; /* ContentScript__StateMachine__PlaybackMode__Types__Helpers Not a pure module */ 


/***/ }),

/***/ 46057:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Util$SmartcutsMacros = __webpack_require__(25092);
var StateMachine$SmartcutsMacros = __webpack_require__(9066);
var ExtensionMessagingBuilders$SmartcutsMacros = __webpack_require__(23158);
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = __webpack_require__(20229);
function message_encode(encoder_message, v) {
    return [
        "Message_FromTabWithStateMachineDeps",
        Curry._1(encoder_message, v._0)
    ];
}
function message_decode(decoder_message, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "Message_FromTabWithStateMachineDeps") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Curry._1(decoder_message, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* Message_FromTabWithStateMachineDeps */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function response_encode(encoder_response, v) {
    return [
        "Response_FromTabWithStateMachineDeps",
        Curry._1(encoder_response, v._0)
    ];
}
function response_decode(decoder_response, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "Response_FromTabWithStateMachineDeps") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Curry._1(decoder_response, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* Response_FromTabWithStateMachineDeps */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function result_encode(encoder_response, v) {
    return Decco.resultToJson(function(param) {
        return response_encode(encoder_response, param);
    }, Decco.stringToJson, v);
}
function result_decode(decoder_response, v) {
    return Decco.resultFromJson(function(param) {
        return response_decode(decoder_response, param);
    }, Decco.stringFromJson, v);
}
function wrapMessage(message) {
    return /* Message_FromTabWithStateMachineDeps */ {
        _0: message
    };
}
function wrapResponse(response) {
    return /* Response_FromTabWithStateMachineDeps */ {
        _0: response
    };
}
function unwrapMessage(message) {
    return message._0;
}
function unwrapResponse(response) {
    return response._0;
}
var AllWrapper = {
    message_encode: message_encode,
    message_decode: message_decode,
    response_encode: response_encode,
    response_decode: response_decode,
    result_encode: result_encode,
    result_decode: result_decode,
    wrapMessage: wrapMessage,
    wrapResponse: wrapResponse,
    unwrapMessage: unwrapMessage,
    unwrapResponse: unwrapResponse
};
function Make(ContentScriptStateMachine) {
    var _$message_encode = function _$message_encode(v) {
        return [
            "NotifyBgOfContentScriptFailure",
            Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, ContentScriptStateMachine.otherFailureReason_encode, v._0),
            Curry._1(ContentScriptStateMachine.errorContext_encode, v._1),
            StateMachine$SmartcutsMacros.$$History.t_encode(ContentScriptStateMachine.state_encode, ContentScriptStateMachine.event_encode, ContentScriptStateMachine.listener_encode, ContentScriptStateMachine.sideEffect_encode, v._2)
        ];
    };
    var _$message_decode = function _$message_decode(v) {
        var jsonArr = Js_json.classify(v);
        if (typeof jsonArr === "number") {
            return Decco.error(undefined, "Not a variant", v);
        }
        if (jsonArr.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a variant", v);
        }
        var jsonArr$1 = jsonArr._0;
        if (jsonArr$1.length === 0) {
            return Decco.error(undefined, "Expected variant, found empty array", v);
        }
        var tagged = jsonArr$1.map(Js_json.classify);
        var match = Belt_Array.getExn(tagged, 0);
        if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "NotifyBgOfContentScriptFailure") {
            if (tagged.length !== 4) {
                return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var match$1 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, ContentScriptStateMachine.otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 1));
            var match$2 = Curry._1(ContentScriptStateMachine.errorContext_decode, Belt_Array.getExn(jsonArr$1, 2));
            var match$3 = StateMachine$SmartcutsMacros.$$History.t_decode(ContentScriptStateMachine.state_decode, ContentScriptStateMachine.event_decode, ContentScriptStateMachine.listener_decode, ContentScriptStateMachine.sideEffect_decode, Belt_Array.getExn(jsonArr$1, 3));
            if (match$1.TAG === /* Ok */ 0) {
                if (match$2.TAG === /* Ok */ 0) {
                    if (match$3.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: /* NotifyBgOfContentScriptFailure */ {
                                _0: match$1._0,
                                _1: match$2._0,
                                _2: match$3._0
                            }
                        };
                    }
                    var e = match$3._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[2]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[1]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = match$1._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
    };
    var _$response_encode = function _$response_encode(v) {
        return [
            "BgDidAckTabError"
        ];
    };
    var _$response_decode = function _$response_decode(v) {
        var jsonArr = Js_json.classify(v);
        if (typeof jsonArr === "number") {
            return Decco.error(undefined, "Not a variant", v);
        }
        if (jsonArr.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a variant", v);
        }
        var jsonArr$1 = jsonArr._0;
        if (jsonArr$1.length === 0) {
            return Decco.error(undefined, "Expected variant, found empty array", v);
        }
        var tagged = jsonArr$1.map(Js_json.classify);
        var match = Belt_Array.getExn(tagged, 0);
        if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "BgDidAckTabError") {
            if (tagged.length !== 1) {
                return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            } else {
                return {
                    TAG: /* Ok */ 0,
                    _0: /* BgDidAckTabError */ 0
                };
            }
        }
        return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
    };
    var MR_NotifyBgOfContentScriptFailure = {
        message_encode: _$message_encode,
        message_decode: _$message_decode,
        response_encode: _$response_encode,
        response_decode: _$response_decode
    };
    var message_encode$1 = function message_encode$1(v) {
        return [
            "NotifyBgOfContentScriptResponseFailure",
            InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v._0),
            Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, ContentScriptStateMachine.otherFailureReason_encode, v._1),
            Curry._1(ContentScriptStateMachine.errorContext_encode, v._2),
            StateMachine$SmartcutsMacros.$$History.t_encode(ContentScriptStateMachine.state_encode, ContentScriptStateMachine.event_encode, ContentScriptStateMachine.listener_encode, ContentScriptStateMachine.sideEffect_encode, v._3)
        ];
    };
    var message_decode$1 = function message_decode$1(v) {
        var jsonArr = Js_json.classify(v);
        if (typeof jsonArr === "number") {
            return Decco.error(undefined, "Not a variant", v);
        }
        if (jsonArr.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a variant", v);
        }
        var jsonArr$1 = jsonArr._0;
        if (jsonArr$1.length === 0) {
            return Decco.error(undefined, "Expected variant, found empty array", v);
        }
        var tagged = jsonArr$1.map(Js_json.classify);
        var match = Belt_Array.getExn(tagged, 0);
        if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "NotifyBgOfContentScriptResponseFailure") {
            if (tagged.length !== 5) {
                return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var match$1 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Array.getExn(jsonArr$1, 1));
            var match$2 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, ContentScriptStateMachine.otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
            var match$3 = Curry._1(ContentScriptStateMachine.errorContext_decode, Belt_Array.getExn(jsonArr$1, 3));
            var match$4 = StateMachine$SmartcutsMacros.$$History.t_decode(ContentScriptStateMachine.state_decode, ContentScriptStateMachine.event_decode, ContentScriptStateMachine.listener_decode, ContentScriptStateMachine.sideEffect_decode, Belt_Array.getExn(jsonArr$1, 4));
            if (match$1.TAG === /* Ok */ 0) {
                if (match$2.TAG === /* Ok */ 0) {
                    if (match$3.TAG === /* Ok */ 0) {
                        if (match$4.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: /* NotifyBgOfContentScriptResponseFailure */ {
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0,
                                    _3: match$4._0
                                }
                            };
                        }
                        var e = match$4._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[3]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$3._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[2]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[1]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = match$1._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
    };
    var response_encode$1 = function response_encode$1(v) {
        return [
            "BgDidAckNotifyBgOfContentScriptResponseFailure"
        ];
    };
    var response_decode$1 = function response_decode$1(v) {
        var jsonArr = Js_json.classify(v);
        if (typeof jsonArr === "number") {
            return Decco.error(undefined, "Not a variant", v);
        }
        if (jsonArr.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a variant", v);
        }
        var jsonArr$1 = jsonArr._0;
        if (jsonArr$1.length === 0) {
            return Decco.error(undefined, "Expected variant, found empty array", v);
        }
        var tagged = jsonArr$1.map(Js_json.classify);
        var match = Belt_Array.getExn(tagged, 0);
        if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "BgDidAckNotifyBgOfContentScriptResponseFailure") {
            if (tagged.length !== 1) {
                return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            } else {
                return {
                    TAG: /* Ok */ 0,
                    _0: /* BgDidAckNotifyBgOfContentScriptResponseFailure */ 0
                };
            }
        }
        return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
    };
    var MR_NotifyBgOfContentScriptResponseFailure = {
        message_encode: message_encode$1,
        message_decode: message_decode$1,
        response_encode: response_encode$1,
        response_decode: response_decode$1
    };
    var message_encode$2 = function message_encode$2(v) {
        if (v.TAG === /* Message_NotifyBgOfContentScriptFailure */ 0) {
            return [
                "Message_NotifyBgOfContentScriptFailure",
                _$message_encode(v._0)
            ];
        } else {
            return [
                "Message_NotifyBgOfContentScriptResponseFailure",
                message_encode$1(v._0)
            ];
        }
    };
    var message_decode$2 = function message_decode$2(v) {
        var jsonArr = Js_json.classify(v);
        if (typeof jsonArr === "number") {
            return Decco.error(undefined, "Not a variant", v);
        }
        if (jsonArr.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a variant", v);
        }
        var jsonArr$1 = jsonArr._0;
        if (jsonArr$1.length === 0) {
            return Decco.error(undefined, "Expected variant, found empty array", v);
        }
        var tagged = jsonArr$1.map(Js_json.classify);
        var match = Belt_Array.getExn(tagged, 0);
        if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
            switch(match._0){
                case "Message_NotifyBgOfContentScriptFailure":
                    if (tagged.length !== 2) {
                        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                    }
                    var v0 = _$message_decode(Belt_Array.getExn(jsonArr$1, 1));
                    if (v0.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Message_NotifyBgOfContentScriptFailure */ 0,
                                _0: v0._0
                            }
                        };
                    }
                    var e = v0._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                case "Message_NotifyBgOfContentScriptResponseFailure":
                    if (tagged.length !== 2) {
                        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                    }
                    var v0$1 = message_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                    if (v0$1.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Message_NotifyBgOfContentScriptResponseFailure */ 1,
                                _0: v0$1._0
                            }
                        };
                    }
                    var e$1 = v0$1._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                default:
            }
        }
        return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
    };
    var response_encode$2 = function response_encode$2(v) {
        if (v.TAG === /* Response_NotifyBgOfContentScriptFailure */ 0) {
            return [
                "Response_NotifyBgOfContentScriptFailure",
                [
                    "BgDidAckTabError"
                ]
            ];
        } else {
            return [
                "Response_NotifyBgOfContentScriptResponseFailure",
                [
                    "BgDidAckNotifyBgOfContentScriptResponseFailure"
                ]
            ];
        }
    };
    var response_decode$2 = function response_decode$2(v) {
        var jsonArr = Js_json.classify(v);
        if (typeof jsonArr === "number") {
            return Decco.error(undefined, "Not a variant", v);
        }
        if (jsonArr.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a variant", v);
        }
        var jsonArr$1 = jsonArr._0;
        if (jsonArr$1.length === 0) {
            return Decco.error(undefined, "Expected variant, found empty array", v);
        }
        var tagged = jsonArr$1.map(Js_json.classify);
        var match = Belt_Array.getExn(tagged, 0);
        if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
            switch(match._0){
                case "Response_NotifyBgOfContentScriptFailure":
                    if (tagged.length !== 2) {
                        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                    }
                    var v0 = _$response_decode(Belt_Array.getExn(jsonArr$1, 1));
                    if (v0.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Response_NotifyBgOfContentScriptFailure */ 0,
                                _0: v0._0
                            }
                        };
                    }
                    var e = v0._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                case "Response_NotifyBgOfContentScriptResponseFailure":
                    if (tagged.length !== 2) {
                        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                    }
                    var v0$1 = response_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                    if (v0$1.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Response_NotifyBgOfContentScriptResponseFailure */ 1,
                                _0: v0$1._0
                            }
                        };
                    }
                    var e$1 = v0$1._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                default:
            }
        }
        return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
    };
    var MR_All = {
        message_encode: message_encode$2,
        message_decode: message_decode$2,
        response_encode: response_encode$2,
        response_decode: response_decode$2
    };
    var message_encode$3 = _$message_encode;
    var message_decode$3 = _$message_decode;
    var response_encode$3 = function response_encode$3(v) {
        return [
            "BgDidAckTabError"
        ];
    };
    var response_decode$3 = _$response_decode;
    var allMessage_encode = message_encode$2;
    var allMessage_decode = message_decode$2;
    var allResponse_encode = response_encode$2;
    var allResponse_decode = response_decode$2;
    var responseError_encode = Decco.stringToJson;
    var responseError_decode = Decco.stringFromJson;
    var wrapMessageAsAllMessage = function wrapMessageAsAllMessage(message) {
        return {
            TAG: /* Message_NotifyBgOfContentScriptFailure */ 0,
            _0: message
        };
    };
    var unwrapAllResponseAsResponse = function unwrapAllResponseAsResponse(allResponse) {
        if (allResponse.TAG === /* Response_NotifyBgOfContentScriptFailure */ 0) {
            return allResponse._0;
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
        }
    };
    var wrapResponseAsAllResponse = function wrapResponseAsAllResponse(response) {
        return {
            TAG: /* Response_NotifyBgOfContentScriptFailure */ 0,
            _0: response
        };
    };
    var MRTransform_NotifyBgOfContentScriptFailure = {
        message_encode: message_encode$3,
        message_decode: message_decode$3,
        response_encode: response_encode$3,
        response_decode: response_decode$3,
        allMessage_encode: allMessage_encode,
        allMessage_decode: allMessage_decode,
        allResponse_encode: allResponse_encode,
        allResponse_decode: allResponse_decode,
        responseError_encode: responseError_encode,
        responseError_decode: responseError_decode,
        wrapMessageAsAllMessage: wrapMessageAsAllMessage,
        unwrapAllResponseAsResponse: unwrapAllResponseAsResponse,
        wrapResponseAsAllResponse: wrapResponseAsAllResponse
    };
    var partial_arg = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;
    var NotifyBgOfContentScriptFailure = partial_arg(MRTransform_NotifyBgOfContentScriptFailure, AllWrapper);
    var message_encode$4 = message_encode$1;
    var message_decode$4 = message_decode$1;
    var response_encode$4 = function response_encode$4(v) {
        return [
            "BgDidAckNotifyBgOfContentScriptResponseFailure"
        ];
    };
    var response_decode$4 = response_decode$1;
    var allMessage_encode$1 = message_encode$2;
    var allMessage_decode$1 = message_decode$2;
    var allResponse_encode$1 = response_encode$2;
    var allResponse_decode$1 = response_decode$2;
    var responseError_encode$1 = Decco.stringToJson;
    var responseError_decode$1 = Decco.stringFromJson;
    var wrapMessageAsAllMessage$1 = function wrapMessageAsAllMessage$1(message) {
        return {
            TAG: /* Message_NotifyBgOfContentScriptResponseFailure */ 1,
            _0: message
        };
    };
    var unwrapAllResponseAsResponse$1 = function unwrapAllResponseAsResponse$1(allResponse) {
        if (allResponse.TAG === /* Response_NotifyBgOfContentScriptFailure */ 0) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
        } else {
            return allResponse._0;
        }
    };
    var wrapResponseAsAllResponse$1 = function wrapResponseAsAllResponse$1(response) {
        return {
            TAG: /* Response_NotifyBgOfContentScriptResponseFailure */ 1,
            _0: response
        };
    };
    var MRTransform_NotifyBgOfContentScriptResponseFailure = {
        message_encode: message_encode$4,
        message_decode: message_decode$4,
        response_encode: response_encode$4,
        response_decode: response_decode$4,
        allMessage_encode: allMessage_encode$1,
        allMessage_decode: allMessage_decode$1,
        allResponse_encode: allResponse_encode$1,
        allResponse_decode: allResponse_decode$1,
        responseError_encode: responseError_encode$1,
        responseError_decode: responseError_decode$1,
        wrapMessageAsAllMessage: wrapMessageAsAllMessage$1,
        unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$1,
        wrapResponseAsAllResponse: wrapResponseAsAllResponse$1
    };
    var partial_arg$1 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;
    var NotifyBgOfContentScriptResponseFailure = partial_arg$1(MRTransform_NotifyBgOfContentScriptResponseFailure, AllWrapper);
    var message_encode$5 = message_encode$2;
    var message_decode$5 = message_decode$2;
    var response_encode$5 = response_encode$2;
    var response_decode$5 = response_decode$2;
    var All = {
        message_encode: message_encode$5,
        message_decode: message_decode$5,
        response_encode: response_encode$5,
        response_decode: response_decode$5
    };
    return {
        MR_NotifyBgOfContentScriptFailure: MR_NotifyBgOfContentScriptFailure,
        MR_NotifyBgOfContentScriptResponseFailure: MR_NotifyBgOfContentScriptResponseFailure,
        MR_All: MR_All,
        MRTransform_NotifyBgOfContentScriptFailure: MRTransform_NotifyBgOfContentScriptFailure,
        NotifyBgOfContentScriptFailure: NotifyBgOfContentScriptFailure,
        MRTransform_NotifyBgOfContentScriptResponseFailure: MRTransform_NotifyBgOfContentScriptResponseFailure,
        NotifyBgOfContentScriptResponseFailure: NotifyBgOfContentScriptResponseFailure,
        All: All
    };
}
exports.AllWrapper = AllWrapper;
exports.Make = Make; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 50924:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Js_math = __webpack_require__(84763);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_MapInt = __webpack_require__(91094);
var Belt_Option = __webpack_require__(46517);
var Belt_Result = __webpack_require__(86369);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function initError_encode(v) {
    return [
        "CannotInitWithEmptyCommands"
    ];
}
function initError_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "CannotInitWithEmptyCommands") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* CannotInitWithEmptyCommands */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyInitError(initError) {
    return "CannotInitWithEmptyCommands";
}
function rewindError_encode(v) {
    if (v) {
        return [
            "CannotRewindBecauseIndexOutOfBounds",
            Decco.intToJson(v._0)
        ];
    } else {
        return [
            "CannotRewindBecauseMaxRetriesReached"
        ];
    }
}
function rewindError_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CannotRewindBecauseIndexOutOfBounds":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CannotRewindBecauseIndexOutOfBounds */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CannotRewindBecauseMaxRetriesReached":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CannotRewindBecauseMaxRetriesReached */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyRewindError(rewindError) {
    if (rewindError) {
        return "CannotRewindBecauseIndexOutOfBounds(" + (String(rewindError._0) + ")");
    } else {
        return "CannotRewindBecauseMaxRetriesReached";
    }
}
function Make(CommandModule) {
    var command_encode = function command_encode(v) {
        return Curry._1(CommandModule.command_encode, v);
    };
    var command_decode = function command_decode(v) {
        return Curry._1(CommandModule.command_decode, v);
    };
    var t_encode = function t_encode(v) {
        return Js_dict.fromArray([
            [
                "frameId",
                Decco.intToJson(v.frameId)
            ],
            [
                "commands",
                Decco.arrayToJson(command_encode, v.commands)
            ],
            [
                "currentCommandIndex",
                Decco.intToJson(v.currentCommandIndex)
            ],
            [
                "commandRetriesByCommandIndex",
                CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(Decco.intToJson, v.commandRetriesByCommandIndex)
            ]
        ]);
    };
    var t_decode = function t_decode(v) {
        var dict = Js_json.classify(v);
        if (typeof dict === "number") {
            return Decco.error(undefined, "Not an object", v);
        }
        if (dict.TAG !== /* JSONObject */ 2) {
            return Decco.error(undefined, "Not an object", v);
        }
        var dict$1 = dict._0;
        var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
        if (frameId.TAG === /* Ok */ 0) {
            var commands = Decco.arrayFromJson(command_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commands"), null));
            if (commands.TAG === /* Ok */ 0) {
                var currentCommandIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentCommandIndex"), null));
                if (currentCommandIndex.TAG === /* Ok */ 0) {
                    var commandRetriesByCommandIndex = CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandRetriesByCommandIndex"), null));
                    if (commandRetriesByCommandIndex.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                frameId: frameId._0,
                                commands: commands._0,
                                currentCommandIndex: currentCommandIndex._0,
                                commandRetriesByCommandIndex: commandRetriesByCommandIndex._0
                            }
                        };
                    }
                    var e = commandRetriesByCommandIndex._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".commandRetriesByCommandIndex" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = currentCommandIndex._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".currentCommandIndex" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = commands._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".commands" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = frameId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".frameId" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    };
    var init = function init(frameId, commands) {
        if (commands.length !== 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    frameId: frameId,
                    commands: commands,
                    currentCommandIndex: 0,
                    commandRetriesByCommandIndex: undefined
                }
            };
        } else {
            return {
                TAG: /* Error */ 1,
                _0: /* CannotInitWithEmptyCommands */ 0
            };
        }
    };
    var frameId1 = function frameId1(param) {
        return param.frameId;
    };
    var currentCommandIndex1 = function currentCommandIndex1(param) {
        return param.currentCommandIndex;
    };
    var currentCommand = function currentCommand(param) {
        return Belt_Array.getExn(param.commands, param.currentCommandIndex);
    };
    var remainingCommands = function remainingCommands(param) {
        return Belt_Array.sliceToEnd(param.commands, param.currentCommandIndex + 1 | 0);
    };
    var completedCommandsReversed = function completedCommandsReversed(param) {
        return Belt_Array.reverse(Belt_Array.slice(param.commands, 0, param.currentCommandIndex));
    };
    var updateCurrentCommand = function updateCurrentCommand(frame, f) {
        var currentCommandIndex = frame.currentCommandIndex;
        var commands = frame.commands;
        return {
            frameId: frame.frameId,
            commands: ArrayUtils$SmartcutsMacros.replaceAtIndex(commands, currentCommandIndex, Curry._1(f, Belt_Array.getExn(commands, currentCommandIndex))),
            currentCommandIndex: frame.currentCommandIndex,
            commandRetriesByCommandIndex: frame.commandRetriesByCommandIndex
        };
    };
    var updateRemainingCommands = function updateRemainingCommands(frame, f) {
        var match = ArrayUtils$SmartcutsMacros.splitAtIndex(frame.commands, frame.currentCommandIndex + 1 | 0);
        return {
            frameId: frame.frameId,
            commands: Belt_Array.concat(match[0], Curry._1(f, match[1])),
            currentCommandIndex: frame.currentCommandIndex,
            commandRetriesByCommandIndex: frame.commandRetriesByCommandIndex
        };
    };
    var getRetriesForCommandIndex = function getRetriesForCommandIndex(param, commandIndex) {
        var arg = Belt_MapInt.get(param.commandRetriesByCommandIndex, commandIndex);
        var param$1 = 0;
        return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
    };
    var indexesOfCommandAffectedByRewinding = function indexesOfCommandAffectedByRewinding(currentCommandIndex, rewindToCommandIndex) {
        return Belt_Array.slice(Belt_Array.mapWithIndex(Caml_array.make(currentCommandIndex, undefined), function(index, param) {
            return index;
        }), rewindToCommandIndex, (currentCommandIndex + 1 | 0) - rewindToCommandIndex | 0);
    };
    var canRewindToCommandIndexAndRetry = function canRewindToCommandIndexAndRetry(frame, rewindToCommandIndex) {
        var currentCommandIndex = frame.currentCommandIndex;
        if (rewindToCommandIndex >= 0 && rewindToCommandIndex < currentCommandIndex) {
            return Belt_Array.every(indexesOfCommandAffectedByRewinding(currentCommandIndex, rewindToCommandIndex), function(commandIndex) {
                return getRetriesForCommandIndex(frame, commandIndex) <= CommandModule.maxRetries;
            });
        } else {
            return false;
        }
    };
    var waitForMillisBeforeRewind = function waitForMillisBeforeRewind(frame) {
        return Js_math.ceil(CommandModule.baseWaitForMillis * Math.pow(2.0, getRetriesForCommandIndex(frame, frame.currentCommandIndex)));
    };
    var advance = function advance(param) {
        var commands = param.commands;
        var nextCommandIndex = param.currentCommandIndex + 1 | 0;
        var _nextCommand = Belt_Array.get(commands, nextCommandIndex);
        if (_nextCommand !== undefined) {
            return /* DidAdvanceCursorToNextCommand */ {
                _0: {
                    frameId: param.frameId,
                    commands: commands,
                    currentCommandIndex: nextCommandIndex,
                    commandRetriesByCommandIndex: param.commandRetriesByCommandIndex
                }
            };
        } else {
            return /* CompletedAllCommandsInFrame */ 0;
        }
    };
    var rewindToCommandIndex1 = function rewindToCommandIndex1(frame, rewindToCommandIndex$1, resetCommandState) {
        var currentCommandIndex = frame.currentCommandIndex;
        if (rewindToCommandIndex$1 >= currentCommandIndex || rewindToCommandIndex$1 < 0) {
            return {
                TAG: /* Error */ 1,
                _0: /* CannotRewindBecauseIndexOutOfBounds */ {
                    _0: rewindToCommandIndex$1
                }
            };
        }
        var commands = frame.commands;
        var commandsResetState = Belt_Array.concat(Belt_Array.concat(Belt_Array.slice(commands, 0, rewindToCommandIndex$1), Belt_Array.map(Belt_Array.slice(commands, rewindToCommandIndex$1, (currentCommandIndex + 1 | 0) - rewindToCommandIndex$1 | 0), resetCommandState)), Belt_Array.sliceToEnd(commands, currentCommandIndex + 1 | 0));
        return {
            TAG: /* Ok */ 0,
            _0: {
                frameId: frame.frameId,
                commands: commandsResetState,
                currentCommandIndex: rewindToCommandIndex$1,
                commandRetriesByCommandIndex: Belt_Array.reduce(indexesOfCommandAffectedByRewinding(currentCommandIndex, rewindToCommandIndex$1), frame.commandRetriesByCommandIndex, function(commandRetriesByCommandIndex, commandIndex) {
                    return Belt_MapInt.set(commandRetriesByCommandIndex, commandIndex, getRetriesForCommandIndex(frame, commandIndex) + 1 | 0);
                })
            }
        };
    };
    var t_encode$1 = function t_encode$1(v) {
        return Decco.listToJson(command_encode, v);
    };
    var t_decode$1 = function t_decode$1(v) {
        return Decco.listFromJson(command_decode, v);
    };
    var completedCommandsReversed$1 = $$Array.of_list;
    var t_encode$2 = function t_encode$2(v) {
        return Js_dict.fromArray([
            [
                "topFrames",
                Decco.arrayToJson(t_encode, v.topFrames)
            ],
            [
                "bottomFrame",
                t_encode(v.bottomFrame)
            ]
        ]);
    };
    var t_decode$2 = function t_decode$2(v) {
        var dict = Js_json.classify(v);
        if (typeof dict === "number") {
            return Decco.error(undefined, "Not an object", v);
        }
        if (dict.TAG !== /* JSONObject */ 2) {
            return Decco.error(undefined, "Not an object", v);
        }
        var dict$1 = dict._0;
        var topFrames = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "topFrames"), null));
        if (topFrames.TAG === /* Ok */ 0) {
            var bottomFrame = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bottomFrame"), null));
            if (bottomFrame.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        topFrames: topFrames._0,
                        bottomFrame: bottomFrame._0
                    }
                };
            }
            var e = bottomFrame._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".bottomFrame" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = topFrames._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".topFrames" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    };
    var push = function push(stack, content) {
        return {
            topFrames: Belt_Array.concat([
                content
            ], stack.topFrames),
            bottomFrame: stack.bottomFrame
        };
    };
    var pop = function pop(param) {
        var bottomFrame = param.bottomFrame;
        var topFrames = param.topFrames;
        var head = Belt_Array.get(topFrames, 0);
        if (head === undefined) {
            return {
                TAG: /* ReachedBottom */ 0,
                _0: bottomFrame
            };
        }
        var tail = Belt_Array.sliceToEnd(topFrames, 1);
        return {
            TAG: /* PoppedStack */ 1,
            _0: head,
            _1: {
                topFrames: tail,
                bottomFrame: bottomFrame
            }
        };
    };
    var replaceTop = function replaceTop(param, newTop) {
        var topFrames = param.topFrames;
        if (topFrames.length === 0) {
            return {
                topFrames: topFrames,
                bottomFrame: newTop
            };
        }
        var tail = Belt_Array.sliceToEnd(topFrames, 1);
        return {
            topFrames: Belt_Array.concat([
                newTop
            ], tail),
            bottomFrame: param.bottomFrame
        };
    };
    var t_encode$3 = function t_encode$3(v) {
        return Js_dict.fromArray([
            [
                "frames",
                t_encode$2(v.frames)
            ],
            [
                "history",
                Decco.listToJson(command_encode, v.history)
            ],
            [
                "nextFrameId",
                Decco.intToJson(v.nextFrameId)
            ]
        ]);
    };
    var t_decode$3 = function t_decode$3(v) {
        var dict = Js_json.classify(v);
        if (typeof dict === "number") {
            return Decco.error(undefined, "Not an object", v);
        }
        if (dict.TAG !== /* JSONObject */ 2) {
            return Decco.error(undefined, "Not an object", v);
        }
        var dict$1 = dict._0;
        var frames = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frames"), null));
        if (frames.TAG === /* Ok */ 0) {
            var history = Decco.listFromJson(command_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "history"), null));
            if (history.TAG === /* Ok */ 0) {
                var nextFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nextFrameId"), null));
                if (nextFrameId.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            frames: frames._0,
                            history: history._0,
                            nextFrameId: nextFrameId._0
                        }
                    };
                }
                var e = nextFrameId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".nextFrameId" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = history._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".history" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = frames._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".frames" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    };
    var fromInitError = function fromInitError(initError) {
        return /* CannotInitWithEmptyCommands */ 0;
    };
    var fromRewindError = function fromRewindError(rewindError) {
        if (rewindError) {
            return /* CannotRewindBecauseIndexOutOfBounds */ {
                _0: rewindError._0
            };
        } else {
            return /* CannotRewindBecauseMaxRetriesReached */ 1;
        }
    };
    var stringify = function stringify(error) {
        if (typeof error === "number") {
            if (error !== 0) {
                return "CannotRewindBecauseMaxRetriesReached";
            } else {
                return "CannotInitWithEmptyCommands";
            }
        } else {
            return "CannotRewindBecauseIndexOutOfBounds(" + (String(error._0) + ")");
        }
    };
    var init$1 = function init$1(commands) {
        var nextFrameId = 1;
        return Belt_Result.map(init(0, commands), function(bottomFrame) {
            var frames_topFrames = [];
            var frames = {
                topFrames: frames_topFrames,
                bottomFrame: bottomFrame
            };
            var commandStack = {
                frames: frames,
                history: /* [] */ 0,
                nextFrameId: nextFrameId
            };
            return /* CommandStackWithTopFrame */ {
                _0: commandStack,
                _1: bottomFrame
            };
        });
    };
    var getTopFrame = function getTopFrame(param) {
        var param$1 = param.frames;
        var head = Belt_Array.get(param$1.topFrames, 0);
        if (head !== undefined) {
            return head;
        } else {
            return param$1.bottomFrame;
        }
    };
    var getHistory = function getHistory(param) {
        return param.history;
    };
    var maybeLastCompletedCommand = function maybeLastCompletedCommand(commandStack) {
        return Belt_Array.get(completedCommandsReversed(getTopFrame(commandStack)), 0);
    };
    var updateTopFrame = function updateTopFrame(commandStack, f) {
        return {
            frames: replaceTop(commandStack.frames, Curry._1(f, getTopFrame(commandStack))),
            history: commandStack.history,
            nextFrameId: commandStack.nextFrameId
        };
    };
    var currentCommand$1 = function currentCommand$1(commandStack) {
        return currentCommand(getTopFrame(commandStack));
    };
    var currentCommandIndexInTopFrame = function currentCommandIndexInTopFrame(commandStack) {
        return currentCommandIndex1(getTopFrame(commandStack));
    };
    var updateCurrentCommand$1 = function updateCurrentCommand$1(stack, f) {
        return updateTopFrame(stack, function(topFrame) {
            return updateCurrentCommand(topFrame, f);
        });
    };
    var popTopFrame = function popTopFrame(stack) {
        var poppedFrame = pop(stack.frames);
        if (poppedFrame.TAG === /* ReachedBottom */ 0) {
            return {
                TAG: /* ReachedBottom */ 0,
                _0: poppedFrame._0
            };
        } else {
            return {
                TAG: /* PoppedStack */ 1,
                _0: poppedFrame._0,
                _1: {
                    frames: poppedFrame._1,
                    history: stack.history,
                    nextFrameId: stack.nextFrameId
                }
            };
        }
    };
    var pushNewFrameWithCommands = function pushNewFrameWithCommands(commandStack, commands) {
        var nextFrameId = commandStack.nextFrameId;
        var frames = commandStack.frames;
        return Belt_Result.map(init(nextFrameId, commands), function(newTopFrame) {
            var nextStack_frames = push(frames, newTopFrame);
            var nextStack_history = commandStack.history;
            var nextStack_nextFrameId = nextFrameId + 1 | 0;
            var nextStack = {
                frames: nextStack_frames,
                history: nextStack_history,
                nextFrameId: nextStack_nextFrameId
            };
            return /* CommandStackWithTopFrame */ {
                _0: nextStack,
                _1: newTopFrame
            };
        });
    };
    var onCompletedCommand = function onCompletedCommand(commandStack) {
        var topFrame = getTopFrame(commandStack);
        var completedCommand = currentCommand(topFrame);
        var withNewHistory = function withNewHistory(stack) {
            return {
                frames: stack.frames,
                history: Belt_List.add(stack.history, completedCommand),
                nextFrameId: stack.nextFrameId
            };
        };
        var nextTopFrame = advance(topFrame);
        if (nextTopFrame) {
            var nextTopFrame$1 = nextTopFrame._0;
            var nextCommand = currentCommand(nextTopFrame$1);
            var nextStack = withNewHistory(updateTopFrame(commandStack, function(_topFrame) {
                return nextTopFrame$1;
            }));
            return {
                TAG: /* MoveToNextCommandInFrame */ 0,
                _0: nextCommand,
                _1: nextStack
            };
        }
        var _poppedFrame = popTopFrame(commandStack);
        if (_poppedFrame.TAG === /* ReachedBottom */ 0) {
            return {
                TAG: /* CompletedAllCommands */ 2,
                _0: withNewHistory(commandStack)
            };
        }
        var nextStack$1 = withNewHistory(updateCurrentCommand$1(_poppedFrame._1, function(currentCommand) {
            var arg = Belt_Option.map(Curry._1(CommandModule.maybeCommandThatCanPushFrame, currentCommand), CommandModule.updateCurrentCommandAfterPoppingFrame);
            return OptionUtils$SmartcutsMacros.withDefault(currentCommand, arg);
        }));
        return {
            TAG: /* PopFrameAndMoveToNextCommand */ 1,
            _0: currentCommand(getTopFrame(nextStack$1)),
            _1: nextStack$1
        };
    };
    return {
        command_encode: command_encode,
        command_decode: command_decode,
        Frame: {
            t_encode: t_encode,
            t_decode: t_decode,
            frameId: frameId1,
            currentCommandIndex: currentCommandIndex1,
            currentCommand: currentCommand,
            remainingCommands: remainingCommands,
            completedCommandsReversed: completedCommandsReversed,
            updateCurrentCommand: updateCurrentCommand,
            updateRemainingCommands: updateRemainingCommands,
            canRewindToCommandIndexAndRetry: canRewindToCommandIndexAndRetry,
            waitForMillisBeforeRewind: waitForMillisBeforeRewind,
            rewindToCommandIndex: rewindToCommandIndex1
        },
        $$History: {
            t_encode: t_encode$1,
            t_decode: t_decode$1,
            completedCommandsReversed: completedCommandsReversed$1
        },
        t_encode: t_encode$3,
        t_decode: t_decode$3,
        $$Error: {
            stringify: stringify,
            fromInitError: fromInitError,
            fromRewindError: fromRewindError
        },
        init: init$1,
        getTopFrame: getTopFrame,
        getHistory: getHistory,
        maybeLastCompletedCommand: maybeLastCompletedCommand,
        currentCommand: currentCommand$1,
        currentCommandIndexInTopFrame: currentCommandIndexInTopFrame,
        updateTopFrame: updateTopFrame,
        updateCurrentCommand: updateCurrentCommand$1,
        pushNewFrameWithCommands: pushNewFrameWithCommands,
        onCompletedCommand: onCompletedCommand
    };
}
exports.initError_encode = initError_encode;
exports.initError_decode = initError_decode;
exports.stringifyInitError = stringifyInitError;
exports.rewindError_encode = rewindError_encode;
exports.rewindError_decode = rewindError_decode;
exports.stringifyRewindError = stringifyRewindError;
exports.Make = Make; /* CustomMap-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 97533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_MapInt = __webpack_require__(91094);
var Belt_Option = __webpack_require__(46517);
var Caml_format = __webpack_require__(63979);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var AppConfig$SmartcutsMacros = __webpack_require__(59730);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var LoginSmartcut$SmartcutsMacros = __webpack_require__(26553);
var OAuthProvider$SmartcutsMacros = __webpack_require__(86090);
var PlaybackValues$SmartcutsMacros = __webpack_require__(9154);
var UserCredential$SmartcutsMacros = __webpack_require__(98207);
var GoogleSheetHelpers$SmartcutsMacros = __webpack_require__(42828);
var PlaybackParamValue$SmartcutsMacros = __webpack_require__(32451);
var RadioOrSelectOption$SmartcutsMacros = __webpack_require__(48300);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
var GoogleApis__Sheets__Schema$SmartcutsMacros = __webpack_require__(11815);
var ExtensionMessaging__FromTab$SmartcutsMacros = __webpack_require__(44409);
var ContentScript__StateMachine__Shared$SmartcutsMacros = __webpack_require__(31166);
function setDataValidationRule(dataValidationRule, columnIndex, param1) {
    var arg = OptionUtils$SmartcutsMacros.withDefault([], param1.values);
    return {
        values: Curry._1((function(param2) {
            var func = function func(param$1, param$2, param$3) {
                return ArrayUtils$SmartcutsMacros.setAtIndexAndFillGap(param2, param$1, param$2, param$3);
            };
            return function(param3) {
                var func$1 = Curry._1(func, param3);
                return function(param) {
                    return Curry._2(func$1, param, arg);
                };
            };
        })(columnIndex)(GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(Caml_option.some(dataValidationRule), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)), GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))
    };
}
var Row_emptyRow = {
    values: undefined
};
var Row = {
    emptyRow: Row_emptyRow,
    setDataValidationRule: setDataValidationRule
};
function makeWorksheet(headers, rows) {
    return GoogleApis__Sheets__Schema$SmartcutsMacros.Sheet.make(undefined, undefined, undefined, undefined, undefined, [
        {
            columnMetadata: undefined,
            rowData: Belt_Array.concat([
                {
                    values: Belt_Array.map(headers, function(header1) {
                        return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.stringValue(header1), undefined);
                    })
                }
            ], rows),
            rowMetadata: undefined,
            startColumn: 0,
            startRow: 0
        }
    ], undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}
function askBgToCreateSheet(authToken, spreadsheetName, worksheet) {
    return Curry._2(ExtensionMessaging__FromTab$SmartcutsMacros.CreateGoogleSheet.encodeAndSendMessageToExtensionId, AppConfig$SmartcutsMacros.extensionId, /* CreateSpreadsheet */ {
        _0: {
            title: spreadsheetName,
            sheets: [
                worksheet
            ],
            authToken: authToken
        }
    });
}
function askExtensionToCreateAnySpreadsheetsForInstall(commandLog, smartcutName) {
    var spreadsheetNameAndColNamesAndCmdIndexBySheetId1 = Belt_List.reduceWithIndex(commandLog, undefined, function(spreadsheetNameAndColNamesAndCmdIndexBySheetId, param4, commandIndex) {
        var command = param4.command;
        var arg = OptionUtils$SmartcutsMacros.map(param4.contextGlobal.title, function(titleWithGoogleSuffix) {
            return titleWithGoogleSuffix.replace(/ - Google Sheets$/, "");
        });
        var spreadsheetName = function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }("Sheet for Smartcut: " + smartcutName);
        if (typeof command === "number") {
            return spreadsheetNameAndColNamesAndCmdIndexBySheetId;
        }
        if (command.TAG !== /* GoogleSheetsCommand */ 33) {
            return spreadsheetNameAndColNamesAndCmdIndexBySheetId;
        }
        var match = command._0;
        var colNames = match.colNames;
        return Belt_MapString.update(spreadsheetNameAndColNamesAndCmdIndexBySheetId, match.spreadsheetId, function(maybeLastSheetNameAndColNames) {
            if (maybeLastSheetNameAndColNames !== undefined) {
                return [
                    spreadsheetName,
                    Belt_Array.reduce(colNames, maybeLastSheetNameAndColNames[1], function(newColNames, colName) {
                        if ($$Array.mem(colName, newColNames)) {
                            return newColNames;
                        } else {
                            return $$Array.append(newColNames, [
                                colName
                            ]);
                        }
                    }),
                    maybeLastSheetNameAndColNames[2]
                ];
            } else {
                return [
                    spreadsheetName,
                    colNames,
                    commandIndex - 1 | 0
                ];
            }
        });
    });
    if (Belt_MapString.isEmpty(spreadsheetNameAndColNamesAndCmdIndexBySheetId1)) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: /* DoesNotInvolveGoogleSheets */ 1
        });
    } else {
        return ContentScript__StateMachine__Shared$SmartcutsMacros.askBgScriptToFetchAuthToken(AppConfig$SmartcutsMacros.extensionId, undefined).then(function(maybeAuthToken) {
            if (maybeAuthToken !== undefined) {
                return Promise.resolve(maybeAuthToken);
            } else {
                return Curry._2(ExtensionMessaging__FromTab$SmartcutsMacros.InitGoogleAuthFlow.encodeAndSendMessageToExtensionId, AppConfig$SmartcutsMacros.extensionId, /* InitGoogleAuthFlow */ {
                    _0: /* BeforeCreateSheetOnInstallSmartcut */ 4
                }).then(function(result) {
                    if (result.TAG === /* Ok */ 0) {
                        var authToken = result._0;
                        if (authToken) {
                            return Promise.resolve(authToken._0);
                        } else {
                            return Promise.resolve(undefined);
                        }
                    }
                    console.error(result._0);
                    return Promise.resolve(undefined);
                });
            }
        }).then(function(maybeAuthToken) {
            if (maybeAuthToken === undefined) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: /* DidNotCreateGoogleSheetBecauseOAuthNotGranted */ 2
                });
            }
            var promises = Belt_Array.map(Belt_MapString.valuesToArray(spreadsheetNameAndColNamesAndCmdIndexBySheetId1), function(param) {
                var firstCommandIndex = param[2];
                return askBgToCreateSheet(maybeAuthToken, param[0], makeWorksheet(param[1], [])).then(function(result) {
                    return Promise.resolve([
                        result,
                        firstCommandIndex
                    ]);
                });
            });
            return Promise.all(promises).then(function(results) {
                var result = Belt_Array.reduce(results, {
                    TAG: /* Ok */ 0,
                    _0: undefined
                }, function(resultSheetUrlByFirstCommandIndex, param) {
                    var resultFromExtension = param[0];
                    if (resultSheetUrlByFirstCommandIndex.TAG !== /* Ok */ 0) {
                        return resultSheetUrlByFirstCommandIndex;
                    }
                    if (resultFromExtension.TAG !== /* Ok */ 0) {
                        return {
                            TAG: /* Error */ 1,
                            _0: resultFromExtension._0
                        };
                    }
                    var match = resultFromExtension._0;
                    if (typeof match === "number") {
                        switch(match){
                            case /* DidNotCreateSpreadsheet */ 0:
                                return {
                                    TAG: /* Error */ 1,
                                    _0: "Smartcuts ran into an issue creating the Google Sheet involved in this automation"
                                };
                            case /* DidNotCreateSpreadsheetBecauseUnauthenticated */ 1:
                                return {
                                    TAG: /* Error */ 1,
                                    _0: "Smartcuts doesn't have access to create the Google Sheet involved in this automation"
                                };
                            case /* DidNotCreateSpreadsheetBecauseGapiNotLoaded */ 2:
                                return {
                                    TAG: /* Error */ 1,
                                    _0: "Reload your extension or restart Chrome. Smartcuts had issues accessing Google APIs."
                                };
                        }
                    } else {
                        var sheetUrl = match._0.spreadsheetUrl;
                        if (sheetUrl !== undefined) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: Belt_MapInt.set(resultSheetUrlByFirstCommandIndex._0, param[1], sheetUrl)
                            };
                        } else {
                            return {
                                TAG: /* Error */ 1,
                                _0: "Smartcuts ran into an issue creating the Google Sheet involved in this automation"
                            };
                        }
                    }
                });
                var tmp;
                tmp = result.TAG === /* Ok */ 0 ? {
                    TAG: /* Ok */ 0,
                    _0: /* DidCreateSheetsByFirstCommandIndex */ {
                        _0: result._0
                    }
                } : {
                    TAG: /* Error */ 1,
                    _0: result._0
                };
                return Promise.resolve(tmp);
            });
        });
    }
}
function textForRadioOrSelectOption(opt) {
    return RadioOrSelectOption$SmartcutsMacros.valueAndTextGet(opt)[1];
}
function header(column) {
    switch(column.TAG | 0){
        case /* OpenWebsiteURL */ 0:
            return "Website URL";
        case /* AddTextOption */ 1:
            return column.addTextInputParam.playbackFormLabel;
        case /* InnerTextOption */ 2:
            return column.innerTextParam.playbackFormLabel;
        case /* CheckboxOption */ 3:
            return column.checkboxParam.playbackFormLabel;
        case /* SelectInputOption */ 4:
            return column.selectInputParam.playbackFormLabel;
        case /* RadioInputOption */ 5:
            return column.radioInputParam.playbackFormLabel;
        case /* DownloadOption */ 6:
            return column.downloadParam.playbackFormLabel;
        case /* GoogleSheetsOption */ 7:
            var match = column.googleSheetsParam;
            if (match.TAG === /* UpdateCellParam */ 0) {
                return match._0.playbackFormLabel;
            } else {
                return match._0.playbackFormLabel;
            }
        case /* LoopOption */ 8:
            return "-";
        case /* UploadOption */ 9:
            return column.uploadParam.playbackFormLabel;
        case /* DestinationGoogleSheet */ 10:
            return "Destination Google Sheet";
        case /* PaginateOption */ 11:
            return "Paginate and load items";
        case /* LoginToWebsite */ 12:
            return "Replay on " + (URLUtils$SmartcutsMacros.extractDomainName(column._0) + " as user");
    }
}
function maybeDataValidation(userCredentials, column) {
    switch(column.TAG | 0){
        case /* SelectInputOption */ 4:
            return {
                condition: GoogleApis__Sheets__Schema$SmartcutsMacros.BooleanCondition.make("ONE_OF_LIST", Belt_Array.map(column.selectInputParam.originalLabeledValue.value.options, function(opt) {
                    return {
                        userEnteredValue: textForRadioOrSelectOption(opt)
                    };
                }), undefined),
                showCustomUi: true,
                strict: true
            };
        case /* LoginToWebsite */ 12:
            var hostname = column._0;
            var options = Belt_Array.map(Belt_Array.keep(userCredentials, function(userCredential) {
                return userCredential._0.hostname === hostname;
            }), function(userCredential) {
                if (userCredential.TAG === /* PasswordCredential */ 0) {
                    var match = userCredential._0;
                    return "" + match.username + " (" + match.id + ")";
                }
                var match$1 = userCredential._0;
                var friendlyName = match$1.username + (" OAuthed via " + OAuthProvider$SmartcutsMacros.stringify(match$1.oauthProvider));
                return "" + friendlyName + " (" + match$1.id + ")";
            });
            return {
                condition: GoogleApis__Sheets__Schema$SmartcutsMacros.BooleanCondition.make("ONE_OF_LIST", Belt_Array.map(options, function(value) {
                    return {
                        userEnteredValue: value
                    };
                }), undefined),
                showCustomUi: true,
                strict: true
            };
        default:
            return;
    }
}
var Column = {
    header: header,
    maybeDataValidation: maybeDataValidation
};
function columnsFromSmartcutParam(param) {
    var param$1 = param.param;
    var otherCommandIndexes = param.otherCommandIndexes;
    var firstCommandIndex = param.firstCommandIndex;
    switch(param$1.TAG | 0){
        case /* AddTextInputParam */ 0:
            return [
                {
                    TAG: /* AddTextOption */ 1,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    addTextInputParam: param$1._0
                }
            ];
        case /* InnerTextParam */ 1:
            return [
                {
                    TAG: /* InnerTextOption */ 2,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    innerTextParam: param$1._0
                }
            ];
        case /* CheckboxParam */ 2:
            return [
                {
                    TAG: /* CheckboxOption */ 3,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    checkboxParam: param$1._0
                }
            ];
        case /* SelectInputParam */ 3:
            return [
                {
                    TAG: /* SelectInputOption */ 4,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    selectInputParam: param$1._0
                }
            ];
        case /* RadioInputParam */ 4:
            return [
                {
                    TAG: /* RadioInputOption */ 5,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    radioInputParam: param$1._0
                }
            ];
        case /* URLParam */ 5:
            return [
                {
                    TAG: /* OpenWebsiteURL */ 0,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    urlParam: param$1._0
                }
            ];
        case /* DownloadParam */ 6:
            return [
                {
                    TAG: /* DownloadOption */ 6,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    downloadParam: param$1._0
                }
            ];
        case /* GoogleSheetsParam */ 7:
            return [
                {
                    TAG: /* GoogleSheetsOption */ 7,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    googleSheetsParam: param$1._0
                }
            ];
        case /* LoopParam */ 8:
            return [
                {
                    TAG: /* LoopOption */ 8,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    loopParam: param$1._0
                }
            ];
        case /* UploadParam */ 9:
            return [
                {
                    TAG: /* UploadOption */ 9,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    uploadParam: param$1._0
                }
            ];
        case /* WithElementGroupsParam */ 10:
            var withElementGroupsParam = param$1._0;
            return Belt_Array.concat(Belt_Array.mapWithIndex(withElementGroupsParam.actions, function(actionIndex, action) {
                return {
                    TAG: /* DestinationGoogleSheet */ 10,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    withElementGroupsParam: withElementGroupsParam,
                    actionIndex: actionIndex
                };
            }), [
                {
                    TAG: /* PaginateOption */ 11,
                    firstCommandIndex: firstCommandIndex,
                    otherCommandIndexes: otherCommandIndexes,
                    withElementGroupsParam: withElementGroupsParam
                }
            ]);
    }
}
function transformRowsToPlaybackValues(fromRowOpt, smartcutParams, loginSmartcuts, userCredentials, rows) {
    var fromRow = fromRowOpt !== undefined ? fromRowOpt : 1;
    var arg1 = Belt_Array.sliceToEnd(rows, fromRow);
    var param5 = function param5(rowIndex, rowData) {
        var arg2 = rowData.values;
        var values = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg2);
        }("Expected row to have values");
        if (Belt_Array.every(values, function(cellData) {
            var match = cellData.effectiveValue;
            if (match === undefined) {
                return true;
            }
            var match$1 = match.stringValue;
            if (match$1 !== undefined && match$1 !== "") {
                return false;
            } else {
                return true;
            }
        })) {
            return;
        }
        var loginToWebsites = Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.getHostnamesWithAtLeastOneLoginSmartcut, loginSmartcuts);
        var columns = Belt_Array.concat(ArrayUtils$SmartcutsMacros.flatMap(columnsFromSmartcutParam, smartcutParams), Belt_Array.map(loginToWebsites, function(hostname) {
            return {
                TAG: /* LoginToWebsite */ 12,
                _0: hostname
            };
        }));
        return Belt_Array.reduceWithIndex(Belt_Array.zip(columns, values), PlaybackValues$SmartcutsMacros.init(undefined), function(playbackValues, param7, columnIndex) {
            var cell = param7[1];
            var column = param7[0];
            switch(column.TAG | 0){
                case /* OpenWebsiteURL */ 0:
                    var match = column.urlParam;
                    var originalUrl = match.originalUrl;
                    var value1 = cell.formattedValue;
                    var url = value1 !== undefined && value1 !== "" ? value1 : originalUrl;
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                            TAG: /* URLParamValue */ 5,
                            _0: {
                                url: url,
                                urlCommandType: match.urlCommandType
                            }
                        }),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* AddTextOption */ 1:
                    var match$1 = column.addTextInputParam;
                    var originalLabeledAddText = match$1.originalLabeledAddText;
                    var text = cell.formattedValue;
                    var labeledAddTextInput = text !== undefined && text !== "" ? {
                        label: originalLabeledAddText.label,
                        addText: {
                            TAG: /* StaticText */ 0,
                            _0: text
                        }
                    } : originalLabeledAddText;
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                            TAG: /* AddTextInputParamValue */ 0,
                            _0: {
                                targetLocator: match$1.targetLocator,
                                labeledAddTextInput: labeledAddTextInput
                            }
                        }),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* InnerTextOption */ 2:
                    var defaultValue = column.innerTextParam.defaultValue;
                    var text$1 = cell.formattedValue;
                    var innerText = text$1 !== undefined && text$1 !== "" ? text$1 : defaultValue;
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                            TAG: /* InnerTextParamValue */ 1,
                            _0: innerText
                        }),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* CheckboxOption */ 3:
                    var arg = cell.formattedValue;
                    console.warn("Ignoring value = " + (function(param) {
                        return OptionUtils$SmartcutsMacros.stringify(param, arg);
                    }(function(value) {
                        return value;
                    }) + (" from (row=" + (String((fromRow + rowIndex | 0) + 1 | 0) + ("column=" + (String(columnIndex + 1 | 0) + ") because the param type is not supported: CheckboxParam"))))));
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, PlaybackParamValue$SmartcutsMacros.fromSmartcutParam({
                            TAG: /* CheckboxParam */ 2,
                            _0: column.checkboxParam
                        })),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* SelectInputOption */ 4:
                    var match$2 = column.selectInputParam;
                    var match$3 = match$2.originalLabeledValue;
                    var options = match$3.value.options;
                    var arg$1 = ArrayUtils$SmartcutsMacros.firstMatchi(function(opt) {
                        return Caml_obj.caml_equal(cell.formattedValue, textForRadioOrSelectOption(opt));
                    }, options);
                    var match$4 = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    }("Expect to get matching option");
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                            TAG: /* SelectInputParamValue */ 3,
                            _0: {
                                targetLocator: match$2.targetLocator,
                                labeledValue: {
                                    label: match$3.label,
                                    value: {
                                        options: options,
                                        selectedIndex: match$4[1]
                                    }
                                }
                            }
                        }),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* RadioInputOption */ 5:
                    var arg$2 = cell.formattedValue;
                    console.warn("Ignoring value = " + (function(param) {
                        return OptionUtils$SmartcutsMacros.stringify(param, arg$2);
                    }(function(value) {
                        return value;
                    }) + (" from (row=" + (String((fromRow + rowIndex | 0) + 1 | 0) + ("column=" + (String(columnIndex + 1 | 0) + ") because the param type is not supported: RadioInnputParam"))))));
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, PlaybackParamValue$SmartcutsMacros.fromSmartcutParam({
                            TAG: /* RadioInputParam */ 4,
                            _0: column.radioInputParam
                        })),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* DownloadOption */ 6:
                    var text$2 = cell.formattedValue;
                    var playbackParamValue = text$2 !== undefined && text$2 !== "" ? {
                        TAG: /* DownloadParamValue */ 6,
                        _0: /* CustomFilename */ {
                            _0: text$2
                        }
                    } : {
                        TAG: /* DownloadParamValue */ 6,
                        _0: /* DefaultFilename */ 0
                    };
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, playbackParamValue),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* GoogleSheetsOption */ 7:
                    var match$5 = column.googleSheetsParam;
                    var firstCommandIndex = column.firstCommandIndex;
                    if (match$5.TAG === /* UpdateCellParam */ 0) {
                        var match$6 = match$5._0;
                        var toValue = match$6.cellUpdate.toValue;
                        var text$3 = cell.formattedValue;
                        var valueToUpdateCellToForPlayback = text$3 !== undefined && text$3 !== "" ? {
                            TAG: /* Value */ 1,
                            _0: {
                                TAG: /* StaticText */ 0,
                                _0: text$3
                            }
                        } : toValue;
                        return {
                            smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex, {
                                TAG: /* GoogleSheetsParamValue */ 7,
                                _0: {
                                    TAG: /* UpdateCellParamValue */ 0,
                                    _0: {
                                        spreadsheetId: match$6.spreadsheetId,
                                        sheetName: match$6.sheetName,
                                        keyColumnIndex: match$6.keyColumnIndex,
                                        keyColumnValue: match$6.keyColumnValue,
                                        colNames: match$6.colNames,
                                        updatedColIndex: match$6.updatedColIndex,
                                        cellUpdate: valueToUpdateCellToForPlayback
                                    }
                                }
                            }),
                            credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                        };
                    }
                    var match$7 = match$5._0;
                    var keyColumnValue = match$7.keyColumnValue;
                    var keyColumnIndex = match$7.keyColumnIndex;
                    var text$4 = cell.formattedValue;
                    var keyColumnValueForPlayback = text$4 !== undefined && text$4 !== "" ? {
                        TAG: /* Value */ 1,
                        _0: {
                            TAG: /* StaticText */ 0,
                            _0: text$4
                        }
                    } : keyColumnValue;
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex, {
                            TAG: /* GoogleSheetsParamValue */ 7,
                            _0: {
                                TAG: /* UpsertRowParamValue */ 1,
                                _0: {
                                    spreadsheetId: match$7.spreadsheetId,
                                    sheetName: match$7.sheetName,
                                    keyColumnIndex: keyColumnIndex,
                                    keyColumnValue: keyColumnValueForPlayback,
                                    colNames: match$7.colNames,
                                    rowData: ArrayUtils$SmartcutsMacros.setWithoutFill(keyColumnIndex, keyColumnValueForPlayback, match$7.rowData)
                                }
                            }
                        }),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* LoopOption */ 8:
                    var arg$3 = cell.formattedValue;
                    console.warn("Ignoring value = " + (function(param) {
                        return OptionUtils$SmartcutsMacros.stringify(param, arg$3);
                    }(function(value) {
                        return value;
                    }) + (" from (row=" + (String((fromRow + rowIndex | 0) + 1 | 0) + ("column=" + (String(columnIndex + 1 | 0) + ") because the param type is not supported: LoopParam"))))));
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, PlaybackParamValue$SmartcutsMacros.fromSmartcutParam({
                            TAG: /* LoopParam */ 8,
                            _0: column.loopParam
                        })),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* UploadOption */ 9:
                    var arg$4 = cell.formattedValue;
                    var filePath = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$4);
                    }("Expect file path in cell");
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                            TAG: /* UploadParamValue */ 9,
                            _0: {
                                TAG: /* FileReference */ 1,
                                _0: {
                                    TAG: /* StaticText */ 0,
                                    _0: filePath
                                }
                            }
                        }),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* DestinationGoogleSheet */ 10:
                    var actionIndex = column.actionIndex;
                    var withElementGroupsParam = column.withElementGroupsParam;
                    var firstCommandIndex$1 = column.firstCommandIndex;
                    var arg$5 = Belt_Array.get(withElementGroupsParam.actions, actionIndex);
                    var match$8 = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$5);
                    }("Expect to get action by index");
                    var googleSheet = match$8._0;
                    var recordedGoogleSheet;
                    recordedGoogleSheet = googleSheet.TAG === /* ExistingGoogleSheet */ 0 ? googleSheet._0 : undefined;
                    var arg$6 = Belt_Option.flatMap(cell.formattedValue, function(spreadsheetUrl) {
                        return Belt_Option.map(GoogleSheetHelpers$SmartcutsMacros.maybeGetSpreadsheetIdFromUrl(spreadsheetUrl), function(spreadsheetId) {
                            return {
                                spreadsheetId: spreadsheetId,
                                spreadsheetName: WithElementGroupsCommand$SmartcutsMacros.unknownSpreadsheet,
                                spreadsheetUrl: spreadsheetUrl,
                                worksheetName: "Sheet1"
                            };
                        });
                    });
                    var arg$7 = function(param) {
                        return OptionUtils$SmartcutsMacros.orElse(param, arg$6);
                    }(recordedGoogleSheet);
                    var googleSheet$1 = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$7);
                    }("Expect to get destination sheet");
                    var arg$8 = Belt_Option.flatMap(Belt_MapInt.get(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex$1), function(paramValue) {
                        if (paramValue.TAG === /* WithElementGroupsParamValue */ 10) {
                            return paramValue._0;
                        }
                        console.warn("Expect WithElementGroupsParamValue");
                    });
                    var withElementGroupsParamValue = function(param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg$8);
                    }(WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(withElementGroupsParam));
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex$1, {
                            TAG: /* WithElementGroupsParamValue */ 10,
                            _0: {
                                actions: ArrayUtils$SmartcutsMacros.replaceAtIndex(withElementGroupsParamValue.actions, actionIndex, /* ExportTo */ {
                                    _0: {
                                        TAG: /* ExistingGoogleSheet */ 0,
                                        _0: googleSheet$1
                                    }
                                }),
                                paginateOptions: withElementGroupsParamValue.paginateOptions
                            }
                        }),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* PaginateOption */ 11:
                    var firstCommandIndex$2 = column.firstCommandIndex;
                    var value$1 = cell.formattedValue;
                    var loadItems = value$1 !== undefined ? /* NumberOfItems */ ({
                        _0: Caml_format.caml_int_of_string(value$1)
                    }) : /* ItemsOnFirstPage */ 0;
                    var arg$9 = Belt_Option.flatMap(Belt_MapInt.get(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex$2), function(paramValue) {
                        if (paramValue.TAG === /* WithElementGroupsParamValue */ 10) {
                            return paramValue._0;
                        }
                        console.warn("Expect WithElementGroupsParamValue");
                    });
                    var withElementGroupsParamValue$1 = function(param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg$9);
                    }(WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(column.withElementGroupsParam));
                    return {
                        smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex$2, {
                            TAG: /* WithElementGroupsParamValue */ 10,
                            _0: {
                                actions: withElementGroupsParamValue$1.actions,
                                paginateOptions: {
                                    paginateMethod: withElementGroupsParamValue$1.paginateOptions.paginateMethod,
                                    loadItems: loadItems
                                }
                            }
                        }),
                        credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                    };
                case /* LoginToWebsite */ 12:
                    var credentialIdRe = new RegExp("\\s\\((.+)\\)$");
                    var maybeCredential = Belt_Option.flatMap(Belt_Option.flatMap(cell.formattedValue, function(value) {
                        return Belt_Option.flatMap(Belt_Option.flatMap(Caml_option.null_to_opt(credentialIdRe.exec(value)), function(result) {
                            return Belt_Array.get(result, 1);
                        }), function(prim) {
                            if (prim == null) {
                                return;
                            } else {
                                return Caml_option.some(prim);
                            }
                        });
                    }), function(credentialId) {
                        return ArrayUtils$SmartcutsMacros.firstMatch(function(credential) {
                            return UserCredential$SmartcutsMacros.WithReEntryStatusAndOAuthProviderCredential.dbIdGet(credential) === credentialId;
                        }, userCredentials);
                    });
                    if (maybeCredential !== undefined) {
                        return {
                            smartcutParamValuesByCommandIndex: playbackValues.smartcutParamValuesByCommandIndex,
                            credentialDbIdsByHostname: Belt_MapString.set(playbackValues.credentialDbIdsByHostname, column._0, UserCredential$SmartcutsMacros.WithReEntryStatusAndOAuthProviderCredential.dbIdGet(maybeCredential))
                        };
                    } else {
                        console.warn("Did not find matching credential for cellvalue ", cell.formattedValue);
                        return playbackValues;
                    }
            }
        });
    };
    return ArrayUtils$SmartcutsMacros.filterMapi(param5, arg1);
}
exports.Row = Row;
exports.makeWorksheet = makeWorksheet;
exports.askBgToCreateSheet = askBgToCreateSheet;
exports.askExtensionToCreateAnySpreadsheetsForInstall = askExtensionToCreateAnySpreadsheetsForInstall;
exports.textForRadioOrSelectOption = textForRadioOrSelectOption;
exports.Column = Column;
exports.columnsFromSmartcutParam = columnsFromSmartcutParam;
exports.transformRowsToPlaybackValues = transformRowsToPlaybackValues; /* URLUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 79159:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Command$SmartcutsMacros = __webpack_require__(4290);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var LoopCommand$SmartcutsMacros = __webpack_require__(67259);
var ModifierKeys$SmartcutsMacros = __webpack_require__(94429);
var SwitchCommand$SmartcutsMacros = __webpack_require__(469);
var UploadCommand$SmartcutsMacros = __webpack_require__(68210);
var DownloadCommand$SmartcutsMacros = __webpack_require__(59170);
var PasswordCommand$SmartcutsMacros = __webpack_require__(9448);
var ContextMenuCommand$SmartcutsMacros = __webpack_require__(48662);
var ClickToOAuthCommand$SmartcutsMacros = __webpack_require__(57114);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
var ScreenshotToClipboardCommand$SmartcutsMacros = __webpack_require__(96617);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
var PasteImageInContentEditableCommand$SmartcutsMacros = __webpack_require__(93978);
function createStyledLogger(logger, css) {
    return function(s) {
        return Curry._2(logger.log2, "%c" + s, css);
    };
}
function createYellowLogger(logger) {
    return createStyledLogger(logger, "background: #222; color: #bada55");
}
function logCommandWithContextLocal(logger, commandWithContextLocal) {
    var command = commandWithContextLocal.command;
    if (typeof command === "number") {
        switch(command){
            case /* ReloadCommand */ 0:
                return Util$SmartcutsMacros.logAndRaiseJsError("reload command should be detected on server, not detected in client and sent to server");
            case /* ForwardCommand */ 1:
                return Curry._1(logger.log1, "Go forward");
            case /* BackCommand */ 2:
                return Curry._1(logger.log1, "Go back");
        }
    } else {
        switch(command.TAG | 0){
            case /* URLCommand */ 6:
                return Curry._2(logger.log2, "URL", command._0.url);
            case /* OpenedLinkCommand */ 7:
                var match = command._0;
                var maybeOpenerTab = match.maybeOpenerTab;
                return Curry._2(logger.logMany, "WaitForNav", {
                    hd: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(match.tabRef),
                    tl: {
                        hd: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.stringify(match.windowRef),
                        tl: {
                            hd: match.url,
                            tl: {
                                hd: maybeOpenerTab !== undefined ? InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(maybeOpenerTab) : "undefined",
                                tl: /* [] */ 0
                            }
                        }
                    }
                });
            case /* SubmitFormCommand */ 8:
                return Curry._2(logger.log2, "Post-form-submission navigation to URL", command._0.url);
            case /* SubmitFormRedirectCommand */ 9:
                return Curry._2(logger.log2, "Form Redirect to URL", command._0.url);
            case /* ClientRedirectCommand */ 10:
                return Curry._2(logger.log2, "Client Javascript Redirect to URL", command._0.url);
            case /* ServerRedirectCommand */ 11:
                return Curry._2(logger.log2, "Server Redirect to URL", command._0.url);
            case /* ClickCommand */ 12:
                var match$1 = command._0;
                var querySelectors = Selector$SmartcutsMacros.stringify(undefined, false, match$1.domElementIdentifierWithSelector.selector);
                return Curry._4(logger.log4, "Click - query selectors: ", querySelectors, "; modifier=", ModifierKeys$SmartcutsMacros.stringify(match$1.modifierKeys));
            case /* TypeCommand */ 15:
                var match$2 = command._0;
                var querySelectors$1 = Selector$SmartcutsMacros.stringify(undefined, false, match$2.domElementIdentifierWithSelector.selector);
                return Curry._4(logger.log4, "Typed: ", match$2.labeledTextInputValueDiff, " ; query selectors: ", querySelectors$1);
            case /* CheckboxCommand */ 16:
                return Curry._2(logger.log2, "Typed: ", command._0);
            case /* SelectCommand */ 17:
                var match$3 = command._0;
                var querySelectors$2 = Selector$SmartcutsMacros.stringify(undefined, false, match$3.domElementIdentifierWithSelector.selector);
                return Curry._4(logger.log4, "Typed: ", match$3.labeledSelectInputValue, " ; query selectors: ", querySelectors$2);
            case /* RadioCommand */ 18:
                var match$4 = command._0;
                var querySelectors$3 = Selector$SmartcutsMacros.stringify(undefined, false, match$4.domElementIdentifierWithSelector.selector);
                return Curry._4(logger.log4, "Typed: ", match$4.radioInputParam, " ; query selectors: ", querySelectors$3);
            case /* DownloadCommand */ 32:
                return Curry._1(logger.log1, Curry._1(DownloadCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
            case /* GoogleSheetsCommand */ 33:
                return Curry._1(logger.log1, Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
            case /* ContextMenuCommand */ 34:
                return Curry._1(logger.log1, Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
            case /* LoopCommand */ 35:
                return Curry._1(logger.log1, LoopCommand$SmartcutsMacros.CommandValue.stringify(command._0));
            case /* SwitchCommand */ 36:
                return Curry._1(logger.log1, SwitchCommand$SmartcutsMacros.CommandValue.stringify(Command$SmartcutsMacros.stringifyRecordingCommand, command._0));
            case /* ScreenshotToClipboardCommand */ 37:
                return Curry._1(logger.log1, Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
            case /* PasteImageInContentEditableCommand */ 38:
                return Curry._1(logger.log1, Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
            case /* PasswordCommand */ 39:
                return Curry._1(logger.log1, Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
            case /* ClickToOAuthCommand */ 40:
                return Curry._1(logger.log1, Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
            case /* UploadCommand */ 41:
                return Curry._1(logger.log1, Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
            case /* WithElementGroupsCommand */ 43:
                return Curry._1(logger.log1, Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, command._0));
            default:
                return;
        }
    }
}
exports.createStyledLogger = createStyledLogger;
exports.createYellowLogger = createYellowLogger;
exports.logCommandWithContextLocal = logCommandWithContextLocal; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 42798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_option = __webpack_require__(57175);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function Make(Collection) {
    var _$sideEffectGroup_encode = function _$sideEffectGroup_encode(encoder_sideEffect, v) {
        if (typeof v === "number") {
            return [
                "NoSideEffects"
            ];
        }
        switch(v.TAG | 0){
            case /* SingleSideEffect */ 0:
                return [
                    "SingleSideEffect",
                    Curry._1(encoder_sideEffect, v._0)
                ];
            case /* SerialSideEffects */ 1:
                return [
                    "SerialSideEffects",
                    Curry._2(Collection.t_encode, encoder_sideEffect, v._0)
                ];
            case /* ParallelSideEffects */ 2:
                return [
                    "ParallelSideEffects",
                    Curry._2(Collection.t_encode, encoder_sideEffect, v._0)
                ];
        }
    };
    var _$sideEffectGroup_decode = function _$sideEffectGroup_decode(decoder_sideEffect, v) {
        var jsonArr = Js_json.classify(v);
        if (typeof jsonArr === "number") {
            return Decco.error(undefined, "Not a variant", v);
        }
        if (jsonArr.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a variant", v);
        }
        var jsonArr$1 = jsonArr._0;
        if (jsonArr$1.length === 0) {
            return Decco.error(undefined, "Expected variant, found empty array", v);
        }
        var tagged = jsonArr$1.map(Js_json.classify);
        var match = Belt_Array.getExn(tagged, 0);
        if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
            switch(match._0){
                case "NoSideEffects":
                    if (tagged.length !== 1) {
                        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                    } else {
                        return {
                            TAG: /* Ok */ 0,
                            _0: /* NoSideEffects */ 0
                        };
                    }
                case "ParallelSideEffects":
                    if (tagged.length !== 2) {
                        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                    }
                    var v0 = Curry._2(Collection.t_decode, decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                    if (v0.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ParallelSideEffects */ 2,
                                _0: v0._0
                            }
                        };
                    }
                    var e = v0._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                case "SerialSideEffects":
                    if (tagged.length !== 2) {
                        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                    }
                    var v0$1 = Curry._2(Collection.t_decode, decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                    if (v0$1.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SerialSideEffects */ 1,
                                _0: v0$1._0
                            }
                        };
                    }
                    var e$1 = v0$1._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                case "SingleSideEffect":
                    if (tagged.length !== 2) {
                        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                    }
                    var v0$2 = Curry._1(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                    if (v0$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SingleSideEffect */ 0,
                                _0: v0$2._0
                            }
                        };
                    }
                    var e$2 = v0$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                default:
            }
        }
        return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
    };
    var stringify = function stringify(stringifySideEffect, sideEffectGroup) {
        if (typeof sideEffectGroup === "number") {
            return "NoSideEffects";
        }
        switch(sideEffectGroup.TAG | 0){
            case /* SingleSideEffect */ 0:
                return Curry._1(stringifySideEffect, sideEffectGroup._0);
            case /* SerialSideEffects */ 1:
                return "SerialSideEffects(" + (Curry._2(Collection.stringify, stringifySideEffect, sideEffectGroup._0) + ")");
            case /* ParallelSideEffects */ 2:
                return "ParallelSideEffects(" + (Curry._2(Collection.stringify, stringifySideEffect, sideEffectGroup._0) + ")");
        }
    };
    var _$map = function _$map(mapSideEffect, sideEffectGroup) {
        if (typeof sideEffectGroup === "number") {
            return /* NoSideEffects */ 0;
        }
        switch(sideEffectGroup.TAG | 0){
            case /* SingleSideEffect */ 0:
                return {
                    TAG: /* SingleSideEffect */ 0,
                    _0: Curry._1(mapSideEffect, sideEffectGroup._0)
                };
            case /* SerialSideEffects */ 1:
                return {
                    TAG: /* SerialSideEffects */ 1,
                    _0: Curry._2(Collection.map, mapSideEffect, sideEffectGroup._0)
                };
            case /* ParallelSideEffects */ 2:
                return {
                    TAG: /* ParallelSideEffects */ 2,
                    _0: Curry._2(Collection.map, mapSideEffect, sideEffectGroup._0)
                };
        }
    };
    var _$find_opt = function _$find_opt(predicate, sideEffectGroup) {
        if (typeof sideEffectGroup === "number") {
            return;
        }
        switch(sideEffectGroup.TAG | 0){
            case /* SingleSideEffect */ 0:
                var sideEffect = sideEffectGroup._0;
                if (Curry._1(predicate, sideEffect)) {
                    return Caml_option.some(sideEffect);
                } else {
                    return;
                }
            case /* SerialSideEffects */ 1:
            case /* ParallelSideEffects */ 2:
                return Curry._2(Collection.find_opt, predicate, sideEffectGroup._0);
        }
    };
    var _$isEmpty = function _$isEmpty(sideEffectGroup) {
        if (typeof sideEffectGroup === "number") {
            return false;
        }
        switch(sideEffectGroup.TAG | 0){
            case /* SingleSideEffect */ 0:
                return false;
            case /* SerialSideEffects */ 1:
            case /* ParallelSideEffects */ 2:
                return Curry._1(Collection.isEmpty, sideEffectGroup._0);
        }
    };
    var _$execute = function _$execute(execSideEffect, sideEffectGroup) {
        if (typeof sideEffectGroup === "number") {
            return Promise.resolve(undefined);
        }
        switch(sideEffectGroup.TAG | 0){
            case /* SingleSideEffect */ 0:
                return Curry._2(execSideEffect, function(sideEffect) {
                    return {
                        TAG: /* SingleSideEffect */ 0,
                        _0: sideEffect
                    };
                }, sideEffectGroup._0);
            case /* SerialSideEffects */ 1:
                return Curry._3(Collection.fold_left, function(promiseChain, sideEffect1) {
                    return promiseChain.then(function(param) {
                        return Curry._2(execSideEffect, function(sideEffect) {
                            return {
                                TAG: /* SerialSideEffects */ 1,
                                _0: Curry._1(Collection.make, sideEffect)
                            };
                        }, sideEffect1);
                    });
                }, Promise.resolve(undefined), sideEffectGroup._0);
            case /* ParallelSideEffects */ 2:
                return Promise.all($$Array.of_list(Curry._1(Collection.toList, Curry._2(Collection.map, Curry._1(execSideEffect, function(sideEffect) {
                    return {
                        TAG: /* ParallelSideEffects */ 2,
                        _0: Curry._1(Collection.make, sideEffect)
                    };
                }), sideEffectGroup._0)))).then(function(param) {
                    return Promise.resolve(undefined);
                });
        }
    };
    return {
        sideEffectGroup_encode: _$sideEffectGroup_encode,
        sideEffectGroup_decode: _$sideEffectGroup_decode,
        stringify: stringify,
        map: _$map,
        find_opt: _$find_opt,
        isEmpty: _$isEmpty,
        execute: _$execute
    };
}
function stringify1(stringifyElement, sideEffects) {
    return StringUtils$SmartcutsMacros.join(", ", List.map(stringifyElement, sideEffects));
}
function sideEffectGroup_encode(encoder_sideEffect, v) {
    if (typeof v === "number") {
        return [
            "NoSideEffects"
        ];
    }
    switch(v.TAG | 0){
        case /* SingleSideEffect */ 0:
            return [
                "SingleSideEffect",
                Curry._1(encoder_sideEffect, v._0)
            ];
        case /* SerialSideEffects */ 1:
            return [
                "SerialSideEffects",
                Decco.listToJson(encoder_sideEffect, v._0)
            ];
        case /* ParallelSideEffects */ 2:
            return [
                "ParallelSideEffects",
                Decco.listToJson(encoder_sideEffect, v._0)
            ];
    }
}
function sideEffectGroup_decode(decoder_sideEffect, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NoSideEffects":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoSideEffects */ 0
                    };
                }
            case "ParallelSideEffects":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ParallelSideEffects */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SerialSideEffects":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SerialSideEffects */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "SingleSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SingleSideEffect */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(stringifySideEffect, sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
        return "NoSideEffects";
    }
    switch(sideEffectGroup.TAG | 0){
        case /* SingleSideEffect */ 0:
            return Curry._1(stringifySideEffect, sideEffectGroup._0);
        case /* SerialSideEffects */ 1:
            return "SerialSideEffects(" + (stringify1(stringifySideEffect, sideEffectGroup._0) + ")");
        case /* ParallelSideEffects */ 2:
            return "ParallelSideEffects(" + (stringify1(stringifySideEffect, sideEffectGroup._0) + ")");
    }
}
function map(mapSideEffect, sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
        return /* NoSideEffects */ 0;
    }
    switch(sideEffectGroup.TAG | 0){
        case /* SingleSideEffect */ 0:
            return {
                TAG: /* SingleSideEffect */ 0,
                _0: Curry._1(mapSideEffect, sideEffectGroup._0)
            };
        case /* SerialSideEffects */ 1:
            return {
                TAG: /* SerialSideEffects */ 1,
                _0: List.map(mapSideEffect, sideEffectGroup._0)
            };
        case /* ParallelSideEffects */ 2:
            return {
                TAG: /* ParallelSideEffects */ 2,
                _0: List.map(mapSideEffect, sideEffectGroup._0)
            };
    }
}
function find_opt(predicate, sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
        return;
    }
    switch(sideEffectGroup.TAG | 0){
        case /* SingleSideEffect */ 0:
            var sideEffect = sideEffectGroup._0;
            if (Curry._1(predicate, sideEffect)) {
                return Caml_option.some(sideEffect);
            } else {
                return;
            }
        case /* SerialSideEffects */ 1:
        case /* ParallelSideEffects */ 2:
            return List.find_opt(predicate, sideEffectGroup._0);
    }
}
function isEmpty(sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
        return false;
    }
    switch(sideEffectGroup.TAG | 0){
        case /* SingleSideEffect */ 0:
            return false;
        case /* SerialSideEffects */ 1:
        case /* ParallelSideEffects */ 2:
            return List.length(sideEffectGroup._0) === 0;
    }
}
function execute(execSideEffect, sideEffectGroup) {
    if (typeof sideEffectGroup === "number") {
        return Promise.resolve(undefined);
    }
    switch(sideEffectGroup.TAG | 0){
        case /* SingleSideEffect */ 0:
            return Curry._2(execSideEffect, function(sideEffect) {
                return {
                    TAG: /* SingleSideEffect */ 0,
                    _0: sideEffect
                };
            }, sideEffectGroup._0);
        case /* SerialSideEffects */ 1:
            return List.fold_left(function(promiseChain, sideEffect2) {
                return promiseChain.then(function(param) {
                    return Curry._2(execSideEffect, function(sideEffect) {
                        return {
                            TAG: /* SerialSideEffects */ 1,
                            _0: {
                                hd: sideEffect,
                                tl: /* [] */ 0
                            }
                        };
                    }, sideEffect2);
                });
            }, Promise.resolve(undefined), sideEffectGroup._0);
        case /* ParallelSideEffects */ 2:
            return Promise.all($$Array.of_list(List.map(Curry._1(execSideEffect, function(sideEffect) {
                return {
                    TAG: /* ParallelSideEffects */ 2,
                    _0: {
                        hd: sideEffect,
                        tl: /* [] */ 0
                    }
                };
            }), sideEffectGroup._0))).then(function(param) {
                return Promise.resolve(undefined);
            });
    }
}
var List$1 = {
    sideEffectGroup_encode: sideEffectGroup_encode,
    sideEffectGroup_decode: sideEffectGroup_decode,
    stringify: stringify$1,
    map: map,
    find_opt: find_opt,
    isEmpty: isEmpty,
    execute: execute
};
exports.Make = Make;
exports.List = List$1; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 97258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Smartcut$SmartcutsMacros = __webpack_require__(95418);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var CommandLog$SmartcutsMacros = __webpack_require__(23831);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var LoginSmartcut$SmartcutsMacros = __webpack_require__(26553);
var PlaybackValues$SmartcutsMacros = __webpack_require__(9154);
var PlaybackOptions$SmartcutsMacros = __webpack_require__(84094);
var PlaybackTrigger$SmartcutsMacros = __webpack_require__(82528);
var BgFx__GoogleSheet$SmartcutsMacros = __webpack_require__(80190);
var Browser__Identity$SmartcutsMacros = __webpack_require__(60051);
var ExtensionMessaging$SmartcutsMacros = __webpack_require__(31052);
var GoogleSheetHelpers$SmartcutsMacros = __webpack_require__(42828);
var ContentScript__StateMachine__Types$SmartcutsMacros = __webpack_require__(65595);
function viewable_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "GoogleSheet":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.optionFromJson(Decco.intFromJson, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* GoogleSheet */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ListOfPlaybackValues":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = PlaybackValues$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.listFromJson(PlaybackValues$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ListOfPlaybackValues */ 0,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function viewable_encode(v) {
    if (v.TAG === /* ListOfPlaybackValues */ 0) {
        return [
            "ListOfPlaybackValues",
            PlaybackValues$SmartcutsMacros.t_encode(v._0),
            Decco.listToJson(PlaybackValues$SmartcutsMacros.t_encode, v._1)
        ];
    } else {
        return [
            "GoogleSheet",
            Decco.stringToJson(v._0),
            Decco.optionToJson(Decco.intToJson, v._1)
        ];
    }
}
function stringify(v) {
    if (v.TAG === /* ListOfPlaybackValues */ 0) {
        return "ListOfPlaybackValues([size=" + (String(List.length(v._1) + 1 | 0) + "])");
    } else {
        return "GoogleSheet(" + (v._0 + (", firstNRows=" + (OptionUtils$SmartcutsMacros.stringify(function(prim) {
            return String(prim);
        }, v._1) + ")")));
    }
}
function onlyFirstNExecutions(nExecutions, batchData) {
    if (batchData.TAG === /* ListOfPlaybackValues */ 0) {
        return {
            TAG: /* ListOfPlaybackValues */ 0,
            _0: batchData._0,
            _1: ListUtils$SmartcutsMacros.take(nExecutions - 1 | 0, batchData._1)
        };
    } else {
        return {
            TAG: /* GoogleSheet */ 1,
            _0: batchData._0,
            _1: nExecutions
        };
    }
}
function size(batchData) {
    if (batchData.TAG === /* ListOfPlaybackValues */ 0) {
        return Promise.resolve(List.length(batchData._1) + 1 | 0);
    }
    var maybeOnlyFirstNRows = batchData._1;
    var spreadsheetId = batchData._0;
    return Browser__Identity$SmartcutsMacros.getAuthToken(true, true, undefined, undefined, undefined).then(function(maybeAccessToken) {
        var accessToken = OptionUtils$SmartcutsMacros.withDefault("Expected access token", maybeAccessToken);
        return GoogleSheetHelpers$SmartcutsMacros.loadClientButReloadExtensionIfGapiIsNotDefined(undefined).then(function(client) {
            return GoogleSheetHelpers$SmartcutsMacros.getSpreadsheetSize_withEdgeCaseHandling(spreadsheetId, accessToken, maybeOnlyFirstNRows, client);
        });
    });
}
function fromPlaybackValuesArray(msgOpt, playbackValuesArray) {
    var msg = msgOpt !== undefined ? msgOpt : "Expected playbackValues to have at least 1 entry";
    var match = ArrayUtils$SmartcutsMacros.splitAtFirstExn(msg, playbackValuesArray);
    return {
        TAG: /* ListOfPlaybackValues */ 0,
        _0: match[0],
        _1: $$Array.to_list(match[1])
    };
}
function listOfPlaybackValues(firstPlaybackData, subsequentPlaybackData) {
    return {
        TAG: /* ListOfPlaybackValues */ 0,
        _0: firstPlaybackData,
        _1: subsequentPlaybackData
    };
}
function googleSheet(firstNRows, spreadsheetId) {
    return {
        TAG: /* GoogleSheet */ 1,
        _0: spreadsheetId,
        _1: firstNRows
    };
}
function getPlaybackValues(batchData, smartcutParams, loginSmartcuts, userCredentials) {
    if (batchData.TAG === /* ListOfPlaybackValues */ 0) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: List.append({
                hd: batchData._0,
                tl: /* [] */ 0
            }, batchData._1)
        });
    } else {
        return BgFx__GoogleSheet$SmartcutsMacros.fetchRowsAndTransformToPlaybackData(smartcutParams, loginSmartcuts, userCredentials, batchData._0).then(function(result) {
            var tmp;
            tmp = result.TAG === /* Ok */ 0 ? {
                TAG: /* Ok */ 0,
                _0: $$Array.to_list(result._0)
            } : {
                TAG: /* Error */ 1,
                _0: result._0
            };
            return Promise.resolve(tmp);
        });
    }
}
function view(batchData) {
    return batchData;
}
function viewable_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var executionSetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "executionSetId"), null));
    if (executionSetId.TAG === /* Ok */ 0) {
        var loadedSmartcut = Smartcut$SmartcutsMacros.LoadedSmartcut.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loadedSmartcut"), null));
        if (loadedSmartcut.TAG === /* Ok */ 0) {
            var userSpecifiedPlaybackOptions = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "userSpecifiedPlaybackOptions"), null));
            if (userSpecifiedPlaybackOptions.TAG === /* Ok */ 0) {
                var maybeSmartcutDefaultPlaybackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeSmartcutDefaultPlaybackOptions"), null));
                if (maybeSmartcutDefaultPlaybackOptions.TAG === /* Ok */ 0) {
                    var startContext = PlaybackOptions$SmartcutsMacros.StartContext.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startContext"), null));
                    if (startContext.TAG === /* Ok */ 0) {
                        var commandLog = CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLog"), null));
                        if (commandLog.TAG === /* Ok */ 0) {
                            var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
                            if (trigger.TAG === /* Ok */ 0) {
                                var batchData = viewable_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "batchData"), null));
                                if (batchData.TAG === /* Ok */ 0) {
                                    var respondToPopup = Decco.optionFromJson(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.respondToSender_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "respondToPopup"), null));
                                    if (respondToPopup.TAG === /* Ok */ 0) {
                                        var rejectToPopup = Decco.optionFromJson(ExtensionMessaging$SmartcutsMacros.rejectToTab_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rejectToPopup"), null));
                                        if (rejectToPopup.TAG === /* Ok */ 0) {
                                            var removeRenderedContentOnTab = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "removeRenderedContentOnTab"), null));
                                            if (removeRenderedContentOnTab.TAG === /* Ok */ 0) {
                                                var smartcutName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutName"), null));
                                                if (smartcutName.TAG === /* Ok */ 0) {
                                                    var origins = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "origins"), null));
                                                    if (origins.TAG === /* Ok */ 0) {
                                                        var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                                                        if (visibility.TAG === /* Ok */ 0) {
                                                            var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
                                                            if (numParams.TAG === /* Ok */ 0) {
                                                                var haveRequestedPermissions = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "haveRequestedPermissions"), null));
                                                                if (haveRequestedPermissions.TAG === /* Ok */ 0) {
                                                                    var loginUrls = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginUrls"), null));
                                                                    if (loginUrls.TAG === /* Ok */ 0) {
                                                                        return {
                                                                            TAG: /* Ok */ 0,
                                                                            _0: {
                                                                                executionSetId: executionSetId._0,
                                                                                loadedSmartcut: loadedSmartcut._0,
                                                                                userSpecifiedPlaybackOptions: userSpecifiedPlaybackOptions._0,
                                                                                maybeSmartcutDefaultPlaybackOptions: maybeSmartcutDefaultPlaybackOptions._0,
                                                                                startContext: startContext._0,
                                                                                commandLog: commandLog._0,
                                                                                trigger: trigger._0,
                                                                                batchData: batchData._0,
                                                                                respondToPopup: respondToPopup._0,
                                                                                rejectToPopup: rejectToPopup._0,
                                                                                removeRenderedContentOnTab: removeRenderedContentOnTab._0,
                                                                                smartcutName: smartcutName._0,
                                                                                origins: origins._0,
                                                                                visibility: visibility._0,
                                                                                numParams: numParams._0,
                                                                                haveRequestedPermissions: haveRequestedPermissions._0,
                                                                                loginUrls: loginUrls._0
                                                                            }
                                                                        };
                                                                    }
                                                                    var e = loginUrls._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".loginUrls" + e.path,
                                                                            message: e.message,
                                                                            value: e.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$1 = haveRequestedPermissions._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".haveRequestedPermissions" + e$1.path,
                                                                        message: e$1.message,
                                                                        value: e$1.value
                                                                    }
                                                                };
                                                            }
                                                            var e$2 = numParams._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".numParams" + e$2.path,
                                                                    message: e$2.message,
                                                                    value: e$2.value
                                                                }
                                                            };
                                                        }
                                                        var e$3 = visibility._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".visibility" + e$3.path,
                                                                message: e$3.message,
                                                                value: e$3.value
                                                            }
                                                        };
                                                    }
                                                    var e$4 = origins._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".origins" + e$4.path,
                                                            message: e$4.message,
                                                            value: e$4.value
                                                        }
                                                    };
                                                }
                                                var e$5 = smartcutName._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".smartcutName" + e$5.path,
                                                        message: e$5.message,
                                                        value: e$5.value
                                                    }
                                                };
                                            }
                                            var e$6 = removeRenderedContentOnTab._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".removeRenderedContentOnTab" + e$6.path,
                                                    message: e$6.message,
                                                    value: e$6.value
                                                }
                                            };
                                        }
                                        var e$7 = rejectToPopup._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".rejectToPopup" + e$7.path,
                                                message: e$7.message,
                                                value: e$7.value
                                            }
                                        };
                                    }
                                    var e$8 = respondToPopup._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".respondToPopup" + e$8.path,
                                            message: e$8.message,
                                            value: e$8.value
                                        }
                                    };
                                }
                                var e$9 = batchData._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".batchData" + e$9.path,
                                        message: e$9.message,
                                        value: e$9.value
                                    }
                                };
                            }
                            var e$10 = trigger._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".trigger" + e$10.path,
                                    message: e$10.message,
                                    value: e$10.value
                                }
                            };
                        }
                        var e$11 = commandLog._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".commandLog" + e$11.path,
                                message: e$11.message,
                                value: e$11.value
                            }
                        };
                    }
                    var e$12 = startContext._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".startContext" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                        }
                    };
                }
                var e$13 = maybeSmartcutDefaultPlaybackOptions._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".maybeSmartcutDefaultPlaybackOptions" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            }
            var e$14 = userSpecifiedPlaybackOptions._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".userSpecifiedPlaybackOptions" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                }
            };
        }
        var e$15 = loadedSmartcut._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".loadedSmartcut" + e$15.path,
                message: e$15.message,
                value: e$15.value
            }
        };
    }
    var e$16 = executionSetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".executionSetId" + e$16.path,
            message: e$16.message,
            value: e$16.value
        }
    };
}
function viewable_encode$1(v) {
    return Js_dict.fromArray([
        [
            "executionSetId",
            Decco.stringToJson(v.executionSetId)
        ],
        [
            "loadedSmartcut",
            Smartcut$SmartcutsMacros.LoadedSmartcut.t_encode(v.loadedSmartcut)
        ],
        [
            "userSpecifiedPlaybackOptions",
            PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v.userSpecifiedPlaybackOptions)
        ],
        [
            "maybeSmartcutDefaultPlaybackOptions",
            Decco.optionToJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_encode, v.maybeSmartcutDefaultPlaybackOptions)
        ],
        [
            "startContext",
            PlaybackOptions$SmartcutsMacros.StartContext.t_encode(v.startContext)
        ],
        [
            "commandLog",
            CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode(v.commandLog)
        ],
        [
            "trigger",
            PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
        ],
        [
            "batchData",
            viewable_encode(v.batchData)
        ],
        [
            "respondToPopup",
            Decco.optionToJson(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.respondToSender_encode, v.respondToPopup)
        ],
        [
            "rejectToPopup",
            Decco.optionToJson(ExtensionMessaging$SmartcutsMacros.rejectToTab_encode, v.rejectToPopup)
        ],
        [
            "removeRenderedContentOnTab",
            Decco.optionToJson(Decco.intToJson, v.removeRenderedContentOnTab)
        ],
        [
            "smartcutName",
            Decco.stringToJson(v.smartcutName)
        ],
        [
            "origins",
            Decco.arrayToJson(Decco.stringToJson, v.origins)
        ],
        [
            "visibility",
            Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
        ],
        [
            "numParams",
            Decco.intToJson(v.numParams)
        ],
        [
            "haveRequestedPermissions",
            Decco.boolToJson(v.haveRequestedPermissions)
        ],
        [
            "loginUrls",
            Decco.arrayToJson(Decco.stringToJson, v.loginUrls)
        ]
    ]);
}
var t_encode = viewable_encode$1;
var t_decode = viewable_decode$1;
function makeWithLoadedSmartcut(executionSetId, userSpecifiedPlaybackOptions, maybeSmartcutDefaultPlaybackOptions, startContext, commandLog, trigger, batchData, respondToPopup, rejectToPopup, removeRenderedContentOnTab, haveRequestedPermissionsOpt, loadedSmartcut) {
    var haveRequestedPermissions = haveRequestedPermissionsOpt !== undefined ? haveRequestedPermissionsOpt : false;
    var match = loadedSmartcut.smartcut;
    return {
        executionSetId: executionSetId,
        loadedSmartcut: loadedSmartcut,
        userSpecifiedPlaybackOptions: userSpecifiedPlaybackOptions,
        maybeSmartcutDefaultPlaybackOptions: maybeSmartcutDefaultPlaybackOptions,
        startContext: startContext,
        commandLog: commandLog,
        trigger: trigger,
        batchData: batchData,
        respondToPopup: respondToPopup,
        rejectToPopup: rejectToPopup,
        removeRenderedContentOnTab: removeRenderedContentOnTab,
        smartcutName: loadedSmartcut.name,
        origins: loadedSmartcut.origins,
        visibility: match.visibility,
        numParams: Smartcut$SmartcutsMacros.LoadedSmartcut.getNumParams(loadedSmartcut),
        haveRequestedPermissions: haveRequestedPermissions,
        loginUrls: match.loginUrls
    };
}
function view$1(startPlayback) {
    return startPlayback;
}
function onlyFirstNExecutions$1(nExecutions, startPlayback) {
    return {
        executionSetId: startPlayback.executionSetId,
        loadedSmartcut: startPlayback.loadedSmartcut,
        userSpecifiedPlaybackOptions: startPlayback.userSpecifiedPlaybackOptions,
        maybeSmartcutDefaultPlaybackOptions: startPlayback.maybeSmartcutDefaultPlaybackOptions,
        startContext: startPlayback.startContext,
        commandLog: startPlayback.commandLog,
        trigger: startPlayback.trigger,
        batchData: onlyFirstNExecutions(nExecutions, startPlayback.batchData),
        respondToPopup: startPlayback.respondToPopup,
        rejectToPopup: startPlayback.rejectToPopup,
        removeRenderedContentOnTab: startPlayback.removeRenderedContentOnTab,
        smartcutName: startPlayback.smartcutName,
        origins: startPlayback.origins,
        visibility: startPlayback.visibility,
        numParams: startPlayback.numParams,
        haveRequestedPermissions: startPlayback.haveRequestedPermissions,
        loginUrls: startPlayback.loginUrls
    };
}
function stringify$1(param) {
    return "{ executionSetId:" + (param.executionSetId + (", playbackOptions, startContext: " + (PlaybackOptions$SmartcutsMacros.StartContext.stringify(param.startContext) + (", commandLog, trigger: " + (PlaybackTrigger$SmartcutsMacros.stringify(param.trigger) + (", batchData: " + (stringify(param.batchData) + (", respondToPopup, rejectToPopup, removeRenderedContentOnTab, smartcutName: " + (param.smartcutName + (", origins: [" + (param.origins.join(", ") + ("], visibility:  " + (Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility) + (", numParams: " + (String(param.numParams) + " }")))))))))))))));
}
function minify(startPlayback) {
    return {
        executionSetId: startPlayback.executionSetId,
        loadedSmartcut: Smartcut$SmartcutsMacros.LoadedSmartcut.minify(startPlayback.loadedSmartcut),
        userSpecifiedPlaybackOptions: startPlayback.userSpecifiedPlaybackOptions,
        maybeSmartcutDefaultPlaybackOptions: startPlayback.maybeSmartcutDefaultPlaybackOptions,
        startContext: startPlayback.startContext,
        commandLog: CommandLog$SmartcutsMacros.GlobalForPlayback.minify(startPlayback.commandLog),
        trigger: startPlayback.trigger,
        batchData: startPlayback.batchData,
        respondToPopup: startPlayback.respondToPopup,
        rejectToPopup: startPlayback.rejectToPopup,
        removeRenderedContentOnTab: startPlayback.removeRenderedContentOnTab,
        smartcutName: startPlayback.smartcutName,
        origins: startPlayback.origins,
        visibility: startPlayback.visibility,
        numParams: startPlayback.numParams,
        haveRequestedPermissions: startPlayback.haveRequestedPermissions,
        loginUrls: startPlayback.loginUrls
    };
}
function executionSetIdGet(param) {
    return param.executionSetId;
}
function numExecutions(param) {
    return size(param.batchData);
}
function numCommands(param) {
    return List.length(param.commandLog);
}
function triggerGet(param) {
    return param.trigger;
}
function generatePlaybackOptions(param) {
    return PlaybackOptions$SmartcutsMacros.substituteInUserSpecifiedAndSmartcutDefaultOverrides(param.userSpecifiedPlaybackOptions, param.maybeSmartcutDefaultPlaybackOptions, param.startContext, param.loadedSmartcut.smartcut.msBeforeNextCommand, PlaybackOptions$SmartcutsMacros.defaultPlaybackOptions);
}
function determineInitialTab(param) {
    var startContext = param.startContext;
    if (startContext) {
        return startContext._0;
    }
}
function getTabIdOnWhichToRemoveRenderedContext(param) {
    return param.removeRenderedContentOnTab;
}
function loginSmartcutsGet(param) {
    return param.loadedSmartcut.smartcut.loginSmartcuts;
}
function doesNeedCredentials(startPlayback) {
    return !Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.isEmpty, loginSmartcutsGet(startPlayback));
}
function makeExecutionContext(startPlayback, executionId, firstPlaybackValues, subsequentPlaybackValues) {
    var match = startPlayback.loadedSmartcut;
    var match$1 = match.smartcut;
    var commandLogWithPlaybackParamValuesSubstitutedIn = PlaybackValues$SmartcutsMacros.substitutePlaybackValuesIntoCommandLog(startPlayback.commandLog, firstPlaybackValues);
    var sizeOfSet = 1 + List.length(subsequentPlaybackValues) | 0;
    return {
        installedSmartcutId: match.installedSmartcut.id,
        smartcutId: match$1.id,
        smartcutName: startPlayback.smartcutName,
        executionSetId: startPlayback.executionSetId,
        executionId: executionId,
        executionStatus: /* Running */ 0,
        commandLog: commandLogWithPlaybackParamValuesSubstitutedIn,
        playbackOptions: generatePlaybackOptions(startPlayback),
        userSpecifiedPlaybackOptions: startPlayback.userSpecifiedPlaybackOptions,
        numExpectedPlaybacks: sizeOfSet,
        numSucceeded: 0,
        numFailed: 0,
        numConsecutiveFailures: 0,
        subsequentPlaybackValues: subsequentPlaybackValues,
        trigger: startPlayback.trigger,
        windowRef: undefined,
        numParams: startPlayback.numParams,
        origins: startPlayback.origins,
        visibility: startPlayback.visibility,
        maybeMsBeforeCloseWindow: match$1.maybeMsBeforeCloseWindow,
        loginUrls: startPlayback.loginUrls,
        loginSmartcuts: match$1.loginSmartcuts,
        currCredentialDbIdsByHostname: firstPlaybackValues.credentialDbIdsByHostname,
        maybeLastUsedCredentialDbIdsByHostname: Caml_option.some(firstPlaybackValues.credentialDbIdsByHostname)
    };
}
function getPlaybackValues$1(param, userCredentials) {
    var match = param.loadedSmartcut;
    var smartcutParamsData = match.smartcutParamsData;
    if (smartcutParamsData.TAG === /* Decoded */ 0) {
        return getPlaybackValues(param.batchData, smartcutParamsData._0, match.smartcut.loginSmartcuts, userCredentials);
    } else {
        return Promise.resolve({
            TAG: /* Error */ 1,
            _0: {
                TAG: /* JsonDecodeArrayError */ 3,
                _0: smartcutParamsData._0
            }
        });
    }
}
function getExtensionMessagingCallbacks(param) {
    return [
        param.respondToPopup,
        param.rejectToPopup
    ];
}
function batchDataGet(param) {
    return param.batchData;
}
function setBatchData(startPlayback, batchData) {
    return {
        executionSetId: startPlayback.executionSetId,
        loadedSmartcut: startPlayback.loadedSmartcut,
        userSpecifiedPlaybackOptions: startPlayback.userSpecifiedPlaybackOptions,
        maybeSmartcutDefaultPlaybackOptions: startPlayback.maybeSmartcutDefaultPlaybackOptions,
        startContext: startPlayback.startContext,
        commandLog: startPlayback.commandLog,
        trigger: startPlayback.trigger,
        batchData: batchData,
        respondToPopup: startPlayback.respondToPopup,
        rejectToPopup: startPlayback.rejectToPopup,
        removeRenderedContentOnTab: startPlayback.removeRenderedContentOnTab,
        smartcutName: startPlayback.smartcutName,
        origins: startPlayback.origins,
        visibility: startPlayback.visibility,
        numParams: startPlayback.numParams,
        haveRequestedPermissions: startPlayback.haveRequestedPermissions,
        loginUrls: startPlayback.loginUrls
    };
}
var BatchData = {
    viewable_encode: viewable_encode,
    viewable_decode: viewable_decode,
    stringify: stringify,
    onlyFirstNExecutions: onlyFirstNExecutions,
    size: size,
    fromPlaybackValuesArray: fromPlaybackValuesArray,
    listOfPlaybackValues: listOfPlaybackValues,
    googleSheet: googleSheet,
    getPlaybackValues: getPlaybackValues,
    view: view
};
exports.BatchData = BatchData;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.viewable_encode = viewable_encode$1;
exports.viewable_decode = viewable_decode$1;
exports.makeWithLoadedSmartcut = makeWithLoadedSmartcut;
exports.view = view$1;
exports.stringify = stringify$1;
exports.minify = minify;
exports.executionSetIdGet = executionSetIdGet;
exports.onlyFirstNExecutions = onlyFirstNExecutions$1;
exports.numExecutions = numExecutions;
exports.numCommands = numCommands;
exports.triggerGet = triggerGet;
exports.determineInitialTab = determineInitialTab;
exports.getTabIdOnWhichToRemoveRenderedContext = getTabIdOnWhichToRemoveRenderedContext;
exports.loginSmartcutsGet = loginSmartcutsGet;
exports.doesNeedCredentials = doesNeedCredentials;
exports.makeExecutionContext = makeExecutionContext;
exports.getPlaybackValues = getPlaybackValues$1;
exports.getExtensionMessagingCallbacks = getExtensionMessagingCallbacks;
exports.batchDataGet = batchDataGet;
exports.setBatchData = setBatchData; /* Smartcut-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 9066:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Fetch = __webpack_require__(84403);
var Js_exn = __webpack_require__(82900);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var Caml_js_exceptions = __webpack_require__(74518);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Logger$SmartcutsMacros = __webpack_require__(79159);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var JsExnUtils$SmartcutsMacros = __webpack_require__(79713);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
function update_encode(encoder_state, encoder_sideEffect, v) {
    if (typeof v === "number") {
        return [
            "Ignore"
        ];
    }
    switch(v.TAG | 0){
        case /* Update */ 0:
            return [
                "Update",
                Curry._1(encoder_state, v._0)
            ];
        case /* SideEffects */ 1:
            return [
                "SideEffects",
                Decco.listToJson(encoder_sideEffect, v._0)
            ];
        case /* SerialSideEffects */ 2:
            return [
                "SerialSideEffects",
                Decco.listToJson(encoder_sideEffect, v._0)
            ];
        case /* UpdateWithSideEffects */ 3:
            return [
                "UpdateWithSideEffects",
                Curry._1(encoder_state, v._0),
                Decco.listToJson(encoder_sideEffect, v._1)
            ];
        case /* UpdateWithSerialSideEffects */ 4:
            return [
                "UpdateWithSerialSideEffects",
                Curry._1(encoder_state, v._0),
                Decco.listToJson(encoder_sideEffect, v._1)
            ];
    }
}
function update_decode(decoder_state, decoder_sideEffect, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Ignore":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Ignore */ 0
                    };
                }
            case "SerialSideEffects":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SerialSideEffects */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SideEffects":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SideEffects */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Update":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(decoder_state, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Update */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "UpdateWithSerialSideEffects":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Curry._1(decoder_state, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* UpdateWithSerialSideEffects */ 4,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$3 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "UpdateWithSideEffects":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Curry._1(decoder_state, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.listFromJson(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* UpdateWithSideEffects */ 3,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$5 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyUpdate(stringifyState, stringifySideEffect, update) {
    if (typeof update === "number") {
        return "Ignore";
    }
    switch(update.TAG | 0){
        case /* Update */ 0:
            return "Update(" + (Curry._1(stringifyState, update._0) + ")");
        case /* SideEffects */ 1:
            return "SideEffects([" + ($$String.concat(", ", List.map(stringifySideEffect, update._0)) + "])");
        case /* SerialSideEffects */ 2:
            return "SerialSideEffects([" + ($$String.concat(", ", List.map(stringifySideEffect, update._0)) + "])");
        case /* UpdateWithSideEffects */ 3:
            return "UpdateSideEffects(" + (Curry._1(stringifyState, update._0) + (", [" + ($$String.concat(", ", List.map(stringifySideEffect, update._1)) + "])")));
        case /* UpdateWithSerialSideEffects */ 4:
            return "UpdateSerialSideEffects(" + (Curry._1(stringifyState, update._0) + (", [" + ($$String.concat(", ", List.map(stringifySideEffect, update._1)) + "])")));
    }
}
function eventSource_encode(encoder_listener, encoder_sideEffect, v) {
    if (typeof v === "number") {
        return [
            "ViaInitialize"
        ];
    } else if (v.TAG === /* ViaListener */ 0) {
        return [
            "ViaListener",
            Curry._1(encoder_listener, v._0)
        ];
    } else {
        return [
            "ViaSideEffect",
            Curry._1(encoder_sideEffect, v._0),
            Decco.intToJson(v._1)
        ];
    }
}
function eventSource_decode(decoder_listener, decoder_sideEffect, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ViaInitialize":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ViaInitialize */ 0
                    };
                }
            case "ViaListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_listener, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ViaListener */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ViaSideEffect":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Curry._1(decoder_sideEffect, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ViaSideEffect */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function mapEventSource(mapListener, mapSideEffect, eventSource) {
    if (typeof eventSource === "number") {
        return /* ViaInitialize */ 0;
    } else if (eventSource.TAG === /* ViaListener */ 0) {
        return {
            TAG: /* ViaListener */ 0,
            _0: Curry._1(mapListener, eventSource._0)
        };
    } else {
        return {
            TAG: /* ViaSideEffect */ 1,
            _0: Curry._1(mapSideEffect, eventSource._0),
            _1: eventSource._1
        };
    }
}
function stringifyEventSource(stringifyListener, stringifySideEffect, eventSource) {
    if (typeof eventSource === "number") {
        return "state machine initialization";
    } else if (eventSource.TAG === /* ViaListener */ 0) {
        return "listener = " + Curry._1(stringifyListener, eventSource._0);
    } else {
        return "side effect (id=" + (String(eventSource._1) + (") = " + Curry._1(stringifySideEffect, eventSource._0)));
    }
}
function transition_encode(encoder_state, encoder_event, encoder_listener, encoder_sideEffect, v) {
    return Js_dict.fromArray([
        [
            "eventId",
            Decco.intToJson(v.eventId)
        ],
        [
            "event",
            Curry._1(encoder_event, v.event)
        ],
        [
            "eventSource",
            eventSource_encode(encoder_listener, encoder_sideEffect, v.eventSource)
        ],
        [
            "update",
            update_encode(encoder_state, encoder_sideEffect, v.update)
        ],
        [
            "sideEffectIds",
            Decco.listToJson(Decco.intToJson, v.sideEffectIds)
        ]
    ]);
}
function transition_decode(decoder_state, decoder_event, decoder_listener, decoder_sideEffect, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var eventId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventId"), null));
    if (eventId.TAG === /* Ok */ 0) {
        var $$event = Curry._1(decoder_event, Belt_Option.getWithDefault(Js_dict.get(dict$1, "event"), null));
        if ($$event.TAG === /* Ok */ 0) {
            var eventSource = eventSource_decode(decoder_listener, decoder_sideEffect, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSource"), null));
            if (eventSource.TAG === /* Ok */ 0) {
                var update = update_decode(decoder_state, decoder_sideEffect, Belt_Option.getWithDefault(Js_dict.get(dict$1, "update"), null));
                if (update.TAG === /* Ok */ 0) {
                    var sideEffectIds = Decco.listFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sideEffectIds"), null));
                    if (sideEffectIds.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                eventId: eventId._0,
                                event: $$event._0,
                                eventSource: eventSource._0,
                                update: update._0,
                                sideEffectIds: sideEffectIds._0
                            }
                        };
                    }
                    var e = sideEffectIds._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".sideEffectIds" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = update._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".update" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = eventSource._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".eventSource" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = $$event._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".event" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = eventId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".eventId" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function t_encode(encoder_state, encoder_event, encoder_listener, encoder_sideEffect, v) {
    return Js_dict.fromArray([
        [
            "firstState",
            Curry._1(encoder_state, v.firstState)
        ],
        [
            "transitions",
            Decco.arrayToJson(function(param) {
                return transition_encode(encoder_state, encoder_event, encoder_listener, encoder_sideEffect, param);
            }, v.transitions)
        ],
        [
            "maxLength",
            Decco.optionToJson(Decco.intToJson, v.maxLength)
        ]
    ]);
}
function t_decode(decoder_state, decoder_event, decoder_listener, decoder_sideEffect, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var firstState = Curry._1(decoder_state, Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstState"), null));
    if (firstState.TAG === /* Ok */ 0) {
        var transitions = Decco.arrayFromJson(function(param) {
            return transition_decode(decoder_state, decoder_event, decoder_listener, decoder_sideEffect, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transitions"), null));
        if (transitions.TAG === /* Ok */ 0) {
            var maxLength = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maxLength"), null));
            if (maxLength.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        firstState: firstState._0,
                        transitions: transitions._0,
                        maxLength: maxLength._0
                    }
                };
            }
            var e = maxLength._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maxLength" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = transitions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".transitions" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = firstState._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".firstState" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function make(maxLength, state, param) {
    return {
        firstState: state,
        transitions: [],
        maxLength: maxLength
    };
}
function recordTransition(eventId, $$event, eventSource, update, sideEffectIds, history) {
    var maxLength = history.maxLength;
    var transitions = history.transitions;
    if (maxLength === undefined) {
        return {
            firstState: history.firstState,
            transitions: $$Array.append(transitions, [
                {
                    eventId: eventId,
                    event: $$event,
                    eventSource: eventSource,
                    update: update,
                    sideEffectIds: sideEffectIds
                }
            ]),
            maxLength: history.maxLength
        };
    }
    if (maxLength === 0) {
        return history;
    }
    if (maxLength > transitions.length) {
        return {
            firstState: history.firstState,
            transitions: $$Array.append(transitions, [
                {
                    eventId: eventId,
                    event: $$event,
                    eventSource: eventSource,
                    update: update,
                    sideEffectIds: sideEffectIds
                }
            ]),
            maxLength: history.maxLength
        };
    }
    if (maxLength !== transitions.length) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: history length (" + (String(transitions.length) + (")is already greater than max length " + String(maxLength))));
    }
    var match = Caml_array.get(transitions, 0).update;
    var newFirstState;
    if (typeof match === "number") {
        newFirstState = history.firstState;
    } else {
        switch(match.TAG | 0){
            case /* SideEffects */ 1:
            case /* SerialSideEffects */ 2:
                newFirstState = history.firstState;
                break;
            default:
                newFirstState = match._0;
        }
    }
    var transitionsExceptFirst = ArrayUtils$SmartcutsMacros.slice(1, transitions.length, transitions);
    return {
        firstState: newFirstState,
        transitions: $$Array.append(transitionsExceptFirst, [
            {
                eventId: eventId,
                event: $$event,
                eventSource: eventSource,
                update: update,
                sideEffectIds: sideEffectIds
            }
        ]),
        maxLength: history.maxLength
    };
}
function reset(history) {
    var maybeLastNewState = Util$SmartcutsMacros.shortcut(function(param) {
        var update = param.update;
        if (typeof update === "number") {
            return;
        }
        switch(update.TAG | 0){
            case /* SideEffects */ 1:
            case /* SerialSideEffects */ 2:
                return;
            default:
                return Caml_option.some(update._0);
        }
    }, Belt_Array.reverse(history.transitions));
    return {
        firstState: maybeLastNewState !== undefined ? Caml_option.valFromOption(maybeLastNewState) : history.firstState,
        transitions: [],
        maxLength: history.maxLength
    };
}
function clearUpToAndIncludingEventId(history, eventId) {
    var transitions = history.transitions;
    var firstState = history.firstState;
    var maybeIndexOfMatchingTransition = Belt_Array.getIndexBy(transitions, function(transition) {
        return transition.eventId === eventId;
    });
    return Belt_Option.getWithDefault(Belt_Option.map(maybeIndexOfMatchingTransition, function(i) {
        return {
            firstState: Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Array.getBy(Belt_Array.reverse(Belt_Array.slice(transitions, 0, i)), function(param) {
                var tmp = param.update;
                if (typeof tmp === "number") {
                    return false;
                }
                switch(tmp.TAG | 0){
                    case /* SideEffects */ 1:
                    case /* SerialSideEffects */ 2:
                        return false;
                    default:
                        return true;
                }
            }), function(param) {
                var update = param.update;
                if (typeof update === "number") {
                    return;
                }
                switch(update.TAG | 0){
                    case /* Update */ 0:
                    case /* UpdateWithSideEffects */ 3:
                    case /* UpdateWithSerialSideEffects */ 4:
                        return Caml_option.some(update._0);
                    default:
                        return;
                }
            }), firstState),
            transitions: Belt_Array.sliceToEnd(transitions, i + 1 | 0),
            maxLength: history.maxLength
        };
    }), history);
}
function map(mapState, mapEvent, mapSideEffect, mapListener, param1) {
    return {
        firstState: Curry._1(mapState, param1.firstState),
        transitions: $$Array.map(function(param) {
            var update = param.update;
            var tmp;
            if (typeof update === "number") {
                tmp = /* Ignore */ 0;
            } else {
                switch(update.TAG | 0){
                    case /* Update */ 0:
                        tmp = {
                            TAG: /* Update */ 0,
                            _0: Curry._1(mapState, update._0)
                        };
                        break;
                    case /* SideEffects */ 1:
                        tmp = {
                            TAG: /* SideEffects */ 1,
                            _0: List.map(mapSideEffect, update._0)
                        };
                        break;
                    case /* SerialSideEffects */ 2:
                        tmp = {
                            TAG: /* SerialSideEffects */ 2,
                            _0: List.map(mapSideEffect, update._0)
                        };
                        break;
                    case /* UpdateWithSideEffects */ 3:
                        tmp = {
                            TAG: /* UpdateWithSideEffects */ 3,
                            _0: Curry._1(mapState, update._0),
                            _1: List.map(mapSideEffect, update._1)
                        };
                        break;
                    case /* UpdateWithSerialSideEffects */ 4:
                        tmp = {
                            TAG: /* UpdateWithSerialSideEffects */ 4,
                            _0: Curry._1(mapState, update._0),
                            _1: List.map(mapSideEffect, update._1)
                        };
                        break;
                }
            }
            return {
                eventId: param.eventId,
                event: Curry._1(mapEvent, param.event),
                eventSource: mapEventSource(mapListener, mapSideEffect, param.eventSource),
                update: tmp,
                sideEffectIds: param.sideEffectIds
            };
        }, param1.transitions),
        maxLength: param1.maxLength
    };
}
function toTransitionsWithPriorStates(param2) {
    return $$Array.fold_left(function(param, param$1) {
        var update = param$1.update;
        var priorState = param[0];
        var nextState;
        if (typeof update === "number") {
            nextState = priorState;
        } else {
            switch(update.TAG | 0){
                case /* SideEffects */ 1:
                case /* SerialSideEffects */ 2:
                    nextState = priorState;
                    break;
                default:
                    nextState = update._0;
            }
        }
        return [
            nextState,
            $$Array.append(param[1], [
                {
                    priorState: priorState,
                    nextState: nextState,
                    eventId: param$1.eventId,
                    event: param$1.event,
                    eventSource: param$1.eventSource,
                    update: update,
                    sideEffectIds: param$1.sideEffectIds
                }
            ])
        ];
    }, [
        param2.firstState,
        []
    ], param2.transitions)[1];
}
function containsEventId(eventId, param) {
    return $$Array.exists(function(transition) {
        return transition.eventId === eventId;
    }, param.transitions);
}
function containsSideEffectId(sideEffectId, param3) {
    return $$Array.exists(function(param) {
        return List.mem(sideEffectId, param.sideEffectIds);
    }, param3.transitions);
}
function truncateToLastExitFailure(stringifyEvent, buffer, history) {
    var transitions = history.transitions;
    var match = Belt_Array.reduceWithIndex(Belt_Array.reverse(transitions), [
        undefined,
        false,
        undefined,
        buffer
    ], function(triplet, param, i) {
        var update = param.update;
        var $$event = param.event;
        var _$buffer = triplet[3];
        var maybeFirstNonFailIndexWithState = triplet[2];
        var hasSeenFail = triplet[1];
        var maybeLastFailIndex = triplet[0];
        if (maybeLastFailIndex !== undefined) {
            if (maybeFirstNonFailIndexWithState !== undefined) {
                return triplet;
            }
            var stringifiedEvent = Curry._1(stringifyEvent, $$event);
            if (stringifiedEvent.includes("Fail(")) {
                return [
                    maybeLastFailIndex,
                    true,
                    maybeFirstNonFailIndexWithState,
                    _$buffer
                ];
            }
            if (!hasSeenFail) {
                return triplet;
            }
            var exit = 0;
            if (typeof update === "number") {
                exit = 2;
            } else {
                switch(update.TAG | 0){
                    case /* Update */ 0:
                    case /* UpdateWithSideEffects */ 3:
                    case /* UpdateWithSerialSideEffects */ 4:
                        exit = 1;
                        break;
                    default:
                        exit = 2;
                }
            }
            switch(exit){
                case 1:
                    if (_$buffer === 0) {
                        return [
                            maybeLastFailIndex,
                            hasSeenFail,
                            [
                                i,
                                update._0
                            ],
                            0
                        ];
                    } else {
                        return [
                            maybeLastFailIndex,
                            hasSeenFail,
                            undefined,
                            _$buffer - 1 | 0
                        ];
                    }
                case 2:
                    return [
                        maybeLastFailIndex,
                        hasSeenFail,
                        undefined,
                        _$buffer - 1 | 0
                    ];
            }
        } else {
            if (maybeFirstNonFailIndexWithState !== undefined) {
                return triplet;
            }
            var stringifiedEvent$1 = Curry._1(stringifyEvent, $$event);
            if (stringifiedEvent$1.includes("ExitFailure(")) {
                return [
                    i,
                    hasSeenFail,
                    undefined,
                    _$buffer
                ];
            } else {
                return triplet;
            }
        }
    });
    var maybeFirstNonFailIndexWithState1 = match[2];
    var match$1 = maybeFirstNonFailIndexWithState1 !== undefined ? [
        Belt_Array.sliceToEnd(transitions, (transitions.length - maybeFirstNonFailIndexWithState1[0] | 0) - 1 | 0),
        maybeFirstNonFailIndexWithState1[1]
    ] : [
        transitions,
        history.firstState
    ];
    return {
        firstState: match$1[1],
        transitions: match$1[0],
        maxLength: history.maxLength
    };
}
function lastNTransistions(param, n) {
    var transitions = param.transitions;
    var to_ = transitions.length;
    var from = Math.max(0, to_ - n | 0);
    return ArrayUtils$SmartcutsMacros.slice(from, to_, transitions);
}
var $$History = {
    transition_encode: transition_encode,
    transition_decode: transition_decode,
    t_encode: t_encode,
    t_decode: t_decode,
    make: make,
    recordTransition: recordTransition,
    reset: reset,
    clearUpToAndIncludingEventId: clearUpToAndIncludingEventId,
    map: map,
    toTransitionsWithPriorStates: toTransitionsWithPriorStates,
    containsEventId: containsEventId,
    containsSideEffectId: containsSideEffectId,
    truncateToLastExitFailure: truncateToLastExitFailure,
    lastNTransistions: lastNTransistions
};
function sideEffectErrorContext_encode(encoder_sideEffect, encoder_state, v) {
    return Js_dict.fromArray([
        [
            "sideEffectId",
            Decco.intToJson(v.sideEffectId)
        ],
        [
            "sideEffect",
            Curry._1(encoder_sideEffect, v.sideEffect)
        ],
        [
            "maybeState",
            Decco.optionToJson(encoder_state, v.maybeState)
        ],
        [
            "extraMessage",
            Decco.stringToJson(v.extraMessage)
        ]
    ]);
}
function sideEffectErrorContext_decode(decoder_sideEffect, decoder_state, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var sideEffectId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sideEffectId"), null));
    if (sideEffectId.TAG === /* Ok */ 0) {
        var sideEffect = Curry._1(decoder_sideEffect, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sideEffect"), null));
        if (sideEffect.TAG === /* Ok */ 0) {
            var maybeState = Decco.optionFromJson(decoder_state, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeState"), null));
            if (maybeState.TAG === /* Ok */ 0) {
                var extraMessage = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "extraMessage"), null));
                if (extraMessage.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            sideEffectId: sideEffectId._0,
                            sideEffect: sideEffect._0,
                            maybeState: maybeState._0,
                            extraMessage: extraMessage._0
                        }
                    };
                }
                var e = extraMessage._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".extraMessage" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = maybeState._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maybeState" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = sideEffect._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sideEffect" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = sideEffectId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".sideEffectId" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function mapSideEffectErrorContext(mapSideEffect, mapState, param) {
    return {
        sideEffectId: param.sideEffectId,
        sideEffect: Curry._1(mapSideEffect, param.sideEffect),
        maybeState: Belt_Option.map(param.maybeState, mapState),
        extraMessage: param.extraMessage
    };
}
function stringifySideEffectErrorContext(stringifySideEffect, stringifyState, param) {
    return "{sideEffect=" + (Curry._1(stringifySideEffect, param.sideEffect) + (", maybeState=" + (OptionUtils$SmartcutsMacros.stringify(stringifyState, param.maybeState) + (", extraMessage" + (param.extraMessage + "}")))));
}
function transitionErrorContext_encode(encoder_state, encoder_event, v) {
    return Js_dict.fromArray([
        [
            "state",
            Curry._1(encoder_state, v.state)
        ],
        [
            "event",
            Curry._1(encoder_event, v.event)
        ],
        [
            "eventId",
            Decco.intToJson(v.eventId)
        ],
        [
            "extraMessage",
            Decco.stringToJson(v.extraMessage)
        ]
    ]);
}
function transitionErrorContext_decode(decoder_state, decoder_event, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var state = Curry._1(decoder_state, Belt_Option.getWithDefault(Js_dict.get(dict$1, "state"), null));
    if (state.TAG === /* Ok */ 0) {
        var $$event = Curry._1(decoder_event, Belt_Option.getWithDefault(Js_dict.get(dict$1, "event"), null));
        if ($$event.TAG === /* Ok */ 0) {
            var eventId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventId"), null));
            if (eventId.TAG === /* Ok */ 0) {
                var extraMessage = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "extraMessage"), null));
                if (extraMessage.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            state: state._0,
                            event: $$event._0,
                            eventId: eventId._0,
                            extraMessage: extraMessage._0
                        }
                    };
                }
                var e = extraMessage._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".extraMessage" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = eventId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".eventId" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = $$event._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".event" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = state._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".state" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function mapTransitionErrorContext(mapState, mapEvent, param) {
    return {
        state: Curry._1(mapState, param.state),
        event: Curry._1(mapEvent, param.event),
        eventId: param.eventId,
        extraMessage: param.extraMessage
    };
}
function stringifyTransitionErrorContext(stringifyState, stringifyEvent, param) {
    return "{state=" + (Curry._1(stringifyState, param.state) + (", event=" + (Curry._1(stringifyEvent, param.event) + (", extraMessage=" + (param.extraMessage + "}")))));
}
function listenerErrorContext_encode(encoder_listener, v) {
    return Js_dict.fromArray([
        [
            "listener",
            Curry._1(encoder_listener, v.listener)
        ],
        [
            "extraMessage",
            Decco.stringToJson(v.extraMessage)
        ]
    ]);
}
function listenerErrorContext_decode(decoder_listener, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var listener = Curry._1(decoder_listener, Belt_Option.getWithDefault(Js_dict.get(dict$1, "listener"), null));
    if (listener.TAG === /* Ok */ 0) {
        var extraMessage = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "extraMessage"), null));
        if (extraMessage.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    listener: listener._0,
                    extraMessage: extraMessage._0
                }
            };
        }
        var e = extraMessage._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".extraMessage" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = listener._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".listener" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function mapListenerErrorContext(mapListener, param) {
    return {
        listener: Curry._1(mapListener, param.listener),
        extraMessage: param.extraMessage
    };
}
function t_encode$1(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, v) {
    switch(v.TAG | 0){
        case /* DidErrDuringTransition */ 0:
            return [
                "DidErrDuringTransition",
                transitionErrorContext_encode(encoder_state, encoder_event, v._0)
            ];
        case /* DidErrDuringSideEffect */ 1:
            return [
                "DidErrDuringSideEffect",
                sideEffectErrorContext_encode(encoder_sideEffect, encoder_state, v._0)
            ];
        case /* DidErrDuringListener */ 2:
            return [
                "DidErrDuringListener",
                listenerErrorContext_encode(encoder_listener, v._0)
            ];
    }
}
function t_decode$1(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DidErrDuringListener":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = listenerErrorContext_decode(decoder_listener, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidErrDuringListener */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DidErrDuringSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = sideEffectErrorContext_decode(decoder_sideEffect, decoder_state, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidErrDuringSideEffect */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "DidErrDuringTransition":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = transitionErrorContext_decode(decoder_state, decoder_event, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidErrDuringTransition */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map$1(mapState, mapEvent, mapSideEffect, mapListener, errorContext) {
    switch(errorContext.TAG | 0){
        case /* DidErrDuringTransition */ 0:
            return {
                TAG: /* DidErrDuringTransition */ 0,
                _0: mapTransitionErrorContext(mapState, mapEvent, errorContext._0)
            };
        case /* DidErrDuringSideEffect */ 1:
            return {
                TAG: /* DidErrDuringSideEffect */ 1,
                _0: mapSideEffectErrorContext(mapSideEffect, mapState, errorContext._0)
            };
        case /* DidErrDuringListener */ 2:
            return {
                TAG: /* DidErrDuringListener */ 2,
                _0: mapListenerErrorContext(mapListener, errorContext._0)
            };
    }
}
var hoist = map$1;
function stringify(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, errorContext) {
    switch(errorContext.TAG | 0){
        case /* DidErrDuringTransition */ 0:
            return "DidErrDuringTransition(state=" + (stringifyTransitionErrorContext(stringifyState, stringifyEvent, errorContext._0) + ")");
        case /* DidErrDuringSideEffect */ 1:
            return "DidErrDuringSideEffect(" + (stringifySideEffectErrorContext(stringifySideEffect, stringifyState, errorContext._0) + ")");
        case /* DidErrDuringListener */ 2:
            var match = errorContext._0;
            return "DidErrDuringListener(listener=" + (Curry._1(stringifyListener, match.listener) + (", extraMessage=" + (match.extraMessage + ")")));
    }
}
var WithListener = {
    listenerErrorContext_encode: listenerErrorContext_encode,
    listenerErrorContext_decode: listenerErrorContext_decode,
    mapListenerErrorContext: mapListenerErrorContext,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    map: map$1,
    hoist: hoist,
    stringify: stringify
};
function t_encode$2(encoder_state, encoder_event, encoder_sideEffect, v) {
    if (v.TAG === /* DidErrDuringTransition */ 0) {
        return [
            "DidErrDuringTransition",
            transitionErrorContext_encode(encoder_state, encoder_event, v._0)
        ];
    } else {
        return [
            "DidErrDuringSideEffect",
            sideEffectErrorContext_encode(encoder_sideEffect, encoder_state, v._0)
        ];
    }
}
function t_decode$2(decoder_state, decoder_event, decoder_sideEffect, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DidErrDuringSideEffect":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = sideEffectErrorContext_decode(decoder_sideEffect, decoder_state, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidErrDuringSideEffect */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DidErrDuringTransition":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = transitionErrorContext_decode(decoder_state, decoder_event, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DidErrDuringTransition */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function hoistToErrorContextWithoutListener(hoistState, hoistEvent, hoistSideEffect, errorContext) {
    if (errorContext.TAG === /* DidErrDuringTransition */ 0) {
        var match = errorContext._0;
        return {
            TAG: /* DidErrDuringTransition */ 0,
            _0: {
                state: Curry._1(hoistState, match.state),
                event: Curry._1(hoistEvent, match.event),
                eventId: match.eventId,
                extraMessage: match.extraMessage
            }
        };
    }
    var match$1 = errorContext._0;
    return {
        TAG: /* DidErrDuringSideEffect */ 1,
        _0: {
            sideEffectId: match$1.sideEffectId,
            sideEffect: Curry._1(hoistSideEffect, match$1.sideEffect),
            maybeState: Belt_Option.map(match$1.maybeState, hoistState),
            extraMessage: match$1.extraMessage
        }
    };
}
function hoistToErrorContextWithListener(hoistState, hoistEvent, hoistSideEffect, errorContext) {
    if (errorContext.TAG === /* DidErrDuringTransition */ 0) {
        var match = errorContext._0;
        return {
            TAG: /* DidErrDuringTransition */ 0,
            _0: {
                state: Curry._1(hoistState, match.state),
                event: Curry._1(hoistEvent, match.event),
                eventId: match.eventId,
                extraMessage: match.extraMessage
            }
        };
    }
    var match$1 = errorContext._0;
    return {
        TAG: /* DidErrDuringSideEffect */ 1,
        _0: {
            sideEffectId: match$1.sideEffectId,
            sideEffect: Curry._1(hoistSideEffect, match$1.sideEffect),
            maybeState: Belt_Option.map(match$1.maybeState, hoistState),
            extraMessage: match$1.extraMessage
        }
    };
}
function map$2(mapState, mapEvent, mapSideEffect, errorContext) {
    if (errorContext.TAG === /* DidErrDuringTransition */ 0) {
        return {
            TAG: /* DidErrDuringTransition */ 0,
            _0: mapTransitionErrorContext(mapState, mapEvent, errorContext._0)
        };
    } else {
        return {
            TAG: /* DidErrDuringSideEffect */ 1,
            _0: mapSideEffectErrorContext(mapSideEffect, mapState, errorContext._0)
        };
    }
}
function stringify$1(stringifyState, stringifyEvent, stringifySideEffect, errorContext) {
    if (errorContext.TAG === /* DidErrDuringTransition */ 0) {
        return "DidErrDuringTransition(state=" + (stringifyTransitionErrorContext(stringifyState, stringifyEvent, errorContext._0) + ")");
    } else {
        return "DidErrDuringSideEffect(" + (stringifySideEffectErrorContext(stringifySideEffect, stringifyState, errorContext._0) + ")");
    }
}
var WithoutListener = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    hoistToErrorContextWithoutListener: hoistToErrorContextWithoutListener,
    hoistToErrorContextWithListener: hoistToErrorContextWithListener,
    map: map$2,
    stringify: stringify$1
};
var ErrorContext = {
    sideEffectErrorContext_encode: sideEffectErrorContext_encode,
    sideEffectErrorContext_decode: sideEffectErrorContext_decode,
    mapSideEffectErrorContext: mapSideEffectErrorContext,
    stringifySideEffectErrorContext: stringifySideEffectErrorContext,
    transitionErrorContext_encode: transitionErrorContext_encode,
    transitionErrorContext_decode: transitionErrorContext_decode,
    mapTransitionErrorContext: mapTransitionErrorContext,
    stringifyTransitionErrorContext: stringifyTransitionErrorContext,
    WithListener: WithListener,
    WithoutListener: WithoutListener
};
function t_encode$3(encoder_otherFailureReason, v) {
    if (typeof v === "number") {
        return [
            "FailWithTimeout"
        ];
    }
    switch(v.TAG | 0){
        case /* FailWithOtherReason */ 0:
            return [
                "FailWithOtherReason",
                Curry._1(encoder_otherFailureReason, v._0)
            ];
        case /* FailWithJsExn */ 1:
            return [
                "FailWithJsExn",
                JsExnUtils$SmartcutsMacros.t_encode(v._0)
            ];
        case /* FailWithJsPromiseError */ 2:
            return [
                "FailWithJsPromiseError",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
            ];
    }
}
function t_decode$3(decoder_otherFailureReason, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FailWithJsExn":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithJsExn */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "FailWithJsPromiseError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithJsPromiseError */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "FailWithOtherReason":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(decoder_otherFailureReason, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FailWithOtherReason */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "FailWithTimeout":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithTimeout */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$2(stringifyOtherFailureReason, exitFailure) {
    if (typeof exitFailure === "number") {
        return "FailWithTimeout";
    }
    switch(exitFailure.TAG | 0){
        case /* FailWithOtherReason */ 0:
            return "FailWithOtherReason(" + (Curry._1(stringifyOtherFailureReason, exitFailure._0) + ")");
        case /* FailWithJsExn */ 1:
            return "FailWithJsExn(exn=" + (OptionUtils$SmartcutsMacros.withDefault("", exitFailure._0.message) + ")");
        case /* FailWithJsPromiseError */ 2:
            return "FailWithJsPromiseError(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, exitFailure._0) + ")");
    }
}
function stringifyWithoutDetails(stringifyOtherFailureReason, exitFailure) {
    if (typeof exitFailure === "number") {
        return "FailWithTimeout";
    }
    switch(exitFailure.TAG | 0){
        case /* FailWithOtherReason */ 0:
            return Curry._1(stringifyOtherFailureReason, exitFailure._0);
        case /* FailWithJsExn */ 1:
            return JsExnUtils$SmartcutsMacros.stringify(exitFailure._0);
        case /* FailWithJsPromiseError */ 2:
            return Curry._1(JsPromiseErrorUtils$SmartcutsMacros.ErrorType.stringifyWithoutDetails, Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, exitFailure._0));
    }
}
function minify(minifyOtherFailureReason, v) {
    if (typeof v === "number" || v.TAG !== /* FailWithOtherReason */ 0) {
        return v;
    } else {
        return {
            TAG: /* FailWithOtherReason */ 0,
            _0: Curry._1(minifyOtherFailureReason, v._0)
        };
    }
}
var FailWith = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringify: stringify$2,
    stringifyWithoutDetails: stringifyWithoutDetails,
    minify: minify
};
function t_encode$4(encoder_otherFailureReason, encoder_context, v) {
    return Js_dict.fromArray([
        [
            "failWith",
            t_encode$3(encoder_otherFailureReason, v.failWith)
        ],
        [
            "context",
            Curry._1(encoder_context, v.context)
        ]
    ]);
}
function t_decode$4(decoder_otherFailureReason, decoder_context, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var failWith = t_decode$3(decoder_otherFailureReason, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failWith"), null));
    if (failWith.TAG === /* Ok */ 0) {
        var context = Curry._1(decoder_context, Belt_Option.getWithDefault(Js_dict.get(dict$1, "context"), null));
        if (context.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    failWith: failWith._0,
                    context: context._0
                }
            };
        }
        var e = context._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".context" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = failWith._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".failWith" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var Generic = {
    t_encode: t_encode$4,
    t_decode: t_decode$4
};
function t_encode$5(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, encoder_otherFailureReason, v) {
    return t_encode$4(encoder_otherFailureReason, function(param) {
        return t_encode$1(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, param);
    }, v);
}
function t_decode$5(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, decoder_otherFailureReason, v) {
    return t_decode$4(decoder_otherFailureReason, function(param) {
        return t_decode$1(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, param);
    }, v);
}
function map$3(mapState, mapEvent, mapSideEffect, mapListener, param) {
    return {
        failWith: param.failWith,
        context: map$1(mapState, mapEvent, mapSideEffect, mapListener, param.context)
    };
}
function stringify$3(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, stringifyOtherFailureReason, param) {
    return "{failWith: " + (stringify$2(stringifyOtherFailureReason, param.failWith) + (", context: " + (stringify(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, param.context) + "}")));
}
var WithListener$1 = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    map: map$3,
    stringify: stringify$3
};
function t_encode$6(encoder_state, encoder_event, encoder_sideEffect, encoder_otherFailureReason, v) {
    return t_encode$4(encoder_otherFailureReason, function(param) {
        return t_encode$2(encoder_state, encoder_event, encoder_sideEffect, param);
    }, v);
}
function t_decode$6(decoder_state, decoder_event, decoder_sideEffect, decoder_otherFailureReason, v) {
    return t_decode$4(decoder_otherFailureReason, function(param) {
        return t_decode$2(decoder_state, decoder_event, decoder_sideEffect, param);
    }, v);
}
function map$4(mapState, mapEvent, mapSideEffect, param) {
    return {
        failWith: param.failWith,
        context: map$2(mapState, mapEvent, mapSideEffect, param.context)
    };
}
function hoistToFailureWithListener(hoistState, hoistEvent, hoistSideEffect, param) {
    return {
        failWith: param.failWith,
        context: hoistToErrorContextWithListener(hoistState, hoistEvent, hoistSideEffect, param.context)
    };
}
function stringify$4(stringifyState, stringifyEvent, stringifySideEffect, stringifyOtherFailureReason, param) {
    return "{failWith: " + (stringify$2(stringifyOtherFailureReason, param.failWith) + (", context: " + (stringify$1(stringifyState, stringifyEvent, stringifySideEffect, param.context) + "}")));
}
var WithoutListener$1 = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    map: map$4,
    hoistToFailureWithListener: hoistToFailureWithListener,
    stringify: stringify$4
};
function t_encode$7(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, encoder_otherFailureReason, v) {
    return Js_dict.fromArray([
        [
            "failure",
            t_encode$3(encoder_otherFailureReason, v.failure)
        ],
        [
            "errorContext",
            t_encode$1(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, v.errorContext)
        ],
        [
            "history",
            t_encode(encoder_state, encoder_event, encoder_listener, encoder_sideEffect, v.history)
        ]
    ]);
}
function t_decode$7(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, decoder_otherFailureReason, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var failure = t_decode$3(decoder_otherFailureReason, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failure"), null));
    if (failure.TAG === /* Ok */ 0) {
        var errorContext = t_decode$1(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, Belt_Option.getWithDefault(Js_dict.get(dict$1, "errorContext"), null));
        if (errorContext.TAG === /* Ok */ 0) {
            var history = t_decode(decoder_state, decoder_event, decoder_listener, decoder_sideEffect, Belt_Option.getWithDefault(Js_dict.get(dict$1, "history"), null));
            if (history.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        failure: failure._0,
                        errorContext: errorContext._0,
                        history: history._0
                    }
                };
            }
            var e = history._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".history" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = errorContext._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".errorContext" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = failure._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".failure" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$5(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, stringifyOtherFailureReason, param) {
    return "{failure=" + (stringify$2(stringifyOtherFailureReason, param.failure) + (", errorContext=" + (stringify(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, param.errorContext) + (", history({len: " + (String(param.history.transitions.length) + "})}")))));
}
var FailureInfo = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    stringify: stringify$5
};
var Root = {
    FailureInfo: FailureInfo
};
var Failure = {
    ErrorContext: ErrorContext,
    FailWith: FailWith,
    Generic: Generic,
    WithListener: WithListener$1,
    WithoutListener: WithoutListener$1,
    Root: Root
};
function t_encode$8(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, encoder_otherFailureReason, v) {
    if (typeof v === "number") {
        if (v === /* ExitSuccess */ 0) {
            return [
                "ExitSuccess"
            ];
        } else {
            return [
                "ExitFromPossibleInfiniteFailureLoop"
            ];
        }
    } else if (v.TAG === /* ExitFailure */ 0) {
        return [
            "ExitFailure",
            t_encode$5(encoder_state, encoder_event, encoder_sideEffect, encoder_listener, encoder_otherFailureReason, v._0)
        ];
    } else {
        return [
            "ExitFromPossibleStaleState",
            Curry._1(encoder_state, v._0)
        ];
    }
}
function t_decode$8(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, decoder_otherFailureReason, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ExitFailure":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$5(decoder_state, decoder_event, decoder_sideEffect, decoder_listener, decoder_otherFailureReason, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExitFailure */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ExitFromPossibleInfiniteFailureLoop":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExitFromPossibleInfiniteFailureLoop */ 1
                    };
                }
            case "ExitFromPossibleStaleState":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_state, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExitFromPossibleStaleState */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ExitSuccess":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExitSuccess */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map$5(mapState, mapEvent, mapSideEffect, mapListener, exitReason) {
    if (typeof exitReason === "number") {
        if (exitReason === /* ExitSuccess */ 0) {
            return /* ExitSuccess */ 0;
        } else {
            return /* ExitFromPossibleInfiniteFailureLoop */ 1;
        }
    } else if (exitReason.TAG === /* ExitFailure */ 0) {
        return {
            TAG: /* ExitFailure */ 0,
            _0: map$3(mapState, mapEvent, mapSideEffect, mapListener, exitReason._0)
        };
    } else {
        return {
            TAG: /* ExitFromPossibleStaleState */ 1,
            _0: Curry._1(mapState, exitReason._0)
        };
    }
}
function stringify$6(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, stringifyOtherFailureReason, exitReason) {
    if (typeof exitReason === "number") {
        if (exitReason === /* ExitSuccess */ 0) {
            return "ExitSuccess";
        } else {
            return "ExitFromPossibleInfiniteFailureLoop";
        }
    } else if (exitReason.TAG === /* ExitFailure */ 0) {
        return "ExitFailure(" + (stringify$3(stringifyState, stringifyEvent, stringifySideEffect, stringifyListener, stringifyOtherFailureReason, exitReason._0) + ")");
    } else {
        return "ExitFromPossibleStaleState(" + (Curry._1(stringifyState, exitReason._0) + ")");
    }
}
var WithListener$2 = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    map: map$5,
    stringify: stringify$6
};
function t_encode$9(encoder_state, encoder_event, encoder_sideEffect, encoder_otherFailureReason, v) {
    if (typeof v === "number") {
        if (v !== 0) {
            return [
                "ExitFromPossibleInfiniteFailureLoop"
            ];
        } else {
            return [
                "ExitSuccess"
            ];
        }
    } else {
        return [
            "ExitFailure",
            t_encode$6(encoder_state, encoder_event, encoder_sideEffect, encoder_otherFailureReason, v._0)
        ];
    }
}
function t_decode$9(decoder_state, decoder_event, decoder_sideEffect, decoder_otherFailureReason, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ExitFailure":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$6(decoder_state, decoder_event, decoder_sideEffect, decoder_otherFailureReason, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExitFailure */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ExitFromPossibleInfiniteFailureLoop":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExitFromPossibleInfiniteFailureLoop */ 1
                    };
                }
            case "ExitSuccess":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExitSuccess */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map$6(mapState, mapEvent, mapSideEffect, exitReason) {
    if (typeof exitReason === "number") {
        if (exitReason !== 0) {
            return /* ExitFromPossibleInfiniteFailureLoop */ 1;
        } else {
            return /* ExitSuccess */ 0;
        }
    } else {
        return /* ExitFailure */ {
            _0: map$4(mapState, mapEvent, mapSideEffect, exitReason._0)
        };
    }
}
function stringify$7(stringifyState, stringifyEvent, stringifySideEffect, stringifyOtherFailureReason, exitReason) {
    if (typeof exitReason === "number") {
        if (exitReason !== 0) {
            return "ExitFromPossibleInfiniteFailureLoop";
        } else {
            return "ExitSuccess";
        }
    } else {
        return "ExitFailure(" + (stringify$4(stringifyState, stringifyEvent, stringifySideEffect, stringifyOtherFailureReason, exitReason._0) + ")");
    }
}
function hoistToExitReasonWithoutListener(hoistState, hoistEvent, hoistSideEffect, exitReason) {
    if (typeof exitReason === "number") {
        if (exitReason !== 0) {
            return /* ExitFromPossibleInfiniteFailureLoop */ 1;
        } else {
            return /* ExitSuccess */ 0;
        }
    } else {
        return /* ExitFailure */ {
            _0: map$4(hoistState, hoistEvent, hoistSideEffect, exitReason._0)
        };
    }
}
function hoistToExitReasonWithListener(hoistState, hoistEvent, hoistSideEffect, exitReason) {
    if (typeof exitReason === "number") {
        if (exitReason !== 0) {
            return /* ExitFromPossibleInfiniteFailureLoop */ 1;
        } else {
            return /* ExitSuccess */ 0;
        }
    } else {
        return {
            TAG: /* ExitFailure */ 0,
            _0: hoistToFailureWithListener(hoistState, hoistEvent, hoistSideEffect, exitReason._0)
        };
    }
}
var WithoutListener$2 = {
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    map: map$6,
    stringify: stringify$7,
    hoistToExitReasonWithoutListener: hoistToExitReasonWithoutListener,
    hoistToExitReasonWithListener: hoistToExitReasonWithListener
};
var ExitReason = {
    WithListener: WithListener$2,
    WithoutListener: WithoutListener$2
};
function t_encode$10(encoder_exitReason, v) {
    return Js_dict.fromArray([
        [
            "mainExitReason",
            Curry._1(encoder_exitReason, v.mainExitReason)
        ],
        [
            "otherExitReasons",
            Decco.listToJson(encoder_exitReason, v.otherExitReasons)
        ]
    ]);
}
function t_decode$10(decoder_exitReason, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var mainExitReason = Curry._1(decoder_exitReason, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mainExitReason"), null));
    if (mainExitReason.TAG === /* Ok */ 0) {
        var otherExitReasons = Decco.listFromJson(decoder_exitReason, Belt_Option.getWithDefault(Js_dict.get(dict$1, "otherExitReasons"), null));
        if (otherExitReasons.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    mainExitReason: mainExitReason._0,
                    otherExitReasons: otherExitReasons._0
                }
            };
        }
        var e = otherExitReasons._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".otherExitReasons" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = mainExitReason._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".mainExitReason" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function initWithMainReason(mainExitReason) {
    return {
        mainExitReason: mainExitReason,
        otherExitReasons: /* [] */ 0
    };
}
function addExitReason(exitReason, allExitReasons) {
    return {
        mainExitReason: allExitReasons.mainExitReason,
        otherExitReasons: {
            hd: exitReason,
            tl: allExitReasons.otherExitReasons
        }
    };
}
function stringify$8(stringifyExitReason, param) {
    return "{mainExitReason: " + (Curry._1(stringifyExitReason, param.mainExitReason) + (", otherExitReasons: " + (StringUtils$SmartcutsMacros.join(", ", List.map(stringifyExitReason, param.otherExitReasons)) + "}")));
}
function map$7(mapExitReason, param) {
    return {
        mainExitReason: Curry._1(mapExitReason, param.mainExitReason),
        otherExitReasons: List.map(mapExitReason, param.otherExitReasons)
    };
}
var AllExitReasons = {
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    initWithMainReason: initWithMainReason,
    addExitReason: addExitReason,
    stringify: stringify$8,
    map: map$7
};
var Exit = {
    ExitReason: ExitReason,
    AllExitReasons: AllExitReasons
};
var logYellow = Logger$SmartcutsMacros.createYellowLogger(Log$SmartcutsMacros.stateMachineCore);
function logSideEffects(indentOpt, prefix, stringifySideEffect, sideEffects) {
    var indent = indentOpt !== undefined ? indentOpt : 2;
    if (sideEffects) {
        if (sideEffects.tl) {
            logYellow(String(List.length(sideEffects)) + (" " + (prefix + " side effects")));
            Belt_List.forEachWithIndex(sideEffects, function(i, sideEffect) {
                return logYellow(StringUtils$SmartcutsMacros.indent(undefined, indent) + (String(i) + (") " + Curry._1(stringifySideEffect, sideEffect))));
            });
            return;
        } else {
            return logYellow("Side effect = " + Curry._1(stringifySideEffect, sideEffects.hd));
        }
    } else {
        return logYellow("No side effects");
    }
}
function logSideEffectsWithIds(indentOpt, prefix, stringifySideEffect, sideEffectsWithIds) {
    var indent = indentOpt !== undefined ? indentOpt : 2;
    if (!sideEffectsWithIds) {
        return logYellow("No side effects");
    }
    if (sideEffectsWithIds.tl) {
        logYellow(String(List.length(sideEffectsWithIds)) + (" " + (prefix + " side effects")));
        return Belt_List.forEachWithIndex(sideEffectsWithIds, function(i, param) {
            return logYellow(StringUtils$SmartcutsMacros.indent(undefined, indent) + (String(i) + (") (id=" + (String(param[1]) + (")" + Curry._1(stringifySideEffect, param[0]))))));
        });
    }
    var match = sideEffectsWithIds.hd;
    return logYellow("Side effect (id=" + (String(match[1]) + (") = " + Curry._1(stringifySideEffect, match[0]))));
}
function maybeLogTransition($$event, eventSource, stateMachine) {
    var match = stateMachine.options.logTransitions;
    if (typeof match === "number" || !(match.TAG === /* DoLogTransitions */ 0 && !Curry._2(match._4, stateMachine.state.contents, $$event))) {
        return;
    } else {
        logYellow("\n\n========== NEW TRANSITION ==========");
        logYellow("Caused by " + stringifyEventSource(match._3, match._2, eventSource));
        logYellow("\n");
        logYellow("(prior state, event) =");
        logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + Curry._1(match._0, stateMachine.state.contents));
        logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + Curry._1(match._1, $$event));
        return logYellow("\n");
    }
}
function maybeLogUpdate(stateMachine, update, $$event, eventId, eventSource, sideEffectIds) {
    var match = stateMachine.options.logTransitions;
    if (typeof match === "number") {
        return;
    }
    if (Curry._2(match._4, stateMachine.state.contents, $$event)) {
        return;
    }
    if (typeof match !== "number") {
        if (match.TAG === /* DoLogTransitions */ 0) {
            var stringifySideEffect = match._2;
            var stringifyState = match._0;
            if (typeof update !== "number") {
                switch(update.TAG | 0){
                    case /* Update */ 0:
                        var nextState = update._0;
                        logYellow("Next state =");
                        var tmp;
                        try {
                            tmp = Caml_obj.caml_equal(nextState, stateMachine.state.contents) ? " (same state)" : "";
                        } catch (raw_msg) {
                            var msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
                            if (msg.RE_EXN_ID === "Invalid_argument") {
                                if (msg._1 === "equal: functional value") {
                                    tmp = "(unknown state equality)";
                                } else {
                                    throw msg;
                                }
                            } else {
                                throw msg;
                            }
                        }
                        logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, nextState) + tmp));
                        logYellow("No side effects");
                        break;
                    case /* SideEffects */ 1:
                        logYellow("Next state =");
                        logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, stateMachine.state.contents) + " (same state)"));
                        var sideEffectsWithIds = List.mapi(function(i, sideEffect) {
                            return [
                                sideEffect,
                                stateMachine.nextSideEffectId.contents + i | 0
                            ];
                        }, update._0);
                        logSideEffectsWithIds(undefined, "Parallel", stringifySideEffect, sideEffectsWithIds);
                        break;
                    case /* SerialSideEffects */ 2:
                        logYellow("Next state =");
                        logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, stateMachine.state.contents) + " (same state)"));
                        var sideEffectsWithIds$1 = List.mapi(function(i, sideEffect) {
                            return [
                                sideEffect,
                                stateMachine.nextSideEffectId.contents + i | 0
                            ];
                        }, update._0);
                        logSideEffectsWithIds(undefined, "Serial", stringifySideEffect, sideEffectsWithIds$1);
                        break;
                    case /* UpdateWithSideEffects */ 3:
                        var nextState$1 = update._0;
                        logYellow("Next state = ");
                        var tmp$1;
                        try {
                            tmp$1 = Caml_obj.caml_equal(nextState$1, stateMachine.state.contents) ? " (same state)" : "";
                        } catch (raw_msg$1) {
                            var msg$1 = Caml_js_exceptions.internalToOCamlException(raw_msg$1);
                            if (msg$1.RE_EXN_ID === "Invalid_argument") {
                                if (msg$1._1 === "equal: functional value") {
                                    tmp$1 = "(unknown state equality)";
                                } else {
                                    throw msg$1;
                                }
                            } else {
                                throw msg$1;
                            }
                        }
                        logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, nextState$1) + tmp$1));
                        var sideEffectsWithIds$2 = List.mapi(function(i, sideEffect) {
                            return [
                                sideEffect,
                                stateMachine.nextSideEffectId.contents + i | 0
                            ];
                        }, update._1);
                        logSideEffectsWithIds(undefined, "Parallel", stringifySideEffect, sideEffectsWithIds$2);
                        break;
                    case /* UpdateWithSerialSideEffects */ 4:
                        var nextState$2 = update._0;
                        logYellow("Next state = ");
                        var tmp$2;
                        try {
                            tmp$2 = Caml_obj.caml_equal(nextState$2, stateMachine.state.contents) ? " (same state)" : "";
                        } catch (raw_msg$2) {
                            var msg$2 = Caml_js_exceptions.internalToOCamlException(raw_msg$2);
                            if (msg$2.RE_EXN_ID === "Invalid_argument") {
                                if (msg$2._1 === "equal: functional value") {
                                    tmp$2 = "(unknown state equality)";
                                } else {
                                    throw msg$2;
                                }
                            } else {
                                throw msg$2;
                            }
                        }
                        logYellow(StringUtils$SmartcutsMacros.indent(undefined, 1) + (Curry._1(stringifyState, nextState$2) + tmp$2));
                        var sideEffectsWithIds$3 = List.mapi(function(i, sideEffect) {
                            return [
                                sideEffect,
                                stateMachine.nextSideEffectId.contents + i | 0
                            ];
                        }, update._1);
                        logSideEffectsWithIds(undefined, "Serial", stringifySideEffect, sideEffectsWithIds$3);
                        break;
                }
            }
            return logYellow("\n");
        }
        var transition = {
            eventId: eventId,
            event: $$event,
            eventSource: eventSource,
            update: update,
            sideEffectIds: sideEffectIds
        };
        var json = transition_encode(match._0, match._1, match._3, match._2, transition);
        fetch("https://trysmartcuts.com" + "/api/log_transition", Fetch.RequestInit.make(/* Post */ 2, {
            "Content-Type": "application/json"
        }, Caml_option.some(JSON.stringify(json)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined));
        return;
    }
}
function dispatch(eventSource, _event, stateMachine) {
    while(true){
        var $$event1 = _event;
        var eventId1 = stateMachine.nextEventId.contents;
        stateMachine.nextEventId.contents = stateMachine.nextEventId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextEventId.contents + 1 | 0;
        maybeLogTransition($$event1, eventSource, stateMachine);
        var update;
        try {
            update = Curry._3(stateMachine.reducer, stateMachine.state.contents, $$event1, eventId1);
        } catch (raw_jsExn) {
            var jsExn = Caml_js_exceptions.internalToOCamlException(raw_jsExn);
            if (jsExn.RE_EXN_ID === Js_exn.$$Error) {
                var failure_failWith = {
                    TAG: /* FailWithJsExn */ 1,
                    _0: jsExn._1
                };
                var failure_context = {
                    TAG: /* DidErrDuringTransition */ 0,
                    _0: {
                        state: stateMachine.state.contents,
                        event: $$event1,
                        eventId: eventId1,
                        extraMessage: ""
                    }
                };
                var failure = {
                    failWith: failure_failWith,
                    context: failure_context
                };
                var failEvent = Curry._1(stateMachine.failEventFromFailure, failure);
                _event = failEvent;
                continue;
            }
            throw jsExn;
        }
        if (update === /* Ignore */ 0) {
            var match = stateMachine.options.logTransitions;
            if (typeof match !== "number" && match.TAG === /* DoLogTransitions */ 0) {
                if (Curry._2(match._4, stateMachine.state.contents, $$event1)) {} else {
                    Curry._1(Log$SmartcutsMacros.stateMachineCore.log1, "IGNORING!!");
                }
            }
        }
        var tmp;
        if (typeof update === "number") {
            tmp = Promise.resolve(undefined);
        } else {
            switch(update.TAG | 0){
                case /* Update */ 0:
                    stateMachine.state.contents = update._0;
                    stateMachine.history.contents = recordTransition(eventId1, $$event1, eventSource, update, /* [] */ 0, stateMachine.history.contents);
                    maybeLogUpdate(stateMachine, update, $$event1, eventId1, eventSource, /* [] */ 0);
                    tmp = Promise.resolve(undefined);
                    break;
                case /* SideEffects */ 1:
                    var sideEffectsWithIds = List.map(function(sideEffect) {
                        var sideEffectId = stateMachine.nextSideEffectId.contents;
                        stateMachine.nextSideEffectId.contents = stateMachine.nextSideEffectId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextSideEffectId.contents + 1 | 0;
                        return [
                            sideEffect,
                            sideEffectId
                        ];
                    }, update._0);
                    stateMachine.history.contents = recordTransition(eventId1, $$event1, eventSource, update, List.map(function(prim) {
                        return prim[1];
                    }, sideEffectsWithIds), stateMachine.history.contents);
                    maybeLogUpdate(stateMachine, update, $$event1, eventId1, eventSource, Belt_List.map(sideEffectsWithIds, function(prim) {
                        return prim[1];
                    }));
                    tmp = Promise.all($$Array.of_list(List.map(function(param) {
                        return Curry._3(stateMachine.execSideEffect, param[1], stateMachine, param[0]);
                    }, sideEffectsWithIds))).then(function(param) {
                        return Promise.resolve(undefined);
                    });
                    break;
                case /* SerialSideEffects */ 2:
                    var sideEffectsWithIds$1 = List.map(function(sideEffect) {
                        var sideEffectId = stateMachine.nextSideEffectId.contents;
                        stateMachine.nextSideEffectId.contents = stateMachine.nextSideEffectId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextSideEffectId.contents + 1 | 0;
                        return [
                            sideEffect,
                            sideEffectId
                        ];
                    }, update._0);
                    stateMachine.history.contents = recordTransition(eventId1, $$event1, eventSource, update, List.map(function(prim) {
                        return prim[1];
                    }, sideEffectsWithIds$1), stateMachine.history.contents);
                    maybeLogUpdate(stateMachine, update, $$event1, eventId1, eventSource, Belt_List.map(sideEffectsWithIds$1, function(prim) {
                        return prim[1];
                    }));
                    tmp = List.fold_left(function(promise, param) {
                        var sideEffectId = param[1];
                        var sideEffect = param[0];
                        return promise.then(function(param) {
                            return Curry._3(stateMachine.execSideEffect, sideEffectId, stateMachine, sideEffect);
                        });
                    }, Promise.resolve(undefined), sideEffectsWithIds$1);
                    break;
                case /* UpdateWithSideEffects */ 3:
                    var sideEffects = update._1;
                    var match$1 = stateMachine.options.logTransitions;
                    if (typeof match$1 !== "number" && !Curry._2(match$1._4, stateMachine.state.contents, $$event1) && typeof match$1 !== "number" && match$1.TAG === /* DoLogTransitions */ 0) {
                        Curry._2(Log$SmartcutsMacros.stateMachineCore.log2, "Side effect count", List.length(sideEffects));
                    }
                    var sideEffectsWithIds$2 = List.map(function(sideEffect) {
                        var sideEffectId = stateMachine.nextSideEffectId.contents;
                        stateMachine.nextSideEffectId.contents = stateMachine.nextSideEffectId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextSideEffectId.contents + 1 | 0;
                        return [
                            sideEffect,
                            sideEffectId
                        ];
                    }, sideEffects);
                    stateMachine.state.contents = update._0;
                    stateMachine.history.contents = recordTransition(eventId1, $$event1, eventSource, update, List.map(function(prim) {
                        return prim[1];
                    }, sideEffectsWithIds$2), stateMachine.history.contents);
                    maybeLogUpdate(stateMachine, update, $$event1, eventId1, eventSource, Belt_List.map(sideEffectsWithIds$2, function(prim) {
                        return prim[1];
                    }));
                    tmp = Promise.all($$Array.of_list(List.map(function(param) {
                        return Curry._3(stateMachine.execSideEffect, param[1], stateMachine, param[0]);
                    }, sideEffectsWithIds$2))).then(function(param) {
                        return Promise.resolve(undefined);
                    }).catch(function(err) {
                        console.error(err);
                        return Util$SmartcutsMacros.logAndRaiseJsError("Uncaught exception during UpdateWithSideEffects");
                    });
                    break;
                case /* UpdateWithSerialSideEffects */ 4:
                    var sideEffectsWithIds$3 = List.map(function(sideEffect) {
                        var sideEffectId = stateMachine.nextSideEffectId.contents;
                        stateMachine.nextSideEffectId.contents = stateMachine.nextSideEffectId.contents === Number.MAX_SAFE_INTEGER ? 1 : stateMachine.nextSideEffectId.contents + 1 | 0;
                        return [
                            sideEffect,
                            sideEffectId
                        ];
                    }, update._1);
                    stateMachine.state.contents = update._0;
                    stateMachine.history.contents = recordTransition(eventId1, $$event1, eventSource, update, List.map(function(prim) {
                        return prim[1];
                    }, sideEffectsWithIds$3), stateMachine.history.contents);
                    maybeLogUpdate(stateMachine, update, $$event1, eventId1, eventSource, Belt_List.map(sideEffectsWithIds$3, function(prim) {
                        return prim[1];
                    }));
                    tmp = List.fold_left(function(promise, param) {
                        var sideEffectId = param[1];
                        var sideEffect = param[0];
                        return promise.then(function(param) {
                            return Curry._3(stateMachine.execSideEffect, sideEffectId, stateMachine, sideEffect);
                        });
                    }, Promise.resolve(undefined), sideEffectsWithIds$3);
                    break;
            }
        }
        return tmp.catch(function($$event, eventId) {
            return function(error) {
                var failure_failWith = {
                    TAG: /* FailWithJsPromiseError */ 2,
                    _0: error
                };
                var failure_context = {
                    TAG: /* DidErrDuringTransition */ 0,
                    _0: {
                        state: stateMachine.state.contents,
                        event: $$event,
                        eventId: eventId,
                        extraMessage: ""
                    }
                };
                var failure = {
                    failWith: failure_failWith,
                    context: failure_context
                };
                var failEvent = Curry._1(stateMachine.failEventFromFailure, failure);
                return dispatch(eventSource, failEvent, stateMachine);
            };
        }($$event1, eventId1));
    }
    ;
}
function wrapExecSideEffectToHandleJsPromiseError(failEventFromFailure, execSideEffect, sideEffectId, stateMachine, sideEffect) {
    var promise;
    try {
        promise = Curry._3(execSideEffect, sideEffectId, stateMachine, sideEffect);
    } catch (raw_jsExn) {
        var jsExn = Caml_js_exceptions.internalToOCamlException(raw_jsExn);
        if (jsExn.RE_EXN_ID === Js_exn.$$Error) {
            return dispatch({
                TAG: /* ViaSideEffect */ 1,
                _0: sideEffect,
                _1: sideEffectId
            }, Curry._1(failEventFromFailure, {
                failWith: {
                    TAG: /* FailWithJsExn */ 1,
                    _0: jsExn._1
                },
                context: {
                    TAG: /* DidErrDuringSideEffect */ 1,
                    _0: {
                        sideEffectId: sideEffectId,
                        sideEffect: sideEffect,
                        maybeState: Caml_option.some(stateMachine.state.contents),
                        extraMessage: ""
                    }
                }
            }), stateMachine);
        }
        throw jsExn;
    }
    return promise.catch(function(error) {
        return dispatch({
            TAG: /* ViaSideEffect */ 1,
            _0: sideEffect,
            _1: sideEffectId
        }, Curry._1(failEventFromFailure, {
            failWith: {
                TAG: /* FailWithJsPromiseError */ 2,
                _0: error
            },
            context: {
                TAG: /* DidErrDuringSideEffect */ 1,
                _0: {
                    sideEffectId: sideEffectId,
                    sideEffect: sideEffect,
                    maybeState: Caml_option.some(stateMachine.state.contents),
                    extraMessage: ""
                }
            }
        }), stateMachine);
    });
}
function wrapChildExecSideEffectToHandleJsPromiseError(failEventFromFailure, buildFailureWithJsPromiseError, buildFailureWithJsExnError, execSideEffect, maybeStateFromRootState, dispatch1, sideEffectId, stateMachine, sideEffect) {
    var promise;
    try {
        promise = Curry._5(execSideEffect, maybeStateFromRootState, dispatch1, sideEffectId, stateMachine, sideEffect);
    } catch (raw_jsExnError) {
        var jsExnError = Caml_js_exceptions.internalToOCamlException(raw_jsExnError);
        if (jsExnError.RE_EXN_ID === Js_exn.$$Error) {
            return Curry._3(dispatch1, {
                TAG: /* ViaSideEffect */ 1,
                _0: sideEffect,
                _1: sideEffectId
            }, Curry._1(failEventFromFailure, Curry._2(buildFailureWithJsExnError, jsExnError._1, {
                sideEffectId: sideEffectId,
                sideEffect: sideEffect,
                maybeState: Curry._1(maybeStateFromRootState, stateMachine.state.contents),
                extraMessage: ""
            })), stateMachine);
        }
        throw jsExnError;
    }
    return promise.catch(function(jsPromiseError) {
        return Curry._3(dispatch1, {
            TAG: /* ViaSideEffect */ 1,
            _0: sideEffect,
            _1: sideEffectId
        }, Curry._1(failEventFromFailure, Curry._2(buildFailureWithJsPromiseError, jsPromiseError, {
            sideEffectId: sideEffectId,
            sideEffect: sideEffect,
            maybeState: Curry._1(maybeStateFromRootState, stateMachine.state.contents),
            extraMessage: ""
        })), stateMachine);
    });
}
function wrapReducerToHandleJsExn(buildFailureContext, failEventFromFailure, buildSideEffectDispatch, reducer, state, $$event, eventId) {
    try {
        return Curry._3(reducer, state, $$event, eventId);
    } catch (raw_jsExn) {
        var jsExn = Caml_js_exceptions.internalToOCamlException(raw_jsExn);
        if (jsExn.RE_EXN_ID === Js_exn.$$Error) {
            var failure_failWith = {
                TAG: /* FailWithJsExn */ 1,
                _0: jsExn._1
            };
            var failure_context = Curry._1(buildFailureContext, {
                state: state,
                event: $$event,
                eventId: eventId,
                extraMessage: ""
            });
            var failure = {
                failWith: failure_failWith,
                context: failure_context
            };
            var failEvent = Curry._1(failEventFromFailure, failure);
            return {
                TAG: /* SideEffects */ 1,
                _0: {
                    hd: Curry._1(buildSideEffectDispatch, failEvent),
                    tl: /* [] */ 0
                }
            };
        }
        throw jsExn;
    }
}
function wrapCallback0ToHandleJsExn(failEventFromFailure, dispatch2, buildListener, exceptionToOtherFailureReason, rootStateMachine, defaultReturn, listenerFn, param) {
    try {
        return Curry._1(listenerFn, undefined);
    } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        var listener = Curry._1(buildListener, undefined);
        var failure_failWith = exn.RE_EXN_ID === Js_exn.$$Error ? {
            TAG: /* FailWithJsExn */ 1,
            _0: exn._1
        } : {
            TAG: /* FailWithOtherReason */ 0,
            _0: Curry._1(exceptionToOtherFailureReason, exn)
        };
        var failure_context = {
            TAG: /* DidErrDuringListener */ 2,
            _0: {
                listener: listener,
                extraMessage: ""
            }
        };
        var failure = {
            failWith: failure_failWith,
            context: failure_context
        };
        var failEvent = Curry._1(failEventFromFailure, failure);
        Curry._3(dispatch2, {
            TAG: /* ViaListener */ 0,
            _0: listener
        }, failEvent, rootStateMachine);
        if (defaultReturn !== undefined) {
            return Caml_option.valFromOption(defaultReturn);
        }
        throw exn;
    }
}
function wrapCallback1ToHandleJsExn(failEventFromFailure, dispatch3, buildListener, exceptionToOtherFailureReason, rootStateMachine, defaultReturn, listenerFn, arg) {
    try {
        return Curry._1(listenerFn, arg);
    } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        var listener = Curry._1(buildListener, arg);
        var failure_failWith = exn.RE_EXN_ID === Js_exn.$$Error ? {
            TAG: /* FailWithJsExn */ 1,
            _0: exn._1
        } : {
            TAG: /* FailWithOtherReason */ 0,
            _0: Curry._1(exceptionToOtherFailureReason, exn)
        };
        var failure_context = {
            TAG: /* DidErrDuringListener */ 2,
            _0: {
                listener: listener,
                extraMessage: ""
            }
        };
        var failure = {
            failWith: failure_failWith,
            context: failure_context
        };
        var failEvent = Curry._1(failEventFromFailure, failure);
        Curry._3(dispatch3, {
            TAG: /* ViaListener */ 0,
            _0: listener
        }, failEvent, rootStateMachine);
        if (defaultReturn !== undefined) {
            return Caml_option.valFromOption(defaultReturn);
        }
        throw exn;
    }
}
function wrapCallback2ToHandleJsExn(failEventFromFailure, dispatch4, buildListener, exceptionToOtherFailureReason, rootStateMachine, defaultReturn, listenerFn, arg1, arg2) {
    try {
        return Curry._2(listenerFn, arg1, arg2);
    } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        var listener = Curry._2(buildListener, arg1, arg2);
        var failure_failWith = exn.RE_EXN_ID === Js_exn.$$Error ? {
            TAG: /* FailWithJsExn */ 1,
            _0: exn._1
        } : {
            TAG: /* FailWithOtherReason */ 0,
            _0: Curry._1(exceptionToOtherFailureReason, exn)
        };
        var failure_context = {
            TAG: /* DidErrDuringListener */ 2,
            _0: {
                listener: listener,
                extraMessage: ""
            }
        };
        var failure = {
            failWith: failure_failWith,
            context: failure_context
        };
        var failEvent = Curry._1(failEventFromFailure, failure);
        Curry._3(dispatch4, {
            TAG: /* ViaListener */ 0,
            _0: listener
        }, failEvent, rootStateMachine);
        if (defaultReturn !== undefined) {
            return Caml_option.valFromOption(defaultReturn);
        }
        throw exn;
    }
}
function make$1(maxHistory, logTransitionsOpt, initialState, failEventFromFailure, buildSideEffectDispatch, reducer, execSideEffect, param4) {
    var logTransitions = logTransitionsOpt !== undefined ? logTransitionsOpt : /* DontLogTransitions */ 0;
    return {
        state: {
            contents: initialState
        },
        history: {
            contents: {
                firstState: initialState,
                transitions: [],
                maxLength: maxHistory
            }
        },
        nextEventId: {
            contents: 1
        },
        nextSideEffectId: {
            contents: 1
        },
        lastFailureTimestampsByKey: undefined,
        reducer: function(param, param$1, param$2) {
            return wrapReducerToHandleJsExn(function(transitionErrorContext) {
                return {
                    TAG: /* DidErrDuringTransition */ 0,
                    _0: transitionErrorContext
                };
            }, failEventFromFailure, buildSideEffectDispatch, reducer, param, param$1, param$2);
        },
        execSideEffect: function(param, param$1, param$2) {
            return wrapExecSideEffectToHandleJsPromiseError(failEventFromFailure, execSideEffect, param, param$1, param$2);
        },
        failEventFromFailure: failEventFromFailure,
        options: {
            logTransitions: logTransitions
        }
    };
}
function createDispatchChildEvent(dispatch5, wrapChildEvent, wrapChildSideEffect, wrapChildListener) {
    return function(eventSource, $$event, rootStateMachine) {
        var tmp;
        tmp = typeof eventSource === "number" ? /* ViaInitialize */ 0 : eventSource.TAG === /* ViaListener */ 0 ? {
            TAG: /* ViaListener */ 0,
            _0: Curry._1(wrapChildListener, eventSource._0)
        } : {
            TAG: /* ViaSideEffect */ 1,
            _0: Curry._1(wrapChildSideEffect, eventSource._0),
            _1: eventSource._1
        };
        return Curry._3(dispatch5, tmp, Curry._1(wrapChildEvent, $$event), rootStateMachine);
    };
}
function hoistChildReducer(stateWrapper, sideEffectWrapper, childFailEventFromChildFailure, buildChildFailureContext, createChildSideEffectDispatchEventFromChildEvent, childReducer) {
    var childReducerWithExnHandling = function childReducerWithExnHandling(param, param$1, param$2) {
        return wrapReducerToHandleJsExn(buildChildFailureContext, childFailEventFromChildFailure, Curry.__1(createChildSideEffectDispatchEventFromChildEvent), childReducer, param, param$1, param$2);
    };
    return function(childState, childEvent, eventId) {
        var newRecordingState = childReducerWithExnHandling(childState, childEvent, eventId);
        if (typeof newRecordingState === "number") {
            return /* Ignore */ 0;
        }
        switch(newRecordingState.TAG | 0){
            case /* Update */ 0:
                return {
                    TAG: /* Update */ 0,
                    _0: Curry._1(stateWrapper, newRecordingState._0)
                };
            case /* SideEffects */ 1:
                return {
                    TAG: /* SideEffects */ 1,
                    _0: List.map(Curry.__1(sideEffectWrapper), newRecordingState._0)
                };
            case /* SerialSideEffects */ 2:
                return {
                    TAG: /* SideEffects */ 1,
                    _0: List.map(sideEffectWrapper, newRecordingState._0)
                };
            case /* UpdateWithSideEffects */ 3:
                return {
                    TAG: /* UpdateWithSideEffects */ 3,
                    _0: Curry._1(stateWrapper, newRecordingState._0),
                    _1: List.map(sideEffectWrapper, newRecordingState._1)
                };
            case /* UpdateWithSerialSideEffects */ 4:
                return {
                    TAG: /* UpdateWithSerialSideEffects */ 4,
                    _0: Curry._1(stateWrapper, newRecordingState._0),
                    _1: List.map(sideEffectWrapper, newRecordingState._1)
                };
        }
    };
}
function extractStateFromUpdate(update) {
    if (typeof update === "number") {
        return;
    }
    switch(update.TAG | 0){
        case /* Update */ 0:
        case /* UpdateWithSideEffects */ 3:
        case /* UpdateWithSerialSideEffects */ 4:
            return Caml_option.some(update._0);
        default:
            return;
    }
}
function recordFailureOccurrence(key, stateMachine) {
    var nextLastFailureTimestampsByKey = Belt_MapString.update(stateMachine.lastFailureTimestampsByKey, key, function(maybeVal) {
        var arrToAppendTo = maybeVal !== undefined ? maybeVal.length === 4 ? Belt_Array.slice(maybeVal, 1, 3) : maybeVal : [];
        return $$Array.append(arrToAppendTo, [
            Date.now()
        ]);
    });
    return {
        state: stateMachine.state,
        history: stateMachine.history,
        nextEventId: stateMachine.nextEventId,
        nextSideEffectId: stateMachine.nextSideEffectId,
        lastFailureTimestampsByKey: nextLastFailureTimestampsByKey,
        reducer: stateMachine.reducer,
        execSideEffect: stateMachine.execSideEffect,
        failEventFromFailure: stateMachine.failEventFromFailure,
        options: stateMachine.options
    };
}
function isLikelyInfiniteFailureLoop(key, param) {
    var now = Date.now();
    var lastFailureTimestamps = Belt_MapString.get(param.lastFailureTimestampsByKey, key);
    if (lastFailureTimestamps !== undefined) {
        return Belt_Array.keep(lastFailureTimestamps, function(ts) {
            return now - ts < 1000.0;
        }).length === 4;
    } else {
        return false;
    }
}
var maxFailureTimestamps = 4;
exports.update_encode = update_encode;
exports.update_decode = update_decode;
exports.stringifyUpdate = stringifyUpdate;
exports.eventSource_encode = eventSource_encode;
exports.eventSource_decode = eventSource_decode;
exports.mapEventSource = mapEventSource;
exports.stringifyEventSource = stringifyEventSource;
exports.$$History = $$History;
exports.Failure = Failure;
exports.Exit = Exit;
exports.logYellow = logYellow;
exports.logSideEffects = logSideEffects;
exports.logSideEffectsWithIds = logSideEffectsWithIds;
exports.maybeLogTransition = maybeLogTransition;
exports.maybeLogUpdate = maybeLogUpdate;
exports.dispatch = dispatch;
exports.wrapExecSideEffectToHandleJsPromiseError = wrapExecSideEffectToHandleJsPromiseError;
exports.wrapChildExecSideEffectToHandleJsPromiseError = wrapChildExecSideEffectToHandleJsPromiseError;
exports.wrapReducerToHandleJsExn = wrapReducerToHandleJsExn;
exports.wrapCallback0ToHandleJsExn = wrapCallback0ToHandleJsExn;
exports.wrapCallback1ToHandleJsExn = wrapCallback1ToHandleJsExn;
exports.wrapCallback2ToHandleJsExn = wrapCallback2ToHandleJsExn;
exports.make = make$1;
exports.createDispatchChildEvent = createDispatchChildEvent;
exports.hoistChildReducer = hoistChildReducer;
exports.extractStateFromUpdate = extractStateFromUpdate;
exports.maxFailureTimestamps = maxFailureTimestamps;
exports.recordFailureOccurrence = recordFailureOccurrence;
exports.isLikelyInfiniteFailureLoop = isLikelyInfiniteFailureLoop; /* logYellow Not a pure module */ 


/***/ }),

/***/ 79764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Uuid = __webpack_require__(97466);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var Constants = {
    defaultWaitMs: 250
};
var uuid_encode = Decco.stringToJson;
var uuid_decode = Decco.stringFromJson;
function entry_encode(encoder_event, encoder_firstCallData, v) {
    return Js_dict.fromArray([
        [
            "lastEventTime",
            Decco.floatToJson(v.lastEventTime)
        ],
        [
            "waitMs",
            Decco.floatToJson(v.waitMs)
        ],
        [
            "timeoutId",
            Decco.optionToJson(DeccoUtils$SmartcutsMacros.timeoutId_encode, v.timeoutId)
        ],
        [
            "event",
            Curry._1(encoder_event, v.event)
        ],
        [
            "firstCallData",
            Curry._1(encoder_firstCallData, v.firstCallData)
        ]
    ]);
}
function entry_decode(decoder_event, decoder_firstCallData, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var lastEventTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastEventTime"), null));
    if (lastEventTime.TAG === /* Ok */ 0) {
        var waitMs = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waitMs"), null));
        if (waitMs.TAG === /* Ok */ 0) {
            var timeoutId = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.timeoutId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeoutId"), null));
            if (timeoutId.TAG === /* Ok */ 0) {
                var $$event = Curry._1(decoder_event, Belt_Option.getWithDefault(Js_dict.get(dict$1, "event"), null));
                if ($$event.TAG === /* Ok */ 0) {
                    var firstCallData = Curry._1(decoder_firstCallData, Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstCallData"), null));
                    if (firstCallData.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                lastEventTime: lastEventTime._0,
                                waitMs: waitMs._0,
                                timeoutId: timeoutId._0,
                                event: $$event._0,
                                firstCallData: firstCallData._0
                            }
                        };
                    }
                    var e = firstCallData._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".firstCallData" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = $$event._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".event" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = timeoutId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".timeoutId" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = waitMs._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".waitMs" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = lastEventTime._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".lastEventTime" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function t_encode(encoder_event, encoder_firstCallData, v) {
    return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(function(param) {
        return entry_encode(encoder_event, encoder_firstCallData, param);
    }, v);
}
function t_decode(decoder_event, decoder_firstCallData, v) {
    return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(function(param) {
        return entry_decode(decoder_event, decoder_firstCallData, param);
    }, v);
}
function mapEntry(mapEvent, mapFirstCallData, entry) {
    return {
        lastEventTime: entry.lastEventTime,
        waitMs: entry.waitMs,
        timeoutId: entry.timeoutId,
        event: Curry._1(mapEvent, entry.event),
        firstCallData: Curry._1(mapFirstCallData, entry.firstCallData)
    };
}
function map(mapEvent, mapFirstCallData, manager) {
    return Belt_MapString.map(manager, function(param) {
        return mapEntry(mapEvent, mapFirstCallData, param);
    });
}
function updateTimeoutId(id, timeoutId, debouncedEntries) {
    return Belt_MapString.update(debouncedEntries, id, function(maybeEntry) {
        if (maybeEntry !== undefined) {
            return {
                lastEventTime: maybeEntry.lastEventTime,
                waitMs: maybeEntry.waitMs,
                timeoutId: Caml_option.some(timeoutId),
                event: maybeEntry.event,
                firstCallData: maybeEntry.firstCallData
            };
        }
    });
}
function clearTimeoutId(id, debouncedEntries) {
    return Belt_MapString.update(debouncedEntries, id, function(maybeEntry) {
        if (maybeEntry !== undefined) {
            return {
                lastEventTime: maybeEntry.lastEventTime,
                waitMs: maybeEntry.waitMs,
                timeoutId: undefined,
                event: maybeEntry.event,
                firstCallData: maybeEntry.firstCallData
            };
        }
    });
}
function removeEntry(id, debouncedEntries) {
    return Belt_MapString.remove(debouncedEntries, id);
}
function maybeDebounceEvent($$event, timestamp, firstCallData, isDebouncable, doesEventMatchEntry, waitMsOpt, debouncedEntries) {
    var waitMs = waitMsOpt !== undefined ? waitMsOpt : 250;
    if (!Curry._1(isDebouncable, $$event)) {
        return /* NoDebounce */ 0;
    }
    var match = Belt_MapString.findFirstBy(debouncedEntries, function(_id, entry) {
        return Curry._2(doesEventMatchEntry, $$event, entry);
    });
    if (match !== undefined) {
        var matchingEntry = match[1];
        var id = match[0];
        if (timestamp - matchingEntry.lastEventTime >= matchingEntry.waitMs) {
            return {
                TAG: /* ShouldInvoke */ 2,
                _0: matchingEntry,
                _1: Belt_MapString.remove(debouncedEntries, id)
            };
        }
        var updatedEntry_waitMs = matchingEntry.waitMs;
        var updatedEntry_timeoutId = matchingEntry.timeoutId;
        var updatedEntry_firstCallData = matchingEntry.firstCallData;
        var updatedEntry = {
            lastEventTime: timestamp,
            waitMs: updatedEntry_waitMs,
            timeoutId: updatedEntry_timeoutId,
            event: $$event,
            firstCallData: updatedEntry_firstCallData
        };
        return {
            TAG: /* DidUpdateDebounceEvent */ 1,
            _0: id,
            _1: updatedEntry,
            _2: Belt_MapString.set(debouncedEntries, id, updatedEntry)
        };
    }
    var id$1 = Uuid.v1();
    var debouncedEvent = {
        lastEventTime: timestamp,
        waitMs: waitMs,
        timeoutId: undefined,
        event: $$event,
        firstCallData: firstCallData
    };
    return {
        TAG: /* DidAddNewDebounceEvent */ 0,
        _0: id$1,
        _1: debouncedEvent,
        _2: Belt_MapString.set(debouncedEntries, id$1, debouncedEvent)
    };
}
function handleTimerExpired(id, debouncedEntries) {
    var matchingEntry = Belt_MapString.get(debouncedEntries, id);
    if (matchingEntry !== undefined) {
        if (Date.now() - matchingEntry.lastEventTime >= matchingEntry.waitMs) {
            return [
                Belt_MapString.remove(debouncedEntries, id),
                {
                    TAG: /* DispatchDidFlushDebouncedEvent */ 1,
                    _0: matchingEntry
                }
            ];
        } else {
            return [
                clearTimeoutId(id, debouncedEntries),
                {
                    TAG: /* ResetDebounceTimeout */ 0,
                    _0: id,
                    _1: undefined
                }
            ];
        }
    }
}
var empty;
var size = Belt_MapString.size;
exports.Constants = Constants;
exports.uuid_encode = uuid_encode;
exports.uuid_decode = uuid_decode;
exports.entry_encode = entry_encode;
exports.entry_decode = entry_decode;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.mapEntry = mapEntry;
exports.map = map;
exports.empty = empty;
exports.size = size;
exports.updateTimeoutId = updateTimeoutId;
exports.clearTimeoutId = clearTimeoutId;
exports.removeEntry = removeEntry;
exports.maybeDebounceEvent = maybeDebounceEvent;
exports.handleTimerExpired = handleTimerExpired; /* uuid Not a pure module */ 


/***/ }),

/***/ 93366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Caml_int32 = __webpack_require__(48723);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Webapi__Dom__Text = __webpack_require__(32348);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var RegExUtils$SmartcutsMacros = __webpack_require__(13257);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__DataTransfer$SmartcutsMacros = __webpack_require__(44129);
var Selection__Snapshot$SmartcutsMacros = __webpack_require__(27836);
var Selection__ContentEditableSelectionOrCursor$SmartcutsMacros = __webpack_require__(92190);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "startIndex",
            Decco.intToJson(v.startIndex)
        ],
        [
            "endIndex",
            Decco.intToJson(v.endIndex)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var startIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startIndex"), null));
    if (startIndex.TAG === /* Ok */ 0) {
        var endIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endIndex"), null));
        if (endIndex.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    startIndex: startIndex._0,
                    endIndex: endIndex._0
                }
            };
        }
        var e = endIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".endIndex" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = startIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".startIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function adjustByOffset(offset, param) {
    return {
        startIndex: param.startIndex + offset | 0,
        endIndex: param.endIndex + offset | 0
    };
}
function containsIndex(index, param) {
    if (param.startIndex <= index) {
        return index <= param.endIndex;
    } else {
        return false;
    }
}
function length(param) {
    return (param.endIndex - param.startIndex | 0) + 1 | 0;
}
var ContentEditableInnerTextPosition = {
    t_encode: t_encode,
    t_decode: t_decode,
    adjustByOffset: adjustByOffset,
    containsIndex: containsIndex,
    length: length
};
var t_encode$1 = t_encode;
var t_decode$1 = t_decode;
function fromCanonicalNewLineCountAndRawNewLineCount(startIndex, canonical, raw) {
    var newLinesPerCanonicalNewLine = Caml_int32.div(raw, canonical);
    return Belt_Array.mapWithIndex(Caml_array.make(canonical, 0), function(i, param) {
        var match = i === (canonical - 1 | 0);
        var match$1 = Caml_int32.mod_(raw, canonical);
        return {
            startIndex: startIndex + Math.imul(i, newLinesPerCanonicalNewLine) | 0,
            endIndex: ((startIndex + Math.imul(i, newLinesPerCanonicalNewLine) | 0) + (match && match$1 !== 0 ? match$1 : newLinesPerCanonicalNewLine) | 0) - 1 | 0
        };
    });
}
function fromExpectedEntersAndString(expectedEnters, str) {
    var actualNumNewLines = StringUtils$SmartcutsMacros.countNewLines(str);
    if (expectedEnters > 0) {
        var newLinesPerCanonicalNewLine = Caml_int32.div(actualNumNewLines, expectedEnters);
        Curry._2(Log$SmartcutsMacros.recordingContentEditing.warn2, "newLinesPerCanonicalNewLine", newLinesPerCanonicalNewLine);
        if (StringUtils$SmartcutsMacros.isComposedOfJustNewLines(str)) {
            return fromCanonicalNewLineCountAndRawNewLineCount(0, expectedEnters, actualNumNewLines);
        }
        if (newLinesPerCanonicalNewLine === 0) {
            return [];
        }
        var re = RegExUtils$SmartcutsMacros.makeNewLinesRegex("g", newLinesPerCanonicalNewLine);
        var index = str.search(re);
        if (index !== -1) {
            Curry._2(Log$SmartcutsMacros.recordingContentEditing.warn2, "index", index);
            return $$Array.append([
                {
                    startIndex: index,
                    endIndex: (index + newLinesPerCanonicalNewLine | 0) - 1 | 0
                }
            ], fromExpectedEntersAndString(expectedEnters - newLinesPerCanonicalNewLine | 0, str.slice(index + newLinesPerCanonicalNewLine | 0)));
        } else {
            return [];
        }
    }
    var index$1 = str.search(RegExUtils$SmartcutsMacros.newLineRe);
    if (index$1 !== -1) {
        return $$Array.append([
            {
                startIndex: index$1,
                endIndex: index$1
            }
        ], fromExpectedEntersAndString(expectedEnters, str.slice(index$1 + 1 | 0)));
    } else {
        return [];
    }
}
function fromCanonicalValueAndRawValue(_startIndexOpt, _canonical, _raw) {
    while(true){
        var startIndexOpt = _startIndexOpt;
        var raw = _raw;
        var canonical = _canonical;
        var startIndex = startIndexOpt !== undefined ? startIndexOpt : 0;
        var match = canonical.search(RegExUtils$SmartcutsMacros.nonNewLineRe);
        var match$1 = raw.search(RegExUtils$SmartcutsMacros.nonNewLineRe);
        if (match === -1) {
            if (match$1 !== -1) {
                console.warn("Expected canonical value to have at least 1 newline if raw value has a newline");
                return [];
            } else {
                return [];
            }
        }
        if (match === 0 && match$1 === 0) {
            var match$2 = canonical.search(RegExUtils$SmartcutsMacros.newLineRe);
            var match$3 = raw.search(RegExUtils$SmartcutsMacros.newLineRe);
            var exit = 0;
            if (match$2 !== match$3) {
                console.warn("Expected first newline to be at same position");
                return [];
            }
            if (match$2 !== -1) {
                exit = 2;
            } else {
                if (match$3 === -1) {
                    return [];
                }
                exit = 2;
            }
            if (exit === 2) {
                _raw = raw.slice(match$3);
                _canonical = canonical.slice(match$2);
                _startIndexOpt = match$2;
                continue;
            }
        }
        if (match$1 !== -1) {
            return $$Array.append(fromCanonicalNewLineCountAndRawNewLineCount(startIndex, match + 1 | 0, match$1 + 1 | 0), fromCanonicalValueAndRawValue(match$1, canonical.slice(match), raw.slice(match$1)));
        } else {
            console.warn("Expected raw value to have at least 1 newline if canonical value has a newline");
            return [];
        }
    }
    ;
}
function fromString(offsetOpt, str) {
    var offset = offsetOpt !== undefined ? offsetOpt : 0;
    if (offset === 0 && str === "\n") {
        return [];
    }
    var startIndex = str.search(RegExUtils$SmartcutsMacros.newLineRe);
    if (startIndex === -1) {
        return [];
    }
    var str2 = str.slice(startIndex);
    var onePastEndIndex = str2.search(RegExUtils$SmartcutsMacros.nonNewLineRe);
    if (onePastEndIndex === -1) {
        return [
            {
                startIndex: startIndex + offset | 0,
                endIndex: (offset + str.length | 0) - 1 | 0
            }
        ];
    }
    var advance = startIndex + onePastEndIndex | 0;
    return $$Array.append([
        {
            startIndex: offset + startIndex | 0,
            endIndex: ((offset + startIndex | 0) + onePastEndIndex | 0) - 1 | 0
        }
    ], fromString(offset + advance | 0, str.slice(advance)));
}
function fromString$1(offsetOpt, s) {
    var offset = offsetOpt !== undefined ? offsetOpt : 0;
    var match = s.search(RegExUtils$SmartcutsMacros.nonNewLineRe);
    var match$1 = s.search(RegExUtils$SmartcutsMacros.newLineRe);
    if (match !== -1) {
        if (match === 0 && match$1 === -1) {
            return [
                {
                    TAG: /* Text */ 0,
                    _0: s
                }
            ];
        }
    } else {
        if (match$1 === -1) {
            return [];
        }
        if (match$1 === 0) {
            return [
                {
                    TAG: /* NewLineGroup */ 1,
                    _0: offset + 0 | 0,
                    _1: s.length
                }
            ];
        }
    }
    if (match$1 === 0) {
        return $$Array.append([
            {
                TAG: /* NewLineGroup */ 1,
                _0: offset + 0 | 0,
                _1: match
            }
        ], fromString$1(offset + match | 0, s.slice(match)));
    }
    if (match !== 0) {
        return [];
    }
    var func = function func(param, param$1) {
        return param$1.slice(0, param);
    };
    return $$Array.append([
        {
            TAG: /* Text */ 0,
            _0: Curry._2(func, match$1, s)
        }
    ], fromString$1(offset + match$1 | 0, s.slice(match$1)));
}
var TextOrNewLineGroup = {
    fromString: fromString$1
};
function isTagBlock(tagName) {
    switch(tagName){
        case "DIV":
        case "P":
            return true;
        default:
            return false;
    }
}
function fromNodesAndState(alreadySeenBreakOrText, openedBlockStatus, nodes) {
    return Belt_Array.reduceWithIndex(nodes, [
        [],
        openedBlockStatus,
        alreadySeenBreakOrText
    ], function(param, node, index) {
        var _$alreadySeenBreakOrText = param[2];
        var _$openedBlockStatus = param[1];
        var textsOrNewLines = param[0];
        var element = Webapi__Dom__Element.ofNode(node);
        if (element !== undefined) {
            var element$1 = Caml_option.valFromOption(element);
            var tagName = element$1.tagName;
            if (tagName === "BR") {
                var updatedTextsOrNewLines = $$Array.append(textsOrNewLines, _$openedBlockStatus !== 1 ? _$openedBlockStatus !== 0 ? [
                    /* NewLine */ 0
                ] : index === (nodes.length - 1 | 0) ? _$alreadySeenBreakOrText ? [
                    /* NewLine */ 0
                ] : [] : [] : _$alreadySeenBreakOrText ? [
                    /* NewLine */ 0
                ] : []);
                return [
                    updatedTextsOrNewLines,
                    _$openedBlockStatus !== 0 ? /* OpenedBlockAndBreakWasSeenInside */ 2 : /* NoBlockOpened */ 0,
                    /* HasSeenBreakOrText */ 1
                ];
            }
            var match = fromNodesAndState(_$alreadySeenBreakOrText, isTagBlock(tagName) ? /* OpenedBlockAndWaitingForTextOrBreak */ 1 : _$openedBlockStatus, Array.prototype.slice.call(element$1.childNodes));
            var updatedTextsOrNewLines$1 = $$Array.append(textsOrNewLines, match[0]);
            return [
                updatedTextsOrNewLines$1,
                match[1],
                match[2]
            ];
        }
        var textNode = Webapi__Dom__Text.ofNode(node);
        if (textNode !== undefined) {
            var text = Caml_option.valFromOption(textNode).data;
            var updatedTextsOrNewLines$2 = $$Array.append(textsOrNewLines, _$openedBlockStatus !== 1 ? [
                /* Text */ {
                    _0: text
                }
            ] : _$alreadySeenBreakOrText ? [
                /* NewLine */ 0,
                /* Text */ {
                    _0: text
                }
            ] : textsOrNewLines.length === 0 ? [
                /* Text */ {
                    _0: text
                }
            ] : [
                /* NewLine */ 0,
                /* Text */ {
                    _0: text
                }
            ]);
            return [
                updatedTextsOrNewLines$2,
                _$openedBlockStatus !== 0 ? /* OpenedBlockAndTextWasSeenInside */ 3 : /* NoBlockOpened */ 0,
                /* HasSeenBreakOrText */ 1
            ];
        }
        console.warn("Unhandled Dom node type", Webapi__Dom__Node.nodeType(node));
        return [
            textsOrNewLines,
            _$openedBlockStatus,
            _$alreadySeenBreakOrText
        ];
    });
}
function fromNodes(nodes) {
    return fromNodesAndState(/* HasNotSeenBreakOrTextYet */ 0, /* NoBlockOpened */ 0, nodes)[0];
}
function arrayToTextsAndNewLineGroups(textOrNewLines) {
    return Belt_Array.reduce(textOrNewLines, [
        undefined,
        0,
        []
    ], function(param, textOrNewLine) {
        var newLineGroups = param[2];
        var offset = param[1];
        var lastSeen = param[0];
        var match;
        if (lastSeen !== undefined) {
            if (lastSeen) {
                if (textOrNewLine) {
                    var textB = textOrNewLine._0;
                    var lastIndex = newLineGroups.length - 1 | 0;
                    var match$1 = Belt_Array.get(newLineGroups, lastIndex);
                    match = match$1 !== undefined && match$1.TAG === /* Text */ 0 ? [
                        $$Array.append(Belt_Array.slice(newLineGroups, 0, lastIndex), [
                            {
                                TAG: /* Text */ 0,
                                _0: match$1._0 + textB
                            }
                        ]),
                        offset + textB.length | 0
                    ] : [
                        newLineGroups,
                        offset
                    ];
                } else {
                    match = [
                        $$Array.append(newLineGroups, [
                            {
                                TAG: /* NewLineGroup */ 1,
                                _0: 0,
                                _1: 1
                            }
                        ]),
                        offset + 1 | 0
                    ];
                }
            } else if (textOrNewLine) {
                var text = textOrNewLine._0;
                match = [
                    $$Array.append(newLineGroups, [
                        {
                            TAG: /* Text */ 0,
                            _0: text
                        }
                    ]),
                    offset + text.length | 0
                ];
            } else {
                var lastIndex$1 = newLineGroups.length - 1 | 0;
                var match$2 = Belt_Array.get(newLineGroups, lastIndex$1);
                if (match$2 !== undefined && match$2.TAG !== /* Text */ 0) {
                    var offset$1 = match$2._0;
                    match = [
                        $$Array.append(Belt_Array.slice(newLineGroups, 0, lastIndex$1), [
                            {
                                TAG: /* NewLineGroup */ 1,
                                _0: offset$1,
                                _1: match$2._1 + 1 | 0
                            }
                        ]),
                        offset$1 + 1 | 0
                    ];
                } else {
                    match = [
                        newLineGroups,
                        offset
                    ];
                }
            }
        } else if (textOrNewLine) {
            var text$1 = textOrNewLine._0;
            match = [
                [
                    {
                        TAG: /* Text */ 0,
                        _0: text$1
                    }
                ],
                text$1.length
            ];
        } else {
            match = [
                [
                    {
                        TAG: /* NewLineGroup */ 1,
                        _0: 0,
                        _1: 1
                    }
                ],
                1
            ];
        }
        return [
            textOrNewLine,
            match[1],
            match[0]
        ];
    })[2];
}
var TextOrNewLine = {
    fromNodes: fromNodes,
    arrayToTextsAndNewLineGroups: arrayToTextsAndNewLineGroups
};
function fromNodesAndInnerText(nodes, innerText) {
    var rawTextsAndNewLineGroups = fromString$1(undefined, innerText);
    var textsAndNewLines = fromNodes(nodes);
    var canonicalTextsAndNewLineGroups = arrayToTextsAndNewLineGroups(textsAndNewLines);
    return Belt_Array.concatMany(ArrayUtils$SmartcutsMacros.filterMap(function(x) {
        return x;
    }, Belt_Array.zipBy(canonicalTextsAndNewLineGroups, rawTextsAndNewLineGroups, function(canonicalTextOrNewLineGroup, rawTextOrNewLineGroup) {
        if (canonicalTextOrNewLineGroup.TAG === /* Text */ 0) {
            if (rawTextOrNewLineGroup.TAG === /* Text */ 0) {
                return;
            } else {
                return Util$SmartcutsMacros.logAndRaiseJsError("Texts and NewLineGroups must match");
            }
        }
        var canonicalCount = canonicalTextOrNewLineGroup._1;
        if (rawTextOrNewLineGroup.TAG === /* Text */ 0) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Texts and NewLineGroups must match");
        }
        var rawCount = rawTextOrNewLineGroup._1;
        var offset = rawTextOrNewLineGroup._0;
        var rawNewLinesPerRegularCanonicalNewLine = Caml_int32.div(rawCount, canonicalCount);
        var rawNewLinesPerIrregularCanonicalNewLine = Caml_int32.mod_(rawCount, canonicalCount);
        var numRegularCanonicalNewLines = rawNewLinesPerIrregularCanonicalNewLine === 0 ? canonicalCount : canonicalCount - 1 | 0;
        var numIrregularCanonicalNewLines = rawNewLinesPerIrregularCanonicalNewLine === 0 ? 0 : 1;
        return $$Array.append($$Array.mapi(function(i, param) {
            return {
                startIndex: offset + Math.imul(i, rawNewLinesPerRegularCanonicalNewLine) | 0,
                endIndex: (offset + Math.imul(i + 1 | 0, rawNewLinesPerRegularCanonicalNewLine) | 0) - 1 | 0
            };
        }, Caml_array.make(numRegularCanonicalNewLines, 0)), numIrregularCanonicalNewLines === 0 ? [] : [
            {
                startIndex: offset + Math.imul(numRegularCanonicalNewLines, rawNewLinesPerRegularCanonicalNewLine) | 0,
                endIndex: (offset + Math.imul(numRegularCanonicalNewLines, rawNewLinesPerRegularCanonicalNewLine) | 0) + rawNewLinesPerIrregularCanonicalNewLine | 0
            }
        ]);
    })));
}
function fromElementAndInnerText(element, innerText) {
    var nodes = Array.prototype.slice.call(element.childNodes);
    return fromNodesAndInnerText(nodes, innerText);
}
function applyToString(str, newLines) {
    return Belt_Array.reduceReverse(newLines, str, function(canonicalStr, param) {
        return canonicalStr.slice(0, param.startIndex) + ("\n" + canonicalStr.slice(param.endIndex + 1 | 0));
    });
}
var CanonicalNewLine = {
    ContentEditableInnerTextPosition: ContentEditableInnerTextPosition,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromExpectedEntersAndString: fromExpectedEntersAndString,
    fromCanonicalValueAndRawValue: fromCanonicalValueAndRawValue,
    fromString: fromString,
    TextOrNewLineGroup: TextOrNewLineGroup,
    TextOrNewLine: TextOrNewLine,
    fromNodesAndInnerText: fromNodesAndInnerText,
    fromElementAndInnerText: fromElementAndInnerText,
    applyToString: applyToString
};
function t_encode$2(encoder_domHtmlElement, encoder_domNode, v) {
    return Js_dict.fromArray([
        [
            "contentEditableHost",
            Curry._1(encoder_domHtmlElement, v.contentEditableHost)
        ],
        [
            "valueCanonical",
            Decco.stringToJson(v.valueCanonical)
        ],
        [
            "valueRaw",
            Decco.stringToJson(v.valueRaw)
        ],
        [
            "selection",
            Selection__Snapshot$SmartcutsMacros.Generic.t_encode(encoder_domNode, v.selection)
        ],
        [
            "expectedPaste",
            Decco.optionToJson(Decco.stringToJson, v.expectedPaste)
        ],
        [
            "expectedEnters",
            Decco.intToJson(v.expectedEnters)
        ],
        [
            "newLines",
            Decco.arrayToJson(t_encode$1, v.newLines)
        ]
    ]);
}
function t_decode$2(decoder_domHtmlElement, decoder_domNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var contentEditableHost = Curry._1(decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditableHost"), null));
    if (contentEditableHost.TAG === /* Ok */ 0) {
        var valueCanonical = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "valueCanonical"), null));
        if (valueCanonical.TAG === /* Ok */ 0) {
            var valueRaw = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "valueRaw"), null));
            if (valueRaw.TAG === /* Ok */ 0) {
                var selection = Selection__Snapshot$SmartcutsMacros.Generic.t_decode(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selection"), null));
                if (selection.TAG === /* Ok */ 0) {
                    var expectedPaste = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectedPaste"), null));
                    if (expectedPaste.TAG === /* Ok */ 0) {
                        var expectedEnters = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectedEnters"), null));
                        if (expectedEnters.TAG === /* Ok */ 0) {
                            var newLines = Decco.arrayFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "newLines"), null));
                            if (newLines.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        contentEditableHost: contentEditableHost._0,
                                        valueCanonical: valueCanonical._0,
                                        valueRaw: valueRaw._0,
                                        selection: selection._0,
                                        expectedPaste: expectedPaste._0,
                                        expectedEnters: expectedEnters._0,
                                        newLines: newLines._0
                                    }
                                };
                            }
                            var e = newLines._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".newLines" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = expectedEnters._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".expectedEnters" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = expectedPaste._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".expectedPaste" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = selection._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".selection" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = valueRaw._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".valueRaw" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = valueCanonical._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".valueCanonical" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = contentEditableHost._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".contentEditableHost" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
function stringify(stringifyDomHtmlElement, stringifyDomNode, param) {
    return "{contentEditableHost: " + (Curry._1(stringifyDomHtmlElement, param.contentEditableHost) + (", valueCanonical: " + (param.valueCanonical + (", selection: " + (Selection__Snapshot$SmartcutsMacros.Generic.stringify(stringifyDomNode, param.selection) + (", expectedPaste: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.expectedPaste, StringUtils$SmartcutsMacros.quote)) + (", expectedEnters: " + (String(param.expectedEnters) + "}")))))))));
}
function map(mapDomHtmlElement, mapDomNode, v) {
    return {
        contentEditableHost: Curry._1(mapDomHtmlElement, v.contentEditableHost),
        valueCanonical: v.valueCanonical,
        valueRaw: v.valueRaw,
        selection: Selection__Snapshot$SmartcutsMacros.Generic.map(mapDomNode, v.selection),
        expectedPaste: v.expectedPaste,
        expectedEnters: v.expectedEnters,
        newLines: v.newLines
    };
}
var Generic = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify,
    map: map
};
function updateWithDomEvent(domElementIdentifierGenerator, domEvent, vContentEditable) {
    switch(domEvent.TAG | 0){
        case /* ClipboardEvent */ 3:
            if (domEvent._0 !== "paste") {
                return vContentEditable;
            }
            var data = domEvent._1.clipboardData;
            var pastedText = DOM__DataTransfer$SmartcutsMacros.getData("text", data);
            var contentEditableHost = vContentEditable.contentEditableHost;
            var valueBeforePaste = contentEditableHost.innerText;
            var selection = Selection__Snapshot$SmartcutsMacros.Regular.capture(undefined);
            var selectionOrCursor = Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.fromSelectionSnapshot(domElementIdentifierGenerator, selection);
            var valueAfterPaste;
            if (typeof selectionOrCursor === "number") {
                valueAfterPaste = valueBeforePaste;
            } else if (selectionOrCursor.TAG === /* ContentEditableSelection */ 0) {
                var nonInputSelection = selectionOrCursor._1;
                var exit = 0;
                var selectedText;
                if (nonInputSelection.TAG === /* SingleNode */ 0) {
                    selectedText = nonInputSelection._0.selectedText;
                    exit = 1;
                } else {
                    selectedText = nonInputSelection._0.selectedText;
                    exit = 1;
                }
                if (exit === 1) {
                    valueAfterPaste = StringUtils$SmartcutsMacros.slice(valueBeforePaste.indexOf(selectedText), selectedText.length, StringUtils$SmartcutsMacros.slice(0, valueBeforePaste.indexOf(selectedText), valueBeforePaste) + (pastedText + valueBeforePaste));
                }
            } else {
                var _contentEditableCursor = selectionOrCursor._1;
                var offset = _contentEditableCursor.offset;
                var textNodeIndex = _contentEditableCursor.textNodeIndex;
                var domElementIdentifier = _contentEditableCursor.domElementRepresentation.domElementIdentifier;
                var enterToken = "\n";
                valueAfterPaste = Belt_List.reduce(_contentEditableCursor.textContents, "", function(str, textContent) {
                    if (textContent.TAG === /* TextSegment */ 0) {
                        var currElement = textContent._0;
                        if (currElement.TAG !== /* NonEmptySegment */ 0) {
                            if (currElement._0.domElementIdentifier === domElementIdentifier) {
                                return str + pastedText;
                            } else {
                                return str;
                            }
                        }
                        var match = currElement._0;
                        var text = match.text;
                        if (match.textNodeIndex === textNodeIndex) {
                            return str + (StringUtils$SmartcutsMacros.slice(0, offset, text) + (pastedText + StringUtils$SmartcutsMacros.slice(offset, text.length, text)));
                        } else {
                            return str + text;
                        }
                    }
                    var currElement$1 = textContent._0;
                    if (currElement$1.TAG !== /* NonEmptySegment */ 0) {
                        if (currElement$1._0.domElementIdentifier === domElementIdentifier) {
                            return str + (enterToken + pastedText);
                        } else {
                            return str + enterToken;
                        }
                    }
                    var match$1 = currElement$1._0;
                    var text$1 = match$1.text;
                    if (match$1.parentElement.domElementIdentifier === domElementIdentifier && textNodeIndex === -1) {
                        return str + (enterToken + (text$1 + pastedText));
                    } else {
                        return str + (enterToken + text$1);
                    }
                });
            }
            return {
                contentEditableHost: vContentEditable.contentEditableHost,
                valueCanonical: valueAfterPaste,
                valueRaw: valueAfterPaste,
                selection: selection,
                expectedPaste: pastedText,
                expectedEnters: vContentEditable.expectedEnters,
                newLines: vContentEditable.newLines
            };
            break;
        case /* Event */ 9:
            if (domEvent._0 === "selectionchange") {
                return {
                    contentEditableHost: vContentEditable.contentEditableHost,
                    valueCanonical: vContentEditable.valueCanonical,
                    valueRaw: vContentEditable.valueRaw,
                    selection: Selection__Snapshot$SmartcutsMacros.Regular.capture(undefined),
                    expectedPaste: vContentEditable.expectedPaste,
                    expectedEnters: vContentEditable.expectedEnters,
                    newLines: vContentEditable.newLines
                };
            } else {
                return vContentEditable;
            }
        default:
            return vContentEditable;
    }
}
function make(contentEditableHost) {
    var valueRaw = contentEditableHost.innerText;
    var newLines = fromElementAndInnerText(contentEditableHost, valueRaw);
    var valueCanonical = StringUtils$SmartcutsMacros.replaceNonBreakingSpacesWithSpaces(applyToString(valueRaw, newLines));
    var selectionSnapshot = Selection__Snapshot$SmartcutsMacros.Regular.capture(undefined);
    return {
        contentEditableHost: contentEditableHost,
        valueCanonical: valueCanonical,
        valueRaw: valueRaw,
        selection: selectionSnapshot,
        expectedPaste: undefined,
        expectedEnters: 0,
        newLines: newLines
    };
}
function refreshValueAndSelection(vContentEditable) {
    var contentEditableHost = vContentEditable.contentEditableHost;
    var valueRaw = contentEditableHost.innerText;
    var updatedNewLines = fromElementAndInnerText(contentEditableHost, valueRaw);
    var valueCanonical = StringUtils$SmartcutsMacros.replaceNonBreakingSpacesWithSpaces(StringUtils$SmartcutsMacros.replaceAll(StringUtils$SmartcutsMacros.nbsp, " ", applyToString(valueRaw, updatedNewLines)));
    Curry._4(Log$SmartcutsMacros.recordingContentEditing.warn4, "new canonical value + updatedNewLines", StringUtils$SmartcutsMacros.quote(valueCanonical), StringUtils$SmartcutsMacros.quote(valueRaw), updatedNewLines);
    return {
        contentEditableHost: vContentEditable.contentEditableHost,
        valueCanonical: valueCanonical,
        valueRaw: valueRaw,
        selection: Selection__Snapshot$SmartcutsMacros.Regular.capture(undefined),
        expectedPaste: undefined,
        expectedEnters: 0,
        newLines: updatedNewLines
    };
}
var Regular = {
    updateWithDomEvent: updateWithDomEvent,
    make: make,
    refreshValueAndSelection: refreshValueAndSelection
};
var ForSerialization = {};
exports.CanonicalNewLine = CanonicalNewLine;
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__HtmlInputElement$SmartcutsMacros = __webpack_require__(64988);
var Selection__InputSelectionOrCursor$SmartcutsMacros = __webpack_require__(2374);
function t_encode(v) {
    if (typeof v === "number") {
        return [
            "SelectionIsUnsupported"
        ];
    } else if (v.TAG === /* Cursor */ 0) {
        return [
            "Cursor",
            Decco.intToJson(v._0)
        ];
    } else {
        return [
            "Selection",
            Decco.intToJson(v._0),
            Decco.intToJson(v._1)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Cursor":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Cursor */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Selection":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Selection */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "SelectionIsUnsupported":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SelectionIsUnsupported */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromHtmlInputElement(htmlInputElement) {
    if (!DOM__HtmlInputElement$SmartcutsMacros.doesSupportSelection(htmlInputElement)) {
        return /* SelectionIsUnsupported */ 0;
    }
    var start = htmlInputElement.selectionStart;
    var end_ = htmlInputElement.selectionEnd;
    if (start === end_) {
        return {
            TAG: /* Cursor */ 0,
            _0: start
        };
    } else {
        return {
            TAG: /* Selection */ 1,
            _0: start,
            _1: end_
        };
    }
}
function stringify(v) {
    if (typeof v === "number") {
        return "SelectionIsUnsupported";
    } else if (v.TAG === /* Cursor */ 0) {
        return "Cursor(" + (String(v._0) + ")");
    } else {
        return "Selection(selectionStart=" + (String(v._0) + (", selectionEnd=" + (String(v._1) + ")")));
    }
}
var Cursor = {
    t_encode: t_encode,
    t_decode: t_decode,
    fromHtmlInputElement: fromHtmlInputElement,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "value",
            Decco.stringToJson(v.value)
        ],
        [
            "cursor",
            t_encode(v.cursor)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */ 0) {
        var cursor = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cursor"), null));
        if (cursor.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    value: value._0,
                    cursor: cursor._0
                }
            };
        }
        var e = cursor._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".cursor" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = value._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".value" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function make(htmlInputElement) {
    return {
        value: htmlInputElement.value,
        cursor: fromHtmlInputElement(htmlInputElement)
    };
}
function stringify$1(param) {
    return "{value=" + (param.value + (", cursor=" + (stringify(param.cursor) + "}")));
}
function updateCursorAndValueToMatchHtmlInputElement(htmlInputElement, _input) {
    return {
        value: htmlInputElement.value,
        cursor: fromHtmlInputElement(htmlInputElement)
    };
}
function getInputValueAfterPaste(domElementIdentifierGenerator, htmlInputElement, pastedText) {
    var selectionOrCursor = Selection__InputSelectionOrCursor$SmartcutsMacros.ForRecording.fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement);
    var inputValueBeforePaste = htmlInputElement.value;
    var match = htmlInputElement.tagName.toLowerCase();
    var pastedTextWithNewlinesAsSpaces;
    var exit = 0;
    switch(match){
        case "input":
            exit = 1;
            break;
        case "textarea":
            pastedTextWithNewlinesAsSpaces = pastedText;
            break;
        default:
            exit = 1;
    }
    if (exit === 1) {
        pastedTextWithNewlinesAsSpaces = pastedText.replace(/\n/g, " ");
    }
    var cursorPosition = selectionOrCursor.params;
    if (typeof cursorPosition === "number") {
        return inputValueBeforePaste;
    }
    if (cursorPosition.TAG === /* InputSelectionParams */ 0) {
        var match$1 = cursorPosition._0;
        return StringUtils$SmartcutsMacros.slice(0, match$1.start, inputValueBeforePaste) + (pastedTextWithNewlinesAsSpaces + StringUtils$SmartcutsMacros.slice(match$1.end_, inputValueBeforePaste.length, inputValueBeforePaste));
    }
    var cursorPosition$1 = cursorPosition._0;
    return StringUtils$SmartcutsMacros.slice(0, cursorPosition$1, inputValueBeforePaste) + (pastedTextWithNewlinesAsSpaces + StringUtils$SmartcutsMacros.slice(cursorPosition$1, inputValueBeforePaste.length, inputValueBeforePaste));
}
function makeWithPastedText(domElementIdentifierGenerator, htmlInputElement, pastedText) {
    var inputValueAfterPaste = getInputValueAfterPaste(domElementIdentifierGenerator, htmlInputElement, pastedText);
    return {
        value: inputValueAfterPaste,
        cursor: {
            TAG: /* Cursor */ 0,
            _0: inputValueAfterPaste.length
        }
    };
}
function updateWithPastedText(domElementIdentifierGenerator, htmlInputElement, pastedText, input) {
    var inputValueAfterPaste = getInputValueAfterPaste(domElementIdentifierGenerator, htmlInputElement, pastedText);
    var lastVirtualizedCursorPosition = input.cursor;
    if (typeof lastVirtualizedCursorPosition === "number") {
        return input;
    } else {
        return {
            value: inputValueAfterPaste,
            cursor: {
                TAG: /* Cursor */ 0,
                _0: lastVirtualizedCursorPosition._0 + pastedText.length | 0
            }
        };
    }
}
exports.Cursor = Cursor;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.make = make;
exports.stringify = stringify$1;
exports.updateCursorAndValueToMatchHtmlInputElement = updateCursorAndValueToMatchHtmlInputElement;
exports.makeWithPastedText = makeWithPastedText;
exports.updateWithPastedText = updateWithPastedText; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 23676:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var $$String = __webpack_require__(65760);
var Belt_Map = __webpack_require__(26810);
var Caml_option = __webpack_require__(57175);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var DOM__Shadow$SmartcutsMacros = __webpack_require__(2497);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var DOM__Attributes$SmartcutsMacros = __webpack_require__(92169);
var DOM__DataTransfer$SmartcutsMacros = __webpack_require__(44129);
var Virtualized__Input$SmartcutsMacros = __webpack_require__(5283);
var DOM__HtmlInputElement$SmartcutsMacros = __webpack_require__(64988);
var empty = CustomMap$SmartcutsMacros.MapDomElement.make(undefined);
var get = Belt_Map.get;
var set = Belt_Map.set;
var has = Belt_Map.has;
var update = Belt_Map.update;
function updateWithDomEvent(domElementIdentifierGenerator, $$event, inputByDomElement) {
    switch($$event.TAG | 0){
        case /* MouseEvent */ 0:
            if ($$event._0 !== "click") {
                return inputByDomElement;
            }
            var mouseEvent = $$event._1;
            var match = DOM$SmartcutsMacros.MouseButtonPressed.fromMouseEvent(mouseEvent);
            if (match !== 0) {
                return inputByDomElement;
            }
            var targetElement = DOM__Shadow$SmartcutsMacros.getTargetFromEvent(mouseEvent);
            if (DOM__Element$SmartcutsMacros.checkSelectionStartCapability(targetElement) && DOM__Element$SmartcutsMacros.isVisibleOnPage(targetElement)) {
                return Belt_Map.update(inputByDomElement, targetElement, function(maybeInput) {
                    if (maybeInput === undefined) {
                        return Virtualized__Input$SmartcutsMacros.make(targetElement);
                    }
                    var clickCount = mouseEvent.detail;
                    return clickCount > 1 && DOM__HtmlInputElement$SmartcutsMacros.doesSupportSelection(targetElement) && targetElement.selectionStart !== targetElement.selectionEnd ? {
                        value: targetElement.value,
                        cursor: maybeInput.cursor
                    } : Virtualized__Input$SmartcutsMacros.updateCursorAndValueToMatchHtmlInputElement(targetElement, maybeInput);
                });
            } else {
                return inputByDomElement;
            }
        case /* InputEvent */ 1:
            if ($$event._0 !== "input") {
                return inputByDomElement;
            }
            var targetElement$1 = DOM__Shadow$SmartcutsMacros.getTargetFromEvent($$event._1);
            var tagName = targetElement$1.tagName.toLowerCase();
            var match$1 = DOM__Attributes$SmartcutsMacros.ofDomElement(targetElement$1);
            var match$2 = OptionUtils$SmartcutsMacros.map(match$1.type_, $$String.lowercase_ascii);
            switch(tagName){
                case "input":
                    if (match$2 !== undefined) {
                        switch(match$2){
                            case "email":
                            case "password":
                            case "search":
                            case "tel":
                            case "text":
                            case "url":
                                break;
                            default:
                                return inputByDomElement;
                        }
                    }
                    break;
                case "textarea":
                    break;
                default:
                    return inputByDomElement;
            }
            return Belt_Map.update(inputByDomElement, targetElement$1, function(maybeInput) {
                if (maybeInput !== undefined) {
                    return Virtualized__Input$SmartcutsMacros.updateCursorAndValueToMatchHtmlInputElement(targetElement$1, maybeInput);
                } else {
                    return Virtualized__Input$SmartcutsMacros.make(targetElement$1);
                }
            });
            break;
        case /* ClipboardEvent */ 3:
            if ($$event._0 !== "paste") {
                return inputByDomElement;
            }
            var clipboardEvent = $$event._1;
            var data = clipboardEvent.clipboardData;
            var pastedText = DOM__DataTransfer$SmartcutsMacros.getData("text", data);
            var targetElement$2 = DOM__Shadow$SmartcutsMacros.getTargetFromEvent(clipboardEvent);
            var htmlInputElement = DOM__HtmlInputElement$SmartcutsMacros.ofElement(targetElement$2);
            if (htmlInputElement === undefined) {
                return inputByDomElement;
            }
            var htmlInputElement$1 = Caml_option.valFromOption(htmlInputElement);
            return Belt_Map.update(inputByDomElement, targetElement$2, function(maybeInput) {
                if (maybeInput !== undefined) {
                    return Virtualized__Input$SmartcutsMacros.updateWithPastedText(domElementIdentifierGenerator, htmlInputElement$1, pastedText, maybeInput);
                } else {
                    return Virtualized__Input$SmartcutsMacros.makeWithPastedText(domElementIdentifierGenerator, htmlInputElement$1, pastedText);
                }
            });
        case /* Event */ 9:
            if ($$event._0 !== "selectionchange") {
                return inputByDomElement;
            }
            var activeDomElement = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
            var maybeActiveDomElementWithCheckSelectionStartCapability;
            if (activeDomElement !== undefined) {
                var activeDomElement$1 = Caml_option.valFromOption(activeDomElement);
                maybeActiveDomElementWithCheckSelectionStartCapability = DOM__Element$SmartcutsMacros.checkSelectionStartCapability(activeDomElement$1) ? Caml_option.some(activeDomElement$1) : undefined;
            } else {
                maybeActiveDomElementWithCheckSelectionStartCapability = undefined;
            }
            if (maybeActiveDomElementWithCheckSelectionStartCapability === undefined) {
                return inputByDomElement;
            }
            var activeDomElement$2 = Caml_option.valFromOption(maybeActiveDomElementWithCheckSelectionStartCapability);
            return Belt_Map.update(inputByDomElement, activeDomElement$2, function(maybeInput) {
                if (maybeInput !== undefined) {
                    return Virtualized__Input$SmartcutsMacros.updateCursorAndValueToMatchHtmlInputElement(activeDomElement$2, maybeInput);
                } else {
                    return Virtualized__Input$SmartcutsMacros.make(activeDomElement$2);
                }
            });
        default:
            return inputByDomElement;
    }
}
var VirtualizedInputByDomElement = {
    empty: empty,
    get: get,
    set: set,
    has: has,
    update: update,
    toList: Belt_Map.toList,
    updateWithDomEvent: updateWithDomEvent
};
function t_encode(v) {
    return Curry._2(CustomMap$SmartcutsMacros.MapSelector.t_encode, Virtualized__Input$SmartcutsMacros.t_encode, v);
}
function t_decode(v) {
    return Curry._2(CustomMap$SmartcutsMacros.MapSelector.t_decode, Virtualized__Input$SmartcutsMacros.t_decode, v);
}
function fromInputByDomElement(inputByDomElement) {
    return Curry._1(CustomMap$SmartcutsMacros.MapSelector.fromArray, $$Array.map(function(param) {
        return [
            Selector$SmartcutsMacros.forDomElement(param[0]),
            param[1]
        ];
    }, Belt_Map.toArray(inputByDomElement)));
}
var VirtualizedInputBySelector = {
    t_encode: t_encode,
    t_decode: t_decode,
    fromInputByDomElement: fromInputByDomElement,
    toList: Belt_Map.toList
};
var VirtualizedInput;
exports.VirtualizedInput = VirtualizedInput;
exports.VirtualizedInputByDomElement = VirtualizedInputByDomElement;
exports.VirtualizedInputBySelector = VirtualizedInputBySelector; /* empty Not a pure module */ 


/***/ }),

/***/ 25558:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_exn = __webpack_require__(82900);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Log$SmartcutsMacros = __webpack_require__(78088);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var _map = {
    "link": "link",
    "typed": "typed",
    "auto_bookmark": "auto_bookmark",
    "auto_subframe": "auto_subframe",
    "manual_subframe": "manual_subframe",
    "generated": "generated",
    "start_page": "start_page",
    "form_submit": "form_submit",
    "reload": "reload",
    "keyword": "keyword",
    "keyword_generated": "keyword_generated"
};
function tToJs(param) {
    return param;
}
function tFromJs(param) {
    return _map[param];
}
var TransitionType = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "Browser.WebNavigation.TransitionType.t",
    tToJs: tToJs,
    tFromJs: tFromJs
});
var _map$1 = {
    "client_redirect": "client_redirect",
    "server_redirect": "server_redirect",
    "forward_back": "forward_back",
    "from_address_bar": "from_address_bar"
};
function tToJs$1(param) {
    return param;
}
function tFromJs$1(param) {
    return _map$1[param];
}
var TransitionQualifier = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "Browser.WebNavigation.transitionQualifier.t",
    tToJs: tToJs$1,
    tFromJs: tFromJs$1
});
function transitionQualifiersFromJs(transitionQualifierStrings) {
    return $$Array.map(function(qualifierStr) {
        var transitionQualifierVariant = Curry._1(TransitionQualifier.tFromJs, qualifierStr);
        if (transitionQualifierVariant !== undefined) {
            return transitionQualifierVariant;
        } else {
            return Js_exn.raiseError("Unknown transitionType: " + qualifierStr);
        }
    }, transitionQualifierStrings);
}
function transitionQualifiersToJs(transitionQualifiers) {
    return $$Array.map(TransitionQualifier.tToJs, transitionQualifiers);
}
var EventFilter = {};
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "tabId",
            Decco.intToJson(v.tabId)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "frameId",
            Decco.intToJson(v.frameId)
        ],
        [
            "parentFrameId",
            Decco.intToJson(v.parentFrameId)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
    if (tabId.TAG === /* Ok */ 0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
            if (frameId.TAG === /* Ok */ 0) {
                var parentFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentFrameId"), null));
                if (parentFrameId.TAG === /* Ok */ 0) {
                    var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                    if (timeStamp.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                tabId: tabId._0,
                                url: url._0,
                                frameId: frameId._0,
                                parentFrameId: parentFrameId._0,
                                timeStamp: timeStamp._0
                            }
                        };
                    }
                    var e = timeStamp._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".timeStamp" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = parentFrameId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".parentFrameId" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = frameId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".frameId" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = tabId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tabId" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function stringify(param) {
    return "{tabId=" + (String(param.tabId) + (", url=" + (param.url + (", frameId=" + (String(param.frameId) + (", parentFrameId=" + (String(param.parentFrameId) + (", timeStamp=" + (param.timeStamp.toString() + "}")))))))));
}
var Details = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
var OnBeforeNavigate = {
    Details: Details
};
var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});
function record_encode(v) {
    return Js_dict.fromArray([
        [
            "tabId",
            Decco.intToJson(v.tabId)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "processId",
            Decco.intToJson(v.processId)
        ],
        [
            "frameId",
            Decco.intToJson(v.frameId)
        ],
        [
            "parentFrameId",
            Decco.intToJson(v.parentFrameId)
        ],
        [
            "transitionType",
            Curry._1(TransitionType.t_encode, v.transitionType)
        ],
        [
            "transitionQualifiers",
            Decco.arrayToJson(TransitionQualifier.t_encode, v.transitionQualifiers)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ]
    ]);
}
function record_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
    if (tabId.TAG === /* Ok */ 0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var processId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "processId"), null));
            if (processId.TAG === /* Ok */ 0) {
                var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
                if (frameId.TAG === /* Ok */ 0) {
                    var parentFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentFrameId"), null));
                    if (parentFrameId.TAG === /* Ok */ 0) {
                        var transitionType = Curry._1(TransitionType.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transitionType"), null));
                        if (transitionType.TAG === /* Ok */ 0) {
                            var transitionQualifiers = Decco.arrayFromJson(TransitionQualifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transitionQualifiers"), null));
                            if (transitionQualifiers.TAG === /* Ok */ 0) {
                                var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                                if (timeStamp.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            tabId: tabId._0,
                                            url: url._0,
                                            processId: processId._0,
                                            frameId: frameId._0,
                                            parentFrameId: parentFrameId._0,
                                            transitionType: transitionType._0,
                                            transitionQualifiers: transitionQualifiers._0,
                                            timeStamp: timeStamp._0
                                        }
                                    };
                                }
                                var e = timeStamp._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".timeStamp" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = transitionQualifiers._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".transitionQualifiers" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = transitionType._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".transitionType" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = parentFrameId._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".parentFrameId" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = frameId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".frameId" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = processId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".processId" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = tabId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tabId" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
function toRecord(details) {
    var tabId = details.tabId;
    var url = details.url;
    var processId = details.processId;
    var frameId = details.frameId;
    var parentFrameId = details.parentFrameId;
    var transitionTypeStr = details.transitionType;
    var transitionTypeVariant = Curry._1(TransitionType.tFromJs, transitionTypeStr);
    var transitionType = transitionTypeVariant !== undefined ? transitionTypeVariant : Js_exn.raiseError("Unknown transitionType: " + transitionTypeStr);
    var transitionQualifiers = transitionQualifiersFromJs(details.transitionQualifiers);
    var timeStamp = details.timeStamp;
    return {
        tabId: tabId,
        url: url,
        processId: processId,
        frameId: frameId,
        parentFrameId: parentFrameId,
        transitionType: transitionType,
        transitionQualifiers: transitionQualifiers,
        timeStamp: timeStamp
    };
}
function fromRecord(record) {
    return {
        tabId: record.tabId,
        url: record.url,
        processId: record.processId,
        frameId: record.frameId,
        parentFrameId: record.parentFrameId,
        transitionType: Curry._1(TransitionType.tToJs, record.transitionType),
        transitionQualifiers: $$Array.map(TransitionQualifier.tToJs, record.transitionQualifiers),
        timeStamp: record.timeStamp
    };
}
function stringify$1(record) {
    return JSON.stringify(fromRecord(record));
}
var Details_t_encode = include.t_encode;
var Details_t_decode = include.t_decode;
var Details$1 = {
    t_encode: Details_t_encode,
    t_decode: Details_t_decode,
    record_encode: record_encode,
    record_decode: record_decode,
    toRecord: toRecord,
    fromRecord: fromRecord,
    stringify: stringify$1
};
var OnCommitted = {
    Details: Details$1
};
var Details$2 = {};
function addListener(logOriginalOpt, listener) {
    var logOriginal = logOriginalOpt !== undefined ? logOriginalOpt : false;
    browser.webNavigation.onDOMContentLoaded.addListener(function(details) {
        if (logOriginal) {
            Curry._2(Log$SmartcutsMacros.chromeEventsWebNav.log2, "Browser.WebNavigation.OnDOMContentLoaded", details);
        }
        return Curry._1(listener, details);
    });
}
var OnDOMContentLoaded = {
    Details: Details$2,
    addListener: addListener
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "tabId",
            Decco.intToJson(v.tabId)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "processId",
            Decco.intToJson(v.processId)
        ],
        [
            "frameId",
            Decco.intToJson(v.frameId)
        ],
        [
            "parentFrameId",
            Decco.intToJson(v.parentFrameId)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
    if (tabId.TAG === /* Ok */ 0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var processId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "processId"), null));
            if (processId.TAG === /* Ok */ 0) {
                var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
                if (frameId.TAG === /* Ok */ 0) {
                    var parentFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentFrameId"), null));
                    if (parentFrameId.TAG === /* Ok */ 0) {
                        var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                        if (timeStamp.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    tabId: tabId._0,
                                    url: url._0,
                                    processId: processId._0,
                                    frameId: frameId._0,
                                    parentFrameId: parentFrameId._0,
                                    timeStamp: timeStamp._0
                                }
                            };
                        }
                        var e = timeStamp._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".timeStamp" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = parentFrameId._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".parentFrameId" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = frameId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".frameId" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = processId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".processId" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = tabId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tabId" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function stringify$2(details) {
    return JSON.stringify(details);
}
var Details$3 = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$2
};
var OnCompleted = {
    Details: Details$3
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "tabId",
            Decco.intToJson(v.tabId)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "frameId",
            Decco.intToJson(v.frameId)
        ],
        [
            "parentFrameId",
            Decco.intToJson(v.parentFrameId)
        ],
        [
            "error",
            Decco.stringToJson(v.error)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
    if (tabId.TAG === /* Ok */ 0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
            if (frameId.TAG === /* Ok */ 0) {
                var parentFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentFrameId"), null));
                if (parentFrameId.TAG === /* Ok */ 0) {
                    var error = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "error"), null));
                    if (error.TAG === /* Ok */ 0) {
                        var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                        if (timeStamp.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    tabId: tabId._0,
                                    url: url._0,
                                    frameId: frameId._0,
                                    parentFrameId: parentFrameId._0,
                                    error: error._0,
                                    timeStamp: timeStamp._0
                                }
                            };
                        }
                        var e = timeStamp._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".timeStamp" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = error._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".error" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = parentFrameId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".parentFrameId" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = frameId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".frameId" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = tabId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tabId" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function stringify$3(details) {
    return JSON.stringify(details);
}
function didOccurInSubFrame(param) {
    return param.frameId !== 0;
}
var Details$4 = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$3,
    didOccurInSubFrame: didOccurInSubFrame
};
var OnErrorOccurred = {
    Details: Details$4
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "sourceTabId",
            Decco.intToJson(v.sourceTabId)
        ],
        [
            "sourceProcessId",
            Decco.intToJson(v.sourceProcessId)
        ],
        [
            "sourceFrameId",
            Decco.intToJson(v.sourceFrameId)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "tabId",
            Decco.intToJson(v.tabId)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var sourceTabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sourceTabId"), null));
    if (sourceTabId.TAG === /* Ok */ 0) {
        var sourceProcessId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sourceProcessId"), null));
        if (sourceProcessId.TAG === /* Ok */ 0) {
            var sourceFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sourceFrameId"), null));
            if (sourceFrameId.TAG === /* Ok */ 0) {
                var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                if (url.TAG === /* Ok */ 0) {
                    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
                    if (tabId.TAG === /* Ok */ 0) {
                        var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
                        if (timeStamp.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    sourceTabId: sourceTabId._0,
                                    sourceProcessId: sourceProcessId._0,
                                    sourceFrameId: sourceFrameId._0,
                                    url: url._0,
                                    tabId: tabId._0,
                                    timeStamp: timeStamp._0
                                }
                            };
                        }
                        var e = timeStamp._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".timeStamp" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = tabId._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".tabId" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = url._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".url" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = sourceFrameId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".sourceFrameId" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = sourceProcessId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sourceProcessId" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = sourceTabId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".sourceTabId" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
var Details$5 = {
    t_encode: t_encode$3,
    t_decode: t_decode$3
};
var OnCreatedNavigationTarget = {
    Details: Details$5
};
var Details$6 = {};
var OnTabReplaced = {
    Details: Details$6
};
var OnHistoryStateUpdated = {
    Details: undefined
};
function isMainFrame(frameId) {
    return frameId === 0;
}
var Helpers = {
    isMainFrame: isMainFrame
};
var isDefined = function isDefined() {
    return typeof browser.webNavigation !== "undefined";
};
exports.TransitionType = TransitionType;
exports.TransitionQualifier = TransitionQualifier;
exports.transitionQualifiersFromJs = transitionQualifiersFromJs;
exports.transitionQualifiersToJs = transitionQualifiersToJs;
exports.EventFilter = EventFilter;
exports.OnBeforeNavigate = OnBeforeNavigate;
exports.OnCommitted = OnCommitted;
exports.OnDOMContentLoaded = OnDOMContentLoaded;
exports.OnCompleted = OnCompleted;
exports.OnErrorOccurred = OnErrorOccurred;
exports.OnCreatedNavigationTarget = OnCreatedNavigationTarget;
exports.OnTabReplaced = OnTabReplaced;
exports.OnHistoryStateUpdated = OnHistoryStateUpdated;
exports.Helpers = Helpers;
exports.isDefined = isDefined; /* TransitionType Not a pure module */ 


/***/ })

}]);